
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("79I2S", function(module, exports) {

$parcel$export(module.exports, "createCanvas", function () { return $5662a6ef9fdc6eee$export$cd3d1f114b139967; });

var $7YQXi = parcelRequire("7YQXi");
function $5662a6ef9fdc6eee$export$cd3d1f114b139967(w, h) {
    const result = document.createElement('canvas');
    if (w !== undefined && h !== undefined) {
        result.width = w;
        result.height = h;
    }
    (0, $7YQXi.CANVAS_DEBUG_HOOKS).onCreate?.(result);
    return result;
}

});
parcelRegister("7YQXi", function(module, exports) {

$parcel$export(module.exports, "CANVAS_DEBUG_HOOKS", function () { return $291a83341435392b$export$17b3544359ed204b; });
// if you want to debug canvas memory usage and churn
const $291a83341435392b$export$17b3544359ed204b = {};

});


parcelRegister("7JV8p", function(module, exports) {
module.exports = $parcel$import("iE3Zn").then(()=>parcelRequire('hPuKu'));

});

parcelRegister("kq72H", function(module, exports) {
module.exports = $parcel$import("6mJjR").then(()=>parcelRequire('72HGO'));

});

parcelRegister("7lhPR", function(module, exports) {
module.exports = $parcel$import("mHXrf").then(()=>parcelRequire('f7hbT'));

});

parcelRegister("fkCzo", function(module, exports) {
module.exports = $parcel$import("gppah").then(()=>parcelRequire('32fes'));

});

parcelRegister("a78X2", function(module, exports) {
module.exports = $parcel$import("agVte").then(()=>parcelRequire('6h7po'));

});

parcelRegister("9oJ54", function(module, exports) {
module.exports = $parcel$import("ax2aj").then(()=>parcelRequire('aPs0m'));

});

parcelRegister("3Evxr", function(module, exports) {
module.exports = $parcel$import("5t8XM").then(()=>parcelRequire('2ZMN7'));

});

parcelRegister("alx6z", function(module, exports) {
module.exports = $parcel$import("h9xqJ").then(()=>parcelRequire('9Pssv'));

});

parcelRegister("ipJXm", function(module, exports) {
module.exports = $parcel$import("7ro1u").then(()=>parcelRequire('bDStZ'));

});

parcelRegister("c7c8m", function(module, exports) {
module.exports = $parcel$import("a7rwj").then(()=>parcelRequire('kwnEI'));

});

parcelRegister("7hpVo", function(module, exports) {
module.exports = $parcel$import("343Ex").then(()=>parcelRequire('76oOX'));

});

parcelRegister("ed6Zh", function(module, exports) {
module.exports = $parcel$import("3a5OQ").then(()=>parcelRequire('gAm1R'));

});

parcelRegister("7XvZk", function(module, exports) {
module.exports = $parcel$import("jHcAF").then(()=>parcelRequire('CKniR'));

});

parcelRegister("irVKs", function(module, exports) {
module.exports = $parcel$import("l2on0").then(()=>parcelRequire('hAyLb'));

});

parcelRegister("fFZUI", function(module, exports) {
module.exports = $parcel$import("gy2u6").then(()=>parcelRequire('h2qZW'));

});

parcelRegister("ay6hC", function(module, exports) {
module.exports = $parcel$import("ccdv2").then(()=>parcelRequire('9L4RU'));

});

parcelRegister("l5xTI", function(module, exports) {
module.exports = $parcel$import("iwO2L").then(()=>parcelRequire('fo1g5'));

});

parcelRegister("14mcD", function(module, exports) {
module.exports = $parcel$import("epHiz").then(()=>parcelRequire('jI96S'));

});

var $723b74bb2949fb5d$exports = {};
$parcel$extendImportMap({
    "iE3Zn": "de.dd8943ef.js",
    "6mJjR": "es.cd4fde4b.js",
    "mHXrf": "fi.4ce0bcfa.js",
    "gppah": "fr.a8212081.js",
    "agVte": "hu.5aab6175.js",
    "ax2aj": "id.efe654ae.js",
    "5t8XM": "ja.a5c82d2c.js",
    "h9xqJ": "ko.fff80e94.js",
    "7ro1u": "lv.a18c59e8.js",
    "a7rwj": "nl.ed5da619.js",
    "343Ex": "pt-BR.1cdfde54.js",
    "3a5OQ": "ru.bfb489a1.js",
    "jHcAF": "sv.0757290c.js",
    "l2on0": "zh-CN.c71278a4.js",
    "gy2u6": "zh-TW.4f4a2294.js",
    "fIoFC": "cursor-rotate.0c8e34b1.png",
    "eVgmx": "klecks-logo.ae8bd45e.png",
    "fc1zd": "Caveat-Regular.2fe80bbd.woff2",
    "4qRL3": "ClimateCrisis-Regular-VariableFont_YEAR.3ad02523.woff2",
    "2B7B7": "CorrectionBrush.a69973aa.woff2",
    "eD12I": "DancingScript-Regular.ef2fe647.woff2",
    "5457Z": "Diabolik-Regular-VF.f4eeb79e.woff2",
    "1Ei10": "FreckleFace-Regular.05946539.woff2",
    "7aQdb": "Gloock-Regular.60f8f765.woff2",
    "9fGBZ": "Pacha.08c8457a.woff2",
    "byuQe": "GochiHand-Regular.c45792b0.woff2",
    "iJp7R": "PassionOne-Bold.9e08b0dc.woff2",
    "asUYV": "PixeloidSans.bc292131.woff2",
    "9tbSO": "PlaypenSans-Thin.314b29a4.woff2",
    "5eBTn": "Quicksand-Light.1f0c44a2.woff2",
    "5A31c": "Silkscreen-Regular.cef2b4cb.woff2",
    "jSUxb": "Tehroc-Regular.4540047b.woff2",
    "fFcMC": "YUNGA-Display.30c04a15.woff2",
    "2Iniz": "edit-invert.91bfa402.png",
    "3db7h": "edit-tilt-shift.7ad164eb.png",
    "h8wMh": "edit-triangle-blur.17417e43.png",
    "qDOS1": "edit-unsharp-mask.38afa514.png",
    "dc3Cy": "brush-sketchy.6c75169d.png",
    "i0cln": "loading.7ff8a2ac.gif",
    "ccdv2": "ag-psd.b33127f0.js",
    "iwO2L": "licenses.7eaed2ea.js",
    "epHiz": "font-licenses.760c91e6.js",
    "23yGC": "cursor-picker.71be1460.png",
    "2K3uA": "cursor-fill.ab749dde.png",
    "hp9Hj": "cursor-text.b4ebf6cd.png",
    "3DJrH": "cursor-zoom-ew.d3ab2d60.png"
});

/**
 * by bitbof (bitbof.com)
 */ // try no to import anything here
// sometimes Android WebView has no localStorage
if (!('localStorage' in window)) try {
    window.localStorage = {
        getItem: ()=>null,
        setItem: ()=>{},
        removeItem: ()=>{}
    };
} catch (e) {
// maybe it fails?
}
// ---------------- polyfills for roughly pre-module era (2017-18) ----------------------------
// sorted by first Chrome version with support
// Chrome 61, Edge 79, Safari 16, Firefox 107
if (!('scrollTo' in Element.prototype)) Object.defineProperty(Element.prototype, 'scrollTo', {
    value: function(x, y) {
        this.scrollLeft = x;
        this.scrollTop = y;
    }
});
// Chrome 61, Edge 79, Safari 16, Firefox 107
if (!('scrollBy' in Element.prototype)) Object.defineProperty(Element.prototype, 'scrollBy', {
    value: function(x, y) {
        this.scrollLeft += x;
        this.scrollTop += y;
    }
});
// Chrome 69, Edge 79, Safari 12, Firefox 62
if (!Array.prototype.flat) Object.defineProperty(Array.prototype, 'flat', {
    configurable: true,
    value: function flat(...args) {
        const depth = isNaN(args[0]) ? 1 : Number(args[0]);
        return depth ? Array.prototype.reduce.call(this, function(acc, cur) {
            if (Array.isArray(cur)) // eslint-disable-next-line prefer-spread
            acc.push.apply(acc, flat.call(cur, depth - 1));
            else acc.push(cur);
            return acc;
        }, []) : Array.prototype.slice.call(this);
    },
    writable: true
});
// Chrome 69, Edge 79, Safari 12, Firefox 62
if (!Array.prototype.flatMap) Object.defineProperty(Array.prototype, 'flatMap', {
    configurable: true,
    writable: true,
    value: function(callback, thisArg) {
        if (typeof callback !== 'function') throw new TypeError(callback + ' is not a function');
        const result = [];
        for(let i = 0; i < this.length; i++)if (i in this) {
            const mapped = callback.call(thisArg, this[i], i, this);
            if (Array.isArray(mapped)) result.push(...mapped);
            else result.push(mapped);
        }
        return result;
    }
});
/*
    Copyright 2018  Alfredo Mungo <alfredo.mungo@protonmail.ch>

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to
    deal in the Software without restriction, including without limitation the
    rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
    sell copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
    IN THE SOFTWARE.
*/ // Chrome 73, Firefox 63, Safari 26.6
if (!Object.fromEntries) Object.defineProperty(Object, 'fromEntries', {
    value (entries) {
        if (!entries || !entries[Symbol.iterator]) throw new Error('Object.fromEntries() requires a single iterable argument');
        const o = {};
        Object.keys(entries).forEach((key)=>{
            const [k, v] = entries[key];
            o[k] = v;
        });
        return o;
    }
});
// Chrome 85, Firefox 77, Safari 13.1
// if there are problems, maybe use core-js
if (!String.prototype.replaceAll) Object.defineProperty(String.prototype, 'replaceAll', {
    value: function(searchValue, replaceValue) {
        if (typeof replaceValue === 'function') throw new Error('replaceAll polyfill does not support replaceValue: function');
        if (typeof searchValue === 'string') return this.split(searchValue).join(replaceValue);
        const flags = searchValue.flags.includes('g') ? searchValue.flags : searchValue.flags + 'g';
        return this.replace(new RegExp(searchValue.source, flags), replaceValue);
    }
});
// Chrome 86, Edge 86, Safari 14, Firefox 78
if (!('replaceChildren' in Element.prototype)) Object.defineProperty(Element.prototype, 'replaceChildren', {
    value: function(...children) {
        this.innerHTML = '';
        this.append(...children);
    }
});
// Chrome 92, Firefox 90, Safari 15.4
if (!('at' in Array.prototype)) Object.defineProperty(Array.prototype, 'at', {
    value: function(index) {
        if (index >= 0) return this[index];
        if (index < 0) return this[index + this.length];
    }
});
// Chrome 92, Firefox 90, Safari 15.4
// ImageData.data is a Uint8ClampedArray. All typed arrays share this prototype.
const $897d95df968833af$var$typedArrayPrototype = Object.getPrototypeOf(Uint8Array.prototype);
if (!('at' in $897d95df968833af$var$typedArrayPrototype)) Object.defineProperty($897d95df968833af$var$typedArrayPrototype, 'at', {
    configurable: true,
    writable: true,
    value: function(index) {
        const i = Math.trunc(index);
        return this[i < 0 ? this.length + i : i];
    }
});
// Chrome 122, Firefox 127, Safari 17
if (!Set.prototype.difference) Object.defineProperty(Set.prototype, 'difference', {
    configurable: true,
    writable: true,
    value: function(other) {
        const result = new Set();
        for (const value of this)if (!other.has(value)) result.add(value);
        return result;
    }
});


/* eslint-disable quotes */ // generated from src/icons. "npm run icon:build" to update
const $7162d492f1f0eac6$export$df03f54e09e486fa = {
    "add-layer": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M33.75 18.86V35.6H17v16.5h16.75v16.74h16.49V52.1h16.75V35.6H50.24V18.86H33.75z\" fill=\"currentColor\"/></svg>",
    "align-center": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg version=\"1.1\" viewBox=\"0 0 26.458 26.458\" xmlns=\"http://www.w3.org/2000/svg\">\n<g display=\"none\">\n<path d=\"m25.084 13.229a11.854 11.854 0 0 1-11.854 11.854 11.854 11.854 0 0 1-11.854-11.854 11.854 11.854 0 0 1 11.854-11.854 11.854 11.854 0 0 1 11.854 11.854z\" fill=\"none\" opacity=\".25\" stroke=\"#f0f\" stroke-linecap=\"round\" stroke-width=\".13229\"/>\n</g>\n<g transform=\"translate(0 -270.54)\">\n<rect x=\"1.3702\" y=\"273.85\" width=\"23.713\" height=\"2.7179\"/>\n<rect x=\"5.0748\" y=\"278.09\" width=\"16.721\" height=\"2.7179\"/>\n<rect x=\"1.3702\" y=\"282.33\" width=\"23.713\" height=\"2.7179\"/>\n<rect x=\"5.0748\" y=\"286.57\" width=\"16.721\" height=\"2.7179\"/>\n<rect x=\"1.3702\" y=\"290.81\" width=\"23.713\" height=\"2.7179\"/>\n</g>\n</svg>\n",
    "align-left": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg version=\"1.1\" viewBox=\"0 0 26.458 26.458\" xmlns=\"http://www.w3.org/2000/svg\">\n<g display=\"none\">\n<path d=\"m25.084 13.229a11.854 11.854 0 0 1-11.854 11.854 11.854 11.854 0 0 1-11.854-11.854 11.854 11.854 0 0 1 11.854-11.854 11.854 11.854 0 0 1 11.854 11.854z\" fill=\"none\" opacity=\".25\" stroke=\"#f0f\" stroke-linecap=\"round\" stroke-width=\".13229\"/>\n</g>\n<g transform=\"translate(0 -270.54)\">\n<rect x=\"1.3702\" y=\"273.85\" width=\"23.713\" height=\"2.7179\"/>\n<rect x=\"1.3702\" y=\"278.09\" width=\"16.721\" height=\"2.7179\"/>\n<rect x=\"1.3702\" y=\"282.33\" width=\"23.713\" height=\"2.7179\"/>\n<rect x=\"1.3702\" y=\"286.57\" width=\"16.721\" height=\"2.7179\"/>\n<rect x=\"1.3702\" y=\"290.81\" width=\"23.713\" height=\"2.7179\"/>\n</g>\n</svg>\n",
    "align-right": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg version=\"1.1\" viewBox=\"0 0 26.458 26.458\" xmlns=\"http://www.w3.org/2000/svg\">\n<g display=\"none\">\n<path d=\"m25.084 13.229a11.854 11.854 0 0 1-11.854 11.854 11.854 11.854 0 0 1-11.854-11.854 11.854 11.854 0 0 1 11.854-11.854 11.854 11.854 0 0 1 11.854 11.854z\" fill=\"none\" opacity=\".25\" stroke=\"#f0f\" stroke-linecap=\"round\" stroke-width=\".13229\"/>\n</g>\n<g transform=\"translate(0 -270.54)\">\n<rect x=\"1.3702\" y=\"273.85\" width=\"23.713\" height=\"2.7179\"/>\n<rect x=\"8.3489\" y=\"278.09\" width=\"16.721\" height=\"2.7179\"/>\n<rect x=\"1.3702\" y=\"282.33\" width=\"23.713\" height=\"2.7179\"/>\n<rect x=\"8.3489\" y=\"286.57\" width=\"16.721\" height=\"2.7179\"/>\n<rect x=\"1.3702\" y=\"290.81\" width=\"23.713\" height=\"2.7179\"/>\n</g>\n</svg>\n",
    "angle": "<svg viewBox=\"0 0 53.33 53.33\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M36.45 26.65h-19.6l9.8-26.5 4.9 13.25z\" fill=\"#e03434\"/><path d=\"M16.84 26.65h19.6l-9.8 26.5-4.9-13.25z\" fill=\"#fff\"/></svg>",
    "bitbof-logo": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 52.9 52.9\"><defs><linearGradient id=\"c\"><stop stop-color=\"#4d00fb\" offset=\"0\"/><stop stop-color=\"#d600ed\" offset=\"1\"/></linearGradient><linearGradient id=\"b\"><stop stop-color=\"#fdfc13\" offset=\"0\"/><stop stop-color=\"#ffe802\" offset=\"1\"/></linearGradient><linearGradient id=\"a\"><stop stop-color=\"#00f8ff\" offset=\"0\"/><stop stop-color=\"#39a3ff\" offset=\"1\"/></linearGradient><linearGradient xlink:href=\"#a\" id=\"h\" x1=\"26.5\" y1=\"247.7\" x2=\"26.5\" y2=\"267.1\" gradientUnits=\"userSpaceOnUse\"/><linearGradient xlink:href=\"#b\" id=\"i\" x1=\"32.4\" y1=\"270.5\" x2=\"49.1\" y2=\"270.5\" gradientUnits=\"userSpaceOnUse\"/><linearGradient xlink:href=\"#c\" id=\"j\" x1=\"12\" y1=\"260.1\" x2=\"12\" y2=\"281\" gradientUnits=\"userSpaceOnUse\"/><linearGradient xlink:href=\"#d\" id=\"m\" x1=\"95.9\" y1=\"82.1\" x2=\"95.9\" y2=\"143.2\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(-13.3 -28.5) scale(.50879)\"/><linearGradient id=\"d\"><stop stop-color=\"#111\" offset=\"0\"/><stop stop-color=\"#6a6a6a\" offset=\"1\"/></linearGradient><linearGradient xlink:href=\"#e\" id=\"n\" x1=\"56.7\" y1=\"137.5\" x2=\"56.7\" y2=\"84\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(-1 -32.3) scale(.52924)\"/><linearGradient id=\"e\"><stop stop-color=\"#c7c7c7\" offset=\"0\"/><stop stop-color=\"#444\" offset=\"1\"/></linearGradient><linearGradient gradientTransform=\"translate(-24.4 214.3) scale(.52924)\" xlink:href=\"#f\" id=\"k\" x1=\"105.9\" y1=\"139\" x2=\"105.9\" y2=\"154.7\" gradientUnits=\"userSpaceOnUse\"/><linearGradient id=\"f\"><stop stop-color=\"#23005f\" offset=\"0\"/><stop stop-color=\"#2d00b0\" offset=\"1\"/></linearGradient><linearGradient gradientTransform=\"translate(-7.7 214.2) scale(.52924)\" xlink:href=\"#g\" id=\"l\" x1=\"90.5\" y1=\"131\" x2=\"90.5\" y2=\"115.7\" gradientUnits=\"userSpaceOnUse\"/><linearGradient id=\"g\"><stop stop-color=\"#38da00\" offset=\"0\"/><stop stop-color=\"#ffaea2\" offset=\"1\"/></linearGradient></defs><path fill=\"url(#h)\" d=\"M26.5 244.4 4.9 256.8l15.7 9h11.8l15.6-9z\" transform=\"translate(0 -244)\"/><path fill=\"url(#i)\" d=\"m49.1 258.8-16.7 9.6-3 2.1 3 2.2 16.7 9.6z\" transform=\"translate(0 -244)\"/><path fill=\"url(#j)\" d=\"M3.8 258.8v23.5l16.8-9.7 2.9-2-2.9-2.1z\" transform=\"translate(0 -244)\"/><path transform=\"translate(0 -244)\" d=\"M48 284.3H5l21.5 12.4z\" fill=\"url(#k)\"/><path d=\"M48 284.3s-5.2 3.5-21.5 3.5c-16 0-21.6-3.5-21.6-3.5l21.6-12.6z\" fill=\"url(#l)\" transform=\"translate(0 -244)\"/><path fill=\"url(#m)\" d=\"m20.6 7 10.7 1.3 1.1 37.2H20.6Z\"/><path fill=\"url(#n)\" d=\"M20.6 7c0 7.9 11.8 31.4 11.8 38.5V7Z\"/></svg>",
    "brush-blend": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 52\"><defs><filter id=\"a\"><feGaussianBlur stdDeviation=\"2.3\"/></filter></defs><path d=\"M18.1 36.38s-5.66-2.27-7.1-5.98c-1.45-3.72-2.37-12.85 3.82-13.83C21 15.6 25.43 19.51 26.2 24c.77 4.49.14 8.59.05 10.73-.15 3.62 2.68.67 3.92-1.5 4.38-7.63-.42-18.35-.05-20.89.93-6.45 9.42-3.78 10.21-.72 2.43 9.39 2.63 16.1-2.37 25.48-1.78 3.34-5.16 7.38-9.03 7.59-3.87.2-7.67-2.52-7.9-5.73-.3-4.44.16-10.32-.77-12.69-.92-2.37-.3-5.42-2.83-4.7-2.53.73-4.43 2.33-3.6 5.43.82 3.1 2.27 5.1 3.66 5.83 1.4.72.62 3.56.62 3.56z\" fill=\"currentColor\" filter=\"url(#a)\" transform=\"matrix(1.0575 0 0 1.05595 -1.6 -2.04)\"/></svg>\n",
    "brush-chemy": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 52\"><path fill=\"currentColor\" d=\"M46.6 48.2c-72.5 0 35.2-51.1-39.5-42\"/></svg>\n",
    "brush-eraser": "<svg viewBox=\"0 0 52 52\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30.46 9.68 8.45 31.7v3.06l7.9 8.04h27.88v-2.92H27.49L43.88 23.5v-2.83L32.9 9.68h-2.44zM20.68 24.1l9.45 9.25-6.44 6.44H18.1l-6.56-6.56 9.13-9.13z\" fill=\"currentColor\"/></svg>\n",
    "brush-pen": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 52\"><path d=\"M22.7 5.06c-5.47.1-11.08 3.87-13.52 6.86-2.56 3.13-2.8 8.93 1.91 11.2 4.16 1.99 12.23 1.49 16.61 1.38 4.39-.1 11.79-.39 13.52 3.1 2.13 4.3-2.07 10-5.57 12.64-3.51 2.63-11.35 3.04-15.79 2.06-4.44-.98-8.36-2.53-8.36-2.53s3.78 3.52 7.58 4.98c4.13 1.58 14.04 2.48 19.15-1.24 5.86-4.27 7.89-9.56 7.94-13.54.05-3.97-1.75-7.94-5.98-8.87-4.23-.93-9.45-.85-16.3-.67-2.85.07-8.07.1-9.95-.8-2.7-1.31-3.5-3.8.14-6.63 5.11-4.6 14.76-6 19.86 2.06 1.14 2.27 4.14 1.7 4.29-.36.16-2.37-2.22-4.95-4.5-6.76-2.26-1.8-5.56-2.99-11.03-2.88Z\" fill=\"currentColor\"/></svg>\n",
    "brush-pixel": "<svg viewBox=\"0 0 52 52\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.45 5.18v5.37h5.38V5.18zm0 5.37H5.08v10.76h5.37v-5.38zm0 10.76v5.37h16.13v-5.37H15.83zm16.13 0h5.38v-5.38h-5.38zm5.38-5.38H42.7v-5.38H31.96zm10.75 0v10.75h5.37V15.93zm0 10.75h-5.38v5.38h5.38zm-5.38 5.38H26.58v5.37h10.75zm-10.75 5.37H21.2V48.2h5.38z\" fill=\"currentColor\"/></svg>\n",
    "brush-pressure": "<svg viewBox=\"0 0 42.67 42.67\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m28.13-.67-13.5 16.56-.03.62c3.96 5.87 10.33 9.4 14.28 11.41l.9-.15L43.22 11.8l.13-12.4-15.22-.06zM14.24 17.09l-.7.4-2.43 16.04.08.45-.42 1.8.4.29 1.52-.87.6-.01 14.92-6.14.3-.76c-4.21-1.62-12.1-7.36-14.27-11.2z\" fill=\"currentColor\"/></svg>\n",
    "brush-smudge": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 52\"><path d=\"M28 2.3s5 .3 9 2S43 8 43 8s-.7 1.2 0 2c1.7 2 3.3 9.8 1.5 15.3-5 15.4-14.8 12.5-14.8 12.5L38 23l-1-.4s-8 14.5-11.3 19.2c-3.2 4.8-7.7 8.1-11.7 8-4-.1-7-4.2-3.4-6.4 6.4-4.8 12-15 11.9-15l-.7-.4-4.8 7.4s-6.6-1.3-7.7-6C8 21 12 8.4 20.4 6 26.8 4.3 28 2.3 28 2.3Z\" fill=\"currentColor\"/></svg>\n",
    "cancel": "<svg viewBox=\"0 0 13.902 22\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.18 3.307 0 5.216l5.025 5.74L0 16.698l2.18 1.908 4.771-5.449 4.77 5.45 2.181-1.909-5.025-5.742 5.025-5.74-2.181-1.909-4.77 5.45Z\" fill=\"#bbb\"/></svg>",
    "caret-down": "<svg viewBox=\"0 0 26.7 26.7\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2 8h22.7L13.3 22Z\" fill=\"#1c1c1c\"/></svg>",
    "check": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.789 25\"><path d=\"M.444 13.163c1.438 2.5 3.414 6.022 4.144 7.277.689 1.185 3.076 1.762 4.11-.098 1.494-2.687 6.05-11.754 6.825-13.326 1.303-2.643-2.522-4.652-4.13-1.489C9.89 8.484 6.537 14.58 6.537 14.58s-1.575-2.699-2.203-3.722c-1.848-3.01-5.623-.524-3.89 2.305z\" fill=\"#fff\"/></svg>",
    "chevron-down": "<svg viewBox=\"0 0 26.67 26.67\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m4.64 7.76-3.27 3.28 11.9 11.9 11.9-11.9-3.27-3.28-8.63 8.63-8.63-8.63z\" fill=\"currentColor\"/></svg>",
    "constrain": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg version=\"1.1\" viewBox=\"0 0 17 46\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"m0.99726 1.792v1.8008h9.5801v10.064h-4.0644v10.107h4.0644v1.5371h-4.0644v10.107h4.0644v7.5586h-9.5801v1.8008h11.383v-9.3594h3.7578v-10.107h-3.7578v-1.5371h3.7578v-10.107h-3.7578v-11.865h-11.383zm7.3184 13.666h6.0195v6.5039h-1.9551v-2.8125h-1.8027v2.8125h-2.2617zm0 11.646h2.2617v3.0312h1.8027v-3.0312h1.9551v6.502h-6.0195z\" fill=\"#aaa\"/>\n</svg>\n",
    "copy": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 85.33 85.33\"><path d=\"M22.96 79.91V20.06h54.15v59.85H22.96Zm6.69-6.69h40.77V26.76H29.65Zm-21.38-6.6V6.67h54.15v9.22h-6.7v-2.53H14.97v46.55h3.62v6.7H8.28Z\" fill=\"#565656\"/></svg>",
    "duplicate-layer": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.96 6.68v59.84h54.15V6.68H22.96zm6.69 6.69h40.77v46.46H29.65V13.37zm-21.38 6.6V79.92h54.15v-9.22h-6.7v2.53H14.97V26.67h3.62v-6.7H8.28zm37.74 3.26V33h-9.76v7.96H46v9.76h7.96v-9.76h9.76v-7.96h-9.76v-9.76H46z\" fill=\"currentColor\"/></svg>",
    "edit-brightness-contrast": "<svg viewBox=\"0 0 24 26.7\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"13.5\" r=\"10.2\" fill=\"none\" opacity=\".8\" stroke=\"#000\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2.2\"/><path d=\"M12 6.6a7 7 0 0 0-7 6.9 7 7 0 0 0 7 7v-14z\" opacity=\".8\"/><path d=\"M12 6.6a7 7 0 0 1 7 6.9 7 7 0 0 1-7 7v-14z\" fill=\"#fff\" opacity=\".8\"/></svg>",
    "edit-crop": "<svg viewBox=\"0 0 24 26.7\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3.8 1v3.3h3V1h-3zM.2 5.2v3h17v9.6h3.1V5.2H.3zM3.8 9v12.6H24v-3H7V9h-3zm13.5 13.5v3.3h3v-3.3h-3z\"/></svg>",
    "edit-curves": "<svg viewBox=\"0 0 24 26.7\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 25.8C8.7 25.8 2 3 24 3\" fill=\"none\" stroke=\"#0f0\" stroke-width=\"1.6\"/><path d=\"M0 25.8C10.1 25.8 14.1 3.6 24 3.6\" fill=\"none\" stroke=\"red\" stroke-width=\"1.6\"/><path d=\"M0 25.8C5 25.8 1.3 7 7 7S10.8 18 16.6 18c5.7 0 2.3-14.3 8-14.3\" fill=\"none\" stroke=\"#00f\" stroke-width=\"1.6\"/></svg>",
    "edit-distort": "<svg viewBox=\"0 0 24 26.667\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#000\" d=\"M14.001 22.045c-.528-.17-.848-.349-1.826-1.016-1.215-.829-1.713-1.107-2.422-1.352-.665-.23-.927-.245-3.348-.176-1.026.03-1.387-.05-1.797-.391-.194-.163-.224-.227-.224-.478 0-.32.079-.434.907-1.322.503-.538.598-.757.495-1.14-.1-.373-.398-.678-1.427-1.462-1.263-.963-1.638-1.38-1.638-1.817 0-.493.304-.826 1.565-1.715 1.277-.9 1.76-1.483 1.76-2.12 0-.161-.077-.556-.171-.877-.337-1.147-.21-1.625.661-2.475.875-.854 2.173-1.571 3.145-1.738.653-.112 1.244-.006 1.97.352.47.232.677.396 1.414 1.114.475.463.972.916 1.104 1.006.613.416 1.684.772 2.701.898 2.502.309 4.499 1.346 4.499 2.337 0 .415-.253.752-1.125 1.494-1.547 1.315-1.607 1.718-.463 3.105.397.482.676.995.674 1.242-.005.5-.4.933-1.862 2.04-1.586 1.202-2.015 1.723-2.184 2.658-.164.898-.247 1.105-.578 1.436-.496.497-1.11.63-1.83.397z\"/></svg>",
    "edit-flip": "<svg viewBox=\"0 0 24 26.7\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 0h2v26.6h-2z\" fill=\"#585858\"/><path d=\"M10 5.6.2 21.9H10V5.6zm4.1 0v16.3h9.6L14.1 5.6z\"/></svg>",
    "edit-grid": "<svg viewBox=\"0 0 24 26.667\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke=\"#000\" stroke-width=\"2\" d=\"M7.632 1.197v24.431M16.91 1.216v24.431m7.362-16.556H-.159m24.412 9.279H-.177\"/></svg>",
    "edit-hue-saturation": "<svg viewBox=\"0 0 98.034 98.034\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\"><defs><linearGradient id=\"b\"><stop stop-color=\"red\" stop-opacity=\"1\" offset=\"0\"/><stop stop-color=\"#ff0\" stop-opacity=\"1\" offset=\".157\"/><stop stop-color=\"#0f0\" stop-opacity=\"1\"  offset=\".33\"/><stop stop-color=\"#0ff\" stop-opacity=\"1\" offset=\".5\"/><stop stop-color=\"#00f\" stop-opacity=\"1\" offset=\".66\"/><stop stop-color=\"#f0f\" stop-opacity=\"1\" offset=\".83\"/><stop stop-color=\"red\" stop-opacity=\"1\" offset=\"1\"/></linearGradient><linearGradient id=\"a\"><stop stop-color=\"gray\" stop-opacity=\"1\" offset=\".055\"/><stop stop-color=\"gray\" stop-opacity=\".8\" offset=\".42\"/><stop stop-color=\"gray\" stop-opacity=\"0\" offset=\"1\"/></linearGradient><linearGradient xlink:href=\"#a\" id=\"d\" x1=\"61.478\" y1=\"151.519\" x2=\"154.274\" y2=\"151.519\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(-243.057 -45.948) scale(1.05645)\"/><linearGradient xlink:href=\"#b\" id=\"c\" x1=\"52.385\" y1=\"142.562\" x2=\"150.419\" y2=\"142.562\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(12.722 -13.47)\"/></defs><path fill=\"url(#c)\" fill-opacity=\"1\" stroke=\"none\" stroke-width=\".264999\" stroke-dasharray=\"none\" stroke-opacity=\".980769\" d=\"M65.107 80.074h98.034v98.034H65.107z\" transform=\"translate(-65.107 -80.074)\"/><path fill=\"url(#d)\" fill-opacity=\"1\" stroke=\"none\" stroke-width=\".265\" stroke-dasharray=\"none\" stroke-opacity=\".980769\" transform=\"rotate(-90 -72.59 -7.484)\" d=\"M-178.108 65.107h98.034v98.034h-98.034z\"/></svg>",
    "edit-noise": "<svg viewBox=\"0 0 24 26.667\" xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"a\"><feTurbulence type=\"fractalNoise\" baseFrequency=\"6.29\" numOctaves=\"6\" stitchTiles=\"stitch\"/><feColorMatrix values=\"0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\"/><feComponentTransfer><feFuncR type=\"linear\" slope=\"8\" intercept=\"-3.5\"/><feFuncG type=\"linear\" slope=\"8\" intercept=\"-3.5\"/><feFuncB type=\"linear\" slope=\"8\" intercept=\"-3.5\"/></feComponentTransfer></filter><rect width=\"100%\" height=\"100%\" filter=\"url(#a)\"/></svg>",
    "edit-pattern": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 26.67\"><path fill=\"#0080ea\" d=\"M3.15 4.79v4.427l4.178-4.428H3.15zm6.6 0v4.427l4.178-4.428H9.75zm6.6 0v4.427l4.18-4.428h-4.18zm-13.2 6.599v4.43l4.178-4.43H3.15zm6.6 0v4.43l4.178-4.43H9.75zm6.6 0v4.43l4.18-4.43h-4.18zM3.15 17.99v4.428l4.178-4.428H3.15zm6.6 0v4.428l4.178-4.428H9.75zm6.6 0v4.428l4.18-4.428h-4.18z\"/></svg>",
    "edit-pencil": "<svg viewBox=\"0 0 85.3 85.3\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#4f4f4f\" d=\"M15.6 52.8a12.4 12.4 0 0 0-3.3 5.7L7.5 74.7a3.2 3.2 0 0 0 4 4L27.6 74c2.2-.5 4.2-1.6 5.9-3.3l37.2-37.2-18-18Zm40.9-41 18 18 1.9-2a12.4 12.4 0 0 0 0-17.5l-.4-.4a12.4 12.4 0 0 0-17.6 0z\"/></svg>",
    "edit-perspective": "<svg viewBox=\"0 0 24 26.7\" xmlns=\"http://www.w3.org/2000/svg\"><defs><linearGradient id=\"a\" x1=\"4.3\" x2=\"19.7\" y1=\"13.5\" y2=\"13.5\" gradientTransform=\"translate(.1 .4)\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\"/><stop stop-color=\"#878787\" offset=\"1\"/></linearGradient></defs><path d=\"M5.5 24 20 16.8v-6L5.5 3z\" fill=\"url(#a)\"/></svg>",
    "edit-resize": "<svg viewBox=\"0 0 24 26.7\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.6 2.2v1.7H20L3 21.1v-5.3H1v8.4h8.6v-1.6H4L21.3 5.3v5.3H23V2.3z\" fill=\"#5d5d5d\" stroke-width=\"1\"/></svg>",
    "edit-rotate": "<svg viewBox=\"0 0 24 26.67\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.87 3.82c-5.69 0-10.31 4.62-10.31 10.3 0 5.69 4.62 10.31 10.3 10.31 4.14 0 7.71-2.45 9.35-5.98l-1.55-.7a8.59 8.59 0 0 1-16.4-3.62A8.59 8.59 0 0 1 19.1 9.49l-4.16-1.25-.45 1.5 5.1 1.54 1.5.46.46-1.51 1.53-5.1-1.51-.45-1.13 3.74a10.3 10.3 0 0 0-8.56-4.6z\" fill=\"#484848\"/></svg>",
    "edit-to-alpha": "<svg viewBox=\"0 0 24 26.7\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#fff\" d=\"M0 0h24v26.7H0z\"/><path d=\"M15 0v3h3V0zm3 3v3h3V3zm3 0h3V0h-3zm0 3v3h3V6zm0 3h-3v3h3zm0 3v3h3v-3zm0 3h-3v3h3zm0 3v3h3v-3zm0 3h-3v3h3zm0 3v3h3v-3zm-3 0h-3v3h3zm-3 0v-3h-3v3zm0-3h3v-3h-3zm0-3v-3h-3v3zm0-3h3v-3h-3zm0-3V9h-3v3zm0-3h3V6h-3zm0-3V3h-3v3z\" fill=\"#c9c9c9\"/><path d=\"M12 2.3A11.2 11.2 0 0 0 .7 13.5 11.2 11.2 0 0 0 12 24.7V2.3z\" fill=\"#2185ff\"/><path d=\"M12 2.3a11.2 11.2 0 0 1 11.2 11.2A11.2 11.2 0 0 1 12 24.7V2.3z\" fill-opacity=\".6\"/></svg>",
    "edit-transform": "<svg viewBox=\"0 0 24 26.7\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path d=\"m18.8 6.3-2.5 2.5-6-6a.5.5 0 0 0-.6 0l-8.3 8.4a.5.5 0 0 0 0 .7l12.3 12.3a.5.5 0 0 0 .6 0l8.4-8.4a.5.5 0 0 0 0-.7l-5.5-5.5 2.4-2.4zM10 3.8l11.6 11.7-7.7 7.7L2.4 11.5z\" fill=\"#8f8f8f\"/><circle id=\"a\" transform=\"rotate(45)\" cx=\"9.4\" cy=\"-4.6\" r=\"1.4\"/><use id=\"b\" transform=\"translate(-8 8)\" width=\"100%\" height=\"100%\" xlink:href=\"#a\"/><use id=\"c\" transform=\"translate(12.3 12.3)\" width=\"100%\" height=\"100%\" xlink:href=\"#b\"/><use id=\"d\" transform=\"translate(8 -8.1)\" width=\"100%\" height=\"100%\" xlink:href=\"#c\"/><use transform=\"translate(-3 -8.9)\" width=\"100%\" height=\"100%\" xlink:href=\"#d\"/></svg>",
    "edit-vanish-point": "<svg viewBox=\"0 0 24 26.667\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"1\" d=\"M22.877 13.373H1.29M12.083 2.579v21.588M21.431 7.976 2.735 18.77M17.48 4.025 6.686 22.72M6.686 4.025 17.48 22.72M2.735 7.976 21.431 18.77\"/></svg>",
    "error": "<svg viewBox=\"0 0 85.3 85.3\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.5 64.4 65 21M21.5 21 65 64.4\" fill=\"none\" stroke=\"#ed2218\" stroke-linecap=\"round\" stroke-width=\"17\"/></svg>",
    "export": "<svg viewBox=\"0 0 69.514 74.486\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.955 0v31.893H11.297l11.594 14.262 11.596 14.262 11.594-14.262 11.596-14.262H45.198V0H23.956ZM0 63.91v10.576h69.514V63.91Z\" fill=\"#007bed\"/></svg>",
    "help": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M42.76 1.38A41.54 41.54 0 0 0 1.29 42.85a41.54 41.54 0 0 0 41.47 41.47 41.54 41.54 0 0 0 41.47-41.47A41.54 41.54 0 0 0 42.76 1.38zm0 8.7a32.7 32.7 0 0 1 32.77 32.77 32.7 32.7 0 0 1-32.77 32.77A32.7 32.7 0 0 1 9.99 42.85a32.7 32.7 0 0 1 32.77-32.77zm.44 10.35c-3.12-.03-6.24.64-8.7 2.28-3.89 2.57-4.86 6.87-5.02 10.76 2.46.03 4.92-.03 7.38-.08.04-1.63.3-3.3 1.12-4.8 1.6-3.05 7.25-3.38 9.72-.93 2.22 2.43 1.39 5.43-.32 7.94-1.69 2.12-3.75 4.4-5.58 6.44-3.06 2.97-2.97 7.23-2.99 10.94h7.49c.21-4.54-.88-5.4 6.73-12.86 2.58-2.78 3.97-7.03 3.4-10.49-.39-3.72-3.3-7.31-7.73-8.45a22.52 22.52 0 0 0-5.5-.75zm-4.57 36.1v7.53h7.69v-7.53h-7.69z\" fill=\"currentColor\"/></svg>\n",
    "import": "<svg viewBox=\"0 0 24 26.67\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.9 7.06 1.5 8.27 1.4 24.4l.48 1.3 15.14.03 2.34-.43 2.55-15.59-.46-.93z\" fill=\"#c19602\"/><path fill=\"#fff\" stroke=\"#d0d0d0\" stroke-width=\".87\" d=\"M6.64 1.83 20.8 3.57l-2.39 19.47-14.17-1.73z\"/><path d=\"M6.11 13.16H23.1c-.02 2.58-.86 11.6-3.73 12.14l-17.14-.05z\" fill=\"#fccc2b\"/></svg>",
    "language": "<svg viewBox=\"0.5 3 23 18\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"1.3\" y=\"3.8\" width=\"12.5\" height=\"12.5\" rx=\"2.5\"/><path d=\"M13.8 7.8h6.5a2.5 2.5 0 0 1 2.4 2.5v7.5a2.5 2.5 0 0 1-2.4 2.4h-7.5a2.5 2.5 0 0 1-2.6-2.4v-1.6M4.5 13.3l3-6.6 3 6.6M5.6 11h3.8\"/><path d=\"M16.5 11.1v1.3m-2.7 1.2h5.4m-4.1 0q1 2.3 4.1 3.3m-1.3-3.3q-1 2.3-4.1 3.3\"/></g></svg>",
    "layer-clipping": "<svg viewBox=\"0 0 26.7 26.7\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m7.6 16.3-2.2 2 7.7 7.8 7.8-7.7-2.2-2.1-5.6 5.5z\" fill=\"currentColor\" stroke-width=\"1\"/><path fill=\"currentColor\" d=\"M20.7.9c-5 0-9 4-9 9v12.6h3V9.9a6 6 0 0 1 6-6h3V1Z\" stroke-width=\"1\"/></svg>",
    "merge-layers": "<svg viewBox=\"0 0 26.67 26.67\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.77 2.08v5.16H8.64l4.69 4.62 2.34-2.31 2.35-2.3h-2.97V2.07zm1.53 11.97-10.85 3.5 10.85 3.51 10.86-3.5zM5.86 20.1l-3.41 1.13 10.85 3.51 10.86-3.5-3.65-1.12-7.2 2.4z\" fill=\"currentColor\"/></svg>",
    "new-image": "<svg viewBox=\"0 0 18.68 22.99\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#fff\" stroke=\"#000\" stroke-width=\"1\" stroke-opacity=\"0.4\" d=\"M.35.35h17.98v22.29H.35z\"/></svg>",
    "ok": "<svg viewBox=\"0 0 85.3 85.3\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m16 42.7 20.4 23.1 34.7-45\" fill=\"none\" stroke=\"#71e009\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"13.6\"/></svg>",
    "remove-layer": "<svg viewBox=\"0 0 26.67 26.67\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.88.87a1.05 1.05 0 0 0-1.05 1.05v.28H5.85A1.05 1.05 0 0 0 4.8 3.25v.87a1.05 1.05 0 0 0 1.05 1.05h14.2a1.05 1.05 0 0 0 1.06-1.05v-.87a1.05 1.05 0 0 0-1.05-1.05h-3.84v-.28A1.05 1.05 0 0 0 15.17.87h-4.3zM6.16 6.3A1.05 1.05 0 0 0 5.1 7.34V24.1a1.05 1.05 0 0 0 1.05 1.05h13.87a1.05 1.05 0 0 0 1.05-1.05V7.34a1.05 1.05 0 0 0-1.05-1.05H6.16zm2.49 1.62a1.5 1.5 0 0 1 1.52 1.53v12.62a1.5 1.5 0 1 1-3 0V9.44A1.5 1.5 0 0 1 8.65 7.9zm4.55 0a1.5 1.5 0 0 1 1.52 1.53v12.62a1.5 1.5 0 1 1-3 0V9.44A1.5 1.5 0 0 1 13.2 7.9zm4.57 0a1.5 1.5 0 0 1 1.53 1.53v12.62a1.5 1.5 0 1 1-3 0V9.44a1.5 1.5 0 0 1 1.47-1.53z\" fill=\"currentColor\"/></svg>",
    "rename-layer": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 85.3 85.3\"><path fill=\"currentColor\" d=\"M6 25v35h41.5v-5H10.8V29.9h36.7V25zm60.4 0v4.8h7.4v25.3h-7.4V60h12.3V25Z\"/><g fill=\"none\" stroke=\"currentColor\" stroke-width=\"6.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"4\" stroke-dasharray=\"none\" stroke-opacity=\"1\"><path d=\"m64.3 9.5-7.6 4.8v46\"/><path d=\"m49.2 9.5 7.5 4.8v46\"/><path d=\"m64.3 77.3-7.6-4.8v-46\"/><path d=\"m49.2 77.3 7.5-4.8v-46\"/></g></svg>",
    "select-default": "<svg viewBox=\"0 0 8.5 8.5\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#000\" stroke=\"none\" d=\"M1 1.1h6.4v6.4H1z\"/></svg>",
    "select-mode-move": "<svg viewBox=\"0 0 85.3 85.3\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#1c1c1c\" stroke-width=\"4\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" stroke-opacity=\"1\" d=\"M42.8 9.7v66.9\"/><path fill=\"none\" stroke=\"#1c1c1c\" stroke-width=\"4\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" stroke-dasharray=\"none\" stroke-opacity=\"1\" d=\"M53 66 42.8 76 32.4 65.8M32.6 19.6 42.8 9.4l10.3 10.3M76.3 43.3H9.4M20 53.4 10 43.2 20.2 33M66.4 33l10.2 10.2-10.3 10.4\"/></svg>",
    "select-mode-select": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\">\n    <rect x=\"8\" y=\"8\" width=\"70\" height=\"70\" rx=\"10\" stroke=\"currentColor\" fill=\"none\" stroke-width=\"4\" stroke-dasharray=\"10\"/>\n</svg>",
    "select-shape-ellipse": "<svg viewBox=\"0 0 16.9 16.9\" xmlns=\"http://www.w3.org/2000/svg\"><ellipse fill=\"none\" stroke=\"#000\" stroke-width=\"0.26\" cx=\"8.5\" cy=\"8.5\" rx=\"5.9\" ry=\"4.4\"/></svg>",
    "select-shape-lasso": "<svg viewBox=\"0 0 16.9 16.9\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"0.26\" d=\"M9.5 3.1c-2-.3-6.4-.6-6 1.8.6 2.3 2.2 1.6 2 3.3 0 1.7-2.5 2.6-2.3 5.1.2 2.5 4 2.2 5.5 2 1.4 0 4.5-1.2 3.9-2.6-.7-1.4-2.8-1-3.1-2.8-.3-1.8 3.7-1 4.9-4 .5-1.6-3-2.5-5-2.8Z\"/></svg>",
    "select-shape-poly": "<svg viewBox=\"0 0 16.9 16.9\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"0.26\" d=\"M7.4 2.6 1.3 5.4l7.4 2.8-5.5 6.4 12.1-2.4-3.8-1.5L14.3 5Z\"/></svg>",
    "select-shape-rect": "<svg viewBox=\"0 0 16.9 16.9\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\"0.26\" d=\"M2.9 2.9h11.2v11.2H2.9z\"/></svg>",
    "select-subtract": "<svg viewBox=\"0 0 8.5 8.5\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke=\"#000\" stroke-width=\".3\" d=\"M.9.9h4.4v4.4H.9zm2.3 2.4h4.4v4.4H3.2z\"/><path d=\"M1 1v4.3h2.2v-2h2.1V.9\"/></svg>",
    "select-transform-warp": "<svg xmlns=\"http://www.w3.org/2000/svg\" stroke=\"#000\" stroke-width=\"0.5\" viewBox=\"0 0 16.9 16.9\"><path fill=\"none\" d=\"M7.324 2.732c2.199 4.66-3.64 6.305-.66 11.26M11.14 2.736c1.785 5.073-2.93 6.572-.594 11.26m3.627-2.268c-4.217 3.047-7.097-6.038-11.26-1.22m11.249-2.646c-3.46 2.714-5.314-5.6-11.26-1.55M2.895 2.73h11.28v11.28H2.896Z\"/></svg>",
    "select-union": "<svg viewBox=\"0 0 8.5 8.5\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M.9.9h4.4v4.4H.9z\"/><path d=\"M3.2 3.3h4.4v4.4H3.2z\"/></svg>",
    "share": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M62.92 5.6a11.57 11.57 0 0 0-11.58 11.58 11.57 11.57 0 0 0 .16 1.85L27.1 34.09A11.57 11.57 0 0 0 19.25 31 11.57 11.57 0 0 0 7.68 42.58a11.57 11.57 0 0 0 11.57 11.57 11.57 11.57 0 0 0 8.3-3.53l24.42 14.93a11.57 11.57 0 0 0-.35 2.79 11.57 11.57 0 0 0 11.57 11.57 11.57 11.57 0 0 0 11.57-11.57 11.57 11.57 0 0 0-11.57-11.57 11.57 11.57 0 0 0-7.47 2.75L30.7 44.22a11.57 11.57 0 0 0 .13-1.64 11.57 11.57 0 0 0-.24-2.3l24.17-14.92a11.57 11.57 0 0 0 8.17 3.39 11.57 11.57 0 0 0 11.57-11.57A11.57 11.57 0 0 0 62.92 5.6z\" fill=\"#4f4f4f\"/></svg>",
    "tab-edit": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#1c1c1c\" d=\"M26.61 11.389a9.373 9.373 0 0 0-9.374 9.375 9.373 9.373 0 0 0 9.373 9.373 9.373 9.373 0 0 0 9.373-9.373 9.373 9.373 0 0 0-9.373-9.375zM8.29 17.419v6.694h7.953V17.42H8.291zm28.68.003v6.693h40.092v-6.693H36.97zm21.636 16.11a9.373 9.373 0 0 0-9.373 9.372 9.373 9.373 0 0 0 9.373 9.373 9.373 9.373 0 0 0 9.375-9.373 9.373 9.373 0 0 0-9.375-9.373zM8.152 39.575v6.692h40.092v-6.692H8.152zm60.784.06v6.694h8.082v-6.693h-8.082zM36.592 55.716a9.373 9.373 0 0 0-9.373 9.373 9.373 9.373 0 0 0 9.373 9.375 9.373 9.373 0 0 0 9.373-9.375 9.373 9.373 0 0 0-9.373-9.373zm10.332 5.86v6.69H77.07v-6.69H46.924zm-38.787.001v6.694h18.101v-6.694H8.137z\"/></svg>",
    "tab-layers": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\"><path fill=\"#1c1c1c\" d=\"m40.2 10.6-32.9 18 33 18 32.8-18-32.9-18zM13.3 37.5l-6.1 3.4 32.9 18 32.9-18-6-3.3-26.7 14.6-27-14.7zm0 12.6-6.1 3.3 32.9 18 32.9-18-6-3.2-26.7 14.6-27-14.7z\"/></svg>",
    "tab-settings": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\"><g stroke=\"#1c1c1c\" stroke-width=\"6.4\"><circle cx=\"41.5\" cy=\"18.9\" r=\"3.2\"/><circle cx=\"41.5\" cy=\"40.1\" r=\"3.2\"/><circle cx=\"41.5\" cy=\"61.2\" r=\"3.2\"/></g></svg>",
    "tool-fill": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m52.32 17.3-5.28 5.26-3.74-3.73-22.97 23.1 29.72 29.72h6l16.88-16.87v-6.33L50.37 25.9l5.27-5.27-3.32-3.33zm-5.44 12.46 15.5 15.5H30.43l-3.33-3.33 7.22-7.22 3.8 3.8 8.76-8.75zM19.24 42.6s-3 10.4-4.35 15.82c-1.34 5.44-1.15 11.57 3.9 11.64 4.76.06 5.76-4.71 4.25-11.57a659.54 659.54 0 0 0-3.8-15.89z\" fill=\"#1c1c1c\"/></svg>",
    "tool-gradient": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\"><defs><linearGradient id=\"a\"><stop stop-color=\"#000\" stop-opacity=\"1\" offset=\"0\"/><stop stop-color=\"#000\" stop-opacity=\"0\" offset=\"1\"/></linearGradient><linearGradient xlink:href=\"#a\" id=\"b\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"/></defs><path fill=\"url(#b)\" d=\"M10.271 10.271h45.553v45.553H10.271z\"/></svg>",
    "tool-hand": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49.5 49.5\"><path d=\"M20.2 45.5c0-.7 0-1.3-.2-1.8-.3-.5-1.4-1.4-3.7-3.9-1-1-2-3.3-4-5.3-1-2.2-7.7-6-6.5-7.6 1.2-1.7 4.3-1 7.2.5 1.7 1 3.4 2.7 3.9 2.7 1.5 0 .9-5.5-1.4-11A42 42 0 0 1 13 11c-.6-3 2.6-3.8 3.6-1.7l3.1 6.1c1.4 2.8 2.4 5.3 3 5.2.5-.1-.1-3.7-.6-7.2-.9-6.9-.6-8.6 1.1-8.8 3-.5 3 3.1 4 9 .4 2.1.9 6.6 1.7 6.7.8.1.9-1.4 1-5.5 0-1.4 0-3.6.4-6.8.3-3.2 4.5-3.4 4.4.2v6.1c.1 4-.3 6.8.4 7 .6.3 1.5-3.4 1.7-4.5.3-1 .3-2.5 1-4.9.8-2.3 4-1.9 3.6 1-.3 3-.6 5.7-1.2 8.5-.5 2.8-.4 5.4-.4 8.5 0 3.6-1 8.2-1.7 10.5a16 16 0 0 0-1.3 5z\" fill=\"#515151\"/></svg>",
    "tool-paint": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#1c1c1c\" fill-opacity=\"1\" stroke=\"none\" stroke-width=\"1px\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" stroke-opacity=\"1\" d=\"M70.533 1.584c-1.5-.017-3.627 1.115-5.844 3.455C62.1 7.76 56.13 15.46 49.82 24.99 44.555 32.947 39.722 41.4 37.28 45.534c-2.442 4.135-2.865 6.462-.608 8.485 2.257 2.022 5.714.186 8.009-2.856 2.295-3.041 8.387-11.652 14.018-20.102C63.75 23.47 68.61 14.13 70.35 11c3.45-6.162 2.686-9.387.184-9.416ZM28.714 58.821c-2.059.28-5.223 1.025-8.505 5.568-3.282 4.543-3.936 11.045-.398 15.164s14.468 4.078 14.468 4.078-2.337-1.17-3.898-4.12c-1.56-2.95.056-6.885 3.356-9.274 3.3-2.39 3.16-5.935 1.588-8.518-1.57-2.582-4.552-3.179-6.61-2.898z\"/></svg>",
    "tool-picker": "<svg viewBox=\"0 0 80 80\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M65.85 4.9c-2.05-.02-4.03.57-5.09 1.63l-11.4 11.4c-2.45 2.45-3.77 2.32-5.8 2.15a12.25 12.25 0 0 1-4.32-1.52l-3.99 3.98 21.36 21.7 3.81-3.82s-.93-1.86-1.6-3.9c-.68-2.03-.26-3.8 2.62-6.7l11.48-11.47c3.9-3.9 1.1-8.82-1.56-11.48-1.34-1.34-3.46-1.96-5.5-1.97zM34.97 32 7.89 59.08a2.5 2.5 0 0 0-.73 1.77v5.31L5 71.02a2.5 2.5 0 0 0 3.16 3.36l4.92-1.84h5.86a2.5 2.5 0 0 0 1.77-.73l26.9-26.9-3.53-3.54L17.9 67.54h-5.27a2.5 2.5 0 0 0-.65.1 2.5 2.5 0 0 0 .18-.94v-4.82l26.35-26.34L34.97 32z\"/></svg>",
    "tool-select": "<svg viewBox=\"0 0 85.3 85.3\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"8\" y=\"8\" width=\"70\" height=\"70\" rx=\"10\" stroke-dasharray=\"10\" stroke=\"#1c1c1c\" stroke-width=\"4\" fill=\"none\"/><path fill=\"none\" stroke=\"#1c1c1c\" stroke-width=\"4\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" stroke-dasharray=\"none\" stroke-opacity=\"1\" d=\"M44 19.5v47M54.1 57.6 44 67.8 33.6 57.4M33.8 29.4 44 19.2l10.4 10.3M67.8 43.7h-47M29.7 53.8 19.5 43.5l10.3-10.3M57.9 33.4 68 43.7 57.7 54\"/></svg>",
    "tool-shape": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\"><path fill=\"#1c1c1c\" d=\"M40.271 7.29c-9.024 0-16.487 6.877-17.423 15.66H8.033V58h35.051V42.092c8.322-1.355 14.713-8.582 14.713-17.278 0-9.655-7.87-17.525-17.526-17.525zm0 4a13.495 13.495 0 0 1 13.526 13.524A13.495 13.495 0 0 1 40.27 38.34a13.495 13.495 0 0 1-13.525-13.526A13.495 13.495 0 0 1 40.271 11.29zM12.033 26.95H22.89c1.012 8.263 7.805 14.761 16.195 15.33V54h-27.05V26.95z\"/></svg>",
    "tool-text": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m25.67 31.03-2.04.09q-1.1 0-1.7-.09V16.46q11.2.34 25.6.34 14.48 0 17.87-.34v14.57q-.59.09-1.86.09-1.19 0-1.86-.09-.6-6.1-3.05-9.74-5.51-.6-11.19-.68V67.9q2.97 1.6 8.3 2.29-.33 2.03-.42 3.13H31.77l.5-3.13q5-.6 7.72-2.3V20.62q-6.53.09-11.1.6-3.05 4.23-3.22 9.82z\" fill=\"#1c1c1c\"/></svg>",
    "tool-undo": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 85.33 85.33\"><path d=\"M34.193 78.121h19.61a23.24 23.24 0 0 0 23.29-23.29 23.237 23.237 0 0 0-23.29-23.29h-38.8M38.522 4.676 11.625 31.533l26.781 26.68\" fill=\"none\" stroke=\"#515151\" stroke-width=\"10.5\"/></svg>",
    "tool-zoom-in": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M42.62 1.28A41.49 41.49 0 0 0 1.2 42.71c0 22.83 18.6 41.43 41.43 41.43s41.43-18.6 41.43-41.43A41.5 41.5 0 0 0 42.62 1.28zm0 8.1a33.27 33.27 0 0 1 33.33 33.33c0 18.46-14.87 33.33-33.33 33.33S9.3 61.17 9.3 42.71A33.27 33.27 0 0 1 42.62 9.38zm-3.07 11.84a2.6 2.6 0 0 0-2.6 2.6v13.17H23.77a2.6 2.6 0 0 0-2.6 2.6v4.7a2.6 2.6 0 0 0 2.6 2.6h13.18v13.18a2.6 2.6 0 0 0 2.6 2.6h4.7a2.6 2.6 0 0 0 2.6-2.6V46.89h13.17a2.6 2.6 0 0 0 2.6-2.6v-4.7a2.6 2.6 0 0 0-2.6-2.6H46.85V23.82a2.6 2.6 0 0 0-2.6-2.6h-4.7z\" fill=\"#4f4f4f\"/></svg>",
    "tool-zoom-out": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M42.62 1.28A41.49 41.49 0 0 0 1.2 42.71c0 22.83 18.6 41.43 41.43 41.43s41.43-18.6 41.43-41.43A41.5 41.5 0 0 0 42.62 1.28zm0 8.1a33.27 33.27 0 0 1 33.33 33.33c0 18.46-14.87 33.33-33.33 33.33S9.3 61.17 9.3 42.71A33.27 33.27 0 0 1 42.62 9.38zM23.77 37a2.6 2.6 0 0 0-2.6 2.6v4.7a2.6 2.6 0 0 0 2.6 2.6h36.25a2.6 2.6 0 0 0 2.6-2.6v-4.7a2.6 2.6 0 0 0-2.6-2.6z\" fill=\"#4f4f4f\"/></svg>",
    "typo-bold": "<svg viewBox=\"0 0 26.5 26.5\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.9 10.6q1.4 0 2.1-.6t.7-1.8q0-1.2-.7-1.8-.7-.6-2.1-.6h-3.3v4.8zm.2 10q1.8 0 2.7-.7.9-.8.9-2.3 0-1.5-1-2.2-.8-.8-2.6-.8h-3.5v6zm5.5-8.2q1.9.5 3 2 1 1.5 1 3.7 0 3.3-2.3 5-2.2 1.6-6.8 1.6H4.7v-23h8.9q4.8 0 6.9 1.5 2.1 1.4 2.1 4.6 0 1.7-.7 2.9-.8 1.1-2.3 1.7z\"/></svg>",
    "typo-italic": "<svg viewBox=\"0 0 26.5 26.5\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m13 21.7-.2.5q0 .7.6.9.5.2 1.7.2v.6q-2 .7-3.2.7-1 0-1.4-.5-.5-.5-.5-1.4l.1-1.1 2-9.3v-.8q0-.5-.3-.7t-1.9-.1V10q2.2-.8 3.4-.8.9 0 1.3.4.5.4.5 1.2l-.1.6zm3.5-18.1q0 .8-.6 1.3-.5.5-1.2.5-.8 0-1.3-.4-.5-.5-.5-1.3t.6-1.3q.5-.5 1.2-.5.8 0 1.3.4.5.5.5 1.3z\"/></svg>",
    "ui-collapse": "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 16V4H2v12h2zm9-1-1.5-1.5L14 11H6V9h8l-2.5-2.5L13 5l5 5-5 5z\" fill=\"#fff\"/></svg>",
    "ui-swap-lr": "<svg viewBox=\"0 0 26.46 26.46\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.2 17.61v1.2L18 24l-1.6-1.6 3.1-3.08H3.34v-2.25h16.14l-3.08-3.09L18 12.41zM3.12 8.85v-1.2l5.2-5.2 1.6 1.6-3.09 3.08h16.15v2.25H6.83l3.09 3.09-1.6 1.59z\" fill=\"#727272\"/></svg>",
    "upload": "<svg viewBox=\"0 0 15.35 17.49\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.68 0 0 8.12h4.06v9.37h7.24V8.12h4.05L7.67 0Z\" fill=\"#367c87\" opacity=\".75\"/></svg>",
    "upload-large": "<svg viewBox=\"0 0 85.3 85.3\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"42.7\" cy=\"43\" r=\"37.9\" fill=\"#289cad\"/><path d=\"M43.4 17.7 30 30.4 16.6 43.1H30v18.6h26.8V43.1h13.3L56.8 30.4z\" fill=\"#fff\"/></svg>",
    "view-flip": "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 1h2v22h-2z\" fill=\"currentColor\"/><path d=\"M1 4l9 8-9 8zm1.8 4.01v7.98L7.29 12z\" fill=\"currentColor\" fill-rule=\"evenodd\"/><path d=\"M23 4l-9 8 9 8z\" fill=\"currentColor\"/></svg>\n",
    "viewport-reset": "<svg viewBox=\"0 0 85.33 85.33\" xmlns=\"http://www.w3.org/2000/svg\">\n    <rect fill=\"transparent\" stroke-width=\"8\" stroke=\"#4f4f4f\" x=\"10\" y=\"10\" width=\"65\" height=\"65\" />\n</svg>",
    "warning": "<svg viewBox=\"0 0 85.3 85.3\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M43 7.2c-1.6 0-3.2.8-4 2.2L22 38.6 5.3 67.8c-1.7 3 .5 6.8 4 6.8h67.4c3.4 0 5.6-3.8 3.9-6.8L63.6 38.6 46.7 9.4a4.5 4.5 0 0 0-3.6-2.2Zm0 12.7c1.1 0 2 .4 2.4 1.3.6.9.8 1.8.8 2.9 0 5-.8 15.8-2.5 32.2-.3.5-.6.8-1.1.9-.5-.2-.8-.5-1-.8a478.1 478.1 0 0 1-2-32.3c0-1.1.3-2 1-2.9.6-.9 1.4-1.3 2.5-1.3zm-.2 41.6c1 0 2 .3 2.7 1.1.8.7 1.2 1.6 1.2 2.7 0 1-.4 2-1.2 2.8-.7.8-1.6 1.2-2.7 1.2-1 0-2-.4-2.8-1.2a4 4 0 0 1-1.2-2.8c0-1 .4-2 1.2-2.7a4 4 0 0 1 2.8-1.1z\" fill=\"#f7d020\"/></svg>"
};


class $94f0b2b810d4d191$export$40612b7e1b7c8ee4 {
    add(callback) {
        this.callbacks.push(callback);
    }
    destroy() {
        const callbacks = this.callbacks;
        this.callbacks = [];
        callbacks.forEach((callback)=>{
            try {
                callback();
            } catch (e) {
                $94f0b2b810d4d191$export$18ba0e477ccb0900(e);
            }
        });
    }
    // ------------------------ public -----------------------------
    constructor(){
        this.callbacks = [];
    }
}
function $94f0b2b810d4d191$export$bb3ff0b2339c52db(signal) {
    return signal.reason ?? new DOMException('Operation aborted', 'AbortError');
}
function $94f0b2b810d4d191$export$c4f94c8b3850a5a9(referenceNode, newNode) {
    if (referenceNode.parentNode) referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}
function $94f0b2b810d4d191$export$dbf350e5966cf602(el, cssObj) {
    const elStyle = el.style;
    Object.entries(cssObj).forEach(([key, value])=>{
        const property = key;
        if (typeof value === 'number') {
            // Let the browser distinguish unitless properties from lengths.
            elStyle[property] = '';
            elStyle[property] = value;
            // e.g. width = 12 will be reset to ''
            if (elStyle[property] === '') elStyle[property] = value + 'px';
        } else // undefined would not assign, we must use '' instead for a reset.
        elStyle[property] = value ?? '';
        if (property === 'userSelect') elStyle.webkitUserSelect = elStyle[property]; // Safari support
    });
}
function $94f0b2b810d4d191$export$74da2cba014bdc09(el, attrObj) {
    const keyArr = Object.keys(attrObj);
    let keyStr;
    for(let i = 0; i < keyArr.length; i++){
        keyStr = keyArr[i];
        el.setAttribute(keyStr, attrObj[keyStr]);
    }
}
function $94f0b2b810d4d191$export$10d8903dec122b9d(target, els) {
    const fragment = document.createDocumentFragment();
    els.forEach((item)=>item && fragment.append(item));
    target.append(fragment);
}
function $94f0b2b810d4d191$export$fa55905620c22535(aw, ah, bw, bh, min, applyFloor) {
    let width = aw * bw, height = ah * bw;
    if (width > bw) {
        height = bw / width * height;
        width = bw;
    }
    if (height > bh) {
        width = bh / height * width;
        height = bh;
    }
    if (min) {
        width = Math.max(min, width);
        height = Math.max(min, height);
    }
    if (applyFloor) {
        width = Math.floor(width);
        height = Math.floor(height);
    }
    return {
        width: width,
        height: height
    };
}
function $94f0b2b810d4d191$export$76d0c1a172b67a61(aw, ah, bw, bh) {
    return {
        x: aw / 2 - bw / 2,
        y: ah / 2 - bh / 2
    };
}
function $94f0b2b810d4d191$export$27be2b2470a97a3() {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const minutes = (date.getHours() * 60 + date.getMinutes()).toString(36).padStart(3, '0');
    return year + '_' + month + '_' + day + '_' + minutes + '_';
}
function $94f0b2b810d4d191$export$f81847884871263e(a, b) {
    return b ? $94f0b2b810d4d191$export$f81847884871263e(b, a % b) : a;
}
function $94f0b2b810d4d191$export$533b26079ad0b4b(numerator, denominator) {
    const g = $94f0b2b810d4d191$export$f81847884871263e(numerator, denominator);
    return [
        numerator / g,
        denominator / g
    ];
}
function $94f0b2b810d4d191$export$8215e6b900906daa(decimalNumber) {
    const len = decimalNumber.toString().length - 2;
    const denominator = 10 ** len;
    const numerator = decimalNumber * denominator;
    return $94f0b2b810d4d191$export$533b26079ad0b4b(numerator, denominator);
}
function $94f0b2b810d4d191$export$5bcd6e94ed871c88(maybeBlob) {
    return maybeBlob instanceof Blob || Object.prototype.toString.call(maybeBlob) === '[object Blob]';
}
function $94f0b2b810d4d191$export$1093707c159148e8(dateA, dateB) {
    dateA = new Date(dateA);
    dateB = new Date(dateB);
    dateA.setHours(0, 0, 0, 0);
    dateB.setHours(0, 0, 0, 0);
    return (dateB.getTime() - dateA.getTime()) / 86400000;
}
function $94f0b2b810d4d191$export$af0d87255f3cfd7e(obj) {
    // structuredClone became available around 2022. Let's wait a bit longer for it.
    return JSON.parse(JSON.stringify(obj));
}
function $94f0b2b810d4d191$export$331c30fd60da0115(p) {
    const mimetype = 'image/png';
    const err = ()=>alert('sharing not supported');
    p.canvas.toBlob(function(blob) {
        if (!blob) {
            err();
            p.callback();
            return;
        }
        try {
            const filesArray = [
                new File([
                    blob
                ], p.fileName, {
                    type: mimetype
                })
            ];
            navigator.share({
                title: p.title,
                files: filesArray
            }).then(()=>{}).catch(()=>{
                err();
            });
        } catch (e) {
            err();
        }
        p.callback();
    }, mimetype);
}
function $94f0b2b810d4d191$export$b981489921ee18cd(clickEvent) {
    const target = clickEvent.target;
    if (!target) return false;
    let el = target;
    while(el){
        if ([
            'A',
            'LABEL',
            'INPUT',
            'SUMMARY'
        ].includes(el.tagName)) return true;
        el = el.parentElement;
    }
    clickEvent.preventDefault();
    return false;
}
function $94f0b2b810d4d191$export$c54fe3b9ecaa84cf(p) {
    const result = document.createElementNS('http://www.w3.org/2000/svg', p.elementType);
    Object.entries(p).forEach(([keyStr, item])=>{
        if (keyStr === 'childrenArr') item.forEach((child)=>{
            result.append($94f0b2b810d4d191$export$c54fe3b9ecaa84cf(child));
        });
        else if (keyStr === 'css') $94f0b2b810d4d191$export$dbf350e5966cf602(result, item);
        else if (keyStr !== 'elementType') result.setAttribute(keyStr, item);
    });
    return result;
}
function $94f0b2b810d4d191$export$b813e062795b89b5(v) {
    if (v === null) throw new Error('value is null');
    return v;
}
function $94f0b2b810d4d191$export$5c097f720de072a2(v, message = 'value is undefined') {
    if (v === undefined) throw new Error(message);
    return v;
}
function $94f0b2b810d4d191$export$d802c22d109d9806(v) {
    return v === null ? undefined : v;
}
class $94f0b2b810d4d191$export$6d5e6de05c94f9f {
    constructor(error){
        this.error = error;
    }
}
function $94f0b2b810d4d191$export$77f9e426014f6edd(fn) {
    try {
        const result = fn();
        if (result instanceof Promise) return result.catch((error)=>new $94f0b2b810d4d191$export$6d5e6de05c94f9f(error));
        return result;
    } catch (error) {
        return new $94f0b2b810d4d191$export$6d5e6de05c94f9f(error);
    }
}
const $94f0b2b810d4d191$export$18ba0e477ccb0900 = (()=>{
    if (typeof window.reportError === 'function') return window.reportError;
    else return (error)=>{
        setTimeout(()=>{
            throw error;
        });
    };
})();
const $94f0b2b810d4d191$var$matchMediaDark = typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-color-scheme: dark)') : false;
function $94f0b2b810d4d191$export$a79ad82046afa44e() {
    return $94f0b2b810d4d191$var$matchMediaDark && $94f0b2b810d4d191$var$matchMediaDark.matches;
}
function $94f0b2b810d4d191$export$a9dfd81f95a8a526(func) {
    if ($94f0b2b810d4d191$var$matchMediaDark && typeof $94f0b2b810d4d191$var$matchMediaDark.addEventListener === 'function') $94f0b2b810d4d191$var$matchMediaDark.addEventListener('change', func);
}
function $94f0b2b810d4d191$export$326d4de4659beb75(func) {
    if ($94f0b2b810d4d191$var$matchMediaDark && typeof $94f0b2b810d4d191$var$matchMediaDark.removeEventListener === 'function') $94f0b2b810d4d191$var$matchMediaDark.removeEventListener('change', func);
}
function $94f0b2b810d4d191$export$b3fb17ae4345ac8f(base64Str) {
    const parts = base64Str.match(/data:([^;]*)(;base64)?,([0-9A-Za-z+/]+)/);
    const binStr = atob(parts[3]);
    const buf = new ArrayBuffer(binStr.length);
    const view = new Uint8Array(buf);
    for(let i = 0; i < view.length; i++)view[i] = binStr.charCodeAt(i);
    return new Blob([
        view
    ], {
        type: parts[1]
    });
}
function $94f0b2b810d4d191$export$7f1ebd623f131021(length, fillValue) {
    return new Array(length).fill(fillValue);
}
function $94f0b2b810d4d191$export$4773ec3a7b05a3f2() {
    if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    // fallback just for dev
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $94f0b2b810d4d191$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function $94f0b2b810d4d191$export$f85d414d081200d8(promise, name, timeoutMs = 5000) {
    return new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>reject(new Error(`Promise "${name}" timed out.`)), timeoutMs);
        promise.then((value)=>{
            clearTimeout(timeoutId);
            resolve(value);
        }, (error)=>{
            clearTimeout(timeoutId);
            reject(error);
        });
    });
}
async function $94f0b2b810d4d191$export$b6a2e78b63791dfa(url) {
    const response = await fetch(url);
    const svgText = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgText, 'image/svg+xml');
    const svg = doc.querySelector('svg');
    if (!svg) throw new Error('No <svg> found in the file');
    // Optional: Clone to prevent reusing the same node
    return svg.cloneNode(true);
}


const $1b4b6b9aff0ae5e5$var$objectUrlByIcon = new Map();
const $1b4b6b9aff0ae5e5$var$elementTemplateByIcon = new Map();
let $1b4b6b9aff0ae5e5$var$isIconCssInitialized = false;
let $1b4b6b9aff0ae5e5$var$nextSvgInstanceId = 0;
// The references occupy global namespace. Make them unique to avoid collisions.
function $1b4b6b9aff0ae5e5$var$makeSvgIdsUnique(svg) {
    const elements = [
        svg,
        ...svg.querySelectorAll('*')
    ];
    const idMap = new Map();
    const prefix = `kl-icon-${$1b4b6b9aff0ae5e5$var$nextSvgInstanceId++}-`;
    for (const element of elements)if (element.hasAttribute('id')) {
        const id = element.id;
        const uniqueId = `${prefix}${id}`;
        idMap.set(id, uniqueId);
        element.id = uniqueId;
    }
    if (!idMap.size) return;
    for (const element of elements)for (const attribute of element.attributes){
        // Match local references like url(#id), url('#id'), or url("#id"), allowing
        // surrounding whitespace inside the parentheses. Capture the optional quote
        // and ID; \1 requires the closing quote to match the opening quote.
        let value = attribute.value.replace(/url\(\s*(['"]?)#([^\s'"()]+)\1\s*\)/g, (match, _quote, id)=>{
            const uniqueId = idMap.get(id);
            return uniqueId ? `url(#${uniqueId})` : match;
        });
        if (attribute.localName === 'href' && value.startsWith('#')) {
            const uniqueId = idMap.get(value.slice(1));
            if (uniqueId) value = `#${uniqueId}`;
        }
        // we iterate over *all* attributes but only reassign where there are references
        if (value !== attribute.value) attribute.value = value;
    }
}
function $1b4b6b9aff0ae5e5$export$2c2252034c67bc5e(icon) {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent((0, $7162d492f1f0eac6$export$df03f54e09e486fa)[icon])}`;
}
function $1b4b6b9aff0ae5e5$export$89d1c740383224f4(icon) {
    const cachedUrl = $1b4b6b9aff0ae5e5$var$objectUrlByIcon.get(icon);
    if (cachedUrl) return cachedUrl;
    const objectUrl = URL.createObjectURL(new Blob([
        (0, $7162d492f1f0eac6$export$df03f54e09e486fa)[icon]
    ], {
        type: 'image/svg+xml'
    }));
    $1b4b6b9aff0ae5e5$var$objectUrlByIcon.set(icon, objectUrl);
    return objectUrl;
}
function $1b4b6b9aff0ae5e5$export$1838b56fa99d7234(icon, styleObj) {
    let template = $1b4b6b9aff0ae5e5$var$elementTemplateByIcon.get(icon);
    if (!template) {
        const parsedDocument = new DOMParser().parseFromString((0, $7162d492f1f0eac6$export$df03f54e09e486fa)[icon], 'image/svg+xml');
        if (parsedDocument.documentElement.localName !== 'svg') throw new Error(`Failed to parse icon: ${icon}`);
        const parsedSvg = parsedDocument.documentElement;
        template = document.importNode(parsedSvg, true);
        $1b4b6b9aff0ae5e5$var$elementTemplateByIcon.set(icon, template);
    }
    const result = template.cloneNode(true);
    $1b4b6b9aff0ae5e5$var$makeSvgIdsUnique(result);
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(result, {
        display: 'block',
        ...styleObj
    });
    return result;
}
function $1b4b6b9aff0ae5e5$export$dd7d56122b36f42e(icon, styleObj) {
    const result = document.createElement('img');
    result.src = $1b4b6b9aff0ae5e5$export$89d1c740383224f4(icon);
    result.alt = '';
    result.draggable = false;
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(result, {
        display: 'block',
        ...styleObj
    });
    return result;
}
function $1b4b6b9aff0ae5e5$export$cabc69a67231dae8() {
    if ($1b4b6b9aff0ae5e5$var$isIconCssInitialized) return;
    $1b4b6b9aff0ae5e5$var$isIconCssInitialized = true;
    // Data URLs because Firefox has trouble loading object urls across domains:
    // e.g. Security Error: Content at https://foo.com/style.css may not load data from blob:https://bar.com/e249649e-be93-4d2c-bf43-009b633b3841.
    const declarations = Object.keys((0, $7162d492f1f0eac6$export$df03f54e09e486fa)).map((icon)=>`--icon-${icon}: url("${$1b4b6b9aff0ae5e5$export$2c2252034c67bc5e(icon)}")`).join(';');
    const styleEl = document.createElement('style');
    styleEl.id = 'icon-urls';
    document.head.append(styleEl);
    const sheet = styleEl.sheet;
    if (!sheet) throw new Error('Failed to create icon stylesheet');
    sheet.insertRule(`:root {${declarations}}`);
}



/**
 * track how many modals are opened
 */ class $a0bbbeb927a78bac$export$f5386afdb763a67e {
    emit() {
        this.listeners.forEach((item)=>{
            item(this.count);
        });
    }
    // ----------------------------------- public -----------------------------------
    increase(v) {
        if (v !== undefined) this.count += v;
        else this.count++;
        this.emit();
    }
    decrease(v) {
        if (v !== undefined) this.count -= v;
        else this.count--;
        this.emit();
    }
    get() {
        return this.count;
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
    constructor(){
        this.listeners = [];
        this.count = 0;
    }
}
const $a0bbbeb927a78bac$export$d3d1650bc39c4419 = new $a0bbbeb927a78bac$export$f5386afdb763a67e();



const $25e38424550c7e3f$export$fa35291248be714f = navigator.userAgent.toLowerCase().includes('firefox');
const $25e38424550c7e3f$export$69accc8c74894f83 = function() {
    const eventUsesHighResTimeStamp = new Event('').timeStamp < 3600000;
    return function() {
        return eventUsesHighResTimeStamp;
    };
}();
const $25e38424550c7e3f$export$7728c852ca75bb6d = !!window.PointerEvent;
const $25e38424550c7e3f$export$558f5e20caee48c2 = function() {
    return 'share' in navigator && 'canShare' in navigator;
};
function $25e38424550c7e3f$export$a432063205610fa1() {
    navigator.storage.estimate().then((estimate)=>{
        if (estimate.quota === undefined || estimate.usage === undefined) {
            console.log('no quota info');
            return;
        }
        console.log(`using ${(estimate.usage / estimate.quota * 100).toFixed(2)}% of total quota`);
        console.log('usage (GB)', (estimate.usage / 1024 / 1024 / 1024).toFixed(2));
        console.log('quota (GB)', (estimate.quota / 1024 / 1024 / 1024).toFixed(2));
    });
}


const $26d18c1211450b7d$var$globalKey = (()=>{
    // keyStr - our key naming system
    // key - KeyboardEvent.key
    // code - KeyboardEvent.code
    const keyStrToKeyObj = {
        // keyStr not to contain a '+', because that's used for the comboStr
        space: [
            ' '
        ],
        alt: [
            'Alt',
            'AltGraph'
        ],
        shift: 'Shift',
        ctrl: 'Control',
        cmd: [
            'Meta',
            'MetaLeft',
            'MetaRight'
        ],
        enter: 'Enter',
        esc: 'Escape',
        backspace: 'Backspace',
        delete: 'Delete',
        sqbr_open: '[',
        sqbr_close: ']',
        a: [
            'a',
            'A'
        ],
        b: [
            'b',
            'B'
        ],
        c: [
            'c',
            'C'
        ],
        e: [
            'e',
            'E'
        ],
        f: [
            'f',
            'F'
        ],
        g: [
            'g',
            'G'
        ],
        h: [
            'h',
            'H'
        ],
        l: [
            'l',
            'L'
        ],
        m: [
            'm',
            'M'
        ],
        r: [
            'r',
            'R'
        ],
        s: [
            's',
            'S'
        ],
        t: [
            't',
            'T'
        ],
        u: [
            'u',
            'U'
        ],
        x: [
            'x',
            'X'
        ],
        y: [
            'y',
            'Y'
        ],
        z: [
            'z',
            'Z'
        ],
        plus: '+',
        minus: '-',
        left: 'ArrowLeft',
        right: 'ArrowRight',
        up: 'ArrowUp',
        down: 'ArrowDown',
        home: 'Home',
        end: 'End'
    };
    // ['space', 'alt', ... ]
    const keyStrArr = Object.keys(keyStrToKeyObj);
    // { space: false, ... }
    const isDownObj = {};
    // { ArrowLeft: 'left', ... }
    const keyToKeyStrObj = {};
    for (const [keyStr, keys] of Object.entries(keyStrToKeyObj)){
        isDownObj[keyStr] = false;
        for (const key of typeof keys === 'string' ? [
            keys
        ] : keys)keyToKeyStrObj[key] = keyStr;
    }
    let comboArr = [];
    // a physical key's "key" can change as other keys get pressed. to keep track, need to also track the code
    // { KeyE: 'e', KeyF: undefined } - undefined - not down, string - the associated keyStr
    let codeIsDownObj = {};
    const listenerArr = [];
    /**
     * Windows bug in all browsers: Pressing the Windows key leads to keyboard events not firing.
     * It breaks key state tracking.
     * Workaround: If after a timeout, only the meta key is pressed, fire a keyup for the meta key.
     */ let metaClearTimeout;
    const setupMetaClear = (keyStr, code)=>{
        metaClearTimeout = setTimeout(()=>{
            if (comboArr.length !== 1 || comboArr[0] === 'cmd') return;
            const oldComboStr = comboArr.join('+');
            isDownObj[keyStr] = false;
            codeIsDownObj[code] = undefined;
            // remove from combo
            for(let i = 0; i < comboArr.length; i++)if (comboArr[i] === keyStr) {
                comboArr.splice(i, 1);
                i--;
            }
            emitUp(keyStr, {
                preventDefault: function() {},
                stopPropagation: function() {}
            }, oldComboStr);
            metaClearTimeout = undefined;
        }, 1000);
    };
    const emitDown = function(a, b, c, d) {
        listenerArr.forEach((item)=>{
            item[0]?.(a, b, c, d);
        });
    };
    const emitUp = function(a, b, c) {
        listenerArr.forEach((item)=>{
            item[1]?.(a, b, c);
        });
    };
    const emitBlur = function() {
        listenerArr.forEach((item)=>{
            item[2]?.();
        });
    };
    function keyDown(e) {
        const key = e.key;
        const code = e.code;
        if (key in keyToKeyStrObj) {
            const keyStr = keyToKeyStrObj[key];
            if (isDownObj[keyStr]) {
                emitDown(keyStr, e, comboArr.join('+'), true);
                return;
            } else {
                if (keyStr === 'cmd') setupMetaClear(keyStr, code);
                else clearTimeout(metaClearTimeout);
                if (keyStr === 'esc') // Workaround for a macOS behavior
                // When in fullscreen, pressing escape exits the fullscreen mode.
                // When that happens, no keyup for escape is fired.
                setTimeout(()=>blur());
            }
            isDownObj[keyStr] = true;
            codeIsDownObj[code] = keyStr;
            //add to combo
            comboArr.push(keyStr);
            emitDown(keyStr, e, comboArr.join('+'));
        }
    }
    function keyUp(e) {
        const code = e.code;
        const oldComboStr = comboArr.join('+');
        // because of a macOS bug: when meta key is down, keyup of other keys does not fire.
        // https://stackoverflow.com/questions/25438608/javascript-keyup-isnt-called-when-command-and-another-is-pressed
        if ([
            'Meta',
            'MetaLeft',
            'MetaRight',
            'OSLeft',
            'OSRight'
        ].includes(code)) {
            blur();
            return;
        } else if (isDownObj['cmd']) {
            // Workaround for Windows bug. Windows doesn't fire keyup for Meta key when pressing Windows Key + Space,
            // neither does it fire blur
            blur();
            return;
        }
        const keyStr = codeIsDownObj[code];
        if (keyStr !== undefined) {
            isDownObj[keyStr] = false;
            codeIsDownObj[code] = undefined;
            // remove from combo
            for(let i = 0; i < comboArr.length; i++)if (comboArr[i] === keyStr) {
                comboArr.splice(i, 1);
                i--;
            }
            emitUp(keyStr, e, oldComboStr);
        }
    }
    function blur() {
        const oldComboStr = comboArr.join('+');
        comboArr = [];
        codeIsDownObj = {};
        const eventArr = [];
        keyStrArr.forEach((keyStr)=>{
            if (isDownObj[keyStr]) {
                isDownObj[keyStr] = false;
                eventArr.push(keyStr);
            }
        });
        for(let i = 0; i < eventArr.length; i++)emitUp(eventArr[i], {
            preventDefault: function() {},
            stopPropagation: function() {}
        }, oldComboStr);
        emitBlur();
    }
    return {
        add: (keyListenerRef)=>{
            if (listenerArr.includes(keyListenerRef)) return;
            const first = listenerArr.length === 0;
            listenerArr.push(keyListenerRef);
            if (first) {
                document.addEventListener('keydown', keyDown);
                document.addEventListener('keyup', keyUp);
                window.addEventListener('blur', blur);
            }
        },
        remove: (keyListenerRef)=>{
            const index = listenerArr.indexOf(keyListenerRef);
            if (index === -1) return;
            listenerArr.splice(index, 1);
            if (listenerArr.length === 0) {
                document.removeEventListener('keydown', keyDown);
                document.removeEventListener('keyup', keyUp);
                window.removeEventListener('blur', blur);
                // cleanup
                clearTimeout(metaClearTimeout);
                metaClearTimeout = undefined;
                comboArr = [];
                codeIsDownObj = {};
                keyStrArr.forEach((keyStr)=>{
                    if (isDownObj[keyStr]) isDownObj[keyStr] = false;
                });
            }
        },
        getIsDown: ()=>isDownObj,
        getCombo: ()=>comboArr,
        blur: blur
    };
})();
class $26d18c1211450b7d$export$f17908c5de22d32e {
    isPressed(keyStr) {
        if (!(keyStr in $26d18c1211450b7d$var$globalKey.getIsDown())) throw 'key "' + keyStr + '" not found';
        return $26d18c1211450b7d$var$globalKey.getIsDown()[keyStr];
    }
    getComboStr() {
        return $26d18c1211450b7d$var$globalKey.getCombo().join('+');
    }
    comboOnlyContains(keyStrArr) {
        return $26d18c1211450b7d$var$globalKey.getCombo().every((keyStr)=>keyStrArr.includes(keyStr));
    }
    destroy() {
        $26d18c1211450b7d$var$globalKey.remove(this.ref);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.ref = [
            p.onDown,
            p.onUp,
            p.onBlur
        ];
        $26d18c1211450b7d$var$globalKey.add(this.ref);
    }
}
function $26d18c1211450b7d$export$e9f65b0175de4c03(comboAStr, comboBStr) {
    return comboAStr.split('+').sort().join('+') === comboBStr.split('+').sort().join('+');
}



const $e3c08bc111aa5952$var$SEQUENCE_TIMEOUT_MS = 200;
class $e3c08bc111aa5952$export$c734b8535f2f8e38 {
    emit(delta) {
        if (this.position === null || this.sequenceUnit === null) return;
        this.callback({
            deltaY: Math.round(delta / this.sequenceUnit),
            pageX: this.position.pageX,
            pageY: this.position.pageY,
            clientX: this.position.clientX,
            clientY: this.position.clientY,
            ...this.latestModifiers
        });
    }
    endSequence() {
        if (this.toEmitDelta !== null) {
            this.emit(this.toEmitDelta);
            this.toEmitDelta = null;
        }
        if (this.sequenceUnit !== null && !this.knownUnitArr.includes(this.sequenceUnit)) this.knownUnitArr.push(this.sequenceUnit);
        this.sequenceLength = 0;
        this.sequenceUnit = null;
    }
    process(event) {
        this.position = {
            pageX: event.pageX,
            pageY: event.pageY,
            clientX: event.clientX,
            clientY: event.clientY
        };
        this.latestModifiers = {
            ctrlKey: event.ctrlKey,
            altKey: event.altKey,
            metaKey: event.metaKey,
            shiftKey: event.shiftKey
        };
        if (this.endSequenceTimeout) clearTimeout(this.endSequenceTimeout);
        this.endSequenceTimeout = setTimeout(()=>this.endSequence(), $e3c08bc111aa5952$var$SEQUENCE_TIMEOUT_MS);
        //prep delta
        let delta = event.deltaY;
        if ('deltaMode' in event && event.deltaMode === 1) delta *= 100 / 3;
        const absDelta = Math.abs(delta);
        //sequence begins
        if (this.sequenceLength === 0) {
            this.sequenceLength++;
            if (absDelta < 50) //dirty - probably a swipe scroll or pinch scroll on trackpad
            return;
            this.sequenceUnit = absDelta;
            if (this.knownUnitArr.includes(this.sequenceUnit)) //we know this unit - emit right away
            this.emit(delta);
            else //unknown unit - wait until next event or sequence end, to have more certainty that it's clean
            this.toEmitDelta = delta;
            return;
        }
        if (this.sequenceUnit === null) {
            //previously determined dirty sequence
            this.toEmitDelta = null;
            return;
        }
        //sequence continues
        if (absDelta === 0) //ignore zero scroll
        return;
        if (absDelta === this.sequenceUnit || absDelta / this.sequenceUnit % 1 < 0.0001 // a multiple
        ) ;
        else if (this.sequenceUnit / absDelta % 1 < 0.0001) //unit was actually a multiple - update it
        this.sequenceUnit = absDelta;
        else if (absDelta !== this.sequenceUnit) {
            //not clean - delta is varying - probably a swipe scroll or pinch scroll on trackpad
            this.sequenceUnit = null;
            this.toEmitDelta = null;
            return;
        }
        if (this.toEmitDelta !== null) {
            this.emit(this.toEmitDelta);
            this.toEmitDelta = null;
        }
        this.emit(delta);
    }
    // ----------------------------------- public -----------------------------------
    constructor(callback){
        this.callback = callback;
        this.knownUnitArr = [
            100
        ];
        this.sequenceLength = 0;
        this.sequenceUnit = null;
        this.toEmitDelta = null;
        this.position = null;
        this.latestModifiers = {
            ctrlKey: false,
            altKey: false,
            metaKey: false,
            shiftKey: false
        };
    }
}


/**
 * Apple Pencil on iPad in Safari has two problems:
 * - You need to press the stylus very strong to reach 1.0 pressure, to the point where the screen starts discoloring
 * - Always fires the same pressure value on pointerdown
 *
 * This normalizer tries to fix that with a workaround.
 *
 * pressure range [0, 1]
 */ class $6f890b00c6882c3d$export$61f95f4b79132931 {
    // ----------------------------------- public -----------------------------------
    normalize(pressure, eventType, pointerType) {
        if (pointerType === 'pen') {
            if (!this.detectionComplete) {
                if (eventType === 'pointerdown') {
                    if (this.initialPointerDownPressure === -1) this.initialPointerDownPressure = pressure;
                    else if (this.initialPointerDownPressure === pressure) {
                        this.pointerDownPressureRepeatCount++;
                        if (this.pointerDownPressureRepeatCount > 1 && this.pointerMoveHasDifferentPressure) {
                            this.detectionComplete = true;
                            this.isApplePencil = true;
                        }
                    } else {
                        this.detectionComplete = true;
                        this.isApplePencil = false;
                    }
                } else if (eventType === 'pointermove') {
                    if (this.initialPointerDownPressure !== pressure) this.pointerMoveHasDifferentPressure = true;
                }
            }
            if (this.detectionComplete && this.isApplePencil) {
                if (this.initialPointerDownPressure === pressure) return 0;
                pressure = Math.min(2, pressure * 2);
            }
            return pressure;
        } else return pressure;
    }
    constructor(){
        this.detectionComplete = false;
        this.isApplePencil = false;
        // detection
        this.initialPointerDownPressure = -1;
        this.pointerDownPressureRepeatCount = 0;
        this.pointerMoveHasDifferentPressure = false;
    }
}


// keeping track of pointers for movement fallback
const $3a4865bce5f52590$var$pointerArr = [];
function $3a4865bce5f52590$var$addPointer(event) {
    const pointerObj = {
        pointerId: event.pointerId,
        lastPageX: null,
        lastPageY: null
    };
    $3a4865bce5f52590$var$pointerArr.push(pointerObj);
    if ($3a4865bce5f52590$var$pointerArr.length > 15) $3a4865bce5f52590$var$pointerArr.shift();
    return pointerObj;
}
function $3a4865bce5f52590$var$getPointer(event) {
    for(let i = $3a4865bce5f52590$var$pointerArr.length - 1; i >= 0; i--){
        if (event.pointerId === $3a4865bce5f52590$var$pointerArr[i].pointerId) return $3a4865bce5f52590$var$pointerArr[i];
    }
    return null;
}
function $3a4865bce5f52590$var$getButtonStr(buttons) {
    switch(buttons){
        case 1:
            return 'left';
        case 2:
            return 'right';
        case 4:
            return 'middle';
        default:
            return undefined;
    }
}
const $3a4865bce5f52590$var$pressureNormalizer = new (0, $6f890b00c6882c3d$export$61f95f4b79132931)();
const $3a4865bce5f52590$var$timeStampOffset = (0, $25e38424550c7e3f$export$69accc8c74894f83)() ? 0 : -(performance.timing?.navigationStart ?? performance.timeOrigin);
const $3a4865bce5f52590$var$pointerDownEvt = (0, $25e38424550c7e3f$export$7728c852ca75bb6d) ? 'pointerdown' : 'mousedown';
const $3a4865bce5f52590$var$pointerMoveEvt = (0, $25e38424550c7e3f$export$7728c852ca75bb6d) ? 'pointermove' : 'mousemove';
const $3a4865bce5f52590$var$pointerUpEvt = (0, $25e38424550c7e3f$export$7728c852ca75bb6d) ? 'pointerup' : 'mouseup';
const $3a4865bce5f52590$var$pointerCancelEvt = (0, $25e38424550c7e3f$export$7728c852ca75bb6d) ? 'pointercancel' : 'mousecancel';
const $3a4865bce5f52590$var$pointerLeaveEvt = (0, $25e38424550c7e3f$export$7728c852ca75bb6d) ? 'pointerleave' : 'mouseleave';
const $3a4865bce5f52590$var$pointerEnterEvt = (0, $25e38424550c7e3f$export$7728c852ca75bb6d) ? 'pointerenter' : 'mouseenter';
/**
 * More trustworthy pointer attributes. that behave the same across browsers.
 * returns a new object. Also attaches itself to the orig event. -> event.corrected
 */ function $3a4865bce5f52590$var$correctPointerEvent(event, isPointerDown) {
    if ('corrected' in event) return event.corrected;
    function determineButtons() {
        if (event.buttons !== undefined) return event.buttons;
        /*
                button -> buttons
        none:	undefined -> 0
        left:	0 -> 1
        middle:	1 -> 4
        right:	2 -> 2
        fourth:	3 -> 8
        fifth:	4 -> 16
         */ if (event.button !== undefined) // old safari on mac has no buttons. remove eventually.
        return [
            1,
            4,
            2,
            8,
            16
        ][event.button];
        return 0;
    }
    const correctedObj = {
        pointerId: event.pointerId,
        pointerType: event.pointerType,
        altKey: event.altKey,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        pageX: event.pageX,
        pageY: event.pageY,
        clientX: event.clientX,
        clientY: event.clientY,
        movementX: event.movementX,
        movementY: event.movementY,
        timeStamp: event.timeStamp + $3a4865bce5f52590$var$timeStampOffset,
        pressure: $3a4865bce5f52590$var$pressureNormalizer.normalize(event.pressure, event.type, event.pointerType),
        buttons: determineButtons(),
        button: event.button,
        coalescedArr: [],
        target: event.target ?? undefined,
        eventPreventDefault: ()=>event.preventDefault(),
        eventStopPropagation: ()=>event.stopPropagation()
    };
    event.corrected = correctedObj;
    let customPressure = null;
    if ('pointerId' in event) {
        if ('pressure' in event && event.buttons !== 0) {
            if (event.pointerType === 'touch' && event.pressure === 0) {
                correctedObj.pressure = 1;
                customPressure = 1;
            }
            // Spec: If there's no pressure support, pressure is 0.5.
            // https://w3c.github.io/pointerevents/#dom-pointerevent-pressure
            // & in older Safari (<=16) it seems to be "mouse" and 0.
            if (event.pointerType === 'mouse' && (event.pressure === 0.5 || event.pressure === 0)) {
                correctedObj.pressure = 1;
                customPressure = 1;
            }
        }
    } else {
        correctedObj.pointerId = 0;
        correctedObj.pointerType = 'mouse';
        correctedObj.pressure = event.buttons !== 0 ? 1 : 0;
        customPressure = correctedObj.pressure;
    }
    if ((0, $25e38424550c7e3f$export$fa35291248be714f) && event.pointerType !== 'mouse' && event.type === 'pointermove' && event.buttons === 0) // once again firefox
    correctedObj.buttons = 1; // todo wrong if no buttons actually pressed
    let coalescedEventArr = [];
    if ('getCoalescedEvents' in event) coalescedEventArr = event.getCoalescedEvents();
    // chrome somehow movementX not same scale as pageX. todo: only chrome?
    // so make my own
    const pointerObj = $3a4865bce5f52590$var$getPointer(correctedObj) || $3a4865bce5f52590$var$addPointer(correctedObj);
    const totalLastX = pointerObj.lastPageX;
    const totalLastY = pointerObj.lastPageY;
    for(let i = 0; i < coalescedEventArr.length; i++){
        const eventItem = coalescedEventArr[i];
        correctedObj.coalescedArr.push({
            altKey: eventItem.altKey,
            ctrlKey: eventItem.ctrlKey,
            metaKey: eventItem.metaKey,
            shiftKey: eventItem.shiftKey,
            pageX: eventItem.pageX,
            pageY: eventItem.pageY,
            clientX: eventItem.clientX,
            clientY: eventItem.clientY,
            movementX: pointerObj.lastPageX === null ? 0 : eventItem.pageX - pointerObj.lastPageX,
            movementY: pointerObj.lastPageY === null ? 0 : eventItem.pageY - pointerObj.lastPageY,
            timeStamp: eventItem.timeStamp === 0 ? correctedObj.timeStamp : eventItem.timeStamp + $3a4865bce5f52590$var$timeStampOffset,
            pressure: customPressure === null ? $3a4865bce5f52590$var$pressureNormalizer.normalize(eventItem.pressure) : customPressure
        });
        pointerObj.lastPageX = eventItem.pageX;
        pointerObj.lastPageY = eventItem.pageY;
    }
    pointerObj.lastPageX = correctedObj.pageX;
    pointerObj.lastPageY = correctedObj.pageY;
    if (isPointerDown) {
        correctedObj.movementX = 0;
        correctedObj.movementY = 0;
    } else {
        correctedObj.movementX = totalLastX === null ? 0 : pointerObj.lastPageX - totalLastX;
        correctedObj.movementY = totalLastY === null ? 0 : pointerObj.lastPageY - totalLastY;
    }
    return correctedObj;
}
const $3a4865bce5f52590$var$OPTIONS_PASSIVE = {
    passive: false
};
class $3a4865bce5f52590$export$9371bd96776f4e82 {
    getDragObj(pointerId) {
        for(let i = 0; i < this.dragObjArr.length; i++){
            if (pointerId === this.dragObjArr[i].pointerId) return this.dragObjArr[i];
        }
        return null;
    }
    removeDragObj(pointerId) {
        let removedDragObj = null;
        for(let i = 0; i < this.dragPointerIdArr.length; i++)if (this.dragPointerIdArr[i] === pointerId) {
            removedDragObj = this.dragObjArr[i];
            this.dragObjArr.splice(i, 1);
            this.dragPointerIdArr.splice(i, 1);
            i--;
        }
        return removedDragObj;
    }
    /**
     * Creates a value for onPointer, from a pointer event handler.
     */ createPointerOutEvent(typeStr, correctedEvent, custom) {
        const bounds = this.targetElement.getBoundingClientRect();
        const result = {
            target: correctedEvent.target,
            type: typeStr,
            pointerId: correctedEvent.pointerId,
            pointerType: correctedEvent.pointerType,
            altKey: correctedEvent.altKey,
            ctrlKey: correctedEvent.ctrlKey,
            metaKey: correctedEvent.metaKey,
            shiftKey: correctedEvent.shiftKey,
            pageX: correctedEvent.pageX,
            pageY: correctedEvent.pageY,
            clientX: correctedEvent.clientX,
            clientY: correctedEvent.clientY,
            relX: correctedEvent.clientX - bounds.left + this.targetElement.scrollLeft,
            relY: correctedEvent.clientY - bounds.top + this.targetElement.scrollTop,
            dX: correctedEvent.movementX,
            dY: correctedEvent.movementY,
            time: correctedEvent.timeStamp,
            eventPreventDefault: correctedEvent.eventPreventDefault,
            eventStopPropagation: correctedEvent.eventStopPropagation,
            ...custom
        };
        if (typeStr === 'pointermove') {
            result.coalescedArr = [];
            if (correctedEvent.coalescedArr.length > 1) {
                let coalescedItem;
                for(let i = 0; i < correctedEvent.coalescedArr.length; i++){
                    coalescedItem = correctedEvent.coalescedArr[i];
                    result.coalescedArr.push({
                        altKey: coalescedItem.altKey,
                        ctrlKey: coalescedItem.ctrlKey,
                        metaKey: coalescedItem.metaKey,
                        shiftKey: coalescedItem.shiftKey,
                        pageX: coalescedItem.pageX,
                        pageY: coalescedItem.pageY,
                        clientX: coalescedItem.clientX,
                        clientY: coalescedItem.clientY,
                        relX: coalescedItem.clientX - bounds.left + this.targetElement.scrollLeft,
                        relY: coalescedItem.clientY - bounds.top + this.targetElement.scrollTop,
                        dX: coalescedItem.movementX,
                        dY: coalescedItem.movementY,
                        time: coalescedItem.timeStamp
                    });
                }
            }
        }
        return result;
    }
    setupDocumentListeners() {
        this.windowOnPointerMove && document.addEventListener($3a4865bce5f52590$var$pointerMoveEvt, this.windowOnPointerMove, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
        this.windowOnPointerUp && document.addEventListener($3a4865bce5f52590$var$pointerUpEvt, this.windowOnPointerUp, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
        this.windowOnPointerLeave && document.addEventListener($3a4865bce5f52590$var$pointerCancelEvt, this.windowOnPointerLeave, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
        this.windowOnPointerLeave && document.addEventListener($3a4865bce5f52590$var$pointerLeaveEvt, this.windowOnPointerLeave, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
    }
    destroyDocumentListeners() {
        this.windowOnPointerMove && document.removeEventListener($3a4865bce5f52590$var$pointerMoveEvt, this.windowOnPointerMove);
        this.windowOnPointerUp && document.removeEventListener($3a4865bce5f52590$var$pointerUpEvt, this.windowOnPointerUp);
        this.windowOnPointerLeave && document.removeEventListener($3a4865bce5f52590$var$pointerCancelEvt, this.windowOnPointerLeave);
        this.windowOnPointerLeave && document.removeEventListener($3a4865bce5f52590$var$pointerLeaveEvt, this.windowOnPointerLeave);
    }
    destroy() {
        if (this.isDestroyed) return;
        this.isDestroyed = true;
        this.onPointerEnter && this.targetElement.removeEventListener($3a4865bce5f52590$var$pointerEnterEvt, this.onPointerEnter);
        this.onPointerLeave && this.targetElement.removeEventListener($3a4865bce5f52590$var$pointerLeaveEvt, this.onPointerLeave);
        this.onPointerMove && this.targetElement.removeEventListener($3a4865bce5f52590$var$pointerMoveEvt, this.onPointerMove);
        this.onPointerDown && this.targetElement.removeEventListener($3a4865bce5f52590$var$pointerDownEvt, this.onPointerDown);
        this.onWheel && this.targetElement.removeEventListener('wheel', this.onWheel);
        this.destroyDocumentListeners();
        this.onTouchMoveScribbleFix && document.removeEventListener('touchmove', this.onTouchMoveScribbleFix);
        this.onTouchStart && this.targetElement.removeEventListener('touchstart', this.onTouchStart);
        this.onTouchMove && this.targetElement.removeEventListener('touchmove', this.onTouchMove);
        this.onTouchEnd && this.targetElement.removeEventListener('touchend', this.onTouchEnd);
        this.onTouchCancel && this.targetElement.removeEventListener('touchcancel', this.onTouchCancel);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isDestroyed = false;
        this.isOverCounter = 0;
        // pointers that are pressing a button
        this.dragObjArr = [];
        this.dragPointerIdArr = [];
        // chrome input glitch workaround
        this.lastPointerType = null;
        this.didSkip = false;
        this.targetElement = p.target;
        this.onPointerCallback = p.onPointer;
        this.onWheelCallback = p.onWheel;
        this.onEnterLeaveCallback = p.onEnterLeave;
        this.maxPointers = Math.max(1, p.maxPointers ?? 1);
        const finalizeWheelEvent = (e)=>{
            if (this.isDestroyed || !this.onWheelCallback) return;
            const bounds = this.targetElement.getBoundingClientRect();
            const whlEvent = {
                ...e instanceof WheelEvent ? {
                    deltaY: e.deltaY / 120,
                    pageX: e.pageX,
                    pageY: e.pageY
                } : e,
                altKey: e.altKey,
                ctrlKey: e.ctrlKey,
                metaKey: e.metaKey,
                shiftKey: e.shiftKey,
                relX: e.clientX - bounds.left + this.targetElement.scrollLeft,
                relY: e.clientY - bounds.top + this.targetElement.scrollTop,
                ...e instanceof WheelEvent ? {
                    event: e
                } : {}
            };
            this.onWheelCallback(whlEvent);
        };
        this.wheelCleaner = p.useDirtyWheel ? undefined : new (0, $e3c08bc111aa5952$export$c734b8535f2f8e38)(finalizeWheelEvent);
        if (this.onPointerCallback) {
            this.onPointerMove = (event)=>{
                const correctedEvent = $3a4865bce5f52590$var$correctPointerEvent(event);
                const tempLastPointerType = this.lastPointerType;
                this.lastPointerType = correctedEvent.pointerType;
                if (this.dragPointerIdArr.includes(correctedEvent.pointerId) || this.dragPointerIdArr.length === this.maxPointers || correctedEvent.pointerType === 'touch') {
                    this.didSkip = false;
                    return;
                }
                // chrome input glitch workaround - throws in a random mouse event with the wrong position when using a stylus
                if (!this.didSkip && correctedEvent.pointerType === 'mouse' && tempLastPointerType === 'pen') {
                    this.didSkip = true;
                    return;
                }
                this.didSkip = false;
                const outEvent = this.createPointerOutEvent('pointermove', correctedEvent);
                this.onPointerCallback?.(outEvent);
            };
            this.onPointerDown = (event, onSkipGlobal)=>{
                //BB.throwOut('pointerdown ' + event.pointerId + ' | ' + dragPointerIdArr.length);
                const correctedEvent = $3a4865bce5f52590$var$correctPointerEvent(event, true);
                ////console.log('debug: ' + event.pointerId + ' pointerdown');
                if (this.dragPointerIdArr.includes(correctedEvent.pointerId) || this.dragPointerIdArr.length === this.maxPointers || ![
                    1,
                    2,
                    4
                ].includes(correctedEvent.buttons)) //BB.throwOut('pointerdown ignored');
                return;
                //set up global listeners
                if (this.dragObjArr.length === 0 && !onSkipGlobal) this.setupDocumentListeners();
                const dragObj = {
                    pointerId: correctedEvent.pointerId,
                    pointerType: correctedEvent.pointerType,
                    downPageX: correctedEvent.pageX,
                    downPageY: correctedEvent.pageY,
                    buttons: correctedEvent.buttons,
                    lastPageX: correctedEvent.pageX,
                    lastPageY: correctedEvent.pageY,
                    lastTimeStamp: correctedEvent.timeStamp
                };
                this.dragObjArr.push(dragObj);
                this.dragPointerIdArr.push(correctedEvent.pointerId);
                const outEvent = this.createPointerOutEvent('pointerdown', correctedEvent, {
                    downPageX: correctedEvent.pageX,
                    downPageY: correctedEvent.pageY,
                    button: $3a4865bce5f52590$var$getButtonStr(correctedEvent.buttons),
                    pressure: correctedEvent.pressure
                });
                this.onPointerCallback?.(outEvent);
            };
            this.windowOnPointerMove = (event)=>{
                //BB.throwOut('pointermove ' + event.pointerId);
                const correctedEvent = $3a4865bce5f52590$var$correctPointerEvent(event);
                ////console.log('debug: ' + event.pointerId + ' GLOBALpointermove');
                if (!this.dragPointerIdArr.includes(correctedEvent.pointerId)) return;
                const dragObj = this.getDragObj(correctedEvent.pointerId);
                if (!dragObj) // todo need to handle this!
                return;
                //if pointer changes button its pressing -> turn into pointerup
                if (correctedEvent.buttons !== dragObj.buttons) {
                    //pointer up
                    //remove listener
                    if (this.dragObjArr.length === 1) this.destroyDocumentListeners();
                    this.removeDragObj(correctedEvent.pointerId);
                    const outEvent = this.createPointerOutEvent('pointerup', correctedEvent, {
                        downPageX: dragObj.downPageX,
                        downPageY: dragObj.downPageY
                    });
                    this.onPointerCallback?.(outEvent);
                    return;
                }
                // ipad likes to do this
                if (correctedEvent.pointerType === 'pen' && correctedEvent.pageX === dragObj.lastPageX && correctedEvent.pageY === dragObj.lastPageY && correctedEvent.timeStamp === dragObj.lastTimeStamp) //ignore
                return;
                const outEvent = this.createPointerOutEvent('pointermove', correctedEvent, {
                    downPageX: dragObj.downPageX,
                    downPageY: dragObj.downPageY,
                    button: $3a4865bce5f52590$var$getButtonStr(correctedEvent.buttons),
                    pressure: correctedEvent.pressure
                });
                dragObj.lastPageX = correctedEvent.pageX;
                dragObj.lastPageY = correctedEvent.pageY;
                dragObj.lastTimeStamp = correctedEvent.timeStamp;
                this.onPointerCallback?.(outEvent);
            };
            this.windowOnPointerUp = (event)=>{
                //BB.throwOut('pointerup ' + event.pointerId);
                const correctedEvent = $3a4865bce5f52590$var$correctPointerEvent(event);
                ////console.log('debug: ' + event.pointerId + ' GLOBALpointerup');
                if (!this.dragPointerIdArr.includes(correctedEvent.pointerId)) return;
                //remove listener
                if (this.dragObjArr.length === 1) this.destroyDocumentListeners();
                const dragObj = this.removeDragObj(correctedEvent.pointerId);
                if (!dragObj) // todo need to handle this!
                return;
                const outEvent = this.createPointerOutEvent('pointerup', correctedEvent, {
                    downPageX: dragObj.downPageX,
                    downPageY: dragObj.downPageY
                });
                this.onPointerCallback?.(outEvent);
            };
            this.windowOnPointerLeave = (event)=>{
                //BB.throwOut('pointerleave ' + event.pointerId);
                const correctedEvent = $3a4865bce5f52590$var$correctPointerEvent(event);
                ////console.log('debug: ' + event.pointerId + ' onGlobalPointerLeave', event);
                if (!this.dragPointerIdArr.includes(correctedEvent.pointerId)) //} || event.target !== document) {
                return;
                //remove listener
                if (this.dragObjArr.length === 1) this.destroyDocumentListeners();
                const dragObj = this.removeDragObj(correctedEvent.pointerId);
                if (!dragObj) // todo need to handle this!
                return;
                const outEvent = this.createPointerOutEvent('pointerup', correctedEvent, {
                    downPageX: dragObj.downPageX,
                    downPageY: dragObj.downPageY
                });
                this.onPointerCallback?.(outEvent);
            };
            this.targetElement.addEventListener($3a4865bce5f52590$var$pointerMoveEvt, this.onPointerMove, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
            this.targetElement.addEventListener($3a4865bce5f52590$var$pointerDownEvt, this.onPointerDown, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
            if (!(0, $25e38424550c7e3f$export$7728c852ca75bb6d)) {
                const touchToFakePointer = (touch, touchEvent, isDown)=>{
                    return {
                        pointerId: touch.identifier,
                        pointerType: 'touch',
                        altKey: touchEvent.altKey,
                        ctrlKey: touchEvent.ctrlKey,
                        metaKey: touchEvent.metaKey,
                        shiftKey: touchEvent.shiftKey,
                        pageX: touch.pageX,
                        pageY: touch.pageY,
                        clientX: touch.clientX,
                        clientY: touch.clientY,
                        button: isDown ? 0 : undefined,
                        buttons: isDown ? 1 : 0,
                        timeStamp: touchEvent.timeStamp,
                        target: touchEvent.target,
                        pressure: isDown ? 1 : 0,
                        preventDefault: ()=>touchEvent.preventDefault(),
                        stopPropagation: ()=>touchEvent.stopPropagation()
                    };
                };
                const handleTouch = (e, type)=>{
                    for(let i = 0; i < e.changedTouches.length; i++){
                        const touch = e.changedTouches[i];
                        const fakePointer = touchToFakePointer(touch, e, [
                            'start',
                            'move'
                        ].includes(type));
                        if (type === 'start') this.onPointerDown(fakePointer, false);
                        else if (type === 'move') this.windowOnPointerMove(fakePointer);
                        else if (type === 'end') this.windowOnPointerUp(fakePointer);
                        else this.windowOnPointerLeave(fakePointer);
                    }
                };
                this.onTouchStart = (e)=>{
                    e.preventDefault();
                    handleTouch(e, 'start');
                };
                this.onTouchMove = (e)=>{
                    handleTouch(e, 'move');
                };
                this.onTouchEnd = (e)=>{
                    handleTouch(e, 'end');
                };
                this.onTouchCancel = (e)=>{
                    handleTouch(e, 'cancel');
                };
                this.targetElement.addEventListener('touchstart', this.onTouchStart, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
                this.targetElement.addEventListener('touchmove', this.onTouchMove, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
                this.targetElement.addEventListener('touchend', this.onTouchEnd, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
                this.targetElement.addEventListener('touchcancel', this.onTouchCancel, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
            }
        }
        if (this.onWheelCallback) {
            this.onWheel = (e)=>{
                if (this.wheelCleaner) this.wheelCleaner.process(e);
                else finalizeWheelEvent(e);
            };
            this.targetElement.addEventListener('wheel', this.onWheel, {
                passive: !!p.isWheelPassive
            });
        }
        if (this.onEnterLeaveCallback) {
            this.onPointerEnter = (e)=>{
                // workaround for Safari which can falsely fire pointerenter. For more details see below.
                if (!$3a4865bce5f52590$var$pointerTypeMouseOccurred && e.pointerType === 'mouse') return;
                this.isOverCounter++;
                this.onEnterLeaveCallback?.(true);
            };
            this.onPointerLeave = ()=>{
                this.isOverCounter--;
                this.onEnterLeaveCallback?.(false);
            };
            this.targetElement.addEventListener($3a4865bce5f52590$var$pointerEnterEvt, this.onPointerEnter, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
            this.targetElement.addEventListener($3a4865bce5f52590$var$pointerLeaveEvt, this.onPointerLeave, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
        }
        if (p.fixScribble) {
            //ipad scribble workaround https://developer.apple.com/forums/thread/662874
            this.onTouchMoveScribbleFix = (e)=>e.preventDefault();
            this.targetElement.addEventListener('touchmove', this.onTouchMoveScribbleFix, $3a4865bce5f52590$var$OPTIONS_PASSIVE);
        }
    }
}
// Workaround for Safari (iOS/IPadOS 26.2) https://bugs.webkit.org/show_bug.cgi?id=305856
// The incorrect pointerenter event will be of type "mouse" although the click happened with "touch".
// This workaround won't work if the user uses both touch and mouse. The probability of that should be low enough.
let $3a4865bce5f52590$var$pointerTypeMouseOccurred = false;
setTimeout(()=>{
    const listener = (e)=>{
        if (e.pointerType === 'mouse' && !$3a4865bce5f52590$var$pointerTypeMouseOccurred) {
            $3a4865bce5f52590$var$pointerTypeMouseOccurred = true;
            document.removeEventListener($3a4865bce5f52590$var$pointerMoveEvt, listener);
        }
    };
    document.addEventListener($3a4865bce5f52590$var$pointerMoveEvt, listener);
});



var $79I2S = parcelRequire("79I2S");

function $2e475852c551fcab$export$fe58198efe02b173(src, options = {}) {
    return new Promise((resolve, reject)=>{
        const image = new Image();
        const clearHandlers = ()=>{
            image.onload = null;
            image.onabort = null;
            image.onerror = null;
        };
        image.onload = ()=>{
            clearHandlers();
            resolve(image);
        };
        image.onabort = ()=>{
            clearHandlers();
            reject(new DOMException('Image loading aborted', 'AbortError'));
        };
        image.onerror = ()=>{
            clearHandlers();
            reject(new Error('Image failed loading'));
        };
        if (options.crossOrigin !== undefined) image.crossOrigin = options.crossOrigin;
        image.src = src;
    });
}
async function $2e475852c551fcab$export$99cbfa07c2ec1e27(blob) {
    const src = URL.createObjectURL(blob);
    try {
        return await $2e475852c551fcab$export$fe58198efe02b173(src);
    } finally{
        URL.revokeObjectURL(src);
    }
}


function $b5f980f0748d5a71$export$ba7ed3181f35c1cc(selection) {
    const path = new Path2D();
    selection.forEach((poly)=>{
        poly.forEach((ring)=>{
            ring.forEach((point, index)=>{
                if (index === 0) path.moveTo(...point);
                else path.lineTo(...point);
            });
        });
        path.closePath();
    });
    return path;
}
function $b5f980f0748d5a71$export$8f2be1db13cf0f94(poly) {
    let result = '';
    poly.forEach((poly)=>{
        poly.forEach((ring)=>{
            result += 'M';
            ring.forEach((point)=>{
                result += point.join(',') + ' ';
            });
        });
    });
    return result.trim();
}



function $4c2c6808296c0d73$export$2c9e8a9632a706b2(a, b, f) {
    return a * (1 - f) + b * f;
}
function $4c2c6808296c0d73$export$6c4a311cc157c764(ax, ay, bx, by) {
    return Math.sqrt((ax - bx) ** 2 + (ay - by) ** 2);
}
function $4c2c6808296c0d73$export$499eb56409f6cbc2(ax, ay, bx, by) {
    // faster because no square-root
    return (ax - bx) ** 2 + (ay - by) ** 2;
}
function $4c2c6808296c0d73$export$a4f99f99d3e99cfa(x, y) {
    // faster because no square-root
    return x * x + y * y;
}
function $4c2c6808296c0d73$export$627023b405ba5028(p1, p2) {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x);
}
function $4c2c6808296c0d73$export$c03a8450eabc2532(p1, p2) {
    return $4c2c6808296c0d73$export$627023b405ba5028(p1, p2) * 180 / Math.PI;
}
function $4c2c6808296c0d73$export$151bd845d70e2099(p, rect) {
    return rect.x <= p.x && p.x <= rect.x + rect.width && rect.y <= p.y && p.y <= rect.y + rect.height;
}
function $4c2c6808296c0d73$export$7d15b64cf5a3a4c4(num, min, max) {
    return num < min ? min : num > max ? max : num;
}
function $4c2c6808296c0d73$export$bb628a54ab399bc9(x, y, deg) {
    const theta = deg * (Math.PI / 180);
    const cs = Math.cos(theta);
    const sn = Math.sin(theta);
    return {
        x: x * cs - y * sn,
        y: x * sn + y * cs
    };
}
function $4c2c6808296c0d73$export$95ec0760d3d00713(center, point, deg) {
    const rot = $4c2c6808296c0d73$export$bb628a54ab399bc9(point.x - center.x, point.y - center.y, deg);
    rot.x += center.x;
    rot.y += center.y;
    return rot;
}
function $4c2c6808296c0d73$export$c0156198713d0f0(angleDeg, snapDegIncrement, maxDistDeg) {
    const modDeg = Math.abs(angleDeg % snapDegIncrement);
    const dist = Math.min(modDeg, snapDegIncrement - modDeg);
    if (dist <= maxDistDeg) angleDeg = Math.round(angleDeg / snapDegIncrement) * snapDegIncrement;
    return angleDeg;
}
function $4c2c6808296c0d73$export$ec85425cac357ca9(angleDeg) {
    angleDeg = angleDeg % 360;
    if (angleDeg > 180) angleDeg -= 360;
    else if (angleDeg < -180) angleDeg += 360;
    return angleDeg;
}
function $4c2c6808296c0d73$export$bbf9af158036c5e9(remainder, fDx, fDy) {
    remainder.x += fDx;
    remainder.y += fDy;
    const dX = Math.round(remainder.x);
    const dY = Math.round(remainder.y);
    remainder.x -= dX;
    remainder.y -= dY;
    return {
        dX: dX,
        dY: dY
    };
}
function $4c2c6808296c0d73$export$94cce7adf2ec2d08(f) {
    if (f % 1 === 0) {
        if (f % 2 === 0) return f;
        return f + 1;
    }
    const above = Math.ceil(f);
    const below = Math.floor(f);
    if (above % 2 === 0) return above;
    else return below;
}
function $4c2c6808296c0d73$export$f373b6a7b0c159a(f) {
    if (f % 1 === 0) {
        if (f % 2 === 0) return f + 1;
        return f;
    }
    const above = Math.ceil(f);
    const below = Math.floor(f);
    if (above % 2 === 1) return above;
    else return below;
}
function $4c2c6808296c0d73$export$2077e0241d6afd3c(f, digits) {
    const digitMult = 10 ** digits;
    // adding epsilon is not much better
    return Math.round(f * digitMult) / digitMult;
}
const $4c2c6808296c0d73$var$roundFormatterCache = new Map();
function $4c2c6808296c0d73$export$c062906a50569e71(f, digits) {
    const result = (0, $94f0b2b810d4d191$export$77f9e426014f6edd)(()=>{
        let formatter = $4c2c6808296c0d73$var$roundFormatterCache.get(digits);
        if (!formatter) {
            formatter = new Intl.NumberFormat('en-US-u-nu-latn', {
                useGrouping: false,
                maximumFractionDigits: digits
            });
            $4c2c6808296c0d73$var$roundFormatterCache.set(digits, formatter);
        }
        return Number(formatter.format(f));
    });
    return result instanceof (0, $94f0b2b810d4d191$export$6d5e6de05c94f9f) ? $4c2c6808296c0d73$export$2077e0241d6afd3c(f, digits) : result;
}
function $4c2c6808296c0d73$export$5f852371c60150f6(value) {
    const [coefficient, exponent = '0'] = value.toString().toLowerCase().split('e');
    const fractionLength = coefficient.split('.')[1]?.length ?? 0;
    return Math.max(0, fractionLength - Number(exponent));
}
function $4c2c6808296c0d73$export$5aa63862e8b9c037(bounds) {
    return {
        ...bounds,
        x1: Math.min(bounds.x1, bounds.x2),
        y1: Math.min(bounds.y1, bounds.y2),
        x2: Math.max(bounds.x1, bounds.x2),
        y2: Math.max(bounds.y1, bounds.y2)
    };
}
function $4c2c6808296c0d73$export$f4467a4f41373bc7(target, bounds) {
    if (!bounds && !target) throw new Error('at least one param needs to be defined');
    if (!bounds) return target;
    if (!target) target = {
        type: bounds.type,
        x1: bounds.x1,
        y1: bounds.y1,
        x2: bounds.x2,
        y2: bounds.y2
    };
    else {
        target.x1 = Math.min(target.x1, bounds.x1);
        target.y1 = Math.min(target.y1, bounds.y1);
        target.x2 = Math.max(target.x2, bounds.x2);
        target.y2 = Math.max(target.y2, bounds.y2);
    }
    return target;
}
function $4c2c6808296c0d73$export$83720aaadc272d85(bounds, limit) {
    if (!bounds) return undefined;
    if (!limit) return bounds;
    const x1 = Math.max(limit.x1, bounds.x1);
    const y1 = Math.max(limit.y1, bounds.y1);
    const x2 = Math.min(limit.x2, bounds.x2);
    const y2 = Math.min(limit.y2, bounds.y2);
    if (x1 > x2 || y1 > y2) return undefined;
    return {
        type: bounds?.type ?? limit?.type,
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $4c2c6808296c0d73$export$ddc1c0069d484d49(bounds, width, height) {
    if (!bounds) return undefined;
    return $4c2c6808296c0d73$export$83720aaadc272d85(bounds, {
        type: 'index',
        x1: 0,
        y1: 0,
        x2: width - 1,
        y2: height - 1
    });
}
function $4c2c6808296c0d73$export$b0036cbc597df324(bounds) {
    const x1 = Math.floor(bounds.x1);
    const y1 = Math.floor(bounds.y1);
    const x2 = Math.ceil(bounds.x2 - 1);
    const y2 = Math.ceil(bounds.y2 - 1);
    return {
        type: 'index',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $4c2c6808296c0d73$export$86989866a3954672(bounds) {
    const x1 = bounds.x1;
    const y1 = bounds.y1;
    const x2 = bounds.x2 + 1;
    const y2 = bounds.y2 + 1;
    return {
        type: 'coordinate',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $4c2c6808296c0d73$export$3488993c9d026384(bounds) {
    return {
        x: bounds.x1,
        y: bounds.y1,
        width: bounds.x2 - bounds.x1 + 1,
        height: bounds.y2 - bounds.y1 + 1
    };
}
function $4c2c6808296c0d73$export$d89ccdf57354a99c(rect, type) {
    const x2 = rect.x + rect.width;
    const y2 = rect.y + rect.height;
    return type === 'index' ? {
        type: 'index',
        x1: rect.x,
        y1: rect.y,
        x2: x2 - 1,
        y2: y2 - 1
    } : {
        type: 'coordinate',
        x1: rect.x,
        y1: rect.y,
        x2: x2,
        y2: y2
    };
}
function $4c2c6808296c0d73$export$4218cb0e42c2e7e(bounds) {
    const isIndex = bounds.type === 'index';
    return {
        x: bounds.x1,
        y: bounds.y1,
        width: bounds.x2 - bounds.x1 + (isIndex ? 1 : 0),
        height: bounds.y2 - bounds.y1 + (isIndex ? 1 : 0)
    };
}




var $7YQXi = parcelRequire("7YQXi");
function $419f77660d9ca0bd$export$b40690970a79d0ef(canvas, width, height, options) {
    const oldWidth = canvas.width;
    const oldHeight = canvas.height;
    if (options?.doForce) {
        canvas.width = width ?? canvas.width;
        canvas.height = height ?? canvas.height;
    } else {
        let didChange = false;
        if (width !== undefined && width !== canvas.width) {
            canvas.width = width;
            didChange = true;
        }
        if (height !== undefined && height !== canvas.height) {
            canvas.height = height;
            didChange = true;
        }
        if (options?.ensureCleared && !didChange) (0, $2f436639594531f3$export$39f92e86d1722f3a)(canvas).clearRect(0, 0, canvas.width, canvas.height);
    }
    (0, $7YQXi.CANVAS_DEBUG_HOOKS).onResize?.(canvas, oldWidth, oldHeight);
}



function $2f436639594531f3$export$83cbd513f10a842b(image) {
    const resultCanvas = (0, $79I2S.createCanvas)(image.width, image.height);
    const ctx = resultCanvas.getContext('2d');
    if (!ctx) throw new Error('2d context not supported or canvas already initialized');
    ctx.drawImage(image, 0, 0);
    return resultCanvas;
}
function $2f436639594531f3$export$39f92e86d1722f3a(canvas, options) {
    const ctx = canvas.getContext('2d', options);
    if (!ctx) throw new Error("couldn't get 2d context");
    return ctx;
}
async function $2f436639594531f3$export$bd64872f2769a724(path) {
    const im = await (0, $2e475852c551fcab$export$fe58198efe02b173)(path);
    const canvas = (0, $79I2S.createCanvas)(im.width, im.height);
    const ctx = canvas.getContext('2d');
    ctx.drawImage(im, 0, 0);
    return canvas;
}
function $2f436639594531f3$export$1555f643cc9a976(transform, scaleX, scaleY) {
    if (![
        1,
        -1
    ].includes(scaleX) || ![
        1,
        -1
    ].includes(scaleY) || transform.width % 1 !== 0 || transform.height % 1 !== 0 || Math.abs(transform.angleDeg) % 90 !== 0) return false;
    const whSwapped = Math.abs(transform.angleDeg - 90) % 180 === 0;
    const width = whSwapped ? transform.height : transform.width;
    const height = whSwapped ? transform.width : transform.height;
    return (Math.abs(width) % 2 === 0 && transform.x % 1 === 0 || Math.abs(width) % 2 === 1 && transform.x % 1 === 0.5) && (Math.abs(height) % 2 === 0 && transform.y % 1 === 0 || Math.abs(height) % 2 === 1 && transform.y % 1 === 0.5);
}
function $2f436639594531f3$export$ded2b43392504635(destCtx, transformImage, transform, bounds, pixelated) {
    bounds ??= {
        x: 0,
        y: 0,
        width: transformImage.width,
        height: transformImage.height
    };
    destCtx.save();
    if (pixelated) destCtx.imageSmoothingEnabled = false;
    else {
        destCtx.imageSmoothingEnabled = true;
        destCtx.imageSmoothingQuality = 'high';
    }
    destCtx.translate(transform.x, transform.y);
    destCtx.rotate(transform.angleDeg / 180 * Math.PI);
    destCtx.scale(transform.width > 0 ? 1 : -1, transform.height > 0 ? 1 : -1);
    destCtx.drawImage(transformImage, bounds.x, bounds.y, bounds.width, bounds.height, -Math.abs(transform.width) / 2, -Math.abs(transform.height) / 2, Math.abs(transform.width), Math.abs(transform.height));
    destCtx.restore();
}
const $2f436639594531f3$export$754559b36e94ea2f = function(size, isDark) {
    const canvas = size < 1 ? (0, $79I2S.createCanvas)(1, 1) : (0, $79I2S.createCanvas)(size * 2, size * 2);
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    if (size < 1) {
        ctx.fillStyle = 'rgb(128, 128, 128)';
        ctx.fillRect(0, 0, 1, 1);
    } else {
        ctx.fillStyle = isDark ? 'rgb(90, 90, 90)' : 'rgb(255, 255, 255)';
        ctx.fillRect(0, 0, size * 2, size * 2);
        ctx.fillStyle = isDark ? 'rgb(63, 63, 63)' : 'rgb(200, 200, 200)';
        ctx.fillRect(0, 0, size, size);
        ctx.fillRect(size, size, size * 2, size * 2);
    }
    return canvas;
};
const $2f436639594531f3$export$42af33c76b681867 = function() {
    // previously created dataUrls
    const cache = {};
    return function(size, callback, isDark) {
        const modeStr = isDark ? 'd' : 'l';
        function create(size) {
            size = parseInt('' + size);
            if (cache['' + size + modeStr]) return cache['' + size + modeStr];
            const canvas = $2f436639594531f3$export$754559b36e94ea2f(size, isDark);
            const result = canvas.toDataURL('image/png');
            cache['' + size + modeStr] = result;
            return result;
        }
        if (callback) //async
        setTimeout(function() {
            callback(create(size));
        }, 1);
        else //sync
        return create(size);
    };
}();
function $2f436639594531f3$export$59b33278b5b2fc8a(canvas, w, h, tmp1, tmp2) {
    //determine base 2 exponents of old and new size
    function getBase2Obj(oldW, oldH, newW, newH) {
        const result = {
            oldWidthEx: Math.round(Math.log2(oldW)),
            oldHeightEx: Math.round(Math.log2(oldH)),
            newWidthEx: Math.ceil(Math.log2(newW)),
            newHeightEx: Math.ceil(Math.log2(newH))
        };
        result.oldWidthEx = Math.max(result.oldWidthEx, result.newWidthEx);
        result.oldHeightEx = Math.max(result.oldHeightEx, result.newHeightEx);
        return result;
    }
    if (!w || !h || w === canvas.width && h === canvas.height) return;
    w = Math.max(w, 1);
    h = Math.max(h, 1);
    if (w <= canvas.width && h <= canvas.height) {
        tmp1 = !tmp1 ? (0, $79I2S.createCanvas)() : tmp1;
        tmp2 = !tmp2 ? (0, $79I2S.createCanvas)() : tmp2;
        const base2 = getBase2Obj(canvas.width, canvas.height, w, h);
        //initially scale to a base of 2. unless new size is too close to old. e.g. sizing from 900 to 600
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(tmp2, base2.oldWidthEx > base2.newWidthEx ? 2 ** base2.oldWidthEx : w, base2.oldHeightEx > base2.newHeightEx ? 2 ** base2.oldHeightEx : h);
        tmp1.getContext('2d').save();
        tmp2.getContext('2d').save();
        let ew, eh;
        let buffer1 = tmp1, buffer2 = tmp2;
        ew = base2.oldWidthEx;
        eh = base2.oldHeightEx;
        let bufferCtx = buffer2.getContext('2d');
        bufferCtx.imageSmoothingEnabled = true;
        bufferCtx.imageSmoothingQuality = 'high';
        bufferCtx.globalCompositeOperation = 'copy';
        bufferCtx.drawImage(canvas, 0, 0, buffer2.width, buffer2.height);
        let currentWidth = buffer2.width;
        let currentHeight = buffer2.height;
        //stepwise half the size
        for(; ew > base2.newWidthEx || eh > base2.newHeightEx; ew--, eh--){
            bufferCtx = buffer1.getContext('2d');
            bufferCtx.imageSmoothingEnabled = true;
            bufferCtx.imageSmoothingQuality = 'high';
            bufferCtx.globalCompositeOperation = 'copy';
            const newWidth = ew > base2.newWidthEx ? currentWidth / 2 : currentWidth;
            const newHeight = eh > base2.newHeightEx ? currentHeight / 2 : currentHeight;
            //buffer also needs to be properly sized, unfortunately
            (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(buffer1, newWidth, newHeight, {
                ensureCleared: true
            });
            bufferCtx.drawImage(buffer2, 0, 0, currentWidth, currentHeight, 0, 0, newWidth, newHeight);
            currentWidth = newWidth;
            currentHeight = newHeight;
            //swap
            const tmp = buffer1;
            buffer1 = buffer2;
            buffer2 = tmp;
        }
        //when no longer can be halved, bring to target size
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(canvas, w, h, {
            ensureCleared: true
        });
        const canvasCtx = canvas.getContext('2d');
        canvasCtx.save();
        canvasCtx.imageSmoothingEnabled = true;
        canvasCtx.imageSmoothingQuality = 'high';
        canvasCtx.drawImage(buffer2, 0, 0, currentWidth, currentHeight, 0, 0, w, h);
        canvasCtx.restore();
        tmp1.getContext('2d').restore();
        tmp2.getContext('2d').restore();
    } else if (w >= canvas.width && h >= canvas.height) {
        tmp1 = !tmp1 ? (0, $79I2S.createCanvas)() : tmp1;
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(tmp1, w, h, {
            ensureCleared: true
        });
        const tmp1Ctx = tmp1.getContext('2d');
        tmp1Ctx.save();
        tmp1Ctx.imageSmoothingEnabled = true;
        tmp1Ctx.imageSmoothingQuality = 'high';
        tmp1Ctx.drawImage(canvas, 0, 0, w, h);
        tmp1Ctx.restore();
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(canvas, w, h);
        canvas.getContext('2d').drawImage(tmp1, 0, 0);
    } else {
        $2f436639594531f3$export$59b33278b5b2fc8a(canvas, w, canvas.height, tmp1, tmp2);
        $2f436639594531f3$export$59b33278b5b2fc8a(canvas, w, h, tmp1, tmp2);
    }
}
function $2f436639594531f3$export$2384aff49c9b73c2(canvas) {
    canvas.width = 1;
    canvas.height = 1;
    canvas.remove();
}
function $2f436639594531f3$export$c1fcf1f93aeabfbf(context, //restricts the search to this area.
searchArea) {
    const searchRect = searchArea ? (0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)(searchArea) : {
        x: 0,
        y: 0,
        width: context.canvas.width,
        height: context.canvas.height
    };
    if (searchRect.width <= 0 || searchRect.height <= 0) return undefined;
    const imdat = context.getImageData(searchRect.x, searchRect.y, searchRect.width, searchRect.height);
    // top-left and bottom-right are non-transparent.
    if (imdat.data[3] > 0 && imdat.data.at(-1) > 0) return searchRect;
    const tempBounds = {};
    for(let i = 3; i < imdat.data.length; i += 4)if (imdat.data[i] > 0) {
        const px = (i - 3) / 4 % searchRect.width;
        const py = Math.floor((i - 3) / 4 / searchRect.width);
        if (tempBounds.x1 === undefined || px < tempBounds.x1) tempBounds.x1 = px;
        if (tempBounds.y1 === undefined || py < tempBounds.y1) tempBounds.y1 = py;
        if (tempBounds.x2 === undefined || px + 1 > tempBounds.x2) tempBounds.x2 = px;
        if (tempBounds.y2 === undefined || py + 1 > tempBounds.y2) tempBounds.y2 = py;
    }
    if (tempBounds.x1 === undefined || tempBounds.y1 === undefined || tempBounds.x2 === undefined || tempBounds.y2 === undefined) return undefined;
    return {
        x: tempBounds.x1 + searchRect.x,
        y: tempBounds.y1 + searchRect.y,
        width: tempBounds.x2 - tempBounds.x1 + 1,
        height: tempBounds.y2 - tempBounds.y1 + 1
    };
}
function $2f436639594531f3$export$f84fa3da4a94c138(ctx, x, y, width, height) {
    const result = (0, $94f0b2b810d4d191$export$77f9e426014f6edd)(()=>ctx.getImageData(x, y, width, height));
    return result instanceof (0, $94f0b2b810d4d191$export$6d5e6de05c94f9f) ? new ImageData(width, height) : result;
}
function $2f436639594531f3$export$27e43d53d0895782(canvas, mimeType) {
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>{
            if (blob) resolve(blob);
            else reject(new Error('Failed to create blob from canvas.'));
        }, mimeType);
    });
}
async function $2f436639594531f3$export$403d539f215df596(canvas, mimeType) {
    if ('toBlob' in HTMLCanvasElement.prototype) return await $2f436639594531f3$export$27e43d53d0895782(canvas, mimeType);
    else // assume base64
    return (0, $94f0b2b810d4d191$export$b3fb17ae4345ac8f)(canvas.toDataURL(mimeType));
}
function $2f436639594531f3$export$f7b95c0f504bef8b(selection, context) {
    const canvas = context.canvas;
    context.save();
    context.fillRect(0, 0, canvas.width, canvas.height);
    const selectionPath = (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(selection);
    context.clip(selectionPath);
    context.fillStyle = 'white';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.restore();
}
const $2f436639594531f3$export$83e8ab53904f8022 = Object.freeze([
    1,
    0,
    0,
    1,
    0,
    0
]);


// https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Matrix_math_for_the_web
// not optimized
function $bf8a1df6cb389ef0$var$getIdentity() {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
// point • matrix
function $bf8a1df6cb389ef0$var$multiplyMatrixAndPoint(matrix, point) {
    return [
        point[0] * matrix[0] + point[1] * matrix[4] + point[2] * matrix[8] + point[3] * matrix[12],
        point[0] * matrix[1] + point[1] * matrix[5] + point[2] * matrix[9] + point[3] * matrix[13],
        point[0] * matrix[2] + point[1] * matrix[6] + point[2] * matrix[10] + point[3] * matrix[14],
        point[0] * matrix[3] + point[1] * matrix[7] + point[2] * matrix[11] + point[3] * matrix[15]
    ];
}
//matrixB • matrixA
function $bf8a1df6cb389ef0$var$multiplyMatrices(matrixA, matrixB) {
    // Slice the second matrix up into rows
    const row0 = [
        matrixB[0],
        matrixB[1],
        matrixB[2],
        matrixB[3]
    ];
    const row1 = [
        matrixB[4],
        matrixB[5],
        matrixB[6],
        matrixB[7]
    ];
    const row2 = [
        matrixB[8],
        matrixB[9],
        matrixB[10],
        matrixB[11]
    ];
    const row3 = [
        matrixB[12],
        matrixB[13],
        matrixB[14],
        matrixB[15]
    ];
    // Multiply each row by matrixA
    const result0 = $bf8a1df6cb389ef0$var$multiplyMatrixAndPoint(matrixA, row0);
    const result1 = $bf8a1df6cb389ef0$var$multiplyMatrixAndPoint(matrixA, row1);
    const result2 = $bf8a1df6cb389ef0$var$multiplyMatrixAndPoint(matrixA, row2);
    const result3 = $bf8a1df6cb389ef0$var$multiplyMatrixAndPoint(matrixA, row3);
    // Turn the result rows back into a single matrix
    return [
        result0[0],
        result0[1],
        result0[2],
        result0[3],
        result1[0],
        result1[1],
        result1[2],
        result1[3],
        result2[0],
        result2[1],
        result2[2],
        result2[3],
        result3[0],
        result3[1],
        result3[2],
        result3[3]
    ];
}
function $bf8a1df6cb389ef0$var$createTranslationMatrix(x, y) {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        x,
        y,
        0,
        1
    ];
}
function $bf8a1df6cb389ef0$var$createRotationMatrix(angleRad) {
    //let angleRad = angleDeg / 360 * 2 * Math.PI;
    return [
        Math.cos(-angleRad),
        -Math.sin(-angleRad),
        0,
        0,
        Math.sin(-angleRad),
        Math.cos(-angleRad),
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
function $bf8a1df6cb389ef0$var$createScaleMatrix(f) {
    return [
        f,
        0,
        0,
        0,
        0,
        f,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
const $bf8a1df6cb389ef0$export$5b12bf1653c0dd85 = Object.freeze({
    getIdentity: $bf8a1df6cb389ef0$var$getIdentity,
    multiplyMatrixAndPoint: $bf8a1df6cb389ef0$var$multiplyMatrixAndPoint,
    multiplyMatrices: $bf8a1df6cb389ef0$var$multiplyMatrices,
    createTranslationMatrix: $bf8a1df6cb389ef0$var$createTranslationMatrix,
    createRotationMatrix: $bf8a1df6cb389ef0$var$createRotationMatrix,
    createScaleMatrix: $bf8a1df6cb389ef0$var$createScaleMatrix
});


const $77055f1820134609$export$ac4bca90992eed1 = {
    add: function(p1, p2) {
        return {
            x: p1.x + p2.x,
            y: p1.y + p2.y
        };
    },
    sub: function(p1, p2) {
        return {
            x: p1.x - p2.x,
            y: p1.y - p2.y
        };
    },
    nor: function(p) {
        const len = Math.sqrt(p.x ** 2 + p.y ** 2);
        return {
            x: p.x / len,
            y: p.y / len
        };
    },
    len: function(p) {
        return Math.sqrt(p.x ** 2 + p.y ** 2);
    },
    dist: function(p1, p2) {
        return $77055f1820134609$export$ac4bca90992eed1.len($77055f1820134609$export$ac4bca90992eed1.sub(p1, p2));
    },
    mul: function(p, s) {
        return {
            x: p.x * s,
            y: p.y * s
        };
    },
    angle: function(p1, p2) {
        return Math.atan2(p2.y - p1.y, p2.x - p1.x);
    },
    dot: function(a, b) {
        const aArr = [
            a.x,
            a.y
        ];
        const bArr = [
            b.x,
            b.y
        ];
        return aArr.map((x, i)=>aArr[i] * bArr[i]).reduce((m, n)=>m + n);
    }
};





const $4f238305bcccbc5b$export$b4c5b177db876445 = function(lineStart, lineEnd, p) {
    let x, y;
    if (lineStart.x === lineEnd.x) {
        x = lineStart.x;
        y = p.y;
        return {
            x: x,
            y: y
        };
    }
    const m = (lineEnd.y - lineStart.y) / (lineEnd.x - lineStart.x);
    const b = lineStart.y - m * lineStart.x;
    x = (m * p.y + p.x - m * b) / (m * m + 1);
    y = (m * m * p.y + m * p.x + b) / (m * m + 1);
    return {
        x: x,
        y: y
    };
};
class $4f238305bcccbc5b$export$8b36a4a83269a640 {
    // ---- interface ----
    /**
     * returns point when traveling *dist* along the line, > 0
     * @param dist
     */ getAtDist(dist) {
        let remainder = Math.min(this.getLength(), dist);
        let i = 0;
        for(; remainder > this.segmentArr[i].length && i < this.segmentArr.length - 2; i++)remainder -= this.segmentArr[i].length;
        const fac = Math.min(1, Math.max(0, remainder / this.segmentArr[i].length));
        return {
            x: this.segmentArr[i].x * (1 - fac) + this.segmentArr[i + 1].x * fac,
            y: this.segmentArr[i].y * (1 - fac) + this.segmentArr[i + 1].y * fac
        };
    }
    /**
     * total length of line
     */ getLength() {
        let result = 0;
        for(let i = 0; i < this.segmentArr.length - 1; i++)result += this.segmentArr[i].length;
        return result;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.segmentArr = [];
        for(let i = 0; i < p.points.length; i++)((i)=>{
            let length = 0;
            if (i < p.points.length - 1) length = (0, $4c2c6808296c0d73$export$6c4a311cc157c764)(p.points[i].x, p.points[i].y, p.points[i + 1].x, p.points[i + 1].y);
            this.segmentArr[i] = {
                x: p.points[i].x,
                y: p.points[i].y,
                length: length
            };
        })(i);
    }
}
class $4f238305bcccbc5b$export$5379d955c16d4d43 {
    /**
     * creates bezier curve from control points
     * @param p1 - control point 1 {x: float, y: float}
     * @param p2 - control point 2 {x: float, y: float}
     * @param p3 - control point 3 {x: float, y: float}
     * @param p4 - control point 4 {x: float, y: float}
     * @param resolution - int
     * @returns bezier curve made up of points {x: float, y: float}
     */ getBezierPoints(p1, p2, p3, p4, resolution) {
        const curvePoints = [];
        let t;
        for(let i = 0; i <= resolution; i++){
            t = i / resolution;
            curvePoints[curvePoints.length] = {
                x: (1 - t) ** 3 * p1.x + 3 * (1 - t) ** 2 * t * p2.x + 3 * (1 - t) * t ** 2 * p3.x + t ** 3 * p4.x,
                y: (1 - t) ** 3 * p1.y + 3 * (1 - t) ** 2 * t * p2.y + 3 * (1 - t) * t ** 2 * p3.y + t ** 3 * p4.y
            };
        }
        return curvePoints;
    }
    // ---- interface ----
    /**
     * Add new point to line. "Drawn" line will go until the previous point.
     *
     * @param x - coord of new point
     * @param y
     * @param spacing - space between each step
     * @param callback - calls for each step
     * @param controlsCallback - calls that callback with the bezier control points
     */ add(x, y, spacing, callback, controlsCallback) {
        if (this.lastPoint && x === this.lastPoint.x && y === this.lastPoint.y) return;
        this.lastPoint = {
            x: x,
            y: y
        };
        this.pointArr[this.pointArr.length] = {
            x: x,
            y: y,
            spacing: spacing
        };
        //calculate directions
        if (this.pointArr.length === 1) {
            this.lastSpacing = spacing;
            return;
        } else if (this.pointArr.length === 2) {
            this.pointArr[0].dir = (0, $77055f1820134609$export$ac4bca90992eed1).nor((0, $77055f1820134609$export$ac4bca90992eed1).sub(this.pointArr[1], this.pointArr[0]));
            this.lastDot = spacing;
            this.lastSpacing = spacing;
            return;
        } else {
            const pointM1 = this.pointArr.at(-1);
            const pointM2 = this.pointArr.at(-2);
            const pointM3 = this.pointArr.at(-3);
            pointM2.dir = (0, $77055f1820134609$export$ac4bca90992eed1).nor((0, $77055f1820134609$export$ac4bca90992eed1).sub(pointM1, pointM3));
            if (isNaN(pointM2.dir.x) || isNaN(pointM2.dir.y)) //when xy -3 == -1
            pointM2.dir = (0, $94f0b2b810d4d191$export$af0d87255f3cfd7e)(pointM3.dir);
        }
        //get bezier curve
        const a = this.pointArr.at(-3);
        const b = this.pointArr.at(-2);
        const p1 = a;
        const p2 = (0, $77055f1820134609$export$ac4bca90992eed1).add(a, (0, $77055f1820134609$export$ac4bca90992eed1).mul(a.dir, (0, $77055f1820134609$export$ac4bca90992eed1).dist(a, b) / 4));
        const p3 = (0, $77055f1820134609$export$ac4bca90992eed1).sub(b, (0, $77055f1820134609$export$ac4bca90992eed1).mul(b.dir, (0, $77055f1820134609$export$ac4bca90992eed1).dist(a, b) / 4));
        const p4 = b;
        let pointLine;
        if (callback) {
            const curvePoints = this.getBezierPoints(p1, p2, p3, p4, 20);
            pointLine = new $4f238305bcccbc5b$export$8b36a4a83269a640({
                points: curvePoints
            });
        } else pointLine = new $4f238305bcccbc5b$export$8b36a4a83269a640({
            points: [
                p1,
                p4
            ]
        });
        //iterate over curve with spacing and callback
        const len = pointLine.getLength();
        let tempSpacing = (0, $4c2c6808296c0d73$export$2c9e8a9632a706b2)(this.lastSpacing, spacing, (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(this.lastDot / len, 0, 1));
        let d = this.lastDot;
        for(; d <= len; d += tempSpacing){
            tempSpacing = (0, $4c2c6808296c0d73$export$2c9e8a9632a706b2)(this.lastSpacing, spacing, (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(d / len, 0, 1));
            const point = pointLine.getAtDist(d);
            const angle = this.lastCallbackPoint ? (0, $4c2c6808296c0d73$export$c03a8450eabc2532)(this.lastCallbackPoint, point) : undefined;
            if (callback) callback({
                x: point.x,
                y: point.y,
                t: d / len,
                angle: angle,
                dAngle: this.lastCallbackPoint ? angle - this.lastAngle : 0
            });
            this.lastCallbackPoint = point;
            this.lastAngle = angle;
        }
        if (callback) this.lastDot = d - len;
        else {
            this.lastDot = 0;
            controlsCallback?.({
                p1: p1,
                p2: p2,
                p3: p3,
                p4: p4
            });
        }
        this.lastSpacing = spacing;
    }
    addFinal(spacing, callback, controlsCallback) {
        if (this.pointArr.length < 2) return;
        const p1 = this.pointArr.at(-2);
        const p2 = this.pointArr.at(-1);
        const newP = (0, $77055f1820134609$export$ac4bca90992eed1).add(p2, (0, $77055f1820134609$export$ac4bca90992eed1).sub(p2, p1));
        this.add(newP.x, newP.y, spacing, callback, controlsCallback);
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.lastDot = 0;
        this.pointArr = [];
    }
}
class $4f238305bcccbc5b$export$80967b1eb9fd6eb4 {
    // ---- interface ----
    getFirstX() {
        return this.first;
    }
    getLastX() {
        return this.last;
    }
    interpolate(x) {
        const n = this.ya.length;
        let klo = 0;
        let khi = n - 1;
        // We will find the right place in the table by means of
        // bisection. This is optimal if sequential calls to this
        // routine are at random values of x. If sequential calls
        // are in order, and closely spaced, one would do better
        // to store previous values of klo and khi.
        while(khi - klo > 1){
            const k = khi + klo >> 1;
            if (this.xa[k] > x) khi = k;
            else klo = k;
        }
        const h = this.xa[khi] - this.xa[klo];
        const a = (this.xa[khi] - x) / h;
        const b = (x - this.xa[klo]) / h;
        // Cubic spline polynomial is now evaluated.
        return a * this.ya[klo] + b * this.ya[khi] + ((a * a * a - a) * this.y2[klo] + (b * b * b - b) * this.y2[khi]) * (h * h) / 6.0;
    }
    /**
     * find x to y. simply by stepping through. suboptimal, so don't call often.
     * searches in x 0-1 range
     */ findX(y, resolution) {
        let x;
        let dist;
        for(let i = 0; i <= resolution; i++){
            const tempX = i / resolution;
            const tempY = this.interpolate(tempX);
            if (x === undefined) {
                x = tempX;
                dist = Math.abs(tempY - y);
                continue;
            }
            const tempDist = Math.abs(tempY - y);
            if (tempDist < dist) {
                x = tempX;
                dist = tempDist;
            } else break;
        }
        return x;
    }
    // ----------------------------------- public -----------------------------------
    constructor(points){
        const n = points.length;
        this.u = [];
        this.y2 = [];
        let i;
        this.first = points[0][0];
        this.last = points.at(-1)[0];
        points.sort(function(a, b) {
            return a[0] - b[0];
        });
        this.xa = points.map((point)=>point[0]);
        this.ya = points.map((point)=>point[1]);
        this.u[0] = 0;
        this.y2[0] = 0;
        for(i = 1; i < n - 1; ++i){
            // This is the decomposition loop of the tridiagonal algorithm.
            // y2 and u are used for temporary storage of the decomposed factors.
            const wx = this.xa[i + 1] - this.xa[i - 1];
            const sig = (this.xa[i] - this.xa[i - 1]) / wx;
            const p = sig * this.y2[i - 1] + 2.0;
            this.y2[i] = (sig - 1.0) / p;
            const ddydx = (this.ya[i + 1] - this.ya[i]) / (this.xa[i + 1] - this.xa[i]) - (this.ya[i] - this.ya[i - 1]) / (this.xa[i] - this.xa[i - 1]);
            this.u[i] = (6.0 * ddydx / wx - sig * this.u[i - 1]) / p;
        }
        this.y2[n - 1] = 0;
        // This is the backsubstitution loop of the tridiagonal algorithm
        for(i = n - 2; i >= 0; --i)this.y2[i] = this.y2[i] * this.y2[i + 1] + this.u[i];
    }
}
function $4f238305bcccbc5b$export$c07c3aaef9f2da42(startVal, endVal, stepSize, exponent = 2) {
    function round(v, dec) {
        return Math.round(v * 10 ** dec) / 10 ** dec;
    }
    const resultArr = [];
    for(let i = 0; i <= 1; i += stepSize)resultArr.push([
        round(i, 4),
        round(startVal + i ** exponent * (endVal - startVal), 4)
    ]);
    return resultArr;
}


// based on js color conversion http://www.webtoolkit.info/
class $26aafdad8ab873aa$export$d2edaecd208aed43 {
    constructor(h, s, v){
        this.h = Math.max(0, Math.min(360, h));
        this.s = Math.max(0.001, Math.min(100, s)); //bug when 0
        this.v = Math.max(0, Math.min(100, v));
    }
}
class $26aafdad8ab873aa$export$8f9ece5a47764b93 {
    constructor(r, g, b){
        this.r = Math.max(0, Math.min(255, r));
        this.g = Math.max(0, Math.min(255, g));
        this.b = Math.max(0, Math.min(255, b));
    }
}
class $26aafdad8ab873aa$export$89d3f85304bf0767 {
    constructor(c, m, y, k){
        this.c = Math.max(0, Math.min(100, c));
        this.m = Math.max(0, Math.min(100, m));
        this.y = Math.max(0, Math.min(100, y));
        this.k = Math.max(0, Math.min(100, k));
    }
}
const $26aafdad8ab873aa$export$fb7efcd2e153af6e = {
    _RGBtoHSV: function(RGB) {
        const result = new $26aafdad8ab873aa$export$d2edaecd208aed43(0, 0, 0);
        const r = RGB.r / 255;
        const g = RGB.g / 255;
        const b = RGB.b / 255;
        const minVal = Math.min(r, g, b);
        const maxVal = Math.max(r, g, b);
        const delta = maxVal - minVal;
        result.v = maxVal;
        if (delta === 0) {
            result.h = 0;
            result.s = 0;
        } else {
            result.s = delta / maxVal;
            const del_R = ((maxVal - r) / 6 + delta / 2) / delta;
            const del_G = ((maxVal - g) / 6 + delta / 2) / delta;
            const del_B = ((maxVal - b) / 6 + delta / 2) / delta;
            if (r === maxVal) result.h = del_B - del_G;
            else if (g === maxVal) result.h = 1 / 3 + del_R - del_B;
            else if (b === maxVal) result.h = 2 / 3 + del_G - del_R;
            if (result.h < 0) result.h += 1;
            if (result.h > 1) result.h -= 1;
        }
        result.h = Math.round(result.h * 360);
        result.s = Math.round(result.s * 100);
        result.v = Math.round(result.v * 100);
        return result;
    },
    _HSVtoRGB: function(HSV) {
        const result = new $26aafdad8ab873aa$export$8f9ece5a47764b93(0, 0, 0);
        let var_h, var_i, var_1, var_2, var_3, var_r, var_g, var_b;
        const h = HSV.h / 360 % 1;
        const s = HSV.s / 100;
        const v = HSV.v / 100;
        if (s === 0) {
            result.r = v * 255;
            result.g = v * 255;
            result.b = v * 255;
        } else {
            var_h = h * 6;
            var_i = Math.floor(var_h);
            var_1 = v * (1 - s);
            var_2 = v * (1 - s * (var_h - var_i));
            var_3 = v * (1 - s * (1 - (var_h - var_i)));
            if (var_i === 0) {
                var_r = v;
                var_g = var_3;
                var_b = var_1;
            } else if (var_i === 1) {
                var_r = var_2;
                var_g = v;
                var_b = var_1;
            } else if (var_i === 2) {
                var_r = var_1;
                var_g = v;
                var_b = var_3;
            } else if (var_i === 3) {
                var_r = var_1;
                var_g = var_2;
                var_b = v;
            } else if (var_i === 4) {
                var_r = var_3;
                var_g = var_1;
                var_b = v;
            } else {
                var_r = v;
                var_g = var_1;
                var_b = var_2;
            }
            result.r = var_r * 255;
            result.g = var_g * 255;
            result.b = var_b * 255;
            result.r = Math.round(result.r);
            result.g = Math.round(result.g);
            result.b = Math.round(result.b);
        }
        return result;
    },
    _CMYKtoRGB: function(CMYK) {
        const result = new $26aafdad8ab873aa$export$8f9ece5a47764b93(0, 0, 0);
        const c = CMYK.c / 100;
        const m = CMYK.m / 100;
        const y = CMYK.y / 100;
        const k = CMYK.k / 100;
        result.r = 1 - Math.min(1, c * (1 - k) + k);
        result.g = 1 - Math.min(1, m * (1 - k) + k);
        result.b = 1 - Math.min(1, y * (1 - k) + k);
        result.r = Math.round(result.r * 255);
        result.g = Math.round(result.g * 255);
        result.b = Math.round(result.b * 255);
        return result;
    },
    _RGBtoCMYK: function(RGB) {
        const result = new $26aafdad8ab873aa$export$89d3f85304bf0767(0, 0, 0, 0);
        const r = RGB.r / 255;
        const g = RGB.g / 255;
        const b = RGB.b / 255;
        result.k = Math.min(1 - r, 1 - g, 1 - b);
        result.c = (1 - r - result.k) / (1 - result.k);
        result.m = (1 - g - result.k) / (1 - result.k);
        result.y = (1 - b - result.k) / (1 - result.k);
        result.c = Math.round(result.c * 100);
        result.m = Math.round(result.m * 100);
        result.y = Math.round(result.y * 100);
        result.k = Math.round(result.k * 100);
        return result;
    },
    toRGB: function(o) {
        if (o instanceof $26aafdad8ab873aa$export$8f9ece5a47764b93) return o;
        if (o instanceof $26aafdad8ab873aa$export$d2edaecd208aed43) return this._HSVtoRGB(o);
        if (o instanceof $26aafdad8ab873aa$export$89d3f85304bf0767) return this._CMYKtoRGB(o);
        throw new Error('unknown type');
    },
    toHSV: function(o) {
        if (o instanceof $26aafdad8ab873aa$export$d2edaecd208aed43) return o;
        if (o instanceof $26aafdad8ab873aa$export$8f9ece5a47764b93) return this._RGBtoHSV(o);
        if (o instanceof $26aafdad8ab873aa$export$89d3f85304bf0767) return this._RGBtoHSV(this._CMYKtoRGB(o));
        throw new Error('unknown type');
    },
    toCMYK: function(o) {
        if (o instanceof $26aafdad8ab873aa$export$89d3f85304bf0767) return o;
        if (o instanceof $26aafdad8ab873aa$export$8f9ece5a47764b93) return this._RGBtoCMYK(o);
        if (o instanceof $26aafdad8ab873aa$export$d2edaecd208aed43) return this._RGBtoCMYK(this._HSVtoRGB(o));
        throw new Error('unknown type');
    },
    toHexString: function(o) {
        if (o instanceof $26aafdad8ab873aa$export$8f9ece5a47764b93 || 'r' in o && 'g' in o && 'b' in o) {
            let ha = parseInt('' + o.r).toString(16);
            let hb = parseInt('' + o.g).toString(16);
            let hc = parseInt('' + o.b).toString(16);
            if (ha.length === 1) ha = '0' + ha;
            if (hb.length === 1) hb = '0' + hb;
            if (hc.length === 1) hc = '0' + hc;
            return ha + hb + hc;
        }
        return '#000';
    },
    toRgbStr: function(rgbObj) {
        return 'rgb(' + Math.round(rgbObj.r) + ', ' + Math.round(rgbObj.g) + ', ' + Math.round(rgbObj.b) + ')';
    },
    toRgbaStr: function(rgbaObj) {
        return 'rgba(' + Math.round(rgbaObj.r) + ', ' + Math.round(rgbaObj.g) + ', ' + Math.round(rgbaObj.b) + ', ' + rgbaObj.a + ')';
    },
    hexToRGB: function(hexStr) {
        hexStr = hexStr.trim();
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hexStr = hexStr.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexStr);
        return result ? new $26aafdad8ab873aa$export$8f9ece5a47764b93(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)) : undefined;
    }
};
function $26aafdad8ab873aa$export$5cf396345d1238ae(rgbObj) {
    return rgbObj.r * 0.299 + rgbObj.g * 0.587 + rgbObj.b * 0.114 < 125;
}




function $9e4d66c06c67fa7f$export$7868464f598ba79d(target, text) {
    const div = document.createElement('div');
    div.innerHTML = text;
    target.append(div);
    return div;
}
const $9e4d66c06c67fa7f$export$e11d0f35da1b29a3 = 'kl-focusable-element';
function $9e4d66c06c67fa7f$export$906dfdb7df31ccfc(getAll = false) {
    const activeElement = document.activeElement;
    const result = !!activeElement && ([
        'INPUT',
        'TEXTAREA',
        'SELECT'
    ].includes(activeElement.tagName) || activeElement.tagName === 'BUTTON' && activeElement.classList.contains($9e4d66c06c67fa7f$export$e11d0f35da1b29a3));
    return result && (getAll || !activeElement?.getAttribute('data-ignore-focus'));
}
function $9e4d66c06c67fa7f$export$e05240ca9e0b8bd9() {
    if ($9e4d66c06c67fa7f$export$906dfdb7df31ccfc(true)) {
        /*
            Unfocus anything that is focused.

            If an Input is focused in Firefox, and it gets detached from the DOM via a Node
            that isn't its direct parent, then Firefox will keep anything attached to this
            Input in memory. It will not be garbage collected until a new Input is focused.

            Workaround: Temporarily create an input, focus it, detach it.
             */ const focusEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: document.body,
            tagName: 'input',
            css: {
                opacity: 0,
                width: 0,
                height: 0
            }
        });
        setTimeout(()=>{
            focusEl.select();
            focusEl.focus();
            focusEl.remove();
        }, 10);
    }
}
function $9e4d66c06c67fa7f$export$a3d02541b0ebf605() {
    if (window.getSelection) {
        const sel = window.getSelection();
        if (sel) {
            if (sel.empty) sel.empty();
            else if (sel.removeAllRanges) sel.removeAllRanges();
        }
    }
}
function $9e4d66c06c67fa7f$export$c3da0dad1b44eea9(params) {
    if (!params) return document.createElement('div');
    const result = document.createElement(params.tagName ? params.tagName : 'div');
    params.css && (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(result, params.css);
    if (params.content) {
        if (typeof params.content === "string") result.innerHTML = params.content;
        else if (Array.isArray(params.content)) (0, $be957da3610487e9$export$921068d8846a1559).append(result, params.content);
        else result.append(params.content);
    }
    if (params.textContent) result.textContent = params.textContent;
    if (params.className) result.className = Array.isArray(params.className) ? params.className.join(' ') : params.className;
    if (params.id) result.id = params.id;
    if (params.parent) params.parent.append(result);
    if ('title' in params && params.title !== undefined) result.title = params.title;
    if (params.onClick) {
        const onClick = params.onClick;
        result.addEventListener('click', onClick);
        params.destroyer?.add(()=>result.removeEventListener('click', onClick));
    }
    if (params.onChange) {
        const onChange = params.onChange;
        result.addEventListener('change', onChange);
        params.destroyer?.add(()=>result.removeEventListener('change', onChange));
    }
    if (params.props) Object.assign(result, // filter out undefined, to avoid things like title = "undefined"
    Object.fromEntries(Object.entries(params.props).filter(([, value])=>value !== undefined)));
    return result;
}
function $9e4d66c06c67fa7f$export$ec664d7487540b(p) {
    const result = new Image();
    if (p.src !== undefined) result.src = p.src;
    if (p.alt !== undefined) result.alt = p.alt;
    if (p.width !== undefined) result.width = p.width;
    if (p.height !== undefined) result.height = p.height;
    if (p.className !== undefined) result.className = p.className;
    p.css && (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(result, p.css);
    return result;
}
function $9e4d66c06c67fa7f$export$a1d71d17ef0b64b3(imageUrl, styleObj) {
    const result = document.createElement('div');
    const mask = `url("${imageUrl}") center / contain no-repeat`;
    result.style.setProperty('mask', mask);
    result.style.setProperty('-webkit-mask', mask);
    result.setAttribute('aria-hidden', 'true');
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(result, {
        display: 'inline-block',
        width: '1em',
        height: '1em',
        backgroundColor: 'currentColor',
        ...styleObj
    });
    return result;
}




var $79I2S = parcelRequire("79I2S");
/**
 * LocalStorage wrapper that does not throw exceptions.
 * If cookies disabled in Safari localStorage interactions throw exception "insecure operation"
 */ class $7a8f101d3676d17a$export$19fffca37ef3e106 {
    static getItem(key) {
        let result = null;
        try {
            result = localStorage.getItem(key);
        } catch (e) {
            this.error = e;
        }
        return result;
    }
    static setItem(key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            this.error = e;
        }
    }
    static removeItem(key) {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            this.error = e;
        }
    }
    static getError() {
        return this.error;
    }
}



class $403644a346975e30$export$fe11e0afe623a677 {
    // ----------------------------------- public -----------------------------------
    setChainOut(func) {
        this.chainOut = func;
    }
    chainIn(event) {
        if (event.type === 'pointermove') {
            if (event.coalescedArr && event.coalescedArr.length > 0) for(let i = 0; i < event.coalescedArr.length; i++){
                const eventCopy = (0, $94f0b2b810d4d191$export$af0d87255f3cfd7e)(event);
                if (i === 0) eventCopy.coalescedArr = [];
                const coalescedItem = event.coalescedArr[i];
                eventCopy.pageX = coalescedItem.pageX;
                eventCopy.pageY = coalescedItem.pageY;
                eventCopy.relX = coalescedItem.relX;
                eventCopy.relY = coalescedItem.relY;
                eventCopy.dX = coalescedItem.dX;
                eventCopy.dY = coalescedItem.dY;
                eventCopy.time = coalescedItem.time;
                eventCopy.isCoalesced = i < event.coalescedArr.length - 1;
                this.chainOut && this.chainOut(eventCopy);
            }
            else return event;
        } else return event;
        return null;
    }
}



class $b4f1cdee8f932fed$export$510622b8aed00381 {
    failGesture() {
        if (this.eventQueueArr.length === 0) return;
        this.timeoutObj.firstLastDownTimeout && clearTimeout(this.timeoutObj.firstLastDownTimeout);
        this.timeoutObj.tapTimeout && clearTimeout(this.timeoutObj.tapTimeout);
        for(let i = 0; i < this.eventQueueArr.length; i++)this.chainOut && this.chainOut(this.eventQueueArr[i]);
        this.eventQueueArr = [];
        this.fingerArr = [];
    }
    success() {
        this.timeoutObj.firstLastDownTimeout && clearTimeout(this.timeoutObj.firstLastDownTimeout);
        this.timeoutObj.tapTimeout && clearTimeout(this.timeoutObj.tapTimeout);
        this.eventQueueArr = []; // events get swallowed
        this.fingerArr = [];
        this.onTap();
    }
    setupTimeout(timeoutStr, timeMS) {
        const diff = timeMS - this.nowTime;
        //console.log(fingers + ': ' + timeoutStr + ' diff', diff);
        if (diff <= 0) // time already up
        return false;
        this.timeoutObj[timeoutStr] = setTimeout(()=>this.failGesture(), diff);
        return true;
    }
    processEvent(event) {
        const tempLastEventTime = this.lastEventTime;
        this.lastEventTime = event.time;
        if (event.type === 'pointerdown') this.pointersDownIdArr.push(event.pointerId);
        else if (event.type === 'pointerup') {
            for(let i = 0; i < this.pointersDownIdArr.length; i++)if (this.pointersDownIdArr[i] === event.pointerId) {
                this.pointersDownIdArr.splice(i, 1);
                break;
            }
        }
        if (event.pointerType !== 'touch') {
            if (this.fingerArr.length > 0) // already in gesture -> fail
            this.failGesture();
            return;
        }
        this.nowTime = performance.now();
        if (event.type === 'pointerdown') {
            //console.log('down');
            if (this.fingerArr.length + 1 !== this.pointersDownIdArr.length) {
                // failed before, and some fingers are still down -> fail
                this.failGesture();
                return;
            }
            if (this.fingerArr.length === this.fingers) {
                // too many fingers down -> fail
                //console.log(fingers + ': too many fingers down -> fail');
                this.failGesture();
                return;
            }
            if (this.fingerArr.length > 0 && event.time - this.maxFirstLastFingerDownMs > this.fingerArr[0].downTimeMs) {
                // took too long to touch with all fingers -> fail
                //console.log(fingers + ': took too long to touch with all fingers -> fail');
                this.failGesture();
                return;
            }
            if (this.fingerArr.length === 0 && event.time - this.minSilenceBeforeDurationMs < tempLastEventTime) {
                // not enough silence before -> fail
                //console.log(fingers + ': not enough silence before -> fail');
                this.failGesture();
                return;
            }
            if (this.fingerArr.length === 0) {
                this.firstDownTime = event.time;
                if (!this.setupTimeout('firstLastDownTimeout', event.time + this.maxFirstLastFingerDownMs) || !this.setupTimeout('tapTimeout', event.time + this.maxTapMs)) {
                    // timeouts already up -> fail
                    this.failGesture();
                    return;
                }
            }
            this.fingerArr.push({
                pointerId: event.pointerId,
                downTimeMs: event.time,
                downPageX: event.pageX,
                downPageY: event.pageY
            });
            return;
        }
        if (event.type === 'pointermove') {
            if (this.fingerArr.length === 0) //not in a gesture -> ignore
            return;
            let fingerObj = null;
            for(let i = 0; i < this.fingerArr.length; i++)if (this.fingerArr[i].pointerId === event.pointerId) {
                fingerObj = this.fingerArr[i];
                break;
            }
            if (fingerObj === null) {
                // finger not part of the tap is on screen -> fail
                this.failGesture();
                return;
            }
            if (event.time - this.maxTapMs > this.firstDownTime) {
                // tap took too long -> fail
                //console.log(fingers + ': tap took too long -> fail');
                this.failGesture();
                return;
            }
            const distance = (0, $4c2c6808296c0d73$export$6c4a311cc157c764)(event.pageX, event.pageY, fingerObj.downPageX, fingerObj.downPageY);
            if (distance > this.maxPressedDistancePx) {
                // finger moved too much -> fail
                //console.log(fingers + ': a finger moved too much -> fail', distance);
                this.failGesture();
                return;
            }
        }
        if (event.type === 'pointerup') {
            if (this.fingerArr.length === 0) //not in a gesture -> ignore
            return;
            //console.log('up', event.pageX, event.pageY);
            if (this.fingerArr.length !== this.fingers) {
                // not enough fingers -> fail
                //console.log(fingers + ': not enough fingers -> fail');
                this.failGesture();
                return;
            }
            let fingerObj = null;
            let i = 0;
            for(; i < this.fingerArr.length; i++)if (this.fingerArr[i].pointerId === event.pointerId) {
                fingerObj = this.fingerArr[i];
                break;
            }
            if (fingerObj === null) //do nothing
            return;
            if (event.time - this.maxTapMs > this.firstDownTime) {
                // tap took too long -> fail
                //console.log(fingers + ': tap took too long -> fail');
                this.failGesture();
                return;
            }
            const distance = (0, $4c2c6808296c0d73$export$6c4a311cc157c764)(event.pageX, event.pageY, fingerObj.downPageX, fingerObj.downPageY);
            if (distance > this.maxPressedDistancePx) {
                // finger moved too much -> fail
                //console.log(fingers + ': b finger moved too much -> fail', distance, event.pageX, event.pageY);
                //console.log(fingerArr);
                this.failGesture();
                return;
            }
            fingerObj.isUp = true;
            let allAreUp = true;
            for(let i = 0; i < this.fingerArr.length; i++)if (!this.fingerArr[i].isUp) {
                allAreUp = false;
                break;
            }
            //console.log('fingerArr', fingerArr);
            if (allAreUp) {
                // success
                this.success();
                return true;
            }
        }
    }
    chainIn(event) {
        const result = this.processEvent(event);
        //console.log(fingerArr.length);
        if (result === true) //tap success -> event gets swallowed
        return null;
        if (this.fingerArr.length === 0) return event;
        else this.eventQueueArr.push(event);
        return null;
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.minSilenceBeforeDurationMs = 50;
        this.maxTapMs = 500;
        this.maxFirstLastFingerDownMs = 250;
        this.maxPressedDistancePx = 12 //5 + fingers * 5;
        ;
        this.fingerArr = [];
        this.eventQueueArr = [];
        this.firstDownTime = 0;
        this.lastEventTime = 0;
        this.nowTime = performance.now();
        this.pointersDownIdArr = [];
        this.timeoutObj = {
            firstLastDownTimeout: null,
            tapTimeout: null
        };
        this.fingers = p.fingers;
        this.onTap = p.onTap;
    }
}



class $84eb4aaf6ec9742b$export$d62358ac2d82abb3 {
    end() {
        this.gestureObj = null;
        this.eventQueueArr = [];
    }
    fail(doSwallow) {
        if (!this.gestureObj) // no gesture happening -> ignore
        return;
        this.timeoutObj.secondFingerTimeout && clearTimeout(this.timeoutObj.secondFingerTimeout);
        if (!doSwallow) for(let i = 0; i < this.eventQueueArr.length; i++)this.chainOut && this.chainOut(this.eventQueueArr[i]);
        this.end();
    }
    setupFailTimeout(timeMS) {
        const diff = timeMS - this.nowTime;
        if (diff <= 0) // time already up
        return false;
        this.timeoutObj.secondFingerTimeout = setTimeout(()=>this.fail(), diff);
        return true;
    }
    processEvent(event) {
        if (event.type === 'pointerdown') this.pointersDownIdArr.push(event.pointerId);
        else if (event.type === 'pointerup') {
            for(let i = 0; i < this.pointersDownIdArr.length; i++)if (this.pointersDownIdArr[i] === event.pointerId) {
                this.pointersDownIdArr.splice(i, 1);
                break;
            }
        }
        //pass through scenarios
        if (!this.gestureObj && (event.pointerType !== 'touch' || // wrong pointer type
        event.type === 'pointermove' && this.pointersDownIdArr.length > 0 || // failed before
        this.pointersDownIdArr.length > 1 || // failed before
        event.type === 'pointerup' // failed before
        )) return;
        this.nowTime = performance.now();
        //pointer down
        if (event.type === 'pointerdown') {
            if (this.gestureObj) {
                if (event.pointerType === 'touch') {
                    // touch finger down - as nth pointer
                    this.gestureObj.touchPointerArr.push({
                        pointerId: event.pointerId,
                        relX: event.relX,
                        relY: event.relY
                    });
                    if (this.gestureObj.isInProgress) this.continuePinch(this.gestureObj, {
                        type: 'down',
                        index: this.gestureObj.touchPointerArr.length - 1
                    });
                    else {
                        this.timeoutObj.secondFingerTimeout && clearTimeout(this.timeoutObj.secondFingerTimeout);
                        this.gestureObj.isInProgress = true;
                        this.beginPinch(this.gestureObj);
                    }
                    return;
                } else {
                    // non-touch finger down - as nth pointer
                    if (this.gestureObj.isInProgress) this.gestureObj.otherPointerIdArr.push(event.pointerId);
                    else // second pointer wrong type -> fail
                    this.fail();
                    return;
                }
            } else {
                // first finger down - can only be touch if no gestureObj
                this.gestureObj = {
                    touchPointerArr: [
                        {
                            pointerId: event.pointerId,
                            relX: event.relX,
                            relY: event.relY,
                            downRelX: event.relX,
                            downRelY: event.relY
                        }
                    ],
                    otherPointerIdArr: [],
                    isInProgress: false
                };
                if (!this.setupFailTimeout(event.time + this.untilSecondFingerDurationMs)) {
                    // time ran out -> fail
                    this.fail();
                    return;
                }
                return;
            }
        }
        // should not happen. something went wrong
        if (!this.gestureObj) {
            // throw? would make it less robust
            this.fail();
            return;
        }
        //pointer move
        if (event.type === 'pointermove' && event.pointerType === 'touch') {
            //gesture object should always exist here
            let touchPointerObj = null;
            let i = 0;
            for(; i < this.gestureObj.touchPointerArr.length; i++)if (event.pointerId === this.gestureObj.touchPointerArr[i].pointerId) {
                touchPointerObj = this.gestureObj.touchPointerArr[i];
                break;
            }
            //null should not be possible. something went wrong
            if (!touchPointerObj) {
                // throw? would make it less robust
                this.fail();
                return;
            }
            touchPointerObj.relX = event.relX;
            touchPointerObj.relY = event.relY;
            if (!this.gestureObj.isInProgress) {
                // only one finger down & pinching hasn't started
                // should not happen. something went wrong
                if (!('downRelX' in touchPointerObj && touchPointerObj.downRelX !== undefined) || !('downRelY' in touchPointerObj && touchPointerObj.downRelY !== undefined)) {
                    this.fail();
                    return;
                }
                const distance = (0, $4c2c6808296c0d73$export$6c4a311cc157c764)(touchPointerObj.downRelX, touchPointerObj.downRelY, touchPointerObj.relX, touchPointerObj.relY);
                if (distance > this.firstFingerMaxDistancePx) {
                    // moved too much -> fail
                    this.fail();
                    return;
                }
            } else if (i < 2) // only first two touches can affect pinching
            this.continuePinch(this.gestureObj, {
                type: 'move',
                index: i
            });
            return;
        }
        //pointer up
        if (event.type === 'pointerup') {
            //gesture object should always exist here
            if (event.pointerType === 'touch') {
                let i = 0;
                for(; i < this.gestureObj.touchPointerArr.length; i++)if (this.gestureObj.touchPointerArr[i].pointerId === event.pointerId) {
                    this.gestureObj.touchPointerArr.splice(i, 1);
                    break;
                }
                if (this.gestureObj.touchPointerArr.length > 0) this.continuePinch(this.gestureObj, {
                    type: 'up',
                    index: i
                });
            } else {
                // non-touch
                for(let i = 0; i < this.gestureObj.otherPointerIdArr.length; i++)if (this.gestureObj.otherPointerIdArr[i] === event.pointerId) {
                    this.gestureObj.otherPointerIdArr.splice(i, 1);
                    break;
                }
            }
            //all fingers lifted?
            if (this.gestureObj.touchPointerArr.length === 0 && this.gestureObj.otherPointerIdArr.length === 0) {
                if (this.gestureObj.isInProgress) {
                    // lifted last finger -> end of pinching
                    this.end();
                    this.endPinch();
                } else // lifted finger again before pinching started -> fail
                this.fail();
                return;
            }
        }
    }
    beginPinch(gestureObj) {
        for(let i = 0; i < gestureObj.touchPointerArr.length; i++){
            const pointerObj = gestureObj.touchPointerArr[i];
            this.pincherArr.push({
                pointerId: pointerObj.pointerId,
                relX: pointerObj.relX,
                relY: pointerObj.relY,
                downRelX: pointerObj.relX,
                downRelY: pointerObj.relY
            });
        }
        const event = {
            type: 'move',
            // temp
            downRelX: 0,
            downRelY: 0,
            relX: 0,
            relY: 0,
            angleRad: 0,
            scale: 1
        };
        if (this.pincherArr.length === 1) {
            event.relX = this.pincherArr[0].downRelX;
            event.relY = this.pincherArr[0].downRelY;
        } else {
            event.relX = 0.5 * (this.pincherArr[0].downRelX + this.pincherArr[1].downRelX);
            event.relY = 0.5 * (this.pincherArr[0].downRelY + this.pincherArr[1].downRelY);
        }
        event.downRelX = event.relX;
        event.downRelY = event.relY;
        this.onPinch(event);
    }
    //actionObj = {type: 'down'|'move'|'up', index: number}
    continuePinch(gestureObj, actionObj) {
        if (actionObj.index > 1) // only first two pointers matter
        return;
        if (actionObj.type === 'move') {
            let event;
            this.pincherArr[actionObj.index].relX = gestureObj.touchPointerArr[actionObj.index].relX;
            this.pincherArr[actionObj.index].relY = gestureObj.touchPointerArr[actionObj.index].relY;
            if (this.pincherArr.length === 1) event = {
                type: 'move',
                downRelX: this.pincherArr[0].downRelX,
                downRelY: this.pincherArr[0].downRelY,
                relX: this.pincherArr[0].relX,
                relY: this.pincherArr[0].relY,
                angleRad: 0,
                scale: 1
            };
            else {
                const startDist = (0, $4c2c6808296c0d73$export$6c4a311cc157c764)(this.pincherArr[0].downRelX, this.pincherArr[0].downRelY, this.pincherArr[1].downRelX, this.pincherArr[1].downRelY);
                const distance = (0, $4c2c6808296c0d73$export$6c4a311cc157c764)(this.pincherArr[0].relX, this.pincherArr[0].relY, this.pincherArr[1].relX, this.pincherArr[1].relY);
                const startAngle = (0, $4c2c6808296c0d73$export$627023b405ba5028)({
                    x: this.pincherArr[0].downRelX,
                    y: this.pincherArr[0].downRelY
                }, {
                    x: this.pincherArr[1].downRelX,
                    y: this.pincherArr[1].downRelY
                });
                const angle = (0, $4c2c6808296c0d73$export$627023b405ba5028)({
                    x: this.pincherArr[0].relX,
                    y: this.pincherArr[0].relY
                }, {
                    x: this.pincherArr[1].relX,
                    y: this.pincherArr[1].relY
                });
                event = {
                    type: 'move',
                    downRelX: 0.5 * (this.pincherArr[0].downRelX + this.pincherArr[1].downRelX),
                    downRelY: 0.5 * (this.pincherArr[0].downRelY + this.pincherArr[1].downRelY),
                    relX: 0.5 * (this.pincherArr[0].relX + this.pincherArr[1].relX),
                    relY: 0.5 * (this.pincherArr[0].relY + this.pincherArr[1].relY),
                    angleRad: angle - startAngle,
                    scale: distance / startDist
                };
            }
            this.onPinch(event);
        } else if (actionObj.type === 'down' || actionObj.type === 'up') {
            this.endPinch();
            this.beginPinch(gestureObj);
        }
    }
    endPinch() {
        this.pincherArr = [];
        this.onPinch({
            type: 'end'
        });
    }
    chainIn(event) {
        this.processEvent(event);
        if (this.gestureObj) {
            if (!this.gestureObj.isInProgress) // might still fail -> into queue
            this.eventQueueArr.push(event);
        } else return event;
        return null;
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.firstFingerMaxDistancePx = 10;
        this.untilSecondFingerDurationMs = 250;
        this.pointersDownIdArr = [];
        this.gestureObj = null;
        this.eventQueueArr = [];
        this.nowTime = performance.now();
        this.timeoutObj = {
            secondFingerTimeout: null
        };
        this.pincherArr = [];
        this.onPinch = p.onPinch;
    }
}



class $c61fdfd84bc32c60$export$db3963a21c01d803 {
    // double tap achieved
    success() {
        this.timeoutObj.fail = null;
        this.timeoutObj.success = null;
        this.eventQueueArr = []; // events get swallowed
        const lastSequenceItem = this.sequenceArr.at(-1);
        this.sequenceArr = [];
        if ('pageX' in lastSequenceItem) this.onDoubleTap({
            pageX: lastSequenceItem.pageX,
            pageY: lastSequenceItem.pageY,
            relX: lastSequenceItem.relX,
            relY: lastSequenceItem.relY
        });
    }
    // returns false if time already up. otherwise sets up timeout
    setupTimeout(timeoutStr, targetFunc, timeMS, noComparison) {
        const diff = timeMS - this.nowTime;
        // console.log(fingers + ': ' + timeoutStr + ' diff', diff);
        if (diff <= 0 && !noComparison) // time already up
        return false;
        this.timeoutObj[timeoutStr] = setTimeout(targetFunc, Math.max(0, diff));
        return true;
    }
    /**
     * @param event object - a pointer event from BB.PointerListener
     */ processEvent(event) {
        if (event.type === 'pointerdown') this.pointersDownIdArr.push(event.pointerId);
        else if (event.type === 'pointerup') {
            for(let i = 0; i < this.pointersDownIdArr.length; i++)if (this.pointersDownIdArr[i] === event.pointerId) {
                this.pointersDownIdArr.splice(i, 1);
                break;
            }
        }
        if (!this.allowedPointerTypeArr.includes(event.pointerType)) {
            //wrong input type -> fail
            //console.log('wrong input type -> fail');
            this.gestureFailed();
            return;
        }
        this.nowTime = performance.now();
        const lastSequenceItem = this.sequenceArr.at(-1) ?? null;
        if (event.type === 'pointerup') this.lastUpTime = event.time;
        if (event.type === 'pointerdown') {
            if (this.pointersDownIdArr.length > 1) {
                // more than one pointer down -> fail
                //console.log('more than one pointer down -> fail');
                this.gestureFailed();
                return;
            }
            if (this.timeoutObj.success !== null) {
                // silence-after not achieved -> fail
                //console.log('silence-after not achieved -> fail');
                this.gestureFailed();
                return;
            }
            if (this.sequenceArr.length === 0 && this.nowTime - this.lastUpTime < this.minSilenceBeforeDurationMs) {
                // silence before not achieved -> fail
                //console.log('silence before not achieved -> fail');
                this.gestureFailed();
                return;
            }
            if (event.button && !this.allowedButtonArr.includes(event.button)) {
                // wrong button -> fail
                //console.log('wrong button -> fail', event.button, allowedButtonArr);
                this.gestureFailed();
                return;
            }
            if (lastSequenceItem && 'isDown' in lastSequenceItem && lastSequenceItem.isDown || this.sequenceArr.length > 2) {
                // jumbled -> fail
                //console.log('jumbled -> fail');
                this.gestureFailed();
                return;
            }
            if (lastSequenceItem && 'position' in lastSequenceItem) {
                const distance = (0, $4c2c6808296c0d73$export$6c4a311cc157c764)(lastSequenceItem.position[0], lastSequenceItem.position[1], event.pageX, event.pageY);
                if (distance > this.maxInbetweenDistancePx) {
                    //moved too much -> reset
                    //console.log('maxInbetweenDistancePx -> reset');
                    this.gestureFailed();
                    if ('time' in lastSequenceItem && this.nowTime - lastSequenceItem.time < this.minSilenceBeforeDurationMs) //silence before not achieved -> fail
                    return;
                }
            }
            this.sequenceArr.push({
                isDown: true,
                time: this.nowTime,
                position: [
                    event.pageX,
                    event.pageY
                ],
                pointerId: event.pointerId
            });
            //maxUntilSecondDown
            if (this.sequenceArr.length > 1) this.timeoutObj.maxUntilSecondDown && clearTimeout(this.timeoutObj.maxUntilSecondDown);
            else if (!this.setupTimeout('maxUntilSecondDown', ()=>this.gestureFailed(), event.time + this.maxUntilSecondDownDurationMs)) {
                //console.log('event.time + maxPressedDurationMs -> fail');
                this.gestureFailed();
                return;
            }
            this.timeoutObj.fail && clearTimeout(this.timeoutObj.fail);
            if (!this.setupTimeout('fail', ()=>this.gestureFailed(), event.time + this.maxPressedDurationMs)) {
                //console.log('event.time + maxPressedDurationMs -> fail');
                this.gestureFailed();
                return;
            }
        }
        if (lastSequenceItem && event.type === 'pointermove' && 'pointerId' in lastSequenceItem && lastSequenceItem.pointerId === event.pointerId) {
            /*if (lastSequenceItem.pointerId !== event.pointerId) { //another pointer mixing in -> fail
                console.log('another pointer mixing in -> fail');
                this.fail();
                return;
            }*/ const distance = (0, $4c2c6808296c0d73$export$6c4a311cc157c764)(lastSequenceItem.position[0], lastSequenceItem.position[1], event.pageX, event.pageY);
            if (distance > this.maxPressedDistancePx) {
                //moved too much -> fail
                //console.log('maxPressedDistancePx -> fail');
                this.gestureFailed();
                return;
            }
        }
        if (lastSequenceItem && event.type === 'pointerup') {
            if ('pointerId' in lastSequenceItem && lastSequenceItem.pointerId !== event.pointerId) {
                //another pointer mixing in -> fail
                this.gestureFailed();
                return;
            }
            if ('time' in lastSequenceItem && this.nowTime >= lastSequenceItem.time + this.maxPressedDurationMs) {
                //pressed too long -> fail
                this.gestureFailed();
                return;
            }
            this.timeoutObj.fail && clearTimeout(this.timeoutObj.fail);
            if (this.sequenceArr.length < 3) {
                if (!this.setupTimeout('fail', ()=>this.gestureFailed(), event.time + this.maxUpToUpDurationMs)) {
                    this.gestureFailed();
                    return;
                }
                this.sequenceArr = [
                    lastSequenceItem,
                    {
                        isUp: true,
                        time: this.nowTime,
                        position: [
                            event.pageX,
                            event.pageY
                        ]
                    }
                ];
                return;
            }
            if ('time' in this.sequenceArr[1] && this.nowTime < this.sequenceArr[1].time + this.maxUpToUpDurationMs) {
                // double tap almost success
                // only needs silence
                this.sequenceArr.push({
                    pageX: event.pageX,
                    pageY: event.pageY,
                    relX: event.relX,
                    relY: event.relY
                });
                if (!this.setupTimeout('success', ()=>this.success(), event.time + this.minSilenceAfterMs, true)) this.gestureFailed();
            } else // time up -> fail
            this.gestureFailed();
        }
    }
    chainIn(event) {
        this.processEvent(event);
        if (this.sequenceArr.length === 0) {
            //existing events can not become a double tap
            this.gestureFailed();
            return event;
        }
        // events might become a double tap -> queue
        this.eventQueueArr.push(event);
        return null;
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    setAllowedPointerTypeArr(arr) {
        this.allowedPointerTypeArr = [
            ...arr
        ];
    }
    setAllowedButtonArr(arr) {
        this.allowedButtonArr = [
            ...arr
        ];
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.allowedPointerTypeArr = [
            'touch',
            'mouse',
            'pen'
        ];
        this.allowedButtonArr = [
            'left'
        ];
        this.minSilenceBeforeDurationMs = 400;
        this.maxPressedDurationMs = 300;
        this.maxPressedDistancePx = 10;
        this.maxInbetweenDistancePx = 19;
        this.maxUpToUpDurationMs = 500;
        this.maxUntilSecondDownDurationMs = 300;
        this.minSilenceAfterMs = 250;
        this.sequenceArr = [];
        this.pointersDownIdArr = [];
        this.lastUpTime = 0;
        this.nowTime = 0;
        this.eventQueueArr = [];
        this.timeoutObj = {
            fail: null,
            maxUntilSecondDown: null,
            success: null
        };
        this.onDoubleTap = p.onDoubleTap;
        if (p.isInstant) {
            this.minSilenceBeforeDurationMs = 0;
            this.minSilenceAfterMs = 0;
        }
        this.gestureFailed = ()=>{
            if (this.sequenceArr.length === 0) // no gesture started -> can be ignored
            return;
            this.timeoutObj.fail && clearTimeout(this.timeoutObj.fail);
            this.timeoutObj.maxUntilSecondDown && clearTimeout(this.timeoutObj.maxUntilSecondDown);
            this.timeoutObj.success && clearTimeout(this.timeoutObj.success);
            this.timeoutObj.fail = null;
            this.timeoutObj.maxUntilSecondDown = null;
            this.timeoutObj.success = null;
            if (this.chainOut) for(let i = 0; i < this.eventQueueArr.length; i++)this.chainOut(this.eventQueueArr[i]);
            this.eventQueueArr = [];
            this.sequenceArr = [];
        };
    }
}


class $61093ea2660d4547$export$71ff2f51bf1f4062 {
    // ----------------------------------- public -----------------------------------
    chainIn(event) {
        if (this.ignorePointerIdArr.includes(event.pointerId)) {
            if (event.type === 'pointerup') {
                for(let i = 0; i < this.ignorePointerIdArr.length; i++)if (this.ignorePointerIdArr[i] === event.pointerId) {
                    this.ignorePointerIdArr.splice(i, 1);
                    break;
                }
            }
            return null;
        }
        if (this.downPointerId === null) {
            if (event.type === 'pointerdown') this.downPointerId = event.pointerId;
            return event;
        } else {
            if (event.pointerId !== this.downPointerId) {
                if (event.type === 'pointerdown') this.ignorePointerIdArr.push(event.pointerId);
                return null;
            }
            if (event.type === 'pointerup') this.downPointerId = null;
            return event;
        }
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    constructor(){
        this.downPointerId = null;
        this.ignorePointerIdArr = [];
    }
}


class $29dd970aa1f95ac5$export$649a211db9812745 {
    continueChain(i, event) {
        for(; i < this.chainArr.length; i++){
            event = this.chainArr[i].chainIn(event);
            if (event === null) return null;
        }
        this.chainOut && this.chainOut(event);
        return null;
    }
    /**
     * feed an event into the chain
     */ chainIn(event) {
        return this.continueChain(0, event);
    }
    /**
     * func will be called when event has passed through the chain
     */ setChainOut(func) {
        this.chainOut = func;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.chainArr = p.chainArr;
        for(let i = 0; i < this.chainArr.length; i++)((i)=>{
            this.chainArr[i].setChainOut((event)=>{
                this.continueChain(i + 1, event);
            });
        })(i);
    }
}


const $be957da3610487e9$export$921068d8846a1559 = {
    // ---- browser ----
    eventUsesHighResTimeStamp: (0, $25e38424550c7e3f$export$69accc8c74894f83),
    hasPointerEvents: (0, $25e38424550c7e3f$export$7728c852ca75bb6d),
    canShareFiles: (0, $25e38424550c7e3f$export$558f5e20caee48c2),
    insertAfter: // ---- base ----
    $94f0b2b810d4d191$export$c4f94c8b3850a5a9,
    setAttributes: $94f0b2b810d4d191$export$74da2cba014bdc09,
    append: $94f0b2b810d4d191$export$10d8903dec122b9d,
    fitInto: $94f0b2b810d4d191$export$fa55905620c22535,
    centerWithin: $94f0b2b810d4d191$export$76d0c1a172b67a61,
    gcd: $94f0b2b810d4d191$export$f81847884871263e,
    reduce: $94f0b2b810d4d191$export$533b26079ad0b4b,
    decToFraction: $94f0b2b810d4d191$export$8215e6b900906daa,
    dateDayDifference: $94f0b2b810d4d191$export$1093707c159148e8,
    copyObj: $94f0b2b810d4d191$export$af0d87255f3cfd7e,
    shareCanvas: $94f0b2b810d4d191$export$331c30fd60da0115,
    handleClick: $94f0b2b810d4d191$export$b981489921ee18cd,
    createSvg: $94f0b2b810d4d191$export$c54fe3b9ecaa84cf,
    LocalStorage: $7a8f101d3676d17a$export$19fffca37ef3e106,
    throwIfNull: $94f0b2b810d4d191$export$b813e062795b89b5,
    nullToUndefined: $94f0b2b810d4d191$export$d802c22d109d9806,
    isDark: $94f0b2b810d4d191$export$a79ad82046afa44e,
    mix: // ---- math ----
    $4c2c6808296c0d73$export$2c9e8a9632a706b2,
    dist: $4c2c6808296c0d73$export$6c4a311cc157c764,
    distSquared: $4c2c6808296c0d73$export$499eb56409f6cbc2,
    lenSquared: $4c2c6808296c0d73$export$a4f99f99d3e99cfa,
    pointsToAngleRad: $4c2c6808296c0d73$export$627023b405ba5028,
    pointsToAngleDeg: $4c2c6808296c0d73$export$c03a8450eabc2532,
    isInsideRect: $4c2c6808296c0d73$export$151bd845d70e2099,
    clamp: $4c2c6808296c0d73$export$7d15b64cf5a3a4c4,
    rotate: $4c2c6808296c0d73$export$bb628a54ab399bc9,
    rotateAround: $4c2c6808296c0d73$export$95ec0760d3d00713,
    Matrix: $bf8a1df6cb389ef0$export$5b12bf1653c0dd85,
    Vec2: $77055f1820134609$export$ac4bca90992eed1,
    intDxy: $4c2c6808296c0d73$export$bbf9af158036c5e9,
    roundEven: $4c2c6808296c0d73$export$94cce7adf2ec2d08,
    roundUneven: $4c2c6808296c0d73$export$f373b6a7b0c159a,
    round: $4c2c6808296c0d73$export$2077e0241d6afd3c,
    updateBounds: $4c2c6808296c0d73$export$f4467a4f41373bc7,
    indexBoundsInArea: $4c2c6808296c0d73$export$ddc1c0069d484d49,
    projectPointOnLine: // ---- line ----
    $4f238305bcccbc5b$export$b4c5b177db876445,
    PointLine: $4f238305bcccbc5b$export$8b36a4a83269a640,
    BezierLine: $4f238305bcccbc5b$export$5379d955c16d4d43,
    SplineInterpolator: $4f238305bcccbc5b$export$80967b1eb9fd6eb4,
    powerSplineInput: $4f238305bcccbc5b$export$c07c3aaef9f2da42,
    // ---- canvas ----
    canvas: (0, $79I2S.createCanvas),
    ctx: $2f436639594531f3$export$39f92e86d1722f3a,
    copyToCanvas: $2f436639594531f3$export$83cbd513f10a842b,
    testShouldPixelate: $2f436639594531f3$export$1555f643cc9a976,
    drawTransformedImageWithBounds: $2f436639594531f3$export$ded2b43392504635,
    createCheckerCanvas: $2f436639594531f3$export$754559b36e94ea2f,
    createCheckerDataUrl: $2f436639594531f3$export$42af33c76b681867,
    resizeCanvas: $2f436639594531f3$export$59b33278b5b2fc8a,
    freeCanvas: $2f436639594531f3$export$2384aff49c9b73c2,
    HSV: // ---- color ----
    $26aafdad8ab873aa$export$d2edaecd208aed43,
    RGB: $26aafdad8ab873aa$export$8f9ece5a47764b93,
    CMYK: $26aafdad8ab873aa$export$89d3f85304bf0767,
    ColorConverter: $26aafdad8ab873aa$export$fb7efcd2e153af6e,
    testIsWhiteBestContrast: $26aafdad8ab873aa$export$5cf396345d1238ae,
    appendTextDiv: // ---- UI ----
    $9e4d66c06c67fa7f$export$7868464f598ba79d,
    clearSelection: $9e4d66c06c67fa7f$export$a3d02541b0ebf605,
    el: $9e4d66c06c67fa7f$export$c3da0dad1b44eea9,
    isInputFocused: $9e4d66c06c67fa7f$export$906dfdb7df31ccfc,
    unfocusAnyInput: $9e4d66c06c67fa7f$export$e05240ca9e0b8bd9,
    KeyListener: // ---- events / input ----
    $26d18c1211450b7d$export$f17908c5de22d32e,
    PointerListener: $3a4865bce5f52590$export$9371bd96776f4e82,
    sameKeys: $26d18c1211450b7d$export$e9f65b0175de4c03,
    EventChain: $29dd970aa1f95ac5$export$649a211db9812745,
    DoubleTapper: $c61fdfd84bc32c60$export$db3963a21c01d803,
    NFingerTapper: $b4f1cdee8f932fed$export$510622b8aed00381,
    PinchZoomer: $84eb4aaf6ec9742b$export$d62358ac2d82abb3,
    CoalescedExploder: $403644a346975e30$export$fe11e0afe623a677,
    OnePointerLimiter: $61093ea2660d4547$export$71ff2f51bf1f4062
};
Object.keys($be957da3610487e9$export$921068d8846a1559); // without this, parcel build may break this object



// generated from src/languages. "npm run lang:build" to update
var $e829bdefed6e08a6$exports = {};
$e829bdefed6e08a6$exports = JSON.parse('["Switch left/right UI","Show/Hide Tools","Scroll","Donate","Home","Open in new tab","Edit","File","Brush","Paint Bucket","Gradient","Shape","Text","Hand Tool","Select Tool","Zoom","More Tools","Click again for more tools","Undo","Redo","Pen","Blend","Sketchy","Pixel","Chemy","Smudge","Size","Blending","Toggle Pressure Sensitivity","Circle","Chalk","Calligraphy","Square","Scale","Dither","New Pattern","Delete","Can\'t edit default patterns","Fill","Stroke","Horizontal Symmetry","Vertical Symmetry","Gradient","Transparent Background","Stabilizer","Stroke Stabilizer","Eyedropper","Secondary Color","Manual Color Input","Hex","Copy","Ok","Cancel","Close","Active Layer","Layer","copy","Blending","New Layer","Remove Layer","Duplicate Layer","Merge with layer below","Clear layer","Advanced merge","Merge all","Rename","Active layer is visible","Active layer is hidden","Layer Visibility","Clipping Mask","normal","darken","multiply","color burn","lighten","screen","color dodge","overlay","soft light","hard light","difference","exclusion","hue","saturation","color","luminosity","Rename Layer","Name","Clear Name","Sketch","Colors","Shading","Lines","Effects","Foreground","Merge/Mix Layers","Merges the selected layer with the one underneath. Select the mix mode:","No autosave, no cloud storage","New","Import","Save","File Format","Show save dialog","Copy","Copy To Clipboard","Paste","Share","Browser Storage","About Browser Storage","Can\'t access storage.","Empty","Store","Open","This image is already open in another tab. Open it here too?","Failed to load.","Clear","Clear Browser Storage? Clearing can not be undone.","Storing","Overwrite","Overwrite Browser Storage? Overwritten data will be permanently deleted.","{x}min ago","{x}h ago","{x}d ago","> 1month ago","Restored from Browser Storage","Stored to Browser Storage","Failed to store to Browser Storage","Failed to store. Possible causes:","Out of disk space","Storage disabled in incognito tab","Browser doesn\'t support storage","Failed to clear.","Upload","Recover closed tabs","Recovery data is only kept for a little while. Save to ensure your work is not lost.","Total:","Nothing to recover.","Recover","Delete","Delete this recovery? Deletion can not be undone.","Failed to recover tab.","Tab recovered.","Restoring your previous session...","Cleared layer","Cleared selected area","Filled","Filled selection","New Image","Current","Fit","Oversize","Square","Landscape","Portrait","Screen","Video","DIN Paper","px","Ratio","Upload to Imgur","Anyone with the link to your uploaded image will be able to view it.","Title","Untitled","Caption","Upload","Uploading...","Upload Successful","Upload failed.","To delete your image from Imgur visit:","Copy To Clipboard","Crop","Mask unselected","Right-click or press hold to copy.","To Clipboard","Copied.","Apply Crop","Drag to crop","Crop/Extend","Flip","Perspective","Resize","Rotate","Transform","Bright/Contrast","Curves","Hue/Saturation","Invert","Tilt Shift","To Alpha","Triangle Blur","Unsharp Mask","Crop / Extend","Crop or extend the image.","Left","Right","Top","Bottom","Rule of Thirds","Fill","Flip","Flips layer or whole image.","Horizontal","Vertical","Flip Image","Flip Layer","Perspective","Transforms the selected layer.","Resize","Resizes the image.","Rotate","Rotates the image.","Layer is empty.","Layer is empty in selected area.","Transform","Transforms selected layer. Hold Shift for additional behavior.","Rotation","Flip","Center","Constrain","Snap","Snap Rotation And Position","Brightness / Contrast","Change brightness and contrast for the selected layer.","Brightness","Contrast","Curves","Apply curves on the selected layer.","All","Hue / Saturation","Change hue and saturation for the selected layer.","Hue","Saturation","\\"{x}\\" applied","Tilt Shift","Applies tilt shift on the selected layer.","Blur Radius","Gradient Radius","To Alpha","Generates alpha channel for selected layer from:","Inverted Luminance","Luminance","Replace RGB","Triangle Blur","Applies triangle blur on the selected layer.","Unsharp Mask","Sharpens the selected layer by scaling pixels away from the average of their neighbors.","Strength","Grid","Draws grid on selected layer.","Noise","Adds noise to selected layer.","Scale","Alpha","Pattern","Generates pattern on selected layer. Drag the preview for further controls.","Distort","Distorts the selected layer.","Phase","Step Size","Sync XY","Vanish Point","Vanishing Point","Adds vanishing point to selected layer. Drag preview to move.","Lines","Drop to import","As New Image","As Layer","Opening file...","You are about to import {x} files. Importing many files at once can cause instability.","Import {x} files","Import Image","Image too large, will be downscaled.","As Layer","As Image","Import Image as New Layer","Adjust the position of the imported image.","Layer limit reached. Image will be placed on existing layer.","Fit","Flatten image","Unsupported file type. See Help for supported types.","Couldn\'t load image. File might be corrupted.","Unsupported features. PSD had to be flattened.","PSD support is limited. Flattened will more likely look correct.","Image exceeds maximum dimensions of {x} x {x} pixels. Unable to import.","Image size","Failed to read from clipboard.","No image found in clipboard.","Reset","Fit","Flip View","Inertia Scrolling","Tolerance","Sample","Which layers to sample color from","All","Active","Above","Grow","Grow filled area (in pixels)","Contiguous","Only fill connected areas","Linear","Linear-Mirror","Radial","Stroke","Fill","Rectangle","Ellipse","Line","Line Width","Outwards","Fixed 1:1","Auto-pan","Automatically moves as you draw","Click canvas to place text","Add Text","Text","Font","Your text","Color","Size","Line Height","Letter Spacing","Left","Center","Right","Italic","Bold","Failed to import the following files:","Supported formats:","Select","Transform","Lasso","Polygon","Replace","Add","Subtract","All","Invert","Reset","Deselect","Fill","Erase","Warp","Clone","Cloned","Move to layer:","Transformation applied","Selected area on active layer is empty.","Unsaved Work","Image was not saved in {a} minutes{b}. Save now to prevent eventual loss.","Save As PSD","PSD will remember all layers.","You can backup your drawing.","Submit","Submit Drawing","Submit drawing?","Submitting","Loading app","Waiting for image","Help","Settings","Language","Will update after reloading.","Theme","Always pixelated zoom","Save Reminder","disabled","Turn off Save Reminder?","There is no autosave and browser tabs don\'t last forever. If you don\'t periodically save you will likely lose work.","Disable at your own risk?","Disable","Dark","Light","Terms of Service","Licenses","Source Code","auto","Zoom In","Zoom Out","Radius","Constrain Proportions","Width","Height","Opacity","Scatter","Red","Green","Blue","Eraser","Center","Layers","Background","Scaling Algorithm","Smooth","Pixelated","Preview","Snap","45\xb0 Angle Snapping","Lock Alpha","Locks layer\'s alpha channel","Reverse","Before","After","Loading","More","{x}min","Work in progress","Double-tap or pinch-out to reset browser zoom.","Dismiss","Error","Retry"]');


const $a5daeddf2bf68f96$export$33e6c23ebe2ee669 = (0, (/*@__PURE__*/$parcel$interopDefault($e829bdefed6e08a6$exports)));
const $a5daeddf2bf68f96$export$d0d68bb9ed2c643d = [
    {
        code: 'en',
        name: 'English'
    },
    {
        code: 'de',
        name: 'Deutsch'
    },
    {
        code: 'es',
        name: "Espa\xf1ol"
    },
    {
        code: 'fi',
        name: 'suomi'
    },
    {
        code: 'fr',
        name: "Fran\xe7ais"
    },
    {
        code: 'hu',
        name: 'Magyar'
    },
    {
        code: 'id',
        name: 'Bahasa Indonesia'
    },
    {
        code: 'ja',
        name: "\u65E5\u672C\u8A9E"
    },
    {
        code: 'ko',
        name: "\uD55C\uAD6D\uC5B4"
    },
    {
        code: 'lv',
        name: "Latvie\u0161u Valoda"
    },
    {
        code: 'nl',
        name: 'Nederlands'
    },
    {
        code: 'pt-BR',
        name: "Portugu\xeas Brasil"
    },
    {
        code: 'ru',
        name: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    {
        code: 'sv',
        name: 'Svenska'
    },
    {
        code: 'zh-CN',
        name: "\u7B80\u4F53\u4E2D\u6587"
    },
    {
        code: 'zh-TW',
        name: "\u7E41\u9AD4\u4E2D\u6587"
    }
];















const $a5daeddf2bf68f96$export$f02cbd868e2f57cf = async (code)=>{
    if (code === 'en') return $a5daeddf2bf68f96$export$33e6c23ebe2ee669;
    else if (code === 'de') return await (parcelRequire("7JV8p"));
    else if (code === 'es') return await (parcelRequire("kq72H"));
    else if (code === 'fi') return await (parcelRequire("7lhPR"));
    else if (code === 'fr') return await (parcelRequire("fkCzo"));
    else if (code === 'hu') return await (parcelRequire("a78X2"));
    else if (code === 'id') return await (parcelRequire("9oJ54"));
    else if (code === 'ja') return await (parcelRequire("3Evxr"));
    else if (code === 'ko') return await (parcelRequire("alx6z"));
    else if (code === 'lv') return await (parcelRequire("ipJXm"));
    else if (code === 'nl') return await (parcelRequire("c7c8m"));
    else if (code === 'pt-BR') return await (parcelRequire("7hpVo"));
    else if (code === 'ru') return await (parcelRequire("ed6Zh"));
    else if (code === 'sv') return await (parcelRequire("7XvZk"));
    else if (code === 'zh-CN') return await (parcelRequire("irVKs"));
    else if (code === 'zh-TW') return await (parcelRequire("fFZUI"));
    throw new Error('unknown language code');
};
const $a5daeddf2bf68f96$export$c58bb360f242b089 = [
    'switch-ui-left-right',
    'toggle-show-tools',
    'scroll',
    'donate',
    'home',
    'modal-new-tab',
    'tab-edit',
    'tab-file',
    'tool-brush',
    'tool-paint-bucket',
    'tool-gradient',
    'tool-shape',
    'tool-text',
    'tool-hand',
    'tool-select',
    'tool-zoom',
    'tool-more-tools',
    'tool-more-tools-click-again',
    'undo',
    'redo',
    'brush-pen',
    'brush-blend',
    'brush-sketchy',
    'brush-pixel',
    'brush-chemy',
    'brush-smudge',
    'brush-size',
    'brush-blending',
    'brush-toggle-pressure',
    'brush-pen-circle',
    'brush-pen-chalk',
    'brush-pen-calligraphy',
    'brush-pen-square',
    'brush-sketchy-scale',
    'brush-pixel-dither',
    'brush-pixel-pattern-add',
    'brush-pixel-pattern-delete',
    'brush-pixel-pattern-edit-default-error',
    'brush-chemy-fill',
    'brush-chemy-stroke',
    'brush-chemy-mirror-x',
    'brush-chemy-mirror-y',
    'brush-chemy-gradient',
    'brush-eraser-transparent-bg',
    'stabilizer',
    'stabilizer-title',
    'eyedropper',
    'secondary-color',
    'manual-color-input',
    'mci-hex',
    'mci-copy',
    'modal-ok',
    'modal-cancel',
    'modal-close',
    'layers-active-layer',
    'layers-layer',
    'layers-copy',
    'layers-blending',
    'layers-new',
    'layers-remove',
    'layers-duplicate',
    'layers-merge',
    'layers-clear',
    'layers-merge-advanced',
    'layers-merge-all',
    'layers-rename',
    'layers-active-layer-visible',
    'layers-active-layer-hidden',
    'layers-visibility-toggle',
    'layers-clipping',
    'layers-blend-normal',
    'layers-blend-darken',
    'layers-blend-multiply',
    'layers-blend-color-burn',
    'layers-blend-lighten',
    'layers-blend-screen',
    'layers-blend-color-dodge',
    'layers-blend-overlay',
    'layers-blend-soft-light',
    'layers-blend-hard-light',
    'layers-blend-difference',
    'layers-blend-exclusion',
    'layers-blend-hue',
    'layers-blend-saturation',
    'layers-blend-color',
    'layers-blend-luminosity',
    'layers-rename-title',
    'layers-rename-name',
    'layers-rename-clear',
    'layers-rename-sketch',
    'layers-rename-colors',
    'layers-rename-shading',
    'layers-rename-lines',
    'layers-rename-effects',
    'layers-rename-foreground',
    'layers-merge-modal-title',
    'layers-merge-description',
    'file-no-autosave',
    'file-new',
    'file-import',
    'file-save',
    'file-format',
    'file-show-save-dialog',
    'file-copy',
    'file-copy-title',
    'file-paste',
    'file-share',
    'file-storage',
    'file-storage-about',
    'file-storage-cant-access',
    'file-storage-empty',
    'file-storage-store',
    'file-storage-open',
    'file-storage-open-confirmation',
    'file-storage-open-failed',
    'file-storage-clear',
    'file-storage-clear-prompt',
    'file-storage-storing',
    'file-storage-overwrite',
    'file-storage-overwrite-confirm',
    'file-storage-min-ago',
    'file-storage-hours-ago',
    'file-storage-days-ago',
    'file-storage-month-ago',
    'file-storage-restored',
    'file-storage-stored',
    'file-storage-failed',
    'file-storage-failed-1',
    'file-storage-failed-2',
    'file-storage-failed-3',
    'file-storage-failed-4',
    'file-storage-failed-clear',
    'file-upload',
    'tab-recovery-recover-tabs',
    'tab-recovery-explanation',
    'tab-recovery-total-quota-label',
    'tab-recovery-empty',
    'tab-recovery-recover',
    'tab-recovery-delete',
    'tab-recovery-delete-confirmation',
    'tab-recovery-failed-to-recover',
    'tab-recovery-recovered',
    'tab-recovery-restoring-session',
    'cleared-layer',
    'cleared-selected-area',
    'filled',
    'filled-selected-area',
    'new-title',
    'new-current',
    'new-fit',
    'new-oversize',
    'new-square',
    'new-landscape',
    'new-portrait',
    'new-screen',
    'new-video',
    'new-din-paper',
    'new-px',
    'new-ratio',
    'upload-title',
    'upload-link-notice',
    'upload-name',
    'upload-title-untitled',
    'upload-caption',
    'upload-submit',
    'upload-uploading',
    'upload-success',
    'upload-failed',
    'upload-delete',
    'cropcopy-title-copy',
    'cropcopy-title-crop',
    'cropcopy-mask',
    'cropcopy-click-hold',
    'cropcopy-btn-copy',
    'cropcopy-copied',
    'cropcopy-btn-crop',
    'crop-drag-to-crop',
    'filter-crop-extend',
    'filter-flip',
    'filter-perspective',
    'filter-resize',
    'filter-rotate',
    'filter-transform',
    'filter-bright-contrast',
    'filter-curves',
    'filter-hue-sat',
    'filter-invert',
    'filter-tilt-shift',
    'filter-to-alpha',
    'filter-triangle-blur',
    'filter-unsharp-mask',
    'filter-crop-title',
    'filter-crop-description',
    'filter-crop-left',
    'filter-crop-right',
    'filter-crop-top',
    'filter-crop-bottom',
    'filter-crop-rule-thirds',
    'filter-crop-fill',
    'filter-flip-title',
    'filter-flip-description',
    'filter-flip-horizontal',
    'filter-flip-vertical',
    'filter-flip-image',
    'filter-flip-layer',
    'filter-perspective-title',
    'filter-perspective-description',
    'filter-resize-title',
    'filter-resize-description',
    'filter-rotate-title',
    'filter-rotate-description',
    'filter-transform-empty',
    'filter-transform-empty-selection',
    'filter-transform-title',
    'filter-transform-description',
    'filter-transform-rotation',
    'filter-transform-flip',
    'filter-transform-center',
    'filter-transform-constrain',
    'filter-transform-snap',
    'filter-transform-snap-title',
    'filter-bright-contrast-title',
    'filter-bright-contrast-description',
    'filter-bright-contrast-brightness',
    'filter-bright-contrast-contrast',
    'filter-curves-title',
    'filter-curves-description',
    'filter-curves-all',
    'filter-hue-sat-title',
    'filter-hue-sat-description',
    'filter-hue-sat-hue',
    'filter-hue-sat-saturation',
    'filter-applied',
    'filter-tilt-shift-title',
    'filter-tilt-shift-description',
    'filter-tilt-shift-blur',
    'filter-tilt-shift-gradient',
    'filter-to-alpha-title',
    'filter-to-alpha-description',
    'filter-to-alpha-inverted-lum',
    'filter-to-alpha-lum',
    'filter-to-alpha-replace',
    'filter-triangle-blur-title',
    'filter-triangle-blur-description',
    'filter-unsharp-mask-title',
    'filter-unsharp-mask-description',
    'filter-unsharp-mask-strength',
    'filter-grid',
    'filter-grid-description',
    'filter-noise',
    'filter-noise-description',
    'filter-noise-scale',
    'filter-noise-alpha',
    'filter-pattern',
    'filter-pattern-description',
    'filter-distort',
    'filter-distort-description',
    'filter-distort-phase',
    'filter-distort-stepsize',
    'filter-distort-sync-xy',
    'filter-vanish-point',
    'filter-vanish-point-title',
    'filter-vanish-point-description',
    'filter-vanish-point-lines',
    'dropper-drop',
    'dropper-as-image',
    'dropper-as-layer',
    'import-opening',
    'import-many-files-warning',
    'import-many-files-confirm',
    'import-title',
    'import-too-large',
    'import-btn-as-layer',
    'import-btn-as-image',
    'import-as-layer-title',
    'import-as-layer-description',
    'import-as-layer-limit-reached',
    'import-as-layer-fit',
    'import-flatten',
    'import-unsupported-file',
    'import-broken-file',
    'import-psd-unsupported',
    'import-psd-limited-support',
    'import-psd-too-large',
    'import-psd-size',
    'clipboard-read-fail',
    'clipboard-no-image',
    'hand-reset',
    'hand-fit',
    'hand-flip',
    'hand-inertia-scrolling',
    'bucket-tolerance',
    'bucket-sample',
    'bucket-sample-title',
    'bucket-sample-all',
    'bucket-sample-active',
    'bucket-sample-above',
    'bucket-grow',
    'bucket-grow-title',
    'bucket-contiguous',
    'bucket-contiguous-title',
    'gradient-linear',
    'gradient-linear-mirror',
    'gradient-radial',
    'shape-stroke',
    'shape-fill',
    'shape-rect',
    'shape-ellipse',
    'shape-line',
    'shape-line-width',
    'shape-outwards',
    'shape-fixed',
    'shape-auto-pan',
    'shape-auto-pan-title',
    'text-instruction',
    'text-title',
    'text-text',
    'text-font',
    'text-placeholder',
    'text-color',
    'text-size',
    'text-line-height',
    'text-letter-spacing',
    'text-left',
    'text-center',
    'text-right',
    'text-italic',
    'text-bold',
    'text-failed-import',
    'text-supported-formats',
    'select-select',
    'select-transform',
    'select-lasso',
    'select-polygon',
    'select-boolean-replace',
    'select-boolean-add',
    'select-boolean-subtract',
    'select-all',
    'select-invert',
    'select-reset',
    'select-deselect',
    'select-fill',
    'select-erase',
    'select-transform-warp',
    'select-transform-clone',
    'select-transform-clone-applied',
    'select-transform-move-to-layer',
    'select-transform-applied',
    'select-transform-empty',
    'save-reminder-title',
    'save-reminder-text',
    'save-reminder-save-psd',
    'save-reminder-psd-layers',
    'backup-drawing',
    'submit',
    'submit-title',
    'submit-prompt',
    'submit-submitting',
    'embed-init-loading',
    'embed-init-waiting',
    'help',
    'tab-settings',
    'settings-language',
    'settings-language-reload',
    'settings-theme',
    'settings-pixelated-zoom',
    'settings-save-reminder-label',
    'settings-save-reminder-disabled',
    'settings-save-reminder-confirm-title',
    'settings-save-reminder-confirm-a',
    'settings-save-reminder-confirm-b',
    'settings-save-reminder-confirm-disable',
    'theme-dark',
    'theme-light',
    'terms-of-service',
    'licenses',
    'source-code',
    'auto',
    'zoom-in',
    'zoom-out',
    'radius',
    'constrain-proportions',
    'width',
    'height',
    'opacity',
    'scatter',
    'red',
    'green',
    'blue',
    'eraser',
    'center',
    'layers',
    'background',
    'scaling-algorithm',
    'algorithm-smooth',
    'algorithm-pixelated',
    'preview',
    'angle-snap',
    'angle-snap-title',
    'lock-alpha',
    'lock-alpha-title',
    'reverse',
    'compare-before',
    'compare-after',
    'loading',
    'more',
    'x-minutes',
    'wip',
    'browser-zoom-help',
    'dismiss',
    'error',
    'retry'
];
const $a5daeddf2bf68f96$export$617cabd92199d079 = Object.fromEntries($a5daeddf2bf68f96$export$c58bb360f242b089.map((code, index)=>[
        code,
        index
    ]));




const $fc42a07754814920$export$991796128b2ca217 = 'klecks-language';
class $fc42a07754814920$var$LanguageStrings {
    async setLanguage(langCode) {
        this.data = (0, $a5daeddf2bf68f96$export$33e6c23ebe2ee669);
        if (langCode !== 'en') try {
            this.data = (await (0, $a5daeddf2bf68f96$export$f02cbd868e2f57cf)(langCode)).map((item, index)=>item ?? this.data[index]);
        } catch (e) {
            (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(new Error('failed to load language: ' + langCode));
            (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
        }
        this.code = langCode;
        document.documentElement.setAttribute('lang', langCode);
        this.listeners.forEach((item)=>{
            item();
        });
    }
    get(code) {
        const index = (0, $a5daeddf2bf68f96$export$617cabd92199d079)[code];
        if (index === undefined) throw new Error("translation code doesn't exist: " + code);
        return this.data[index];
    }
    getLanguage() {
        return (0, $a5daeddf2bf68f96$export$d0d68bb9ed2c643d).find((item)=>{
            return item.code === this.code;
        });
    }
    getAutoLanguage() {
        const autoCode = $fc42a07754814920$export$64783e31db14f0ba(false);
        return (0, $a5daeddf2bf68f96$export$d0d68bb9ed2c643d).find((item)=>{
            return item.code === autoCode;
        });
    }
    getCode() {
        return this.code;
    }
    // get notified on language change
    subscribe(subscriber) {
        if (this.listeners.includes(subscriber)) return;
        this.listeners.push(subscriber);
    }
    unsubscribe(subscriber) {
        for(let i = 0; i < this.listeners.length; i++)if (subscriber === this.listeners[i]) {
            this.listeners.splice(i, 1);
            return;
        }
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.listeners = [];
        // need to use setLanguage for a different language
        this.data = (0, $a5daeddf2bf68f96$export$33e6c23ebe2ee669);
        this.code = 'en';
    }
}
function $fc42a07754814920$export$64783e31db14f0ba(useLocalStorage) {
    let result = 'en';
    const langs = []; // from highest to lowest priority
    const navLangs = navigator.languages ? navigator.languages : [
        navigator.language
    ];
    navLangs.forEach((item)=>{
        const split = item.split('-');
        langs.push(item);
        if (split.length === 2) langs.push(split[0]);
    });
    if (useLocalStorage) try {
        const item = (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem($fc42a07754814920$export$991796128b2ca217);
        if (item) {
            const found = (0, $a5daeddf2bf68f96$export$d0d68bb9ed2c643d).find((language)=>{
                return language.code === item;
            });
            if (found) return found.code;
            else (0, $7a8f101d3676d17a$export$19fffca37ef3e106).removeItem($fc42a07754814920$export$991796128b2ca217);
        }
    } catch (e) {
    // likely cookies disabled in Safari
    }
    for(let i = 0; i < langs.length; i++){
        const lang = langs[i];
        const found = (0, $a5daeddf2bf68f96$export$d0d68bb9ed2c643d).find((item)=>{
            return item.code.toLowerCase() === lang.toLowerCase();
        });
        if (found) {
            result = found.code;
            break;
        }
    }
    return result;
}
const $fc42a07754814920$var$activeLanguageCode = $fc42a07754814920$export$64783e31db14f0ba(true);
const $fc42a07754814920$export$e4ce066d17694649 = new $fc42a07754814920$var$LanguageStrings();
const $fc42a07754814920$export$ce37e184d908d785 = (code, replace)=>{
    if (replace) {
        let result = $fc42a07754814920$export$e4ce066d17694649.get(code);
        const keyArr = Object.keys(replace);
        keyArr.forEach((key)=>{
            result = result.replace(`{${key}}`, replace[key]);
        });
        return result;
    } else return $fc42a07754814920$export$e4ce066d17694649.get(code);
};
const $fc42a07754814920$export$7a2ea9f2e4d199d3 = ()=>$fc42a07754814920$export$e4ce066d17694649.setLanguage($fc42a07754814920$var$activeLanguageCode);


const $5b46848ca200986a$var$cancelImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('cancel');
class $5b46848ca200986a$export$185108a9b725b68 {
    // ---- interface ----
    close() {
        (0, $a0bbbeb927a78bac$export$d3d1650bc39c4419).decrease();
        this.rootEl.remove();
        this.destroyer.destroy();
        window.removeEventListener('resize', this.updatePos);
        this.keyListener.destroy();
        this.onClose && this.onClose();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        (0, $a0bbbeb927a78bac$export$d3d1650bc39c4419).increase();
        this.onClose = p.onClose;
        this.parent = document.body;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.parent,
            className: 'g-root kl-d-modal-root',
            css: {
                position: 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
                right: 0,
                overflow: 'auto',
                animationName: 'consoleIn',
                animationDuration: '0.3s',
                animationTimingFunction: 'ease-out'
            },
            destroyer: this.destroyer,
            onClick: (0, $be957da3610487e9$export$921068d8846a1559).handleClick
        });
        //background element registering clicks
        this.bgEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                right: 0
            },
            destroyer: this.destroyer,
            onClick: ()=>this.close()
        });
        //the actual popup box
        const popupEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-d-modal',
            css: {
                position: 'absolute',
                width: `min(calc(100% - 40px), ${p.width ? p.width : 400}px)`,
                height: p.height === undefined ? 'calc(100% - 40px)' : `min(calc(100% - 40px), ${p.height}px)`,
                borderRadius: 10,
                overflow: 'hidden'
            }
        });
        //x and y position via script. flex not powerful enough imo
        this.updatePos = ()=>{
            const elW = popupEl.offsetWidth;
            const elH = popupEl.offsetHeight;
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(popupEl, {
                left: Math.max(0, (window.innerWidth - elW) / 2),
                top: Math.max(20, (window.innerHeight - elH) / 2 - elH * 0.2)
            });
        };
        this.updatePos();
        window.addEventListener('resize', this.updatePos);
        //title row in popup
        const titleHeight = 40;
        const titleEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: popupEl,
            css: {
                height: titleHeight,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingLeft: titleHeight / 2
            }
        });
        if (p.title) titleEl.append(p.title);
        this.xButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: titleEl,
            tagName: 'button',
            className: 'popup-x',
            destroyer: this.destroyer,
            content: `<img alt="${(0, $fc42a07754814920$export$ce37e184d908d785)('modal-close')}" height="20" src="${$5b46848ca200986a$var$cancelImg}">`,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('modal-close'),
            onClick: ()=>this.close(),
            css: {
                width: titleHeight,
                height: titleHeight,
                lineHeight: titleHeight + 'px',
                background: 'none',
                boxShadow: 'none'
            },
            props: {
                tabIndex: 0
            }
        });
        const contentEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: popupEl,
            css: {
                height: 'calc(100% - ' + titleHeight + 'px)'
            }
        });
        if (p.content) contentEl.append(p.content);
        this.keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
            onDown: (keyStr, e)=>{
                if (keyStr === 'esc') {
                    e.stopPropagation();
                    e.preventDefault(); // stay in fullscreen on Mac
                    this.close();
                }
            }
        });
    }
}





class $be3050d362858227$export$48513f6b9f8ce62d {
    getValue() {
        return this.check.checked;
    }
    setValue(b) {
        this.check.checked = b;
        if (this.doHighlight) this.rootEl.classList.toggle('kl-checkbox--highlight', this.check.checked);
    }
    setEnabled(enabled) {
        this.check.disabled = !enabled;
        this.rootEl.classList.toggle('kl-checkbox--disabled', !enabled);
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.check.onchange = null;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        const isEnabled = p.isEnabled ?? true;
        this.doHighlight = !!p.doHighlight;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-checkbox'
        });
        this.rootEl.classList.toggle('kl-checkbox--disabled', !isEnabled);
        const innerEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            tagName: 'label',
            className: 'kl-checkbox__inner',
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        this.check = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: innerEl,
            tagName: 'input',
            css: {
                margin: '0 5px 0 0',
                // otherwise varies by browser
                width: 14,
                height: 14
            },
            props: {
                type: 'checkbox',
                name: p.name,
                ...!isEnabled ? {
                    disabled: true
                } : {}
            }
        });
        this.check.checked = !!p.init;
        if (this.doHighlight && this.check.checked) this.rootEl.classList.add('kl-checkbox--highlight');
        if (!p.allowTab) this.check.tabIndex = -1;
        if (p.title) innerEl.title = p.title;
        const label = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: innerEl,
            content: p.label,
            css: {
                display: 'flex',
                alignItems: 'center',
                gap: 3
            }
        });
        this.check.onchange = ()=>{
            if (this.doHighlight) this.rootEl.classList.toggle('kl-checkbox--highlight', this.check.checked);
            p.callback && p.callback(this.check.checked);
            setTimeout(()=>{
                this.check.blur();
            }, 0);
        };
        if (p.css) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, p.css);
    }
}




class $5b4df30e3b8eea04$export$ef9b1a59e592288f {
    setValue(val) {
        this.selectEl.value = val === undefined ? '' : val;
    }
    getValue() {
        return this.selectEl.value;
    }
    setDeltaValue(delta) {
        let index = 0;
        for(let i = 0; i < this.optionArr.length; i++){
            const option = this.optionArr[i];
            if (option.item && '' + option.item[0] === this.selectEl.value) {
                index = i;
                break;
            }
        }
        index = Math.max(0, Math.min(this.optionArr.length - 1, index + delta));
        const option = this.optionArr[index];
        this.selectEl.value = option.item ? option.item[0] : '';
        this.onChange && this.onChange(this.getValue());
    }
    getElement() {
        return this.selectEl;
    }
    updateLabel(id, label) {
        this.optionArr.forEach((option)=>{
            if (option.item && option.item[0] === id && option.el) {
                option.item[1] = label;
                option.el.textContent = option.item[1];
            }
        });
    }
    setOptionArr(optionArr) {
        const oldVal = this.selectEl.value;
        this.optionArr = [];
        this.selectEl.innerHTML = '';
        for(let i = 0; i < optionArr.length; i++){
            const item = optionArr[i];
            if (!item) {
                this.optionArr.push({
                    item: item
                });
                continue;
            }
            const el = document.createElement('option');
            el.value = item[0];
            el.textContent = item[1];
            if (item[2]) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(el, item[2].css);
            this.optionArr.push({
                item: item,
                el: el
            });
            this.selectEl.append(el);
        }
        // restore old value
        if (oldVal === '' || optionArr.findIndex((item)=>item && item[0] === oldVal) > -1) this.setValue(oldVal);
    }
    destroy() {
        this.selectEl.removeEventListener('change', this.changeListener);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.optionArr = [];
        this.selectEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'select',
            title: p.title,
            className: 'kl-select',
            css: {
                cursor: 'pointer',
                fontSize: 15,
                padding: 3
            },
            props: {
                name: p.name
            }
        });
        if (p.css) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.selectEl, p.css);
        const isFocusable = p.isFocusable;
        if (!isFocusable) this.selectEl.tabIndex = -1;
        this.setOptionArr(p.optionArr);
        if (p.onChange) this.onChange = p.onChange;
        this.changeListener = ()=>{
            if (!isFocusable) this.selectEl.blur();
            this.onChange && this.onChange(this.getValue());
        };
        this.selectEl.addEventListener('change', this.changeListener);
        this.selectEl.value = p.initValue !== undefined ? p.initValue : '';
    }
}




class $fdd030cdfa4412e2$export$b6d053cded550773 {
    update() {
        this.rootEl.classList.toggle('image-toggle-active', this.isActive);
    }
    // --- interface ---
    setValue(b) {
        this.isActive = b;
        this.update();
    }
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return this.isActive;
    }
    destroy() {
        this.destroyer.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.isActive = p.initValue;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'image-toggle',
            title: p.title,
            content: (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'image-toggle__im' + (p.darkInvert ? ' dark-invert' : ''),
                css: {
                    backgroundImage: "url('" + p.image + "')"
                }
            }),
            destroyer: this.destroyer,
            onClick: (e)=>{
                e.preventDefault();
                if (p.isRadio && this.isActive) return;
                this.isActive = !this.isActive;
                this.update();
                p.onChange(this.isActive);
            }
        });
        this.update();
    }
}




class $f3056e554051c8ed$export$7cc1012a658e6ad8 {
    // --- interface ---
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return this.optionArr[this.activeIndex].id;
    }
    destroy() {
        this.optionArr.forEach((item)=>{
            item.radioEl.destroy();
        });
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'image-radio-wrapper',
            css: {
                display: 'flex'
            }
        });
        this.optionArr = [];
        const select = (index, id)=>{
            this.activeIndex = index;
            for(let i = 0; i < this.optionArr.length; i++)this.optionArr[i].radioEl.setValue(i === this.activeIndex);
            p.onChange(id);
        };
        let initialIndex;
        const createOption = (index, o)=>{
            if (o.id === p.initId) initialIndex = index;
            const radioEl = new (0, $fdd030cdfa4412e2$export$b6d053cded550773)({
                image: o.image,
                title: o.title,
                initValue: o.id === p.initId,
                isRadio: true,
                onChange: ()=>{
                    select(index, o.id);
                },
                darkInvert: o.darkInvert
            });
            this.rootEl.append(radioEl.getElement());
            return {
                id: o.id,
                radioEl: radioEl
            };
        };
        for(let i = 0; i < p.optionArr.length; i++)this.optionArr.push(createOption(i, p.optionArr[i]));
        if (initialIndex === undefined) throw new Error('initId not in optionArr');
        this.activeIndex = initialIndex;
    }
}







class $0b383e4686740404$export$2358c75ad3c15b2d {
    update() {
        this.el.classList.toggle('kl-box-toggle--active', this.value);
    }
    getValue() {
        return this.value;
    }
    setValue(b) {
        this.value = b;
        this.update();
    }
    getElement() {
        return this.el;
    }
    destroy() {
        this.destroyer.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.value = !!p.init;
        this.el = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: p.label,
            title: p.title,
            className: typeof p.label === 'string' ? 'kl-box-toggle' : 'kl-box-toggle kl-box-toggle--custom-el',
            destroyer: this.destroyer,
            onClick: ()=>{
                this.value = !this.value;
                this.update();
                p.onChange(this.value);
            },
            css: {
                cursor: 'pointer'
            }
        });
        if (typeof p.label !== 'string' && !p.keepOriginalLabel) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(p.label, {
            display: 'block',
            pointerEvents: 'none'
        });
        this.update();
    }
}


const $7a8db4f517a189fb$var$iconImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('brush-pressure');
const $7a8db4f517a189fb$export$9da2e8821e6cbb57 = function(isChecked, changeCallback) {
    const toggleEl = new (0, $0b383e4686740404$export$2358c75ad3c15b2d)({
        label: (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'dark-invert',
            css: {
                width: 17,
                height: 17,
                backgroundImage: 'url("' + $7a8db4f517a189fb$var$iconImg + '")',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                margin: 1,
                borderRadius: 3
            }
        }),
        title: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-toggle-pressure'),
        init: isChecked,
        onChange: (b)=>{
            changeCallback(b);
        }
    });
    return toggleEl.getElement();
};



/**
 * To make sliders more fine-grained. The falloff when moving cursor away from cursor.
 * Returns the factor [0,1]
 *  0 -> infinite movement required for change of 1
 *  1 -> 1px movement for change of 1
 *
 * @param deltaY vertical distance from pointerdown
 * @param isRightButton
 */ function $61c75be24be916f2$export$f8e41e222e32615d(deltaY, isRightButton) {
    let result = Math.min(10, 1 + Math.floor(deltaY / 50) ** 2);
    if (isRightButton) result *= 2;
    return 1 / result;
}







class $781553b3646364b0$export$f5b8910cec6cf069 {
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return this.value;
    }
    setValue(value, triggerChange = false) {
        this.input.value = '' + value;
        if (triggerChange) this.input.dispatchEvent(new Event('change', {
            bubbles: true
        }));
        else this.value = value;
    }
    getIsFocused() {
        return document.activeElement === this.input;
    }
    focus() {
        this.input.focus();
    }
    select() {
        this.input.select();
    }
    setRange(min, max) {
        if (min !== undefined) this.input.min = '' + min;
        if (max !== undefined) this.input.max = '' + max;
    }
    destroy() {
        this.input.removeEventListener('change', this.changeListener);
        this.input.removeEventListener('input', this.inputListener);
        if (this.blurListener) this.input.removeEventListener('blur', this.blurListener);
        this.pointerListener?.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'label',
            content: p.label,
            css: {
                display: 'flex',
                alignItems: 'center',
                gap: 5,
                width: 'fit-content'
            }
        });
        this.input = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'input',
            parent: this.rootEl,
            title: p.title,
            props: {
                name: p.name
            }
        });
        if (p.isFocusIgnored) this.input.setAttribute('data-ignore-focus', 'true');
        this.type = p.type ?? 'text';
        try {
            this.input.type = this.type;
        } catch (e) {
        // ie can't deal with number
        }
        if (this.type === 'number') {
            this.setRange(p.min, p.max);
            // undefined would default to 1 (https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Attributes/step)
            this.input.step = p.step === undefined ? 'any' : '' + p.step;
        }
        this.input.value = '' + p.init;
        this.value = p.init;
        const defaultNumberValidate = (value)=>{
            if (!Number.isFinite(value)) return false;
            return true;
        };
        const defaultConstrain = (value)=>{
            let result = value;
            const min = this.input.min === '' ? undefined : +this.input.min;
            const max = this.input.max === '' ? undefined : +this.input.max;
            if (this.input.step !== 'any') {
                const step = +this.input.step;
                if (Number.isFinite(step) && step > 0) {
                    const stepBase = min ?? 0;
                    const digits = Math.max((0, $4c2c6808296c0d73$export$5f852371c60150f6)(step), (0, $4c2c6808296c0d73$export$5f852371c60150f6)(stepBase));
                    const stepIndex = Math.round((result - stepBase) / step);
                    result = (0, $be957da3610487e9$export$921068d8846a1559).round(stepBase + stepIndex * step, digits);
                }
            }
            if (min !== undefined) result = Math.max(result, min);
            if (max !== undefined) result = Math.min(result, max);
            return result;
        };
        const customValidate = p.validate;
        const customConstrain = p.constrain;
        // return true if changed
        const handleInput = ()=>{
            if (this.type === 'number') {
                let newValue = this.input.valueAsNumber;
                const isValid = customValidate ? customValidate(newValue) : defaultNumberValidate(newValue);
                if (!isValid) return false;
                newValue = customConstrain ? customConstrain(newValue) : defaultConstrain(newValue);
                if (newValue !== this.value) {
                    this.value = newValue;
                    return true;
                }
                return false;
            }
            let newValue = this.input.value;
            if (customValidate && !customValidate(newValue)) return false;
            if (customConstrain) newValue = customConstrain(newValue);
            if (newValue !== this.value) {
                this.value = newValue;
                return true;
            }
            return false;
        };
        // return true if changed
        const handleChange = ()=>{
            const changed = handleInput();
            this.input.value = '' + this.value;
            return changed;
        };
        this.inputListener = ()=>{
            if (handleInput()) p.onChange?.(this.value);
        };
        this.input.addEventListener('input', this.inputListener);
        this.changeListener = ()=>{
            if (handleChange()) p.onChange?.(this.value);
        };
        this.input.addEventListener('change', this.changeListener);
        this.blurListener = p.onBlur ? ()=>p.onBlur?.(this.getValue()) : undefined;
        if (this.blurListener) this.input.addEventListener('blur', this.blurListener);
        if (p.css) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.input, p.css);
        if (p.type === 'number') this.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.input,
            onWheel: (e)=>{
                const stepSize = p.step ?? 1;
                const stepDigits = (0, $4c2c6808296c0d73$export$5f852371c60150f6)(stepSize);
                const fac = e.shiftKey ? 4 : 1;
                const value = parseFloat(this.input.value) - e.deltaY * stepSize * fac;
                this.input.value = '' + (0, $be957da3610487e9$export$921068d8846a1559).round(value, stepDigits);
                handleChange() && p.onChange?.(this.getValue());
            }
        });
    }
}


class $2e43c14468eefb48$export$db3d4fde05db9a5e {
    emit() {
        const value = Number(this.input.getValue());
        if (this.lastValue !== value) {
            this.onChange(value);
            this.lastValue = value;
        }
    }
    privateOnClose() {
        if (this.isClosed) return;
        this.isClosed = true;
        this.emit();
        this.onClose();
        setTimeout(()=>{
            // because iPad keyboard changes the scroll position
            this.scrollBefore && window.scrollTo(this.scrollBefore.x, this.scrollBefore.y);
            this.scrollBefore = undefined;
        });
    }
    getElement() {
        return this.input.getElement();
    }
    focus() {
        this.input.focus();
        this.input.select();
    }
    destroy() {
        this.input.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(value, min, max, rect, onChange, onClose, roundDigits){
        this.onChange = onChange;
        this.onClose = onClose;
        this.isClosed = false;
        this.input = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            type: 'number',
            init: value,
            min: min,
            max: max,
            name: 'slider-manual-input',
            step: roundDigits === undefined ? undefined : 10 ** -roundDigits,
            onChange: ()=>this.emit(),
            onBlur: ()=>this.privateOnClose(),
            css: {
                width: rect.width,
                height: rect.height
            }
        });
        this.input.getElement().addEventListener('keyup', (e)=>{
            if ([
                'Enter',
                'Escape'
            ].includes(e.key)) this.privateOnClose();
            else this.emit();
        }, {
            passive: false
        });
        this.scrollBefore = {
            x: window.scrollX,
            y: window.scrollY
        };
        let currentValue;
        if (roundDigits || roundDigits === 0) currentValue = (0, $be957da3610487e9$export$921068d8846a1559).round(value, roundDigits);
        else currentValue = value;
        this.lastValue = currentValue;
        this.input.setValue(currentValue);
    }
}



class $886527ea181efb50$export$a1855b925e534de7 {
    valueToSliderValue(value) {
        if (this.useSpline && this.splineInterpolator) return this.splineInterpolator.findX(value, Math.floor(this.resolution)) || 0;
        return (value - this.min) / (this.max - this.min);
    }
    sliderValueToValue(sliderValue) {
        let result = this.min + sliderValue * (this.max - this.min);
        if (this.useSpline && this.splineInterpolator) result = this.splineInterpolator.interpolate(sliderValue) || 0;
        return result;
    }
    updateLabel() {
        let displayValue = this.valueToDisplayValue(this.value);
        displayValue = this.formatFunc ? this.formatFunc(displayValue) : Math.round(displayValue);
        displayValue = displayValue.toLocaleString((0, $fc42a07754814920$export$e4ce066d17694649).getCode());
        const unit = this.unit !== undefined ? this.unit : '';
        this.labelValueEl.textContent = displayValue + unit;
        const sliderValue = this.valueToSliderValue(this.value);
        this.control.style.width = sliderValue * this.elementWidth + 'px';
    }
    emit(isFinal) {
        if (!isFinal && this.isChangeOnFinal) return;
        if (isFinal || !this.eventResMs) {
            this.onChange(this.value);
            if (this.emitInterval) {
                clearInterval(this.emitInterval);
                this.emitInterval = undefined;
            }
            return;
        }
        if (this.emitInterval) this.emitValue = this.value;
        else {
            this.onChange(this.value);
            this.emitInterval = setInterval(()=>{
                if (this.emitValue === undefined) {
                    clearInterval(this.emitInterval);
                    this.emitInterval = undefined;
                } else {
                    this.onChange(this.emitValue);
                    this.emitValue = undefined;
                }
            }, this.eventResMs);
        }
    }
    updateEnable() {
        this.sliderWrapperEl.classList.toggle('slider-wrapper--disabled', !this.isEnabled);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.sliderWrapperEl, {
            opacity: this.isEnabled ? undefined : 0.5,
            pointerEvents: this.isEnabled ? undefined : 'none'
        });
    }
    showManualInput() {
        this.manualInput = new (0, $2e43c14468eefb48$export$db3d4fde05db9a5e)(this.valueToDisplayValue(this.value), this.valueToDisplayValue(this.min), this.valueToDisplayValue(this.max), this.sliderWrapperEl.getBoundingClientRect(), (val)=>{
            val = this.displayValueToValue(val);
            this.setValue((0, $be957da3610487e9$export$921068d8846a1559).clamp(val, this.min, this.max));
            this.onChange(this.value);
        }, ()=>{
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.sliderWrapperEl, {
                display: ''
            });
            if (this.manualInput) {
                this.manualInput.getElement().remove();
                this.manualInput.destroy();
            }
            this.manualInput = undefined;
        }, this.manualInputRoundDigits && this.manualInputRoundDigits > 0 ? this.manualInputRoundDigits : 0);
        this.rootEl.append(this.manualInput.getElement());
        setTimeout(()=>{
            this.manualInput && this.manualInput.focus();
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.sliderWrapperEl, {
            display: 'none'
        });
    }
    changeSliderValue(f) {
        if (!this.isEnabled) return;
        let sliderValue = this.valueToSliderValue(this.value);
        sliderValue = (0, $be957da3610487e9$export$921068d8846a1559).clamp(sliderValue + f, 0, 1);
        this.value = this.sliderValueToValue(sliderValue);
        this.updateLabel();
        this.onChange(this.value);
    }
    setValue(v) {
        this.value = (0, $be957da3610487e9$export$921068d8846a1559).clamp(v, this.min, this.max);
        this.updateLabel();
    }
    getValue() {
        return this.value;
    }
    getDisplayValue() {
        return this.valueToDisplayValue(this.value);
    }
    update(config) {
        this.min = config.min;
        this.max = config.max;
        this.useSpline = !!config.curve;
        if (this.useSpline) {
            if (!config.curve) throw new Error('curve needs to be set if useSpline true');
            const curveArr = config.curve === 'quadratic' ? (0, $be957da3610487e9$export$921068d8846a1559).powerSplineInput(this.min, this.max, 0.1) : config.curve;
            this.splineInterpolator = new (0, $be957da3610487e9$export$921068d8846a1559).SplineInterpolator(curveArr);
        } else this.splineInterpolator = undefined;
        this.setIsEnabled(!config.isDisabled);
    }
    setIsEnabled(e) {
        this.isEnabled = e;
        this.updateEnable();
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        clearTimeout(this.pointerListenerTimeout);
        this.pointerListener && this.pointerListener.destroy();
        if (this.manualInput) this.manualInput.destroy();
        if (this.emitInterval) clearInterval(this.emitInterval);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isEnabled = p.isEnabled !== false;
        this.manualInputRoundDigits = p.manualInputRoundDigits;
        this.useSpline = !!p.curve;
        if (!p.label) throw new Error('KlSlider missing params');
        if (p.min !== 0 && p.max !== 0 && p.value !== 0) {
            if (!p.min || !p.max || !p.value) throw new Error('KlSlider broken params');
        }
        if (p.min >= p.max) throw new Error('KlSlider broken params');
        this.min = p.min;
        this.max = p.max;
        this.value = (0, $be957da3610487e9$export$921068d8846a1559).clamp(p.value, this.min, this.max);
        this.elementWidth = p.width;
        this.elementHeight = p.height;
        this.resolution = p.resolution ? p.resolution : this.elementWidth * 2;
        this.onChange = p.onChange ? p.onChange : ()=>{};
        if (!p.toValue !== !p.toDisplayValue) throw new Error('both or neither have to be set, toValue and toDisplayValue');
        this.displayValueToValue = p.toValue ? p.toValue : (displayValue)=>displayValue;
        this.valueToDisplayValue = p.toDisplayValue ? p.toDisplayValue : (value)=>value;
        this.isChangeOnFinal = !!p.isChangeOnFinal;
        this.formatFunc = p.formatFunc;
        this.eventResMs = p.eventResMs;
        this.unit = p.unit;
        if (this.useSpline) {
            if (!p.curve) throw new Error('curve needs to be set if useSpline true');
            const curveArr = p.curve === 'quadratic' ? (0, $be957da3610487e9$export$921068d8846a1559).powerSplineInput(this.min, this.max, 0.1) : p.curve;
            this.splineInterpolator = new (0, $be957da3610487e9$export$921068d8846a1559).SplineInterpolator(curveArr);
        }
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex'
            }
        });
        this.sliderWrapperEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'slider-wrapper',
            css: {
                overflow: 'hidden',
                position: 'relative',
                width: this.elementWidth,
                height: this.elementHeight,
                userSelect: 'none'
            }
        });
        this.rootEl.oncontextmenu = function() {
            return false;
        };
        this.label = p.label;
        const labelFontSize = this.elementHeight - 14;
        this.labelValueEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                fontWeight: 'bold'
            }
        });
        this.textEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    content: this.label,
                    css: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }
                }),
                this.labelValueEl
            ],
            css: {
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                padding: '0 7px',
                height: '100%',
                width: '100%',
                fontSize: labelFontSize,
                pointerEvents: 'none',
                gap: 8
            }
        });
        this.control = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'slider-inner',
            css: {
                position: 'absolute',
                left: 0,
                top: 0,
                width: this.valueToSliderValue(this.value) * this.elementWidth,
                height: this.elementHeight
            }
        });
        const controlInner = document.createElement('div');
        this.sliderWrapperEl.append(this.control, this.textEl);
        this.control.append(controlInner);
        this.updateEnable();
        const doubleTapper = new (0, $be957da3610487e9$export$921068d8846a1559).DoubleTapper({
            onDoubleTap: ()=>{
                this.showManualInput();
            }
        });
        doubleTapper.setAllowedButtonArr([
            'left',
            'right'
        ]);
        const eventChain = new (0, $be957da3610487e9$export$921068d8846a1559).EventChain({
            chainArr: [
                doubleTapper
            ]
        });
        let virtualVal;
        const onPointer = (event)=>{
            event.eventPreventDefault();
            if (!this.isEnabled) return;
            if (event.type === 'pointerdown') {
                // unfocus manual slider input
                (0, $be957da3610487e9$export$921068d8846a1559).unfocusAnyInput();
                this.sliderWrapperEl.className = 'slider-wrapper slider-wrapper--active';
                if (event.button === 'left') {
                    let sliderValue = event.relX / this.elementWidth;
                    sliderValue = Math.max(0, Math.min(1, sliderValue));
                    this.value = this.sliderValueToValue(sliderValue);
                    this.updateLabel();
                    this.emit(false);
                }
                virtualVal = this.valueToSliderValue(this.value);
            }
            if (event.type === 'pointermove' && [
                'left',
                'right'
            ].includes(event.button || '')) {
                let deltaX = event.dX;
                const deltaY = Math.abs(event.pageY - (event.downPageY || 0));
                const factor = (0, $61c75be24be916f2$export$f8e41e222e32615d)(deltaY, event.button === 'right');
                deltaX *= factor;
                deltaX /= this.elementWidth;
                virtualVal += deltaX;
                const sliderValue = Math.max(0, Math.min(1, virtualVal));
                this.value = this.sliderValueToValue(sliderValue);
                this.updateLabel();
                this.emit(false);
            }
            if (event.type === 'pointerup') {
                this.sliderWrapperEl.className = 'slider-wrapper';
                this.emit(true);
            }
        };
        this.pointerListenerTimeout = setTimeout(()=>{
            this.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                target: this.sliderWrapperEl,
                fixScribble: true,
                onPointer: (e)=>{
                    onPointer(e);
                    eventChain.chainIn(e);
                },
                onWheel: (event)=>{
                    event.event?.preventDefault();
                    let sliderValue = this.valueToSliderValue(this.value);
                    sliderValue = (0, $be957da3610487e9$export$921068d8846a1559).clamp(sliderValue - event.deltaY / 40, 0, 1);
                    this.value = this.sliderValueToValue(sliderValue);
                    this.updateLabel();
                    this.onChange(this.value);
                },
                useDirtyWheel: true
            });
            this.updateLabel();
        }, 1);
    }
}










function $8405ecc79d32770a$var$decomposeElString(el) {
    if (el === '') return {};
    let split;
    let tagName;
    const classes = [];
    split = el.split('.');
    if (split.length === 1) {
        split = split[0].split(',');
        tagName = split.shift();
    } else {
        tagName = split.shift();
        split.forEach((item, index)=>{
            const isLast = index === split.length - 1;
            if (isLast) {
                split = item.split(',');
                const last = split.shift();
                if (last !== undefined) classes.push(last);
            } else classes.push(item);
        });
    }
    const result = {};
    if (tagName !== '') result.tagName = tagName;
    if (classes.length > 0) result.classes = classes;
    if (split.length > 0) result.styles = split;
    return result;
}
function $8405ecc79d32770a$var$applyStyleNames(el, styleNames) {
    const style = {};
    const operations = {
        c: (params)=>{
            style.color = params[0];
        },
        bg: (params)=>{
            style.background = params[0];
        },
        p: (params)=>{
            style.padding = params[0] + 'px';
        },
        py: (params)=>{
            style.paddingTop = params[0] + 'px';
            style.paddingBottom = params[0] + 'px';
        },
        pt: (params)=>{
            style.paddingTop = params[0] + 'px';
        },
        pr: (params)=>{
            style.paddingRight = params[0] + 'px';
        },
        pb: (params)=>{
            style.paddingBottom = params[0] + 'px';
        },
        pl: (params)=>{
            style.paddingLeft = params[0] + 'px';
        },
        mt: (params)=>{
            style.marginTop = params[0] + 'px';
        },
        mr: (params)=>{
            style.marginRight = params[0] + 'px';
        },
        mb: (params)=>{
            style.marginBottom = params[0] + 'px';
        },
        ml: (params)=>{
            style.marginLeft = params[0] + 'px';
        },
        // flex
        flex: ()=>{
            style.display = 'flex';
        },
        flexCol: ()=>{
            style.flexDirection = 'column';
        },
        flexWrap: ()=>{
            style.flexWrap = 'wrap';
        },
        gap: (params)=>{
            style.gap = params.map((item)=>item + 'px').join(' ');
        },
        grow: ()=>{
            style.flexGrow = 1;
        },
        justify: (params)=>{
            style.justifyContent = params[0];
        },
        items: (params)=>{
            style.alignItems = params[0];
        },
        hidden: ()=>{
            style.display = 'none';
        },
        nowrap: ()=>{
            style.whiteSpace = 'nowrap';
        },
        abs: (params)=>{
            style.position = 'absolute';
            style.left = params[0] + 'px';
            style.top = params[1] + 'px';
        },
        w: (params)=>{
            style.width = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        h: (params)=>{
            style.height = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        minh: (params)=>{
            style.minHeight = params[0] + 'px';
        },
        z: (params)=>{
            style.zIndex = params[0];
        },
        overflow: (params)=>{
            style.overflow = params[0];
        },
        pos: (params)=>{
            style.position = params[0];
        },
        left: (params)=>{
            style.left = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        top: (params)=>{
            style.top = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        right: (params)=>{
            style.right = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        bottom: (params)=>{
            style.bottom = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        size: (params)=>{
            style.fontSize = params[0] + 'px';
        },
        pointer: (params)=>{
            style.pointerEvents = params[0];
        }
    };
    styleNames.forEach((item)=>{
        const params = item.split('-');
        const operation = params.shift();
        operations[operation](params);
    });
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(el, style);
}
function $8405ecc79d32770a$export$db3b6bfb95261072(element, inner) {
    if (element === undefined) return document.createElement('div');
    if (typeof element !== 'string') {
        if (!(element instanceof HTMLElement)) element = (0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)(element);
        if (inner) {
            if (typeof inner === 'string') element.innerHTML = inner;
            else element.append(...inner);
        }
        return element;
    }
    const decomp = $8405ecc79d32770a$var$decomposeElString(element);
    const result = document.createElement(decomp.tagName ?? 'div');
    decomp.classes && result.classList.add(...decomp.classes);
    decomp.styles && $8405ecc79d32770a$var$applyStyleNames(result, decomp.styles);
    if (inner) {
        if (typeof inner === 'string') result.innerHTML = inner;
        else result.append(...inner);
    }
    return result;
}


var $57d556fd31824ba3$export$e8e78c978b129247;
var $57d556fd31824ba3$export$9852986a3ec5f6a0;
var $57d556fd31824ba3$export$fb184b623420d9be;
$57d556fd31824ba3$export$e8e78c978b129247 = `_7-bVqq_root`;
$57d556fd31824ba3$export$9852986a3ec5f6a0 = `_7-bVqq_table`;
$57d556fd31824ba3$export$fb184b623420d9be = `_7-bVqq_title`;







class $daa5c765527ff785$export$87dc5ec3506b6854 {
    applyPosition() {
        const rect = this.rootEl.getBoundingClientRect();
        if (this.doCenterInitially) {
            this.doCenterInitially = false;
            this.position.x = (window.innerWidth - rect.width) / 2;
            this.position.y = (window.innerHeight - rect.height) / 2;
        }
        this.position.x = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(this.position.x, 0, Math.max(0, window.innerWidth - rect.width));
        this.position.y = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(this.position.y, 0, Math.max(0, window.innerHeight - rect.height));
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
            left: this.position.x,
            top: this.position.y,
            visibility: 'visible'
        });
        this.fractionalPosition.x = (this.position.x + rect.width / 2) / window.innerWidth;
        this.fractionalPosition.y = (this.position.y + rect.height / 2) / window.innerHeight;
    }
    // keep window roughly in same area - similar to easel
    applyFractionalPosition() {
        const newFloatingCenterX = Math.round(window.innerWidth * this.fractionalPosition.x);
        const newFloatingCenterY = Math.round(window.innerHeight * this.fractionalPosition.y);
        const rect = this.rootEl.getBoundingClientRect();
        this.position.x = newFloatingCenterX - rect.width / 2;
        this.position.y = newFloatingCenterY - rect.height / 2;
        this.applyPosition();
    }
    destroy() {
        if (this.isDestroyed) return;
        this.isDestroyed = true;
        this.rootEl.remove();
        if (this.outsideClickListenerTimeout !== undefined) {
            clearTimeout(this.outsideClickListenerTimeout);
            this.outsideClickListenerTimeout = undefined;
        }
        document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        window.removeEventListener('resize', this.onResize);
        this.pointerListener.destroy();
        this.destroyer.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.fractionalPosition = {
            x: 0.5,
            y: 0.5
        };
        this.isDestroyed = false;
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.position = p.position ? {
            ...p.position
        } : {
            x: 0,
            y: 0
        };
        this.doCenterInitially = !p.position;
        this.onDocumentPointerDown = (event)=>{
            if (p.triggerElement && p.triggerElement.contains(event.target)) return;
            if (this.rootEl.contains(event.target)) return;
            this.destroy();
            p.onClose?.();
        };
        this.onResize = ()=>this.applyFractionalPosition();
        this.closeButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'popup-x',
            content: `<img alt="${(0, $fc42a07754814920$export$ce37e184d908d785)('modal-close')}" height="20" src="${(0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('cancel')}">`,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('modal-close'),
            destroyer: this.destroyer,
            onClick: ()=>{
                this.destroy();
                p.onClose?.();
            },
            css: {
                width: 32,
                height: 32,
                lineHeight: '32px',
                background: 'none',
                boxShadow: 'none'
            },
            props: {
                tabIndex: 0
            }
        });
        const header = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-floating-window-header'
        });
        header.append(this.closeButton);
        const body = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: p.content,
            css: {
                minWidth: 0,
                minHeight: 0,
                overflow: 'auto'
            }
        });
        let downPosition = {
            x: 0,
            y: 0
        };
        let isDragging = false;
        this.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: header,
            onPointer: (event)=>{
                if (!isDragging && event.button === 'left' && event.type === 'pointerdown') {
                    if (event.target && this.closeButton.contains(event.target)) // don't drag close button
                    return;
                    event.eventPreventDefault();
                    isDragging = true;
                    downPosition = {
                        ...this.position
                    };
                }
                if (isDragging && event.button === 'left' && event.type === 'pointermove') {
                    event.eventPreventDefault();
                    this.position.x = downPosition.x + event.pageX - event.downPageX;
                    this.position.y = downPosition.y + event.pageY - event.downPageY;
                    this.applyPosition();
                }
                if (isDragging && event.type === 'pointerup') {
                    p.onMove?.({
                        ...this.position
                    });
                    isDragging = false;
                }
            }
        });
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-floating-window',
            css: {
                position: 'fixed',
                display: 'flex',
                flexDirection: 'column',
                left: this.position.x,
                top: this.position.y,
                visibility: this.doCenterInitially ? 'hidden' : undefined,
                maxWidth: '100vw',
                maxHeight: '100vh',
                borderRadius: 4,
                overflow: 'hidden'
            }
        });
        this.rootEl.append(header, body);
        document.body.append(this.rootEl);
        window.addEventListener('resize', this.onResize);
        setTimeout(()=>this.applyPosition());
        if (p.closeOnOutsideClick) {
            this.outsideClickListenerTimeout = undefined;
            document.addEventListener('pointerdown', this.onDocumentPointerDown);
        }
    }
}



class $53651500142d0776$var$ChannelInputTableRow {
    setColor(color) {
        if (!this.input.getIsFocused()) this.input.setValue(color[this.channel]);
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.input.destroy();
    }
    constructor(p){
        this.channel = p.channel;
        this.input = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            name: 'manual-color-' + this.channel,
            init: p.value,
            min: 0,
            max: 255,
            step: 1,
            type: 'number',
            css: {
                width: 80
            },
            onChange: (value)=>p.onChange(this.channel, value)
        });
        const label = {
            r: (0, $fc42a07754814920$export$ce37e184d908d785)('red'),
            g: (0, $fc42a07754814920$export$ce37e184d908d785)('green'),
            b: (0, $fc42a07754814920$export$ce37e184d908d785)('blue')
        }[this.channel];
        this.rootEl = (0, $8405ecc79d32770a$export$db3b6bfb95261072)('tr', [
            (0, $8405ecc79d32770a$export$db3b6bfb95261072)('td,pr-10', label),
            (0, $8405ecc79d32770a$export$db3b6bfb95261072)('td', [
                this.input.getElement()
            ])
        ]);
    }
}
class $53651500142d0776$export$84716e3b5dbece5f {
    emitChange() {
        this.onChange?.(new (0, $be957da3610487e9$export$921068d8846a1559).RGB(this.value.r, this.value.g, this.value.b));
    }
    updateFromHex(value) {
        this.value = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.hexToRGB(value);
        this.channelInputs.forEach((item)=>item.setColor(this.value));
        this.emitChange();
    }
    updateFromRgb(channel, value) {
        this.value[channel] = value;
        this.hexInput.setValue('#' + (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHexString(this.value));
        this.emitChange();
    }
    setColor(color) {
        this.value = new (0, $be957da3610487e9$export$921068d8846a1559).RGB(color.r, color.g, color.b);
        if (!this.hexInput.getIsFocused()) this.hexInput.setValue('#' + (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHexString(this.value));
        this.channelInputs.forEach((item)=>item.setColor(this.value));
    }
    destroy() {
        if (this.isDestroyed) return;
        this.isDestroyed = true;
        this.destroyer.destroy();
        this.hexInput.destroy();
        this.channelInputs.forEach((item)=>item.destroy());
        this.channelInputs.splice(0, this.channelInputs.length);
        this.floatingWindow.destroy();
        this.onClose();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.isDestroyed = false;
        this.value = new (0, $be957da3610487e9$export$921068d8846a1559).RGB(p.color.r, p.color.g, p.color.b);
        this.onClose = p.onClose;
        this.onChange = p.onChange;
        // hex input
        const hexLabel = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('mci-hex')
        });
        this.hexInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            name: 'manual-color-hex',
            init: '#' + (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHexString(this.value),
            css: {
                width: 80
            },
            validate: (value)=>(0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.hexToRGB(value) !== undefined,
            constrain: (value)=>{
                const trimmedValue = value.trim();
                return trimmedValue.startsWith('#') ? trimmedValue : '#' + trimmedValue;
            },
            onChange: (value)=>this.updateFromHex(value)
        });
        this.copyButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            destroyer: this.destroyer,
            content: (0, $1b4b6b9aff0ae5e5$export$dd7d56122b36f42e)('copy', {
                height: 20
            }),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('mci-copy'),
            onClick: ()=>{
                this.hexInput.select();
                navigator.clipboard.writeText(this.hexInput.getValue()).then().catch();
            }
        });
        const hexRowEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                hexLabel,
                (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,items-center,gap-10', [
                    this.hexInput.getElement(),
                    this.copyButton
                ])
            ],
            css: {
                display: 'flex',
                alignItems: 'center',
                marginBottom: 15,
                flexWrap: 'wrap',
                gap: '5px 10px',
                maxWidth: 250
            }
        });
        // rgb channel inputs
        this.channelInputs = [
            new $53651500142d0776$var$ChannelInputTableRow({
                channel: 'r',
                value: this.value.r,
                onChange: (channel, value)=>this.updateFromRgb(channel, value)
            }),
            new $53651500142d0776$var$ChannelInputTableRow({
                channel: 'g',
                value: this.value.g,
                onChange: (channel, value)=>this.updateFromRgb(channel, value)
            }),
            new $53651500142d0776$var$ChannelInputTableRow({
                channel: 'b',
                value: this.value.b,
                onChange: (channel, value)=>this.updateFromRgb(channel, value)
            })
        ];
        const contentEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                hexRowEl,
                (0, $8405ecc79d32770a$export$db3b6bfb95261072)('table.' + $57d556fd31824ba3$export$9852986a3ec5f6a0, [
                    (0, $8405ecc79d32770a$export$db3b6bfb95261072)('tbody', this.channelInputs.map((item)=>item.getElement()))
                ])
            ]
        });
        const rootEl = (0, $8405ecc79d32770a$export$db3b6bfb95261072)('.' + $57d556fd31824ba3$export$e8e78c978b129247, [
            (0, $8405ecc79d32770a$export$db3b6bfb95261072)('b.' + $57d556fd31824ba3$export$fb184b623420d9be, (0, $fc42a07754814920$export$ce37e184d908d785)('manual-color-input')),
            contentEl
        ]);
        this.floatingWindow = new (0, $daa5c765527ff785$export$87dc5ec3506b6854)({
            content: rootEl,
            onClose: ()=>this.destroy(),
            onMove: p.onMove,
            position: p.position
        });
        setTimeout(()=>{
            if (this.isDestroyed) return;
            this.hexInput.focus();
            this.hexInput.select();
        });
    }
}






const $96c8dd5f33e03504$var$LS_THEME_KEY = 'klecks-theme';
class $96c8dd5f33e03504$var$Theme {
    updateTheme() {
        const oldTheme = this.theme;
        this.theme = this.storedTheme || this.mediaQueryTheme;
        if (this.theme === oldTheme) return;
        document.documentElement.classList.toggle('kl-theme-dark', this.theme === 'dark');
        this.listeners.forEach((item)=>item());
    }
    readLocalStorage() {
        let result = (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem($96c8dd5f33e03504$var$LS_THEME_KEY);
        if (!result || typeof result === 'string' && ![
            'dark',
            'light'
        ].includes(result)) {
            result = undefined;
            (0, $7a8f101d3676d17a$export$19fffca37ef3e106).removeItem($96c8dd5f33e03504$var$LS_THEME_KEY); // reset because invalid
        }
        return result;
    }
    isDark() {
        return this.theme === 'dark';
    }
    addIsDarkListener(func) {
        if (this.listeners.includes(func)) return;
        this.listeners.push(func);
    }
    removeIsDarkListener(func) {
        for(let i = 0; i < this.listeners.length; i++)if (this.listeners[i] === func) {
            this.listeners.splice(i, 1);
            return;
        }
    }
    getMediaQueryTheme() {
        return this.mediaQueryTheme;
    }
    getStoredTheme() {
        return this.storedTheme;
    }
    setStoredTheme(theme) {
        if (theme) (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem($96c8dd5f33e03504$var$LS_THEME_KEY, theme);
        else (0, $7a8f101d3676d17a$export$19fffca37ef3e106).removeItem($96c8dd5f33e03504$var$LS_THEME_KEY);
        this.storedTheme = theme;
        this.updateTheme();
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        // initialization will be overwritten.
        this.mediaQueryTheme = 'light' // prefers-color-scheme
        ;
        this.theme = 'light';
        this.listeners = [];
        // init media query
        this.mediaQueryTheme = (0, $94f0b2b810d4d191$export$a79ad82046afa44e)() ? 'dark' : 'light';
        (0, $94f0b2b810d4d191$export$a9dfd81f95a8a526)(()=>{
            this.mediaQueryTheme = (0, $94f0b2b810d4d191$export$a79ad82046afa44e)() ? 'dark' : 'light';
            this.updateTheme();
        });
        // init local storage
        this.storedTheme = this.readLocalStorage();
        addEventListener('storage', (e)=>{
            if (e.key === $96c8dd5f33e03504$var$LS_THEME_KEY) {
                this.storedTheme = this.readLocalStorage();
                this.updateTheme();
            }
        });
        this.updateTheme();
    }
}
const $96c8dd5f33e03504$export$5714e40777c1bcc2 = new $96c8dd5f33e03504$var$Theme();


const $bc268e0fc7103648$export$e4203cb02d5e5b28 = (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).isDark() ? 255 : 255;
function $bc268e0fc7103648$export$8627e24041b28589() {
    return {
        r: $bc268e0fc7103648$export$e4203cb02d5e5b28,
        g: $bc268e0fc7103648$export$e4203cb02d5e5b28,
        b: $bc268e0fc7103648$export$e4203cb02d5e5b28
    };
}




function $3ca7117411f9d5a7$export$eed76a6c3d7eed98(grad) {
    for(let i = 0; i <= 100; i++){
        const frac = i / 100;
        const col = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(new (0, $be957da3610487e9$export$921068d8846a1559).HSV(frac * 360, 100, 100));
        grad.addColorStop(frac, '#' + (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHexString(col));
    }
}


const $14647f881f00eb2f$var$eyedropperImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-picker');
class $14647f881f00eb2f$export$4e5102252876c5d7 {
    updatePrimaryHSV(hsv) {
        if (hsv.s === 0) this.primaryColorHsv = new (0, $be957da3610487e9$export$921068d8846a1559).HSV(this.primaryColorHsv.h, hsv.s, hsv.v);
        else this.primaryColorHsv = new (0, $be957da3610487e9$export$921068d8846a1559).HSV(hsv.h, hsv.s, hsv.v);
    }
    updateSVCanvas() {
        const rgb = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(new (0, $be957da3610487e9$export$921068d8846a1559).HSV(this.primaryColorHsv.h, 100, 100));
        this.svGradient.style.setProperty('--kl-color-picker--hue', '#' + (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHexString(rgb));
    }
    updateSVPointer() {
        const left = this.primaryColorHsv.s / 100 * this.width - 7;
        const top = (1 - this.primaryColorHsv.v / 100) * this.svHeight - 6;
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.pointerSV, {
            left: left,
            top: top
        });
    }
    setColPreview() {
        this.divPreview.style.backgroundColor = 'rgb(' + this.primaryColorRgb.r + ',' + this.primaryColorRgb.g + ',' + this.primaryColorRgb.b + ')';
        if ((0, $be957da3610487e9$export$921068d8846a1559).testIsWhiteBestContrast(this.primaryColorRgb)) {
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.pickerButton, {
                filter: 'invert(1)'
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.hexButton, {
                filter: 'invert(1)'
            });
        } else {
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.pickerButton, {
                filter: ''
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.hexButton, {
                filter: ''
            });
        }
        this.hexColorWindow?.setColor(this.primaryColorRgb);
    }
    updateSecondaryColor() {
        this.secondaryColorBtn.style.backgroundColor = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr(this.secondaryColorRgb);
    }
    setColor(c) {
        this.primaryColorRgb = {
            r: parseInt('' + c.r),
            g: parseInt('' + c.g),
            b: parseInt('' + c.b)
        };
        this.updatePrimaryHSV((0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHSV(c));
        this.controlH.style.left = parseInt('' + (this.primaryColorHsv.h / 359 * this.width - 1)) + 'px';
        this.updateSVCanvas();
        this.updateSVPointer();
        this.setColPreview();
    }
    getColor() {
        return new (0, $be957da3610487e9$export$921068d8846a1559).RGB(this.primaryColorRgb.r, this.primaryColorRgb.g, this.primaryColorRgb.b);
    }
    getSecondaryRGB() {
        return new (0, $be957da3610487e9$export$921068d8846a1559).RGB(this.secondaryColorRgb.r, this.secondaryColorRgb.g, this.secondaryColorRgb.b);
    }
    getIsEyedropping() {
        return this.isPicking;
    }
    setIsEyedropping(b) {
        if (b) {
            this.isPicking = true;
            this.onEyedropper(true);
            this.pickerButton.classList.add('color-picker-preview-button-active');
        } else {
            this.isPicking = false;
            this.onEyedropper(false);
            this.pickerButton.classList.remove('color-picker-preview-button-active');
        }
    }
    enable(e) {
        const style = {
            pointerEvents: e ? undefined : 'none',
            opacity: e ? 1 : 0.5
        };
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, style);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.outputDiv, style);
    }
    setHeight(h) {
        h = parseInt('' + (h - this.height * 2 - 3), 10);
        if (h === this.svHeight) return;
        this.svHeight = h;
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.svGradient, {
            width: this.width,
            height: this.svHeight
        });
        this.SVContainer.style.height = this.svHeight + 'px';
        this.updateSVPointer();
    }
    swapColors() {
        // swap hsv
        let tmp = this.secondaryColorHsv;
        this.secondaryColorHsv = this.primaryColorHsv;
        this.updatePrimaryHSV(tmp);
        // swap rgb
        tmp = this.secondaryColorRgb;
        this.secondaryColorRgb = this.primaryColorRgb;
        this.primaryColorRgb = tmp;
        this.controlH.style.left = parseInt('' + (this.primaryColorHsv.h / 359 * this.width - 1)) + 'px';
        this.updateSVCanvas();
        this.updateSVPointer();
        this.setColPreview();
        this.updateSecondaryColor();
        this.emitColor(new (0, $be957da3610487e9$export$921068d8846a1559).RGB(this.primaryColorRgb.r, this.primaryColorRgb.g, this.primaryColorRgb.b));
    }
    getElement() {
        return this.rootEl;
    }
    getOutputElement() {
        return this.outputDiv;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-color-picker',
            css: {
                position: 'relative',
                zIndex: 0
            }
        });
        this.outputDiv = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        this.width = p.width;
        this.svHeight = p.svHeight;
        this.height = p.height;
        this.emitColor = p.onPick;
        this.onEyedropper = p.onEyedropper;
        this.primaryColorRgb = {
            r: parseInt('' + p.startValue.r),
            g: parseInt('' + p.startValue.g),
            b: parseInt('' + p.startValue.b)
        };
        this.primaryColorHsv = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHSV(p.startValue); // BB.HSV
        this.secondaryColorRgb = {
            r: (0, $bc268e0fc7103648$export$e4203cb02d5e5b28),
            g: (0, $bc268e0fc7103648$export$e4203cb02d5e5b28),
            b: (0, $bc268e0fc7103648$export$e4203cb02d5e5b28)
        };
        this.secondaryColorHsv = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter._RGBtoHSV(this.secondaryColorRgb); // BB.HSV
        const svWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el();
        this.svGradient = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                background: 'linear-gradient(0deg, #000 0%, rgba(255, 0, 0, 0) 100%), linear-gradient(-90deg, var(--kl-color-picker--hue) 0%, #fff 100%)',
                width: this.width,
                height: this.svHeight
            }
        });
        svWrapper.append(this.svGradient);
        const divH = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-color-picker__h',
            css: {
                overflow: 'hidden',
                position: 'relative',
                width: this.width,
                height: this.height,
                cursor: 'ew-resize',
                marginTop: 1,
                marginBottom: 1
            }
        });
        this.divPreview = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-color-picker__preview',
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                width: this.height * 2.5,
                height: this.height
            }
        });
        this.controlH = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const createHueBg = (targetEl)=>{
            const im = new Image();
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(im, {
                position: 'absolute',
                left: 0,
                top: 0,
                display: 'none',
                pointerEvents: 'none'
            });
            const cv = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.width, this.height);
            const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(cv);
            const gradH = ctx.createLinearGradient(0, 0, this.width, 0);
            (0, $3ca7117411f9d5a7$export$eed76a6c3d7eed98)(gradH);
            ctx.fillStyle = gradH;
            ctx.fillRect(0, 0, this.width, this.height);
            targetEl.append(im);
            im.alt = 'hue';
            im.src = cv.toDataURL('image/png');
            im.style.display = 'block';
        };
        this.updateSVCanvas();
        this.rootEl.style.width = this.width + 'px';
        this.rootEl.oncontextmenu = ()=>{
            return false;
        };
        this.SVContainer = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-color-picker__sv',
            css: {
                width: this.width,
                height: this.svHeight,
                overflow: 'hidden',
                display: 'block',
                position: 'relative',
                cursor: 'crosshair'
            }
        });
        this.pointerSV = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: 12,
                height: 12,
                borderRadius: 6,
                position: 'absolute',
                pointerEvents: 'none',
                boxShadow: '0px 0px 0 1px #000, inset 0px 0px 0 1px #fff'
            }
        });
        this.SVContainer.append(svWrapper, this.pointerSV);
        this.updateSVPointer();
        this.rootEl.append(this.SVContainer, divH);
        this.outputDiv.append(this.divPreview);
        //divH.className = "svSlider";
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.controlH, {
            width: 2,
            height: this.height,
            background: '#000',
            borderLeft: '1px solid #fff',
            position: 'absolute',
            top: 0,
            left: parseInt('' + (this.primaryColorHsv.h / 360 * this.width - 1))
        });
        const virtualHSV = {
            h: 0,
            s: 0,
            v: 0
        };
        this.pickerButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('eyedropper') + ' [Alt]',
            className: 'color-picker-preview-button',
            css: {
                width: 30,
                height: 30,
                backgroundImage: 'url(' + $14647f881f00eb2f$var$eyedropperImg + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '70%',
                backgroundPosition: 'center'
            },
            onClick: ()=>{
                if (this.isPicking) this.setIsEyedropping(false);
                else {
                    this.pickerButton.classList.remove('color-picker-preview-button-hover');
                    this.pickerButton.classList.add('color-picker-preview-button-active');
                    this.isPicking = true;
                    this.onEyedropper(true);
                }
            }
        });
        this.isPicking = false;
        const pickerButtonPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.pickerButton,
            onEnterLeave: (isOver)=>{
                if (this.isPicking) return;
                this.pickerButton.classList.toggle('color-picker-preview-button-hover', isOver);
            }
        });
        this.divPreview.append(this.pickerButton);
        this.hexButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: '#',
            className: 'color-picker-preview-button',
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('manual-color-input'),
            css: {
                height: '100%',
                width: this.height,
                lineHeight: this.height + 'px',
                fontSize: this.height * 0.65
            },
            onClick: ()=>{
                if (this.hexColorWindow) {
                    this.hexColorWindow.destroy();
                    this.hexColorWindow = undefined;
                    return;
                }
                this.hexColorWindow = new (0, $53651500142d0776$export$84716e3b5dbece5f)({
                    color: new (0, $be957da3610487e9$export$921068d8846a1559).RGB(this.primaryColorRgb.r, this.primaryColorRgb.g, this.primaryColorRgb.b),
                    position: this.hexColorWindowPosition,
                    onChange: (rgbObj)=>{
                        this.setColor(rgbObj);
                        this.emitColor(new (0, $be957da3610487e9$export$921068d8846a1559).RGB(this.primaryColorRgb.r, this.primaryColorRgb.g, this.primaryColorRgb.b));
                    },
                    onClose: ()=>{
                        this.hexColorWindow = undefined;
                    },
                    onMove: (position)=>{
                        this.hexColorWindowPosition = position;
                    }
                });
            }
        });
        const hexButtonPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.hexButton,
            onEnterLeave: (isOver)=>{
                this.hexButton.classList.toggle('color-picker-preview-button-hover', isOver);
            }
        });
        this.divPreview.append(this.hexButton);
        this.setColPreview();
        setTimeout(()=>{
            createHueBg(divH);
            divH.append(this.controlH);
            const svPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                target: svWrapper,
                fixScribble: true,
                onPointer: (event)=>{
                    if (event.type === 'pointerdown') {
                        // prevent manual slider input keeping focus on iPad
                        (0, $be957da3610487e9$export$921068d8846a1559).unfocusAnyInput();
                        this.SVContainer.classList.toggle('kl-color-picker--active', true);
                        if (event.button === 'left') {
                            virtualHSV.s = event.relX / this.width * 100;
                            virtualHSV.v = 100 - event.relY / this.svHeight * 100;
                            this.primaryColorHsv = new (0, $be957da3610487e9$export$921068d8846a1559).HSV(this.primaryColorHsv.h, virtualHSV.s, virtualHSV.v);
                            this.primaryColorRgb = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv);
                            this.updateSVPointer();
                            this.setColPreview();
                            this.emitColor((0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv));
                        } else {
                            virtualHSV.s = this.primaryColorHsv.s;
                            virtualHSV.v = this.primaryColorHsv.v;
                        }
                    }
                    if (event.type === 'pointermove' && [
                        'left',
                        'right'
                    ].includes(event.button || '')) {
                        let factor = 1;
                        if (event.button === 'right') factor = 0.5;
                        virtualHSV.s += event.dX / this.width * 100 * factor;
                        virtualHSV.v -= event.dY / this.svHeight * 100 * factor;
                        this.primaryColorHsv = new (0, $be957da3610487e9$export$921068d8846a1559).HSV(this.primaryColorHsv.h, virtualHSV.s, virtualHSV.v);
                        this.primaryColorRgb = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv);
                        this.updateSVPointer();
                        this.setColPreview();
                        this.emitColor((0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv));
                    }
                    if (event.type === 'pointerup') this.SVContainer.classList.toggle('kl-color-picker--active', false);
                }
            });
            const hPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                target: divH,
                fixScribble: true,
                onPointer: (event)=>{
                    if (event.type === 'pointerdown') {
                        // prevent manual slider input keeping focus on iPad
                        (0, $be957da3610487e9$export$921068d8846a1559).unfocusAnyInput();
                        divH.classList.toggle('kl-color-picker--active', true);
                        if (event.button === 'left') {
                            virtualHSV.h = event.relX / this.width * 359.99;
                            this.primaryColorHsv = new (0, $be957da3610487e9$export$921068d8846a1559).HSV(virtualHSV.h, this.primaryColorHsv.s, this.primaryColorHsv.v);
                            this.primaryColorRgb = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv);
                            this.controlH.style.left = Math.round(this.primaryColorHsv.h / 359.99 * this.width) - 1 + 'px';
                            this.updateSVCanvas();
                            this.setColPreview();
                            this.emitColor((0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv));
                        } else virtualHSV.h = this.primaryColorHsv.h;
                    }
                    if (event.type === 'pointermove' && [
                        'left',
                        'right'
                    ].includes(event.button || '')) {
                        const deltaY = Math.abs(event.pageY - event.downPageY);
                        const factor = (0, $61c75be24be916f2$export$f8e41e222e32615d)(deltaY, event.button === 'right');
                        virtualHSV.h += event.dX / this.width * 359.99 * factor;
                        if (event.button === 'right') {
                            virtualHSV.h = virtualHSV.h % 359.99;
                            if (virtualHSV.h < 0) virtualHSV.h += 359.99;
                        }
                        virtualHSV.h = Math.min(359.99, virtualHSV.h);
                        this.primaryColorHsv = new (0, $be957da3610487e9$export$921068d8846a1559).HSV(virtualHSV.h, this.primaryColorHsv.s, this.primaryColorHsv.v);
                        this.primaryColorRgb = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv);
                        this.controlH.style.left = Math.round(this.primaryColorHsv.h / 359.99 * this.width) - 1 + 'px';
                        this.updateSVCanvas();
                        this.setColPreview();
                        this.emitColor((0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.primaryColorHsv));
                    }
                    if (event.type === 'pointerup') divH.classList.toggle('kl-color-picker--active', false);
                }
            });
        }, 1);
        // --- secondary color ---
        this.secondaryColorBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.outputDiv,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('secondary-color') + ' [X]',
            className: 'kl-color-picker__secondary',
            css: {
                cursor: 'pointer',
                marginLeft: 5,
                width: 22,
                height: 22
            },
            onClick: (e)=>{
                e.preventDefault();
                this.swapColors();
            }
        });
        this.updateSecondaryColor();
    }
}






class $845fa9514537a3d1$export$66306bf21a9ff39e {
    updateSV() {
        const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.canvasSV);
        if (!ctx) throw new Error("couldn't create canvas");
        for(let i = 0; i < this.canvasSV.height; i += 1){
            const gradient1 = ctx.createLinearGradient(0, 0, this.canvasSV.width, 0);
            const colleft = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(new (0, $be957da3610487e9$export$921068d8846a1559).HSV(this.color.h, 1, 100 - i / this.canvasSV.height * 100.0));
            const colright = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(new (0, $be957da3610487e9$export$921068d8846a1559).HSV(this.color.h, 100, 100 - i / this.canvasSV.height * 100.0));
            gradient1.addColorStop(0, '#' + (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHexString(colleft));
            gradient1.addColorStop(1, '#' + (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHexString(colright));
            ctx.fillStyle = '#ff0000'; //needed for chrome...otherwise alpha problem
            ctx.fillStyle = gradient1;
            ctx.fillRect(0, i, this.canvasSV.width, 1);
        }
    }
    updateSVPointer() {
        const left = this.color.s / 100 * this.width - this.svCircleRadius;
        const top = (1 - this.color.v / 100) * this.heightSV - this.svCircleRadius;
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.pointerSV, {
            left: left,
            top: top
        });
    }
    updateHPointer() {
        this.pointerH.style.left = this.color.h / 359.999 * this.width - 1 + 'px';
    }
    // ---- interface ----
    setColor(c) {
        if (this.hPointerId !== null || this.svPointerId !== null) return;
        this.color = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHSV(new (0, $be957da3610487e9$export$921068d8846a1559).RGB(c.r, c.g, c.b));
        this.updateSV();
        this.updateSVPointer();
        this.updateHPointer();
    }
    getColor() {
        return (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.color);
    }
    getElement() {
        return this.rootEl;
    }
    end() {
        this.svPointerId = null;
        this.hPointerId = null;
    }
    destroy() {
        this.svPointerListener.destroy();
        this.hPointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.svCircleRadius = 6;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: p.width,
                position: 'relative',
                overflow: 'hidden',
                userSelect: 'none'
            }
        });
        this.rootEl.oncontextmenu = (e)=>{
            e.preventDefault();
        };
        this.color = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHSV(new (0, $be957da3610487e9$export$921068d8846a1559).RGB(p.color.r, p.color.g, p.color.b));
        this.width = p.width;
        this.heightSV = p.heightSV;
        this.canvasSV = (0, $be957da3610487e9$export$921068d8846a1559).canvas(10, 10);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.canvasSV, {
            width: this.width,
            height: this.heightSV,
            cursor: 'crosshair'
        });
        this.updateSV();
        const canvasH = (0, $be957da3610487e9$export$921068d8846a1559).canvas(p.width, p.heightH);
        canvasH.style.cursor = 'ew-resize';
        (()=>{
            const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvasH);
            const gradH = ctx.createLinearGradient(0, 0, p.width, 0);
            (0, $3ca7117411f9d5a7$export$eed76a6c3d7eed98)(gradH);
            ctx.fillStyle = gradH;
            ctx.fillRect(0, 0, p.width, p.heightH);
        })();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.canvasSV, {
            width: p.width,
            height: p.heightSV,
            overflow: 'hidden',
            position: 'relative'
        });
        this.canvasSV.style.float = 'left';
        canvasH.style.float = 'left';
        this.rootEl.append(this.canvasSV, canvasH);
        this.pointerSV = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                width: this.svCircleRadius * 2,
                height: this.svCircleRadius * 2,
                borderRadius: this.svCircleRadius,
                position: 'absolute',
                pointerEvents: 'none',
                boxShadow: '0 0 0 1px #000, inset 0 0 0 1px #fff'
            }
        });
        this.pointerH = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                width: 0,
                height: p.heightH,
                borderLeft: '1px solid #fff',
                borderRight: '1px solid #000',
                position: 'absolute',
                top: p.heightSV,
                pointerEvents: 'none'
            }
        });
        this.updateSVPointer();
        this.updateHPointer();
        const virtualHSV = {
            h: 0,
            s: 0,
            v: 0
        };
        this.svPointerId = null;
        this.svPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.canvasSV,
            fixScribble: true,
            onPointer: (event)=>{
                if (event.type === 'pointerdown') {
                    // prevent manual slider input keeping focus on iPad
                    (0, $be957da3610487e9$export$921068d8846a1559).unfocusAnyInput();
                    this.svPointerId = event.pointerId;
                    if (event.button === 'left') {
                        virtualHSV.s = event.relX / p.width * 100;
                        virtualHSV.v = 100 - event.relY / p.heightSV * 100;
                        this.color = new (0, $be957da3610487e9$export$921068d8846a1559).HSV(this.color.h, virtualHSV.s, virtualHSV.v);
                        this.updateSVPointer();
                        p.callback((0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.color));
                    } else {
                        virtualHSV.s = this.color.s;
                        virtualHSV.v = this.color.v;
                    }
                }
                if (event.type === 'pointermove' && [
                    'left',
                    'right'
                ].includes('' + event.button) && this.svPointerId === event.pointerId) {
                    let factor = 1;
                    if (event.button === 'right') factor = 0.5;
                    virtualHSV.s += event.dX / p.width * 100 * factor;
                    virtualHSV.v -= event.dY / p.heightSV * 100 * factor;
                    this.color = new (0, $be957da3610487e9$export$921068d8846a1559).HSV(this.color.h, virtualHSV.s, virtualHSV.v);
                    this.updateSVPointer();
                    p.callback((0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.color));
                }
                if (event.type === 'pointerup') this.svPointerId = null;
            }
        });
        this.hPointerId = null;
        this.hPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: canvasH,
            fixScribble: true,
            onPointer: (event)=>{
                if (event.type === 'pointerdown') {
                    this.hPointerId = event.pointerId;
                    if (event.button === 'left') {
                        virtualHSV.h = event.relX / p.width * 359.99;
                        this.color = new (0, $be957da3610487e9$export$921068d8846a1559).HSV(virtualHSV.h, this.color.s, this.color.v);
                        this.updateSV();
                        this.updateHPointer();
                        p.callback((0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.color));
                    } else virtualHSV.h = this.color.h;
                }
                if (event.type === 'pointermove' && [
                    'left',
                    'right'
                ].includes('' + event.button) && this.hPointerId === event.pointerId) {
                    const deltaY = Math.abs(event.pageY - event.downPageY);
                    const factor = (0, $61c75be24be916f2$export$f8e41e222e32615d)(deltaY, event.button === 'right');
                    virtualHSV.h += event.dX / p.width * 359.99 * factor;
                    if (event.button === 'right') {
                        virtualHSV.h = virtualHSV.h % 359.99;
                        if (virtualHSV.h < 0) virtualHSV.h += 359.99;
                    }
                    virtualHSV.h = Math.min(359.99, virtualHSV.h);
                    this.color = new (0, $be957da3610487e9$export$921068d8846a1559).HSV(virtualHSV.h, this.color.s, this.color.v);
                    this.updateSV();
                    this.updateHPointer();
                    p.callback((0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRGB(this.color));
                }
                if (event.type === 'pointerup') this.hPointerId = null;
            }
        });
        const cleardiv = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                clear: 'both'
            }
        });
    }
}




class $94a8fc3859482fa7$export$ac00cea56cec3037 {
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    setActive(isActive) {
        this.sliderPoint.style.backgroundColor = isActive ? '#fff' : '#eaeaea';
    }
    destroy() {
        this.pointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'relative'
            }
        });
        const sliderLine = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-point-slider__line',
            css: {
                marginTop: parseInt('' + (p.pointSize / 2 - 1)),
                width: p.width
            }
        });
        this.sliderPoint = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-point-slider__point'
        });
        let sliderPos;
        //sliderPoint
        const touchAreaEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            // expand clickable area
            parent: this.sliderPoint,
            css: {
                // background: 'rgba(255,0,0,0.4)',
                margin: '-7px 0 0 -7px',
                width: 'calc(100% + 14px)',
                height: 'calc(100% + 7px)'
            }
        });
        const redrawPoint = ()=>{
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.sliderPoint, {
                left: sliderPos
            });
        };
        const getValue = ()=>{
            return sliderPos / (p.width - p.pointSize);
        };
        {
            let isDragging = false;
            let isFirst;
            sliderPos = (0, $be957da3610487e9$export$921068d8846a1559).clamp(p.init * (p.width - p.pointSize), 0, p.width - p.pointSize);
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.sliderPoint, {
                width: p.pointSize,
                height: p.pointSize,
                borderRadius: p.pointSize
            });
            redrawPoint();
            let imaginaryPos;
            this.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                target: this.sliderPoint,
                fixScribble: true,
                onPointer: (event)=>{
                    if (event.type === 'pointerdown' && event.button === 'left' && !p.getDoIgnore()) {
                        isFirst = true;
                        isDragging = true;
                        imaginaryPos = sliderPos;
                        redrawPoint();
                        event.eventStopPropagation();
                    } else if (event.type === 'pointermove' && event.button === 'left' && isDragging) {
                        event.eventStopPropagation();
                        imaginaryPos = imaginaryPos + event.dX;
                        sliderPos = parseInt('' + (0, $be957da3610487e9$export$921068d8846a1559).clamp(imaginaryPos, 0, p.width - p.pointSize));
                        redrawPoint();
                        p.callback(getValue(), isFirst, false);
                        isFirst = false;
                    }
                    if (event.type === 'pointerup' && isDragging) {
                        event.eventStopPropagation();
                        isDragging = false;
                        redrawPoint();
                        p.callback(getValue(), false, true);
                    }
                }
            });
        }
    }
}





var $0ac4f77e333321b9$export$af0e03c0aa23cf3d;
var $0ac4f77e333321b9$export$a75d1723e6bda2ec;
var $0ac4f77e333321b9$export$3c17b0e969a90510;
var $0ac4f77e333321b9$export$cc74dcc53cfce4eb;
$0ac4f77e333321b9$export$af0e03c0aa23cf3d = `DL2sGG_customEl`;
$0ac4f77e333321b9$export$a75d1723e6bda2ec = `DL2sGG_option`;
$0ac4f77e333321b9$export$3c17b0e969a90510 = `DL2sGG_small`;
$0ac4f77e333321b9$export$cc74dcc53cfce4eb = `DL2sGG_wrapper`;



class $bf43abcd46abf209$export$c019608e5b5bb4cb {
    getIndex() {
        for(let i = 0; i < this.optionArr.length; i++){
            if (this.optionArr[i].id === this.selectedId) return i;
        }
        return -1;
    }
    update() {
        for(let i = 0; i < this.optionArr.length; i++){
            const isSelected = this.optionArr[i].id === this.selectedId;
            this.optionArr[i].el.setAttribute('aria-checked', '' + isSelected);
            this.optionArr[i].el.tabIndex = this.isFocusable && isSelected ? 0 : -1;
        }
    }
    selectValue(val, skipEmit) {
        if (this.selectedId === val) return true;
        if (this.onBeforeChange && !this.onBeforeChange(val)) return false;
        this.selectedId = val;
        this.update();
        !skipEmit && this.onChange && this.onChange(this.selectedId);
        return true;
    }
    focusSelected() {
        const index = this.getIndex();
        if (index > -1) this.optionArr[index].el.focus();
    }
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return this.selectedId;
    }
    next() {
        this.setValue(this.optionArr[(this.getIndex() + 1) % this.optionArr.length].id);
    }
    setValue(val, skipEmit) {
        this.selectValue(val, skipEmit);
    }
    updateOption(id, p) {
        const option = this.optionArr.find((item)=>item.id === id);
        if (!option) return;
        if (p.title !== undefined) option.el.title = p.title;
        if (p.ariaLabel !== undefined) option.el.setAttribute('aria-label', p.ariaLabel);
        if (p.css) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(option.el, p.css);
    }
    previous() {
        this.setValue(this.optionArr[(this.optionArr.length + this.getIndex() - 1) % this.optionArr.length].id);
    }
    destroy() {
        if (this.keydownListener) this.wrapperEl.removeEventListener('keydown', this.keydownListener);
        this.rootEl.remove();
        this.destroyer.destroy();
        this.optionArr.splice(0, this.optionArr.length);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: p.css
        });
        this.isFocusable = !!p.isFocusable;
        this.wrapperEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: $0ac4f77e333321b9$export$cc74dcc53cfce4eb,
            props: {
                role: 'radiogroup',
                ariaOrientation: p.isColumn ? 'vertical' : 'horizontal',
                ...p.ariaLabel ? {
                    ariaLabel: p.ariaLabel
                } : {}
            },
            css: {
                display: 'flex',
                flexDirection: p.isColumn ? 'column' : 'row'
            }
        });
        this.onChange = p.onChange;
        this.onBeforeChange = p.onBeforeChange;
        this.optionArr = [];
        this.selectedId = p.initId !== undefined ? p.initId : p.optionArr[0].id;
        const createOption = (o)=>{
            const classArr = [
                $0ac4f77e333321b9$export$a75d1723e6bda2ec
            ];
            if (p.isSmall) classArr.push($0ac4f77e333321b9$export$3c17b0e969a90510);
            if (o.label && typeof o.label !== 'string') {
                classArr.push($0ac4f77e333321b9$export$af0e03c0aa23cf3d);
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(o.label, {
                    display: 'block',
                    pointerEvents: 'none'
                });
            }
            const ariaLabel = o.ariaLabel ?? (o.title && typeof o.label !== 'string' ? o.title : undefined);
            if (this.isFocusable) // important because you change the active option via keyboard presses
            classArr.push((0, $9e4d66c06c67fa7f$export$e11d0f35da1b29a3));
            const optionObj = {
                id: o.id,
                el: (0, $be957da3610487e9$export$921068d8846a1559).el({
                    parent: this.wrapperEl,
                    tagName: 'button',
                    content: o.label ?? '',
                    className: classArr,
                    destroyer: this.destroyer,
                    onClick: ()=>{
                        if (this.selectedId === optionObj.id) p.onClickSelected?.(optionObj.id, optionObj.el);
                        else this.selectValue(optionObj.id);
                        if (this.isFocusable) this.focusSelected();
                    },
                    css: {
                        ...p.optionCss,
                        ...o.css
                    },
                    props: {
                        // per default would be "submit"
                        type: 'button',
                        role: 'radio',
                        ...ariaLabel ? {
                            ariaLabel: ariaLabel
                        } : {}
                    }
                })
            };
            if (o.title) optionObj.el.title = o.title;
            this.optionArr.push(optionObj);
        };
        for(let i = 0; i < p.optionArr.length; i++)createOption(p.optionArr[i]);
        if (this.isFocusable) {
            this.keydownListener = (event)=>{
                let nextIndex;
                const currentIndex = this.getIndex();
                if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.optionArr.length;
                else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (this.optionArr.length + currentIndex - 1) % this.optionArr.length;
                else if (event.key === 'Home') nextIndex = 0;
                else if (event.key === 'End') nextIndex = this.optionArr.length - 1;
                else if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                    event.stopPropagation();
                    return;
                } else return;
                event.preventDefault();
                event.stopPropagation();
                this.selectValue(this.optionArr[nextIndex].id);
                this.focusSelected();
            };
            this.wrapperEl.addEventListener('keydown', this.keydownListener);
        }
        this.update();
        if (p.changeOnInit) setTimeout(()=>{
            this.onChange && this.onChange(this.selectedId);
        }, 0);
    }
}


var $bc54f3b145e2f7ef$export$e8e78c978b129247;
$bc54f3b145e2f7ef$export$e8e78c978b129247 = `yxLveW_root`;




class $364f444c1ac877b6$export$214507535a0fe5b2 {
    setColor(color) {
        this.colorPicker.setColor(color);
    }
    destroy() {
        if (this.isDestroyed) return;
        this.isDestroyed = true;
        this.floatingWindow.destroy();
        this.colorPicker.destroy();
    }
    constructor(p){
        this.isDestroyed = false;
        this.colorPicker = new (0, $845fa9514537a3d1$export$66306bf21a9ff39e)({
            width: 200,
            heightSV: 200,
            heightH: 30,
            color: p.color,
            callback: p.onChange
        });
        this.floatingWindow = new (0, $daa5c765527ff785$export$87dc5ec3506b6854)({
            content: this.colorPicker.getElement(),
            onClose: ()=>{
                this.destroy();
                p.onClose?.();
            },
            onMove: p.onMove,
            position: p.position,
            closeOnOutsideClick: p.closeOnOutsideClick,
            triggerElement: p.triggerElement
        });
    }
}


class $115e148fb390275d$export$24ba9b81662d4366 {
    closeColorPicker() {
        if (this.colorPickerWindow) {
            this.colorPickerWindow.destroy();
            this.colorPickerWindow = undefined;
        }
    }
    toggleColorPicker(index, triggerElement) {
        if (this.colorPickerWindow) {
            this.closeColorPicker();
            return;
        }
        const color = this.colorArr[index];
        if (!color || color.a !== 1) return;
        if (!this.colorPickerPosition) {
            const rect = this.options.getElement().getBoundingClientRect();
            this.colorPickerPosition = {
                x: rect.left,
                y: rect.bottom + 8
            };
        }
        this.colorPickerWindow = new (0, $364f444c1ac877b6$export$214507535a0fe5b2)({
            color: color,
            onChange: (newColor)=>{
                const rgba = {
                    ...newColor,
                    a: 1
                };
                const colorStr = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(rgba);
                this.colorArr[index] = rgba;
                this.options.updateOption(index, {
                    ariaLabel: colorStr,
                    css: {
                        backgroundColor: colorStr
                    }
                });
                this.onChange(rgba);
            },
            onMove: (position)=>{
                this.colorPickerPosition = position;
            },
            onClose: ()=>this.closeColorPicker(),
            position: this.colorPickerPosition,
            closeOnOutsideClick: true,
            triggerElement: triggerElement
        });
    }
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return this.colorArr[this.options.getValue()];
    }
    destroy() {
        this.closeColorPicker();
        this.options.destroy();
        this.rootEl.remove();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.colorArr = [];
        this.onChange = p.onChange;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: p.label ? p.label : '',
            title: p.title ?? undefined,
            className: $bc54f3b145e2f7ef$export$e8e78c978b129247,
            css: {
                display: 'flex',
                alignItems: 'center',
                gap: 7,
                position: 'relative',
                width: 'fit-content',
                ...p.css
            }
        });
        let selectedIndex = 0;
        // build colorArr while removing duplicates
        for(let i = 0; i < p.colorArr.length; i++){
            const item = p.colorArr[i];
            let found = false;
            for(let e = 0; e < this.colorArr.length; e++){
                const sItem = this.colorArr[e];
                if (sItem === item) {
                    found = true;
                    break;
                }
                if (sItem === null || item === null) continue;
                if (sItem.r === item.r && sItem.g === item.g && sItem.b === item.b && sItem.a === item.a) {
                    found = true;
                    break;
                }
            }
            if (found) continue;
            this.colorArr.push(item);
            if ('initialIndex' in p && p.initialIndex === i) selectedIndex = this.colorArr.length - 1;
        }
        this.options = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: this.colorArr.map((color, index)=>{
                const colorStr = color ? (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(color) : 'X';
                return {
                    id: index,
                    label: color ? undefined : 'X',
                    ariaLabel: color ? colorStr : undefined,
                    css: color && color.a === 0 ? {
                        background: 'var(--kl-checkerboard-background)'
                    } : {
                        backgroundColor: color ? colorStr : 'transparent'
                    }
                };
            }),
            initId: selectedIndex,
            isFocusable: true,
            ariaLabel: p.title ?? p.label,
            onChange: (index)=>{
                this.closeColorPicker();
                this.onChange(this.colorArr[index]);
            },
            onClickSelected: (index, element)=>{
                this.toggleColorPicker(index, element);
            }
        });
        this.rootEl.append(this.options.getElement());
    }
}






const $d36f61f1e82ce977$var$angleSvg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('angle');
class $d36f61f1e82ce977$export$5ee0af1d5c87e856 {
    updateUiState() {
        if (this.uiState === 'left') this.el.style.left = '271px';
        else this.el.style.removeProperty('left');
    }
    setWide(b) {
        this.isWide = b;
        if (!this.el) return;
        if (this.isWide) {
            this.el.style.width = '100%';
            this.el.style.left = '';
        } else {
            this.el.style.removeProperty('width');
            this.el.style.left = this.uiState === 'left' ? '271px' : '';
        }
    }
    setUiState(state) {
        this.uiState = state;
        this.updateUiState();
    }
    out(msg, doPulse) {
        if (typeof msg === 'string') {
            this.angleIm.style.display = 'none';
            this.innerInnerEl.style.removeProperty('font-family');
            this.innerInnerEl.innerHTML = msg;
        } else if (msg.type === 'transform') {
            this.angleIm.style.display = 'inline-block';
            this.angleIm.style.transform = 'rotate(' + msg.angleDeg + 'deg)';
            if (msg.angleDeg % 90 === 0) this.angleIm.style.boxShadow = 'inset 0 0 0 1px rgba(255, 255, 255, 0.7)';
            else this.angleIm.style.boxShadow = '';
            this.innerInnerEl.style.fontFamily = 'monospace';
            this.innerInnerEl.innerHTML = Math.round(msg.scale * 100) + '%';
        } else this.angleIm.style.display = 'none';
        if (doPulse) {
            this.innerEl.style.animation = '';
            setTimeout(()=>this.innerEl.style.animation = 'topOverlayPulse 0.5s ease-out', 20);
            clearTimeout(this.timeout3);
            this.timeout3 = setTimeout(()=>this.innerEl.style.animation = '', 520);
        }
        clearTimeout(this.timeout);
        clearTimeout(this.timeout2);
        this.el.style.animationName = doPulse ? 'consoleInFast' : 'consoleIn';
        this.el.style.opacity = '1';
        this.timeout = setTimeout(()=>{
            this.el.style.opacity = '0';
            this.el.style.animationName = 'consoleOut';
            this.timeout2 = setTimeout(()=>{
                this.el.style.display = 'none';
            }, 450);
        }, 1200);
        this.el.style.display = 'flex';
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.isWide = false // tool space hidden
        ;
        this.uiState = 'right';
        this.el = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'top-overlay g-root',
            onClick: (0, $be957da3610487e9$export$921068d8846a1559).handleClick
        });
        this.updateUiState();
        this.innerEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'top-overlay--inner'
        });
        this.angleIm = new Image();
        this.angleIm.src = $d36f61f1e82ce977$var$angleSvg;
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.angleIm, {
            verticalAlign: 'bottom',
            width: 20,
            height: 20,
            marginLeft: 5,
            borderRadius: 10
        });
        this.innerInnerEl = document.createElement('div');
        this.innerInnerEl.style.display = 'inline-block';
        this.innerEl.append(this.innerInnerEl, this.angleIm);
        this.el.append(this.innerEl);
        document.body.append(this.el);
        this.el.style.display = 'none';
    }
}








var $79I2S = parcelRequire("79I2S");


// Layers ordered bottom to top
function $bf21845f1f663a21$export$a5d179ff6c1f548e(layers) {
    const groups = [];
    for (const layer of layers){
        const lastGroup = groups.at(-1);
        if (layer.hasClipping && lastGroup && !lastGroup[0].hasClipping) lastGroup.push(layer);
        else groups.push([
            layer
        ]);
    }
    return groups;
}


class $7db1a448998b9957$export$fca65d4bf5f27b48 {
    // Returns the compositor's reusable scratch canvas.
    drawGroup(layers, width, height, drawLayer) {
        this.canvas ??= (0, $79I2S.createCanvas)(width, height);
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.canvas, width, height, {
            ensureCleared: true
        });
        if (!layers[0].isVisible) return this.canvas;
        const target = (0, $2f436639594531f3$export$39f92e86d1722f3a)(this.canvas);
        const draw = (layer, mode)=>{
            target.save();
            try {
                target.globalAlpha = layer.opacity;
                target.globalCompositeOperation = mode;
                drawLayer(target, layer);
            } finally{
                target.restore();
            }
        };
        layers.forEach((layer)=>{
            if (layer.isVisible && layer.opacity) draw(layer, layer.mixModeStr);
        });
        draw(layers[0], 'destination-atop');
        return this.canvas;
    }
    // ----------------------------------- public -----------------------------------
    draw(targetCtx, layers, clippingCanvasWidth, clippingCanvasHeight, drawLayer) {
        for (const group of (0, $bf21845f1f663a21$export$a5d179ff6c1f548e)(layers)){
            const base = group[0];
            if (!base.isVisible || base.opacity === 0) continue;
            targetCtx.save();
            try {
                targetCtx.globalCompositeOperation = base.mixModeStr;
                targetCtx.globalAlpha = base.opacity;
                if (group.length === 1) drawLayer(targetCtx, base);
                else {
                    const image = this.drawGroup(group, clippingCanvasWidth, clippingCanvasHeight, drawLayer);
                    targetCtx.globalAlpha = 1;
                    targetCtx.drawImage(image, 0, 0);
                }
            } finally{
                targetCtx.restore();
            }
        }
    }
    // Merges into the bottom layer's pixels while retaining its layer properties.
    // Returns true if drawing was needed.
    merge(bottomCtx, bottomLayer, topLayer, drawLayer) {
        const hasClipping = topLayer.hasClipping && !bottomLayer.hasClipping;
        if (!topLayer.isVisible || topLayer.opacity === 0 || hasClipping && (!bottomLayer.isVisible || bottomLayer.opacity === 0)) return false;
        const { width: width, height: height } = bottomCtx.canvas;
        if (hasClipping) {
            bottomCtx.save();
            try {
                const sourceCanvas = this.drawGroup([
                    {
                        ...bottomLayer,
                        opacity: 1
                    },
                    topLayer
                ], width, height, drawLayer);
                bottomCtx.globalCompositeOperation = 'source-over';
                bottomCtx.globalAlpha = 1;
                bottomCtx.clearRect(0, 0, width, height);
                bottomCtx.drawImage(sourceCanvas, 0, 0);
            } finally{
                bottomCtx.restore();
            }
        } else this.draw(bottomCtx, [
            topLayer
        ], width, height, drawLayer);
        return true;
    }
    destroy() {
        if (this.canvas) {
            (0, $2f436639594531f3$export$2384aff49c9b73c2)(this.canvas);
            this.canvas = undefined;
        }
    }
}






/**
 * Calculate a point transformed with an affine matrix
 * @param matrix {Matrix} Affine Matrix
 * @param  point {Point} Point
 * @returns {Point} Point
 */ function $43e83319b765a157$export$9b20165a36586806(matrix, point) {
    return Array.isArray(point) ? [
        matrix.a * point[0] + matrix.c * point[1] + matrix.e,
        matrix.b * point[0] + matrix.d * point[1] + matrix.f
    ] : {
        x: matrix.a * point.x + matrix.c * point.y + matrix.e,
        y: matrix.b * point.x + matrix.d * point.y + matrix.f
    };
}
function $43e83319b765a157$export$25080e195dd950cc(matrix, points) {
    return points.map((point)=>$43e83319b765a157$export$9b20165a36586806(matrix, point));
}


/**
 * Extract an affine matrix from an object that contains a,b,c,d,e,f keys
 * Any value could be a float or a string that contains a float
 * @param object {Object} Object that contains a,b,c,d,e,f keys
 * @return {Matrix} Affine Matrix
 */ function $c9a0736565b8c91e$export$9144c32b59cbaec4(object) {
    return {
        a: parseFloat(object.a),
        b: parseFloat(object.b),
        c: parseFloat(object.c),
        d: parseFloat(object.d),
        e: parseFloat(object.e),
        f: parseFloat(object.f)
    };
}


/**
 * @ignore
 * @type {RegExp}
 */ const $ddc1f8deddd73df0$var$matrixRegex = /^matrix\(\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*\)$/i;
function $ddc1f8deddd73df0$export$3004f64547af360e(string) {
    const parseFloatOrThrow = (number)=>{
        const n = parseFloat(number);
        if (Number.isFinite(n)) return n // excludes NaN, +Infinite, -Infinite
        ;
        throw new Error(`'${string}' is not a matrix`);
    };
    const prefix = string.substring(0, 7).toLowerCase();
    const suffix = string.substring(string.length - 1);
    const body = string.substring(7, string.length - 1);
    const elements = body.split(',');
    if (prefix === 'matrix(' && suffix === ')' && elements.length === 6) return {
        a: parseFloatOrThrow(elements[0]),
        b: parseFloatOrThrow(elements[1]),
        c: parseFloatOrThrow(elements[2]),
        d: parseFloatOrThrow(elements[3]),
        e: parseFloatOrThrow(elements[4]),
        f: parseFloatOrThrow(elements[5])
    };
    throw new Error(`'${string}' is not a matrix`);
}
function $ddc1f8deddd73df0$export$c1c8983dc21927d2(string) {
    const parsed = string.match($ddc1f8deddd73df0$var$matrixRegex);
    if (parsed === null || parsed.length < 7) throw new Error(`'${string}' is not a matrix`);
    return {
        a: parseFloat(parsed[1]),
        b: parseFloat(parsed[2]),
        c: parseFloat(parsed[3]),
        d: parseFloat(parsed[4]),
        e: parseFloat(parsed[5]),
        f: parseFloat(parsed[6])
    };
}


/**
 * Identity matrix
 * @returns {Matrix} Affine Matrix
 */ function $b8cf610a99a4f5d8$export$f0954fd7d5368655() {
    return {
        a: 1,
        c: 0,
        e: 0,
        b: 0,
        d: 1,
        f: 0
    };
}


/**
 * Calculate a matrix that is the inverse of the provided matrix
 * @param matrix {Matrix} Affine Matrix
 * @returns {Matrix} Inverted Affine Matrix
 */ function $fd04355d00b81239$export$70ae2c07e401031b(matrix) {
    // http://www.wolframalpha.com/input/?i=Inverse+%5B%7B%7Ba,c,e%7D,%7Bb,d,f%7D,%7B0,0,1%7D%7D%5D
    const { a: a, b: b, c: c, d: d, e: e, f: f } = matrix;
    const denom = a * d - b * c;
    return {
        a: d / denom,
        b: b / -denom,
        c: c / -denom,
        d: a / denom,
        e: (d * e - c * f) / -denom,
        f: (b * e - a * f) / denom
    };
}


function $092fec51a26fdf08$export$fce6876652108ab(val) {
    return typeof val === 'undefined';
}
function $092fec51a26fdf08$export$e90fb89750dba83f(n) {
    return typeof n === 'number' && !Number.isNaN(n) && Number.isFinite(n);
}
function $092fec51a26fdf08$export$a6cdc56e425d0d0a(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}
function $092fec51a26fdf08$export$ea33763237293206(obj, keys) {
    return keys.every((key)=>key in obj);
}


function $4df675e1eb62f5b4$export$b500e24115cd4dcf(object) {
    return (0, $092fec51a26fdf08$export$a6cdc56e425d0d0a)(object) && 'a' in object && (0, $092fec51a26fdf08$export$e90fb89750dba83f)(object.a) && 'b' in object && (0, $092fec51a26fdf08$export$e90fb89750dba83f)(object.b) && 'c' in object && (0, $092fec51a26fdf08$export$e90fb89750dba83f)(object.c) && 'd' in object && (0, $092fec51a26fdf08$export$e90fb89750dba83f)(object.d) && 'e' in object && (0, $092fec51a26fdf08$export$e90fb89750dba83f)(object.e) && 'f' in object && (0, $092fec51a26fdf08$export$e90fb89750dba83f)(object.f);
}



/**
 * Calculate a translate matrix
 * @param tx {number} Translation on axis x
 * @param [ty = 0] {number} Translation on axis y
 * @returns {Matrix} Affine Matrix
 */ function $15f17d2145582868$export$d73ee8ef04f5226a(tx, ty = 0) {
    return {
        a: 1,
        c: 0,
        e: tx,
        b: 0,
        d: 1,
        f: ty
    };
}


/**
 * Merge multiple matrices into one
 * @param matrices {...Matrix | Matrix[]} Matrices listed as separate parameters or in an array
 * @returns {Matrix} Affine Matrix
 */ function $1122233c3b48b24e$export$51186ad6e864892a(...matrices) {
    matrices = Array.isArray(matrices[0]) ? matrices[0] : matrices;
    const multiply = (m1, m2)=>{
        return {
            a: m1.a * m2.a + m1.c * m2.b,
            c: m1.a * m2.c + m1.c * m2.d,
            e: m1.a * m2.e + m1.c * m2.f + m1.e,
            b: m1.b * m2.a + m1.d * m2.b,
            d: m1.b * m2.c + m1.d * m2.d,
            f: m1.b * m2.e + m1.d * m2.f + m1.f
        };
    };
    switch(matrices.length){
        case 0:
            throw new Error('no matrices provided');
        case 1:
            return matrices[0];
        case 2:
            return multiply(matrices[0], matrices[1]);
        default:
            {
                const [m1, m2, ...rest] = matrices;
                const m = multiply(m1, m2);
                return $1122233c3b48b24e$export$51186ad6e864892a(m, ...rest);
            }
    }
}
function $1122233c3b48b24e$export$f672e0b6f7222cd7(...matrices) {
    return $1122233c3b48b24e$export$51186ad6e864892a(...matrices);
}


const { cos: $648ca1a32d748118$var$cos, sin: $648ca1a32d748118$var$sin, PI: $648ca1a32d748118$var$PI } = Math;
function $648ca1a32d748118$export$bb628a54ab399bc9(angle, cx, cy) {
    const cosAngle = $648ca1a32d748118$var$cos(angle);
    const sinAngle = $648ca1a32d748118$var$sin(angle);
    const rotationMatrix = {
        a: cosAngle,
        c: -sinAngle,
        e: 0,
        b: sinAngle,
        d: cosAngle,
        f: 0
    };
    if ((0, $092fec51a26fdf08$export$fce6876652108ab)(cx) || (0, $092fec51a26fdf08$export$fce6876652108ab)(cy)) return rotationMatrix;
    return (0, $1122233c3b48b24e$export$51186ad6e864892a)([
        (0, $15f17d2145582868$export$d73ee8ef04f5226a)(cx, cy),
        rotationMatrix,
        (0, $15f17d2145582868$export$d73ee8ef04f5226a)(-cx, -cy)
    ]);
}
function $648ca1a32d748118$export$9ade995dfe562073(angle, cx, cy) {
    return $648ca1a32d748118$export$bb628a54ab399bc9(angle * $648ca1a32d748118$var$PI / 180, cx, cy);
}





function $c78f6b9ad5de5188$export$dcdf75081b88279d(sx, sy, cx, cy) {
    if ((0, $092fec51a26fdf08$export$fce6876652108ab)(sy)) sy = sx;
    const scaleMatrix = {
        a: sx,
        c: 0,
        e: 0,
        b: 0,
        d: sy,
        f: 0
    };
    if ((0, $092fec51a26fdf08$export$fce6876652108ab)(cx) || (0, $092fec51a26fdf08$export$fce6876652108ab)(cy)) return scaleMatrix;
    return (0, $1122233c3b48b24e$export$51186ad6e864892a)([
        (0, $15f17d2145582868$export$d73ee8ef04f5226a)(cx, cy),
        scaleMatrix,
        (0, $15f17d2145582868$export$d73ee8ef04f5226a)(-cx, -cy)
    ]);
}


/**
 * Calculate a shear matrix
 * @param shx {number} Shear on axis x
 * @param shy {number} Shear on axis y
 * @returns {Matrix} Affine Matrix
 */ function $281c51994586aa01$export$4861775273fb6d4f(shx, shy) {
    return {
        a: 1,
        c: shx,
        e: 0,
        b: shy,
        d: 1,
        f: 0
    };
}


// https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/skew
const { tan: $3fbafabd18c504ae$var$tan } = Math;
function $3fbafabd18c504ae$export$dd2d5a892675faf1(ax, ay) {
    return {
        a: 1,
        c: $3fbafabd18c504ae$var$tan(ax),
        e: 0,
        b: $3fbafabd18c504ae$var$tan(ay),
        d: 1,
        f: 0
    };
}
function $3fbafabd18c504ae$export$80b820e0f249e768(ax, ay) {
    return $3fbafabd18c504ae$export$dd2d5a892675faf1(ax * Math.PI / 180, ay * Math.PI / 180);
}


/**
 * Serialize an affine matrix to a string that can be used with CSS or SVG
 * @param matrix {Matrix} Affine Matrix
 * @returns {string} String that contains an affine matrix formatted as matrix(a,b,c,d,e,f)
 */ function $0d54487ebe898db3$export$5d05fd1a2be8c220(matrix) {
    return $0d54487ebe898db3$export$f84e8e69fd4488a5(matrix);
}
function $0d54487ebe898db3$export$1d0eee16b7a93374(matrix) {
    return $0d54487ebe898db3$export$f84e8e69fd4488a5(matrix);
}
function $0d54487ebe898db3$export$f84e8e69fd4488a5(matrix) {
    return `matrix(${matrix.a},${matrix.b},${matrix.c},${matrix.d},${matrix.e},${matrix.f})`;
}






/**
 * Rounds all elements of the given matrix using the given precision
 * @param matrix {Matrix} An affine matrix to round
 * @param [precision] {number} A precision to use for Math.round. Defaults to 10000000000 (meaning which rounds to the 10th digit after the comma).
 * @returns {Matrix} The rounded Affine Matrix
 */ function $b04b307419f62f22$export$8459a0a25f7ea1f1(matrix, precision = 10000000000) {
    return {
        a: Math.round(matrix.a * precision) / precision,
        b: Math.round(matrix.b * precision) / precision,
        c: Math.round(matrix.c * precision) / precision,
        d: Math.round(matrix.d * precision) / precision,
        e: Math.round(matrix.e * precision) / precision,
        f: Math.round(matrix.f * precision) / precision
    };
}


function $62dcf34ec1a39342$export$2565f8052cb7f44a(t1, t2) {
    // point p = first point of the triangle
    const px1 = t1[0].x != null ? t1[0].x : t1[0][0];
    const py1 = t1[0].y != null ? t1[0].y : t1[0][1];
    const px2 = t2[0].x != null ? t2[0].x : t2[0][0];
    const py2 = t2[0].y != null ? t2[0].y : t2[0][1];
    // point q = second point of the triangle
    const qx1 = t1[1].x != null ? t1[1].x : t1[1][0];
    const qy1 = t1[1].y != null ? t1[1].y : t1[1][1];
    const qx2 = t2[1].x != null ? t2[1].x : t2[1][0];
    const qy2 = t2[1].y != null ? t2[1].y : t2[1][1];
    // point r = third point of the triangle
    const rx1 = t1[2].x != null ? t1[2].x : t1[2][0];
    const ry1 = t1[2].y != null ? t1[2].y : t1[2][1];
    const rx2 = t2[2].x != null ? t2[2].x : t2[2][0];
    const ry2 = t2[2].y != null ? t2[2].y : t2[2][1];
    const r1 = {
        a: px1 - rx1,
        b: py1 - ry1,
        c: qx1 - rx1,
        d: qy1 - ry1,
        e: rx1,
        f: ry1
    };
    const r2 = {
        a: px2 - rx2,
        b: py2 - ry2,
        c: qx2 - rx2,
        d: qy2 - ry2,
        e: rx2,
        f: ry2
    };
    const inverseR1 = (0, $fd04355d00b81239$export$70ae2c07e401031b)(r1);
    const affineMatrix = (0, $1122233c3b48b24e$export$51186ad6e864892a)([
        r2,
        inverseR1
    ]);
    // round the matrix elements to smooth the finite inversion
    return (0, $b04b307419f62f22$export$8459a0a25f7ea1f1)(affineMatrix);
}









function $2e4dbd99093f4e84$export$36aa15ab5c729b62(definitionOrArrayOfDefinition) {
    return Array.isArray(definitionOrArrayOfDefinition) ? definitionOrArrayOfDefinition.map(mapper) : mapper(definitionOrArrayOfDefinition);
    function mapper(descriptor) {
        switch(descriptor.type){
            case 'matrix':
                if ('a' in descriptor && 'b' in descriptor && 'c' in descriptor && 'd' in descriptor && 'e' in descriptor && 'f' in descriptor) return (0, $c9a0736565b8c91e$export$9144c32b59cbaec4)(descriptor);
                else throw new Error('MISSING_MANDATORY_PARAM');
            case 'translate':
                if (!('tx' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                if ('ty' in descriptor) return (0, $15f17d2145582868$export$d73ee8ef04f5226a)(descriptor.tx, descriptor.ty);
                return (0, $15f17d2145582868$export$d73ee8ef04f5226a)(descriptor.tx);
            case 'scale':
                if (!('sx' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                if ('sy' in descriptor) return (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(descriptor.sx, descriptor.sy);
                return (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(descriptor.sx);
            case 'rotate':
                if (!('angle' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                if ('cx' in descriptor && 'cy' in descriptor) return (0, $648ca1a32d748118$export$9ade995dfe562073)(descriptor.angle, descriptor.cx, descriptor.cy);
                return (0, $648ca1a32d748118$export$9ade995dfe562073)(descriptor.angle);
            case 'skewX':
                if (!('angle' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                return (0, $3fbafabd18c504ae$export$80b820e0f249e768)(descriptor.angle, 0);
            case 'skewY':
                if (!('angle' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                return (0, $3fbafabd18c504ae$export$80b820e0f249e768)(0, descriptor.angle);
            case 'shear':
                if (!('shx' in descriptor && 'shy' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                return (0, $281c51994586aa01$export$4861775273fb6d4f)(descriptor.shx, descriptor.shy);
            default:
                throw new Error('UNSUPPORTED_DESCRIPTOR');
        }
    }
}


// @generated by Peggy 5.0.6.
//
// https://peggyjs.org/
class $50033f7b62464f93$export$f21cea08b0dd60e8 extends SyntaxError {
    format(sources) {
        let str = "Error: " + this.message;
        if (this.location) {
            let src = null;
            const st = sources.find((s)=>s.source === this.location.source);
            if (st) src = st.text.split(/\r\n|\n|\r/g);
            const s = this.location.start;
            const offset_s = this.location.source && typeof this.location.source.offset === "function" ? this.location.source.offset(s) : s;
            const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
            if (src) {
                const e = this.location.end;
                const filler = "".padEnd(offset_s.line.toString().length, " ");
                const line = src[s.line - 1];
                const last = s.line === e.line ? e.column : line.length + 1;
                const hatLen = last - s.column || 1;
                str += "\n --> " + loc + "\n" + filler + " |\n" + offset_s.line + " | " + line + "\n" + filler + " | " + "".padEnd(s.column - 1, " ") + "".padEnd(hatLen, "^");
            } else str += "\n at " + loc;
        }
        return str;
    }
    static buildMessage(expected, found) {
        function hex(ch) {
            return ch.codePointAt(0).toString(16).toUpperCase();
        }
        const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode") ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu") : null;
        function unicodeEscape(s) {
            if (nonPrintable) return s.replace(nonPrintable, (ch)=>"\\u{" + hex(ch) + "}");
            return s;
        }
        function literalEscape(s) {
            return unicodeEscape(s.replace(/\\/g, "\\\\").replace(/"/g, "\\\"").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch)=>"\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch)=>"\\x" + hex(ch)));
        }
        function classEscape(s) {
            return unicodeEscape(s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch)=>"\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch)=>"\\x" + hex(ch)));
        }
        const DESCRIBE_EXPECTATION_FNS = {
            literal (expectation) {
                return "\"" + literalEscape(expectation.text) + "\"";
            },
            class (expectation) {
                const escapedParts = expectation.parts.map((part)=>Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part));
                return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
            },
            any () {
                return "any character";
            },
            end () {
                return "end of input";
            },
            other (expectation) {
                return expectation.description;
            }
        };
        function describeExpectation(expectation) {
            return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected) {
            const descriptions = expected.map(describeExpectation);
            descriptions.sort();
            if (descriptions.length > 0) {
                let j = 1;
                for(let i = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                    descriptions[j] = descriptions[i];
                    j++;
                }
                descriptions.length = j;
            }
            switch(descriptions.length){
                case 1:
                    return descriptions[0];
                case 2:
                    return descriptions[0] + " or " + descriptions[1];
                default:
                    return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
            }
        }
        function describeFound(found) {
            return found ? "\"" + literalEscape(found) + "\"" : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
    }
    constructor(message, expected, found, location){
        super(message);
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
    }
}
function $50033f7b62464f93$export$98e6a39c04603d36(input, options) {
    options = options !== undefined ? options : {};
    const peg$FAILED = {};
    const peg$source = options.grammarSource;
    const peg$startRuleFunctions = {
        transformList: peg$parsetransformList
    };
    let peg$startRuleFunction = peg$parsetransformList;
    const peg$c0 = "matrix";
    const peg$c1 = "(";
    const peg$c2 = ")";
    const peg$c3 = "translate";
    const peg$c4 = "scale";
    const peg$c5 = "rotate";
    const peg$c6 = "skewX";
    const peg$c7 = "skewY";
    const peg$c8 = ",";
    const peg$c9 = ".";
    const peg$r0 = /^[eE]/;
    const peg$r1 = /^[+\-]/;
    const peg$r2 = /^[0-9]/;
    const peg$r3 = /^[ \t\r\n]/;
    const peg$e0 = peg$literalExpectation("matrix", false);
    const peg$e1 = peg$literalExpectation("(", false);
    const peg$e2 = peg$literalExpectation(")", false);
    const peg$e3 = peg$literalExpectation("translate", false);
    const peg$e4 = peg$literalExpectation("scale", false);
    const peg$e5 = peg$literalExpectation("rotate", false);
    const peg$e6 = peg$literalExpectation("skewX", false);
    const peg$e7 = peg$literalExpectation("skewY", false);
    const peg$e8 = peg$literalExpectation(",", false);
    const peg$e9 = peg$otherExpectation("fractionalConstant");
    const peg$e10 = peg$literalExpectation(".", false);
    const peg$e11 = peg$classExpectation([
        "e",
        "E"
    ], false, false, false);
    const peg$e12 = peg$classExpectation([
        "+",
        "-"
    ], false, false, false);
    const peg$e13 = peg$classExpectation([
        [
            "0",
            "9"
        ]
    ], false, false, false);
    const peg$e14 = peg$classExpectation([
        " ",
        "\t",
        "\r",
        "\n"
    ], false, false, false);
    function peg$f0(ts) {
        return ts;
    }
    function peg$f1(t, ts) {
        return t.concat(ts);
    }
    function peg$f2(a, b, c, d, e, f) {
        return [
            {
                type: 'matrix',
                a: a,
                b: b,
                c: c,
                d: d,
                e: e,
                f: f
            }
        ];
    }
    function peg$f3(tx, ty) {
        var t = {
            type: 'translate',
            tx: tx
        };
        if (ty) t.ty = ty;
        return [
            t
        ];
    }
    function peg$f4(sx, sy) {
        var s = {
            type: 'scale',
            sx: sx
        };
        if (sy) s.sy = sy;
        return [
            s
        ];
    }
    function peg$f5(angle, c) {
        var r = {
            type: 'rotate',
            angle: angle
        };
        if (c) {
            r.cx = c[0];
            r.cy = c[1];
        }
        return [
            r
        ];
    }
    function peg$f6(angle) {
        return [
            {
                type: 'skewX',
                angle: angle
            }
        ];
    }
    function peg$f7(angle) {
        return [
            {
                type: 'skewY',
                angle: angle
            }
        ];
    }
    function peg$f8(f) {
        return parseFloat(f.join(""));
    }
    function peg$f9(i) {
        return parseInt(i.join(""));
    }
    function peg$f10(n) {
        return n;
    }
    function peg$f11(n1, n2) {
        return [
            n1,
            n2
        ];
    }
    function peg$f12(ds) {
        return ds.join("");
    }
    function peg$f13(f, e) {
        return [
            f,
            e || null
        ].join("");
    }
    function peg$f14(d, e) {
        return [
            d,
            e
        ].join("");
    }
    function peg$f15(d1, d2) {
        return [
            d1 ? d1.join("") : null,
            ".",
            d2.join("")
        ].join("");
    }
    function peg$f16(d) {
        return d.join("");
    }
    function peg$f17(s, d) {
        return [
            'e',
            s,
            d.join("")
        ].join("");
    }
    let peg$currPos = options.peg$currPos | 0;
    let peg$savedPos = peg$currPos;
    const peg$posDetailsCache = [
        {
            line: 1,
            column: 1
        }
    ];
    let peg$maxFailPos = peg$currPos;
    let peg$maxFailExpected = options.peg$maxFailExpected || [];
    let peg$silentFails = options.peg$silentFails | 0;
    let peg$result;
    if (options.startRule) {
        if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function offset() {
        return peg$savedPos;
    }
    function range() {
        return {
            source: peg$source,
            start: peg$savedPos,
            end: peg$currPos
        };
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function expected(description, location) {
        location = location !== undefined ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildStructuredError([
            peg$otherExpectation(description)
        ], input.substring(peg$savedPos, peg$currPos), location);
    }
    function error(message, location) {
        location = location !== undefined ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location);
    }
    function peg$getUnicode(pos = peg$currPos) {
        const cp = input.codePointAt(pos);
        if (cp === undefined) return "";
        return String.fromCodePoint(cp);
    }
    function peg$literalExpectation(text, ignoreCase) {
        return {
            type: "literal",
            text: text,
            ignoreCase: ignoreCase
        };
    }
    function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
        return {
            type: "class",
            parts: parts,
            inverted: inverted,
            ignoreCase: ignoreCase,
            unicode: unicode
        };
    }
    function peg$anyExpectation() {
        return {
            type: "any"
        };
    }
    function peg$endExpectation() {
        return {
            type: "end"
        };
    }
    function peg$otherExpectation(description) {
        return {
            type: "other",
            description: description
        };
    }
    function peg$computePosDetails(pos) {
        let details = peg$posDetailsCache[pos];
        let p;
        if (details) return details;
        else {
            if (pos >= peg$posDetailsCache.length) p = peg$posDetailsCache.length - 1;
            else {
                p = pos;
                while(!peg$posDetailsCache[--p]);
            }
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while(p < pos){
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                } else details.column++;
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos, offset) {
        const startPosDetails = peg$computePosDetails(startPos);
        const endPosDetails = peg$computePosDetails(endPos);
        const res = {
            source: peg$source,
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
        if (offset && peg$source && typeof peg$source.offset === "function") {
            res.start = peg$source.offset(res.start);
            res.end = peg$source.offset(res.end);
        }
        return res;
    }
    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) return;
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected);
    }
    function peg$buildSimpleError(message, location) {
        return new $50033f7b62464f93$export$f21cea08b0dd60e8(message, null, null, location);
    }
    function peg$buildStructuredError(expected, found, location) {
        return new $50033f7b62464f93$export$f21cea08b0dd60e8($50033f7b62464f93$export$f21cea08b0dd60e8.buildMessage(expected, found), expected, found, location);
    }
    function peg$parsetransformList() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsewsp();
        while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = peg$parsewsp();
        }
        s2 = peg$parsetransforms();
        if (s2 === peg$FAILED) s2 = null;
        s3 = [];
        s4 = peg$parsewsp();
        while(s4 !== peg$FAILED){
            s3.push(s4);
            s4 = peg$parsewsp();
        }
        peg$savedPos = s0;
        s0 = peg$f0(s2);
        return s0;
    }
    function peg$parsetransforms() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parsetransform();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsecommaWsp();
            if (s3 !== peg$FAILED) while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsecommaWsp();
            }
            else s2 = peg$FAILED;
            if (s2 !== peg$FAILED) {
                s3 = peg$parsetransforms();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f1(s1, s3);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) s0 = peg$parsetransform();
        return s0;
    }
    function peg$parsetransform() {
        let s0;
        s0 = peg$parsematrix();
        if (s0 === peg$FAILED) {
            s0 = peg$parsetranslate();
            if (s0 === peg$FAILED) {
                s0 = peg$parsescale();
                if (s0 === peg$FAILED) {
                    s0 = peg$parserotate();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseskewX();
                        if (s0 === peg$FAILED) s0 = peg$parseskewY();
                    }
                }
            }
        }
        return s0;
    }
    function peg$parsematrix() {
        let s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 6) === peg$c0) {
            s1 = peg$c0;
            peg$currPos += 6;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e0);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWsp();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parsenumber();
                        if (s7 !== peg$FAILED) {
                            s8 = peg$parsecommaWsp();
                            if (s8 !== peg$FAILED) {
                                s9 = peg$parsenumber();
                                if (s9 !== peg$FAILED) {
                                    s10 = peg$parsecommaWsp();
                                    if (s10 !== peg$FAILED) {
                                        s11 = peg$parsenumber();
                                        if (s11 !== peg$FAILED) {
                                            s12 = peg$parsecommaWsp();
                                            if (s12 !== peg$FAILED) {
                                                s13 = peg$parsenumber();
                                                if (s13 !== peg$FAILED) {
                                                    s14 = peg$parsecommaWsp();
                                                    if (s14 !== peg$FAILED) {
                                                        s15 = peg$parsenumber();
                                                        if (s15 !== peg$FAILED) {
                                                            s16 = [];
                                                            s17 = peg$parsewsp();
                                                            while(s17 !== peg$FAILED){
                                                                s16.push(s17);
                                                                s17 = peg$parsewsp();
                                                            }
                                                            if (input.charCodeAt(peg$currPos) === 41) {
                                                                s17 = peg$c2;
                                                                peg$currPos++;
                                                            } else {
                                                                s17 = peg$FAILED;
                                                                if (peg$silentFails === 0) peg$fail(peg$e2);
                                                            }
                                                            if (s17 !== peg$FAILED) {
                                                                peg$savedPos = s0;
                                                                s0 = peg$f2(s5, s7, s9, s11, s13, s15);
                                                            } else {
                                                                peg$currPos = s0;
                                                                s0 = peg$FAILED;
                                                            }
                                                        } else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    } else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsetranslate() {
        let s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 9) === peg$c3) {
            s1 = peg$c3;
            peg$currPos += 9;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e3);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWspNumber();
                    if (s6 === peg$FAILED) s6 = null;
                    s7 = [];
                    s8 = peg$parsewsp();
                    while(s8 !== peg$FAILED){
                        s7.push(s8);
                        s8 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c2;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f3(s5, s6);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsescale() {
        let s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c4) {
            s1 = peg$c4;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e4);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWspNumber();
                    if (s6 === peg$FAILED) s6 = null;
                    s7 = [];
                    s8 = peg$parsewsp();
                    while(s8 !== peg$FAILED){
                        s7.push(s8);
                        s8 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c2;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f4(s5, s6);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parserotate() {
        let s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 6) === peg$c5) {
            s1 = peg$c5;
            peg$currPos += 6;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e5);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWspTwoNumbers();
                    if (s6 === peg$FAILED) s6 = null;
                    s7 = [];
                    s8 = peg$parsewsp();
                    while(s8 !== peg$FAILED){
                        s7.push(s8);
                        s8 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c2;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f5(s5, s6);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseskewX() {
        let s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c6) {
            s1 = peg$c6;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e6);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = [];
                    s7 = peg$parsewsp();
                    while(s7 !== peg$FAILED){
                        s6.push(s7);
                        s7 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s7 = peg$c2;
                        peg$currPos++;
                    } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s7 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f6(s5);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseskewY() {
        let s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c7) {
            s1 = peg$c7;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e7);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = [];
                    s7 = peg$parsewsp();
                    while(s7 !== peg$FAILED){
                        s6.push(s7);
                        s7 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s7 = peg$c2;
                        peg$currPos++;
                    } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s7 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f7(s5);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsenumber() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = peg$parsesign();
        if (s2 === peg$FAILED) s2 = null;
        s3 = peg$parsefloatingPointConstant();
        if (s3 !== peg$FAILED) {
            s2 = [
                s2,
                s3
            ];
            s1 = s2;
        } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f8(s1);
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$parsesign();
            if (s2 === peg$FAILED) s2 = null;
            s3 = peg$parseintegerConstant();
            if (s3 !== peg$FAILED) {
                s2 = [
                    s2,
                    s3
                ];
                s1 = s2;
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f9(s1);
            }
            s0 = s1;
        }
        return s0;
    }
    function peg$parsecommaWspNumber() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parsecommaWsp();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumber();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f10(s2);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsecommaWspTwoNumbers() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = peg$parsecommaWsp();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumber();
            if (s2 !== peg$FAILED) {
                s3 = peg$parsecommaWsp();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsenumber();
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f11(s2, s4);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsecommaWsp() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsewsp();
        if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = peg$parsewsp();
        }
        else s1 = peg$FAILED;
        if (s1 !== peg$FAILED) {
            s2 = peg$parsecomma();
            if (s2 === peg$FAILED) s2 = null;
            s3 = [];
            s4 = peg$parsewsp();
            while(s4 !== peg$FAILED){
                s3.push(s4);
                s4 = peg$parsewsp();
            }
            s1 = [
                s1,
                s2,
                s3
            ];
            s0 = s1;
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsecomma();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                s1 = [
                    s1,
                    s2
                ];
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsecomma() {
        let s0;
        if (input.charCodeAt(peg$currPos) === 44) {
            s0 = peg$c8;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e8);
        }
        return s0;
    }
    function peg$parseintegerConstant() {
        let s0, s1;
        s0 = peg$currPos;
        s1 = peg$parsedigitSequence();
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f12(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parsefloatingPointConstant() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parsefractionalConstant();
        if (s1 !== peg$FAILED) {
            s2 = peg$parseexponent();
            if (s2 === peg$FAILED) s2 = null;
            peg$savedPos = s0;
            s0 = peg$f13(s1, s2);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsedigitSequence();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseexponent();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f14(s1, s2);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsefractionalConstant() {
        let s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parsedigitSequence();
        if (s1 === peg$FAILED) s1 = null;
        if (input.charCodeAt(peg$currPos) === 46) {
            s2 = peg$c9;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e10);
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsedigitSequence();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f15(s1, s3);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsedigitSequence();
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 46) {
                    s2 = peg$c9;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e10);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f16(s1);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e9);
        }
        return s0;
    }
    function peg$parseexponent() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = input.charAt(peg$currPos);
        if (peg$r0.test(s1)) peg$currPos++;
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e11);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsesign();
            if (s2 === peg$FAILED) s2 = null;
            s3 = peg$parsedigitSequence();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f17(s2, s3);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsesign() {
        let s0;
        s0 = input.charAt(peg$currPos);
        if (peg$r1.test(s0)) peg$currPos++;
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e12);
        }
        return s0;
    }
    function peg$parsedigitSequence() {
        let s0, s1;
        s0 = [];
        s1 = peg$parsedigit();
        if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
            s0.push(s1);
            s1 = peg$parsedigit();
        }
        else s0 = peg$FAILED;
        return s0;
    }
    function peg$parsedigit() {
        let s0;
        s0 = input.charAt(peg$currPos);
        if (peg$r2.test(s0)) peg$currPos++;
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e13);
        }
        return s0;
    }
    function peg$parsewsp() {
        let s0;
        s0 = input.charAt(peg$currPos);
        if (peg$r3.test(s0)) peg$currPos++;
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e14);
        }
        return s0;
    }
    peg$result = peg$startRuleFunction();
    const peg$success = peg$result !== peg$FAILED && peg$currPos === input.length;
    function peg$throw() {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
    if (options.peg$library) return /** @type {any} */ {
        peg$result: peg$result,
        peg$currPos: peg$currPos,
        peg$FAILED: peg$FAILED,
        peg$maxFailExpected: peg$maxFailExpected,
        peg$maxFailPos: peg$maxFailPos,
        peg$success: peg$success,
        peg$throw: peg$success ? undefined : peg$throw
    };
    if (peg$success) return peg$result;
    else peg$throw();
}
const $50033f7b62464f93$export$b495b1bde973ffbd = [
    "transformList"
];


function $a411eb6d8d01f27b$export$dd451a2a4984e188(transformString) {
    return (0, $50033f7b62464f93$export$98e6a39c04603d36)(transformString);
}




function $ff3a9dc5853797d9$export$34daa7fcbfeb2849(matrix, flipX = false, flipY = false) {
    // Remove flip from the matrix first - flip could be incorrectly interpreted as
    // rotations (e.g. flipX + flipY = rotate by 180 degrees).
    // Note flipX is a vertical flip, and flipY is a horizontal flip.
    if (flipX) {
        if (flipY) matrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)(matrix, (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(-1, -1));
        else matrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)(matrix, (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(1, -1));
    } else if (flipY) matrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)(matrix, (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(-1, 1));
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    let scaleX, scaleY, rotation;
    if (a !== 0 || c !== 0) {
        const hypotAc = Math.hypot(a, c);
        scaleX = hypotAc;
        scaleY = (a * d - b * c) / hypotAc;
        const acos = Math.acos(a / hypotAc);
        rotation = c > 0 ? -acos : acos;
    } else if (b !== 0 || d !== 0) {
        const hypotBd = Math.hypot(b, d);
        scaleX = (a * d - b * c) / hypotBd;
        scaleY = hypotBd;
        const acos = Math.acos(b / hypotBd);
        rotation = Math.PI / 2 + (d > 0 ? -acos : acos);
    } else {
        scaleX = 0;
        scaleY = 0;
        rotation = 0;
    }
    // put the flip factors back
    if (flipY) scaleX = -scaleX;
    if (flipX) scaleY = -scaleY;
    return {
        translate: {
            tx: matrix.e,
            ty: matrix.f
        },
        scale: {
            sx: scaleX,
            sy: scaleY
        },
        rotation: {
            angle: rotation
        }
    };
}


/**
 * Tranformation matrix that mirrors on x-axis
 * @returns {Matrix} Affine Matrix
 */ function $19b5be0d9e3a966c$export$9ffbcc0b36390a8f() {
    return {
        a: 1,
        c: 0,
        e: 0,
        b: 0,
        d: -1,
        f: 0
    };
}
function $19b5be0d9e3a966c$export$13e88519d622f890() {
    return {
        a: -1,
        c: 0,
        e: 0,
        b: 0,
        d: 1,
        f: 0
    };
}
function $19b5be0d9e3a966c$export$8817f89b5790665a() {
    return {
        a: -1,
        c: 0,
        e: 0,
        b: 0,
        d: -1,
        f: 0
    };
}







function $ce37a03991142e4b$export$91619259a15f04b8(startingPoint, endingPoint) {
    const tx = endingPoint.x - startingPoint.x;
    const ty = endingPoint.y - startingPoint.y;
    return (0, $15f17d2145582868$export$d73ee8ef04f5226a)(tx, ty);
}
function $ce37a03991142e4b$export$87d7516aee2dd9d9(startingPoint1, startingPoint2, endingPoint1, endingPoint2) {
    // finds translation
    const translationMatrix = $ce37a03991142e4b$export$91619259a15f04b8(startingPoint1, endingPoint1);
    const pointA = (0, $43e83319b765a157$export$9b20165a36586806)(translationMatrix, startingPoint2) // I have to translate this point
    ;
    const center = endingPoint1;
    const pointB = endingPoint2;
    // finds rotation matrix
    const angle = Math.atan2(pointB.y - center.y, pointB.x - center.x) - Math.atan2(pointA.y - center.y, pointA.x - center.x);
    const rotationMatrix = (0, $648ca1a32d748118$export$bb628a54ab399bc9)(angle, center.x, center.y);
    // finds scale matrix
    const d1 = Math.sqrt(Math.pow(pointA.x - center.x, 2) + Math.pow(pointA.y - center.y, 2));
    const d2 = Math.sqrt(Math.pow(pointB.x - center.x, 2) + Math.pow(pointB.y - center.y, 2));
    const scalingLevel = d2 / d1;
    const scalingMatrix = (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(scalingLevel, scalingLevel, center.x, center.y);
    return (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)([
        translationMatrix,
        scalingMatrix,
        rotationMatrix
    ]);
}




function $e1e2f7367ca96a19$export$ad1d215dd03fe75a(transform) {
    const scaleX = 'scale' in transform ? transform.isMirrored ? -transform.scale : transform.scale : transform.scaleX;
    const scaleY = 'scale' in transform ? transform.scale : transform.scaleY;
    return (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $15f17d2145582868$export$d73ee8ef04f5226a)(transform.x, transform.y), (0, $648ca1a32d748118$export$bb628a54ab399bc9)(transform.angleDeg / 180 * Math.PI), (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(scaleX, scaleY));
}


function $f7c026d16783f524$export$2b60e7dafdbde18a(m) {
    return [
        m.a,
        m.b,
        m.c,
        m.d,
        m.e,
        m.f
    ];
}




// finds the largest index that is defined
function $13bdfa616d4ac6a6$var$getLatestDefined(array) {
    for(let i = array.length - 1; i >= 0; i--){
        const value = array[i];
        if (value !== undefined) return value;
    }
    throw new Error('no defined entry found');
}
// in an array of maps, finds array[i][prop] for the largest index
// where array[i][prop] is defined
function $13bdfa616d4ac6a6$var$getLatestDefinedProp(array, prop) {
    for(let i = array.length - 1; i >= 0; i--){
        if (!array[i]) continue;
        const value = array[i][prop];
        if (value !== undefined) return value;
    }
    throw new Error('no defined entry found');
}
// For each tile gets the latest which is defined.
// Each tile[] is from a history entry.
function $13bdfa616d4ac6a6$var$composeLayerTiles(tilesEntries) {
    const result = [
        ...$13bdfa616d4ac6a6$var$getLatestDefined(tilesEntries)
    ];
    Object.entries(result).forEach(([id])=>{
        result[+id] = $13bdfa616d4ac6a6$var$getLatestDefinedProp(tilesEntries, id);
    });
    return result;
}
// combines layers from multiple history entries into the latest representation
function $13bdfa616d4ac6a6$var$composeLayer(layerEntries) {
    return {
        name: $13bdfa616d4ac6a6$var$getLatestDefinedProp(layerEntries, 'name'),
        opacity: $13bdfa616d4ac6a6$var$getLatestDefinedProp(layerEntries, 'opacity'),
        isVisible: $13bdfa616d4ac6a6$var$getLatestDefinedProp(layerEntries, 'isVisible'),
        mixModeStr: $13bdfa616d4ac6a6$var$getLatestDefinedProp(layerEntries, 'mixModeStr'),
        hasClipping: $13bdfa616d4ac6a6$var$getLatestDefinedProp(layerEntries, 'hasClipping'),
        index: $13bdfa616d4ac6a6$var$getLatestDefinedProp(layerEntries, 'index'),
        tiles: $13bdfa616d4ac6a6$var$composeLayerTiles(layerEntries.map((item)=>item ? item.tiles : undefined))
    };
}
// combines layerMaps from multiple history entries into the latest representation
function $13bdfa616d4ac6a6$var$composeLayerMap(layerMaps) {
    const result = {
        ...$13bdfa616d4ac6a6$var$getLatestDefined(layerMaps)
    };
    Object.entries(result).forEach(([id])=>{
        result[id] = $13bdfa616d4ac6a6$var$composeLayer(layerMaps.map((item)=>item ? item[id] : undefined));
    });
    return result;
}
function $13bdfa616d4ac6a6$export$801426c37c1dd1c8(entries, targetIndex) {
    if (targetIndex === undefined) targetIndex = entries.length - 1;
    entries = entries.slice(0, targetIndex + 1);
    return {
        projectId: $13bdfa616d4ac6a6$var$getLatestDefinedProp(entries, 'projectId'),
        size: $13bdfa616d4ac6a6$var$getLatestDefinedProp(entries, 'size'),
        activeLayerId: $13bdfa616d4ac6a6$var$getLatestDefinedProp(entries, 'activeLayerId'),
        selection: $13bdfa616d4ac6a6$var$getLatestDefinedProp(entries, 'selection'),
        layerMap: $13bdfa616d4ac6a6$var$composeLayerMap(entries.map((item)=>item.layerMap))
    };
}


function $2bd547100370cd3c$export$dba0834b723f37f4(obj) {
    return typeof obj === 'object' && obj !== null && 'fill' in obj && typeof obj.fill === 'string';
}


function $9b522b7d78a163d0$export$d295ad2aaa1da9f9(imageData) {
    return imageData.data.byteLength;
}
function $9b522b7d78a163d0$export$7e1e7fdda5538f3d(fillStr) {
    // 2 byte per character
    return fillStr.length * 2;
}
function $9b522b7d78a163d0$export$9522719957028754(entry) {
    let result = 0;
    // for complex selection paths
    entry.selection?.value?.forEach((poly)=>{
        poly.forEach((ring)=>{
            result += ring.length * 2 * 8; // each number 8 bytes
        });
    });
    entry.layerMap && Object.entries(entry.layerMap).forEach(([, layer])=>{
        layer.tiles?.forEach((tile)=>{
            if (tile === undefined) return;
            if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(tile)) result += $9b522b7d78a163d0$export$7e1e7fdda5538f3d(tile.fill);
            else result += $9b522b7d78a163d0$export$d295ad2aaa1da9f9(tile.data);
        });
    });
    return result;
}


function $a15336ca857ae7b8$export$770e40ded99d2233(entry, composed) {
    if (entry.size !== undefined) {
        if (entry.size.width !== composed.size.width) return true;
        if (entry.size.height !== composed.size.height) return true;
    }
    if (entry.selection !== undefined) {
        if (entry.selection.value !== composed.selection.value) return true;
    }
    if (entry.activeLayerId !== undefined) {
        if (entry.activeLayerId !== composed.activeLayerId) return true;
    }
    if (entry.layerMap !== undefined) {
        const entryLayerMapIds = Object.keys(entry.layerMap);
        for (const layerId of Object.keys(composed.layerMap)){
            if (!entryLayerMapIds.includes(layerId)) return true;
        }
        for (const layerId of entryLayerMapIds){
            const composedLayer = composed.layerMap[layerId];
            if (!composedLayer) return true;
            const entryLayer = entry.layerMap[layerId];
            if (entryLayer.name !== undefined && entryLayer.name !== composedLayer.name) return true;
            if (entryLayer.opacity !== undefined && entryLayer.opacity !== composedLayer.opacity) return true;
            if (entryLayer.isVisible !== undefined && entryLayer.isVisible !== composedLayer.isVisible) return true;
            if (entryLayer.mixModeStr !== undefined && entryLayer.mixModeStr !== composedLayer.mixModeStr) return true;
            if (entryLayer.hasClipping !== undefined && entryLayer.hasClipping !== composedLayer.hasClipping) return true;
            if (entryLayer.index !== undefined && entryLayer.index !== composedLayer.index) return true;
            if (entryLayer.tiles !== undefined) // not needed currently
            return true;
        }
    }
    return false;
}




const $95e5cfe8e5557ed7$export$dcf9b1c44bd9f3ca = 200e6; // 200 MB
const $95e5cfe8e5557ed7$export$b2fc749d02ee72fc = 10e6; // 10 MB
const $95e5cfe8e5557ed7$export$3581b93879161a65 = 50;
const $95e5cfe8e5557ed7$export$31969bbe78931f29 = 1e9; // 1 GB
function $95e5cfe8e5557ed7$export$d67e774f8b500179(entries) {
    return entries.reduce((sum, e)=>sum + e.memoryEstimateBytes, 0);
}
function $95e5cfe8e5557ed7$export$d87cc29d5f016b5d(entries) {
    entries = [
        ...entries
    ];
    const totalBytes = $95e5cfe8e5557ed7$export$d67e774f8b500179(entries);
    if (totalBytes <= $95e5cfe8e5557ed7$export$dcf9b1c44bd9f3ca) // we always keep all below this threshold
    return entries;
    const newestEntryIndex = entries.length - 1; // index of the newest entry
    // limit age of large entries
    // Otherwise they may stick around very long and drive up the average memory usage.
    let oldestIndex = 0;
    for(let i = 0; i <= newestEntryIndex; i++){
        const age = newestEntryIndex - i;
        if (entries[i].memoryEstimateBytes > $95e5cfe8e5557ed7$export$b2fc749d02ee72fc && age > $95e5cfe8e5557ed7$export$3581b93879161a65) oldestIndex = i;
    }
    // Regular entries together can't exceed ALWAYS_KEEP_THRESHOLD_BYTES.
    // Large entries not included in this.
    {
        let accumulatedBytes = 0;
        for(let i = newestEntryIndex; i >= 0; i--){
            if (entries[i].memoryEstimateBytes > $95e5cfe8e5557ed7$export$b2fc749d02ee72fc) continue;
            accumulatedBytes += entries[i].memoryEstimateBytes;
            if (accumulatedBytes > $95e5cfe8e5557ed7$export$dcf9b1c44bd9f3ca) {
                oldestIndex = Math.max(oldestIndex, i);
                break;
            }
        }
    }
    // can't exceed TOTAL_THRESHOLD_BYTES
    {
        let accumulatedBytes = 0;
        for(let i = newestEntryIndex; i >= 0; i--){
            accumulatedBytes += entries[i].memoryEstimateBytes;
            if (accumulatedBytes > $95e5cfe8e5557ed7$export$31969bbe78931f29) {
                oldestIndex = Math.max(oldestIndex, i);
                break;
            }
        }
    }
    // compose entries 0..oldestIndex into a single "oldest" entry
    while(oldestIndex > 0){
        const composedData = (0, $13bdfa616d4ac6a6$export$801426c37c1dd1c8)(entries.slice(0, oldestIndex + 1).map((item)=>item.data), oldestIndex);
        const memoryEstimateBytes = (0, $9b522b7d78a163d0$export$9522719957028754)(composedData);
        entries = [
            {
                timestamp: entries[oldestIndex].timestamp,
                memoryEstimateBytes: memoryEstimateBytes,
                description: 'oldest',
                data: composedData
            },
            ...entries.slice(oldestIndex + 1)
        ];
        oldestIndex = 0;
        // Despite the earlier check the composed entry may still push the total over 1 GB.
        if ($95e5cfe8e5557ed7$export$d67e774f8b500179(entries) > $95e5cfe8e5557ed7$export$31969bbe78931f29) oldestIndex = 1;
    }
    return entries;
}




const $9b7bcd54b484ef9c$export$3d7bd55e322555b1 = (imageData)=>{
    return new ImageData(new Uint8ClampedArray(imageData.data), imageData.width, imageData.height);
};




function $aab5cae708a98039$export$55941c74c8f934(data) {
    return {
        id: (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)(),
        data: data
    };
}
function $aab5cae708a98039$export$1a44c122b8668cb(tile) {
    return {
        id: (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)(),
        data: (0, $9b7bcd54b484ef9c$export$3d7bd55e322555b1)(tile.data)
    };
}
function $aab5cae708a98039$export$185d2f15b67cd13(col, row, canvasSize) {
    const x = col * (0, $211b564339712990$export$f7bc58374d6bc9b6);
    const y = row * (0, $211b564339712990$export$f7bc58374d6bc9b6);
    const width = Math.min((0, $211b564339712990$export$f7bc58374d6bc9b6), canvasSize.width - x);
    const height = Math.min((0, $211b564339712990$export$f7bc58374d6bc9b6), canvasSize.height - y);
    if (width <= 0 || height <= 0 || col < 0 || row < 0) throw new Error('invalid out-of-bounds tile');
    return {
        width: width,
        height: height
    };
}
function $aab5cae708a98039$export$c849c66042090269(tileIndex, canvasSize) {
    const tilesPerRow = Math.ceil(canvasSize.width / (0, $211b564339712990$export$f7bc58374d6bc9b6));
    const col = tileIndex % tilesPerRow;
    const row = Math.floor(tileIndex / tilesPerRow);
    return $aab5cae708a98039$export$185d2f15b67cd13(col, row, canvasSize);
}



function $06d5f1b2444942f7$export$9eb4fb7247b73c3e(entryData, previousSize) {
    const size = entryData.size ?? previousSize;
    const tilesX = Math.ceil(size.width / (0, $211b564339712990$export$f7bc58374d6bc9b6));
    const tilesY = Math.ceil(size.height / (0, $211b564339712990$export$f7bc58374d6bc9b6));
    const expectedTileCount = tilesX * tilesY;
    const layerEntries = Object.entries(entryData.layerMap ?? {});
    for(let layerIndex = 0; layerIndex < layerEntries.length; layerIndex++){
        const [layerId, layer] = layerEntries[layerIndex];
        if (layer.tiles === undefined) continue;
        if (layer.tiles.length !== expectedTileCount) {
            const err = `[KlHistory] Invalid tile count for layer "${layerId}": expected ${expectedTileCount}, got ${layer.tiles.length}`;
            (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(new Error(err));
            // one error is enough
            return;
        }
        for(let tileIndex = 0; tileIndex < layer.tiles.length; tileIndex++){
            const tile = layer.tiles[tileIndex];
            if (tile === undefined || (0, $2bd547100370cd3c$export$dba0834b723f37f4)(tile)) continue;
            const tileSize = (0, $aab5cae708a98039$export$c849c66042090269)(tileIndex, size);
            if (tile.data.width !== tileSize.width || tile.data.height !== tileSize.height) {
                const err = `[KlHistory] Invalid tile dimensions for layer "${layerId}" at index ${tileIndex}: expected ${tileSize.width}x${tileSize.height}, got ${tile.data.width}x${tile.data.height}`;
                (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(new Error(err));
                // one error is enough
                return;
            }
        }
    }
}


const $211b564339712990$export$f7bc58374d6bc9b6 = 256;
const $211b564339712990$var$HISTORY_DEBUGGING = false;
class $211b564339712990$export$1a1044741a812c67 {
    broadcast() {
        this.changeCount++;
        setTimeout(()=>{
            for(let i = 0; i < this.listeners.length; i++)this.listeners[i]();
        });
    }
    updateComposed() {
        this.composed = (0, $13bdfa616d4ac6a6$export$801426c37c1dd1c8)(this.entries.slice(0, this.index + 1).map((item)=>item.data));
    }
    /**
     * Needed, because sometimes there are actions that would cause other undo steps.
     * For example a filter that does something with two layers and then merges them.
     * That should be a single undo step, and prevent merging from creating its own undo step.
     * Pause prevents creation of unintended undo steps.
     */ pause(b) {
        if (b) this.pauseStack++;
        else this.pauseStack = Math.max(0, this.pauseStack - 1);
    }
    /**
     * listens to changes - on undo, redo, push
     */ addListener(l) {
        this.listeners.push(l);
    }
    // doesn't push if: paused or if entry is empty
    push(entryData, replaceTop) {
        if (this.pauseStack > 0) return;
        if (Object.keys(entryData).length === 0) // no change -> noop
        return;
        (0, $06d5f1b2444942f7$export$9eb4fb7247b73c3e)(entryData, this.composed.size);
        const entry = {
            timestamp: Date.now(),
            memoryEstimateBytes: (0, $9b522b7d78a163d0$export$9522719957028754)(entryData),
            data: entryData
        };
        if (replaceTop && this.index > 0) {
            this.index--;
            // remove current top
            while(this.index < this.entries.length - 1)this.entries.pop();
            // it's possible that new entry replacing top is same to composed history
            // e.g. toggle layer visibility twice
            const isDifferent = (0, $a15336ca857ae7b8$export$770e40ded99d2233)(entryData, (0, $13bdfa616d4ac6a6$export$801426c37c1dd1c8)(this.entries.slice(0, this.index + 1).map((item)=>item.data)));
            // only need to push if it's different
            isDifferent && this.entries.push(entry);
        } else {
            while(this.index < this.entries.length - 1)this.entries.pop();
            this.entries.push(entry);
        }
        this.entries = (0, $95e5cfe8e5557ed7$export$d87cc29d5f016b5d)(this.entries);
        if ($211b564339712990$var$HISTORY_DEBUGGING) {
            const totalBytes = (0, $95e5cfe8e5557ed7$export$d67e774f8b500179)(this.entries);
            console.log(`[KlHistory] pushed ${(entry.memoryEstimateBytes / 1e6).toFixed(1)} MB \u{2014} total: ${(totalBytes / 1e6).toFixed(1)} MB (${this.entries.length} entries)`);
        }
        this.totalActions++;
        this.index = this.entries.length - 1;
        this.updateComposed();
        this.broadcast();
    }
    increaseIndex() {
        if (this.canRedo()) this.index++;
        this.updateComposed();
        this.broadcast();
        return this.entries[this.index];
    }
    decreaseIndex() {
        if (this.canUndo()) this.index--;
        this.updateComposed();
        this.broadcast();
        return this.entries[this.index];
    }
    canUndo() {
        return this.index > 0;
    }
    canRedo() {
        return this.index < this.entries.length - 1;
    }
    getEntries() {
        return this.entries.slice(0, this.index + 1);
    }
    getComposed() {
        return this.composed;
    }
    getChangeCount() {
        return this.changeCount;
    }
    getTotalIndex() {
        return this.totalActions;
    }
    isPaused() {
        return this.pauseStack > 0;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.index = 0 // current action the user is on.
        ;
        this.totalActions = 0;
        this.changeCount = 0 // number keeps incrementing with each change (push, undo, redo)
        ;
        this.pauseStack = 0 // how often paused without unpause. push does nothing when paused.
        ;
        this.listeners = [] // broadcasts on undo, redo, push
        ;
        (0, $06d5f1b2444942f7$export$9eb4fb7247b73c3e)(p.oldest, p.oldest.size);
        this.entries = [
            {
                timestamp: Date.now(),
                memoryEstimateBytes: (0, $9b522b7d78a163d0$export$9522719957028754)(p.oldest),
                data: p.oldest
            }
        ];
        this.composed = p.oldest;
        if ($211b564339712990$var$HISTORY_DEBUGGING) window.getHistoryEntries = ()=>this.entries;
    }
}


const $b34734078b2db3b1$export$40257b1b753712da = false;
/**
 * renders into all ProjectViewports
 */ class $b34734078b2db3b1$var$DebugRender {
    render(ctx, width, height, scale) {
        this.internalRenderFuncs.forEach((func)=>{
            ctx.save();
            func(ctx, width, height, scale);
            ctx.restore();
        });
        this.renderFuncs.forEach((func)=>{
            ctx.save();
            func(ctx, width, height, scale);
            ctx.restore();
        });
    }
    // add something to be rendered
    add(func) {
        this.renderFuncs.push(func);
    }
    remove(func) {
        for(let i = 0; i < this.renderFuncs.length; i++)if (this.renderFuncs[i] === func) {
            this.renderFuncs.splice(i, 1);
            return;
        }
    }
    clear() {
        this.renderFuncs = [];
    }
    // --------------- public ---------------------
    constructor(){
        this.internalRenderFuncs = [];
        this.renderFuncs = [];
        if ($b34734078b2db3b1$export$40257b1b753712da) {
            // draw checkerboard
            const checkerCanvas = (0, $be957da3610487e9$export$921068d8846a1559).createCheckerCanvas(256, false);
            const pattern = (0, $94f0b2b810d4d191$export$b813e062795b89b5)((0, $be957da3610487e9$export$921068d8846a1559).ctx((0, $be957da3610487e9$export$921068d8846a1559).canvas((0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6))).createPattern(checkerCanvas, 'repeat'));
            this.internalRenderFuncs.push((ctx, width, height)=>{
                ctx.fillStyle = pattern;
                ctx.globalAlpha = 0.2;
                ctx.fillRect(0, 0, width, height);
            });
        }
    }
}
const $b34734078b2db3b1$export$7bf40fdf7bf55821 = new $b34734078b2db3b1$var$DebugRender();





const $2ca2f462d49915a5$var$LS_PIXELATED_ZOOM_KEY = 'klecks-pixelated-zoom';
const $2ca2f462d49915a5$var$changeEventTarget = new EventTarget();
let $2ca2f462d49915a5$var$isEnabled = (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem($2ca2f462d49915a5$var$LS_PIXELATED_ZOOM_KEY) === 'true';
function $2ca2f462d49915a5$export$5230bb0e4a571ad8() {
    return $2ca2f462d49915a5$var$isEnabled;
}
function $2ca2f462d49915a5$export$300d7d3a7f814f7f(func) {
    $2ca2f462d49915a5$var$changeEventTarget.addEventListener('change', func);
}
function $2ca2f462d49915a5$export$7cd30d1e52750de3(func) {
    $2ca2f462d49915a5$var$changeEventTarget.removeEventListener('change', func);
}
function $2ca2f462d49915a5$var$setIsPixelatedZoomEnabled(value) {
    if ($2ca2f462d49915a5$var$isEnabled === value) return;
    $2ca2f462d49915a5$var$isEnabled = value;
    if ($2ca2f462d49915a5$var$isEnabled) (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem($2ca2f462d49915a5$var$LS_PIXELATED_ZOOM_KEY, 'true');
    else (0, $7a8f101d3676d17a$export$19fffca37ef3e106).removeItem($2ca2f462d49915a5$var$LS_PIXELATED_ZOOM_KEY);
    $2ca2f462d49915a5$var$changeEventTarget.dispatchEvent(new Event('change'));
}
class $2ca2f462d49915a5$export$25614a4cab357476 {
    getElement() {
        return this.checkbox.getElement();
    }
    destroy() {
        this.checkbox.destroy();
    }
    constructor(){
        this.checkbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('settings-pixelated-zoom'),
            init: $2ca2f462d49915a5$export$5230bb0e4a571ad8(),
            callback: $2ca2f462d49915a5$var$setIsPixelatedZoomEnabled,
            name: 'pixelated-zoom',
            css: {
                display: 'inline-block'
            }
        });
    }
}


function $5e9856f8e33534aa$var$fixScale(scale, pixels) {
    return Math.round(pixels * scale) / pixels;
}
class $5e9856f8e33534aa$export$a140ed60c2ca052c {
    render(optimizeForAnimation) {
        this.onBeforeRender?.();
        const isDark = (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).isDark();
        const transform = {
            ...this.transform,
            x: this.transform.x,
            y: this.transform.y,
            scale: this.transform.scale
        };
        if (this.doResize) {
            this.doResize = false;
            this.resFactor = this.useNativeResolution ? devicePixelRatio : 1;
            (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.canvas, Math.round(this.width * this.resFactor), Math.round(this.height * this.resFactor));
        }
        const renderedTransform = optimizeForAnimation ? {
            x: transform.x,
            y: transform.y,
            angleDeg: transform.angleDeg,
            scaleX: transform.isMirrored ? -transform.scale : transform.scale,
            scaleY: transform.scale
        } : {
            x: Math.round(transform.x),
            y: Math.round(transform.y),
            scaleX: (transform.isMirrored ? -1 : 1) * $5e9856f8e33534aa$var$fixScale(transform.scale, this.project.width),
            scaleY: $5e9856f8e33534aa$var$fixScale(transform.scale, this.project.height),
            angleDeg: transform.angleDeg
        };
        const renderedMat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(renderedTransform);
        this.renderedTransform = renderedTransform;
        const absRenderedScaleX = Math.abs(renderedTransform.scaleX);
        this.ctx.save();
        const isImageSmoothingEnabled = !(0, $2ca2f462d49915a5$export$5230bb0e4a571ad8)() && absRenderedScaleX < 4 && (absRenderedScaleX !== 1 || renderedTransform.angleDeg !== 0);
        this.ctx.imageSmoothingEnabled = isImageSmoothingEnabled;
        if (isImageSmoothingEnabled) this.ctx.imageSmoothingQuality = 'low';
        // draw background
        if (this.background === 'checker') this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        else {
            this.ctx.fillStyle = this.background ?? (isDark ? 'rgb(33, 33, 33)' : 'rgb(158,158,158)');
            this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        }
        this.ctx.transform(...(0, $f7c026d16783f524$export$2b60e7dafdbde18a)(renderedMat));
        {
            this.ctx.save();
            // outline
            this.ctx.fillStyle = (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).isDark() ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.2)';
            const scaledPixelX = 1 / absRenderedScaleX;
            const scaledPixelY = 1 / renderedTransform.scaleY;
            this.ctx.fillRect(-scaledPixelX, -scaledPixelY, this.project.width + scaledPixelX * 2, this.project.height + scaledPixelY * 2);
            // checkerboard
            this.ctx.clearRect(0, 0, this.project.width, this.project.height);
            this.ctx.restore();
        }
        // Resolve dynamic sources once per render so the base and its mask use the same image.
        const renderedImages = new Map();
        this.compositor.draw(this.ctx, this.project.layers, this.project.width, this.project.height, (ctx, layer)=>{
            let renderedImage = renderedImages.get(layer);
            if (!renderedImage) {
                if (typeof layer.image === 'function') {
                    const result = layer.image(this.renderedTransform, this.canvas.width, this.canvas.height);
                    renderedImage = 'image' in result && 'transform' in result ? result : {
                        image: result
                    };
                } else renderedImage = {
                    image: layer.image
                };
                renderedImages.set(layer, renderedImage);
            }
            if (renderedImage.transform) ctx.transform(...(0, $f7c026d16783f524$export$2b60e7dafdbde18a)(renderedImage.transform));
            ctx.drawImage(renderedImage.image, 0, 0);
        });
        this.renderAfter?.(this.ctx, renderedTransform);
        (0, $b34734078b2db3b1$export$40257b1b753712da) && (0, $b34734078b2db3b1$export$7bf40fdf7bf55821).render(this.ctx, this.project.width, this.project.height, absRenderedScaleX);
        this.ctx.restore();
    }
    setSize(width, height) {
        this.doResize = true;
        this.width = width;
        this.height = height;
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.canvas, {
            width: this.doFillParent ? '100%' : this.width,
            height: this.doFillParent ? '100%' : this.height
        });
    }
    setTransform(transform) {
        this.transform = {
            ...transform
        };
    }
    setProject(project) {
        this.project = project;
    }
    setBackground(background) {
        this.background = background;
        this.render();
    }
    getTransform() {
        return {
            ...this.transform
        };
    }
    setUseNativeResolution(b) {
        this.useNativeResolution = b;
        this.doResize = true;
    }
    getUseNativeResolution() {
        return this.useNativeResolution;
    }
    getElement() {
        return this.canvas;
    }
    destroy() {
        (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.canvas);
        this.compositor.destroy();
        (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).removeIsDarkListener(this.onIsDark);
        (0, $2ca2f462d49915a5$export$7cd30d1e52750de3)(this.onPixelatedZoomChange);
        window.removeEventListener('resize', this.resizeListener);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.compositor = new (0, $7db1a448998b9957$export$fca65d4bf5f27b48)();
        this.doResize = true;
        this.onIsDark = ()=>this.render();
        this.onPixelatedZoomChange = ()=>{
            this.render();
        };
        this.oldDPR = devicePixelRatio;
        this.resizeListener = ()=>{
            if (devicePixelRatio !== this.oldDPR) {
                this.canvas.style.imageRendering = Math.round(devicePixelRatio) !== devicePixelRatio ? '' : 'pixelated';
                this.oldDPR = devicePixelRatio;
            }
        };
        this.width = p.width;
        this.height = p.height;
        this.project = p.project;
        this.useNativeResolution = !!p.useNativeResolution;
        this.background = p.background;
        this.doFillParent = !!p.fillParent;
        this.onBeforeRender = p.onBeforeRender;
        this.renderAfter = p.renderAfter;
        this.transform = {
            ...p.transform
        };
        this.resFactor = this.useNativeResolution ? devicePixelRatio : 1;
        this.canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.width * this.resFactor, this.height * this.resFactor);
        this.ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.canvas);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.canvas, {
            width: this.doFillParent ? '100%' : this.width,
            height: this.doFillParent ? '100%' : this.height,
            imageRendering: Math.round(devicePixelRatio) !== devicePixelRatio ? undefined : 'pixelated',
            display: 'block',
            // achieves accurate mixing with all layer mix modes
            background: 'var(--kl-checkerboard-background)',
            backgroundSize: '20px'
        });
        window.addEventListener('resize', this.resizeListener);
        (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).addIsDarkListener(this.onIsDark);
        (0, $2ca2f462d49915a5$export$300d7d3a7f814f7f)(this.onPixelatedZoomChange);
    // this.render();
    }
}






var $6c5b492e766c52d7$export$77aefb1076e6c10f;
var $6c5b492e766c52d7$export$48c2d0f2f545ac27;
var $6c5b492e766c52d7$export$d7b7311ec04a3e8f;
$6c5b492e766c52d7$export$77aefb1076e6c10f = `VFEAZq_kl-theme-dark`;
$6c5b492e766c52d7$export$48c2d0f2f545ac27 = `VFEAZq_preview`;
$6c5b492e766c52d7$export$d7b7311ec04a3e8f = `VFEAZq_viewport`;


function $b9d080b8d62d48af$export$8c03162b1a39d183(oldScale, stepNum) {
    const step = Math.log2(oldScale);
    let newStep = step / Math.abs(stepNum);
    newStep += stepNum > 0 ? 1 : -1;
    newStep = Math.round(newStep);
    newStep *= Math.abs(stepNum);
    return 2 ** newStep;
}






function $cdf37dcca656673a$export$99c68a89351e15c0(viewportPoint, canvasPoint, scale, angleDeg, isMirrored) {
    const mat = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(-scale, -scale), (0, $648ca1a32d748118$export$bb628a54ab399bc9)(angleDeg / 180 * Math.PI), (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(isMirrored ? -1 : 1, 1));
    const topLeftP = (0, $43e83319b765a157$export$9b20165a36586806)(mat, canvasPoint);
    topLeftP.x += viewportPoint.x;
    topLeftP.y += viewportPoint.y;
    return {
        x: topLeftP.x,
        y: topLeftP.y,
        scale: scale,
        angleDeg: angleDeg,
        isMirrored: isMirrored
    };
}




function $a04467f1089650ac$export$935bc53f7df03c95(transform, viewportP) {
    const m = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(transform);
    const canvasP = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(m), viewportP);
    return {
        viewportP: viewportP,
        canvasP: canvasP,
        scale: transform.scale,
        angleDeg: transform.angleDeg,
        isMirrored: transform.isMirrored
    };
}





var $52a8a36eabf772e3$export$8bb18c96af1baaf3;
var $52a8a36eabf772e3$export$eea3e4f737fa39e3;
var $52a8a36eabf772e3$export$d1eb619e8f7efb22;
var $52a8a36eabf772e3$export$2f48b40a5a83dc1b;
$52a8a36eabf772e3$export$8bb18c96af1baaf3 = `uIhb5a_blackAnim`;
$52a8a36eabf772e3$export$8bb18c96af1baaf3;
$52a8a36eabf772e3$export$eea3e4f737fa39e3 = `uIhb5a_blackPath`;
$52a8a36eabf772e3$export$d1eb619e8f7efb22 = `uIhb5a_whiteAnim`;
$52a8a36eabf772e3$export$d1eb619e8f7efb22;
$52a8a36eabf772e3$export$2f48b40a5a83dc1b = `uIhb5a_whitePath`;





function $5f00e0232038b1be$export$aa391dbbf8073422(multiPolygon, transform) {
    return multiPolygon.map((poly)=>{
        return poly.map((ring)=>{
            return ring.map((point)=>{
                return Object.values((0, $43e83319b765a157$export$9b20165a36586806)(transform, {
                    x: point[0],
                    y: point[1]
                }));
            });
        });
    });
}


var $b32bebe3283c38cc$exports = {};
(function(global, factory) {
    $b32bebe3283c38cc$exports = factory();
})($b32bebe3283c38cc$exports, function() {
    'use strict';
    /**
     * splaytree v3.1.2
     * Fast Splay tree for Node and browser
     *
     * @author Alexander Milevski <info@w8r.name>
     * @license MIT
     * @preserve
     */ /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */ function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    var Node = /** @class */ function() {
        function Node(key, data) {
            this.next = null;
            this.key = key;
            this.data = data;
            this.left = null;
            this.right = null;
        }
        return Node;
    }();
    /* follows "An implementation of top-down splaying"
     * by D. Sleator <sleator@cs.cmu.edu> March 1992
     */ function DEFAULT_COMPARE(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    /**
     * Simple top down splay, not requiring i to be in the tree t.
     */ function splay(i, t, comparator) {
        var N = new Node(null, null);
        var l = N;
        var r = N;
        while(true){
            var cmp = comparator(i, t.key);
            //if (i < t.key) {
            if (cmp < 0) {
                if (t.left === null) break;
                //if (i < t.left.key) {
                if (comparator(i, t.left.key) < 0) {
                    var y = t.left; /* rotate right */ 
                    t.left = y.right;
                    y.right = t;
                    t = y;
                    if (t.left === null) break;
                }
                r.left = t; /* link right */ 
                r = t;
                t = t.left;
            //} else if (i > t.key) {
            } else if (cmp > 0) {
                if (t.right === null) break;
                //if (i > t.right.key) {
                if (comparator(i, t.right.key) > 0) {
                    var y = t.right; /* rotate left */ 
                    t.right = y.left;
                    y.left = t;
                    t = y;
                    if (t.right === null) break;
                }
                l.right = t; /* link left */ 
                l = t;
                t = t.right;
            } else break;
        }
        /* assemble */ l.right = t.left;
        r.left = t.right;
        t.left = N.right;
        t.right = N.left;
        return t;
    }
    function insert(i, data, t, comparator) {
        var node = new Node(i, data);
        if (t === null) {
            node.left = node.right = null;
            return node;
        }
        t = splay(i, t, comparator);
        var cmp = comparator(i, t.key);
        if (cmp < 0) {
            node.left = t.left;
            node.right = t;
            t.left = null;
        } else if (cmp >= 0) {
            node.right = t.right;
            node.left = t;
            t.right = null;
        }
        return node;
    }
    function split(key, v, comparator) {
        var left = null;
        var right = null;
        if (v) {
            v = splay(key, v, comparator);
            var cmp = comparator(v.key, key);
            if (cmp === 0) {
                left = v.left;
                right = v.right;
            } else if (cmp < 0) {
                right = v.right;
                v.right = null;
                left = v;
            } else {
                left = v.left;
                v.left = null;
                right = v;
            }
        }
        return {
            left: left,
            right: right
        };
    }
    function merge(left, right, comparator) {
        if (right === null) return left;
        if (left === null) return right;
        right = splay(left.key, right, comparator);
        right.left = left;
        return right;
    }
    /**
     * Prints level of the tree
     */ function printRow(root, prefix, isTail, out, printNode) {
        if (root) {
            out("" + prefix + (isTail ? "\u2514\u2500\u2500 " : "\u251C\u2500\u2500 ") + printNode(root) + "\n");
            var indent = prefix + (isTail ? '    ' : "\u2502   ");
            if (root.left) printRow(root.left, indent, false, out, printNode);
            if (root.right) printRow(root.right, indent, true, out, printNode);
        }
    }
    var Tree = /** @class */ function() {
        function Tree(comparator) {
            if (comparator === void 0) comparator = DEFAULT_COMPARE;
            this._root = null;
            this._size = 0;
            this._comparator = comparator;
        }
        /**
       * Inserts a key, allows duplicates
       */ Tree.prototype.insert = function(key, data) {
            this._size++;
            return this._root = insert(key, data, this._root, this._comparator);
        };
        /**
       * Adds a key, if it is not present in the tree
       */ Tree.prototype.add = function(key, data) {
            var node = new Node(key, data);
            if (this._root === null) {
                node.left = node.right = null;
                this._size++;
                this._root = node;
            }
            var comparator = this._comparator;
            var t = splay(key, this._root, comparator);
            var cmp = comparator(key, t.key);
            if (cmp === 0) this._root = t;
            else {
                if (cmp < 0) {
                    node.left = t.left;
                    node.right = t;
                    t.left = null;
                } else if (cmp > 0) {
                    node.right = t.right;
                    node.left = t;
                    t.right = null;
                }
                this._size++;
                this._root = node;
            }
            return this._root;
        };
        /**
       * @param  {Key} key
       * @return {Node|null}
       */ Tree.prototype.remove = function(key) {
            this._root = this._remove(key, this._root, this._comparator);
        };
        /**
       * Deletes i from the tree if it's there
       */ Tree.prototype._remove = function(i, t, comparator) {
            var x;
            if (t === null) return null;
            t = splay(i, t, comparator);
            var cmp = comparator(i, t.key);
            if (cmp === 0) {
                /* found it */ if (t.left === null) x = t.right;
                else {
                    x = splay(i, t.left, comparator);
                    x.right = t.right;
                }
                this._size--;
                return x;
            }
            return t; /* It wasn't there */ 
        };
        /**
       * Removes and returns the node with smallest key
       */ Tree.prototype.pop = function() {
            var node = this._root;
            if (node) {
                while(node.left)node = node.left;
                this._root = splay(node.key, this._root, this._comparator);
                this._root = this._remove(node.key, this._root, this._comparator);
                return {
                    key: node.key,
                    data: node.data
                };
            }
            return null;
        };
        /**
       * Find without splaying
       */ Tree.prototype.findStatic = function(key) {
            var current = this._root;
            var compare = this._comparator;
            while(current){
                var cmp = compare(key, current.key);
                if (cmp === 0) return current;
                else if (cmp < 0) current = current.left;
                else current = current.right;
            }
            return null;
        };
        Tree.prototype.find = function(key) {
            if (this._root) {
                this._root = splay(key, this._root, this._comparator);
                if (this._comparator(key, this._root.key) !== 0) return null;
            }
            return this._root;
        };
        Tree.prototype.contains = function(key) {
            var current = this._root;
            var compare = this._comparator;
            while(current){
                var cmp = compare(key, current.key);
                if (cmp === 0) return true;
                else if (cmp < 0) current = current.left;
                else current = current.right;
            }
            return false;
        };
        Tree.prototype.forEach = function(visitor, ctx) {
            var current = this._root;
            var Q = []; /* Initialize stack s */ 
            var done = false;
            while(!done){
                if (current !== null) {
                    Q.push(current);
                    current = current.left;
                } else if (Q.length !== 0) {
                    current = Q.pop();
                    visitor.call(ctx, current);
                    current = current.right;
                } else done = true;
            }
            return this;
        };
        /**
       * Walk key range from `low` to `high`. Stops if `fn` returns a value.
       */ Tree.prototype.range = function(low, high, fn, ctx) {
            var Q = [];
            var compare = this._comparator;
            var node = this._root;
            var cmp;
            while(Q.length !== 0 || node)if (node) {
                Q.push(node);
                node = node.left;
            } else {
                node = Q.pop();
                cmp = compare(node.key, high);
                if (cmp > 0) break;
                else if (compare(node.key, low) >= 0) {
                    if (fn.call(ctx, node)) return this; // stop if smth is returned
                }
                node = node.right;
            }
            return this;
        };
        /**
       * Returns array of keys
       */ Tree.prototype.keys = function() {
            var keys = [];
            this.forEach(function(_a) {
                var key = _a.key;
                return keys.push(key);
            });
            return keys;
        };
        /**
       * Returns array of all the data in the nodes
       */ Tree.prototype.values = function() {
            var values = [];
            this.forEach(function(_a) {
                var data = _a.data;
                return values.push(data);
            });
            return values;
        };
        Tree.prototype.min = function() {
            if (this._root) return this.minNode(this._root).key;
            return null;
        };
        Tree.prototype.max = function() {
            if (this._root) return this.maxNode(this._root).key;
            return null;
        };
        Tree.prototype.minNode = function(t) {
            if (t === void 0) t = this._root;
            if (t) while(t.left)t = t.left;
            return t;
        };
        Tree.prototype.maxNode = function(t) {
            if (t === void 0) t = this._root;
            if (t) while(t.right)t = t.right;
            return t;
        };
        /**
       * Returns node at given index
       */ Tree.prototype.at = function(index) {
            var current = this._root;
            var done = false;
            var i = 0;
            var Q = [];
            while(!done){
                if (current) {
                    Q.push(current);
                    current = current.left;
                } else if (Q.length > 0) {
                    current = Q.pop();
                    if (i === index) return current;
                    i++;
                    current = current.right;
                } else done = true;
            }
            return null;
        };
        Tree.prototype.next = function(d) {
            var root = this._root;
            var successor = null;
            if (d.right) {
                successor = d.right;
                while(successor.left)successor = successor.left;
                return successor;
            }
            var comparator = this._comparator;
            while(root){
                var cmp = comparator(d.key, root.key);
                if (cmp === 0) break;
                else if (cmp < 0) {
                    successor = root;
                    root = root.left;
                } else root = root.right;
            }
            return successor;
        };
        Tree.prototype.prev = function(d) {
            var root = this._root;
            var predecessor = null;
            if (d.left !== null) {
                predecessor = d.left;
                while(predecessor.right)predecessor = predecessor.right;
                return predecessor;
            }
            var comparator = this._comparator;
            while(root){
                var cmp = comparator(d.key, root.key);
                if (cmp === 0) break;
                else if (cmp < 0) root = root.left;
                else {
                    predecessor = root;
                    root = root.right;
                }
            }
            return predecessor;
        };
        Tree.prototype.clear = function() {
            this._root = null;
            this._size = 0;
            return this;
        };
        Tree.prototype.toList = function() {
            return toList(this._root);
        };
        /**
       * Bulk-load items. Both array have to be same size
       */ Tree.prototype.load = function(keys, values, presort) {
            if (values === void 0) values = [];
            if (presort === void 0) presort = false;
            var size = keys.length;
            var comparator = this._comparator;
            // sort if needed
            if (presort) sort(keys, values, 0, size - 1, comparator);
            if (this._root === null) {
                // empty tree
                this._root = loadRecursive(keys, values, 0, size);
                this._size = size;
            } else {
                // that re-builds the whole tree from two in-order traversals
                var mergedList = mergeLists(this.toList(), createList(keys, values), comparator);
                size = this._size + size;
                this._root = sortedListToBST({
                    head: mergedList
                }, 0, size);
            }
            return this;
        };
        Tree.prototype.isEmpty = function() {
            return this._root === null;
        };
        Object.defineProperty(Tree.prototype, "size", {
            get: function() {
                return this._size;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tree.prototype, "root", {
            get: function() {
                return this._root;
            },
            enumerable: true,
            configurable: true
        });
        Tree.prototype.toString = function(printNode) {
            if (printNode === void 0) printNode = function(n) {
                return String(n.key);
            };
            var out = [];
            printRow(this._root, '', true, function(v) {
                return out.push(v);
            }, printNode);
            return out.join('');
        };
        Tree.prototype.update = function(key, newKey, newData) {
            var comparator = this._comparator;
            var _a = split(key, this._root, comparator), left = _a.left, right = _a.right;
            if (comparator(key, newKey) < 0) right = insert(newKey, newData, right, comparator);
            else left = insert(newKey, newData, left, comparator);
            this._root = merge(left, right, comparator);
        };
        Tree.prototype.split = function(key) {
            return split(key, this._root, this._comparator);
        };
        Tree.prototype[Symbol.iterator] = function() {
            var current, Q, done;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        current = this._root;
                        Q = [];
                        done = false;
                        _a.label = 1;
                    case 1:
                        if (!!done) return [
                            3 /*break*/ ,
                            6
                        ];
                        if (!(current !== null)) return [
                            3 /*break*/ ,
                            2
                        ];
                        Q.push(current);
                        current = current.left;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!(Q.length !== 0)) return [
                            3 /*break*/ ,
                            4
                        ];
                        current = Q.pop();
                        return [
                            4 /*yield*/ ,
                            current
                        ];
                    case 3:
                        _a.sent();
                        current = current.right;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        done = true;
                        _a.label = 5;
                    case 5:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        };
        return Tree;
    }();
    function loadRecursive(keys, values, start, end) {
        var size = end - start;
        if (size > 0) {
            var middle = start + Math.floor(size / 2);
            var key = keys[middle];
            var data = values[middle];
            var node = new Node(key, data);
            node.left = loadRecursive(keys, values, start, middle);
            node.right = loadRecursive(keys, values, middle + 1, end);
            return node;
        }
        return null;
    }
    function createList(keys, values) {
        var head = new Node(null, null);
        var p = head;
        for(var i = 0; i < keys.length; i++)p = p.next = new Node(keys[i], values[i]);
        p.next = null;
        return head.next;
    }
    function toList(root) {
        var current = root;
        var Q = [];
        var done = false;
        var head = new Node(null, null);
        var p = head;
        while(!done){
            if (current) {
                Q.push(current);
                current = current.left;
            } else if (Q.length > 0) {
                current = p = p.next = Q.pop();
                current = current.right;
            } else done = true;
        }
        p.next = null; // that'll work even if the tree was empty
        return head.next;
    }
    function sortedListToBST(list, start, end) {
        var size = end - start;
        if (size > 0) {
            var middle = start + Math.floor(size / 2);
            var left = sortedListToBST(list, start, middle);
            var root = list.head;
            root.left = left;
            list.head = list.head.next;
            root.right = sortedListToBST(list, middle + 1, end);
            return root;
        }
        return null;
    }
    function mergeLists(l1, l2, compare) {
        var head = new Node(null, null); // dummy
        var p = head;
        var p1 = l1;
        var p2 = l2;
        while(p1 !== null && p2 !== null){
            if (compare(p1.key, p2.key) < 0) {
                p.next = p1;
                p1 = p1.next;
            } else {
                p.next = p2;
                p2 = p2.next;
            }
            p = p.next;
        }
        if (p1 !== null) p.next = p1;
        else if (p2 !== null) p.next = p2;
        return head.next;
    }
    function sort(keys, values, left, right, compare) {
        if (left >= right) return;
        var pivot = keys[left + right >> 1];
        var i = left - 1;
        var j = right + 1;
        while(true){
            do i++;
            while (compare(keys[i], pivot) < 0);
            do j--;
            while (compare(keys[j], pivot) > 0);
            if (i >= j) break;
            var tmp = keys[i];
            keys[i] = keys[j];
            keys[j] = tmp;
            tmp = values[i];
            values[i] = values[j];
            values[j] = tmp;
        }
        sort(keys, values, left, j, compare);
        sort(keys, values, j + 1, right, compare);
    }
    /**
     * A bounding box has the format:
     *
     *  { ll: { x: xmin, y: ymin }, ur: { x: xmax, y: ymax } }
     *
     */ const isInBbox = (bbox, point)=>{
        return bbox.ll.x <= point.x && point.x <= bbox.ur.x && bbox.ll.y <= point.y && point.y <= bbox.ur.y;
    };
    /* Returns either null, or a bbox (aka an ordered pair of points)
     * If there is only one point of overlap, a bbox with identical points
     * will be returned */ const getBboxOverlap = (b1, b2)=>{
        // check if the bboxes overlap at all
        if (b2.ur.x < b1.ll.x || b1.ur.x < b2.ll.x || b2.ur.y < b1.ll.y || b1.ur.y < b2.ll.y) return null;
        // find the middle two X values
        const lowerX = b1.ll.x < b2.ll.x ? b2.ll.x : b1.ll.x;
        const upperX = b1.ur.x < b2.ur.x ? b1.ur.x : b2.ur.x;
        // find the middle two Y values
        const lowerY = b1.ll.y < b2.ll.y ? b2.ll.y : b1.ll.y;
        const upperY = b1.ur.y < b2.ur.y ? b1.ur.y : b2.ur.y;
        // put those middle values together to get the overlap
        return {
            ll: {
                x: lowerX,
                y: lowerY
            },
            ur: {
                x: upperX,
                y: upperY
            }
        };
    };
    /* Javascript doesn't do integer math. Everything is
     * floating point with percision Number.EPSILON.
     *
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/EPSILON
     */ let epsilon$1 = Number.EPSILON;
    // IE Polyfill
    if (epsilon$1 === undefined) epsilon$1 = Math.pow(2, -52);
    const EPSILON_SQ = epsilon$1 * epsilon$1;
    /* FLP comparator */ const cmp = (a, b)=>{
        // check if they're both 0
        if (-epsilon$1 < a && a < epsilon$1) {
            if (-epsilon$1 < b && b < epsilon$1) return 0;
        }
        // check if they're flp equal
        const ab = a - b;
        if (ab * ab < EPSILON_SQ * a * b) return 0;
        // normal comparison
        return a < b ? -1 : 1;
    };
    /**
     * This class rounds incoming values sufficiently so that
     * floating points problems are, for the most part, avoided.
     *
     * Incoming points are have their x & y values tested against
     * all previously seen x & y values. If either is 'too close'
     * to a previously seen value, it's value is 'snapped' to the
     * previously seen value.
     *
     * All points should be rounded by this class before being
     * stored in any data structures in the rest of this algorithm.
     */ class PtRounder {
        reset() {
            this.xRounder = new CoordRounder();
            this.yRounder = new CoordRounder();
        }
        round(x, y) {
            return {
                x: this.xRounder.round(x),
                y: this.yRounder.round(y)
            };
        }
        constructor(){
            this.reset();
        }
    }
    class CoordRounder {
        // Note: this can rounds input values backwards or forwards.
        //       You might ask, why not restrict this to just rounding
        //       forwards? Wouldn't that allow left endpoints to always
        //       remain left endpoints during splitting (never change to
        //       right). No - it wouldn't, because we snap intersections
        //       to endpoints (to establish independence from the segment
        //       angle for t-intersections).
        round(coord) {
            const node = this.tree.add(coord);
            const prevNode = this.tree.prev(node);
            if (prevNode !== null && cmp(node.key, prevNode.key) === 0) {
                this.tree.remove(coord);
                return prevNode.key;
            }
            const nextNode = this.tree.next(node);
            if (nextNode !== null && cmp(node.key, nextNode.key) === 0) {
                this.tree.remove(coord);
                return nextNode.key;
            }
            return coord;
        }
        constructor(){
            this.tree = new Tree();
            // preseed with 0 so we don't end up with values < Number.EPSILON
            this.round(0);
        }
    }
    // singleton available by import
    const rounder = new PtRounder();
    const epsilon = 1.1102230246251565e-16;
    const splitter = 134217729;
    const resulterrbound = (3 + 8 * epsilon) * epsilon;
    // fast_expansion_sum_zeroelim routine from oritinal code
    function sum(elen, e, flen, f, h) {
        let Q, Qnew, hh, bvirt;
        let enow = e[0];
        let fnow = f[0];
        let eindex = 0;
        let findex = 0;
        if (fnow > enow === fnow > -enow) {
            Q = enow;
            enow = e[++eindex];
        } else {
            Q = fnow;
            fnow = f[++findex];
        }
        let hindex = 0;
        if (eindex < elen && findex < flen) {
            if (fnow > enow === fnow > -enow) {
                Qnew = enow + Q;
                hh = Q - (Qnew - enow);
                enow = e[++eindex];
            } else {
                Qnew = fnow + Q;
                hh = Q - (Qnew - fnow);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
            while(eindex < elen && findex < flen){
                if (fnow > enow === fnow > -enow) {
                    Qnew = Q + enow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (enow - bvirt);
                    enow = e[++eindex];
                } else {
                    Qnew = Q + fnow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                    fnow = f[++findex];
                }
                Q = Qnew;
                if (hh !== 0) h[hindex++] = hh;
            }
        }
        while(eindex < elen){
            Qnew = Q + enow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (enow - bvirt);
            enow = e[++eindex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        while(findex < flen){
            Qnew = Q + fnow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (fnow - bvirt);
            fnow = f[++findex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        if (Q !== 0 || hindex === 0) h[hindex++] = Q;
        return hindex;
    }
    function estimate(elen, e) {
        let Q = e[0];
        for(let i = 1; i < elen; i++)Q += e[i];
        return Q;
    }
    function vec(n) {
        return new Float64Array(n);
    }
    const ccwerrboundA = (3 + 16 * epsilon) * epsilon;
    const ccwerrboundB = (2 + 12 * epsilon) * epsilon;
    const ccwerrboundC = (9 + 64 * epsilon) * epsilon * epsilon;
    const B = vec(4);
    const C1 = vec(8);
    const C2 = vec(12);
    const D = vec(16);
    const u = vec(4);
    function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
        let acxtail, acytail, bcxtail, bcytail;
        let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
        const acx = ax - cx;
        const bcx = bx - cx;
        const acy = ay - cy;
        const bcy = by - cy;
        s1 = acx * bcy;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcx;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        B[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        B[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        B[2] = _j - (u3 - bvirt) + (_i - bvirt);
        B[3] = u3;
        let det = estimate(4, B);
        let errbound = ccwerrboundB * detsum;
        if (det >= errbound || -det >= errbound) return det;
        bvirt = ax - acx;
        acxtail = ax - (acx + bvirt) + (bvirt - cx);
        bvirt = bx - bcx;
        bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
        bvirt = ay - acy;
        acytail = ay - (acy + bvirt) + (bvirt - cy);
        bvirt = by - bcy;
        bcytail = by - (bcy + bvirt) + (bvirt - cy);
        if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
        errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
        det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
        if (det >= errbound || -det >= errbound) return det;
        s1 = acxtail * bcy;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcx;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const C1len = sum(4, B, 4, u, C1);
        s1 = acx * bcytail;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcxtail;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const C2len = sum(C1len, C1, 4, u, C2);
        s1 = acxtail * bcytail;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcxtail;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const Dlen = sum(C2len, C2, 4, u, D);
        return D[Dlen - 1];
    }
    function orient2d(ax, ay, bx, by, cx, cy) {
        const detleft = (ay - cy) * (bx - cx);
        const detright = (ax - cx) * (by - cy);
        const det = detleft - detright;
        const detsum = Math.abs(detleft + detright);
        if (Math.abs(det) >= ccwerrboundA * detsum) return det;
        return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
    }
    /* Cross Product of two vectors with first point at origin */ const crossProduct = (a, b)=>a.x * b.y - a.y * b.x;
    /* Dot Product of two vectors with first point at origin */ const dotProduct = (a, b)=>a.x * b.x + a.y * b.y;
    /* Comparator for two vectors with same starting point */ const compareVectorAngles = (basePt, endPt1, endPt2)=>{
        const res = orient2d(basePt.x, basePt.y, endPt1.x, endPt1.y, endPt2.x, endPt2.y);
        if (res > 0) return -1;
        if (res < 0) return 1;
        return 0;
    };
    const length = (v)=>Math.sqrt(dotProduct(v, v));
    /* Get the sine of the angle from pShared -> pAngle to pShaed -> pBase */ const sineOfAngle = (pShared, pBase, pAngle)=>{
        const vBase = {
            x: pBase.x - pShared.x,
            y: pBase.y - pShared.y
        };
        const vAngle = {
            x: pAngle.x - pShared.x,
            y: pAngle.y - pShared.y
        };
        return crossProduct(vAngle, vBase) / length(vAngle) / length(vBase);
    };
    /* Get the cosine of the angle from pShared -> pAngle to pShaed -> pBase */ const cosineOfAngle = (pShared, pBase, pAngle)=>{
        const vBase = {
            x: pBase.x - pShared.x,
            y: pBase.y - pShared.y
        };
        const vAngle = {
            x: pAngle.x - pShared.x,
            y: pAngle.y - pShared.y
        };
        return dotProduct(vAngle, vBase) / length(vAngle) / length(vBase);
    };
    /* Get the x coordinate where the given line (defined by a point and vector)
     * crosses the horizontal line with the given y coordiante.
     * In the case of parrallel lines (including overlapping ones) returns null. */ const horizontalIntersection = (pt, v, y)=>{
        if (v.y === 0) return null;
        return {
            x: pt.x + v.x / v.y * (y - pt.y),
            y: y
        };
    };
    /* Get the y coordinate where the given line (defined by a point and vector)
     * crosses the vertical line with the given x coordiante.
     * In the case of parrallel lines (including overlapping ones) returns null. */ const verticalIntersection = (pt, v, x)=>{
        if (v.x === 0) return null;
        return {
            x: x,
            y: pt.y + v.y / v.x * (x - pt.x)
        };
    };
    /* Get the intersection of two lines, each defined by a base point and a vector.
     * In the case of parrallel lines (including overlapping ones) returns null. */ const intersection$1 = (pt1, v1, pt2, v2)=>{
        // take some shortcuts for vertical and horizontal lines
        // this also ensures we don't calculate an intersection and then discover
        // it's actually outside the bounding box of the line
        if (v1.x === 0) return verticalIntersection(pt2, v2, pt1.x);
        if (v2.x === 0) return verticalIntersection(pt1, v1, pt2.x);
        if (v1.y === 0) return horizontalIntersection(pt2, v2, pt1.y);
        if (v2.y === 0) return horizontalIntersection(pt1, v1, pt2.y);
        // General case for non-overlapping segments.
        // This algorithm is based on Schneider and Eberly.
        // http://www.cimec.org.ar/~ncalvo/Schneider_Eberly.pdf - pg 244
        const kross = crossProduct(v1, v2);
        if (kross == 0) return null;
        const ve = {
            x: pt2.x - pt1.x,
            y: pt2.y - pt1.y
        };
        const d1 = crossProduct(ve, v1) / kross;
        const d2 = crossProduct(ve, v2) / kross;
        // take the average of the two calculations to minimize rounding error
        const x1 = pt1.x + d2 * v1.x, x2 = pt2.x + d1 * v2.x;
        const y1 = pt1.y + d2 * v1.y, y2 = pt2.y + d1 * v2.y;
        const x = (x1 + x2) / 2;
        const y = (y1 + y2) / 2;
        return {
            x: x,
            y: y
        };
    };
    class SweepEvent {
        // for ordering sweep events in the sweep event queue
        static compare(a, b) {
            // favor event with a point that the sweep line hits first
            const ptCmp = SweepEvent.comparePoints(a.point, b.point);
            if (ptCmp !== 0) return ptCmp;
            // the points are the same, so link them if needed
            if (a.point !== b.point) a.link(b);
            // favor right events over left
            if (a.isLeft !== b.isLeft) return a.isLeft ? 1 : -1;
            // we have two matching left or right endpoints
            // ordering of this case is the same as for their segments
            return Segment.compare(a.segment, b.segment);
        }
        // for ordering points in sweep line order
        static comparePoints(aPt, bPt) {
            if (aPt.x < bPt.x) return -1;
            if (aPt.x > bPt.x) return 1;
            if (aPt.y < bPt.y) return -1;
            if (aPt.y > bPt.y) return 1;
            return 0;
        }
        link(other) {
            if (other.point === this.point) throw new Error("Tried to link already linked events");
            const otherEvents = other.point.events;
            for(let i = 0, iMax = otherEvents.length; i < iMax; i++){
                const evt = otherEvents[i];
                this.point.events.push(evt);
                evt.point = this.point;
            }
            this.checkForConsuming();
        }
        /* Do a pass over our linked events and check to see if any pair
       * of segments match, and should be consumed. */ checkForConsuming() {
            // FIXME: The loops in this method run O(n^2) => no good.
            //        Maintain little ordered sweep event trees?
            //        Can we maintaining an ordering that avoids the need
            //        for the re-sorting with getLeftmostComparator in geom-out?
            // Compare each pair of events to see if other events also match
            const numEvents = this.point.events.length;
            for(let i = 0; i < numEvents; i++){
                const evt1 = this.point.events[i];
                if (evt1.segment.consumedBy !== undefined) continue;
                for(let j = i + 1; j < numEvents; j++){
                    const evt2 = this.point.events[j];
                    if (evt2.consumedBy !== undefined) continue;
                    if (evt1.otherSE.point.events !== evt2.otherSE.point.events) continue;
                    evt1.segment.consume(evt2.segment);
                }
            }
        }
        getAvailableLinkedEvents() {
            // point.events is always of length 2 or greater
            const events = [];
            for(let i = 0, iMax = this.point.events.length; i < iMax; i++){
                const evt = this.point.events[i];
                if (evt !== this && !evt.segment.ringOut && evt.segment.isInResult()) events.push(evt);
            }
            return events;
        }
        /**
       * Returns a comparator function for sorting linked events that will
       * favor the event that will give us the smallest left-side angle.
       * All ring construction starts as low as possible heading to the right,
       * so by always turning left as sharp as possible we'll get polygons
       * without uncessary loops & holes.
       *
       * The comparator function has a compute cache such that it avoids
       * re-computing already-computed values.
       */ getLeftmostComparator(baseEvent) {
            const cache = new Map();
            const fillCache = (linkedEvent)=>{
                const nextEvent = linkedEvent.otherSE;
                cache.set(linkedEvent, {
                    sine: sineOfAngle(this.point, baseEvent.point, nextEvent.point),
                    cosine: cosineOfAngle(this.point, baseEvent.point, nextEvent.point)
                });
            };
            return (a, b)=>{
                if (!cache.has(a)) fillCache(a);
                if (!cache.has(b)) fillCache(b);
                const { sine: asine, cosine: acosine } = cache.get(a);
                const { sine: bsine, cosine: bcosine } = cache.get(b);
                // both on or above x-axis
                if (asine >= 0 && bsine >= 0) {
                    if (acosine < bcosine) return 1;
                    if (acosine > bcosine) return -1;
                    return 0;
                }
                // both below x-axis
                if (asine < 0 && bsine < 0) {
                    if (acosine < bcosine) return -1;
                    if (acosine > bcosine) return 1;
                    return 0;
                }
                // one above x-axis, one below
                if (bsine < asine) return -1;
                if (bsine > asine) return 1;
                return 0;
            };
        }
        // Warning: 'point' input will be modified and re-used (for performance)
        constructor(point, isLeft){
            if (point.events === undefined) point.events = [
                this
            ];
            else point.events.push(this);
            this.point = point;
            this.isLeft = isLeft;
        // this.segment, this.otherSE set by factory
        }
    }
    // Give segments unique ID's to get consistent sorting of
    // segments and sweep events when all else is identical
    let segmentId = 0;
    class Segment {
        /* This compare() function is for ordering segments in the sweep
       * line tree, and does so according to the following criteria:
       *
       * Consider the vertical line that lies an infinestimal step to the
       * right of the right-more of the two left endpoints of the input
       * segments. Imagine slowly moving a point up from negative infinity
       * in the increasing y direction. Which of the two segments will that
       * point intersect first? That segment comes 'before' the other one.
       *
       * If neither segment would be intersected by such a line, (if one
       * or more of the segments are vertical) then the line to be considered
       * is directly on the right-more of the two left inputs.
       */ static compare(a, b) {
            const alx = a.leftSE.point.x;
            const blx = b.leftSE.point.x;
            const arx = a.rightSE.point.x;
            const brx = b.rightSE.point.x;
            // check if they're even in the same vertical plane
            if (brx < alx) return 1;
            if (arx < blx) return -1;
            const aly = a.leftSE.point.y;
            const bly = b.leftSE.point.y;
            const ary = a.rightSE.point.y;
            const bry = b.rightSE.point.y;
            // is left endpoint of segment B the right-more?
            if (alx < blx) {
                // are the two segments in the same horizontal plane?
                if (bly < aly && bly < ary) return 1;
                if (bly > aly && bly > ary) return -1;
                // is the B left endpoint colinear to segment A?
                const aCmpBLeft = a.comparePoint(b.leftSE.point);
                if (aCmpBLeft < 0) return 1;
                if (aCmpBLeft > 0) return -1;
                // is the A right endpoint colinear to segment B ?
                const bCmpARight = b.comparePoint(a.rightSE.point);
                if (bCmpARight !== 0) return bCmpARight;
                // colinear segments, consider the one with left-more
                // left endpoint to be first (arbitrary?)
                return -1;
            }
            // is left endpoint of segment A the right-more?
            if (alx > blx) {
                if (aly < bly && aly < bry) return -1;
                if (aly > bly && aly > bry) return 1;
                // is the A left endpoint colinear to segment B?
                const bCmpALeft = b.comparePoint(a.leftSE.point);
                if (bCmpALeft !== 0) return bCmpALeft;
                // is the B right endpoint colinear to segment A?
                const aCmpBRight = a.comparePoint(b.rightSE.point);
                if (aCmpBRight < 0) return 1;
                if (aCmpBRight > 0) return -1;
                // colinear segments, consider the one with left-more
                // left endpoint to be first (arbitrary?)
                return 1;
            }
            // if we get here, the two left endpoints are in the same
            // vertical plane, ie alx === blx
            // consider the lower left-endpoint to come first
            if (aly < bly) return -1;
            if (aly > bly) return 1;
            // left endpoints are identical
            // check for colinearity by using the left-more right endpoint
            // is the A right endpoint more left-more?
            if (arx < brx) {
                const bCmpARight = b.comparePoint(a.rightSE.point);
                if (bCmpARight !== 0) return bCmpARight;
            }
            // is the B right endpoint more left-more?
            if (arx > brx) {
                const aCmpBRight = a.comparePoint(b.rightSE.point);
                if (aCmpBRight < 0) return 1;
                if (aCmpBRight > 0) return -1;
            }
            if (arx !== brx) {
                // are these two [almost] vertical segments with opposite orientation?
                // if so, the one with the lower right endpoint comes first
                const ay = ary - aly;
                const ax = arx - alx;
                const by = bry - bly;
                const bx = brx - blx;
                if (ay > ax && by < bx) return 1;
                if (ay < ax && by > bx) return -1;
            }
            // we have colinear segments with matching orientation
            // consider the one with more left-more right endpoint to be first
            if (arx > brx) return 1;
            if (arx < brx) return -1;
            // if we get here, two two right endpoints are in the same
            // vertical plane, ie arx === brx
            // consider the lower right-endpoint to come first
            if (ary < bry) return -1;
            if (ary > bry) return 1;
            // right endpoints identical as well, so the segments are idential
            // fall back on creation order as consistent tie-breaker
            if (a.id < b.id) return -1;
            if (a.id > b.id) return 1;
            // identical segment, ie a === b
            return 0;
        }
        static fromRing(pt1, pt2, ring) {
            let leftPt, rightPt, winding;
            // ordering the two points according to sweep line ordering
            const cmpPts = SweepEvent.comparePoints(pt1, pt2);
            if (cmpPts < 0) {
                leftPt = pt1;
                rightPt = pt2;
                winding = 1;
            } else if (cmpPts > 0) {
                leftPt = pt2;
                rightPt = pt1;
                winding = -1;
            } else throw new Error(`Tried to create degenerate segment at [${pt1.x}, ${pt1.y}]`);
            const leftSE = new SweepEvent(leftPt, true);
            const rightSE = new SweepEvent(rightPt, false);
            return new Segment(leftSE, rightSE, [
                ring
            ], [
                winding
            ]);
        }
        /* When a segment is split, the rightSE is replaced with a new sweep event */ replaceRightSE(newRightSE) {
            this.rightSE = newRightSE;
            this.rightSE.segment = this;
            this.rightSE.otherSE = this.leftSE;
            this.leftSE.otherSE = this.rightSE;
        }
        bbox() {
            const y1 = this.leftSE.point.y;
            const y2 = this.rightSE.point.y;
            return {
                ll: {
                    x: this.leftSE.point.x,
                    y: y1 < y2 ? y1 : y2
                },
                ur: {
                    x: this.rightSE.point.x,
                    y: y1 > y2 ? y1 : y2
                }
            };
        }
        /* A vector from the left point to the right */ vector() {
            return {
                x: this.rightSE.point.x - this.leftSE.point.x,
                y: this.rightSE.point.y - this.leftSE.point.y
            };
        }
        isAnEndpoint(pt) {
            return pt.x === this.leftSE.point.x && pt.y === this.leftSE.point.y || pt.x === this.rightSE.point.x && pt.y === this.rightSE.point.y;
        }
        /* Compare this segment with a point.
       *
       * A point P is considered to be colinear to a segment if there
       * exists a distance D such that if we travel along the segment
       * from one * endpoint towards the other a distance D, we find
       * ourselves at point P.
       *
       * Return value indicates:
       *
       *   1: point lies above the segment (to the left of vertical)
       *   0: point is colinear to segment
       *  -1: point lies below the segment (to the right of vertical)
       */ comparePoint(point) {
            if (this.isAnEndpoint(point)) return 0;
            const lPt = this.leftSE.point;
            const rPt = this.rightSE.point;
            const v = this.vector();
            // Exactly vertical segments.
            if (lPt.x === rPt.x) {
                if (point.x === lPt.x) return 0;
                return point.x < lPt.x ? 1 : -1;
            }
            // Nearly vertical segments with an intersection.
            // Check to see where a point on the line with matching Y coordinate is.
            const yDist = (point.y - lPt.y) / v.y;
            const xFromYDist = lPt.x + yDist * v.x;
            if (point.x === xFromYDist) return 0;
            // General case.
            // Check to see where a point on the line with matching X coordinate is.
            const xDist = (point.x - lPt.x) / v.x;
            const yFromXDist = lPt.y + xDist * v.y;
            if (point.y === yFromXDist) return 0;
            return point.y < yFromXDist ? -1 : 1;
        }
        /**
       * Given another segment, returns the first non-trivial intersection
       * between the two segments (in terms of sweep line ordering), if it exists.
       *
       * A 'non-trivial' intersection is one that will cause one or both of the
       * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
       *
       *   * endpoint of segA with endpoint of segB --> trivial
       *   * endpoint of segA with point along segB --> non-trivial
       *   * endpoint of segB with point along segA --> non-trivial
       *   * point along segA with point along segB --> non-trivial
       *
       * If no non-trivial intersection exists, return null
       * Else, return null.
       */ getIntersection(other) {
            // If bboxes don't overlap, there can't be any intersections
            const tBbox = this.bbox();
            const oBbox = other.bbox();
            const bboxOverlap = getBboxOverlap(tBbox, oBbox);
            if (bboxOverlap === null) return null;
            // We first check to see if the endpoints can be considered intersections.
            // This will 'snap' intersections to endpoints if possible, and will
            // handle cases of colinearity.
            const tlp = this.leftSE.point;
            const trp = this.rightSE.point;
            const olp = other.leftSE.point;
            const orp = other.rightSE.point;
            // does each endpoint touch the other segment?
            // note that we restrict the 'touching' definition to only allow segments
            // to touch endpoints that lie forward from where we are in the sweep line pass
            const touchesOtherLSE = isInBbox(tBbox, olp) && this.comparePoint(olp) === 0;
            const touchesThisLSE = isInBbox(oBbox, tlp) && other.comparePoint(tlp) === 0;
            const touchesOtherRSE = isInBbox(tBbox, orp) && this.comparePoint(orp) === 0;
            const touchesThisRSE = isInBbox(oBbox, trp) && other.comparePoint(trp) === 0;
            // do left endpoints match?
            if (touchesThisLSE && touchesOtherLSE) {
                // these two cases are for colinear segments with matching left
                // endpoints, and one segment being longer than the other
                if (touchesThisRSE && !touchesOtherRSE) return trp;
                if (!touchesThisRSE && touchesOtherRSE) return orp;
                // either the two segments match exactly (two trival intersections)
                // or just on their left endpoint (one trivial intersection
                return null;
            }
            // does this left endpoint matches (other doesn't)
            if (touchesThisLSE) {
                // check for segments that just intersect on opposing endpoints
                if (touchesOtherRSE) {
                    if (tlp.x === orp.x && tlp.y === orp.y) return null;
                }
                // t-intersection on left endpoint
                return tlp;
            }
            // does other left endpoint matches (this doesn't)
            if (touchesOtherLSE) {
                // check for segments that just intersect on opposing endpoints
                if (touchesThisRSE) {
                    if (trp.x === olp.x && trp.y === olp.y) return null;
                }
                // t-intersection on left endpoint
                return olp;
            }
            // trivial intersection on right endpoints
            if (touchesThisRSE && touchesOtherRSE) return null;
            // t-intersections on just one right endpoint
            if (touchesThisRSE) return trp;
            if (touchesOtherRSE) return orp;
            // None of our endpoints intersect. Look for a general intersection between
            // infinite lines laid over the segments
            const pt = intersection$1(tlp, this.vector(), olp, other.vector());
            // are the segments parrallel? Note that if they were colinear with overlap,
            // they would have an endpoint intersection and that case was already handled above
            if (pt === null) return null;
            // is the intersection found between the lines not on the segments?
            if (!isInBbox(bboxOverlap, pt)) return null;
            // round the the computed point if needed
            return rounder.round(pt.x, pt.y);
        }
        /**
       * Split the given segment into multiple segments on the given points.
       *  * Each existing segment will retain its leftSE and a new rightSE will be
       *    generated for it.
       *  * A new segment will be generated which will adopt the original segment's
       *    rightSE, and a new leftSE will be generated for it.
       *  * If there are more than two points given to split on, new segments
       *    in the middle will be generated with new leftSE and rightSE's.
       *  * An array of the newly generated SweepEvents will be returned.
       *
       * Warning: input array of points is modified
       */ split(point) {
            const newEvents = [];
            const alreadyLinked = point.events !== undefined;
            const newLeftSE = new SweepEvent(point, true);
            const newRightSE = new SweepEvent(point, false);
            const oldRightSE = this.rightSE;
            this.replaceRightSE(newRightSE);
            newEvents.push(newRightSE);
            newEvents.push(newLeftSE);
            const newSeg = new Segment(newLeftSE, oldRightSE, this.rings.slice(), this.windings.slice());
            // when splitting a nearly vertical downward-facing segment,
            // sometimes one of the resulting new segments is vertical, in which
            // case its left and right events may need to be swapped
            if (SweepEvent.comparePoints(newSeg.leftSE.point, newSeg.rightSE.point) > 0) newSeg.swapEvents();
            if (SweepEvent.comparePoints(this.leftSE.point, this.rightSE.point) > 0) this.swapEvents();
            // in the point we just used to create new sweep events with was already
            // linked to other events, we need to check if either of the affected
            // segments should be consumed
            if (alreadyLinked) {
                newLeftSE.checkForConsuming();
                newRightSE.checkForConsuming();
            }
            return newEvents;
        }
        /* Swap which event is left and right */ swapEvents() {
            const tmpEvt = this.rightSE;
            this.rightSE = this.leftSE;
            this.leftSE = tmpEvt;
            this.leftSE.isLeft = true;
            this.rightSE.isLeft = false;
            for(let i = 0, iMax = this.windings.length; i < iMax; i++)this.windings[i] *= -1;
        }
        /* Consume another segment. We take their rings under our wing
       * and mark them as consumed. Use for perfectly overlapping segments */ consume(other) {
            let consumer = this;
            let consumee = other;
            while(consumer.consumedBy)consumer = consumer.consumedBy;
            while(consumee.consumedBy)consumee = consumee.consumedBy;
            const cmp = Segment.compare(consumer, consumee);
            if (cmp === 0) return; // already consumed
            // the winner of the consumption is the earlier segment
            // according to sweep line ordering
            if (cmp > 0) {
                const tmp = consumer;
                consumer = consumee;
                consumee = tmp;
            }
            // make sure a segment doesn't consume it's prev
            if (consumer.prev === consumee) {
                const tmp = consumer;
                consumer = consumee;
                consumee = tmp;
            }
            for(let i = 0, iMax = consumee.rings.length; i < iMax; i++){
                const ring = consumee.rings[i];
                const winding = consumee.windings[i];
                const index = consumer.rings.indexOf(ring);
                if (index === -1) {
                    consumer.rings.push(ring);
                    consumer.windings.push(winding);
                } else consumer.windings[index] += winding;
            }
            consumee.rings = null;
            consumee.windings = null;
            consumee.consumedBy = consumer;
            // mark sweep events consumed as to maintain ordering in sweep event queue
            consumee.leftSE.consumedBy = consumer.leftSE;
            consumee.rightSE.consumedBy = consumer.rightSE;
        }
        /* The first segment previous segment chain that is in the result */ prevInResult() {
            if (this._prevInResult !== undefined) return this._prevInResult;
            if (!this.prev) this._prevInResult = null;
            else if (this.prev.isInResult()) this._prevInResult = this.prev;
            else this._prevInResult = this.prev.prevInResult();
            return this._prevInResult;
        }
        beforeState() {
            if (this._beforeState !== undefined) return this._beforeState;
            if (!this.prev) this._beforeState = {
                rings: [],
                windings: [],
                multiPolys: []
            };
            else {
                const seg = this.prev.consumedBy || this.prev;
                this._beforeState = seg.afterState();
            }
            return this._beforeState;
        }
        afterState() {
            if (this._afterState !== undefined) return this._afterState;
            const beforeState = this.beforeState();
            this._afterState = {
                rings: beforeState.rings.slice(0),
                windings: beforeState.windings.slice(0),
                multiPolys: []
            };
            const ringsAfter = this._afterState.rings;
            const windingsAfter = this._afterState.windings;
            const mpsAfter = this._afterState.multiPolys;
            // calculate ringsAfter, windingsAfter
            for(let i = 0, iMax = this.rings.length; i < iMax; i++){
                const ring = this.rings[i];
                const winding = this.windings[i];
                const index = ringsAfter.indexOf(ring);
                if (index === -1) {
                    ringsAfter.push(ring);
                    windingsAfter.push(winding);
                } else windingsAfter[index] += winding;
            }
            // calcualte polysAfter
            const polysAfter = [];
            const polysExclude = [];
            for(let i = 0, iMax = ringsAfter.length; i < iMax; i++){
                if (windingsAfter[i] === 0) continue; // non-zero rule
                const ring = ringsAfter[i];
                const poly = ring.poly;
                if (polysExclude.indexOf(poly) !== -1) continue;
                if (ring.isExterior) polysAfter.push(poly);
                else {
                    if (polysExclude.indexOf(poly) === -1) polysExclude.push(poly);
                    const index = polysAfter.indexOf(ring.poly);
                    if (index !== -1) polysAfter.splice(index, 1);
                }
            }
            // calculate multiPolysAfter
            for(let i = 0, iMax = polysAfter.length; i < iMax; i++){
                const mp = polysAfter[i].multiPoly;
                if (mpsAfter.indexOf(mp) === -1) mpsAfter.push(mp);
            }
            return this._afterState;
        }
        /* Is this segment part of the final result? */ isInResult() {
            // if we've been consumed, we're not in the result
            if (this.consumedBy) return false;
            if (this._isInResult !== undefined) return this._isInResult;
            const mpsBefore = this.beforeState().multiPolys;
            const mpsAfter = this.afterState().multiPolys;
            switch(operation.type){
                case "union":
                    {
                        // UNION - included iff:
                        //  * On one side of us there is 0 poly interiors AND
                        //  * On the other side there is 1 or more.
                        const noBefores = mpsBefore.length === 0;
                        const noAfters = mpsAfter.length === 0;
                        this._isInResult = noBefores !== noAfters;
                        break;
                    }
                case "intersection":
                    {
                        // INTERSECTION - included iff:
                        //  * on one side of us all multipolys are rep. with poly interiors AND
                        //  * on the other side of us, not all multipolys are repsented
                        //    with poly interiors
                        let least;
                        let most;
                        if (mpsBefore.length < mpsAfter.length) {
                            least = mpsBefore.length;
                            most = mpsAfter.length;
                        } else {
                            least = mpsAfter.length;
                            most = mpsBefore.length;
                        }
                        this._isInResult = most === operation.numMultiPolys && least < most;
                        break;
                    }
                case "xor":
                    {
                        // XOR - included iff:
                        //  * the difference between the number of multipolys represented
                        //    with poly interiors on our two sides is an odd number
                        const diff = Math.abs(mpsBefore.length - mpsAfter.length);
                        this._isInResult = diff % 2 === 1;
                        break;
                    }
                case "difference":
                    {
                        // DIFFERENCE included iff:
                        //  * on exactly one side, we have just the subject
                        const isJustSubject = (mps)=>mps.length === 1 && mps[0].isSubject;
                        this._isInResult = isJustSubject(mpsBefore) !== isJustSubject(mpsAfter);
                        break;
                    }
                default:
                    throw new Error(`Unrecognized operation type found ${operation.type}`);
            }
            return this._isInResult;
        }
        /* Warning: a reference to ringWindings input will be stored,
       *  and possibly will be later modified */ constructor(leftSE, rightSE, rings, windings){
            this.id = ++segmentId;
            this.leftSE = leftSE;
            leftSE.segment = this;
            leftSE.otherSE = rightSE;
            this.rightSE = rightSE;
            rightSE.segment = this;
            rightSE.otherSE = leftSE;
            this.rings = rings;
            this.windings = windings;
        // left unset for performance, set later in algorithm
        // this.ringOut, this.consumedBy, this.prev
        }
    }
    class RingIn {
        getSweepEvents() {
            const sweepEvents = [];
            for(let i = 0, iMax = this.segments.length; i < iMax; i++){
                const segment = this.segments[i];
                sweepEvents.push(segment.leftSE);
                sweepEvents.push(segment.rightSE);
            }
            return sweepEvents;
        }
        constructor(geomRing, poly, isExterior){
            if (!Array.isArray(geomRing) || geomRing.length === 0) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.poly = poly;
            this.isExterior = isExterior;
            this.segments = [];
            if (typeof geomRing[0][0] !== "number" || typeof geomRing[0][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            const firstPoint = rounder.round(geomRing[0][0], geomRing[0][1]);
            this.bbox = {
                ll: {
                    x: firstPoint.x,
                    y: firstPoint.y
                },
                ur: {
                    x: firstPoint.x,
                    y: firstPoint.y
                }
            };
            let prevPoint = firstPoint;
            for(let i = 1, iMax = geomRing.length; i < iMax; i++){
                if (typeof geomRing[i][0] !== "number" || typeof geomRing[i][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                let point = rounder.round(geomRing[i][0], geomRing[i][1]);
                // skip repeated points
                if (point.x === prevPoint.x && point.y === prevPoint.y) continue;
                this.segments.push(Segment.fromRing(prevPoint, point, this));
                if (point.x < this.bbox.ll.x) this.bbox.ll.x = point.x;
                if (point.y < this.bbox.ll.y) this.bbox.ll.y = point.y;
                if (point.x > this.bbox.ur.x) this.bbox.ur.x = point.x;
                if (point.y > this.bbox.ur.y) this.bbox.ur.y = point.y;
                prevPoint = point;
            }
            // add segment from last to first if last is not the same as first
            if (firstPoint.x !== prevPoint.x || firstPoint.y !== prevPoint.y) this.segments.push(Segment.fromRing(prevPoint, firstPoint, this));
        }
    }
    class PolyIn {
        getSweepEvents() {
            const sweepEvents = this.exteriorRing.getSweepEvents();
            for(let i = 0, iMax = this.interiorRings.length; i < iMax; i++){
                const ringSweepEvents = this.interiorRings[i].getSweepEvents();
                for(let j = 0, jMax = ringSweepEvents.length; j < jMax; j++)sweepEvents.push(ringSweepEvents[j]);
            }
            return sweepEvents;
        }
        constructor(geomPoly, multiPoly){
            if (!Array.isArray(geomPoly)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.exteriorRing = new RingIn(geomPoly[0], this, true);
            // copy by value
            this.bbox = {
                ll: {
                    x: this.exteriorRing.bbox.ll.x,
                    y: this.exteriorRing.bbox.ll.y
                },
                ur: {
                    x: this.exteriorRing.bbox.ur.x,
                    y: this.exteriorRing.bbox.ur.y
                }
            };
            this.interiorRings = [];
            for(let i = 1, iMax = geomPoly.length; i < iMax; i++){
                const ring = new RingIn(geomPoly[i], this, false);
                if (ring.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = ring.bbox.ll.x;
                if (ring.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = ring.bbox.ll.y;
                if (ring.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = ring.bbox.ur.x;
                if (ring.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = ring.bbox.ur.y;
                this.interiorRings.push(ring);
            }
            this.multiPoly = multiPoly;
        }
    }
    class MultiPolyIn {
        getSweepEvents() {
            const sweepEvents = [];
            for(let i = 0, iMax = this.polys.length; i < iMax; i++){
                const polySweepEvents = this.polys[i].getSweepEvents();
                for(let j = 0, jMax = polySweepEvents.length; j < jMax; j++)sweepEvents.push(polySweepEvents[j]);
            }
            return sweepEvents;
        }
        constructor(geom, isSubject){
            if (!Array.isArray(geom)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            try {
                // if the input looks like a polygon, convert it to a multipolygon
                if (typeof geom[0][0][0] === "number") geom = [
                    geom
                ];
            } catch (ex) {
            // The input is either malformed or has empty arrays.
            // In either case, it will be handled later on.
            }
            this.polys = [];
            this.bbox = {
                ll: {
                    x: Number.POSITIVE_INFINITY,
                    y: Number.POSITIVE_INFINITY
                },
                ur: {
                    x: Number.NEGATIVE_INFINITY,
                    y: Number.NEGATIVE_INFINITY
                }
            };
            for(let i = 0, iMax = geom.length; i < iMax; i++){
                const poly = new PolyIn(geom[i], this);
                if (poly.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = poly.bbox.ll.x;
                if (poly.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = poly.bbox.ll.y;
                if (poly.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = poly.bbox.ur.x;
                if (poly.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = poly.bbox.ur.y;
                this.polys.push(poly);
            }
            this.isSubject = isSubject;
        }
    }
    class RingOut {
        /* Given the segments from the sweep line pass, compute & return a series
       * of closed rings from all the segments marked to be part of the result */ static factory(allSegments) {
            const ringsOut = [];
            for(let i = 0, iMax = allSegments.length; i < iMax; i++){
                const segment = allSegments[i];
                if (!segment.isInResult() || segment.ringOut) continue;
                let prevEvent = null;
                let event = segment.leftSE;
                let nextEvent = segment.rightSE;
                const events = [
                    event
                ];
                const startingPoint = event.point;
                const intersectionLEs = [];
                /* Walk the chain of linked events to form a closed ring */ while(true){
                    prevEvent = event;
                    event = nextEvent;
                    events.push(event);
                    /* Is the ring complete? */ if (event.point === startingPoint) break;
                    while(true){
                        const availableLEs = event.getAvailableLinkedEvents();
                        /* Did we hit a dead end? This shouldn't happen.
               * Indicates some earlier part of the algorithm malfunctioned. */ if (availableLEs.length === 0) {
                            const firstPt = events[0].point;
                            const lastPt = events[events.length - 1].point;
                            throw new Error(`Unable to complete output ring starting at [${firstPt.x},` + ` ${firstPt.y}]. Last matching segment found ends at` + ` [${lastPt.x}, ${lastPt.y}].`);
                        }
                        /* Only one way to go, so cotinue on the path */ if (availableLEs.length === 1) {
                            nextEvent = availableLEs[0].otherSE;
                            break;
                        }
                        /* We must have an intersection. Check for a completed loop */ let indexLE = null;
                        for(let j = 0, jMax = intersectionLEs.length; j < jMax; j++)if (intersectionLEs[j].point === event.point) {
                            indexLE = j;
                            break;
                        }
                        /* Found a completed loop. Cut that off and make a ring */ if (indexLE !== null) {
                            const intersectionLE = intersectionLEs.splice(indexLE)[0];
                            const ringEvents = events.splice(intersectionLE.index);
                            ringEvents.unshift(ringEvents[0].otherSE);
                            ringsOut.push(new RingOut(ringEvents.reverse()));
                            continue;
                        }
                        /* register the intersection */ intersectionLEs.push({
                            index: events.length,
                            point: event.point
                        });
                        /* Choose the left-most option to continue the walk */ const comparator = event.getLeftmostComparator(prevEvent);
                        nextEvent = availableLEs.sort(comparator)[0].otherSE;
                        break;
                    }
                }
                ringsOut.push(new RingOut(events));
            }
            return ringsOut;
        }
        getGeom() {
            // Remove superfluous points (ie extra points along a straight line),
            let prevPt = this.events[0].point;
            const points = [
                prevPt
            ];
            for(let i = 1, iMax = this.events.length - 1; i < iMax; i++){
                const pt = this.events[i].point;
                const nextPt = this.events[i + 1].point;
                if (compareVectorAngles(pt, prevPt, nextPt) === 0) continue;
                points.push(pt);
                prevPt = pt;
            }
            // ring was all (within rounding error of angle calc) colinear points
            if (points.length === 1) return null;
            // check if the starting point is necessary
            const pt = points[0];
            const nextPt = points[1];
            if (compareVectorAngles(pt, prevPt, nextPt) === 0) points.shift();
            points.push(points[0]);
            const step = this.isExteriorRing() ? 1 : -1;
            const iStart = this.isExteriorRing() ? 0 : points.length - 1;
            const iEnd = this.isExteriorRing() ? points.length : -1;
            const orderedPoints = [];
            for(let i = iStart; i != iEnd; i += step)orderedPoints.push([
                points[i].x,
                points[i].y
            ]);
            return orderedPoints;
        }
        isExteriorRing() {
            if (this._isExteriorRing === undefined) {
                const enclosing = this.enclosingRing();
                this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
            }
            return this._isExteriorRing;
        }
        enclosingRing() {
            if (this._enclosingRing === undefined) this._enclosingRing = this._calcEnclosingRing();
            return this._enclosingRing;
        }
        /* Returns the ring that encloses this one, if any */ _calcEnclosingRing() {
            // start with the ealier sweep line event so that the prevSeg
            // chain doesn't lead us inside of a loop of ours
            let leftMostEvt = this.events[0];
            for(let i = 1, iMax = this.events.length; i < iMax; i++){
                const evt = this.events[i];
                if (SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
            }
            let prevSeg = leftMostEvt.segment.prevInResult();
            let prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
            while(true){
                // no segment found, thus no ring can enclose us
                if (!prevSeg) return null;
                // no segments below prev segment found, thus the ring of the prev
                // segment must loop back around and enclose us
                if (!prevPrevSeg) return prevSeg.ringOut;
                // if the two segments are of different rings, the ring of the prev
                // segment must either loop around us or the ring of the prev prev
                // seg, which would make us and the ring of the prev peers
                if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
                    if (prevPrevSeg.ringOut.enclosingRing() !== prevSeg.ringOut) return prevSeg.ringOut;
                    else return prevSeg.ringOut.enclosingRing();
                }
                // two segments are from the same ring, so this was a penisula
                // of that ring. iterate downward, keep searching
                prevSeg = prevPrevSeg.prevInResult();
                prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
            }
        }
        constructor(events){
            this.events = events;
            for(let i = 0, iMax = events.length; i < iMax; i++)events[i].segment.ringOut = this;
            this.poly = null;
        }
    }
    class PolyOut {
        addInterior(ring) {
            this.interiorRings.push(ring);
            ring.poly = this;
        }
        getGeom() {
            const geom = [
                this.exteriorRing.getGeom()
            ];
            // exterior ring was all (within rounding error of angle calc) colinear points
            if (geom[0] === null) return null;
            for(let i = 0, iMax = this.interiorRings.length; i < iMax; i++){
                const ringGeom = this.interiorRings[i].getGeom();
                // interior ring was all (within rounding error of angle calc) colinear points
                if (ringGeom === null) continue;
                geom.push(ringGeom);
            }
            return geom;
        }
        constructor(exteriorRing){
            this.exteriorRing = exteriorRing;
            exteriorRing.poly = this;
            this.interiorRings = [];
        }
    }
    class MultiPolyOut {
        getGeom() {
            const geom = [];
            for(let i = 0, iMax = this.polys.length; i < iMax; i++){
                const polyGeom = this.polys[i].getGeom();
                // exterior ring was all (within rounding error of angle calc) colinear points
                if (polyGeom === null) continue;
                geom.push(polyGeom);
            }
            return geom;
        }
        _composePolys(rings) {
            const polys = [];
            for(let i = 0, iMax = rings.length; i < iMax; i++){
                const ring = rings[i];
                if (ring.poly) continue;
                if (ring.isExteriorRing()) polys.push(new PolyOut(ring));
                else {
                    const enclosingRing = ring.enclosingRing();
                    if (!enclosingRing.poly) polys.push(new PolyOut(enclosingRing));
                    enclosingRing.poly.addInterior(ring);
                }
            }
            return polys;
        }
        constructor(rings){
            this.rings = rings;
            this.polys = this._composePolys(rings);
        }
    }
    /**
     * NOTE:  We must be careful not to change any segments while
     *        they are in the SplayTree. AFAIK, there's no way to tell
     *        the tree to rebalance itself - thus before splitting
     *        a segment that's in the tree, we remove it from the tree,
     *        do the split, then re-insert it. (Even though splitting a
     *        segment *shouldn't* change its correct position in the
     *        sweep line tree, the reality is because of rounding errors,
     *        it sometimes does.)
     */ class SweepLine {
        process(event) {
            const segment = event.segment;
            const newEvents = [];
            // if we've already been consumed by another segment,
            // clean up our body parts and get out
            if (event.consumedBy) {
                if (event.isLeft) this.queue.remove(event.otherSE);
                else this.tree.remove(segment);
                return newEvents;
            }
            const node = event.isLeft ? this.tree.add(segment) : this.tree.find(segment);
            if (!node) throw new Error(`Unable to find segment #${segment.id} ` + `[${segment.leftSE.point.x}, ${segment.leftSE.point.y}] -> ` + `[${segment.rightSE.point.x}, ${segment.rightSE.point.y}] ` + "in SweepLine tree.");
            let prevNode = node;
            let nextNode = node;
            let prevSeg = undefined;
            let nextSeg = undefined;
            // skip consumed segments still in tree
            while(prevSeg === undefined){
                prevNode = this.tree.prev(prevNode);
                if (prevNode === null) prevSeg = null;
                else if (prevNode.key.consumedBy === undefined) prevSeg = prevNode.key;
            }
            // skip consumed segments still in tree
            while(nextSeg === undefined){
                nextNode = this.tree.next(nextNode);
                if (nextNode === null) nextSeg = null;
                else if (nextNode.key.consumedBy === undefined) nextSeg = nextNode.key;
            }
            if (event.isLeft) {
                // Check for intersections against the previous segment in the sweep line
                let prevMySplitter = null;
                if (prevSeg) {
                    const prevInter = prevSeg.getIntersection(segment);
                    if (prevInter !== null) {
                        if (!segment.isAnEndpoint(prevInter)) prevMySplitter = prevInter;
                        if (!prevSeg.isAnEndpoint(prevInter)) {
                            const newEventsFromSplit = this._splitSafely(prevSeg, prevInter);
                            for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                        }
                    }
                }
                // Check for intersections against the next segment in the sweep line
                let nextMySplitter = null;
                if (nextSeg) {
                    const nextInter = nextSeg.getIntersection(segment);
                    if (nextInter !== null) {
                        if (!segment.isAnEndpoint(nextInter)) nextMySplitter = nextInter;
                        if (!nextSeg.isAnEndpoint(nextInter)) {
                            const newEventsFromSplit = this._splitSafely(nextSeg, nextInter);
                            for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                        }
                    }
                }
                // For simplicity, even if we find more than one intersection we only
                // spilt on the 'earliest' (sweep-line style) of the intersections.
                // The other intersection will be handled in a future process().
                if (prevMySplitter !== null || nextMySplitter !== null) {
                    let mySplitter = null;
                    if (prevMySplitter === null) mySplitter = nextMySplitter;
                    else if (nextMySplitter === null) mySplitter = prevMySplitter;
                    else {
                        const cmpSplitters = SweepEvent.comparePoints(prevMySplitter, nextMySplitter);
                        mySplitter = cmpSplitters <= 0 ? prevMySplitter : nextMySplitter;
                    }
                    // Rounding errors can cause changes in ordering,
                    // so remove afected segments and right sweep events before splitting
                    this.queue.remove(segment.rightSE);
                    newEvents.push(segment.rightSE);
                    const newEventsFromSplit = segment.split(mySplitter);
                    for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                }
                if (newEvents.length > 0) {
                    // We found some intersections, so re-do the current event to
                    // make sure sweep line ordering is totally consistent for later
                    // use with the segment 'prev' pointers
                    this.tree.remove(segment);
                    newEvents.push(event);
                } else {
                    // done with left event
                    this.segments.push(segment);
                    segment.prev = prevSeg;
                }
            } else {
                // event.isRight
                // since we're about to be removed from the sweep line, check for
                // intersections between our previous and next segments
                if (prevSeg && nextSeg) {
                    const inter = prevSeg.getIntersection(nextSeg);
                    if (inter !== null) {
                        if (!prevSeg.isAnEndpoint(inter)) {
                            const newEventsFromSplit = this._splitSafely(prevSeg, inter);
                            for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                        }
                        if (!nextSeg.isAnEndpoint(inter)) {
                            const newEventsFromSplit = this._splitSafely(nextSeg, inter);
                            for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                        }
                    }
                }
                this.tree.remove(segment);
            }
            return newEvents;
        }
        /* Safely split a segment that is currently in the datastructures
       * IE - a segment other than the one that is currently being processed. */ _splitSafely(seg, pt) {
            // Rounding errors can cause changes in ordering,
            // so remove afected segments and right sweep events before splitting
            // removeNode() doesn't work, so have re-find the seg
            // https://github.com/w8r/splay-tree/pull/5
            this.tree.remove(seg);
            const rightSE = seg.rightSE;
            this.queue.remove(rightSE);
            const newEvents = seg.split(pt);
            newEvents.push(rightSE);
            // splitting can trigger consumption
            if (seg.consumedBy === undefined) this.tree.add(seg);
            return newEvents;
        }
        constructor(queue){
            let comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Segment.compare;
            this.queue = queue;
            this.tree = new Tree(comparator);
            this.segments = [];
        }
    }
    // Limits on iterative processes to prevent infinite loops - usually caused by floating-point math round-off errors.
    const POLYGON_CLIPPING_MAX_QUEUE_SIZE = 1000000;
    const POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS = 1000000;
    class Operation {
        run(type, geom, moreGeoms) {
            operation.type = type;
            rounder.reset();
            /* Convert inputs to MultiPoly objects */ const multipolys = [
                new MultiPolyIn(geom, true)
            ];
            for(let i = 0, iMax = moreGeoms.length; i < iMax; i++)multipolys.push(new MultiPolyIn(moreGeoms[i], false));
            operation.numMultiPolys = multipolys.length;
            /* BBox optimization for difference operation
         * If the bbox of a multipolygon that's part of the clipping doesn't
         * intersect the bbox of the subject at all, we can just drop that
         * multiploygon. */ if (operation.type === "difference") {
                // in place removal
                const subject = multipolys[0];
                let i = 1;
                while(i < multipolys.length)if (getBboxOverlap(multipolys[i].bbox, subject.bbox) !== null) i++;
                else multipolys.splice(i, 1);
            }
            /* BBox optimization for intersection operation
         * If we can find any pair of multipolygons whose bbox does not overlap,
         * then the result will be empty. */ if (operation.type === "intersection") // TODO: this is O(n^2) in number of polygons. By sorting the bboxes,
            //       it could be optimized to O(n * ln(n))
            for(let i = 0, iMax = multipolys.length; i < iMax; i++){
                const mpA = multipolys[i];
                for(let j = i + 1, jMax = multipolys.length; j < jMax; j++){
                    if (getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
                }
            }
            /* Put segment endpoints in a priority queue */ const queue = new Tree(SweepEvent.compare);
            for(let i = 0, iMax = multipolys.length; i < iMax; i++){
                const sweepEvents = multipolys[i].getSweepEvents();
                for(let j = 0, jMax = sweepEvents.length; j < jMax; j++){
                    queue.insert(sweepEvents[j]);
                    if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) // prevents an infinite loop, an otherwise common manifestation of bugs
                    throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big).");
                }
            }
            /* Pass the sweep line over those endpoints */ const sweepLine = new SweepLine(queue);
            let prevQueueSize = queue.size;
            let node = queue.pop();
            while(node){
                const evt = node.key;
                if (queue.size === prevQueueSize) {
                    // prevents an infinite loop, an otherwise common manifestation of bugs
                    const seg = evt.segment;
                    throw new Error(`Unable to pop() ${evt.isLeft ? "left" : "right"} SweepEvent ` + `[${evt.point.x}, ${evt.point.y}] from segment #${seg.id} ` + `[${seg.leftSE.point.x}, ${seg.leftSE.point.y}] -> ` + `[${seg.rightSE.point.x}, ${seg.rightSE.point.y}] from queue.`);
                }
                if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) // prevents an infinite loop, an otherwise common manifestation of bugs
                throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big).");
                if (sweepLine.segments.length > POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS) // prevents an infinite loop, an otherwise common manifestation of bugs
                throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments).");
                const newEvents = sweepLine.process(evt);
                for(let i = 0, iMax = newEvents.length; i < iMax; i++){
                    const evt = newEvents[i];
                    if (evt.consumedBy === undefined) queue.insert(evt);
                }
                prevQueueSize = queue.size;
                node = queue.pop();
            }
            // free some memory we don't need anymore
            rounder.reset();
            /* Collect and compile segments we're keeping into a multipolygon */ const ringsOut = RingOut.factory(sweepLine.segments);
            const result = new MultiPolyOut(ringsOut);
            return result.getGeom();
        }
    }
    // singleton available by import
    const operation = new Operation();
    const union = function(geom) {
        for(var _len = arguments.length, moreGeoms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)moreGeoms[_key - 1] = arguments[_key];
        return operation.run("union", geom, moreGeoms);
    };
    const intersection = function(geom) {
        for(var _len2 = arguments.length, moreGeoms = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)moreGeoms[_key2 - 1] = arguments[_key2];
        return operation.run("intersection", geom, moreGeoms);
    };
    const xor = function(geom) {
        for(var _len3 = arguments.length, moreGeoms = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)moreGeoms[_key3 - 1] = arguments[_key3];
        return operation.run("xor", geom, moreGeoms);
    };
    const difference = function(subjectGeom) {
        for(var _len4 = arguments.length, clippingGeoms = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)clippingGeoms[_key4 - 1] = arguments[_key4];
        return operation.run("difference", subjectGeom, clippingGeoms);
    };
    var index = {
        union: union,
        intersection: intersection,
        xor: xor,
        difference: difference
    };
    return index;
});



function $95437e6a4f5261a8$export$7ec1a3fdd6e82838(operation, geom, ...geoms) {
    const result = (0, $94f0b2b810d4d191$export$77f9e426014f6edd)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($b32bebe3283c38cc$exports)))[operation](geom, ...geoms));
    return result instanceof (0, $94f0b2b810d4d191$export$6d5e6de05c94f9f) ? [] : result;
}
function $95437e6a4f5261a8$export$ea06409da076aec8(multiPolygon, clip) {
    const result = [];
    for (const polygon of multiPolygon)for (const ring of polygon){
        const clipped = $95437e6a4f5261a8$export$7ec1a3fdd6e82838('intersection', [
            [
                ring
            ]
        ], [
            [
                clip
            ]
        ]);
        for (const poly of clipped)result.push(poly);
    }
    return result;
}


function $276b775cfacb0889$export$f3040a9d9c5d06ba(multiPolygon) {
    return multiPolygon.map((poly)=>{
        return poly.map((ring)=>{
            return ring.map((point)=>{
                return [
                    Math.round(point[0] + 0.5) - 0.5,
                    Math.round(point[1] + 0.5) - 0.5
                ]; // on .5
            });
        });
    });
}
class $276b775cfacb0889$export$c61ab90e0d3eb9b1 {
    update() {
        const selection = this.renderedSelection === null ? this.selection : this.renderedSelection;
        if (!selection) {
            this.svgPath1.setAttribute('d', '');
            this.svgPath2.setAttribute('d', '');
            return;
        }
        // firefox has problems with non-scaling-stroke, so we scale manually.
        // ^ it has visual glitches when the transformation changes.
        const transformedSelection = (0, $5f00e0232038b1be$export$aa391dbbf8073422)(selection, this.viewportMat);
        // Firefox has bad performance when zoomed in far (guess: it doesn't clip the path)
        // So we clip manually.
        const clipPadding = 10;
        const clippedSelection = (0, $95437e6a4f5261a8$export$ea06409da076aec8)(transformedSelection, [
            [
                -clipPadding,
                -clipPadding
            ],
            [
                this.viewportWidth + clipPadding,
                -clipPadding
            ],
            [
                this.viewportWidth + clipPadding,
                this.viewportHeight + clipPadding
            ],
            [
                -clipPadding,
                this.viewportHeight + clipPadding
            ],
            [
                -clipPadding,
                -clipPadding
            ]
        ]);
        const d = (0, $b5f980f0748d5a71$export$8f2be1db13cf0f94)($276b775cfacb0889$export$f3040a9d9c5d06ba(clippedSelection));
        this.svgPath1.setAttribute('d', d);
        this.svgPath2.setAttribute('d', d);
    }
    setTransform(transform) {
        this.viewportTransform = transform;
        this.viewportMat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.viewportTransform);
        this.update();
    }
    setSelection(selection) {
        if (this.selection === selection) return;
        this.selection = selection;
        // only need to update when this.selection is used
        if (this.renderedSelection === null) this.update();
    }
    // overwrite project selection
    setRenderedSelection(renderedSelection, isImmediate) {
        if (this.renderedSelection === renderedSelection) return;
        this.renderedSelection = renderedSelection;
        this.update();
    }
    // render project selection again
    clearRenderedSelection(isImmediate) {
        this.renderedSelection = null;
        if (!isImmediate) // good enough to update on next setSelection. (to prevent flickering)
        return;
        this.update();
    }
    setSize(width, height) {
        this.viewportWidth = width;
        this.viewportHeight = height;
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.rootEl.remove();
        this.selection = undefined;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.renderedSelection = null // overwrites this.selection, unless it's null
        ;
        this.viewportTransform = p.transform;
        this.viewportMat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.viewportTransform);
        this.selection = p.selection;
        this.viewportWidth = p.width;
        this.viewportHeight = p.height;
        this.svgPath1 = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'path',
            'vector-effect': 'non-scaling-stroke'
        });
        this.svgPath1.classList.add($52a8a36eabf772e3$export$2f48b40a5a83dc1b);
        this.svgPath2 = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'path',
            'vector-effect': 'non-scaling-stroke'
        });
        this.svgPath2.classList.add($52a8a36eabf772e3$export$eea3e4f737fa39e3);
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.rootEl.append(this.svgPath1, this.svgPath2);
    }
}



const $00631e3d51f88f11$export$31ee023005d8c68f = [
    'touch'
];
const $00631e3d51f88f11$export$4f41ddbc92f66d7d = [
    'space',
    'alt',
    'r',
    'z'
];
const $00631e3d51f88f11$export$c5299001bfb7de59 = [
    'mouse-middle',
    'mouse-right',
    ...$00631e3d51f88f11$export$4f41ddbc92f66d7d
];
const $00631e3d51f88f11$export$5e2c057e240c0b8c = 1 / 16;
const $00631e3d51f88f11$export$ac82c07320907c00 = 128;


const $1e2e9186a42c4ae7$var$toolZoomInImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-zoom-in');
const $1e2e9186a42c4ae7$var$toolZoomOutImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-zoom-out');
const $1e2e9186a42c4ae7$var$viewportResetImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('viewport-reset');
const $1e2e9186a42c4ae7$var$toolHandImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-hand');
const $1e2e9186a42c4ae7$var$editPencilImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-pencil');
const $1e2e9186a42c4ae7$var$DEFAULT_PADDING = 10;
class $1e2e9186a42c4ae7$export$133773870222880f {
    requestRerender() {
        this.doRender = true;
    }
    resetOrZoom(x, y) {
        if (this.isReset) {
            this.isReset = false;
            const canvasP = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)((0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.viewport.getTransform())), {
                x: x,
                y: y
            });
            this.viewport.setTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)({
                x: this.width / 2,
                y: this.height / 2
            }, canvasP, 1, 0, false));
            this.requestRerender();
        } else this.reset();
    }
    reset() {
        const fit = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(this.project.width, this.project.height, this.width - this.padding * 2, this.height - this.padding * 2);
        const scale = fit.width / this.project.width;
        this.viewport.setTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)({
            x: this.width / 2,
            y: this.height / 2
        }, {
            x: this.project.width / 2,
            y: this.project.height / 2
        }, scale, 0, false));
        this.isReset = true;
        this.requestRerender();
    }
    transformCanvas(t) {
        if (t.type === 'translate') {
            const old = this.viewport.getTransform();
            if (t.x === 0 && t.y === 0) return;
            this.viewport.setTransform({
                ...old,
                x: old.x + t.x,
                y: old.y + t.y
            });
        } else if (t.type === 'zoom') {
            const old = this.viewport.getTransform();
            const viewportRect = this.viewport.getElement().getBoundingClientRect();
            t.vX = t.vX ?? viewportRect.width / 2;
            t.vY = t.vY ?? viewportRect.height / 2;
            const metaTransform = (0, $a04467f1089650ac$export$935bc53f7df03c95)(old, {
                x: t.vX,
                y: t.vY
            });
            metaTransform.scale = Math.min((0, $00631e3d51f88f11$export$ac82c07320907c00), metaTransform.scale * t.fac);
            this.viewport.setTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg, metaTransform.isMirrored));
        }
        this.isReset = false;
        this.requestRerender();
    }
    render() {
        this.requestRerender();
    }
    setTransform(transform) {
        this.viewport.setTransform(transform);
        this.requestRerender();
        this.isReset = false;
    }
    setBackground(background) {
        this.viewport.setBackground(background);
    }
    getTransform() {
        return this.viewport.getTransform();
    }
    onPointer(event) {
        this.pointerChain.chainIn(event);
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.animationFrameId !== undefined && cancelAnimationFrame(this.animationFrameId);
        this.viewport.destroy();
        this.viewportPointerListener.destroy();
        this.rootEl.remove();
        this.modeToggle && this.modeToggle.destroy();
        this.selectionRenderer?.destroy();
        this.destroyer.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isReset = true;
        this.doRender = false;
        this.lastEmittedTransform = {
            x: 0,
            y: 0,
            scale: 0,
            angleDeg: 0,
            isMirrored: false
        };
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.renderLoop = ()=>{
            this.animationFrameId = requestAnimationFrame(this.renderLoop);
            if (this.doRender) {
                this.doRender = false;
                this.viewport.render();
                const viewportTransform = this.viewport.getTransform();
                this.selectionRenderer?.setTransform(viewportTransform);
                if (this.onTransformChange && JSON.stringify(this.lastEmittedTransform) !== JSON.stringify(viewportTransform)) {
                    this.onTransformChange(viewportTransform);
                    this.lastEmittedTransform = viewportTransform;
                }
            }
        };
        this.onWheel = (e)=>{
            e.event?.preventDefault();
            const oldScale = this.viewport.getTransform().scale;
            const newScale = oldScale * 1.4 ** -e.deltaY;
            this.transformCanvas({
                type: 'zoom',
                vX: e.relX,
                vY: e.relY,
                fac: newScale / oldScale
            });
        };
        this.width = p.width;
        this.height = p.height;
        this.project = p.project;
        this.onTransformChange = p.onTransformChange;
        this.padding = p.padding ?? $1e2e9186a42c4ae7$var$DEFAULT_PADDING;
        const fit = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(this.project.width, this.project.height, this.width - this.padding * 2, this.height - this.padding * 2);
        const scale = fit.width / this.project.width;
        this.viewport = new (0, $5e9856f8e33534aa$export$a140ed60c2ca052c)({
            width: this.width,
            height: this.height,
            transform: (0, $cdf37dcca656673a$export$99c68a89351e15c0)({
                x: this.width / 2,
                y: this.height / 2
            }, {
                x: this.project.width / 2,
                y: this.project.height / 2
            }, scale, 0, false),
            project: this.project,
            useNativeResolution: false,
            background: p.background
        });
        const doubleTapper = new (0, $c61fdfd84bc32c60$export$db3963a21c01d803)({
            onDoubleTap: (e)=>{
                const m = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.viewport.getTransform());
                const tl = (0, $43e83319b765a157$export$9b20165a36586806)(m, {
                    x: 0,
                    y: 0
                });
                const br = (0, $43e83319b765a157$export$9b20165a36586806)(m, {
                    x: this.project.width,
                    y: this.project.height
                });
                const isInside = (0, $be957da3610487e9$export$921068d8846a1559).isInsideRect({
                    x: e.relX,
                    y: e.relY
                }, {
                    x: tl.x,
                    y: tl.y,
                    width: br.x - tl.x,
                    height: br.y - tl.y
                });
                if (!this.isReset || isInside) this.resetOrZoom(e.relX, e.relY);
            },
            isInstant: true
        });
        let oldTransform = undefined;
        const pinchZoomer = new (0, $84eb4aaf6ec9742b$export$d62358ac2d82abb3)({
            onPinch: (e)=>{
                if (e.type === 'move') {
                    oldTransform ??= this.viewport.getTransform();
                    const metaTransform = (0, $a04467f1089650ac$export$935bc53f7df03c95)(oldTransform, {
                        x: e.downRelX,
                        y: e.downRelY
                    });
                    metaTransform.scale = Math.min((0, $00631e3d51f88f11$export$ac82c07320907c00), metaTransform.scale * e.scale);
                    metaTransform.viewportP.x += e.relX - e.downRelX;
                    metaTransform.viewportP.y += e.relY - e.downRelY;
                    this.viewport.setTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg, metaTransform.isMirrored));
                    this.requestRerender();
                    this.isReset = false;
                } else if (e.type === 'end') oldTransform = undefined;
            }
        });
        this.pointerChain = new (0, $29dd970aa1f95ac5$export$649a211db9812745)({
            chainArr: [
                pinchZoomer,
                doubleTapper
            ]
        });
        this.pointerChain.setChainOut((e)=>{
            if (e.button && [
                'left',
                'middle'
            ].includes(e.button) && e.type === 'pointermove') this.transformCanvas({
                type: 'translate',
                x: e.dX,
                y: e.dY
            });
        });
        this.viewport.getElement().classList.add($6c5b492e766c52d7$export$d7b7311ec04a3e8f);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.viewport.getElement(), {
            userSelect: 'none',
            touchAction: 'none'
        });
        this.viewport.getElement().addEventListener('touchend', (e)=>{
            e.preventDefault();
            return false;
        });
        this.viewport.getElement().addEventListener('contextmenu', (e)=>{
            e.preventDefault();
            return false;
        });
        this.viewport.getElement().addEventListener('dragstart', (e)=>{
            e.preventDefault();
            return false;
        });
        this.viewportPointerListener = new (0, $3a4865bce5f52590$export$9371bd96776f4e82)({
            target: this.viewport.getElement(),
            onPointer: (e)=>{
                this.pointerChain.chainIn(e);
            },
            onWheel: this.onWheel,
            useDirtyWheel: true,
            maxPointers: 2
        });
        const svgRoot = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'svg'
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(svgRoot, {
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        });
        if (p.selection) {
            this.selectionRenderer = new (0, $276b775cfacb0889$export$c61ab90e0d3eb9b1)({
                transform: this.lastEmittedTransform,
                selection: p.selection,
                width: this.width,
                height: this.height
            });
            svgRoot.append(this.selectionRenderer.getElement());
        }
        if (p.hasEditMode) this.modeToggle = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            isFocusable: true,
            optionArr: [
                'edit',
                'hand'
            ].map((id)=>{
                const el = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    className: 'dark-invert',
                    css: {
                        width: 28,
                        height: 28,
                        backgroundSize: 'contain',
                        margin: 5,
                        backgroundImage: `url(${id === 'edit' ? p.editIcon ?? $1e2e9186a42c4ae7$var$editPencilImg : $1e2e9186a42c4ae7$var$toolHandImg})`,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }
                });
                return {
                    id: id,
                    label: el,
                    title: id === 'edit' ? (0, $fc42a07754814920$export$ce37e184d908d785)('tab-edit') : (0, $fc42a07754814920$export$ce37e184d908d785)('tool-hand')
                };
            }),
            initId: 'edit',
            onChange: (val)=>{
                p.onModeChange && p.onModeChange(val);
            }
        });
        // pointer-events: auto - So the canvas can be ignored, while the buttons still work.
        this.rootEl = (0, $8405ecc79d32770a$export$db3b6bfb95261072)({
            className: p.hasBorder === false ? undefined : $6c5b492e766c52d7$export$48c2d0f2f545ac27,
            css: {
                position: 'relative',
                zIndex: 0
            }
        }, [
            this.viewport.getElement(),
            svgRoot,
            ...this.modeToggle ? [
                (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',pos-absolute,left-5,top-5,z-1,pointer-auto', [
                    this.modeToggle.getElement()
                ])
            ] : [],
            (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',pos-absolute,right-5,bottom-5,flex,flexCol,gap-5,z-1,pointer-auto', [
                (0, $8405ecc79d32770a$export$db3b6bfb95261072)({
                    tagName: 'button',
                    className: 'kl-button',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('hand-reset'),
                    destroyer: this.destroyer,
                    onClick: ()=>{
                        this.reset();
                    },
                    content: `<img alt="reset" height="20" src="${$1e2e9186a42c4ae7$var$viewportResetImg}">`
                }),
                (0, $8405ecc79d32770a$export$db3b6bfb95261072)({
                    tagName: 'button',
                    className: 'kl-button',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('zoom-in'),
                    destroyer: this.destroyer,
                    onClick: ()=>{
                        const oldScale = this.viewport.getTransform().scale;
                        const newScale = (0, $b9d080b8d62d48af$export$8c03162b1a39d183)(oldScale, 1);
                        this.transformCanvas({
                            type: 'zoom',
                            fac: newScale / oldScale
                        });
                    },
                    content: `<img alt="zoom-in" height="20" src="${$1e2e9186a42c4ae7$var$toolZoomInImg}">`
                }),
                (0, $8405ecc79d32770a$export$db3b6bfb95261072)({
                    tagName: 'button',
                    className: 'kl-button',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('zoom-out'),
                    destroyer: this.destroyer,
                    onClick: ()=>{
                        const oldScale = this.viewport.getTransform().scale;
                        const newScale = (0, $b9d080b8d62d48af$export$8c03162b1a39d183)(oldScale, -1);
                        this.transformCanvas({
                            type: 'zoom',
                            fac: newScale / oldScale
                        });
                    },
                    content: `<img alt="zoom-out" height="20" src="${$1e2e9186a42c4ae7$var$toolZoomOutImg}">`
                })
            ])
        ]);
        this.renderLoop();
    }
}










const $67988e2254ac179d$var$editCropImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-crop');
class $67988e2254ac179d$export$40175a5948a88a57 {
    resetCrop() {
        this.cropRect = {
            x: 0,
            y: 0,
            width: this.canvas.width,
            height: this.canvas.height
        };
    }
    getViewportSelectionRect() {
        const transform = this.preview.getTransform();
        const mat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(transform);
        const p = (0, $43e83319b765a157$export$9b20165a36586806)(mat, this.cropRect);
        return {
            x: p.x,
            y: p.y,
            width: this.cropRect.width * transform.scale,
            height: this.cropRect.height * transform.scale
        };
    }
    async updateCroppedCanvas() {
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.croppedCanvas, Math.round(this.cropRect.width), Math.round(this.cropRect.height), {
            ensureCleared: true
        });
        const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.croppedCanvas);
        ctx.drawImage(this.canvas, Math.round(-this.cropRect.x), Math.round(-this.cropRect.y));
        const blob = await (0, $2f436639594531f3$export$403d539f215df596)(this.croppedCanvas, 'image/png');
        this.croppedBlob = blob;
        if (this.croppedObjectUrl !== '') URL.revokeObjectURL(this.croppedObjectUrl);
        this.croppedObjectUrl = URL.createObjectURL(blob);
        if (this.croppedImageElement) this.croppedImageElement.src = this.croppedObjectUrl;
        this.onChange?.(this.croppedCanvas.width, this.croppedCanvas.height);
    }
    updateSelectionRect() {
        const rect = this.getViewportSelectionRect();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.selectionRectEl, {
            left: rect.x,
            top: rect.y,
            width: rect.width,
            height: rect.height,
            display: this.isReset() ? 'none' : ''
        });
        this.onChange?.(Math.round(this.cropRect.width), Math.round(this.cropRect.height));
    }
    isReset() {
        return this.cropRect.x === 0 && this.cropRect.y === 0 && this.cropRect.width === this.canvas.width && this.cropRect.height === this.canvas.height;
    }
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    // in input canvas coordinates
    getCropRect() {
        return (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.cropRect);
    }
    getCroppedCanvas() {
        return this.croppedCanvas;
    }
    // image/png blob
    getCroppedBlob() {
        return this.croppedBlob;
    }
    setCanvas(canvas) {
        this.canvas = canvas;
        this.previewLayer.image = canvas;
        this.updateCroppedCanvas();
        this.preview.render();
    }
    destroy() {
        if (this.croppedImageElement) this.croppedImageElement.src = '';
        URL.revokeObjectURL(this.croppedObjectUrl);
        this.rootEl.remove();
        this.eventTarget.style.removeProperty('width');
        this.eventTarget.style.removeProperty('height');
        this.keyListener.destroy();
        this.pointerListener.destroy();
        this.preview.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.cropRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        } // canvas coordinates
        ;
        this.mode = 'edit';
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-edit-crop-preview',
            css: {
                position: 'relative',
                height: p.height,
                width: p.width,
                overflow: 'hidden'
            }
        });
        if (p.onChange) this.onChange = p.onChange;
        this.canvas = p.canvas;
        if (p.init) this.cropRect = p.init;
        else this.resetCrop();
        const isInsideSelectionRect = (p)=>{
            return (0, $be957da3610487e9$export$921068d8846a1559).isInsideRect(p, this.getViewportSelectionRect());
        };
        this.croppedCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas();
        this.croppedBlob = {};
        this.croppedObjectUrl = '';
        this.eventTarget = this.croppedCanvas;
        if (p.enableRightClickCopy) {
            this.croppedImageElement = new Image();
            this.eventTarget = this.croppedImageElement;
        }
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.eventTarget, {
            height: p.height,
            width: p.width,
            touchAction: 'none'
        });
        this.rootEl.append(this.eventTarget);
        this.updateCroppedCanvas();
        this.previewLayer = {
            image: p.canvas,
            opacity: 1,
            isVisible: true,
            mixModeStr: 'source-over',
            hasClipping: false
        };
        this.preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: p.width,
            height: p.height - 2,
            project: {
                width: p.canvas.width,
                height: p.canvas.height,
                layers: [
                    this.previewLayer
                ]
            },
            hasEditMode: true,
            onModeChange: (mode)=>{
                this.mode = mode;
                this.preview.getElement().style.pointerEvents = mode === 'edit' ? 'none' : '';
                this.rootEl.title = mode === 'edit' ? (0, $fc42a07754814920$export$ce37e184d908d785)('crop-drag-to-crop') : '';
            },
            onTransformChange: ()=>this.updateSelectionRect(),
            padding: 20,
            hasBorder: false,
            editIcon: $67988e2254ac179d$var$editCropImg
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.preview.getElement(), {
            position: 'absolute',
            left: 0,
            top: 0,
            overflow: 'hidden',
            pointerEvents: 'none'
        });
        this.preview.render();
        this.rootEl.append(this.preview.getElement());
        this.selectionRectEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.preview.getElement(),
            className: 'kl-edit-crop-preview__sel'
        });
        this.updateSelectionRect();
        //gen crop from viewport points
        const genCrop = (p1, p2)=>{
            const mat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.preview.getTransform());
            const inverseMat = (0, $fd04355d00b81239$export$70ae2c07e401031b)(mat);
            const topLeftP = {
                x: Math.min(p1.x, p2.x),
                y: Math.min(p1.y, p2.y)
            };
            const bottomRightP = {
                x: Math.max(p1.x, p2.x),
                y: Math.max(p1.y, p2.y)
            };
            const origTopLeftP = (0, $43e83319b765a157$export$9b20165a36586806)(inverseMat, topLeftP);
            const origBottomRightP = (0, $43e83319b765a157$export$9b20165a36586806)(inverseMat, bottomRightP);
            origTopLeftP.x = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(Math.floor(origTopLeftP.x), 0, this.canvas.width);
            origTopLeftP.y = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(Math.floor(origTopLeftP.y), 0, this.canvas.height);
            origBottomRightP.x = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(Math.ceil(origBottomRightP.x), 0, this.canvas.width);
            origBottomRightP.y = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(Math.ceil(origBottomRightP.y), 0, this.canvas.height);
            return {
                x: origTopLeftP.x,
                y: origTopLeftP.y,
                width: origBottomRightP.x - origTopLeftP.x,
                height: origBottomRightP.y - origTopLeftP.y
            };
        };
        let startP;
        let startCrop = null;
        let isDragging = false;
        let didMove = false;
        let updateCropTimeout;
        const pointerChain = new (0, $29dd970aa1f95ac5$export$649a211db9812745)({
            chainArr: [
                new (0, $61093ea2660d4547$export$71ff2f51bf1f4062)()
            ]
        });
        pointerChain.setChainOut((event)=>{
            if (event.type === 'pointerdown' && event.button === 'left') {
                event.eventPreventDefault();
                isDragging = true;
                startP = {
                    x: event.relX,
                    y: event.relY
                };
                if (!this.isReset() && isInsideSelectionRect(startP)) startCrop = {
                    x: this.cropRect.x,
                    y: this.cropRect.y,
                    width: this.cropRect.width,
                    height: this.cropRect.height
                };
                else this.cropRect = genCrop(startP, startP);
            } else if (event.type === 'pointermove' && event.button === 'left') {
                event.eventPreventDefault();
                didMove = true;
                if (startCrop) {
                    const transform = this.preview.getTransform();
                    this.cropRect.x = startCrop.x + Math.round((event.relX - startP.x) / transform.scale);
                    this.cropRect.y = startCrop.y + Math.round((event.relY - startP.y) / transform.scale);
                    this.cropRect.x = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.cropRect.x, 0, this.canvas.width - this.cropRect.width);
                    this.cropRect.y = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.cropRect.y, 0, this.canvas.height - this.cropRect.height);
                } else this.cropRect = genCrop(startP, {
                    x: event.relX,
                    y: event.relY
                });
                this.updateSelectionRect();
            } else if (event.type === 'pointerup' && startP) {
                event.eventPreventDefault();
                isDragging = false;
                startCrop = null;
                startP = null;
                if (this.cropRect.width === 0 || this.cropRect.height === 0 || !didMove) {
                    this.resetCrop();
                    this.updateSelectionRect();
                }
                didMove = false;
                updateCropTimeout = setTimeout(()=>this.updateCroppedCanvas(), 1);
            }
        });
        this.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.eventTarget,
            fixScribble: true,
            onWheel: (event)=>{
                this.preview.onWheel(event);
            },
            useDirtyWheel: true,
            onPointer: (event)=>{
                if (this.mode === 'hand') {
                    event.eventPreventDefault();
                    this.preview.onPointer(event);
                    return;
                }
                pointerChain.chainIn(event);
            },
            maxPointers: 2
        });
        this.keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
            onDown: (keyStr, e)=>{
                if (isDragging) return;
                let doUpdate = false;
                const transform = this.preview.getTransform();
                const stepSize = Math.max(1, 1 / transform.scale);
                const shiftIsPressed = this.keyListener.isPressed('shift');
                if (keyStr === 'left') {
                    if (shiftIsPressed) this.cropRect.width = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.cropRect.width - stepSize, 1, this.canvas.width - this.cropRect.x);
                    else this.cropRect.x = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.cropRect.x - stepSize, 0, this.canvas.width - this.cropRect.width);
                    doUpdate = true;
                }
                if (keyStr === 'right') {
                    if (shiftIsPressed) this.cropRect.width = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.cropRect.width + stepSize, 1, this.canvas.width - this.cropRect.x);
                    else this.cropRect.x = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.cropRect.x + stepSize, 0, this.canvas.width - this.cropRect.width);
                    doUpdate = true;
                }
                if (keyStr === 'up') {
                    if (shiftIsPressed) this.cropRect.height = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.cropRect.height - stepSize, 1, this.canvas.height - this.cropRect.y);
                    else this.cropRect.y = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.cropRect.y - stepSize, 0, this.canvas.height - this.cropRect.height);
                    doUpdate = true;
                }
                if (keyStr === 'down') {
                    if (shiftIsPressed) this.cropRect.height = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.cropRect.height + stepSize, 1, this.canvas.height - this.cropRect.y);
                    else this.cropRect.y = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.cropRect.y + stepSize, 0, this.canvas.height - this.cropRect.height);
                    doUpdate = true;
                }
                if (doUpdate) {
                    e.preventDefault();
                    this.updateSelectionRect();
                    clearTimeout(updateCropTimeout);
                    updateCropTimeout = setTimeout(()=>this.updateCroppedCanvas(), 100);
                }
            }
        });
    }
}








function $5f9f54d39d868ac2$export$d7e8d4d4450c819c(p) {
    (0, $a0bbbeb927a78bac$export$d3d1650bc39c4419).increase();
    let isClosed = false;
    let ignoreBackground = !!p.ignoreBackground;
    const destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
    // need this extra layer because chrome mobile otherwise scrolls the page and then glitches as the address bar goes away
    const rootRootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
        parent: document.body,
        css: {
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            overflow: 'hidden'
        }
    });
    const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
        parent: rootRootEl,
        className: 'kl-popup'
    });
    const scrollContent = (0, $be957da3610487e9$export$921068d8846a1559).el({
        parent: rootEl,
        css: {
            width: '100%',
            minHeight: '100%',
            // padding: '10px 0',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }
    });
    const bgEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
        parent: scrollContent,
        destroyer: destroyer,
        onClick: ()=>{
            if (ignoreBackground) return;
            close('Cancel');
        },
        css: {
            position: 'absolute',
            left: 0,
            top: 0,
            zIndex: 0,
            width: '100%',
            height: '100%'
        }
    });
    const titleSize = 40;
    const xButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'button',
        className: 'popup-x',
        destroyer: destroyer,
        content: `<img alt="${(0, $fc42a07754814920$export$ce37e184d908d785)('modal-close')}" height="20" src="${(0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('cancel')}">`,
        title: (0, $fc42a07754814920$export$ce37e184d908d785)('modal-close'),
        onClick: ()=>{
            close('Cancel');
        },
        css: {
            width: titleSize,
            height: titleSize,
            lineHeight: titleSize + 'px',
            position: 'absolute',
            right: 0,
            top: 0,
            background: 'none',
            boxShadow: 'none'
        }
    });
    let icon = undefined;
    if (p.type) icon = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: {
            error: 'kl-popup__icon-error',
            ok: 'kl-popup__icon-ok',
            warning: 'kl-popup__icon-warning',
            upload: 'kl-popup__icon-upload'
        }[p.type]
    });
    const boxClasses = [
        'kl-popup-box'
    ];
    boxClasses.push('kl-popup-box--sm');
    const boxEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
        content: [
            xButton,
            icon,
            (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: p.message,
                css: {
                    marginRight: 15,
                    marginBottom: p.div ? 10 : undefined
                }
            }),
            p.div
        ],
        className: boxClasses,
        css: p.style ? p.style : undefined
    });
    scrollContent.append((0, $be957da3610487e9$export$921068d8846a1559).el({
        css: {
            flex: 0.5
        }
    }), boxEl, (0, $be957da3610487e9$export$921068d8846a1559).el({
        css: {
            flex: 1
        }
    }));
    const keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
        onDown: function(keyStr, e, comboStr) {
            if (isClosed) return;
            if (clickOnEnterBtn && comboStr === 'enter' && !(0, $be957da3610487e9$export$921068d8846a1559).isInputFocused()) {
                e.stopPropagation();
                setTimeout(()=>{
                    clickOnEnterBtn && clickOnEnterBtn.click();
                }, 10);
            }
            if (comboStr === 'esc') {
                e.stopPropagation();
                e.preventDefault(); // stay in fullscreen on Mac
                close('Cancel');
            }
        }
    });
    // prevent ctrl scroll -> zooming page
    const wheelPrevent = (event)=>{
        if (keyListener.isPressed('ctrl')) event.preventDefault();
    };
    rootEl.addEventListener('wheel', wheelPrevent, {
        passive: false
    });
    rootEl.onclick = (0, $be957da3610487e9$export$921068d8846a1559).handleClick;
    let autoFocus;
    if (p.autoFocus === undefined) autoFocus = 'Ok';
    else if (p.autoFocus === false) autoFocus = undefined;
    else autoFocus = p.autoFocus;
    const buttonToId = (button)=>{
        return button === 'Ok' || button === 'Cancel' ? button : button.id;
    };
    const buttonRowEl = p.buttons && p.buttons.length > 0 ? (0, $be957da3610487e9$export$921068d8846a1559).el({
        parent: boxEl,
        css: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            marginTop: 12,
            marginLeft: -8
        }
    }) : undefined;
    let clickOnEnterBtn;
    const btnElArr = [];
    if (p.buttons) {
        const iconSize = '17px';
        p.buttons.forEach((button)=>{
            const buttonId = buttonToId(button);
            const label = (()=>{
                if (button === 'Ok') return (0, $fc42a07754814920$export$ce37e184d908d785)('modal-ok');
                if (button === 'Cancel') return (0, $fc42a07754814920$export$ce37e184d908d785)('modal-cancel');
                return button.label;
            })();
            const btnClasses = new Set([
                'kl-button',
                'kl-popup__btn'
            ]);
            if (p.primaries?.includes(buttonId)) btnClasses.add('kl-button-primary');
            let iconImg = undefined;
            if (buttonId === p.deleteButton) {
                iconImg = (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('remove-layer', {
                    width: iconSize,
                    height: iconSize
                });
                btnClasses.add('kl-button-delete');
            }
            if (buttonId === 'Ok') {
                iconImg = (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('check', {
                    width: iconSize,
                    height: iconSize
                });
                btnClasses.add('kl-button-primary');
            }
            if (buttonId === 'Cancel') iconImg = (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('cancel', {
                width: iconSize,
                height: iconSize
            });
            const btn = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: buttonRowEl,
                tagName: 'button',
                className: [
                    ...btnClasses
                ],
                destroyer: destroyer,
                content: [
                    iconImg,
                    (0, $be957da3610487e9$export$921068d8846a1559).el({
                        className: 'kl-popup__btn__text',
                        content: label
                    })
                ],
                onClick: ()=>{
                    close(buttonId);
                }
            });
            btnElArr.push(btn);
            if (autoFocus === buttonId) {
                setTimeout(()=>{
                    btn.focus();
                    rootEl.scrollTo(0, 0);
                }, 10);
                setTimeout(()=>{
                    // safari needs a separate timeout
                    rootEl.scrollTo(0, 0);
                }, 20);
            }
            if (buttonId === p.clickOnEnter) clickOnEnterBtn = btn;
        });
    }
    function close(buttonId) {
        if (isClosed) return;
        isClosed = true;
        (0, $be957da3610487e9$export$921068d8846a1559).clearSelection();
        (0, $be957da3610487e9$export$921068d8846a1559).unfocusAnyInput();
        rootRootEl.remove();
        (0, $a0bbbeb927a78bac$export$d3d1650bc39c4419).decrease();
        destroyer.destroy();
        keyListener.destroy();
        rootEl.removeEventListener('wheel', wheelPrevent);
        rootEl.onclick = null;
        btnElArr.splice(0, btnElArr.length);
        if (p.callback) p.callback(buttonId);
    }
    if (p.closeFunc) p.closeFunc(function() {
        close('Cancel');
    });
    return {
        setIgnoreBackground: (b)=>{
            ignoreBackground = b;
        }
    };
}
function $5f9f54d39d868ac2$export$3879b24e8245693d(message) {
    $5f9f54d39d868ac2$export$d7e8d4d4450c819c({
        message: message,
        type: 'error',
        buttons: [
            'Ok'
        ]
    });
}






function $c005e974076b5b75$export$a04a50ae6d6450f8(poly, type) {
    let x1;
    let y1;
    let x2;
    let y2;
    poly.forEach((poly)=>{
        poly.forEach((ring)=>{
            ring.forEach((p)=>{
                x1 = x1 === undefined ? p[0] : Math.min(x1, p[0]);
                y1 = y1 === undefined ? p[1] : Math.min(y1, p[1]);
                x2 = x2 === undefined ? p[0] : Math.max(x2, p[0]);
                y2 = y2 === undefined ? p[1] : Math.max(y2, p[1]);
            });
        });
    });
    if (x1 === undefined || y1 === undefined || x2 === undefined || y2 === undefined) throw new Error('empty MultiPolygon');
    const bounds = {
        type: 'coordinate',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
    return type === 'index' ? (0, $4c2c6808296c0d73$export$b0036cbc597df324)(bounds) : bounds;
}




let $9e1eaf0318480dae$var$maskSelection = false;
function $9e1eaf0318480dae$export$32b89bc9bb92706a(parent, getFullCanvas, cropCallback, output, showCropButton, closeOnBlur = true, selection) {
    let clipboardItemIsSupported = false;
    try {
        clipboardItemIsSupported = !!ClipboardItem;
    } catch (e) {
    /* empty */ }
    const div = document.createElement('div');
    const isSmall = window.innerWidth < 550 || window.innerHeight < 550;
    const maskToggle = selection ? new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
        init: $9e1eaf0318480dae$var$maskSelection,
        label: (0, $fc42a07754814920$export$ce37e184d908d785)('cropcopy-mask'),
        name: 'check-mask-selection',
        css: {
            width: 'fit-content'
        },
        callback: (b)=>{
            $9e1eaf0318480dae$var$maskSelection = b;
            cropCopy.setCanvas(getFullCanvas(b));
        }
    }) : undefined;
    const topWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
        content: [
            maskToggle?.getElement(),
            (0, $fc42a07754814920$export$ce37e184d908d785)('crop-drag-to-crop'),
            ...clipboardItemIsSupported ? [] : [
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'br'
                }),
                (0, $fc42a07754814920$export$ce37e184d908d785)('cropcopy-click-hold')
            ]
        ],
        css: {
            textAlign: 'center'
        }
    });
    div.append(topWrapper);
    const fullCanvas = getFullCanvas($9e1eaf0318480dae$var$maskSelection);
    let init;
    if (selection) {
        const bounds = (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(selection, 'index');
        const boundsInCanvas = (0, $4c2c6808296c0d73$export$ddc1c0069d484d49)(bounds, fullCanvas.width, fullCanvas.height);
        init = boundsInCanvas ? (0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)(boundsInCanvas) : undefined;
    }
    const cropCopy = new (0, $67988e2254ac179d$export$40175a5948a88a57)({
        width: isSmall ? 340 : 540,
        height: isSmall ? 300 : 350,
        canvas: fullCanvas,
        enableRightClickCopy: true,
        init: init
    });
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(cropCopy.getElement(), {
        marginTop: 10,
        marginLeft: -20
    });
    div.append(cropCopy.getElement());
    async function toClipboard() {
        const result = await (0, $94f0b2b810d4d191$export$77f9e426014f6edd)(async ()=>{
            const blob = cropCopy.getCroppedBlob();
            await navigator.clipboard.write([
                new ClipboardItem({
                    [blob.type]: blob
                })
            ]);
        });
        if (result instanceof (0, $94f0b2b810d4d191$export$6d5e6de05c94f9f)) {
            console.error(result.error);
            return;
        }
        setTimeout(function() {
            output.out((0, $fc42a07754814920$export$ce37e184d908d785)('cropcopy-copied'), true);
        }, 200);
    }
    const keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
        onDown: function(keyStr, KeyEvent, comboStr) {
            if ([
                'ctrl+c',
                'cmd+c'
            ].includes(comboStr)) {
                toClipboard();
                closeFunc && closeFunc();
            }
        }
    });
    let closeFunc;
    function blur() {
        if (closeOnBlur) closeFunc?.();
    }
    window.addEventListener('blur', blur);
    const buttonArr = [];
    if (clipboardItemIsSupported) buttonArr.push({
        id: 'copy',
        label: (0, $fc42a07754814920$export$ce37e184d908d785)('cropcopy-btn-copy')
    });
    if (showCropButton) buttonArr.push({
        id: 'crop',
        label: (0, $fc42a07754814920$export$ce37e184d908d785)('cropcopy-btn-crop')
    });
    buttonArr.push('Cancel');
    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
        message: '<b>' + (showCropButton ? `${(0, $fc42a07754814920$export$ce37e184d908d785)('cropcopy-title-copy')} / ${(0, $fc42a07754814920$export$ce37e184d908d785)('cropcopy-title-crop')}` : `${(0, $fc42a07754814920$export$ce37e184d908d785)('cropcopy-title-copy')}`) + '</b>',
        div: div,
        style: isSmall ? {} : {
            width: 540
        },
        buttons: buttonArr,
        primaries: [
            'copy'
        ],
        clickOnEnter: 'copy',
        callback: function(result) {
            if (result === 'copy') toClipboard();
            else if (result === 'crop') {
                const rectObj = cropCopy.getCropRect();
                cropCallback({
                    left: Math.round(-rectObj.x),
                    right: Math.round(rectObj.x + rectObj.width - fullCanvas.width),
                    top: Math.round(-rectObj.y),
                    bottom: Math.round(rectObj.y + rectObj.height - fullCanvas.height)
                });
            }
            window.removeEventListener('blur', blur);
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(cropCopy.getCroppedCanvas());
            cropCopy.destroy();
            keyListener.destroy();
        },
        closeFunc: function(func) {
            closeFunc = func;
        }
    });
}







var $37256a760d257ef6$export$89da14300d534261;
var $37256a760d257ef6$export$1237798dc640739a;
var $37256a760d257ef6$export$8837f4fc672e936d;
var $37256a760d257ef6$export$a75d1723e6bda2ec;
var $37256a760d257ef6$export$29dd17c7f3c81c36;
var $37256a760d257ef6$export$e8e78c978b129247;
var $37256a760d257ef6$export$3e523c77c1f23f8c;
var $37256a760d257ef6$export$346677f925de839c;
$37256a760d257ef6$export$89da14300d534261 = `St2lzG_active`;
$37256a760d257ef6$export$1237798dc640739a = `St2lzG_label`;
$37256a760d257ef6$export$8837f4fc672e936d = `St2lzG_list`;
$37256a760d257ef6$export$a75d1723e6bda2ec = `St2lzG_option`;
$37256a760d257ef6$export$29dd17c7f3c81c36 = `St2lzG_overlay`;
$37256a760d257ef6$export$e8e78c978b129247 = `St2lzG_root`;
$37256a760d257ef6$export$3e523c77c1f23f8c = `St2lzG_separator`;
$37256a760d257ef6$export$346677f925de839c = `St2lzG_size`;


class $ba1c791155c758a7$export$388c3f18f9e173f3 {
    getItems() {
        return this.optionArr.filter((item)=>!!item);
    }
    update() {
        this.labelEl.textContent = this.getItems().find((item)=>item[0] === this.value)?.[1] ?? '';
    }
    updateSize() {
        this.sizeEl.replaceChildren(...this.getItems().map((item)=>{
            const el = document.createElement('span');
            el.textContent = item[1];
            return el;
        }));
    }
    highlight(index, shouldScroll = false) {
        this.activeIndex = (0, $be957da3610487e9$export$921068d8846a1559).clamp(index, 0, this.optionEls.length - 1);
        this.optionEls.forEach((el, i)=>{
            el.classList.toggle($37256a760d257ef6$export$89da14300d534261, i === this.activeIndex);
        });
        const el = this.optionEls[this.activeIndex];
        if (el) {
            this.listEl?.setAttribute('aria-activedescendant', el.id);
            if (shouldScroll) el.scrollIntoView?.({
                block: 'nearest'
            });
        }
    }
    select(index) {
        const item = this.getItems()[index];
        if (!item) return;
        const hasChanged = this.value !== item[0];
        hasChanged && this.setValue(item[0]);
        this.close();
        hasChanged && this.onChange?.(this.value);
    }
    open(shouldScroll = false) {
        if (!this.getItems().length || !this.rootEl.isConnected) return;
        this.popupEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'div',
            className: $37256a760d257ef6$export$29dd17c7f3c81c36
        });
        this.listEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'div',
            className: $37256a760d257ef6$export$8837f4fc672e936d,
            props: {
                tabIndex: -1,
                role: 'listbox',
                ariaLabel: this.rootEl.title || this.rootEl.name
            }
        });
        this.listEl.id = `kl-select-custom-${$ba1c791155c758a7$export$388c3f18f9e173f3.nextId++}`;
        this.rootEl.setAttribute('aria-controls', this.listEl.id);
        this.rootEl.setAttribute('aria-expanded', 'true');
        this.optionEls = [];
        for (const item of this.optionArr){
            const el = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'div',
                className: item ? $37256a760d257ef6$export$a75d1723e6bda2ec : $37256a760d257ef6$export$3e523c77c1f23f8c,
                props: item ? {
                    role: 'option',
                    ariaSelected: '' + (item[0] === this.value)
                } : {
                    role: 'separator'
                }
            });
            if (item) {
                const index = this.optionEls.length;
                el.id = `${this.listEl.id}-${index}`;
                el.textContent = item[1];
                if (item[2]) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(el, item[2].css);
                el.addEventListener('click', ()=>this.select(index));
                el.addEventListener('pointermove', (event)=>{
                    if (event.pointerType !== 'touch') this.highlight(index);
                });
                this.optionEls.push(el);
            }
            this.listEl.append(el);
        }
        this.popupEl.append(this.listEl);
        this.popupEl.addEventListener('wheel', (event)=>event.stopPropagation());
        document.body.append(this.popupEl);
        document.addEventListener('pointerdown', this.onDocumentPointerDown);
        this.reposition();
        if (!this.popupEl) return;
        this.listEl?.focus({
            preventScroll: true
        });
        this.highlight(Math.max(0, this.getItems().findIndex((item)=>item[0] === this.value)), shouldScroll);
        this.search = '';
        document.addEventListener('keydown', this.onKeyDown, true);
        window.addEventListener('resize', this.reposition);
        window.visualViewport?.addEventListener('resize', this.reposition);
        window.visualViewport?.addEventListener('scroll', this.reposition);
        this.observer = new MutationObserver(()=>{
            if (!this.rootEl.isConnected) this.close(false);
        });
        this.observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    close(restoreFocus = true) {
        if (!this.popupEl) return;
        this.observer?.disconnect();
        document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        document.removeEventListener('keydown', this.onKeyDown, true);
        window.removeEventListener('resize', this.reposition);
        window.visualViewport?.removeEventListener('resize', this.reposition);
        window.visualViewport?.removeEventListener('scroll', this.reposition);
        this.popupEl.remove();
        this.popupEl = undefined;
        this.listEl = undefined;
        this.optionEls = [];
        this.rootEl.setAttribute('aria-expanded', 'false');
        this.rootEl.removeAttribute('aria-controls');
        if (restoreFocus && this.isFocusable && this.rootEl.isConnected) this.rootEl.focus({
            preventScroll: true
        });
        else this.rootEl.blur();
    }
    setValue(val) {
        this.value = this.getItems().some((item)=>item[0] === val) ? val : '';
        this.update();
    }
    getValue() {
        return this.value;
    }
    setDeltaValue(delta) {
        const items = this.getItems();
        if (!items.length) return;
        const index = Math.max(0, items.findIndex((item)=>item[0] === this.value));
        this.setValue(items[Math.max(0, Math.min(items.length - 1, index + Math.trunc(delta)))][0]);
        this.onChange?.(this.value);
    }
    getElement() {
        return this.rootEl;
    }
    updateLabel(id, label) {
        this.optionArr.forEach((item)=>{
            if (item?.[0] === id) item[1] = label;
        });
        this.setOptionArr(this.optionArr);
    }
    setOptionArr(optionArr) {
        this.close();
        const oldValue = this.value;
        this.optionArr = optionArr;
        this.updateSize();
        this.setValue(oldValue === '' || this.getItems().some((item)=>item[0] === oldValue) ? oldValue : this.getItems()[0]?.[0]);
    }
    destroy() {
        this.close(false);
        this.rootEl.removeEventListener('click', this.toggle);
        this.rootEl.removeEventListener('pointerdown', this.preventMouseFocus);
        this.rootEl.removeEventListener('keydown', this.onKeyDown);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.optionArr = [];
        this.value = '';
        this.optionEls = [];
        this.activeIndex = 0;
        this.search = '';
        this.searchTime = 0;
        this.onDocumentPointerDown = (event)=>{
            const target = event.target;
            if (this.rootEl.contains(target) || this.popupEl?.contains(target)) return;
            this.close();
        };
        this.toggle = ()=>{
            if (this.popupEl) this.close();
            else this.open();
        };
        this.preventMouseFocus = (event)=>{
            if (!this.isFocusable && event.pointerType !== 'touch') event.preventDefault();
        };
        this.onKeyDown = (event)=>{
            if (!this.popupEl) {
                if ([
                    'ArrowDown',
                    'ArrowUp',
                    'Enter',
                    ' '
                ].includes(event.key)) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.open(true);
                }
                return;
            }
            // Keep popup keys away from drawing shortcuts and the parent dialog.
            event.stopImmediatePropagation();
            if (event.key === 'Tab') {
                this.close();
                return;
            }
            if (event.ctrlKey || event.metaKey || event.altKey) return;
            event.preventDefault();
            if (event.key === 'Escape') this.close();
            else if (event.key === 'Enter' || event.key === ' ') this.select(this.activeIndex);
            else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') this.highlight(this.activeIndex + (event.key === 'ArrowDown' ? 1 : -1), true);
            else if (event.key === 'Home' || event.key === 'End') this.highlight(event.key === 'Home' ? 0 : this.optionEls.length - 1, true);
            else if (event.key.length === 1) {
                const now = Date.now();
                this.search = (now - this.searchTime < 700 ? this.search : '') + event.key.toLocaleLowerCase();
                this.searchTime = now;
                const items = this.getItems();
                const index = items.findIndex((item)=>item[1].toLocaleLowerCase().startsWith(this.search));
                if (index !== -1) this.highlight(index, true);
            }
        };
        this.reposition = ()=>{
            if (!this.rootEl.isConnected || !this.rootEl.getClientRects().length) {
                this.close(false);
                return;
            }
            if (!this.listEl) return;
            const rect = this.rootEl.getBoundingClientRect();
            const viewport = window.visualViewport;
            const left = viewport?.offsetLeft ?? 0;
            const top = viewport?.offsetTop ?? 0;
            const width = viewport?.width ?? window.innerWidth;
            const height = viewport?.height ?? window.innerHeight;
            const margin = 6;
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.listEl, {
                minWidth: Math.min(rect.width, width - margin * 2),
                maxWidth: Math.max(0, width - margin * 2),
                maxHeight: Math.max(0, height - margin * 2)
            });
            const listRect = this.listEl.getBoundingClientRect();
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.listEl, {
                left: Math.max(left + margin, Math.min(rect.left, left + width - listRect.width - margin)),
                top: Math.max(top + margin, Math.min(rect.bottom + listRect.height <= top + height - margin ? rect.bottom : rect.top - listRect.height, top + height - listRect.height - margin))
            });
        };
        this.isFocusable = !!p.isFocusable;
        this.onChange = p.onChange;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: [
                $37256a760d257ef6$export$e8e78c978b129247,
                'kl-focusable-element'
            ],
            css: p.css,
            props: {
                type: 'button',
                name: p.name,
                title: p.title,
                ariaHasPopup: 'listbox',
                ariaExpanded: 'false',
                ...this.isFocusable ? {} : {
                    tabIndex: -1
                }
            }
        });
        this.labelEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'span',
            parent: this.rootEl,
            className: $37256a760d257ef6$export$1237798dc640739a
        });
        this.sizeEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'span',
            parent: this.rootEl,
            className: $37256a760d257ef6$export$346677f925de839c,
            props: {
                ariaHidden: 'true'
            }
        });
        this.optionArr = p.optionArr;
        this.updateSize();
        this.setValue(p.initValue);
        this.rootEl.addEventListener('click', this.toggle);
        this.rootEl.addEventListener('pointerdown', this.preventMouseFocus);
        this.rootEl.addEventListener('keydown', this.onKeyDown);
    }
}
$ba1c791155c758a7$export$388c3f18f9e173f3.nextId = 0;






/**
 * Set values in data within rect to 254, unless they're 255
 *
 * @param data Uint8Array
 * @param width int
 * @param x0 int
 * @param y0 int
 * @param x1 int >x0
 * @param y1 int >y0
 */ function $d7484fd837b79568$var$fillRect(data, width, x0, y0, x1, y1) {
    for(let x = x0; x <= x1; x++)for(let y = y0; y <= y1; y++){
        if (data[y * width + x] === 255) continue;
        data[y * width + x] = 254;
    }
}
// test, should fill, if there is a tolerance < 255
function $d7484fd837b79568$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, i) {
    return (srcArr[i * 4] - initR) ** 2 <= toleranceSquared && (srcArr[i * 4 + 1] - initG) ** 2 <= toleranceSquared && (srcArr[i * 4 + 2] - initB) ** 2 <= toleranceSquared && (srcArr[i * 4 + 3] - initA) ** 2 <= toleranceSquared;
}
// check is within selection
function $d7484fd837b79568$var$selectionMaskTest(selectionMaskArr, i) {
    return !selectionMaskArr || !!selectionMaskArr[i];
}
/**
 *
 * @param srcArr Uint8ClampedArray rgba
 * @param selectionMaskArr Uint8Array width x height, 0 or 1 values
 * @param targetArr Uint8Array
 * @param width int
 * @param height int
 * @param px int
 * @param py int
 * @param tolerance int 0 - 255
 * @param grow int >= 0
 * @param isContiguous boolean
 */ function $d7484fd837b79568$var$floodFill(srcArr, selectionMaskArr, targetArr, width, height, px, py, tolerance, grow, isContiguous) {
    const initR = srcArr[(py * width + px) * 4];
    const initG = srcArr[(py * width + px) * 4 + 1];
    const initB = srcArr[(py * width + px) * 4 + 2];
    const initA = srcArr[(py * width + px) * 4 + 3];
    const view = new DataView(srcArr.buffer);
    const init = view.getUint32((py * width + px) * 4, true);
    const toleranceSquared = tolerance ** 2;
    const bounds = {
        type: 'index',
        x1: px,
        y1: py,
        x2: px,
        y2: py
    };
    if (isContiguous) {
        const q = []; // queue of pixel indices. they are already filled.
        q.push(py * width + px); // starting pixel, where the user clicked to fill
        targetArr[py * width + px] = 255;
        let i, e;
        let x, y;
        while(q.length){
            // checks neighbors of queued pixels, fills, and queues them.
            // Adds to queue after filling it. Skip if was already filled.
            i = q.pop();
            y = Math.floor(i / width);
            x = i % width;
            if (x > 0) {
                // can go left
                e = i - 1;
                if (targetArr[e] !== 255 && $d7484fd837b79568$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $d7484fd837b79568$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.x1 = Math.min(bounds.x1, x - 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
            if (x < width - 1) {
                // can go right
                e = i + 1;
                if (targetArr[e] !== 255 && $d7484fd837b79568$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $d7484fd837b79568$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.x2 = Math.max(bounds.x2, x + 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
            if (y > 0) {
                // can go up
                e = i - width;
                if (targetArr[e] !== 255 && $d7484fd837b79568$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $d7484fd837b79568$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.y1 = Math.min(bounds.y1, y - 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
            if (y < height - 1) {
                // can go down
                e = i + width;
                if (targetArr[e] !== 255 && $d7484fd837b79568$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $d7484fd837b79568$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.y2 = Math.max(bounds.y2, y + 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
        }
    } else // not contiguous
    for(let y = 0, i = 0; y < height; y++){
        for(let x = 0; x < width; x++, i++)if ($d7484fd837b79568$var$selectionMaskTest(selectionMaskArr, i) && (view.getUint32(i * 4, true) === init || tolerance > 0 && $d7484fd837b79568$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, i))) {
            targetArr[i] = 255;
            if (x < bounds.x1) bounds.x1 = x;
            if (y < bounds.y1) bounds.y1 = y;
            if (x > bounds.x2) bounds.x2 = x;
            if (y > bounds.y2) bounds.y2 = y;
        }
    }
    if (grow === 0) return bounds;
    // --- grow ---
    // how does it grow? it finds all pixel at the edge.
    // then depending on what kind of edge it is, it draws a rectangle into target
    // In the rectangle each pixel has the value 254, or else it will mess it all up.
    // after it's all done, replaces it with 255
    let x0, x1, y0, y1;
    let l, tl, t, tr, r, br, b, bl; // left, top left, top, top right, etc.
    for(let x = bounds.x1; x <= bounds.x2; x++)for(let y = bounds.y1; y <= bounds.y2; y++){
        if (targetArr[y * width + x] !== 255) continue;
        // bounds of rectangle
        x0 = x;
        x1 = x;
        y0 = y;
        y1 = y;
        l = targetArr[y * width + x - 1] !== 255;
        tl = targetArr[(y - 1) * width + x - 1] !== 255;
        t = targetArr[(y - 1) * width + x] !== 255;
        tr = targetArr[(y - 1) * width + x + 1] !== 255;
        r = targetArr[y * width + x + 1] !== 255;
        br = targetArr[(y + 1) * width + x + 1] !== 255;
        b = targetArr[(y + 1) * width + x] !== 255;
        bl = targetArr[(y + 1) * width + x - 1] !== 255;
        if (l) // left
        x0 = x - grow;
        if (l && tl && t) {
            // top left
            x0 = x - grow;
            y0 = y - grow;
        }
        if (t) // top
        y0 = Math.min(y0, y - grow);
        if (t && tr && r) {
            // top right
            y0 = Math.min(y0, y - grow);
            x1 = x + grow;
        }
        if (r) // right
        x1 = Math.max(x1, x + grow);
        if (r && br && b) {
            // bottom right
            x1 = Math.max(x1, x + grow);
            y1 = Math.max(y1, y + grow);
        }
        if (b) // bottom
        y1 = Math.max(y1, y + grow);
        if (b && bl && l) {
            // bottom left
            x0 = Math.min(x0, x - grow);
            y1 = Math.max(y1, y + grow);
        }
        if (!l && !tl && !t && !tr && !r && !br && !b && !bl) continue;
        $d7484fd837b79568$var$fillRect(targetArr, width, Math.max(0, x0), Math.max(0, y0), Math.min(width - 1, x1), Math.min(height - 1, y1));
    }
    for(let i = 0; i < width * height; i++)if (targetArr[i] === 254) targetArr[i] = 255;
    // expand bounds by grow
    bounds.x1 -= grow;
    bounds.y1 -= grow;
    bounds.x2 += grow;
    bounds.y2 += grow;
    return bounds;
}
function $d7484fd837b79568$export$13d50f258a8034f(rgbaArr, // width x height, 0 or 1 values
selectionMaskArr, width, height, x, y, tolerance, grow, isContiguous) {
    x = Math.round(x); // just in case
    y = Math.round(y);
    const resultArr = new Uint8Array(new ArrayBuffer(width * height));
    const bounds = $d7484fd837b79568$var$floodFill(rgbaArr, selectionMaskArr, resultArr, width, height, x, y, tolerance, grow, isContiguous);
    return {
        data: resultArr,
        bounds: bounds
    };
}




function $e54f3e9fe3a16a29$export$5dd60a54dd55622(bounds, transform) {
    const p1 = (0, $43e83319b765a157$export$9b20165a36586806)(transform, {
        x: bounds.x1,
        y: bounds.y1
    });
    const p2 = (0, $43e83319b765a157$export$9b20165a36586806)(transform, {
        x: bounds.x2,
        y: bounds.y1
    });
    const p3 = (0, $43e83319b765a157$export$9b20165a36586806)(transform, {
        x: bounds.x2,
        y: bounds.y2
    });
    const p4 = (0, $43e83319b765a157$export$9b20165a36586806)(transform, {
        x: bounds.x1,
        y: bounds.y2
    });
    return {
        type: 'coordinate',
        x1: Math.min(p1.x, p2.x, p3.x, p4.x),
        y1: Math.min(p1.y, p2.y, p3.y, p4.y),
        x2: Math.max(p1.x, p2.x, p3.x, p4.x),
        y2: Math.max(p1.y, p2.y, p3.y, p4.y)
    };
}





class $03d72c2b76715beb$export$27550cc14d7ae85a {
    onDown(x, y, angleRad) {
        this.downX = x;
        this.downY = y;
        this.downAngleRad = angleRad;
    }
    onMove(x, y) {
        this.onShape(false, this.downX, this.downY, x, y, this.downAngleRad);
    }
    onUp(x, y) {
        this.onShape(true, this.downX, this.downY, x, y, this.downAngleRad);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.downX = 0;
        this.downY = 0;
        this.downAngleRad = 0;
        this.onShape = p.onShape;
    }
}
function $03d72c2b76715beb$export$71b514a25c47df50(ctx, shapeObj, selectionPath) {
    shapeObj = {
        // defaults
        angleRad: 0,
        isOutwards: false,
        opacity: 1,
        isEraser: false,
        doLockAlpha: false,
        ...(0, $be957da3610487e9$export$921068d8846a1559).copyObj(shapeObj)
    };
    let bounds = {
        type: 'coordinate',
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
    };
    if ([
        'rect',
        'ellipse',
        'line'
    ].includes(shapeObj.type)) {
        if (shapeObj.angleRad === undefined) throw new Error('angleRad undefined');
        const lineWidth = shapeObj.lineWidth === undefined ? -1 : Math.round(shapeObj.lineWidth);
        const angleDeg = shapeObj.angleRad * 180 / Math.PI;
        // --- prep color ---
        if (!shapeObj.isEraser && shapeObj.fillRgb === undefined && shapeObj.strokeRgb === undefined) throw new Error('fillRgb and strokeRgb undefined');
        const colorRgb = shapeObj.isEraser ? {
            r: 255,
            g: 255,
            b: 255
        } : shapeObj.fillRgb ? shapeObj.fillRgb : shapeObj.strokeRgb;
        // --- prep canvas ---
        ctx.save();
        selectionPath && ctx.clip(selectionPath);
        if (shapeObj.opacity) ctx.globalAlpha = shapeObj.opacity;
        if (shapeObj.isEraser) ctx.globalCompositeOperation = 'destination-out';
        if (shapeObj.doLockAlpha) ctx.globalCompositeOperation = 'source-atop';
        const transformation = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $648ca1a32d748118$export$bb628a54ab399bc9)(-shapeObj.angleRad));
        ctx.setTransform(...(0, $f7c026d16783f524$export$2b60e7dafdbde18a)(transformation));
        if (shapeObj.fillRgb) ctx.fillStyle = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr(colorRgb);
        else if (shapeObj.strokeRgb) {
            ctx.strokeStyle = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr(colorRgb);
            ctx.lineWidth = lineWidth;
        }
        let x1 = shapeObj.x1;
        let y1 = shapeObj.y1;
        let x2 = shapeObj.x2;
        let y2 = shapeObj.y2;
        // --- angle snapping ---
        if (shapeObj.isAngleSnap) {
            const r1 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(x1, y1, shapeObj.angleRad / Math.PI * 180);
            const r2 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(x2, y2, shapeObj.angleRad / Math.PI * 180);
            const pAngleDeg = (0, $be957da3610487e9$export$921068d8846a1559).pointsToAngleDeg(r1, r2) + 90;
            const pAngleDegSnapped = Math.round(pAngleDeg / 45) * 45;
            const rotated = (0, $be957da3610487e9$export$921068d8846a1559).rotateAround({
                x: x1,
                y: y1
            }, {
                x: x2,
                y: y2
            }, pAngleDegSnapped - pAngleDeg);
            x2 = rotated.x;
            y2 = rotated.y;
            // needs to be perfect if p1->p2 aligns with canvas x- or y-axis
            if ((angleDeg + pAngleDegSnapped) % 90 === 0) {
                if (Math.round((angleDeg - pAngleDegSnapped) / 90) % 2 === 0) // up or down
                x2 = x1;
                else // left or right
                y2 = y1;
            }
        }
        let x = x1;
        let y = y1;
        let dX = x2 - x1;
        let dY = y2 - y1;
        // --- 1:1 ratio ---
        if (shapeObj.type !== 'line' && shapeObj.isFixedRatio) {
            let r1 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(shapeObj.x1, shapeObj.y1, shapeObj.angleRad / Math.PI * 180);
            let r2 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(shapeObj.x2, shapeObj.y2, shapeObj.angleRad / Math.PI * 180);
            const rx = r1.x;
            const ry = r1.y;
            let rdX = r2.x - r1.x;
            let rdY = r2.y - r1.y;
            if (Math.abs(rdX) < Math.abs(rdY)) rdY = Math.abs(rdX) * (rdY < 0 ? -1 : 1);
            else rdX = Math.abs(rdY) * (rdX < 0 ? -1 : 1);
            r2.x = rx + rdX;
            r2.y = ry + rdY;
            r1 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(r1.x, r1.y, -shapeObj.angleRad / Math.PI * 180);
            r2 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(r2.x, r2.y, -shapeObj.angleRad / Math.PI * 180);
            x1 = r1.x;
            y1 = r1.y;
            x2 = r2.x;
            y2 = r2.y;
            x = x1;
            y = y1;
            dX = x2 - x1;
            dY = y2 - y1;
        }
        // outwards modifier
        if (shapeObj.isOutwards) {
            x -= dX;
            y -= dY;
            dX *= 2;
            dY *= 2;
            x1 = x;
            y1 = y;
            x2 = x + dX;
            y2 = y + dY;
        }
        let p1;
        let p2;
        if (shapeObj.type === 'line') {
            // --- line ---
            // rounded
            const x1r = Math.round(x1);
            const y1r = Math.round(y1);
            const x2r = Math.round(x2);
            const y2r = Math.round(y2);
            // floored
            const x1f = Math.floor(x1);
            const y1f = Math.floor(y1);
            const x2f = Math.floor(x2);
            const y2f = Math.floor(y2);
            if (lineWidth % 2 === 0) {
                if (y1r === y2r) {
                    p1 = {
                        x: x1f,
                        y: y1r
                    };
                    p2 = {
                        x: x2f,
                        y: y2r
                    };
                    if (x1f < x2f) p2.x += 1;
                    else p1.x += 1;
                } else if (x1r === x2r) {
                    p1 = {
                        x: x1r,
                        y: y1f
                    };
                    p2 = {
                        x: x2r,
                        y: y2f
                    };
                    if (y1f < y2f) p2.y += 1;
                    else p1.y += 1;
                } else {
                    p1 = {
                        x: x1,
                        y: y1
                    };
                    p2 = {
                        x: x2,
                        y: y2
                    };
                }
            } else {
                p1 = {
                    x: x1f,
                    y: y1f
                };
                p2 = {
                    x: x2f,
                    y: y2f
                };
                if (y1f === y2f) {
                    if (x1f < x2f) p2.x += 1;
                    else p1.x += 1;
                    p1.y += 0.5;
                    p2.y += 0.5;
                } else if (x1f === x2f) {
                    if (y1f < y2f) p2.y += 1;
                    else p1.y += 1;
                    p1.x += 0.5;
                    p2.x += 0.5;
                } else {
                    p1.x = x1;
                    p1.y = y1;
                    p2.x = x2;
                    p2.y = y2;
                }
            }
            bounds = {
                type: 'coordinate',
                x1: Math.min(p1.x, p2.x) - lineWidth / 2,
                y1: Math.min(p1.y, p2.y) - lineWidth / 2,
                x2: Math.max(p1.x, p2.x) + lineWidth / 2,
                y2: Math.max(p1.y, p2.y) + lineWidth / 2
            };
            p1 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(p1.x, p1.y, shapeObj.angleRad / Math.PI * 180);
            p2 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(p2.x, p2.y, shapeObj.angleRad / Math.PI * 180);
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
        } else if (shapeObj.type === 'rect') {
            // --- rect ---
            // floored
            const x1f = Math.floor(x1);
            const y1f = Math.floor(y1);
            const x2f = Math.floor(x2);
            const y2f = Math.floor(y2);
            if (angleDeg % 90 === 0) {
                if (shapeObj.fillRgb) {
                    if (x1 % 1 === 0) x1 += 1;
                    if (y1 % 1 === 0) y1 += 1;
                    if (x2 % 1 === 0) x2 += 1;
                    if (y2 % 1 === 0) y2 += 1;
                    p1 = {
                        x: x1 < x2 ? x1f : x2f,
                        y: y1 < y2 ? y1f : y2f
                    };
                    p2 = {
                        x: Math.ceil((x1 < x2 ? x2 : x1) - p1.x),
                        y: Math.ceil((y1 < y2 ? y2 : y1) - p1.y)
                    };
                    p2.x = p1.x + p2.x;
                    p2.y = p1.y + p2.y;
                } else if (lineWidth % 2 === 0) {
                    p1 = {
                        x: x1f,
                        y: y1f
                    };
                    p2 = {
                        x: x2f,
                        y: y2f
                    };
                } else {
                    p1 = {
                        x: x1f + 0.5,
                        y: y1f + 0.5
                    };
                    p2 = {
                        x: x2f + 0.5,
                        y: y2f + 0.5
                    };
                }
            } else {
                p1 = {
                    x: x1,
                    y: y1
                };
                p2 = {
                    x: x2,
                    y: y2
                };
            }
            p1 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(p1.x, p1.y, shapeObj.angleRad / Math.PI * 180);
            p2 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(p2.x, p2.y, shapeObj.angleRad / Math.PI * 180);
            const rect = {
                x: p1.x,
                y: p1.y,
                width: p2.x - p1.x,
                height: p2.y - p1.y
            };
            const padding = shapeObj.fillRgb ? 0 : lineWidth / 2;
            bounds = (0, $e54f3e9fe3a16a29$export$5dd60a54dd55622)({
                type: 'coordinate',
                x1: Math.min(p1.x, p2.x) - padding,
                y1: Math.min(p1.y, p2.y) - padding,
                x2: Math.max(p1.x, p2.x) + padding,
                y2: Math.max(p1.y, p2.y) + padding
            }, transformation);
            if (shapeObj.fillRgb) ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
            else ctx.strokeRect(rect.x, rect.y, rect.width, rect.height);
        } else {
            // --- circle ---
            p1 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(x1, y1, shapeObj.angleRad / Math.PI * 180);
            p2 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(x2, y2, shapeObj.angleRad / Math.PI * 180);
            x = p1.x;
            y = p1.y;
            dX = p2.x - p1.x;
            dY = p2.y - p1.y;
            const center = {
                x: x + dX / 2,
                y: y + dY / 2
            };
            const rX = Math.abs(dX / 2);
            const rY = Math.abs(dY / 2);
            ctx.beginPath();
            ctx.ellipse(center.x, center.y, rX, rY, 0, 0, Math.PI * 2);
            if (shapeObj.fillRgb) ctx.fill();
            else ctx.stroke();
            const padding = shapeObj.fillRgb ? 0 : lineWidth / 2;
            // bounds are bigger than they need to be when it's rotated and rX ~ rY. should be good enough though.
            bounds = (0, $e54f3e9fe3a16a29$export$5dd60a54dd55622)({
                type: 'coordinate',
                x1: center.x - rX - padding,
                y1: center.y - rY - padding,
                x2: center.x + rX + padding,
                y2: center.y + rY + padding
            }, transformation);
        }
        ctx.restore();
    } else throw new Error('unknown shape');
    return (0, $4c2c6808296c0d73$export$b0036cbc597df324)(bounds);
}



// accurately represents the bounds of the text, even it's fancy Zalgo text that tries to break layout
function $7f7fc3a72d8b806e$var$textMetricToRect(metrics, align) {
    const ascent = metrics.actualBoundingBoxAscent;
    const descent = metrics.actualBoundingBoxDescent;
    const left = metrics.actualBoundingBoxLeft;
    const right = metrics.actualBoundingBoxRight;
    const width = right + left; // More accurate width calculation considering left/right bounds
    const height = ascent + descent;
    if (align === 'left') return {
        x: -left,
        y: -ascent,
        width: width,
        height: height
    };
    if (align === 'right') return {
        x: -width,
        y: -ascent,
        width: width,
        height: height
    };
    // center
    return {
        x: -left,
        y: -ascent,
        width: width,
        height: height
    };
}
function $7f7fc3a72d8b806e$export$482c90f94eb9717c(canvas, p, selectionPath) {
    p = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(p);
    // setup context
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    ctx.save();
    selectionPath && ctx.clip(selectionPath);
    ctx.textAlign = p.align;
    ctx.letterSpacing = p.letterSpacing ? p.letterSpacing + 'px' : '0';
    // font
    const fontArr = [
        p.size + 'px ' + (p.font ? p.font : 'sans-serif')
    ];
    if (p.isBold) fontArr.unshift('bold');
    if (p.isItalic) fontArr.unshift('italic');
    ctx.font = fontArr.join(' ');
    // fill
    ctx.fillStyle = p.fill ? (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(p.fill.color) : 'transparent';
    // stroke
    ctx.strokeStyle = p.stroke ? (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(p.stroke.color) : 'transparent';
    if (p.stroke) {
        ctx.lineWidth = p.stroke.lineWidth;
        ctx.lineJoin = 'round';
    }
    ctx.translate(p.x, p.y);
    ctx.rotate(-p.angleRad);
    const lines = p.text.split('\n').map((line)=>line.replaceAll('\t', '    '));
    // bounds
    const bounds = {
        type: 'index',
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
    };
    {
        let isFirst = true;
        lines.forEach((line, lineIndex)=>{
            const metrics = ctx.measureText(line);
            const x = 0;
            const y = p.size * (p.lineHeight ?? 1) * lineIndex;
            const mRect = $7f7fc3a72d8b806e$var$textMetricToRect(metrics, p.align);
            if (isFirst) {
                isFirst = false;
                bounds.x1 = x + mRect.x;
                bounds.y1 = y + mRect.y;
                bounds.x2 = x + mRect.x + mRect.width - 1;
                bounds.y2 = y + mRect.y + mRect.height - 1;
            } else {
                bounds.x1 = Math.min(bounds.x1, x + mRect.x);
                bounds.y1 = Math.min(bounds.y1, y + mRect.y);
                bounds.x2 = Math.max(bounds.x2, x + mRect.x + mRect.width - 1);
                bounds.y2 = Math.max(bounds.y2, y + mRect.y + mRect.height - 1);
            }
        });
    }
    // draw stroke
    lines.forEach((line, lineIndex)=>{
        const x = 0;
        const y = p.size * (p.lineHeight ?? 1) * lineIndex;
        ctx.strokeText(line, x, y);
    });
    // draw fill
    lines.forEach((line, lineIndex)=>{
        const x = 0;
        const y = p.size * (p.lineHeight ?? 1) * lineIndex;
        ctx.fillText(line, x, y);
    });
    ctx.restore();
    return {
        x: bounds.x1,
        y: bounds.y1,
        width: bounds.x2 - bounds.x1,
        height: bounds.y2 - bounds.y1
    };
}









function $3efd55021d1b8d84$export$5f63a7b18dc4503a(project, factor = 1, selection) {
    const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(Math.max(1, Math.round(project.width * factor)), Math.max(1, Math.round(project.height * factor)));
    const transformedSelection = selection ? (0, $5f00e0232038b1be$export$aa391dbbf8073422)(selection, (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(canvas.width / project.width, canvas.height / project.height)) : undefined;
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    ctx.save();
    if (transformedSelection) ctx.clip((0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(transformedSelection));
    if (factor > 1) ctx.imageSmoothingEnabled = false;
    const compositor = new (0, $7db1a448998b9957$export$fca65d4bf5f27b48)();
    try {
        compositor.draw(ctx, project.layers, canvas.width, canvas.height, (targetCtx, layer)=>{
            if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(layer.image)) {
                targetCtx.fillStyle = layer.image.fill;
                targetCtx.fillRect(0, 0, canvas.width, canvas.height);
            } else if (layer.image instanceof Array) throw new Error('not implemented');
            else targetCtx.drawImage(layer.image, 0, 0, canvas.width, canvas.height);
        });
    } finally{
        compositor.destroy();
        ctx.restore();
    }
    return canvas;
}




class $abbf5f9031f83ecb$export$74d12f09ff9f1956 {
    onDown(x, y, angleRad) {
        this.downX = x;
        this.downY = y;
        this.downAngleRad = angleRad;
    }
    onMove(x, y) {
        this.onGradient(false, this.downX, this.downY, x, y, this.downAngleRad);
    }
    onUp(x, y) {
        this.onGradient(true, this.downX, this.downY, x, y, this.downAngleRad);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.downX = 0;
        this.downY = 0;
        this.downAngleRad = 0;
        this.onGradient = p.onGradient;
    }
}
function $abbf5f9031f83ecb$export$b1f70a113e3b5c1b(ctx, gradientObj, selectionPath) {
    ctx.save();
    selectionPath && ctx.clip(selectionPath);
    const x1 = gradientObj.x1;
    const y1 = gradientObj.y1;
    let x2 = gradientObj.x2;
    let y2 = gradientObj.y2;
    if (gradientObj.doSnap) {
        const angleDeg = gradientObj.angleRad * 180 / Math.PI;
        const r1 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(x1, y1, gradientObj.angleRad / Math.PI * 180);
        const r2 = (0, $be957da3610487e9$export$921068d8846a1559).rotate(x2, y2, gradientObj.angleRad / Math.PI * 180);
        const pAngleDeg = (0, $be957da3610487e9$export$921068d8846a1559).pointsToAngleDeg(r1, r2) + 90;
        const pAngleDegSnapped = Math.round(pAngleDeg / 45) * 45;
        const rotated = (0, $be957da3610487e9$export$921068d8846a1559).rotateAround({
            x: x1,
            y: y1
        }, {
            x: x2,
            y: y2
        }, pAngleDegSnapped - pAngleDeg);
        x2 = rotated.x;
        y2 = rotated.y;
        // needs to be perfect if p1->p2 aligns with canvas x- or y-axis
        if ((angleDeg + pAngleDegSnapped) % 90 === 0) {
            if (Math.round((angleDeg - pAngleDegSnapped) / 90) % 2 === 0) // up or down
            x2 = x1;
            else // left or right
            y2 = y1;
        }
    }
    let baseColor = gradientObj.color1;
    if (gradientObj.isEraser && gradientObj.doLockAlpha) baseColor = {
        r: 255,
        g: 255,
        b: 255
    };
    let color1 = {
        ...baseColor,
        a: gradientObj.opacity
    };
    let color2 = {
        ...baseColor,
        a: 0
    };
    if (gradientObj.isReversed) {
        const temp = color1;
        color1 = color2;
        color2 = temp;
    }
    let gradient;
    if (gradientObj.type === 'linear') {
        gradient = ctx.createLinearGradient(x1, y1, x2, y2);
        gradient.addColorStop(0, (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(color1));
        gradient.addColorStop(1, (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(color2));
    } else if (gradientObj.type === 'linear-mirror') {
        const d = {
            x: x2 - x1,
            y: y2 - y1
        };
        gradient = ctx.createLinearGradient(x1 - d.x, y1 - d.y, x2, y2);
        gradient.addColorStop(0, (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(color2));
        gradient.addColorStop(0.5, (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(color1));
        gradient.addColorStop(1, (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(color2));
    } else if (gradientObj.type === 'radial') {
        const r = (0, $be957da3610487e9$export$921068d8846a1559).Vec2.dist({
            x: x1,
            y: y1
        }, {
            x: x2,
            y: y2
        });
        gradient = ctx.createRadialGradient(x1, y1, 0, x1, y1, r);
        gradient.addColorStop(0, (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(color1));
        gradient.addColorStop(1, (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr(color2));
    }
    ctx.fillStyle = gradient;
    if (gradientObj.isEraser) ctx.globalCompositeOperation = 'destination-out';
    if (gradientObj.doLockAlpha) ctx.globalCompositeOperation = 'source-atop';
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.restore();
}










let $f13a819f841fbdb5$var$layerId = 0;
function $f13a819f841fbdb5$export$b2ce7a8a096070e2() {
    return '' + $f13a819f841fbdb5$var$layerId++;
}



function $714316c134a8cc2b$export$9a1731baa7701cc7(width, height, fill) {
    const result = [];
    const tilesX = Math.ceil(width / (0, $211b564339712990$export$f7bc58374d6bc9b6));
    const tilesY = Math.ceil(height / (0, $211b564339712990$export$f7bc58374d6bc9b6));
    for(let y = 0; y < tilesY; y++)for(let x = 0; x < tilesX; x++)result.push({
        fill: fill
    });
    return result;
}




function $6b58556e30cebed5$export$87eabc555ccfbb9f(a, b) {
    if (a.index > b.index) return 1;
    if (a.index < b.index) return -1;
    return 0;
}



function $8d7083f03957efab$export$cee5b735b1b9bad1(layers, before, after) {
    const sizeDidChange = before.size.width !== after.size.width || before.size.height !== after.size.height;
    return Object.entries(after.layerMap).map(([id, composedAfterLayer])=>{
        let canvas = {};
        let context = {};
        const composedBeforeLayer = before.layerMap[id];
        const tilesPerX = Math.ceil(after.size.width / (0, $211b564339712990$export$f7bc58374d6bc9b6));
        if (sizeDidChange || !composedBeforeLayer) {
            // create new canvas
            canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(after.size.width, after.size.height);
            context = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
            composedAfterLayer.tiles.forEach((item, index)=>{
                const x = index % tilesPerX;
                const y = Math.floor(index / tilesPerX);
                if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(item)) {
                    context.save();
                    context.fillStyle = item.fill;
                    context.fillRect(x * (0, $211b564339712990$export$f7bc58374d6bc9b6), y * (0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6));
                    context.restore();
                } else context.putImageData(item.data, x * (0, $211b564339712990$export$f7bc58374d6bc9b6), y * (0, $211b564339712990$export$f7bc58374d6bc9b6));
            });
        } else {
            canvas = layers[composedBeforeLayer.index].canvas;
            context = layers[composedBeforeLayer.index].context;
            composedAfterLayer.tiles.forEach((item, index)=>{
                if (item === composedBeforeLayer.tiles[index]) // todo more advanced check ^
                return;
                const x = index % tilesPerX;
                const y = Math.floor(index / tilesPerX);
                if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(item)) {
                    context.save();
                    context.fillStyle = item.fill;
                    context.clearRect(x * (0, $211b564339712990$export$f7bc58374d6bc9b6), y * (0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6));
                    context.fillRect(x * (0, $211b564339712990$export$f7bc58374d6bc9b6), y * (0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6));
                    context.restore();
                } else context.putImageData(item.data, x * (0, $211b564339712990$export$f7bc58374d6bc9b6), y * (0, $211b564339712990$export$f7bc58374d6bc9b6));
            });
        }
        return {
            id: id,
            index: composedAfterLayer.index,
            name: composedAfterLayer.name,
            mixModeStr: composedAfterLayer.mixModeStr,
            hasClipping: composedAfterLayer.hasClipping,
            isVisible: composedAfterLayer.isVisible,
            opacity: composedAfterLayer.opacity,
            canvas: canvas,
            context: context
        };
    }).sort((0, $6b58556e30cebed5$export$87eabc555ccfbb9f));
}


function $f40e9d7cf0f73872$export$e173233eae155bba(entry, layerId) {
    const keys = Object.keys(entry);
    if (keys.length !== 1 || !entry.layerMap) return false;
    const ids = Object.keys(entry.layerMap);
    for(let i = 0; i < ids.length; i++){
        const id = ids[i];
        const layer = entry.layerMap[id];
        if (id === layerId) {
            const layerKeys = Object.keys(layer);
            if (layerKeys.length !== 1 || layerKeys[0] !== 'opacity') return false;
        } else {
            const layerKeys = Object.keys(layer);
            if (layerKeys.length > 0) return false;
        }
    }
    return true;
}


function $17452f9bf68a33d6$export$b706b44cfdbaaa7d(entry, layerId) {
    const keys = Object.keys(entry);
    if (keys.length !== 1 || !entry.layerMap) return false;
    const ids = Object.keys(entry.layerMap);
    for(let i = 0; i < ids.length; i++){
        const id = ids[i];
        const layer = entry.layerMap[id];
        if (id === layerId) {
            const layerKeys = Object.keys(layer);
            if (layerKeys.length !== 1 || layerKeys[0] !== 'isVisible') return false;
        } else {
            const layerKeys = Object.keys(layer);
            if (layerKeys.length > 0) return false;
        }
    }
    return true;
}








function $9431fc21c806d9d2$export$6b742be78fc940fb(canvas, col, row) {
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    const { width: width, height: height } = (0, $aab5cae708a98039$export$185d2f15b67cd13)(col, row, canvas);
    /*
        NS_ERROR_FAILURE & NS_ERROR_OUT_OF_MEMORY
        Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:148.0) Gecko/20100101 Firefox/148.0
        Probably out of memory judging by https://searchfox.org/firefox-main/source/dom/canvas/CanvasRenderingContext2D.cpp
        I am only able to force NS_ERROR_FAILURE with 83GB worth of canvas elements (32gb ram).
        Maybe a memory leak?
     */ /*
        Uncaught SecurityError: Failed to execute 'getImageData' on 'CanvasRenderingContext2D': The canvas has been tainted by cross-origin data.
        Mozilla/5.0 (X11; CrOS x86_64 14541.0.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36
        -> no idea how this was achieved. Tried importing svg with cross-origin content. Did not result in that exception
     */ // Exception: InvalidStateError: The object is in an invalid state.
    return (0, $2f436639594531f3$export$f84fa3da4a94c138)(ctx, col * (0, $211b564339712990$export$f7bc58374d6bc9b6), row * (0, $211b564339712990$export$f7bc58374d6bc9b6), width, height);
}





function $a0d4fe9620fd4adc$export$2098fe43203ddd32(bounds, width, height, tileSize = (0, $211b564339712990$export$f7bc58374d6bc9b6)) {
    // ensure: 1 top left, 2 bottom right
    bounds = {
        type: 'index',
        x1: Math.min(bounds.x1, bounds.x2),
        y1: Math.min(bounds.y1, bounds.y2),
        x2: Math.max(bounds.x1, bounds.x2),
        y2: Math.max(bounds.y1, bounds.y2)
    };
    const boundsInCanvas = (0, $4c2c6808296c0d73$export$ddc1c0069d484d49)(bounds, width, height);
    const tilesX = Math.ceil(width / tileSize);
    const tilesY = Math.ceil(height / tileSize);
    if (!boundsInCanvas) // no change if bounds don't overlap canvas
    return (0, $94f0b2b810d4d191$export$7f1ebd623f131021)(tilesX * tilesY, false);
    const result = (0, $94f0b2b810d4d191$export$7f1ebd623f131021)(tilesX * tilesY, false);
    const tileBounds = {
        x1: (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x1 / tileSize), 0, tilesX - 1),
        y1: (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y1 / tileSize), 0, tilesY - 1),
        x2: (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x2 / tileSize), 0, tilesX - 1),
        y2: (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y2 / tileSize), 0, tilesY - 1)
    };
    for(let i = tileBounds.x1; i <= tileBounds.x2; i++)for(let e = tileBounds.y1; e <= tileBounds.y2; e++)result[e * tilesX + i] = true;
    return result;
}
function $a0d4fe9620fd4adc$export$1774f90c6da5013c(oldChangedOrEmpty, newChanged) {
    return newChanged.map((newItem, index)=>{
        return newItem || !!oldChangedOrEmpty[index];
    });
}




function $3aa9c52208735678$export$6706c882ea9c3dbd(canvas, changedTiles) {
    const result = [];
    const tilesX = Math.ceil(canvas.width / (0, $211b564339712990$export$f7bc58374d6bc9b6));
    const tilesY = Math.ceil(canvas.height / (0, $211b564339712990$export$f7bc58374d6bc9b6));
    for(let row = 0; row < tilesY; row++)for(let col = 0; col < tilesX; col++)result.push(changedTiles[row * tilesX + col] ? (0, $aab5cae708a98039$export$55941c74c8f934)((0, $9431fc21c806d9d2$export$6b742be78fc940fb)(canvas, col, row)) : undefined);
    return result;
}
function $3aa9c52208735678$export$7b1ba44282f9a519(canvas, bounds) {
    if (bounds) {
        const changedTiles = (0, $a0d4fe9620fd4adc$export$2098fe43203ddd32)(bounds, canvas.width, canvas.height);
        return $3aa9c52208735678$export$6706c882ea9c3dbd(canvas, changedTiles);
    } else {
        // only do a single read back
        const ctx = canvas.getContext('2d');
        /*
            Uncaught SecurityError: Failed to execute 'getImageData' on 'CanvasRenderingContext2D': The canvas has been tainted by cross-origin data.
            Mozilla/5.0 (X11; CrOS x86_64 14541.0.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36
            -> no idea how this was achieved. Tried importing svg with cross-origin content. Did not result in that exception
         */ // InvalidStateError: The object is in an invalid state.
        const fullImageData = (0, $2f436639594531f3$export$f84fa3da4a94c138)(ctx, 0, 0, canvas.width, canvas.height);
        const tilesX = Math.ceil(canvas.width / (0, $211b564339712990$export$f7bc58374d6bc9b6));
        const tilesY = Math.ceil(canvas.height / (0, $211b564339712990$export$f7bc58374d6bc9b6));
        const result = [];
        // manually transfer into tiles
        for(let row = 0; row < tilesY; row++)for(let col = 0; col < tilesX; col++){
            const tileSize = (0, $aab5cae708a98039$export$185d2f15b67cd13)(col, row, canvas);
            const x = col * (0, $211b564339712990$export$f7bc58374d6bc9b6);
            const y = row * (0, $211b564339712990$export$f7bc58374d6bc9b6);
            const tileData = new ImageData(tileSize.width, tileSize.height);
            for(let line = 0; line < tileSize.height; line++){
                const srcStart = ((y + line) * canvas.width + x) * 4;
                const destStart = line * tileSize.width * 4;
                tileData.data.set(fullImageData.data.subarray(srcStart, srcStart + tileSize.width * 4), destStart);
            }
            result.push((0, $aab5cae708a98039$export$55941c74c8f934)(tileData));
        }
        return result;
    }
}


// create individual THistoryEntryLayer
function $0957b1eeba070f0f$var$createEntryLayer(layer, attributes, bounds, tiles) {
    const useAll = attributes === 'all';
    const result = {};
    if (useAll || attributes.includes('name')) result.name = layer.name;
    if (useAll || attributes.includes('opacity')) result.opacity = layer.opacity;
    if (useAll || attributes.includes('isVisible')) result.isVisible = layer.isVisible;
    if (useAll || attributes.includes('mixModeStr')) result.mixModeStr = layer.mixModeStr;
    if (useAll || attributes.includes('hasClipping')) result.hasClipping = layer.hasClipping;
    if (useAll || attributes.includes('index')) result.index = layer.index;
    if (useAll || attributes.includes('tiles')) result.tiles = tiles ?? (0, $3aa9c52208735678$export$7b1ba44282f9a519)(layer.context.canvas, bounds);
    return result;
}
function $0957b1eeba070f0f$export$7cefb04ac49374c4(layers, ...items) {
    const generic = items.find((item)=>item && !('layerId' in item)) ?? {
        attributes: []
    };
    const targets = items.filter((item)=>!!item).filter((item)=>'layerId' in item);
    return Object.fromEntries(layers.map((layer, index)=>{
        for (const target of targets){
            if (target.layerId === layer.id) return [
                layer.id,
                $0957b1eeba070f0f$var$createEntryLayer(layer, target.attributes, target.bounds, target.tiles)
            ];
        }
        return [
            layer.id,
            $0957b1eeba070f0f$var$createEntryLayer(layer, generic.attributes)
        ];
    }));
}







class $2f3fd31975078e63$export$a8c18874b9331404 {
    // Reads from history (ImageData) to avoid reading from canvas.
    getColorAt(x, y, composed) {
        x = Math.floor(x);
        y = Math.floor(y);
        if (x < 0 || x >= composed.size.width || y < 0 || y >= composed.size.height) return new (0, $be957da3610487e9$export$921068d8846a1559).RGB(0, 0, 0);
        const tilesX = Math.ceil(composed.size.width / (0, $211b564339712990$export$f7bc58374d6bc9b6));
        const tileCol = Math.floor(x / (0, $211b564339712990$export$f7bc58374d6bc9b6));
        const tileRow = Math.floor(y / (0, $211b564339712990$export$f7bc58374d6bc9b6));
        const tileIndex = tileRow * tilesX + tileCol;
        this.canvas ??= (0, $be957da3610487e9$export$921068d8846a1559).canvas(1, 1);
        this.ctx ??= (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.canvas);
        const ctx = this.ctx;
        ctx.clearRect(0, 0, 1, 1);
        ctx.imageSmoothingEnabled = false;
        this.compositor.draw(ctx, Object.values(composed.layerMap).sort((0, $6b58556e30cebed5$export$87eabc555ccfbb9f)), 1, 1, (targetCtx, layer)=>{
            const tile = layer.tiles[tileIndex];
            let fillStyle = '';
            if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(tile)) fillStyle = tile.fill;
            else {
                const pixelIndex = y % (0, $211b564339712990$export$f7bc58374d6bc9b6) * tile.data.width + x % (0, $211b564339712990$export$f7bc58374d6bc9b6);
                const alpha = tile.data.data[pixelIndex * 4 + 3];
                fillStyle = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr({
                    r: tile.data.data[pixelIndex * 4],
                    g: tile.data.data[pixelIndex * 4 + 1],
                    b: tile.data.data[pixelIndex * 4 + 2],
                    a: alpha / 255
                });
            }
            targetCtx.fillStyle = fillStyle;
            targetCtx.fillRect(0, 0, 1, 1);
        });
        const imData = ctx.getImageData(0, 0, 1, 1);
        return new (0, $be957da3610487e9$export$921068d8846a1559).RGB(imData.data[0], imData.data[1], imData.data[2]);
    }
    destroy() {
        this.compositor.destroy();
        if (this.canvas) {
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.canvas);
            this.canvas = undefined;
            this.ctx = undefined;
        }
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.compositor = new (0, $7db1a448998b9957$export$fca65d4bf5f27b48)();
    }
}




function $58f7addd70485099$export$199acb5b15c43176(poly, x, y) {
    return poly.map((poly)=>{
        return poly.map((ring)=>{
            return ring.map((p)=>{
                return [
                    p[0] + x,
                    p[1] + y
                ];
            });
        });
    });
}




function $21750daad446671b$export$820c5732ce56544(selection, width, height) {
    const result = new Uint8Array(new ArrayBuffer(width * height));
    const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(width, height);
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    (0, $2f436639594531f3$export$f7b95c0f504bef8b)(selection, ctx);
    const imageData = ctx.getImageData(0, 0, width, height);
    (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(canvas);
    const len = width * height;
    for(let i = 0, e = 0; i < len; i++, e += 4)result[i] = imageData.data[e] >>> 7;
    return result;
}



function $60b53242b35ddd35$export$21e46d5143f188b8(mixModeStr) {
    return mixModeStr ?? 'source-over';
}


const $a919a1fb23b6c719$export$9f4f73b1bd7c2f26 = 16;
class $a919a1fb23b6c719$export$4a819bde91671014 {
    updateIndices() {
        this.layers.forEach((item, index)=>{
            item.index = index;
        });
    }
    /*
     * Resets canvas -> 1 layer, 100% opacity,
     * unless layers provided.
     * @param p
     */ reset(p) {
        if (!p.width || !p.height || p.width < 1 || p.height < 1 || isNaN(p.width) || isNaN(p.height)) throw new Error('invalid canvas size');
        this.width = p.width;
        this.height = p.height;
        this.selection = undefined;
        this.layers.splice(1, Math.max(0, this.layers.length - 1));
        this.klHistory.pause(true);
        try {
            if (p.layers) for(let i = 0; i < p.layers.length; i++){
                const pItem = p.layers[i];
                if (!this.layers[i]) this.addLayer();
                const layer = this.layers[i];
                layer.id = pItem.id;
                layer.name = pItem.name;
                layer.isVisible = pItem.isVisible;
                layer.mixModeStr = pItem.mixModeStr;
                layer.hasClipping = pItem.hasClipping;
                (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(layer.canvas, this.width, this.height, {
                    ensureCleared: true
                });
                layer.context.drawImage(pItem.image, 0, 0);
                this.setOpacity(i, pItem.opacity);
            }
            else {
                const layer = this.layers[0];
                layer.name = p.layerName ? p.layerName : (0, $fc42a07754814920$export$ce37e184d908d785)('layers-layer') + ' 1';
                layer.isVisible = true;
                layer.hasClipping = false;
                (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(layer.canvas, this.width, this.height, {
                    ensureCleared: true
                });
                layer.mixModeStr = 'source-over';
                this.setOpacity(0, 1);
                if (p.color) this.layerFill(0, p.color);
                else if (p.image) layer.context.drawImage(p.image, 0, 0);
            }
        } finally{
            this.klHistory.pause(false);
        }
        this.updateIndices();
        if (!this.klHistory.isPaused()) {
            const historyEntryData = {
                projectId: {
                    value: p.projectId ?? (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)()
                },
                size: {
                    width: this.width,
                    height: this.height
                },
                selection: {
                    value: this.selection
                },
                activeLayerId: this.layers.at(-1).id,
                layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                    attributes: 'all'
                })
            };
            this.klHistory.push(historyEntryData);
        }
        return this.layers.length - 1;
    }
    isLayerLimitReached() {
        return this.layers.length >= $a919a1fb23b6c719$export$9f4f73b1bd7c2f26;
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    /**
     * without resizing
     */ setSize(width, height) {
        this.width = width;
        this.height = height;
    }
    getLayerCount() {
        return this.layers.length;
    }
    resize(w, h, algorithm = 'smooth') {
        if (!w || !h || w === this.width && h === this.height || isNaN(w) || isNaN(h) || w < 1 || h < 1) return false;
        w = Math.max(w, 1);
        h = Math.max(h, 1);
        let tmp1, tmp2;
        if (algorithm === 'pixelated') {
            tmp1 = (0, $be957da3610487e9$export$921068d8846a1559).canvas(w, h);
            const tmp1Ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(tmp1);
            tmp1Ctx.imageSmoothingEnabled = false;
            for(let i = 0; i < this.layers.length; i++){
                if (i > 0) tmp1Ctx.clearRect(0, 0, w, h);
                const layer = this.layers[i];
                tmp1Ctx.drawImage(layer.canvas, 0, 0, w, h);
                (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(layer.canvas, w, h, {
                    ensureCleared: true
                });
                layer.context.drawImage(tmp1, 0, 0);
            }
        } else {
            // smooth
            tmp1 = (0, $be957da3610487e9$export$921068d8846a1559).canvas();
            tmp2 = (0, $be957da3610487e9$export$921068d8846a1559).canvas();
            for(let i = 0; i < this.layers.length; i++)(0, $be957da3610487e9$export$921068d8846a1559).resizeCanvas(this.layers[i].canvas, w, h, tmp1, tmp2);
        }
        if (this.selection) this.selection = (0, $5f00e0232038b1be$export$aa391dbbf8073422)(this.selection, (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(w / this.width, h / this.height));
        this.width = w;
        this.height = h;
        this.klHistory.push({
            size: {
                width: this.width,
                height: this.height
            },
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'tiles'
                ]
            }),
            ...this.selection ? {
                selection: {
                    value: this.selection
                }
            } : {}
        });
        return true;
    }
    /**
     * crop / extend
     */ cropExtend(p) {
        const newW = Math.round(p.left) + this.width + Math.round(p.right);
        const newH = Math.round(p.top) + this.height + Math.round(p.bottom);
        const offX = Math.round(p.left);
        const offY = Math.round(p.top);
        if (isNaN(newW) || isNaN(newH) || newW < 1 || newH < 1) return false;
        for(let i = 0; i < this.layers.length; i++){
            const ctemp = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.width, this.height);
            const layer = this.layers[i];
            (0, $be957da3610487e9$export$921068d8846a1559).ctx(ctemp).drawImage(layer.canvas, 0, 0);
            (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(layer.canvas, newW, newH, {
                ensureCleared: true
            });
            layer.context.save();
            if (i === 0 && p.fillColor) {
                layer.context.fillStyle = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr(p.fillColor);
                layer.context.fillRect(0, 0, newW, newH);
                layer.context.clearRect(offX, offY, this.width, this.height);
            }
            layer.context.drawImage(ctemp, offX, offY);
            layer.context.restore();
        }
        this.width = newW;
        this.height = newH;
        if (this.selection) this.selection = (0, $58f7addd70485099$export$199acb5b15c43176)(this.selection, offX, offY);
        this.klHistory.push({
            size: {
                width: this.width,
                height: this.height
            },
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'tiles'
                ]
            }),
            ...this.selection ? {
                selection: {
                    value: this.selection
                }
            } : {}
        });
        return true;
    }
    /**
     * will be inserted above of selected
     */ addLayer(selectedIndex, data) {
        if (this.isLayerLimitReached()) return false;
        const index = selectedIndex === undefined ? this.layers.length : selectedIndex + 1;
        const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.width, this.height);
        const context = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
        if (data) {
            if (typeof data.image === 'function') data.image(context);
            else context.drawImage(data.image, 0, 0);
        }
        const layerId = (0, $f13a819f841fbdb5$export$b2ce7a8a096070e2)();
        const layer = {
            id: layerId,
            index: index,
            name: data && data.name !== undefined ? data.name : (0, $fc42a07754814920$export$ce37e184d908d785)('layers-layer') + ' ' + (this.layers.length + this.layerNrOffset),
            mixModeStr: (0, $60b53242b35ddd35$export$21e46d5143f188b8)(data?.mixModeStr),
            hasClipping: data?.hasClipping ?? false,
            isVisible: data ? data.isVisible : true,
            opacity: data ? data.opacity : 1,
            canvas: canvas,
            context: context
        };
        this.layers.splice(index, 0, layer);
        this.klHistory.pause(true);
        try {
            this.setOpacity(index, 1);
        } finally{
            this.klHistory.pause(false);
        }
        this.updateIndices();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: layerId,
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'index'
                ]
            }, {
                layerId: layerId,
                attributes: 'all',
                tiles: data ? undefined : (0, $714316c134a8cc2b$export$9a1731baa7701cc7)(this.width, this.height, 'transparent')
            })
        });
        return index;
    }
    duplicateLayer(srcIndex) {
        if (!this.layers[srcIndex] || this.isLayerLimitReached()) return false;
        const srcLayer = this.layers[srcIndex];
        const newIndex = srcIndex + 1;
        const composed = this.klHistory.getComposed();
        const srcComposed = composed.layerMap[srcLayer.id];
        const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.width, this.height);
        const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
        const layerId = (0, $f13a819f841fbdb5$export$b2ce7a8a096070e2)();
        const newLayer = {
            id: layerId,
            index: newIndex,
            name: srcLayer.name + ' ' + (0, $fc42a07754814920$export$ce37e184d908d785)('layers-copy'),
            mixModeStr: srcLayer.mixModeStr,
            hasClipping: srcLayer.hasClipping,
            isVisible: srcLayer.isVisible,
            opacity: srcLayer.opacity,
            canvas: canvas,
            context: ctx
        };
        this.layers.splice(newIndex, 0, newLayer);
        {
            // draw into new layer from old
            const tilesPerX = Math.ceil(this.width / (0, $211b564339712990$export$f7bc58374d6bc9b6));
            // Uncaught TypeError: Cannot read properties of undefined (reading 'tiles')
            srcComposed.tiles.forEach((tile, index)=>{
                const x = index % tilesPerX;
                const y = Math.floor(index / tilesPerX);
                ctx.save();
                if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(tile)) {
                    ctx.fillStyle = tile.fill;
                    ctx.fillRect(x * (0, $211b564339712990$export$f7bc58374d6bc9b6), y * (0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6));
                } else ctx.putImageData(tile.data, x * (0, $211b564339712990$export$f7bc58374d6bc9b6), y * (0, $211b564339712990$export$f7bc58374d6bc9b6));
                ctx.restore();
            });
        }
        this.updateIndices();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: layerId,
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'index'
                ]
            }, {
                layerId: layerId,
                attributes: 'all',
                tiles: srcComposed.tiles.map((tile)=>{
                    if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(tile)) return {
                        ...tile
                    };
                    return (0, $aab5cae708a98039$export$1a44c122b8668cb)(tile);
                })
            })
        });
        return srcIndex + 1;
    }
    getLayerContext(index, doReturnNull) {
        if (this.layers[index]) return this.layers[index].context;
        if (doReturnNull) return null;
        throw new Error('layer of index ' + index + ' not found (in ' + this.layers.length + ' layers)');
    }
    removeLayer(index) {
        const toDeleteLayer = this.layers[index];
        if (!toDeleteLayer) return false;
        (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(toDeleteLayer.canvas);
        this.layers.splice(index, 1);
        this.updateIndices();
        const activeLayerIndex = Math.max(0, index - 1);
        const activeLayerId = this.layers[activeLayerIndex].id;
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: activeLayerId,
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'index'
                ]
            })
        });
        return activeLayerIndex;
    }
    renameLayer(index, name) {
        const targetLayer = this.layers[index];
        if (targetLayer) targetLayer.name = name;
        else return false;
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'name'
                ]
            })
        });
        return true;
    }
    setOpacity(layerIndex, opacity) {
        if (!this.layers[layerIndex]) return;
        opacity = Math.max(0, Math.min(1, opacity));
        this.layers[layerIndex].opacity = opacity;
        if (!this.klHistory.isPaused()) {
            const layerId = this.layers[layerIndex].id;
            const topEntry = this.klHistory.getEntries().at(-1).data;
            const replaceTop = (0, $f40e9d7cf0f73872$export$e173233eae155bba)(topEntry, layerId);
            this.klHistory.push({
                layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                    layerId: layerId,
                    attributes: [
                        'opacity'
                    ]
                })
            }, replaceTop);
        }
    }
    setLayerIsVisible(layerIndex, isVisible) {
        if (this.layers[layerIndex]) this.layers[layerIndex].isVisible = isVisible;
        else throw new Error(`layer ${layerIndex} undefined`);
        if (!this.klHistory.isPaused()) {
            const layerId = this.layers[layerIndex].id;
            const topEntry = this.klHistory.getEntries().at(-1).data;
            const replaceTop = (0, $17452f9bf68a33d6$export$b706b44cfdbaaa7d)(topEntry, layerId);
            this.klHistory.push({
                layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                    layerId: layerId,
                    attributes: [
                        'isVisible'
                    ]
                })
            }, replaceTop);
        }
    }
    setLayerHasClipping(layerIndex, hasClipping) {
        if (this.layers[layerIndex]) this.layers[layerIndex].hasClipping = hasClipping;
        else throw new Error(`layer ${layerIndex} undefined`);
        if (!this.klHistory.isPaused()) // todo could this also do replace top like setLayerIsVisible? - might require extra effort
        this.klHistory.push({
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                layerId: this.layers[layerIndex].id,
                attributes: [
                    'hasClipping'
                ]
            })
        });
    }
    moveLayer(index, delta) {
        if (delta === 0) return;
        if (!this.layers[index]) return;
        const temp = this.layers[index];
        this.layers.splice(index, 1);
        const targetIndex = Math.max(0, Math.min(index + delta, this.layers.length));
        this.layers.splice(targetIndex, 0, temp);
        this.updateIndices();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: this.layers[targetIndex].id,
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'index'
                ]
            })
        });
        return targetIndex;
    }
    mergeLayer(layerIndex, mixModeStr) {
        const topLayer = this.layers[layerIndex];
        const bottomLayer = this.layers[layerIndex - 1];
        if (!bottomLayer || !topLayer) return;
        const compositor = new (0, $7db1a448998b9957$export$fca65d4bf5f27b48)();
        let hasChanges;
        try {
            hasChanges = compositor.merge(bottomLayer.context, bottomLayer, {
                ...topLayer,
                mixModeStr: mixModeStr ?? topLayer.mixModeStr
            }, (ctx, layer)=>ctx.drawImage(layer.canvas, 0, 0));
        } finally{
            compositor.destroy();
        }
        this.klHistory.pause(true);
        try {
            this.removeLayer(layerIndex);
        } finally{
            this.klHistory.pause(false);
        }
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: bottomLayer.id,
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'index'
                ]
            }, hasChanges ? {
                layerId: bottomLayer.id,
                attributes: [
                    'tiles'
                ]
            } : undefined)
        });
        return bottomLayer.index;
    }
    mergeAll() {
        if (this.layers.length <= 1) return false;
        const mergedCanvas = (0, $3efd55021d1b8d84$export$5f63a7b18dc4503a)(this.getProject());
        const bottomLayer = {
            id: this.layers[0].id,
            index: 0,
            canvas: mergedCanvas,
            context: (0, $2f436639594531f3$export$39f92e86d1722f3a)(mergedCanvas),
            name: (0, $fc42a07754814920$export$ce37e184d908d785)('layers-layer') + ' 1',
            opacity: 1,
            isVisible: true,
            mixModeStr: 'source-over',
            hasClipping: false
        };
        (0, $2f436639594531f3$export$2384aff49c9b73c2)(this.layers[0].canvas);
        this.layers[0] = bottomLayer;
        this.klHistory.pause(true);
        try {
            // remove upper layers
            for(let i = this.layers.length - 1; i > 0; i--)this.removeLayer(i);
        } finally{
            this.klHistory.pause(false);
        }
        if (!this.klHistory.isPaused()) {
            const activeLayerId = bottomLayer.id;
            this.klHistory.push({
                activeLayerId: activeLayerId,
                layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                    layerId: bottomLayer.id,
                    attributes: 'all'
                })
            });
        }
        return 0;
    }
    // rotates the canvas with all layers. either by 90, 180, or 270 degrees
    rotate(deg) {
        while(deg < 0)deg += 360;
        deg %= 360;
        if (deg !== 90 && deg !== 180 && deg !== 270) return;
        const temp = (0, $be957da3610487e9$export$921068d8846a1559).canvas();
        if (deg === 180) (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(temp, this.width, this.height);
        else if (deg === 90 || deg === 270) (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(temp, this.height, this.width);
        let matrix = (0, $b8cf610a99a4f5d8$export$f0954fd7d5368655)();
        if (deg === 90) matrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $15f17d2145582868$export$d73ee8ef04f5226a)(this.height, 0), (0, $648ca1a32d748118$export$bb628a54ab399bc9)(Math.PI / 2));
        else if (deg === 180) matrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $15f17d2145582868$export$d73ee8ef04f5226a)(this.width, this.height), (0, $648ca1a32d748118$export$bb628a54ab399bc9)(Math.PI));
        else if (deg === 270) matrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $15f17d2145582868$export$d73ee8ef04f5226a)(0, this.width), (0, $648ca1a32d748118$export$bb628a54ab399bc9)(3 * Math.PI / 2));
        const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(temp);
        for(let i = 0; i < this.layers.length; i++){
            ctx.clearRect(0, 0, temp.width, temp.height);
            ctx.save();
            ctx.setTransform(...(0, $f7c026d16783f524$export$2b60e7dafdbde18a)(matrix));
            ctx.drawImage(this.layers[i].canvas, 0, 0);
            ctx.restore();
            (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.layers[i].canvas, temp.width, temp.height, {
                ensureCleared: true
            });
            this.layers[i].context.drawImage(temp, 0, 0);
        }
        this.width = temp.width;
        this.height = temp.height;
        if (this.selection) this.selection = (0, $5f00e0232038b1be$export$aa391dbbf8073422)(this.selection, matrix);
        this.klHistory.push({
            size: {
                width: this.width,
                height: this.height
            },
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                attributes: [
                    'tiles'
                ]
            }),
            ...this.selection ? {
                selection: {
                    value: this.selection
                }
            } : {}
        });
    }
    flip(isHorizontal, isVertical, layerIndex) {
        if (!isHorizontal && !isVertical) return;
        const temp = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.width, this.height);
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(temp, this.width, this.height);
        const tempCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(temp);
        const matrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $15f17d2145582868$export$d73ee8ef04f5226a)(temp.width / 2, temp.height / 2), (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(isHorizontal ? -1 : 1, isVertical ? -1 : 1), (0, $15f17d2145582868$export$d73ee8ef04f5226a)(-temp.width / 2, -temp.height / 2));
        for(let i = 0; i < this.layers.length; i++){
            if ((layerIndex || layerIndex === 0) && i !== layerIndex) continue;
            tempCtx.save();
            tempCtx.clearRect(0, 0, temp.width, temp.height);
            tempCtx.setTransform(...(0, $f7c026d16783f524$export$2b60e7dafdbde18a)(matrix));
            tempCtx.drawImage(this.layers[i].canvas, 0, 0);
            tempCtx.restore();
            this.layers[i].context.clearRect(0, 0, this.layers[i].canvas.width, this.layers[i].canvas.height);
            this.layers[i].context.drawImage(temp, 0, 0);
        }
        if (this.selection) this.selection = (0, $5f00e0232038b1be$export$aa391dbbf8073422)(this.selection, matrix);
        const targetLayer = layerIndex === undefined ? undefined : this.layers[layerIndex];
        this.klHistory.push({
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, targetLayer ? {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ]
            } : {
                attributes: [
                    'tiles'
                ]
            }),
            ...this.selection ? {
                selection: {
                    value: this.selection
                }
            } : {}
        });
    }
    // arbitrary drawing operation & focus layer
    drawOperation(layerIndex, operation) {
        const targetLayer = this.layers[layerIndex];
        const ctx = targetLayer.context;
        operation(ctx);
        if (!this.klHistory.isPaused()) this.klHistory.push({
            activeLayerId: targetLayer.id,
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ]
            })
        });
    }
    layerFill(layerIndex, colorObj, compositeOperation, doClipSelection) {
        const ctx = this.layers[layerIndex].context;
        ctx.save();
        const isUniformFill = !(doClipSelection && this.selection) && compositeOperation === undefined;
        if (compositeOperation) ctx.globalCompositeOperation = compositeOperation;
        let bounds;
        if (doClipSelection && this.selection) {
            const selectionPath = (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection);
            ctx.clip(selectionPath);
            bounds = (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(this.selection, 'index');
        }
        const fill = 'rgba(' + colorObj.r + ',' + colorObj.g + ',' + colorObj.b + ',1)';
        ctx.fillStyle = fill;
        ctx.fillRect(0, 0, this.layers[layerIndex].canvas.width, this.layers[layerIndex].canvas.height);
        ctx.restore();
        if (!this.klHistory.isPaused()) {
            const targetLayer = this.layers[layerIndex];
            this.klHistory.push({
                layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                    layerId: targetLayer.id,
                    attributes: [
                        'tiles'
                    ],
                    tiles: isUniformFill ? (0, $714316c134a8cc2b$export$9a1731baa7701cc7)(this.width, this.height, fill) : undefined,
                    bounds: bounds
                })
            });
        }
    }
    floodFill(layerIndex, x, y, rgb, opacity, tolerance, sampleStr, grow, isContiguous) {
        if (x < 0 || y < 0 || x >= this.width || y >= this.height || opacity === 0) return;
        tolerance = Math.round(tolerance);
        x = Math.round(x);
        y = Math.round(y);
        if (![
            'above',
            'current',
            'all'
        ].includes(sampleStr)) throw new Error('invalid sampleStr');
        const selectionMask = this.selection ? (0, $21750daad446671b$export$820c5732ce56544)(this.selection, this.width, this.height) : undefined;
        if (selectionMask && selectionMask[y * this.width + x] === 0) // don't fill if outside of selection
        return;
        const targetLayer = this.layers[layerIndex];
        let result;
        let targetCtx;
        let targetImageData;
        if (sampleStr === 'all') {
            const srcCanvas = this.layers.length === 1 ? this.layers[0].canvas : this.getCanvas();
            const srcCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(srcCanvas);
            const srcImageData = srcCtx.getImageData(0, 0, this.width, this.height);
            const srcData = srcImageData.data;
            result = (0, $d7484fd837b79568$export$13d50f258a8034f)(srcData, selectionMask, this.width, this.height, x, y, tolerance, Math.round(grow), isContiguous);
            targetCtx = targetLayer.context;
            targetImageData = targetCtx.getImageData(0, 0, this.width, this.height);
        } else {
            const srcIndex = sampleStr === 'above' ? layerIndex + 1 : layerIndex;
            if (srcIndex >= this.layers.length) return;
            const srcCtx = this.layers[srcIndex].context;
            const srcImageData = srcCtx.getImageData(0, 0, this.width, this.height);
            const srcData = srcImageData.data;
            result = (0, $d7484fd837b79568$export$13d50f258a8034f)(srcData, selectionMask, this.width, this.height, x, y, tolerance, Math.round(grow), isContiguous);
            targetCtx = layerIndex === srcIndex ? srcCtx : targetLayer.context;
            targetImageData = layerIndex === srcIndex ? srcImageData : targetCtx.getImageData(0, 0, this.width, this.height);
        }
        const targetData = targetImageData.data;
        if (rgb) {
            if (opacity === 1) {
                for(let i = 0; i < this.width * this.height; i++)if (result.data[i] === 255) {
                    targetData[i * 4] = rgb.r;
                    targetData[i * 4 + 1] = rgb.g;
                    targetData[i * 4 + 2] = rgb.b;
                    targetData[i * 4 + 3] = 255;
                }
            } else {
                for(let i = 0; i < this.width * this.height; i++)if (result.data[i] === 255) {
                    targetData[i * 4] = (0, $be957da3610487e9$export$921068d8846a1559).mix(targetData[i * 4], rgb.r, opacity);
                    targetData[i * 4 + 1] = (0, $be957da3610487e9$export$921068d8846a1559).mix(targetData[i * 4 + 1], rgb.g, opacity);
                    targetData[i * 4 + 2] = (0, $be957da3610487e9$export$921068d8846a1559).mix(targetData[i * 4 + 2], rgb.b, opacity);
                    targetData[i * 4 + 3] = (0, $be957da3610487e9$export$921068d8846a1559).mix(targetData[i * 4 + 3], 255, opacity);
                }
            }
        } else // erase
        if (opacity === 1) {
            for(let i = 0; i < this.width * this.height; i++)if (result.data[i] === 255) targetData[i * 4 + 3] = 0;
        } else {
            for(let i = 0; i < this.width * this.height; i++)if (result.data[i] === 255) targetData[i * 4 + 3] = (0, $be957da3610487e9$export$921068d8846a1559).mix(targetData[i * 4 + 3], 0, opacity);
        }
        targetCtx.putImageData(targetImageData, 0, 0);
        // const ctx = this.layers[layerIndex].context;
        // ctx.save();
        // ctx.fillStyle = 'rgba(255,0,0,0.2)';
        // ctx.fillRect(
        //     result.bounds.x1,
        //     result.bounds.y1,
        //     result.bounds.x2 - result.bounds.x1,
        //     result.bounds.y2 - result.bounds.y1,
        // );
        // ctx.restore();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ],
                bounds: result.bounds
            })
        });
    }
    /**
     * draw geometric shape (circle, line, rect)
     * @param layerIndex
     * @param shapeObj
     */ drawShape(layerIndex, shapeObj) {
        if (shapeObj.x1 === shapeObj.x2 && shapeObj.y1 === shapeObj.y2) return;
        const targetLayer = this.layers[layerIndex];
        const selectionPath = this.selection ? new Path2D((0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection)) : undefined;
        const bounds = (0, $03d72c2b76715beb$export$71b514a25c47df50)(targetLayer.context, shapeObj, selectionPath);
        // debug
        /*const ctx = this.layers[layerIndex].context;
        ctx.save();
        ctx.fillStyle = 'rgba(255,0,0,0.2)';
        ctx.fillRect(bounds.x1, bounds.y1, bounds.x2 - bounds.x1, bounds.y2 - bounds.y1);
        ctx.restore();*/ if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ],
                bounds: bounds
            })
        });
    }
    drawGradient(layerIndex, gradientObj) {
        const targetLayer = this.layers[layerIndex];
        const selectionPath = this.selection ? new Path2D((0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection)) : undefined;
        (0, $abbf5f9031f83ecb$export$b1f70a113e3b5c1b)(targetLayer.context, gradientObj, selectionPath);
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ]
            })
        });
    }
    text(layerIndex, p) {
        const targetLayer = this.layers[layerIndex];
        const rect = (0, $7f7fc3a72d8b806e$export$482c90f94eb9717c)(targetLayer.canvas, (0, $be957da3610487e9$export$921068d8846a1559).copyObj(p), this.selection ? new Path2D((0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection)) : undefined);
        // add 2, because rect not entirely accurate
        const padding = 2 + (p.stroke ? p.stroke.lineWidth / 2 : 0);
        const changedBounds = (0, $e54f3e9fe3a16a29$export$5dd60a54dd55622)((0, $4c2c6808296c0d73$export$d89ccdf57354a99c)(rect, 'coordinate'), (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $15f17d2145582868$export$d73ee8ef04f5226a)(p.x, p.y), (0, $648ca1a32d748118$export$bb628a54ab399bc9)(-p.angleRad)));
        changedBounds.x1 -= padding;
        changedBounds.y1 -= padding;
        changedBounds.x2 += padding;
        changedBounds.y2 += padding;
        // const ctx = this.layers[layerIndex].context;
        // ctx.save();
        // ctx.fillStyle = 'rgba(255,0,0,0.2)';
        // ctx.fillRect(bounds.x1, bounds.y1, bounds.x2 - bounds.x1, bounds.y2 - bounds.y1);
        // ctx.restore();
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ],
                bounds: (0, $4c2c6808296c0d73$export$b0036cbc597df324)(changedBounds)
            })
        });
    }
    eraseLayer(p) {
        const targetLayer = this.layers[p.layerIndex];
        const ctx = targetLayer.context;
        ctx.save();
        let bounds;
        if (p.useSelection && this.selection) {
            const selectionPath = (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection);
            ctx.clip(selectionPath);
            bounds = (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(this.selection, 'index');
        }
        if (p.useAlphaLock) ctx.globalCompositeOperation = 'source-atop';
        else ctx.globalCompositeOperation = 'destination-out';
        ctx.fillStyle = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr((0, $bc268e0fc7103648$export$8627e24041b28589)());
        ctx.fillRect(0, 0, this.width, this.height);
        ctx.restore();
        const isUniformFill = !p.useAlphaLock && !(p.useSelection && this.selection);
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'tiles'
                ],
                tiles: isUniformFill ? (0, $714316c134a8cc2b$export$9a1731baa7701cc7)(this.width, this.height, 'transparent') : undefined,
                bounds: bounds
            })
        });
    }
    getKlHistory() {
        return this.klHistory;
    }
    getLayersReference() {
        return this.layers;
    }
    getLayers() {
        return this.layers.map((layer)=>({
                ...layer
            }));
    }
    getLayer(index) {
        const layer = this.layers[index];
        if (!layer) throw new Error('layer of index ' + index + ' not found (in ' + this.layers.length + ' layers)');
        return {
            ...layer
        };
    }
    getColorAt(x, y) {
        let result;
        try {
            result = this.eyedropper.getColorAt(x, y, this.klHistory.getComposed());
        } catch (_) {
        // history probably messed up. but the app should stay operational
        }
        return result;
    }
    getCanvas(factor = 1, masksSelection) {
        return (0, $3efd55021d1b8d84$export$5f63a7b18dc4503a)(this.getProject(), factor, masksSelection ? this.selection : undefined);
    }
    getProject() {
        return {
            projectId: this.klHistory.getComposed().projectId.value,
            width: this.width,
            height: this.height,
            layers: this.layers.map((layer)=>{
                return {
                    name: layer.name,
                    isVisible: layer.isVisible,
                    opacity: layer.opacity,
                    mixModeStr: layer.mixModeStr,
                    hasClipping: layer.hasClipping,
                    image: layer.canvas
                };
            })
        };
    }
    setMixMode(layerIndex, mixModeStr) {
        const targetLayer = this.layers[layerIndex];
        targetLayer.mixModeStr = mixModeStr;
        if (!this.klHistory.isPaused()) this.klHistory.push({
            layerMap: (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(this.layers, {
                layerId: targetLayer.id,
                attributes: [
                    'mixModeStr'
                ]
            })
        });
    }
    /**
     * Set composite drawing step for KlCanvasWorkspace.
     * To apply temporary manipulations to a layer.
     *
     * @param layerIndex
     * @param compositeObj
     */ setComposite(layerIndex, compositeObj) {
        if (!this.layers[layerIndex]) throw new Error('invalid layer');
        this.layers[layerIndex].compositeObj = compositeObj;
    }
    setSelection(selection) {
        if (!this.selection && !selection) return;
        this.selection = selection;
        this.klHistory.push({
            selection: {
                value: selection
            }
        });
    }
    getSelection() {
        return this.selection;
    }
    /**
     * called after undo/redo, to apply the changes to the klCanvas.
     * before - before undo/redo was called - equivalent to current state of klCanvas.
     * after - after undo/redo was called.
     */ updateViaComposed(before, after) {
        this.width = after.size.width;
        this.height = after.size.height;
        this.selection = after.selection.value;
        this.layers = (0, $8d7083f03957efab$export$cee5b735b1b9bad1)(this.layers, before, after);
    }
    destroy() {
        if (this.isDestroyed) return;
        this.layers.forEach((layer)=>{
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(layer.canvas);
            layer.canvas = {};
            layer.context = {};
        });
        this.layers = [];
        this.eyedropper.destroy();
        this.isDestroyed = true;
    }
    // ----------------------------------- public -----------------------------------
    constructor(history, layerNrOffset = 0){
        this.layerNrOffset = layerNrOffset;
        this.isDestroyed = false;
        this.selection = undefined;
        this.klHistory = history;
        this.layers = [];
        this.eyedropper = new (0, $2f3fd31975078e63$export$a8c18874b9331404)();
        this.width = 0;
        this.height = 0;
        this.updateViaComposed({
            projectId: {
                value: (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)()
            },
            size: {
                width: 0,
                height: 0
            },
            activeLayerId: '',
            selection: {
                value: []
            },
            layerMap: {}
        }, this.klHistory.getComposed());
    }
}




function $2af5569ab072fe29$export$6e1bedb2a6cdff30(blendMode) {
    if (!blendMode) return (0, $fc42a07754814920$export$ce37e184d908d785)('layers-blend-normal');
    const codes = {
        'source-over': 'layers-blend-normal',
        darken: 'layers-blend-darken',
        multiply: 'layers-blend-multiply',
        'color-burn': 'layers-blend-color-burn',
        lighten: 'layers-blend-lighten',
        screen: 'layers-blend-screen',
        'color-dodge': 'layers-blend-color-dodge',
        overlay: 'layers-blend-overlay',
        'soft-light': 'layers-blend-soft-light',
        'hard-light': 'layers-blend-hard-light',
        difference: 'layers-blend-difference',
        exclusion: 'layers-blend-exclusion',
        hue: 'layers-blend-hue',
        saturation: 'layers-blend-saturation',
        color: 'layers-blend-color',
        luminosity: 'layers-blend-luminosity'
    };
    if (!(blendMode in codes)) throw new Error('unknown blend mode');
    return (0, $fc42a07754814920$export$ce37e184d908d785)(codes[blendMode]);
}








function $5554e63384bd2870$export$28debfc111084e87(parentEl, currentName, callback) {
    const div = (0, $be957da3610487e9$export$921068d8846a1559).el();
    const destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
    const label = (0, $be957da3610487e9$export$921068d8846a1559).el({
        content: (0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename-name') + ':',
        css: {
            marginRight: 5
        }
    });
    const row = (0, $be957da3610487e9$export$921068d8846a1559).el({
        css: {
            display: 'flex'
        }
    });
    const input = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
        init: currentName,
        name: 'layer-name',
        isFocusIgnored: true,
        css: {
            width: '100%'
        }
    });
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(input.getElement(), {
        flexGrow: 1
    });
    const clearBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'button',
        className: 'kl-button',
        content: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('remove-layer', {
            height: 20
        }),
        title: (0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename-clear'),
        destroyer: destroyer,
        css: {
            marginLeft: 10
        },
        onClick: ()=>{
            input.setValue('');
            input.focus();
        }
    });
    const suggestions = [
        (0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename-sketch'),
        (0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename-colors'),
        (0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename-shading'),
        (0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename-lines'),
        (0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename-effects'),
        (0, $fc42a07754814920$export$ce37e184d908d785)('background'),
        (0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename-foreground')
    ];
    const suggestionBtns = [];
    const row2 = (0, $be957da3610487e9$export$921068d8846a1559).el({
        css: {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: 5,
            marginLeft: -5
        }
    });
    suggestions.forEach((item)=>{
        const btn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: row2,
            tagName: 'button',
            className: 'kl-button',
            content: item,
            destroyer: destroyer,
            onClick: ()=>{
                input.setValue(btn.textContent ?? '');
            },
            css: {
                margin: '5px 0 0 5px'
            }
        });
        suggestionBtns.push(btn);
    });
    div.append(label);
    label.append(row, row2);
    row.append(input.getElement(), clearBtn);
    setTimeout(()=>{
        input.focus();
        input.select();
    }, 10);
    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename-title')}</b>`,
        div: div,
        buttons: [
            {
                id: 'rename',
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename')
            },
            'Cancel'
        ],
        primaries: [
            'rename'
        ],
        callback: (val)=>{
            const newName = val === 'rename' ? input.getValue() : undefined;
            input.destroy();
            destroyer.destroy();
            suggestionBtns.splice(0, suggestionBtns.length);
            callback(newName);
        },
        clickOnEnter: 'rename'
    });
}







function $1129d9e167be0b75$export$ee79aceabae6bb8a(parentEl, p) {
    const div = (0, $be957da3610487e9$export$921068d8846a1559).el();
    div.innerHTML = (0, $fc42a07754814920$export$ce37e184d908d785)('layers-merge-description');
    const options = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
        isFocusable: true,
        optionArr: [
            {
                id: p.mixModeStr,
                label: (0, $2af5569ab072fe29$export$6e1bedb2a6cdff30)(p.mixModeStr)
            },
            {
                id: 'source-in',
                label: 'source-in'
            },
            {
                id: 'source-out',
                label: 'source-out'
            },
            {
                id: 'source-atop',
                label: 'source-atop'
            },
            {
                id: 'destination-in',
                label: 'destination-in'
            },
            {
                id: 'destination-out',
                label: 'destination-out'
            },
            {
                id: 'destination-atop',
                label: 'destination-atop'
            },
            {
                id: 'xor',
                label: 'xor'
            }
        ],
        initId: p.mixModeStr,
        onChange: ()=>{
            update();
        },
        isSmall: true,
        css: {
            marginTop: 5
        }
    });
    div.append(options.getElement());
    const thumbDimensions = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(p.topCanvas.width, p.topCanvas.height, 200, 200, 1);
    const preview = (0, $be957da3610487e9$export$921068d8846a1559).canvas(thumbDimensions.width, thumbDimensions.height);
    preview.title = (0, $fc42a07754814920$export$ce37e184d908d785)('preview');
    preview.className = 'kl-merge-preview';
    const spacer = (0, $be957da3610487e9$export$921068d8846a1559).el({
        content: '<br/>',
        css: {
            clear: 'both'
        }
    });
    div.append(spacer, preview);
    const update = ()=>{
        const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(preview);
        ctx.save();
        ctx.clearRect(0, 0, preview.width, preview.height);
        if (preview.width > p.topCanvas.width) ctx.imageSmoothingEnabled = false;
        ctx.drawImage(p.bottomCanvas, 0, 0, preview.width, preview.height);
        ctx.globalCompositeOperation = options.getValue();
        ctx.globalAlpha = p.topOpacity;
        ctx.drawImage(p.topCanvas, 0, 0, preview.width, preview.height);
        ctx.restore();
    };
    update();
    const keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
        onDown: (keyStr)=>{
            if (keyStr === 'right') options.next();
            if (keyStr === 'left') options.previous();
        }
    });
    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $fc42a07754814920$export$ce37e184d908d785)('layers-merge-modal-title')}</b>`,
        div: div,
        buttons: [
            'Ok',
            'Cancel'
        ],
        clickOnEnter: 'Ok',
        callback: (val)=>{
            keyListener.destroy();
            options.destroy();
            if (val === 'Ok') p.callback(options.getValue());
        }
    });
}







class $717502b6f4cb5d24$export$e44a253a59704894 {
    getElement() {
        return this.rootElement;
    }
    setEnabled(id, enabled) {
        this.onSetEnabled(id, enabled);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isExpanded = false;
        this.onSetEnabled = ()=>0;
        const button = (0, $8405ecc79d32770a$export$db3b6bfb95261072)('button.kl-button,w-full,h-full', [
            p.button
        ]);
        button.tabIndex = -1;
        button.onclick = ()=>{
            toggle(!this.isExpanded);
        };
        if (p.buttonTitle) button.title = p.buttonTitle;
        const items = [];
        const itemMap = {};
        p.items.forEach((item)=>{
            const itemButton = (0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
                tagName: 'button',
                className: 'kl-button',
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    gap: 10
                }
            });
            itemButton.tabIndex = -1;
            itemButton.append((0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
                content: item[1]
            }));
            if (item[2]) itemButton.append((0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
                content: item[2],
                css: {
                    fontSize: '0.8em',
                    opacity: '0.8'
                }
            }));
            itemButton.onclick = ()=>{
                toggle(false);
                p.onItemClick(item[0]);
            };
            items.push(itemButton);
            itemMap[item[0]] = itemButton;
        });
        this.onSetEnabled = (id, enabled)=>{
            itemMap[id].disabled = !enabled;
        };
        const menu = (0, $8405ecc79d32770a$export$db3b6bfb95261072)('.kl-dropdown-menu,right-0,top-full,nowrap,hidden', items);
        this.rootElement = (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',pos-relative', [
            button,
            menu
        ]);
        const toggle = (force)=>{
            this.isExpanded = force;
            menu.style.display = this.isExpanded ? '' : 'none';
            if (this.isExpanded) {
                document.addEventListener('pointerdown', onPointerDown, {
                    passive: false
                });
                window.addEventListener('blur', onBlur);
            } else {
                document.removeEventListener('pointerdown', onPointerDown);
                window.removeEventListener('blur', onBlur);
            }
        };
        const onPointerDown = (e)=>{
            const target = e.target;
            if (button.contains(target) || menu.contains(target)) return;
            toggle(false);
        };
        const onBlur = ()=>toggle(false);
    }
}


var $7b3d66f7b450f031$export$e1582ee498163d8b;
var $7b3d66f7b450f031$export$10cc39ba6eccc3a;
var $7b3d66f7b450f031$export$d9626c42532082a;
$7b3d66f7b450f031$export$e1582ee498163d8b = `yAFbda_clippingIcon`;
$7b3d66f7b450f031$export$10cc39ba6eccc3a = `yAFbda_clippingIconWrapper`;
$7b3d66f7b450f031$export$d9626c42532082a = `yAFbda_clippingIndicator`;



const $385cb86a8c70e1f3$var$paddingLeft = 25;
class $385cb86a8c70e1f3$export$c3bf51e04f391d6d {
    move(oldSpotIndex, newSpotIndex) {
        if (isNaN(oldSpotIndex) || isNaN(newSpotIndex)) throw 'layers-ui - invalid move';
        for(let i = 0; i < this.layerElArr.length; i++)((i)=>{
            let posy = this.layerElArr[i].spot;
            if (this.layerElArr[i].spot === oldSpotIndex) posy = newSpotIndex;
            else {
                if (this.layerElArr[i].spot > oldSpotIndex) posy--;
                if (posy >= newSpotIndex) posy++;
            }
            this.layerElArr[i].spot = posy;
            this.layerElArr[i].posY = (this.layerHeight + this.layerSpacing) * (this.klCanvasLayerArr.length - posy - 1);
            this.layerElArr[i].style.top = this.layerElArr[i].posY + 'px';
        })(i);
        if (oldSpotIndex === newSpotIndex) return;
        this.applyUncommitted();
        this.klCanvas.moveLayer(this.selectedSpotIndex, newSpotIndex - oldSpotIndex);
        this.klCanvasLayerArr = this.klCanvas.getLayers();
        this.selectedSpotIndex = newSpotIndex;
        this.mergeBtn.disabled = this.selectedSpotIndex === 0;
    }
    posToSpot(p) {
        let result = parseInt('' + (p / (this.layerHeight + this.layerSpacing) + 0.5));
        result = Math.min(this.klCanvasLayerArr.length - 1, Math.max(0, result));
        result = this.klCanvasLayerArr.length - result - 1;
        return result;
    }
    /**
     * update css position of all layers that are not being dragged, while dragging
     */ updateLayersVerticalPosition(elementIndex, newspot) {
        newspot = Math.min(this.klCanvasLayerArr.length - 1, Math.max(0, newspot));
        if (newspot === this.lastpos) return;
        for(let i = 0; i < this.layerElArr.length; i++){
            if (this.layerElArr[i].spot === elementIndex) continue;
            let posy = this.layerElArr[i].spot;
            if (this.layerElArr[i].spot > elementIndex) posy--;
            if (posy >= newspot) posy++;
            this.layerElArr[i].posY = (this.layerHeight + this.layerSpacing) * (this.klCanvasLayerArr.length - posy - 1);
            this.layerElArr[i].style.top = this.layerElArr[i].posY + 'px';
        }
        this.lastpos = newspot;
    }
    renameLayer(layerSpot) {
        (0, $5554e63384bd2870$export$28debfc111084e87)(this.parentEl, this.klCanvas.getLayer(layerSpot).name, (newName)=>{
            if (newName === undefined || newName === this.klCanvas.getLayer(layerSpot).name) return;
            this.klCanvas.renameLayer(layerSpot, newName);
            //this.createLayerList();
            this.onSelect(layerSpot, false);
        });
    }
    updateHeight() {
        this.layerListEl.style.height = this.layerElArr.length * 35 + 'px';
    }
    createLayerList(force) {
        if (this.klHistory.getChangeCount() === this.oldHistoryState && !force) return;
        this.isManipulating = false;
        this.oldHistoryState = this.klHistory.getChangeCount();
        this.klCanvasLayerArr = this.klCanvas.getLayers();
        const createLayerEntry = (index)=>{
            const klLayer = this.klCanvas.getLayer(index);
            const layerName = klLayer.name;
            const opacity = this.klCanvasLayerArr[index].opacity;
            const isVisible = klLayer.isVisible;
            const layercanvas = this.klCanvasLayerArr[index].context.canvas;
            const hasClipping = this.klCanvasLayerArr[index].hasClipping;
            const clippingOffset = hasClipping ? 15 : 0;
            const layer = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'kl-layer'
            });
            this.layerElArr[index] = layer;
            layer.posY = (this.klCanvasLayerArr.length - 1) * 35 - index * 35;
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(layer, {
                top: layer.posY
            });
            const innerLayer = (0, $be957da3610487e9$export$921068d8846a1559).el();
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(innerLayer, {
                position: 'relative'
            });
            const container1 = (0, $be957da3610487e9$export$921068d8846a1559).el();
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(container1, {
                width: 270,
                height: 34
            });
            const container2 = (0, $be957da3610487e9$export$921068d8846a1559).el();
            layer.append(innerLayer);
            innerLayer.append(container1, container2);
            layer.spot = index;
            //checkbox - visibility
            {
                const checkWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'label',
                    parent: container1,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('layers-visibility-toggle'),
                    css: {
                        display: 'flex',
                        width: 25,
                        height: '100%',
                        justifyContent: 'right',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }
                });
                const check = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'input',
                    parent: checkWrapper,
                    props: {
                        type: 'checkbox',
                        tabIndex: -1,
                        name: 'layer-visibility'
                    },
                    css: {
                        display: 'block',
                        cursor: 'pointer',
                        margin: 0,
                        marginRight: 5
                    }
                });
                check.checked = isVisible;
                check.onchange = ()=>{
                    this.klCanvas.setLayerIsVisible(layer.spot, check.checked);
                    if (layer.spot === this.selectedSpotIndex) this.onSelect(this.selectedSpotIndex, false);
                };
                // prevent layer getting dragged
                const preventFunc = (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                };
                if (0, $25e38424550c7e3f$export$7728c852ca75bb6d) checkWrapper.onpointerdown = preventFunc;
                else checkWrapper.onmousedown = preventFunc;
            }
            //thumb
            {
                const thumbDimensions = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(layercanvas.width, layercanvas.height, 30, 30, 1, true);
                layer.thumb = (0, $be957da3610487e9$export$921068d8846a1559).canvas(thumbDimensions.width, thumbDimensions.height);
                const thc = (0, $be957da3610487e9$export$921068d8846a1559).ctx(layer.thumb);
                thc.save();
                if (layer.thumb.width > layercanvas.width) thc.imageSmoothingEnabled = false;
                thc.drawImage(layercanvas, 0, 0, layer.thumb.width, layer.thumb.height);
                thc.restore();
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(layer.thumb, {
                    position: 'absolute',
                    left: (32 - layer.thumb.width) / 2 + $385cb86a8c70e1f3$var$paddingLeft,
                    top: (32 - layer.thumb.height) / 2 + 1,
                    background: 'var(--kl-checkerboard-background)'
                });
            }
            //clipping indicator
            const clippingIcon = hasClipping ? (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('layer-clipping', {
                position: 'absolute',
                left: $385cb86a8c70e1f3$var$paddingLeft + 32,
                top: 9,
                width: 16,
                height: 16,
                pointerEvents: 'none'
            }) : undefined;
            clippingIcon?.classList.add($7b3d66f7b450f031$export$d9626c42532082a);
            layer.label = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'kl-layer__label'
            });
            layer.layerName = layerName;
            layer.label.append(layer.layerName);
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(layer.label, {
                position: 'absolute',
                left: 38 + $385cb86a8c70e1f3$var$paddingLeft + clippingOffset,
                top: 1,
                fontSize: 13,
                width: 165 - clippingOffset,
                height: 20,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            });
            layer.label.ondblclick = ()=>{
                this.applyUncommitted();
                this.renameLayer(layer.spot);
            };
            layer.opacityLabel = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'kl-layer__opacity-label'
            });
            layer.opacity = opacity;
            layer.opacityLabel.append(parseInt('' + layer.opacity * 100) + '%');
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(layer.opacityLabel, {
                position: 'absolute',
                left: 189 + $385cb86a8c70e1f3$var$paddingLeft,
                top: 1,
                fontSize: 13,
                textAlign: 'right',
                width: 50,
                transition: 'color 0.2s ease-in-out',
                textDecoration: isVisible ? undefined : 'line-through'
            });
            let oldOpacity;
            const opacitySlider = new (0, $94a8fc3859482fa7$export$ac00cea56cec3037)({
                init: layer.opacity,
                width: 200 - clippingOffset,
                pointSize: 14,
                callback: (sliderValue, isFirst, isLast)=>{
                    if (isFirst) {
                        this.isManipulating = true;
                        oldOpacity = this.klCanvas.getLayer(layer.spot).opacity;
                        return;
                    }
                    if (isLast) {
                        this.isManipulating = false;
                        if (oldOpacity !== sliderValue) this.klCanvas.setOpacity(layer.spot, sliderValue);
                        return;
                    }
                    layer.opacityLabel.innerHTML = Math.round(sliderValue * 100) + '%';
                    this.klHistory.pause(true);
                    try {
                        this.klCanvas.setOpacity(layer.spot, sliderValue);
                    } finally{
                        this.klHistory.pause(false);
                    }
                    this.onUpdateProject();
                },
                getDoIgnore: ()=>this.isManipulating
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(opacitySlider.getElement(), {
                position: 'absolute',
                left: 39 + $385cb86a8c70e1f3$var$paddingLeft + clippingOffset,
                top: 17
            });
            layer.opacitySlider = opacitySlider;
            //larger layer preview - hover
            layer.thumb.onpointerover = (e)=>{
                if (e.buttons !== 0 && (!e.pointerType || e.pointerType !== 'touch')) //shouldn't show while dragging
                return;
                const thumbDimensions = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(layercanvas.width, layercanvas.height, 250, 250, 1, true);
                (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.largeThumbCanvas, thumbDimensions.width, thumbDimensions.height, {
                    ensureCleared: true
                });
                const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.largeThumbCanvas);
                ctx.save();
                if (this.largeThumbCanvas.width > layercanvas.width) ctx.imageSmoothingEnabled = false;
                ctx.imageSmoothingQuality = 'high';
                ctx.drawImage(layercanvas, 0, 0, this.largeThumbCanvas.width, this.largeThumbCanvas.height);
                ctx.restore();
                this.floatingLayerPreview.show(this.largeThumbCanvas, e.clientY);
            };
            // Won't fire when element is removed from DOM. To fix when rewriting layers-ui.
            layer.thumb.onpointerout = ()=>{
                this.floatingLayerPreview.hide();
            };
            container1.append(layer.thumb);
            if (clippingIcon) container1.append(clippingIcon);
            container1.append(layer.label, layer.opacityLabel, opacitySlider.getElement());
            let dragstart = false;
            let freshSelection = false;
            //events for moving layers up and down
            let isDragging = false;
            const dragEventHandler = (event)=>{
                if (event.type === 'pointerdown' && event.button === 'left' && !this.isManipulating) {
                    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(layer, {
                        transition: 'box-shadow 0.3s ease-in-out',
                        zIndex: 1
                    });
                    this.lastpos = layer.spot;
                    freshSelection = false;
                    if (!layer.isSelected) {
                        freshSelection = true;
                        this.activateLayer(layer.spot);
                    }
                    dragstart = true;
                    isDragging = true;
                    this.isManipulating = true;
                } else if (event.type === 'pointermove' && event.button === 'left' && isDragging) {
                    if (dragstart) {
                        dragstart = false;
                        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(layer, {
                            boxShadow: '1px 3px 5px rgba(0,0,0,0.4)'
                        });
                    }
                    layer.posY += event.dY;
                    const corrected = Math.max(0, Math.min((this.klCanvasLayerArr.length - 1) * 35, layer.posY));
                    layer.style.top = corrected + 'px';
                    this.updateLayersVerticalPosition(layer.spot, this.posToSpot(layer.posY));
                }
                if (event.type === 'pointerup' && isDragging) {
                    this.isManipulating = false;
                    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(layer, {
                        transition: 'all 0.1s linear'
                    });
                    setTimeout(()=>{
                        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(layer, {
                            boxShadow: ''
                        });
                    }, 20);
                    layer.posY = Math.max(0, Math.min((this.klCanvasLayerArr.length - 1) * 35, layer.posY));
                    layer.style.zIndex = '';
                    const newSpot = this.posToSpot(layer.posY);
                    const oldSpot = layer.spot;
                    this.move(layer.spot, newSpot);
                    if (oldSpot !== newSpot) this.onSelect(this.selectedSpotIndex, false);
                    if (oldSpot === newSpot && freshSelection) {
                        this.applyUncommitted();
                        this.onSelect(this.selectedSpotIndex, true);
                    }
                    freshSelection = false;
                }
            };
            layer.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                target: container1,
                onPointer: dragEventHandler,
                maxPointers: 1
            });
            this.layerListEl.append(layer);
        };
        this.layerElArr = [];
        while(this.layerListEl.firstChild){
            const child = this.layerListEl.firstChild;
            child.pointerListener.destroy();
            child.opacitySlider.destroy();
            child.remove();
        }
        for(let i = 0; i < this.klCanvasLayerArr.length; i++)createLayerEntry(i);
        this.activateLayer(this.selectedSpotIndex);
        this.updateHeight();
    }
    updateButtons() {
        const maxReached = this.klCanvasLayerArr.length === (0, $a919a1fb23b6c719$export$9f4f73b1bd7c2f26);
        const oneLayer = this.klCanvasLayerArr.length === 1;
        this.addBtn.disabled = maxReached;
        this.removeBtn.disabled = oneLayer;
        this.duplicateBtn.disabled = maxReached;
        this.mergeBtn.disabled = this.selectedSpotIndex === 0;
        this.moreDropdown.setEnabled('advanced-merge', !oneLayer);
        this.moreDropdown.setEnabled('merge-all', !oneLayer);
    }
    mergeLayer(mixModeStr) {
        const layerIndex = this.klCanvas.mergeLayer(this.selectedSpotIndex, mixModeStr);
        if (layerIndex === undefined) return;
        this.update(layerIndex);
        this.onSelect(layerIndex, false);
    }
    // ---- interface ----
    update(activeLayerSpotIndex) {
        this.klCanvasLayerArr = this.klCanvas.getLayers();
        if (activeLayerSpotIndex || activeLayerSpotIndex === 0) this.selectedSpotIndex = activeLayerSpotIndex;
        this.updateButtons();
        if (this.isVisible) this.createLayerList();
    }
    getSelected() {
        return this.selectedSpotIndex;
    }
    activateLayer(spotIndex) {
        if (spotIndex < 0 || spotIndex > this.layerElArr.length - 1) throw 'invalid spotIndex ' + spotIndex + ', layerElArr.length ' + this.layerElArr.length;
        this.selectedSpotIndex = spotIndex;
        this.modeSelect.setValue(this.klCanvasLayerArr[this.selectedSpotIndex].mixModeStr);
        this.clippingToggle.setValue(this.klCanvasLayerArr[this.selectedSpotIndex].hasClipping);
        for(let i = 0; i < this.layerElArr.length; i++){
            const layer = this.layerElArr[i];
            const isSelected = this.selectedSpotIndex === layer.spot;
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(layer, {
                boxShadow: ''
            });
            layer.classList.toggle('kl-layer--selected', isSelected);
            layer.opacitySlider.setActive(isSelected);
            layer.isSelected = isSelected;
        }
        this.mergeBtn.disabled = this.selectedSpotIndex === 0;
    }
    getElement() {
        return this.rootEl;
    }
    advancedMergeDialog() {
        this.applyUncommitted();
        if (this.selectedSpotIndex <= 0) return;
        (0, $1129d9e167be0b75$export$ee79aceabae6bb8a)(this.parentEl, {
            topCanvas: this.klCanvasLayerArr[this.selectedSpotIndex].context.canvas,
            bottomCanvas: this.klCanvasLayerArr[this.selectedSpotIndex - 1].context.canvas,
            topOpacity: this.klCanvas.getLayer(this.selectedSpotIndex).opacity,
            mixModeStr: this.klCanvasLayerArr[this.selectedSpotIndex].mixModeStr,
            callback: (mode)=>this.mergeLayer(mode)
        });
    }
    setIsVisible(b) {
        if (b === this.isVisible) return;
        this.isVisible = b;
        this.rootEl.style.display = b ? 'block' : 'none';
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isVisible = true;
        this.isManipulating = false;
        this.lastpos = 0;
        this.layerHeight = 35;
        this.layerSpacing = 0;
        this.klCanvas = p.klCanvas;
        this.onSelect = p.onSelect;
        this.parentEl = p.parentEl;
        this.floatingLayerPreview = p.floatingLayerPreview;
        this.applyUncommitted = p.applyUncommitted;
        this.klHistory = p.klHistory;
        this.onUpdateProject = p.onUpdateProject;
        this.onClearLayer = p.onClearLayer;
        this.layerElArr = [];
        this.layerHeight = 35;
        this.layerSpacing = 0;
        const width = 270;
        this.largeThumbCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas();
        this.klCanvasLayerArr = this.klCanvas.getLayers();
        this.selectedSpotIndex = this.klCanvasLayerArr.length - 1;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                marginRight: 10,
                marginBottom: 0,
                marginLeft: 10,
                marginTop: 10,
                cursor: 'default',
                position: 'relative',
                zIndex: 0
            }
        });
        const listDiv = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: width,
                position: 'relative',
                margin: '0 -10px',
                zIndex: 0
            }
        });
        this.layerListEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: listDiv
        });
        this.addBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button'
        });
        this.duplicateBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button'
        });
        this.mergeBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button'
        });
        this.removeBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button'
        });
        const renameBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button'
        });
        const iconSize = 20;
        this.clippingToggle = new (0, $0b383e4686740404$export$2358c75ad3c15b2d)({
            keepOriginalLabel: true,
            label: (()=>{
                const icon = (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('layer-clipping', {
                    width: iconSize,
                    height: iconSize
                });
                icon.classList.add($7b3d66f7b450f031$export$e1582ee498163d8b);
                return (0, $be957da3610487e9$export$921068d8846a1559).el({
                    content: icon,
                    className: $7b3d66f7b450f031$export$10cc39ba6eccc3a
                });
            })(),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('layers-clipping'),
            init: this.klCanvasLayerArr[this.selectedSpotIndex].hasClipping,
            onChange: (hasClipping)=>{
                this.klCanvas.setLayerHasClipping(this.selectedSpotIndex, hasClipping);
                this.update(this.selectedSpotIndex);
            }
        });
        this.moreDropdown = new (0, $717502b6f4cb5d24$export$e44a253a59704894)({
            button: (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('chevron-down', {
                    width: '13px'
                }),
                css: {
                    display: 'flex',
                    justifyContent: 'center',
                    opacity: '0.9'
                }
            }),
            buttonTitle: (0, $fc42a07754814920$export$ce37e184d908d785)('more'),
            items: [
                [
                    'clear-layer',
                    (0, $fc42a07754814920$export$ce37e184d908d785)('layers-clear'),
                    "\u232B"
                ],
                [
                    'advanced-merge',
                    (0, $fc42a07754814920$export$ce37e184d908d785)('layers-merge-advanced'),
                    'Ctrl + Shift + E'
                ],
                [
                    'merge-all',
                    (0, $fc42a07754814920$export$ce37e184d908d785)('layers-merge-all')
                ]
            ],
            onItemClick: (id)=>{
                if (id === 'clear-layer') this.onClearLayer();
                if (id === 'advanced-merge') this.advancedMergeDialog();
                if (id === 'merge-all') {
                    this.applyUncommitted();
                    const newIndex = this.klCanvas.mergeAll();
                    if (newIndex === false) return;
                    this.update(newIndex);
                    this.onSelect(newIndex, false);
                }
            }
        });
        this.updateButtons();
        const createButtons = ()=>{
            const div = (0, $be957da3610487e9$export$921068d8846a1559).el();
            const async = ()=>{
                this.addBtn.tabIndex = -1;
                this.duplicateBtn.tabIndex = -1;
                this.mergeBtn.tabIndex = -1;
                this.removeBtn.tabIndex = -1;
                renameBtn.tabIndex = -1;
                this.addBtn.title = (0, $fc42a07754814920$export$ce37e184d908d785)('layers-new');
                this.duplicateBtn.title = (0, $fc42a07754814920$export$ce37e184d908d785)('layers-duplicate');
                this.removeBtn.title = (0, $fc42a07754814920$export$ce37e184d908d785)('layers-remove');
                this.mergeBtn.title = (0, $fc42a07754814920$export$ce37e184d908d785)('layers-merge');
                renameBtn.title = (0, $fc42a07754814920$export$ce37e184d908d785)('layers-rename-title');
                this.addBtn.append((0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('add-layer', {
                    height: 20
                }));
                this.duplicateBtn.append((0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('duplicate-layer', {
                    height: 20
                }));
                this.mergeBtn.append((0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('merge-layers', {
                    height: 20
                }));
                this.removeBtn.append((0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('remove-layer', {
                    height: 20
                }));
                renameBtn.append((0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('rename-layer', {
                    height: 20
                }));
                div.append((0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,gap-5,mb-10', [
                    this.addBtn,
                    this.removeBtn,
                    this.duplicateBtn,
                    this.mergeBtn,
                    renameBtn,
                    this.clippingToggle.getElement(),
                    (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',grow-1'),
                    this.moreDropdown.getElement()
                ]));
                this.addBtn.onclick = ()=>{
                    this.applyUncommitted();
                    if (this.klCanvas.addLayer(this.selectedSpotIndex) === false) return;
                    this.klCanvasLayerArr = this.klCanvas.getLayers();
                    this.selectedSpotIndex = this.selectedSpotIndex + 1;
                    this.onSelect(this.selectedSpotIndex, false);
                    this.updateButtons();
                };
                this.duplicateBtn.onclick = ()=>{
                    this.applyUncommitted();
                    if (this.klCanvas.duplicateLayer(this.selectedSpotIndex) === false) return;
                    this.klCanvasLayerArr = this.klCanvas.getLayers();
                    this.selectedSpotIndex++;
                    this.onSelect(this.selectedSpotIndex, false);
                    this.updateButtons();
                };
                this.removeBtn.onclick = ()=>{
                    this.applyUncommitted();
                    if (this.layerElArr.length <= 1) return;
                    this.klCanvas.removeLayer(this.selectedSpotIndex);
                    if (this.selectedSpotIndex > 0) this.selectedSpotIndex--;
                    this.klCanvasLayerArr = this.klCanvas.getLayers();
                    this.onSelect(this.selectedSpotIndex, false);
                    this.updateButtons();
                };
                this.mergeBtn.onclick = ()=>{
                    this.applyUncommitted();
                    this.mergeLayer();
                };
                renameBtn.onclick = ()=>{
                    this.applyUncommitted();
                    this.renameLayer(this.selectedSpotIndex);
                };
            };
            setTimeout(async, 1);
            return div;
        };
        this.rootEl.append(createButtons());
        let modeWrapper;
        modeWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('layers-blending') + '&nbsp;',
            css: {
                fontSize: 15
            }
        });
        this.modeSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
            optionArr: [
                'source-over',
                undefined,
                'darken',
                'multiply',
                'color-burn',
                undefined,
                'lighten',
                'screen',
                'color-dodge',
                undefined,
                'overlay',
                'soft-light',
                'hard-light',
                undefined,
                'difference',
                'exclusion',
                undefined,
                'hue',
                'saturation',
                'color',
                'luminosity'
            ].map((item)=>{
                return item ? [
                    item,
                    (0, $2af5569ab072fe29$export$6e1bedb2a6cdff30)(item)
                ] : undefined;
            }),
            onChange: (val)=>{
                this.klCanvas.setMixMode(this.selectedSpotIndex, val);
                this.update(this.selectedSpotIndex);
            },
            css: {
                marginBottom: 10
            },
            name: 'layer-blend-mode'
        });
        modeWrapper.append(this.modeSelect.getElement());
        this.rootEl.append(modeWrapper);
        this.rootEl.append(listDiv);
        this.klHistory.addListener(()=>{
            if (this.rootEl.style.display !== 'block') return;
            this.createLayerList();
        });
        this.createLayerList();
    }
}





class $8960a416cd34201a$export$e258ade1648009b7 {
    getElement() {
        return this.canvas;
    }
    setLayers(layers) {
        this.layers = layers;
        this.render();
    }
    render() {
        if (!this.ctx) return;
        const ctx = this.ctx;
        ctx.save();
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.compositor.draw(ctx, this.layers, this.canvas.width, this.canvas.height, (target, layer)=>{
            if (this.canvas.width > layer.image.width) target.imageSmoothingEnabled = false;
            target.drawImage(layer.image, 0, 0, this.canvas.width, this.canvas.height);
        });
        ctx.restore();
    }
    destroy() {
        (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.canvas);
        this.compositor.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.compositor = new (0, $7db1a448998b9957$export$fca65d4bf5f27b48)();
        this.layers = p.layers;
        const scale = p.width / p.layers[0].image.width;
        const width = scale > 1 ? p.layers[0].image.width : p.width;
        const height = scale > 1 ? p.layers[0].image.height : p.height;
        this.canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(width, height);
        this.ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.canvas);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.canvas, {
            width: '100%',
            height: '100%',
            imageRendering: scale > 1 ? 'pixelated' : undefined,
            background: 'var(--kl-checkerboard-background)',
            backgroundSize: 16
        });
        setTimeout(()=>this.render(), 0);
    }
}



var $ad1446fb751cd9a3$exports = {};
$ad1446fb751cd9a3$exports = $parcel$resolve("fIoFC");



function $8c752cc1d7c845be$export$958c2bfe8d7142a9(transform) {
    transform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(transform);
    if (Math.abs(transform.angleDeg) % 90 !== 0) return transform;
    transform.width = Math.round(transform.width);
    transform.height = Math.round(transform.height);
    // 0° is original orientation.
    // At 90° and 270° width and height become swapped due to different orientation.
    const whSwapped = Math.abs(transform.angleDeg - 90) % 180 === 0;
    transform.x = (whSwapped ? transform.height : transform.width) % 2 === 0 ? Math.round(transform.x) : Math.round(transform.x - 0.5) + 0.5;
    transform.y = (whSwapped ? transform.width : transform.height) % 2 === 0 ? Math.round(transform.y) : Math.round(transform.y - 0.5) + 0.5;
    return transform;
}
function $8c752cc1d7c845be$export$6a4549ec4168874a(x, y, transform) {
    let px, py;
    px = x - transform.x;
    py = y - transform.y;
    const rot = (0, $be957da3610487e9$export$921068d8846a1559).rotateAround({
        x: 0,
        y: 0
    }, {
        x: px,
        y: py
    }, -transform.angleDeg);
    px = rot.x;
    py = rot.y;
    return {
        x: px,
        y: py
    };
}
function $8c752cc1d7c845be$export$3fba3b383c654cc6(x, y, transform) {
    const rot = (0, $be957da3610487e9$export$921068d8846a1559).rotateAround({
        x: 0,
        y: 0
    }, {
        x: x,
        y: y
    }, transform.angleDeg);
    return {
        x: rot.x + transform.x,
        y: rot.y + transform.y
    };
}






const $93e6a53ec76e8c56$var$gripSize = 16;
const $93e6a53ec76e8c56$var$edgeSize = 10;
function $93e6a53ec76e8c56$var$isOnlyShiftPressed(event) {
    return event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey;
}
// 0 - east
function $93e6a53ec76e8c56$var$angleDegToCursor(angleDeg) {
    const cursors = [
        'e',
        'ne',
        'n',
        'nw',
        'w',
        'sw',
        's',
        'se'
    ];
    while(angleDeg < 0)angleDeg += 360;
    const index = Math.round(angleDeg / 45) % cursors.length;
    return cursors[index] + '-resize';
}
class $93e6a53ec76e8c56$export$79a74567acf241b0 {
    // counterclockwise angle in canvas space -> counterclockwise angle in viewport space
    toViewportAngleDeg(angleDeg) {
        return (this.viewportTransform.isMirrored ? 180 - angleDeg : angleDeg) - this.viewportTransform.angleDeg;
    }
    updateScaled() {
        const viewportMatrix = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.viewportTransform);
        const centerInViewport = (0, $43e83319b765a157$export$9b20165a36586806)(viewportMatrix, {
            x: this.value.x,
            y: this.value.y
        });
        this.rectInViewport.x = centerInViewport.x;
        this.rectInViewport.y = centerInViewport.y;
        this.rectInViewport.width = this.value.width * this.viewportTransform.scale;
        this.rectInViewport.height = this.value.height * this.viewportTransform.scale;
        this.rectInViewport.corners = this.corners.map((item)=>{
            return {
                x: item.x * this.viewportTransform.scale,
                y: item.y * this.viewportTransform.scale
            };
        });
    }
    /**
     * Returns snapped point, if ix, iy snaps. If no snapping, returns point unchanged.
     * both in image space
     *
     * @param iX - image space
     * @param iY - image space
     * @private
     */ snapCorner(iX, iY) {
        if (!this.snappingEnabled) return {
            x: iX,
            y: iY
        };
        let dist;
        const snap = {
            x: undefined,
            y: undefined,
            dist: {
                x: undefined,
                y: undefined
            }
        };
        for(let e = 0; e < this.snapX.length; e++){
            dist = Math.abs(iX - this.snapX[e]);
            if (dist < this.minSnapDist / this.viewportTransform.scale) {
                if (snap.x === undefined || dist < snap.dist.x) {
                    snap.x = this.snapX[e];
                    snap.dist.x = dist;
                }
            }
        }
        for(let e = 0; e < this.snapY.length; e++){
            dist = Math.abs(iY - this.snapY[e]);
            if (dist < this.minSnapDist / this.viewportTransform.scale) {
                if (snap.y === undefined || dist < snap.dist.y) {
                    snap.y = this.snapY[e];
                    snap.dist.y = dist;
                }
            }
        }
        if (snap.x === undefined && snap.y === undefined) return {
            x: iX,
            y: iY
        };
        return {
            x: snap.x ?? iX,
            y: snap.y ?? iY
        };
    }
    /**
     * If constrained return nearest corner pos that fits aspect ratio
     *
     * @param cornerIndex
     * @param iX
     * @param iY
     * @private
     */ constrainCorner(cornerIndex, iX, iY) {
        if (!this.isConstrained) return {
            x: iX,
            y: iY
        };
        const flip = this.value.width * this.value.height < 0 ? -1 : 1;
        return (0, $be957da3610487e9$export$921068d8846a1559).projectPointOnLine({
            x: this.value.x,
            y: this.value.y
        }, (0, $8c752cc1d7c845be$export$3fba3b383c654cc6)(this.ratio, flip * ([
            0,
            2
        ].includes(cornerIndex) ? 1 : -1), this.value), {
            x: iX,
            y: iY
        });
    }
    /**
     * Update corners according to width height.
     * Not their DOM.
     */ updateCornerPositions() {
        this.corners[0].x = -this.value.width / 2; // top left
        this.corners[0].y = -this.value.height / 2;
        this.corners[1].x = this.value.width / 2; // top right
        this.corners[1].y = -this.value.height / 2;
        this.corners[2].x = this.value.width / 2; // bottom right
        this.corners[2].y = this.value.height / 2;
        this.corners[3].x = -this.value.width / 2; // bottom left
        this.corners[3].y = this.value.height / 2;
    }
    /**
     * If constrained and dragging an edge, restore aspect ratio
     * Updates corner positions.
     *
     * @param widthChanged
     * @param heightChanged
     * @private
     */ restoreRatio(widthChanged, heightChanged) {
        if (!this.isConstrained) return;
        const angle90 = Math.abs(this.value.angleDeg) % 90 === 0;
        const whSwapped = Math.abs(this.value.angleDeg - 90) % 180 === 0;
        if (heightChanged && !widthChanged) {
            const newHeight = Math.abs(this.corners[3].y - this.corners[0].y);
            let newWidth = this.ratio * newHeight;
            if (angle90) newWidth = (whSwapped ? this.value.y % 1 : this.value.x % 1) === 0 ? (0, $be957da3610487e9$export$921068d8846a1559).roundEven(newWidth) : (0, $be957da3610487e9$export$921068d8846a1559).roundUneven(newWidth);
            if (this.corners[1].x - this.corners[0].x < 0) newWidth *= -1;
            this.corners[0].x = -newWidth / 2;
            this.corners[3].x = -newWidth / 2;
            this.corners[1].x = newWidth / 2;
            this.corners[2].x = newWidth / 2;
        }
        if (!heightChanged && widthChanged) {
            const newWidth = Math.abs(this.corners[0].x - this.corners[1].x);
            let newHeight = newWidth / this.ratio;
            if (angle90) newHeight = (whSwapped ? this.value.x % 1 : this.value.y % 1) === 0 ? (0, $be957da3610487e9$export$921068d8846a1559).roundEven(newHeight) : (0, $be957da3610487e9$export$921068d8846a1559).roundUneven(newHeight);
            if (this.corners[3].y - this.corners[0].y < 0) newHeight *= -1;
            this.corners[0].y = -newHeight / 2;
            this.corners[1].y = -newHeight / 2;
            this.corners[2].y = newHeight / 2;
            this.corners[3].y = newHeight / 2;
        }
    }
    /**
     * update transform based on corners
     * @private
     */ updateTransformViaCorners() {
        // calc transform center in image space
        const rot = (0, $be957da3610487e9$export$921068d8846a1559).rotateAround({
            x: 0,
            y: 0
        }, {
            x: (this.corners[0].x + this.corners[1].x) / 2,
            y: (this.corners[0].y + this.corners[3].y) / 2
        }, this.value.angleDeg);
        this.value.x = rot.x + this.value.x;
        this.value.y = rot.y + this.value.y;
        // update size
        this.value.width = this.corners[1].x - this.corners[0].x;
        this.value.height = this.corners[3].y - this.corners[0].y;
        // new center means corners changed their position
        this.updateCornerPositions();
        this.updateDOM();
    }
    /**
     * updates DOM according to transform
     * @param skipCallback
     */ updateDOM(skipCallback) {
        this.updateScaled();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.transEl, {
            left: this.rectInViewport.x,
            top: this.rectInViewport.y,
            transformOrigin: '0 0',
            transform: `rotate(${this.viewportTransform.angleDeg}deg) scaleX(${this.viewportTransform.isMirrored ? -1 : 1}) rotate(${this.value.angleDeg}deg)`
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.boundsEl, {
            width: Math.abs(this.rectInViewport.width),
            height: Math.abs(this.rectInViewport.height),
            left: Math.min(this.rectInViewport.corners[0].x, this.rectInViewport.corners[1].x),
            top: Math.min(this.rectInViewport.corners[0].y, this.rectInViewport.corners[3].y)
        });
        this.corners[0].updateDOM();
        this.corners[1].updateDOM();
        this.corners[2].updateDOM();
        this.corners[3].updateDOM();
        this.edges[0].updateDOM();
        this.edges[1].updateDOM();
        this.edges[2].updateDOM();
        this.edges[3].updateDOM();
        this.angleGrip.x = 0;
        this.angleGrip.y = -Math.abs(this.value.height * this.viewportTransform.scale) / 2 - 20;
        this.angleGrip.updateDOM();
        if (!skipCallback) {
            if (this.callback) // why should updateDOM trigger the callback?
            this.callback({
                ...this.value
            });
        }
    }
    getValue() {
        return {
            ...this.value
        };
    }
    setIsConstrained(b) {
        this.isConstrained = b;
        if (b && this.value.width !== 0 && this.value.height !== 0) this.ratio = Math.abs(this.value.width / this.value.height);
    }
    setSnapping(b) {
        this.snappingEnabled = b;
    }
    setSnappingPoints(snapX, snapY) {
        this.snapX = snapX;
        this.snapY = snapY;
    }
    setPos(p) {
        this.value.x = p.x;
        this.value.y = p.y;
        this.updateDOM(true);
    }
    move(dX, dY) {
        this.value.x += dX;
        this.value.y += dY;
        this.updateDOM(false);
    }
    setSize(w, h) {
        this.value.width = w;
        this.value.height = h;
        if (Math.abs(this.value.angleDeg) % 90 === 0) this.value = (0, $8c752cc1d7c845be$export$958c2bfe8d7142a9)(this.value);
        this.updateCornerPositions();
        this.updateDOM(false);
    }
    initialise(transform) {
        this.value.x = transform.x;
        this.value.y = transform.y;
        this.value.width = transform.width;
        this.value.height = transform.height;
        this.value.angleDeg = transform.angleDeg;
        this.ratio = Math.abs(transform.width / transform.height);
        this.updateCornerPositions();
        this.updateDOM(true);
    }
    setAngleDeg(a) {
        this.value.angleDeg = a;
        if (Math.abs(this.value.angleDeg) % 90 === 0) {
            this.value = (0, $8c752cc1d7c845be$export$958c2bfe8d7142a9)(this.value);
            this.updateCornerPositions();
        }
        this.updateDOM(true);
    }
    setViewportTransform(transform) {
        this.viewportTransform = {
            ...transform
        };
        this.updateScaled();
        // skip callback because viewport change does not affect the value
        this.updateDOM(true);
    }
    getElement() {
        return this.rootEl;
    }
    getRatio() {
        return this.ratio;
    }
    destroy() {
        this.boundsPointerListener.destroy();
        this.corners.forEach((item)=>item.pointerListener.destroy());
        this.edges.forEach((item)=>item.pointerListener.destroy());
        this.anglePointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rectInViewport = {
            // x and y in center of rect
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            // relative to center of rect. without rotation.
            corners: [
                {
                    x: 0,
                    y: 0
                }
            ]
        };
        this.minSnapDist = 7 // minimal snapping distance in px viewport space
        ;
        this.corners = [];
        this.edges = [];
        this.viewportTransform = {
            ...p.viewportTransform
        };
        this.value = {
            // coordinates and dimensions of transformation
            x: p.x,
            y: p.y,
            width: p.width,
            height: p.height,
            angleDeg: p.angleDeg
        };
        this.isConstrained = p.isConstrained;
        this.snapX = p.snapX;
        this.snapY = p.snapY;
        this.callback = p.callback;
        this.snappingEnabled = true;
        this.ratio = this.value.width / this.value.height;
        const onWheel = p.onWheel ? (e)=>{
            if (!p.onWheel || !p.wheelParent) return;
            const parentRect = p.wheelParent.getBoundingClientRect();
            e.relX = e.pageX - parentRect.left;
            e.relY = e.pageY - parentRect.top;
            p.onWheel(e);
        } : undefined;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-free-transform',
            css: {
                userSelect: 'none'
            }
        });
        this.transEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                position: 'absolute'
            }
        });
        this.boundsEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                cursor: 'move',
                boxShadow: 'rgba(255, 255, 255, 0.5) 0 0 0 1px inset, rgba(0, 0, 0, 0.5) 0 0 0 1px'
            }
        });
        const pointerRemainder = {
            x: 0,
            y: 0
        };
        function resetRemainder() {
            pointerRemainder.x = 0;
            pointerRemainder.y = 0;
        }
        let boundsStartP = {
            x: 0,
            y: 0
        };
        this.boundsPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.boundsEl,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointerdown') boundsStartP = {
                    x: this.value.x,
                    y: this.value.y
                };
                if (event.type === 'pointermove' && event.button === 'left') {
                    const viewportMatrix = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.viewportTransform);
                    const originInCanvas = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(viewportMatrix), {
                        x: event.downPageX,
                        y: event.downPageY
                    });
                    const deltaInCanvas = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(viewportMatrix), {
                        x: event.pageX,
                        y: event.pageY
                    });
                    const delta = {
                        x: deltaInCanvas.x - originInCanvas.x,
                        y: deltaInCanvas.y - originInCanvas.y
                    };
                    this.value.x = boundsStartP.x + delta.x;
                    this.value.y = boundsStartP.y + delta.y;
                    let dist;
                    let snap = {
                        distX: -1,
                        distY: -1
                    };
                    if (this.snappingEnabled) {
                        let i;
                        for(i = 0; i < this.snapX.length; i++){
                            dist = Math.abs(this.value.x - this.snapX[i]);
                            if (dist < this.minSnapDist / this.viewportTransform.scale) {
                                if (snap.x === undefined || dist < snap.distX) {
                                    snap.x = this.snapX[i];
                                    snap.distX = dist;
                                }
                            }
                        }
                        for(i = 0; i < this.snapY.length; i++){
                            dist = Math.abs(this.value.y - this.snapY[i]);
                            if (dist < this.minSnapDist / this.viewportTransform.scale) {
                                if (snap.y === undefined || dist < snap.distY) {
                                    snap.y = this.snapY[i];
                                    snap.distY = dist;
                                }
                            }
                        }
                        let iP;
                        for(i = 0; i < 4; i++){
                            iP = (0, $8c752cc1d7c845be$export$3fba3b383c654cc6)(this.corners[i].x, this.corners[i].y, this.value);
                            let j;
                            for(j = 0; j < this.snapX.length; j++){
                                dist = Math.abs(iP.x - this.snapX[j]);
                                if (dist < this.minSnapDist / this.viewportTransform.scale) {
                                    if (snap.x === undefined || dist < snap.distX) {
                                        snap.x = this.snapX[j] - (iP.x - this.value.x);
                                        snap.distX = dist;
                                    }
                                }
                            }
                            for(j = 0; j < this.snapY.length; j++){
                                dist = Math.abs(iP.y - this.snapY[j]);
                                if (dist < this.minSnapDist / this.viewportTransform.scale) {
                                    if (snap.y === undefined || dist < snap.distY) {
                                        snap.y = this.snapY[j] - (iP.y - this.value.y);
                                        snap.distY = dist;
                                    }
                                }
                            }
                        }
                    }
                    if ($93e6a53ec76e8c56$var$isOnlyShiftPressed(event)) {
                        let projected = (0, $be957da3610487e9$export$921068d8846a1559).projectPointOnLine({
                            x: 0,
                            y: boundsStartP.y
                        }, {
                            x: 10,
                            y: boundsStartP.y
                        }, {
                            x: this.value.x,
                            y: this.value.y
                        });
                        let dist = (0, $be957da3610487e9$export$921068d8846a1559).dist(projected.x, projected.y, this.value.x, this.value.y);
                        snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist,
                            distY: dist
                        };
                        projected = (0, $be957da3610487e9$export$921068d8846a1559).projectPointOnLine({
                            x: boundsStartP.x,
                            y: 0
                        }, {
                            x: boundsStartP.x,
                            y: 10
                        }, {
                            x: this.value.x,
                            y: this.value.y
                        });
                        dist = (0, $be957da3610487e9$export$921068d8846a1559).dist(projected.x, projected.y, this.value.x, this.value.y);
                        if (dist < snap.distX) snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist,
                            distY: dist
                        };
                        projected = (0, $be957da3610487e9$export$921068d8846a1559).projectPointOnLine({
                            x: boundsStartP.x,
                            y: boundsStartP.y
                        }, {
                            x: boundsStartP.x + 1,
                            y: boundsStartP.y + 1
                        }, {
                            x: this.value.x,
                            y: this.value.y
                        });
                        dist = (0, $be957da3610487e9$export$921068d8846a1559).dist(projected.x, projected.y, this.value.x, this.value.y);
                        if (dist < snap.distX) snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist,
                            distY: dist
                        };
                        projected = (0, $be957da3610487e9$export$921068d8846a1559).projectPointOnLine({
                            x: boundsStartP.x,
                            y: boundsStartP.y
                        }, {
                            x: boundsStartP.x + 1,
                            y: boundsStartP.y - 1
                        }, {
                            x: this.value.x,
                            y: this.value.y
                        });
                        dist = (0, $be957da3610487e9$export$921068d8846a1559).dist(projected.x, projected.y, this.value.x, this.value.y);
                        if (dist < snap.distX) snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist,
                            distY: dist
                        };
                    }
                    if (snap.x !== undefined) this.value.x = snap.x;
                    if (snap.y !== undefined) this.value.y = snap.y;
                    // snap to pixels
                    if (Math.abs(this.value.angleDeg) % 90 === 0) {
                        this.value = (0, $8c752cc1d7c845be$export$958c2bfe8d7142a9)(this.value);
                        this.updateCornerPositions();
                    }
                    this.updateDOM();
                }
            },
            useDirtyWheel: true,
            onWheel: onWheel
        });
        for(let i = 0; i < 4; i++)((i)=>{
            const g = this.corners[i] = {
                i: i,
                el: (0, $be957da3610487e9$export$921068d8846a1559).el({
                    css: {
                        width: $93e6a53ec76e8c56$var$gripSize,
                        height: $93e6a53ec76e8c56$var$gripSize,
                        background: '#fff',
                        /*background: [
                                '#ff0000',
                                '#00ff00',
                                '#0000ff',
                                '#ff00ff',
                            ][i],*/ borderRadius: $93e6a53ec76e8c56$var$gripSize,
                        position: 'absolute',
                        border: '2px solid #000'
                    }
                }),
                x: 0,
                y: 0,
                virtualPos: {
                    x: 0,
                    y: 0
                }
            };
            g.updateDOM = ()=>{
                // grip position
                // if it gets small: slightly offset grips, so easier to handle
                const offsetArr = [
                    [
                        -1,
                        -1
                    ],
                    [
                        1,
                        -1
                    ],
                    [
                        1,
                        1
                    ],
                    [
                        -1,
                        1
                    ]
                ].map((item)=>{
                    item[0] *= this.value.width > 0 ? 1 : -1;
                    item[1] *= this.value.height > 0 ? 1 : -1;
                    return item;
                });
                const tinyOffset = Math.abs(this.rectInViewport.width) < 20 || Math.abs(this.rectInViewport.height) < 20 ? 10 : 0;
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(g.el, {
                    left: this.rectInViewport.corners[g.i].x - $93e6a53ec76e8c56$var$gripSize / 2 + offsetArr[i][0] * tinyOffset,
                    top: this.rectInViewport.corners[g.i].y - $93e6a53ec76e8c56$var$gripSize / 2 + offsetArr[i][1] * tinyOffset
                });
                // cursor
                const xMult = this.value.width < 0 ? -1 : 1;
                const yMult = this.value.height < 0 ? -1 : 1;
                const cornerVectors = [
                    {
                        x: -1,
                        y: -1
                    },
                    {
                        x: 1,
                        y: -1
                    },
                    {
                        x: 1,
                        y: 1
                    },
                    {
                        x: -1,
                        y: 1
                    }
                ];
                const cornerVector = {
                    x: cornerVectors[i].x * xMult,
                    y: cornerVectors[i].y * yMult * -1
                };
                const angleDeg = this.toViewportAngleDeg((0, $4c2c6808296c0d73$export$c03a8450eabc2532)({
                    x: 0,
                    y: 0
                }, cornerVector) - this.value.angleDeg);
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(g.el, {
                    cursor: $93e6a53ec76e8c56$var$angleDegToCursor(angleDeg)
                });
            };
            g.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                target: this.corners[i].el,
                fixScribble: true,
                onPointer: (event)=>{
                    event.eventPreventDefault();
                    if (event.type === 'pointerdown' && event.button === 'left') this.corners[i].virtualPos = (0, $8c752cc1d7c845be$export$3fba3b383c654cc6)(this.corners[i].x, this.corners[i].y, this.value);
                    else if (event.type === 'pointermove' && event.button === 'left') {
                        const viewportMatrix = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.viewportTransform);
                        const originInCanvas = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(viewportMatrix), {
                            x: 0,
                            y: 0
                        });
                        const deltaInCanvas = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(viewportMatrix), {
                            x: event.dX,
                            y: event.dY
                        });
                        const delta = {
                            x: deltaInCanvas.x - originInCanvas.x,
                            y: deltaInCanvas.y - originInCanvas.y
                        };
                        this.corners[i].virtualPos.x += delta.x;
                        this.corners[i].virtualPos.y += delta.y;
                        let iP = {
                            x: this.corners[i].virtualPos.x,
                            y: this.corners[i].virtualPos.y
                        };
                        iP = this.constrainCorner(i, iP.x, iP.y);
                        if (!this.isConstrained) iP = this.snapCorner(iP.x, iP.y);
                        if (Math.abs(this.value.angleDeg) % 90 === 0) {
                            iP.x = Math.round(iP.x);
                            iP.y = Math.round(iP.y);
                        }
                        const tP = (0, $8c752cc1d7c845be$export$6a4549ec4168874a)(iP.x, iP.y, this.value);
                        const dX = tP.x - this.corners[i].x;
                        const dY = tP.y - this.corners[i].y;
                        this.corners[i].x = tP.x;
                        this.corners[i].y = tP.y;
                        let indexes = [];
                        if (i === 0) // top left
                        indexes = [
                            3,
                            1,
                            2
                        ];
                        else if (i === 1) // top right
                        indexes = [
                            2,
                            0,
                            3
                        ];
                        else if (i === 2) // bottom right
                        indexes = [
                            1,
                            3,
                            0
                        ];
                        else if (i === 3) // bottom left
                        indexes = [
                            0,
                            2,
                            1
                        ];
                        this.corners[indexes[0]].x = this.corners[i].x;
                        this.corners[indexes[1]].y = this.corners[i].y;
                        if (event.shiftKey) {
                            this.corners[indexes[2]].x -= dX;
                            this.corners[indexes[2]].y -= dY;
                            this.corners[indexes[1]].x = this.corners[indexes[2]].x;
                            this.corners[indexes[0]].y = this.corners[indexes[2]].y;
                        }
                        this.updateTransformViaCorners();
                    }
                },
                useDirtyWheel: true,
                onWheel: onWheel
            });
        })(i);
        this.updateCornerPositions();
        this.updateScaled();
        let isInverted;
        for(let i = 0; i < 4; i++)((i)=>{
            this.edges[i] = {
                el: (0, $be957da3610487e9$export$921068d8846a1559).el({
                    css: {
                        width: $93e6a53ec76e8c56$var$edgeSize,
                        height: $93e6a53ec76e8c56$var$edgeSize,
                        //background: ['red', 'green', 'blue', 'orange'][i],
                        position: 'absolute'
                    }
                })
            };
            const g = this.edges[i];
            g.updateDOM = ()=>{
                if (i === 0) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(g.el, {
                    left: Math.min(this.rectInViewport.corners[0].x, this.rectInViewport.corners[1].x),
                    top: Math.min(this.rectInViewport.corners[0].y, this.rectInViewport.corners[3].y) - $93e6a53ec76e8c56$var$edgeSize,
                    width: Math.abs(this.rectInViewport.width),
                    height: $93e6a53ec76e8c56$var$edgeSize
                });
                else if (i === 1) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(g.el, {
                    left: Math.max(this.rectInViewport.corners[0].x, this.rectInViewport.corners[1].x),
                    top: Math.min(this.rectInViewport.corners[1].y, this.rectInViewport.corners[2].y),
                    width: $93e6a53ec76e8c56$var$edgeSize,
                    height: Math.abs(this.rectInViewport.height)
                });
                else if (i === 2) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(g.el, {
                    left: Math.min(this.rectInViewport.corners[3].x, this.rectInViewport.corners[2].x),
                    top: Math.max(this.rectInViewport.corners[0].y, this.rectInViewport.corners[3].y),
                    width: Math.abs(this.rectInViewport.width),
                    height: $93e6a53ec76e8c56$var$edgeSize
                });
                else if (i === 3) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(g.el, {
                    left: Math.min(this.rectInViewport.corners[0].x, this.rectInViewport.corners[1].x) - $93e6a53ec76e8c56$var$edgeSize,
                    top: Math.min(this.rectInViewport.corners[0].y, this.rectInViewport.corners[3].y),
                    width: $93e6a53ec76e8c56$var$edgeSize,
                    height: Math.abs(this.rectInViewport.height)
                });
                const xFlipped = this.value.width < 0;
                const yFlipped = this.value.height < 0;
                const angles = [
                    yFlipped ? -90 : 90,
                    xFlipped ? 180 : 0,
                    yFlipped ? 90 : -90,
                    xFlipped ? 0 : 180
                ];
                const angleDeg = this.toViewportAngleDeg(angles[i] - this.value.angleDeg);
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(g.el, {
                    cursor: $93e6a53ec76e8c56$var$angleDegToCursor(angleDeg)
                });
            };
            const isVertical = [
                0,
                2
            ].includes(i);
            g.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                target: this.edges[i].el,
                fixScribble: true,
                onPointer: (event)=>{
                    event.eventPreventDefault();
                    if (event.type === 'pointerdown' && event.button === 'left') {
                        if (isVertical) // top bottom
                        isInverted = this.corners[0].y >= this.corners[3].y;
                        else // left right
                        isInverted = this.corners[0].x >= this.corners[1].x;
                        resetRemainder();
                    }
                    if (event.type === 'pointermove' && event.button === 'left') {
                        const viewportMatrix = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.viewportTransform);
                        const originInCanvas = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(viewportMatrix), {
                            x: 0,
                            y: 0
                        });
                        const deltaInCanvas = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(viewportMatrix), {
                            x: event.dX,
                            y: event.dY
                        });
                        const originInTransform = (0, $8c752cc1d7c845be$export$6a4549ec4168874a)(originInCanvas.x, originInCanvas.y, this.value);
                        const deltaInTransform = (0, $8c752cc1d7c845be$export$6a4549ec4168874a)(deltaInCanvas.x, deltaInCanvas.y, this.value);
                        const tfD = {
                            x: deltaInTransform.x - originInTransform.x,
                            y: deltaInTransform.y - originInTransform.y
                        };
                        let ti = {
                            dX: tfD.x,
                            dY: tfD.y
                        };
                        if (Math.abs(this.value.angleDeg) % 90 === 0) ti = (0, $be957da3610487e9$export$921068d8846a1559).intDxy(pointerRemainder, tfD.x, tfD.y);
                        let indexes = [];
                        if (i === 0) // top
                        indexes = [
                            2,
                            3,
                            0,
                            1
                        ];
                        else if (i === 1) // right
                        indexes = [
                            0,
                            3,
                            1,
                            2
                        ];
                        else if (i === 2) // bottom
                        indexes = [
                            0,
                            1,
                            2,
                            3
                        ];
                        else if (i === 3) // left
                        indexes = [
                            1,
                            2,
                            0,
                            3
                        ];
                        const dimension = isVertical ? 'y' : 'x';
                        const d = isVertical ? ti.dY : ti.dX;
                        if (isInverted) {
                            this.corners[indexes[0]][dimension] += d;
                            this.corners[indexes[1]][dimension] += d;
                        } else {
                            this.corners[indexes[2]][dimension] += d;
                            this.corners[indexes[3]][dimension] += d;
                        }
                        if (event.shiftKey) {
                            if (isInverted) {
                                this.corners[indexes[2]][dimension] -= d;
                                this.corners[indexes[3]][dimension] -= d;
                            } else {
                                this.corners[indexes[0]][dimension] -= d;
                                this.corners[indexes[1]][dimension] -= d;
                            }
                        }
                        if (isVertical) // top bottom
                        this.restoreRatio(false, true);
                        else // left right
                        this.restoreRatio(true, false);
                        this.updateTransformViaCorners();
                    }
                },
                useDirtyWheel: true,
                onWheel: onWheel
            });
        })(i);
        this.angleGrip = {
            el: (0, $be957da3610487e9$export$921068d8846a1559).el({
                css: {
                    cursor: 'url(' + (0, (/*@__PURE__*/$parcel$interopDefault($ad1446fb751cd9a3$exports))) + ') 10 10, move',
                    width: $93e6a53ec76e8c56$var$gripSize,
                    height: $93e6a53ec76e8c56$var$gripSize,
                    background: '#0ff',
                    borderRadius: $93e6a53ec76e8c56$var$gripSize,
                    position: 'absolute',
                    boxShadow: 'inset 0 0 0 2px #000'
                }
            }),
            x: 0,
            y: 0,
            snap: false,
            updateDOM: ()=>{
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.angleGrip.el, {
                    left: this.angleGrip.x - $93e6a53ec76e8c56$var$gripSize / 2,
                    top: this.angleGrip.y - $93e6a53ec76e8c56$var$gripSize / 2
                });
            }
        };
        (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.angleGrip.el,
            css: {
                width: 2,
                height: 13,
                left: $93e6a53ec76e8c56$var$gripSize / 2 - 1,
                top: $93e6a53ec76e8c56$var$gripSize,
                background: '#0ff',
                position: 'absolute'
            }
        });
        this.anglePointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.angleGrip.el,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    const viewportMatrix = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.viewportTransform);
                    const rootBoundingClientRect = this.rootEl.getBoundingClientRect();
                    const cursorInViewportPosition = {
                        x: event.clientX - rootBoundingClientRect.left,
                        y: event.clientY - rootBoundingClientRect.top
                    };
                    const cursorInCanvasPosition = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(viewportMatrix), cursorInViewportPosition);
                    const a = (0, $be957da3610487e9$export$921068d8846a1559).pointsToAngleDeg({
                        x: this.value.x,
                        y: this.value.y
                    }, cursorInCanvasPosition) + 90;
                    this.value.angleDeg = a;
                    const snapDeg = Math.round(a / 360 * 8) * 45;
                    if ($93e6a53ec76e8c56$var$isOnlyShiftPressed(event)) this.value.angleDeg = snapDeg;
                    else if (this.snappingEnabled && Math.abs(snapDeg - a) < 8) this.value.angleDeg = snapDeg;
                    this.updateDOM();
                }
                if (event.type === 'pointerup') {
                    if (Math.abs(this.value.angleDeg) % 90 === 0) {
                        this.value = (0, $8c752cc1d7c845be$export$958c2bfe8d7142a9)(this.value);
                        this.updateCornerPositions();
                        this.updateDOM();
                    }
                }
            },
            useDirtyWheel: true,
            onWheel: onWheel
        });
        this.value = (0, $8c752cc1d7c845be$export$958c2bfe8d7142a9)(this.value);
        this.updateDOM(true);
        (0, $be957da3610487e9$export$921068d8846a1559).append(this.transEl, [
            this.boundsEl,
            this.edges[0].el,
            this.edges[1].el,
            this.edges[2].el,
            this.edges[3].el,
            this.corners[0].el,
            this.corners[1].el,
            this.corners[2].el,
            this.corners[3].el,
            this.angleGrip.el
        ]);
    }
}






class $6f7fb59adaa892d0$export$205c2dd29f8a66b5 {
    updatePreview() {
        const transform = this.freeTransform.getValue();
        const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.previewCanvas);
        ctx.save();
        ctx.clearRect(0, 0, this.previewCanvas.width, this.previewCanvas.height);
        (0, $be957da3610487e9$export$921068d8846a1559).drawTransformedImageWithBounds(ctx, this.layers[this.transformIndex].image, transform, undefined, this.algorithm === 'pixelated' || (0, $be957da3610487e9$export$921068d8846a1559).testShouldPixelate(transform, transform.width / this.initTransform.width, transform.height / this.initTransform.height));
        ctx.restore();
        this.preview.render();
    }
    // ---- interface ----
    move(dX, dY) {
        this.freeTransform.move(dX, dY);
    }
    reset() {
        const w = this.layers[this.transformIndex].image.width;
        const h = this.layers[this.transformIndex].image.height;
        this.freeTransform.setSize(w, h);
        this.freeTransform.setPos({
            x: w / 2,
            y: h / 2
        });
        this.freeTransform.setAngleDeg(0);
        this.updatePreview();
    }
    setTransformFit() {
        const fit = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(this.layers[this.transformIndex].image.width, this.layers[this.transformIndex].image.height, this.imageWidth, this.imageHeight, 1);
        this.freeTransform.setSize(fit.width, fit.height);
        this.freeTransform.setPos({
            x: fit.width / 2,
            y: fit.height / 2
        });
        this.freeTransform.setAngleDeg(0);
        this.updatePreview();
    }
    setTransformCenter() {
        this.freeTransform.setPos({
            x: this.imageWidth / 2,
            y: this.imageHeight / 2
        });
        this.freeTransform.setAngleDeg(0);
        this.updatePreview();
    }
    setAlgorithm(algo) {
        this.algorithm = algo;
        this.updatePreview();
    }
    /**
     * gives you the transformation in the original scale
     */ getTransformation() {
        return this.freeTransform.getValue();
    }
    getIsPixelated() {
        const transform = this.freeTransform.getValue();
        return this.algorithm === 'pixelated' || (0, $be957da3610487e9$export$921068d8846a1559).testShouldPixelate(transform, transform.width / this.initTransform.width, transform.height / this.initTransform.height);
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.freeTransform.destroy();
        this.preview.destroy();
        (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.previewCanvas);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.algorithm = 'smooth';
        this.imageWidth = p.imageWidth;
        this.imageHeight = p.imageHeight;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper',
            css: {
                width: p.elementWidth,
                height: p.elementHeight
            }
        });
        this.rootEl.oncontextmenu = ()=>{
            return false;
        };
        this.layers = p.layers;
        this.transformIndex = p.transformIndex;
        this.previewLayerArr = this.layers.map((item)=>{
            return {
                image: item.image,
                isVisible: item.isVisible,
                mixModeStr: item.mixModeStr,
                opacity: item.opacity,
                hasClipping: item.hasClipping
            };
        });
        this.previewCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.imageWidth, this.imageHeight);
        this.previewLayerArr.at(-1).image = this.previewCanvas;
        this.preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: p.elementWidth,
            height: p.elementHeight,
            project: {
                width: p.imageWidth,
                height: p.imageHeight,
                layers: this.previewLayerArr
            },
            hasEditMode: true,
            onModeChange: (m)=>{
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.freeTransform.getElement(), {
                    pointerEvents: m === 'edit' ? undefined : 'none',
                    opacity: m === 'edit' ? undefined : 0.5
                });
            },
            onTransformChange: (transform)=>{
                this.freeTransform.setViewportTransform(transform);
            },
            padding: 30
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.preview.getElement(), {
            overflow: 'hidden',
            marginLeft: -20,
            marginRight: -20
        });
        this.rootEl.append(this.preview.getElement());
        this.initTransform = {
            x: this.imageWidth / 2,
            y: this.imageHeight / 2,
            width: this.layers[this.transformIndex].image.width,
            height: this.layers[this.transformIndex].image.height
        };
        this.freeTransform = new (0, $93e6a53ec76e8c56$export$79a74567acf241b0)({
            x: this.initTransform.x,
            y: this.initTransform.y,
            width: this.initTransform.width,
            height: this.initTransform.height,
            angleDeg: 0,
            isConstrained: true,
            snapX: [
                0,
                this.imageWidth
            ],
            snapY: [
                0,
                this.imageHeight
            ],
            viewportTransform: this.preview.getTransform(),
            callback: ()=>{
                this.updatePreview();
            }
        });
        this.preview.getElement().append(this.freeTransform.getElement());
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.freeTransform.getElement(), {
            position: 'absolute',
            left: 0,
            top: 0
        });
        setTimeout(()=>this.updatePreview(), 0);
    }
}





const $0a5c1a04b3d5c21e$var$directionToCursor = {
    n: 'ns-resize',
    ne: 'nesw-resize',
    e: 'ew-resize',
    se: 'nwse-resize',
    s: 'ns-resize',
    sw: 'nesw-resize',
    w: 'ew-resize',
    nw: 'nwse-resize'
};
const $0a5c1a04b3d5c21e$var$resizeDirectionArr = Object.keys($0a5c1a04b3d5c21e$var$directionToCursor);
class $0a5c1a04b3d5c21e$export$71ed2b85d4ca43d3 {
    /**
     * Clips render geometry to one pixel outside the viewport. The logical crop rect is untouched.
     */ clipRect(rect) {
        const x1 = (0, $be957da3610487e9$export$921068d8846a1559).clamp(rect.x, -1, this.width + 1);
        const y1 = (0, $be957da3610487e9$export$921068d8846a1559).clamp(rect.y, -1, this.height + 1);
        const x2 = (0, $be957da3610487e9$export$921068d8846a1559).clamp(rect.x + rect.width, -1, this.width + 1);
        const y2 = (0, $be957da3610487e9$export$921068d8846a1559).clamp(rect.y + rect.height, -1, this.height + 1);
        return {
            x: x1,
            y: y1,
            width: Math.max(0, x2 - x1),
            height: Math.max(0, y2 - y1)
        };
    }
    postProcessRenderedCrop(rect) {
        const result = {
            ...rect
        };
        // align with viewport pixels
        const x1 = Math.round(result.x);
        const y1 = Math.round(result.y);
        const x2 = Math.round(result.x + result.width);
        const y2 = Math.round(result.y + result.height);
        result.x = x1;
        result.y = y1;
        result.width = x2 - x1;
        result.height = y2 - y1;
        // min size 2x2
        if (result.width < 2) {
            result.x -= Math.ceil((2 - result.width) / 2);
            result.width = 2;
        }
        if (result.height < 2) {
            result.y -= Math.ceil((2 - result.height) / 2);
            result.height = 2;
        }
        return result;
    }
    setElementRect(el, rect) {
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(el, {
            left: rect.x + 'px',
            top: rect.y + 'px',
            width: Math.max(0, rect.width) + 'px',
            height: Math.max(0, rect.height) + 'px'
        });
    }
    setClippedElementRect(el, rect) {
        this.setElementRect(el, this.clipRect(rect));
    }
    updatePointerEvents(activeEl) {
        [
            this.moveEl,
            ...Object.values(this.handleElMap)
        ].forEach((el)=>{
            el.style.pointerEvents = activeEl === undefined || el === activeEl ? '' : 'none';
        });
    }
    processAndApply(event) {
        this.crop = this.processEvent(event);
        this.onChange?.({
            ...this.crop
        });
        this.render();
    }
    render() {
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
            width: this.width + 'px',
            height: this.height + 'px',
            overflow: this.debugShowOverflow ? 'visible' : 'hidden'
        });
        const renderedCrop = this.postProcessRenderedCrop(this.toRendered(this.crop));
        const renderCropRect = this.clipRect(renderedCrop);
        const x1 = Math.max(0, renderCropRect.x);
        const y1 = Math.max(0, renderCropRect.y);
        const x2 = Math.min(this.width, renderCropRect.x + renderCropRect.width);
        const y2 = Math.min(this.height, renderCropRect.y + renderCropRect.height);
        if (x2 <= x1 || y2 <= y1) {
            this.setElementRect(this.maskElArr[0], {
                x: 0,
                y: 0,
                width: this.width,
                height: this.height
            });
            this.maskElArr.slice(1).forEach((el)=>{
                this.setElementRect(el, {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                });
            });
        } else {
            this.setElementRect(this.maskElArr[0], {
                x: 0,
                y: 0,
                width: this.width,
                height: y1
            });
            this.setElementRect(this.maskElArr[1], {
                x: 0,
                y: y2,
                width: this.width,
                height: this.height - y2
            });
            this.setElementRect(this.maskElArr[2], {
                x: 0,
                y: y1,
                width: x1,
                height: y2 - y1
            });
            this.setElementRect(this.maskElArr[3], {
                x: x2,
                y: y1,
                width: this.width - x2,
                height: y2 - y1
            });
        }
        this.setElementRect(this.moveEl, renderCropRect);
        this.setElementRect(this.selectionEl, renderCropRect);
        $0a5c1a04b3d5c21e$var$resizeDirectionArr.forEach((direction)=>{
            const el = this.handleElMap[direction];
            el.style.background = this.debugShowHandles ? direction.length === 2 ? 'rgba(0, 128, 0, 0.5)' : 'rgba(0, 0, 255, 0.5)' : 'transparent';
        });
        this.thirdsElArr.forEach((el)=>{
            el.style.display = this.showThirds ? 'block' : 'none';
        });
        const thirdsRectArr = [
            {
                x: renderedCrop.x + renderedCrop.width / 3,
                y: renderedCrop.y,
                width: 1,
                height: renderedCrop.height
            },
            {
                x: renderedCrop.x + renderedCrop.width * 2 / 3,
                y: renderedCrop.y,
                width: 1,
                height: renderedCrop.height
            },
            {
                x: renderedCrop.x,
                y: renderedCrop.y + renderedCrop.height / 3,
                width: renderedCrop.width,
                height: 1
            },
            {
                x: renderedCrop.x,
                y: renderedCrop.y + renderedCrop.height * 2 / 3,
                width: renderedCrop.width,
                height: 1
            }
        ];
        this.thirdsElArr.forEach((el, index)=>{
            this.setClippedElementRect(el, thirdsRectArr[index]);
        });
        const sourceRect = renderedCrop;
        const outward = this.handleSize - this.handleInset;
        // limit inward, for better usability (easier to move small crop) and prevent overlap
        const insetX = Math.min(this.handleInset, Math.max(0, sourceRect.width - 50));
        const insetY = Math.min(this.handleInset, Math.max(0, sourceRect.height - 50));
        const handleRectMap = {
            nw: {
                x: sourceRect.x - outward,
                y: sourceRect.y - outward,
                width: outward + insetX,
                height: outward + insetY
            },
            n: {
                x: sourceRect.x + insetX,
                y: sourceRect.y - outward,
                width: sourceRect.width - insetX * 2,
                height: outward + insetY
            },
            ne: {
                x: sourceRect.x + sourceRect.width - insetX,
                y: sourceRect.y - outward,
                width: outward + insetX,
                height: outward + insetY
            },
            e: {
                x: sourceRect.x + sourceRect.width - insetX,
                y: sourceRect.y + insetY,
                width: outward + insetX,
                height: sourceRect.height - insetY * 2
            },
            se: {
                x: sourceRect.x + sourceRect.width - insetX,
                y: sourceRect.y + sourceRect.height - insetY,
                width: outward + insetX,
                height: outward + insetY
            },
            s: {
                x: sourceRect.x + insetX,
                y: sourceRect.y + sourceRect.height - insetY,
                width: sourceRect.width - insetX * 2,
                height: outward + insetY
            },
            sw: {
                x: sourceRect.x - outward,
                y: sourceRect.y + sourceRect.height - insetY,
                width: outward + insetX,
                height: outward + insetY
            },
            w: {
                x: sourceRect.x - outward,
                y: sourceRect.y + insetY,
                width: outward + insetX,
                height: sourceRect.height - insetY * 2
            }
        };
        $0a5c1a04b3d5c21e$var$resizeDirectionArr.forEach((direction)=>{
            this.setClippedElementRect(this.handleElMap[direction], handleRectMap[direction]);
        });
    }
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return {
            ...this.crop
        };
    }
    setWidth(width) {
        this.width = width;
        this.render();
    }
    setHeight(height) {
        this.height = height;
        this.render();
    }
    setValue(value) {
        this.crop = {
            ...value
        };
        this.render();
    }
    setShowThirds(showThirds) {
        this.showThirds = showThirds;
        this.render();
    }
    destroy() {
        this.pointerListenerArr.forEach((pointerListener)=>pointerListener.destroy());
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.pointerListenerArr = [];
        this.handleSize = 80;
        this.handleInset = 15;
        this.debugShowHandles = false;
        this.debugShowOverflow = false;
        this.width = p.width;
        this.height = p.height;
        this.processEvent = p.processEvent;
        this.toRendered = p.toRendered;
        this.crop = {
            ...p.value
        };
        this.showThirds = p.showThirds ?? false;
        this.onChange = p.onChange;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'relative',
                touchAction: 'none',
                userSelect: 'none'
            }
        });
        this.rootEl.oncontextmenu = ()=>false;
        this.maskElArr = Array(4).fill(0).map(()=>{
            return (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: this.rootEl,
                css: {
                    position: 'absolute',
                    background: 'rgba(0, 0, 0, 0.5)'
                }
            });
        });
        this.moveEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                position: 'absolute',
                cursor: 'move'
            }
        });
        this.selectionEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                position: 'absolute',
                pointerEvents: 'none',
                zIndex: '1'
            }
        });
        [
            'top',
            'right',
            'bottom',
            'left'
        ].forEach((side)=>{
            const isHorizontal = side === 'top' || side === 'bottom';
            (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: this.selectionEl,
                css: {
                    position: 'absolute',
                    left: isHorizontal ? '0' : side === 'left' ? '-1px' : '100%',
                    top: isHorizontal ? side === 'top' ? '-1px' : '100%' : '0',
                    width: isHorizontal ? '100%' : '1px',
                    height: isHorizontal ? '1px' : '100%',
                    background: isHorizontal ? 'repeating-linear-gradient(90deg, white 0 4px, black 4px 8px)' : 'repeating-linear-gradient(180deg, white 0 4px, black 4px 8px)'
                }
            });
        });
        this.thirdsElArr = Array(4).fill(0).map(()=>{
            return (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: this.rootEl,
                css: {
                    position: 'absolute',
                    background: '#0ff',
                    pointerEvents: 'none',
                    zIndex: '1'
                }
            });
        });
        this.handleElMap = {};
        $0a5c1a04b3d5c21e$var$resizeDirectionArr.forEach((direction)=>{
            this.handleElMap[direction] = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: this.rootEl,
                css: {
                    position: 'absolute',
                    cursor: $0a5c1a04b3d5c21e$var$directionToCursor[direction]
                }
            });
        });
        this.pointerListenerArr.push(new (0, $3a4865bce5f52590$export$9371bd96776f4e82)({
            target: this.moveEl,
            fixScribble: true,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.type === 'pointerdown') {
                    this.updatePointerEvents(this.moveEl);
                    this.processEvent({
                        type: 'start'
                    });
                }
                if (event.type === 'pointermove' && event.button === 'left') this.processAndApply({
                    type: 'move',
                    dX: event.dX,
                    dY: event.dY
                });
                if (event.type === 'pointerup') this.updatePointerEvents(undefined);
            }
        }));
        $0a5c1a04b3d5c21e$var$resizeDirectionArr.forEach((direction)=>{
            this.pointerListenerArr.push(new (0, $3a4865bce5f52590$export$9371bd96776f4e82)({
                target: this.handleElMap[direction],
                fixScribble: true,
                onPointer: (event)=>{
                    event.eventPreventDefault();
                    if (event.type === 'pointerdown') {
                        this.updatePointerEvents(this.handleElMap[direction]);
                        this.processEvent({
                            type: 'start'
                        });
                    }
                    if (event.type === 'pointermove' && event.button === 'left') this.processAndApply({
                        type: 'resize',
                        direction: direction,
                        dX: event.dX,
                        dY: event.dY,
                        isSymmetric: event.shiftKey
                    });
                    if (event.type === 'pointerup') this.updatePointerEvents(undefined);
                }
            }));
        });
    }
}








class $d68260f31c92ba6d$export$d25420b53e16716f {
    updateClippingIconColor() {
        this.clippingIconEl.style.color = (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).isDark() ? '#ccc' : 'var(--kl-color)';
    }
    getLayer() {
        const composed = this.klHistory.getComposed();
        const layerId = composed.activeLayerId;
        return this.klCanvas.getLayer(composed.layerMap[layerId].index);
    }
    /**
     * is always instant
     */ drawLargeCanvas() {
        const layer = this.getLayer();
        if (!layer) return;
        const layerCanvas = layer.canvas;
        const canvasDimensions = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(layerCanvas.width, layerCanvas.height, this.largeCanvasSize, this.largeCanvasSize, 1);
        const newWidth = Math.round(canvasDimensions.width);
        const newHeight = Math.round(canvasDimensions.height);
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.largeCanvas, newWidth, newHeight, {
            ensureCleared: true
        });
        this.largeCanvasCtx.save();
        if (this.largeCanvas.width > layerCanvas.width) this.largeCanvasCtx.imageSmoothingEnabled = false;
        else {
            this.largeCanvasCtx.imageSmoothingEnabled = true;
            this.largeCanvasCtx.imageSmoothingQuality = 'high';
        }
        this.largeCanvasCtx.drawImage(layerCanvas, 0, 0, this.largeCanvas.width, this.largeCanvas.height);
        this.largeCanvasCtx.restore();
    }
    updateLabel() {
        const layer = this.getLayer();
        if (!this.isPreviewVisible || !layer) return;
        const layerIsVisible = layer.isVisible;
        this.checkEl.parentElement.title = layerIsVisible ? (0, $fc42a07754814920$export$ce37e184d908d785)('layers-active-layer-visible') : (0, $fc42a07754814920$export$ce37e184d908d785)('layers-active-layer-hidden');
        this.checkEl.checked = layerIsVisible;
        this.checkEl.style.boxShadow = layerIsVisible ? '' : '0 0 0 1px red';
        this.clippingIconEl.style.display = layer.hasClipping ? '' : 'none';
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.nameWrapperEl, {
            paddingLeft: layer.hasClipping ? 21 : 10
        });
        this.nameLabelEl.textContent = layer.name;
        if (layer.isVisible) this.opacityEl.innerHTML = (0, $fc42a07754814920$export$ce37e184d908d785)('opacity') + '<br>' + Math.round(layer.opacity * 100) + '%';
        else this.opacityEl.innerHTML = (0, $fc42a07754814920$export$ce37e184d908d785)('opacity') + '<br><s>' + Math.round(layer.opacity * 100) + '%</s>';
    }
    draw() {
        const layer = this.getLayer();
        if (!this.isPreviewVisible || !layer) return;
        this.updateLabel();
        const layerCanvas = layer.canvas;
        const canvasDimensions = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(layerCanvas.width, layerCanvas.height, this.canvasSize, this.canvasSize, 1);
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.canvas, Math.round(canvasDimensions.width), Math.round(canvasDimensions.height), {
            ensureCleared: true
        });
        this.canvasCtx.save();
        this.canvasCtx.imageSmoothingEnabled = false;
        this.canvasCtx.drawImage(layerCanvas, 0, 0, this.canvas.width, this.canvas.height);
        this.canvasCtx.restore();
        this.lastDrawnSize.width = layerCanvas.width;
        this.lastDrawnSize.height = layerCanvas.height;
    }
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    setIsVisible(b) {
        if (this.isPreviewVisible === b) return;
        this.isPreviewVisible = b;
        this.contentWrapperEl.style.display = this.isPreviewVisible ? 'flex' : 'none';
        this.rootEl.style.marginBottom = this.isPreviewVisible ? '' : '10px';
        this.draw();
    }
    setIsSmall(b) {
        if (this.isSmall === b) return;
        this.isSmall = b;
        this.height = b ? 36 : 40;
        this.canvasSize = this.height - 10;
        this.contentWrapperEl.style.height = `${this.height}px`;
        this.canvasWrapperEl.style.minWidth = `${this.height}px`;
        this.canvasWrapperEl.style.height = `${this.height}px`;
        this.draw();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        // syncs via updateLayer, and internally updates layer opacity via a hack
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-layer-preview'
        });
        this.klHistory = p.klHistory;
        this.klCanvas = p.klCanvas;
        this.floatingLayerPreview = p.floatingLayerPreview;
        this.isPreviewVisible = true;
        this.isSmall = false;
        this.height = 40;
        this.canvasSize = this.height - 10;
        this.largeCanvasSize = 300;
        this.lastDrawnSize = {
            width: 0,
            height: 0
        };
        // --- setup dom ---
        this.contentWrapperEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                alignItems: 'center',
                height: this.height
            }
        });
        const checkWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                width: 23,
                flexShrink: 0
            }
        });
        this.checkEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: checkWrapper,
            tagName: 'input',
            css: {
                pointerEvents: 'none'
            },
            props: {
                type: 'checkbox',
                disabled: true,
                name: 'layer-visible'
            }
        });
        this.canvasWrapperEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                //background: '#f00',
                minWidth: this.height,
                height: this.height,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        });
        this.canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.canvasSize, this.canvasSize);
        this.canvasCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.canvas);
        this.canvas.title = (0, $fc42a07754814920$export$ce37e184d908d785)('layers-active-layer');
        const nameWrapper = this.nameWrapperEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                //background: '#ff0',
                flexGrow: 1,
                paddingLeft: 10,
                fontSize: 13,
                overflow: 'hidden',
                position: 'relative'
            }
        });
        this.clippingIconEl = (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('layer-clipping', {
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
            display: 'none'
        });
        nameWrapper.append(this.clippingIconEl);
        this.nameLabelEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: '',
            css: {
                float: 'left',
                whiteSpace: 'nowrap'
            }
        });
        const clickableEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                // background: 'rgba(0,255,0,0.6)',
                position: 'absolute',
                left: 10,
                top: 0,
                width: 90,
                height: '100%'
            }
        });
        this.clippingIconEl.addEventListener('click', ()=>p.onClick(), {
            passive: false
        });
        clickableEl.addEventListener('click', ()=>p.onClick(), {
            passive: false
        });
        this.canvas.addEventListener('click', ()=>p.onClick(), {
            passive: false
        });
        checkWrapper.addEventListener('click', ()=>p.onClick(), {
            passive: false
        });
        this.opacityEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity') + '<br>100%',
            css: {
                minWidth: 60,
                fontSize: 12,
                textAlign: 'center'
            }
        });
        this.largeCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.largeCanvasSize, this.largeCanvasSize);
        this.largeCanvasCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.largeCanvas);
        this.canvasWrapperEl.append(this.canvas);
        nameWrapper.append(this.nameLabelEl, clickableEl);
        this.contentWrapperEl.append(checkWrapper, this.canvasWrapperEl, nameWrapper, this.opacityEl);
        this.rootEl.append(this.contentWrapperEl);
        this.updateClippingIconColor();
        (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).addIsDarkListener(()=>{
            this.updateClippingIconColor();
        });
        let previousLayerId = '';
        let timeout;
        this.klHistory.addListener(()=>{
            // label should update instantly
            this.updateLabel();
            const activeLayerId = this.klHistory.getComposed().activeLayerId;
            if (activeLayerId !== previousLayerId) {
                // layer changed, draw instantly
                this.draw();
                timeout = undefined;
            } else // layer didn't change, can update slowly
            timeout ??= setTimeout(()=>{
                timeout = undefined;
                this.draw();
            }, 500);
            previousLayerId = activeLayerId;
        });
        const pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.canvas,
            onEnterLeave: (b)=>{
                if (b) {
                    this.drawLargeCanvas();
                    const bounds = this.rootEl.getBoundingClientRect();
                    this.floatingLayerPreview.show(this.largeCanvas, bounds.top + this.height / 2);
                } else this.floatingLayerPreview.hide();
            }
        });
        this.draw();
    }
}






function $9a26bc0f26acb8b1$export$8f6817a932bf45cd() {
    return window.innerWidth < 550;
}


const $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768 = {
    width: 340,
    height: 220
};
const $0cebc8ae8ef681f1$export$3a4a74a7d8c44e62 = {
    width: 540,
    height: 300
};
function $0cebc8ae8ef681f1$export$8b9199c1f5e4be8(isSmall) {
    return isSmall ? $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768.width : $0cebc8ae8ef681f1$export$3a4a74a7d8c44e62.width;
}
function $0cebc8ae8ef681f1$export$94cffdbcf128864a(isSmall) {
    return isSmall ? $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768.height : $0cebc8ae8ef681f1$export$3a4a74a7d8c44e62.height;
}






var $79I2S = parcelRequire("79I2S");


function $451c2c6773f98d8b$var$getAlgorithmIconDataUrl() {
    const canvas = (0, $79I2S.createCanvas)(3, 3);
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    ctx.fillRect(0, 0, 1, 1);
    ctx.fillRect(2, 0, 1, 1);
    ctx.fillRect(1, 1, 1, 1);
    ctx.fillRect(0, 2, 1, 1);
    ctx.fillRect(2, 2, 1, 1);
    return canvas.toDataURL('image/png');
}
function $451c2c6773f98d8b$var$createAlgorithmIcon(src, isPixelated) {
    const icon = new Image();
    icon.src = src;
    icon.className = 'dark-invert';
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(icon, {
        width: 20,
        height: 20,
        margin: 4,
        imageRendering: isPixelated ? 'pixelated' : undefined
    });
    return icon;
}
let $451c2c6773f98d8b$var$iconSrc;
class $451c2c6773f98d8b$export$6152f1e421c68434 {
    getElement() {
        return this.options.getElement();
    }
    getValue() {
        return this.options.getValue();
    }
    setValue(value, skipEmit) {
        this.options.setValue(value, skipEmit);
    }
    destroy() {
        this.options.destroy();
    }
    constructor(p){
        if (!$451c2c6773f98d8b$var$iconSrc) $451c2c6773f98d8b$var$iconSrc = $451c2c6773f98d8b$var$getAlgorithmIconDataUrl();
        this.options = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'smooth',
                    label: $451c2c6773f98d8b$var$createAlgorithmIcon($451c2c6773f98d8b$var$iconSrc, false),
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('algorithm-smooth')
                },
                {
                    id: 'pixelated',
                    label: $451c2c6773f98d8b$var$createAlgorithmIcon($451c2c6773f98d8b$var$iconSrc, true),
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('algorithm-pixelated')
                }
            ],
            initId: p.initValue,
            isFocusable: p.isFocusable,
            ariaLabel: (0, $fc42a07754814920$export$ce37e184d908d785)('scaling-algorithm'),
            onChange: p.onChange
        });
        if (p.initValue) this.options.setValue(p.initValue, true);
    }
}


function $e8feadb2d03819a1$export$962af7e240721d88(params) {
    const div = document.createElement('div');
    (0, $be957da3610487e9$export$921068d8846a1559).appendTextDiv(div, (0, $fc42a07754814920$export$ce37e184d908d785)('import-as-layer-description'));
    if (params.klCanvas.isLayerLimitReached()) {
        const noteEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-import-note',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('import-as-layer-limit-reached')
        });
        div.append(noteEl);
    }
    const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
    const destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
    const buttonRowEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
        css: {
            display: 'flex'
        }
    });
    const originalSizeBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'button',
        className: 'kl-button',
        content: '1:1',
        destroyer: destroyer,
        css: {
            marginRight: 10
        },
        onClick: function() {
            freeTransformCanvas.reset();
        }
    });
    const fitSizeBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'button',
        className: 'kl-button',
        content: (0, $fc42a07754814920$export$ce37e184d908d785)('import-as-layer-fit'),
        destroyer: destroyer,
        css: {
            marginRight: 10
        },
        onClick: function() {
            freeTransformCanvas.setTransformFit();
        }
    });
    const centerBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'button',
        className: 'kl-button',
        content: (0, $fc42a07754814920$export$ce37e184d908d785)('center'),
        destroyer: destroyer,
        css: {
            marginRight: 10
        },
        onClick: function() {
            freeTransformCanvas.setTransformCenter();
        }
    });
    const algorithmToggle = new (0, $451c2c6773f98d8b$export$6152f1e421c68434)({
        initValue: 'smooth',
        isFocusable: true,
        onChange: (val)=>{
            freeTransformCanvas.setAlgorithm(val);
        }
    });
    buttonRowEl.append(originalSizeBtn, fitSizeBtn, centerBtn, (0, $be957da3610487e9$export$921068d8846a1559).el({
        css: {
            flexGrow: 1
        }
    }), algorithmToggle.getElement());
    div.append(buttonRowEl);
    const layers = [];
    {
        const klCanvasLayerArr = params.klCanvas.getLayers();
        for(let i = 0; i < klCanvasLayerArr.length; i++)layers.push({
            image: klCanvasLayerArr[i].context.canvas,
            isVisible: klCanvasLayerArr[i].isVisible,
            opacity: klCanvasLayerArr[i].opacity,
            mixModeStr: klCanvasLayerArr[i].mixModeStr,
            hasClipping: klCanvasLayerArr[i].hasClipping
        });
    }
    layers.push({
        image: params.importImage,
        isVisible: true,
        opacity: 1,
        mixModeStr: 'source-over',
        hasClipping: false
    });
    const freeTransformCanvas = new (0, $6f7fb59adaa892d0$export$205c2dd29f8a66b5)({
        elementWidth: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
        elementHeight: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall) + 50,
        imageWidth: params.klCanvas.getLayerContext(0).canvas.width,
        imageHeight: params.klCanvas.getLayerContext(0).canvas.height,
        layers: layers,
        transformIndex: layers.length - 1
    });
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(freeTransformCanvas.getElement(), {
        marginTop: 10,
        marginLeft: -20
    });
    div.append(freeTransformCanvas.getElement());
    function move(x, y) {
        freeTransformCanvas.move(x, y);
    }
    const keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
        onDown: function(keyStr) {
            if (keyStr === 'left') move(-1, 0);
            if (keyStr === 'right') move(1, 0);
            if (keyStr === 'up') move(0, -1);
            if (keyStr === 'down') move(0, 1);
        }
    });
    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $fc42a07754814920$export$ce37e184d908d785)('import-as-layer-title')}</b>`,
        div: div,
        style: isSmall ? undefined : {
            width: 540
        },
        buttons: [
            'Ok',
            'Cancel'
        ],
        clickOnEnter: 'Ok',
        callback: function(buttonStr) {
            keyListener.destroy();
            freeTransformCanvas.destroy();
            algorithmToggle.destroy();
            destroyer.destroy();
            if (buttonStr === 'Ok') params.callback(freeTransformCanvas.getTransformation(), freeTransformCanvas.getIsPixelated());
            else params.callback();
        }
    });
}




class $78d0d4fee3100d15$export$e789742143ba5b1 {
    // ----------------------------------- public -----------------------------------
    constructor(p){
        //set up DOM
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('dropper-drop'),
            css: {
                paddingTop: 100,
                position: 'fixed',
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(50, 50, 50, 0.7)',
                color: '#fff',
                textShadow: '2px 2px #000',
                textAlign: 'center',
                fontSize: 25
            }
        });
        const wrapperEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                marginTop: 50,
                display: 'flex',
                justifyContent: 'center'
            }
        });
        const optionStyle = {
            width: 200,
            padding: 50,
            margin: 10,
            //opacity: 0.5,
            borderRadius: 20,
            border: '1px dashed #fff',
            background: '#00aefe',
            fontWeight: 'bold'
        };
        const optionLayerEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('dropper-as-layer'),
            css: optionStyle
        });
        const optionImageEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('dropper-as-image'),
            css: optionStyle
        });
        this.rootEl.append(wrapperEl);
        wrapperEl.append(optionLayerEl, optionImageEl);
        let rootCounter = 0;
        let optionLayerCounter = 0;
        let optionImageCounter = 0;
        const destroy = ()=>{
            rootCounter = 0;
            optionLayerCounter = 0;
            optionImageCounter = 0;
            this.rootEl.remove();
        };
        /**
         * check, can drop content be imported
         */ const testAcceptType = (event)=>{
            return !!event.dataTransfer && !event.dataTransfer.types.includes('text/plain');
        };
        const updateOptions = ()=>{
            const boxShadow = '0 0 20px 4px #fff';
            if (optionLayerCounter > 0) {
                optionLayerEl.style.boxShadow = boxShadow;
                optionImageEl.style.boxShadow = '';
            } else if (optionImageCounter > 0) {
                optionLayerEl.style.boxShadow = '';
                optionImageEl.style.boxShadow = boxShadow;
            } else {
                optionLayerEl.style.boxShadow = '';
                optionImageEl.style.boxShadow = '';
            }
        };
        optionLayerEl.addEventListener('dragenter', ()=>{
            optionLayerCounter++;
            updateOptions();
        }, {
            passive: false
        });
        optionLayerEl.addEventListener('dragleave', ()=>{
            optionLayerCounter--;
            updateOptions();
        }, {
            passive: false
        });
        optionImageEl.addEventListener('dragenter', ()=>{
            optionImageCounter++;
            updateOptions();
        }, {
            passive: false
        });
        optionImageEl.addEventListener('dragleave', ()=>{
            optionImageCounter--;
            updateOptions();
        }, {
            passive: false
        });
        const rootDragOver = (event)=>{
            if (!testAcceptType(event)) return;
            event.stopPropagation();
            event.preventDefault();
        };
        const rootDragEnter = (event)=>{
            if (!p.enabledTest() || !testAcceptType(event)) return;
            if (rootCounter === 0) p.target.append(this.rootEl);
            rootCounter++;
        };
        const rootDragLeave = (event)=>{
            if (!testAcceptType(event) || rootCounter === 0) return;
            rootCounter = Math.max(0, rootCounter - 1);
            if (rootCounter === 0) this.rootEl.remove();
        };
        const rootDrop = (event)=>{
            if (!testAcceptType(event) || !event.dataTransfer || event.dataTransfer.files.length === 0) {
                destroy();
                return;
            }
            event.stopPropagation();
            event.preventDefault();
            let optionStr = 'default';
            if (optionLayerCounter > 0) optionStr = 'layer';
            else if (optionImageCounter > 0) optionStr = 'image';
            p.onDrop(event.dataTransfer.files, optionStr);
            if (rootCounter > 0) this.rootEl.remove();
            rootCounter = 0;
            optionLayerCounter = 0;
            optionImageCounter = 0;
            updateOptions();
        };
        window.addEventListener('dragover', rootDragOver, {
            passive: false
        });
        window.addEventListener('dragenter', rootDragEnter, {
            passive: false
        });
        window.addEventListener('dragleave', rootDragLeave, {
            passive: false
        });
        window.addEventListener('drop', rootDrop, {
            passive: false
        });
        // if something goes wrong and you're stuck with overlay
        this.rootEl.addEventListener('pointerdown', ()=>{
            destroy();
        }, {
            passive: false
        });
        const keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
            onDown: (keyStr)=>{
                if (rootCounter > 0 && keyStr === 'esc') destroy();
            }
        });
    }
}







class $a77c2094a41ced02$export$9f0da9b942594e99 {
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        const sizeObj = {
            width: 150,
            svHeight: 90,
            hHeight: 20,
            sliderHeight: 25
        };
        let isVisible = false;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-overlay-toolspace'
        });
        const queuedObj = {
            color: null,
            size: null,
            opacity: null
        };
        // --- inputs ---
        //color selection
        const colorEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-overlay-toolspace__color'
        });
        const colorSlider = new (0, $845fa9514537a3d1$export$66306bf21a9ff39e)({
            width: sizeObj.width,
            heightSV: sizeObj.svHeight,
            heightH: sizeObj.hHeight,
            color: p.brushSettingService.getColor(),
            callback: (rgbObj)=>{
                selectedColorEl.style.backgroundColor = 'rgb(' + rgbObj.r + ',' + rgbObj.g + ',' + rgbObj.b + ')';
                p.brushSettingService.setColor(rgbObj, subscriptionFunc);
            }
        });
        const selectedColorEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: sizeObj.width,
                height: sizeObj.hHeight,
                pointerEvents: 'none'
            }
        });
        {
            const initialColor = p.brushSettingService.getColor();
            selectedColorEl.style.backgroundColor = 'rgb(' + initialColor.r + ',' + initialColor.g + ',' + initialColor.b + ')';
        }
        colorEl.append(selectedColorEl, colorSlider.getElement());
        const updateColor = (rgbObj)=>{
            colorSlider.setColor(rgbObj);
            selectedColorEl.style.backgroundColor = 'rgb(' + rgbObj.r + ',' + rgbObj.g + ',' + rgbObj.b + ')';
        };
        //brushsize slider
        const sizeSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-size'),
            width: sizeObj.width,
            height: sizeObj.sliderHeight,
            min: 0,
            max: 500,
            value: 50,
            resolution: 225,
            eventResMs: 1000 / 30,
            toDisplayValue: (val)=>val * 2,
            toValue: (displayValue)=>displayValue / 2,
            onChange: (v)=>{
                p.brushSettingService.setSize(v);
            },
            formatFunc: (displayValue)=>{
                if (displayValue < 10) return (0, $be957da3610487e9$export$921068d8846a1559).round(displayValue, 1);
                else return Math.round(displayValue);
            }
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(sizeSlider.getElement(), {
            marginTop: 2
        });
        const opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
            width: sizeObj.width,
            height: sizeObj.sliderHeight,
            min: 0,
            max: 1,
            value: 1,
            resolution: 225,
            eventResMs: 1000 / 30,
            toDisplayValue: (val)=>val * 100,
            toValue: (displayValue)=>displayValue / 100,
            onChange: (v)=>{
                p.brushSettingService.setOpacity(v);
            }
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(opacitySlider.getElement(), {
            margin: '2px 0'
        });
        this.rootEl.append(sizeSlider.getElement(), opacitySlider.getElement());
        // --- general setup ---
        const subscriptionFunc = (event)=>{
            if (event.type === 'color') {
                if (!isVisible) queuedObj.color = event.value;
                else updateColor(event.value);
            }
            if (event.type === 'size') {
                if (!isVisible) queuedObj.size = event.value;
                else sizeSlider.setValue(event.value);
            }
            if (event.type === 'opacity') {
                if (!isVisible) queuedObj.opacity = event.value;
                else opacitySlider.setValue(event.value);
            }
            if (event.type === 'sliderConfig') {
                sizeSlider.update(event.value.sizeSlider);
                opacitySlider.update(event.value.opacitySlider);
            }
        };
        p.brushSettingService.subscribe(subscriptionFunc);
        {
            const sliderConfig = p.brushSettingService.getSliderConfig();
            sizeSlider.update(sliderConfig.sizeSlider);
            opacitySlider.update(sliderConfig.opacitySlider);
            sizeSlider.setValue(p.brushSettingService.getSize());
            opacitySlider.setValue(p.brushSettingService.getOpacity());
        }
        const updateUI = ()=>{
            // unfocus manual slider input
            (0, $be957da3610487e9$export$921068d8846a1559).unfocusAnyInput();
            this.rootEl.style.display = isVisible ? 'block' : 'none';
            if (isVisible && mousePos) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
                left: mousePos.x - Math.round(sizeObj.width / 2),
                top: mousePos.y - Math.round(sizeObj.svHeight + sizeObj.hHeight * 3 / 2)
            });
        };
        let mousePos = null;
        document.addEventListener('pointermove', (event)=>{
            mousePos = {
                x: event.pageX,
                y: event.pageY
            };
        }, {
            passive: false
        });
        const keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
            onDown: (keyStr, event, comboStr, isRepeat)=>{
                if (isRepeat) return;
                if (isVisible) {
                    isVisible = false;
                    updateUI();
                    return;
                }
                if (!p.enabledTest() || !mousePos) return;
                if ([
                    'ctrl+alt',
                    'cmd+alt',
                    'alt+ctrl',
                    'alt+cmd'
                ].includes(comboStr)) {
                    event.preventDefault();
                    isVisible = true;
                    if (queuedObj.color !== null) {
                        updateColor(queuedObj.color);
                        queuedObj.color = null;
                    }
                    if (queuedObj.size !== null) {
                        sizeSlider.setValue(queuedObj.size);
                        queuedObj.size = null;
                    }
                    if (queuedObj.opacity !== null) {
                        opacitySlider.setValue(queuedObj.opacity);
                        queuedObj.opacity = null;
                    }
                    updateUI();
                }
            },
            onUp: (keyStr, event, oldComboStr)=>{
                if ([
                    'ctrl+alt',
                    'cmd+alt',
                    'alt+ctrl',
                    'alt+cmd'
                ].includes(oldComboStr) && isVisible) {
                    isVisible = false;
                    colorSlider.end();
                    updateUI();
                }
            },
            onBlur: ()=>{
                if (isVisible) {
                    isVisible = false;
                    colorSlider.end();
                    updateUI();
                }
            }
        });
    }
}




var $b7b1802c3f8fdaa5$exports = {};
$b7b1802c3f8fdaa5$exports = $parcel$resolve("eVgmx");




const $e3cc87398ab80fdb$var$newImageImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('new-image');
const $e3cc87398ab80fdb$var$importImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('import');
const $e3cc87398ab80fdb$var$exportImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('export');
const $e3cc87398ab80fdb$var$shareImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('share');
class $e3cc87398ab80fdb$export$665d2c76b1eb8459 {
    setLogo(logoImg, isPixelated, keepOriginalColors) {
        const el = document.getElementById('kl-logo-button-im');
        if (el) {
            el.style.backgroundImage = "url('" + logoImg + "')";
            el.style.imageRendering = isPixelated ? 'pixelated' : '';
            el.classList.toggle('dark-invert', !keepOriginalColors);
        }
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-toolspace-row',
            css: {
                height: 36,
                display: 'flex'
            }
        });
        function createButton(p) {
            const padding = 6 + (p.extraPadding ? p.extraPadding : 0);
            const el = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'toolspace-row-button nohighlight',
                title: p.title,
                onClick: p.onClick,
                css: {
                    padding: p.contain ? padding + 'px 0' : ''
                }
            });
            if (p.content) el.append(p.content);
            else {
                const im = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    className: p.darkInvert ? 'dark-invert' : undefined,
                    id: 'kl-logo-button-im',
                    css: {
                        backgroundImage: "url('" + p.image + "')",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: p.contain ? 'contain' : '',
                        //filter: 'grayscale(1)',
                        height: '100%'
                    }
                });
                im.style.pointerEvents = 'none';
                el.append(im);
            }
            const pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                // because :hover causes problems w touch
                target: el,
                onEnterLeave: function(isOver) {
                    el.classList.toggle('toolspace-row-button-hover', isOver);
                }
            });
            return {
                el: el,
                pointerListener: pointerListener
            };
        }
        const logoButton = createButton({
            onClick: p.onLogo,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('home'),
            image: p.logoImg ?? (0, (/*@__PURE__*/$parcel$interopDefault($b7b1802c3f8fdaa5$exports))),
            contain: true,
            darkInvert: true
        });
        logoButton.el.classList.add('kl-tool-row-border-right');
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(logoButton.el, {
            width: 46
        });
        const newButton = createButton({
            onClick: p.onNew,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('file-new'),
            image: $e3cc87398ab80fdb$var$newImageImg,
            extraPadding: 1,
            contain: true
        });
        const importButton = createButton({
            onClick: p.onImport,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('file-import'),
            image: $e3cc87398ab80fdb$var$importImg,
            extraPadding: 1,
            contain: true
        });
        const saveButton = createButton({
            onClick: p.onSave,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('file-save'),
            image: $e3cc87398ab80fdb$var$exportImg,
            extraPadding: 1,
            contain: true
        });
        let shareButton = null;
        if ((0, $be957da3610487e9$export$921068d8846a1559).canShareFiles()) shareButton = createButton({
            onClick: p.onShare,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('file-share'),
            image: $e3cc87398ab80fdb$var$shareImg,
            contain: true,
            darkInvert: true
        });
        const helpButton = createButton({
            onClick: p.onHelp,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('help'),
            content: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('help', {
                width: 24,
                height: 24,
                margin: '0 auto'
            }),
            contain: true
        });
        helpButton.el.style.flexBasis = '0';
        (0, $be957da3610487e9$export$921068d8846a1559).append(this.rootEl, [
            logoButton.el,
            newButton.el,
            importButton.el,
            saveButton.el,
            shareButton ? shareButton.el : undefined,
            helpButton.el
        ]);
    }
}









const $d45d7d6cdafbb300$var$toolPaintImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-paint');
const $d45d7d6cdafbb300$var$toolFillImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-fill');
const $d45d7d6cdafbb300$var$toolGradientImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-gradient');
const $d45d7d6cdafbb300$var$toolTextImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-text');
const $d45d7d6cdafbb300$var$toolShapeImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-shape');
const $d45d7d6cdafbb300$var$toolSelectImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-select');
class $d45d7d6cdafbb300$export$a0a40f8a0b8fee15 {
    updateButton() {
        this.activeButton.title = this.titleArr[this.currentActiveIndex] + (this.isActive ? ' (' + (0, $fc42a07754814920$export$ce37e184d908d785)('tool-more-tools-click-again') + ')' : '');
        this.activeButtonIm.style.backgroundImage = "url('" + this.imArr[this.currentActiveIndex] + "')";
    }
    // ---- interface ----
    setIsSmall(b) {
        this.activeButton.style.padding = b ? this.smallMargin : '10px 0';
        for(let i = 0; i < this.optionArr.length; i++)this.dropdownBtnArr[i].setIsSmall(b);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.arrowButton, {
            width: b ? 14 : 18,
            height: b ? 14 : 18
        });
    }
    setActive(activeStr) {
        if (this.optionArr.includes(activeStr)) {
            this.isActive = true;
            for(let i = 0; i < this.optionArr.length; i++)if (this.optionArr[i] === activeStr) {
                this.currentActiveIndex = i;
                break;
            }
            this.activeButton.classList.add('toolspace-row-button-activated');
            this.updateButton();
        } else {
            this.isActive = false;
            this.activeButton.classList.remove('toolspace-row-button-activated');
            this.updateButton();
        }
    }
    getActive() {
        return this.optionArr[this.currentActiveIndex];
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.smallMargin = '6px 0';
        this.optionArr = [
            'brush',
            'paintBucket',
            'gradient',
            'text',
            'shape',
            'select'
        ];
        this.imArr = [
            $d45d7d6cdafbb300$var$toolPaintImg,
            $d45d7d6cdafbb300$var$toolFillImg,
            $d45d7d6cdafbb300$var$toolGradientImg,
            $d45d7d6cdafbb300$var$toolTextImg,
            $d45d7d6cdafbb300$var$toolShapeImg,
            $d45d7d6cdafbb300$var$toolSelectImg
        ];
        this.titleArr = [
            `${(0, $fc42a07754814920$export$ce37e184d908d785)('tool-brush')} [B]`,
            `${(0, $fc42a07754814920$export$ce37e184d908d785)('tool-paint-bucket')} [G]`,
            `${(0, $fc42a07754814920$export$ce37e184d908d785)('tool-gradient')} [G]`,
            `${(0, $fc42a07754814920$export$ce37e184d908d785)('tool-text')} [T]`,
            `${(0, $fc42a07754814920$export$ce37e184d908d785)('tool-shape')} [U]`,
            `${(0, $fc42a07754814920$export$ce37e184d908d785)('tool-select')} [L]`
        ];
        this.currentActiveIndex = 0;
        this.isActive = true;
        let isOpen = false;
        //preload images
        setTimeout(()=>{
            for(let i = 1; i < this.imArr.length; i++){
                const im = new Image();
                im.src = this.imArr[i];
            }
        }, 100);
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'relative',
                flexGrow: 1
            }
        });
        let openTimeout;
        let isDragging = false;
        let startX;
        let startY;
        let pointerListener;
        if ((0, $be957da3610487e9$export$921068d8846a1559).hasPointerEvents) pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.rootEl,
            onPointer: (event)=>{
                if (event.type === 'pointerdown') {
                    if (isOpen) return;
                    openTimeout = setTimeout(()=>{
                        showDropdown();
                    }, 400);
                    isDragging = true;
                    startX = event.pageX;
                    startY = event.pageY;
                } else if (event.type === 'pointermove' && isDragging) {
                    if (!isOpen && (0, $be957da3610487e9$export$921068d8846a1559).dist(startX, startY, event.pageX, event.pageY) > 5) {
                        clearTimeout(openTimeout);
                        showDropdown();
                    }
                } else if (event.type === 'pointerup' && isDragging) {
                    clearTimeout(openTimeout);
                    isDragging = false;
                    if (isOpen) {
                        const target = document.elementFromPoint(event.pageX, event.pageY);
                        for(let i = 0; i < this.dropdownBtnArr.length; i++)if (target === this.dropdownBtnArr[i].wrapper) {
                            closeDropdown();
                            this.isActive = true;
                            this.currentActiveIndex = i;
                            this.updateButton();
                            p.onChange(this.optionArr[this.currentActiveIndex]);
                            break;
                        }
                    }
                }
            }
        });
        this.activeButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'toolspace-row-button nohighlight toolspace-row-button-activated',
            title: this.titleArr[this.currentActiveIndex],
            onClick: (e)=>{
                if (this.isActive && !isOpen) {
                    e.preventDefault();
                    e.stopPropagation();
                    showDropdown();
                    return;
                }
                this.isActive = true;
                p.onChange(this.optionArr[this.currentActiveIndex]);
                if (isOpen) closeDropdown();
            },
            css: {
                padding: '10px 0',
                pointerEvents: 'auto',
                height: '100%',
                boxSizing: 'border-box',
                zIndex: 1
            }
        });
        // hover via JS, so hover-state not stuck on mobile
        const activeButtonPointerListener = new (0, $3a4865bce5f52590$export$9371bd96776f4e82)({
            target: this.activeButton,
            onEnterLeave: (isOver)=>{
                this.activeButton.classList.toggle('kl-tool-button--hover', isOver);
            }
        });
        this.activeButtonIm = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.activeButton,
            className: 'dark-invert',
            css: {
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                width: 'calc(100% - 7px)',
                height: '100%',
                pointerEvents: 'none',
                opacity: 0.75
            }
        });
        this.arrowButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.activeButton,
            className: 'kl-tooldropdown-caret',
            content: (0, $8405ecc79d32770a$export$db3b6bfb95261072)('.dark-invert'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('tool-more-tools'),
            onClick: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                showDropdown();
            }
        });
        const overlay = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                //background: 'rgba(255,0,0,0.5)',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            }
        });
        const overlayPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: overlay,
            onPointer: (e)=>{
                if (e.type === 'pointerdown') {
                    e.eventPreventDefault();
                    closeDropdown();
                }
            }
        });
        const dropdownWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'tool-dropdown-wrapper',
            css: {
                position: 'absolute',
                width: '100%',
                height: 100 * (this.optionArr.length - 1) + '%',
                top: '100%',
                left: 0,
                zIndex: -1,
                boxSizing: 'border-box',
                cursor: 'pointer',
                transition: 'height 0.1s ease-in-out, opacity 0.1s ease-in-out',
                borderBottomLeftRadius: 5,
                borderBottomRightRadius: 5,
                overflow: 'hidden'
            }
        });
        this.dropdownBtnArr = [];
        const createDropdownButton = (p)=>{
            const wrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: dropdownWrapper,
                className: 'tool-dropdown-button',
                title: p.title,
                css: {
                    padding: '10px 0',
                    height: 100 / (this.optionArr.length - 1) + '%',
                    boxSizing: 'border-box'
                },
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    p.onClick(p.index);
                }
            });
            (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: wrapper,
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + p.image + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    height: '100%',
                    pointerEvents: 'none',
                    opacity: 0.75
                }
            });
            // --- interface ---
            const show = (b)=>{
                wrapper.style.display = b ? 'block' : 'none';
            };
            const setIsSmall = (b)=>{
                wrapper.style.padding = b ? this.smallMargin : '10px 0';
            };
            return {
                wrapper: wrapper,
                show: show,
                setIsSmall: setIsSmall
            };
        };
        const onClickDropdownBtn = (index)=>{
            closeDropdown();
            this.isActive = true;
            this.currentActiveIndex = index;
            this.updateButton();
            p.onChange(this.optionArr[this.currentActiveIndex]);
        };
        for(let i = 0; i < this.optionArr.length; i++)this.dropdownBtnArr.push(createDropdownButton({
            index: i,
            id: this.optionArr[i],
            image: this.imArr[i],
            title: this.titleArr[i],
            onClick: onClickDropdownBtn
        }));
        const showDropdown = ()=>{
            if ((0, $a0bbbeb927a78bac$export$d3d1650bc39c4419).get() > 0) return;
            (0, $a0bbbeb927a78bac$export$d3d1650bc39c4419).increase(0.5);
            isOpen = true;
            for(let i = 0; i < this.optionArr.length; i++)this.dropdownBtnArr[i].show(this.currentActiveIndex !== i);
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.arrowButton, {
                opacity: 0,
                pointerEvents: 'none'
            });
            this.rootEl.style.zIndex = '1';
            document.body.append(overlay);
            this.rootEl.append(dropdownWrapper);
        };
        const closeDropdown = ()=>{
            (0, $a0bbbeb927a78bac$export$d3d1650bc39c4419).decrease(0.5);
            isOpen = false;
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.arrowButton, {
                opacity: undefined,
                pointerEvents: undefined
            });
            this.rootEl.style.removeProperty('z-index');
            overlay.remove();
            dropdownWrapper.remove();
        };
        this.updateButton();
    }
}







const $3fde918673ae1534$var$toolHandImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-hand');
const $3fde918673ae1534$var$toolZoomInImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-zoom-in');
const $3fde918673ae1534$var$toolZoomOutImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-zoom-out');
const $3fde918673ae1534$var$toolUndoImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-undo');
class $3fde918673ae1534$export$c744a22bef9e0b97 {
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    setIsSmall(b) {
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
            height: b ? 36 : 54
        });
        this.toolDropdown.setIsSmall(b);
        this.handButton.setIsSmall(b);
        this.zoomInButton.setIsSmall(b);
        this.zoomOutButton.setIsSmall(b);
        this.undoButton.setIsSmall(b);
        this.redoButton.setIsSmall(b);
        if (b) {
            this.zoomInNOutButton.el.style.display = 'none';
            this.undoNRedoButton.el.style.display = 'none';
            this.zoomInButton.el.style.display = 'block';
            this.zoomOutButton.el.style.display = 'block';
            this.undoButton.el.style.display = 'block';
            this.redoButton.el.style.display = 'block';
        } else {
            this.zoomInNOutButton.el.style.display = 'block';
            this.undoNRedoButton.el.style.display = 'block';
            this.zoomInButton.el.style.display = 'none';
            this.zoomOutButton.el.style.display = 'none';
            this.undoButton.el.style.display = 'none';
            this.redoButton.el.style.display = 'none';
        }
    }
    setEnableZoomIn(b) {
        this.zoomInButton.el.classList.toggle('toolspace-row-button-disabled', !b);
        this.zoomInNOutButton.setIsEnabledLeft(b);
    }
    setEnableZoomOut(b) {
        this.zoomOutButton.el.classList.toggle('toolspace-row-button-disabled', !b);
        this.zoomInNOutButton.setIsEnabledRight(b);
    }
    setEnableUndo(b) {
        this.undoButton.el.classList.toggle('toolspace-row-button-disabled', !b);
        this.undoNRedoButton.setIsEnabledLeft(b);
    }
    setEnableRedo(b) {
        this.redoButton.el.classList.toggle('toolspace-row-button-disabled', !b);
        this.undoNRedoButton.setIsEnabledRight(b);
    }
    setActive(activeStr, doEmit) {
        if (this.currentActiveStr === activeStr) return;
        this.currentActiveStr = activeStr;
        this.toolDropdown.setActive(this.currentActiveStr);
        this.handButton.el.classList.toggle('toolspace-row-button-activated', this.currentActiveStr === 'hand');
        if (doEmit) this.onActivate(this.currentActiveStr);
    }
    getActive() {
        return this.currentActiveStr;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-toolspace-row',
            css: {
                height: 54,
                display: 'flex'
            }
        });
        this.onActivate = p.onActivate;
        this.currentActiveStr = 'brush';
        const createButton = (p)=>{
            const smallMargin = p.doLighten ? '6px 0' : '8px 0';
            const el = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'toolspace-row-button nohighlight',
                //title: p.title,
                onClick: p.onClick,
                css: {
                    padding: p.contain ? '10px 0' : ''
                }
            });
            const im = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + p.image + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: p.contain ? 'contain' : '',
                    //filter: 'grayscale(1)',
                    height: '100%',
                    transform: p.doMirror ? 'scale(-1, 1)' : '',
                    pointerEvents: 'none',
                    opacity: p.doLighten ? 0.75 : 1
                }
            });
            el.append(im);
            const pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                // because :hover causes problems w touch
                target: el,
                onEnterLeave: (isOver)=>{
                    el.classList.toggle('toolspace-row-button-hover', isOver);
                }
            });
            const setIsSmall = (b)=>{
                el.style.padding = p.contain ? b ? smallMargin : '10px 0' : '';
            };
            return {
                el: el,
                pointerListener: pointerListener,
                setIsSmall: setIsSmall
            };
        };
        const createTriangleButton = (p)=>{
            // because IE and Edge don't support clip path
            const result = (0, $be957da3610487e9$export$921068d8846a1559).el({
                css: {
                    flexGrow: 1,
                    position: 'relative'
                }
            });
            const svg = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
                elementType: 'svg',
                width: '67px',
                height: '54px',
                viewBox: '0 0 100 100',
                preserveAspectRatio: 'none'
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(svg, {
                position: 'absolute',
                left: 0,
                top: 0
            });
            const blurRadius = 10;
            const blurOffsetX = 2;
            const blurOffsetY = 2;
            const defs = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
                // inset shadow via svg
                elementType: 'defs',
                childrenArr: [
                    {
                        elementType: 'filter',
                        id: 'innershadow',
                        x0: '-50%',
                        y0: '-50%',
                        width: '200%',
                        height: '200%',
                        childrenArr: [
                            {
                                elementType: 'feGaussianBlur',
                                in: 'SourceAlpha',
                                stdDeviation: '' + blurRadius,
                                result: 'blur'
                            },
                            {
                                elementType: 'feOffset',
                                dx: '' + blurOffsetX,
                                dy: '' + blurOffsetY
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'SourceAlpha',
                                operator: 'arithmetic',
                                k2: '-1',
                                k3: '1',
                                result: 'shadowDiff'
                            },
                            {
                                elementType: 'feFlood',
                                'flood-color': '#000',
                                'flood-opacity': '0.2'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'shadowDiff',
                                operator: 'in'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'SourceGraphic',
                                operator: 'over',
                                result: 'firstfilter'
                            },
                            {
                                elementType: 'feGaussianBlur',
                                in: 'firstfilter',
                                stdDeviation: '' + blurRadius,
                                result: 'blur2'
                            },
                            {
                                elementType: 'feOffset',
                                dx: '' + blurOffsetX,
                                dy: '' + blurOffsetY
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'firstfilter',
                                operator: 'arithmetic',
                                k2: '-1',
                                k3: '1',
                                result: 'shadowDiff'
                            },
                            {
                                elementType: 'feFlood',
                                'flood-color': '#000',
                                'flood-opacity': '0.2'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'shadowDiff',
                                operator: 'in'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'firstfilter',
                                operator: 'over'
                            }
                        ]
                    }
                ]
            });
            const svgTriangleLeft = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
                elementType: 'path',
                'vector-effect': 'non-scaling-stroke',
                d: 'M0,0 L 100,0 0,100 z',
                fill: 'rgba(0,0,0,0)',
                class: 'toolspace-svg-triangle-button'
            });
            svgTriangleLeft.onclick = ()=>{
                p.onLeft();
                svgTriangleLeft.classList.remove('toolspace-svg-triangle-button-hover');
            };
            const svgTriangleRight = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
                elementType: 'path',
                'vector-effect': 'non-scaling-stroke',
                d: 'M100,100 L 100,0 0,100 z',
                fill: 'rgba(0,0,0,0)',
                class: 'toolspace-svg-triangle-button'
            });
            svgTriangleRight.onclick = ()=>{
                p.onRight();
                svgTriangleRight.classList.remove('toolspace-svg-triangle-button-hover');
            };
            // because :hover causes problems w touch
            const leftPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                target: svgTriangleLeft,
                onEnterLeave: (isOver)=>{
                    svgTriangleLeft.classList.toggle('toolspace-svg-triangle-button-hover', isOver);
                }
            });
            const rightPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                target: svgTriangleRight,
                onEnterLeave: (isOver)=>{
                    svgTriangleRight.classList.toggle('toolspace-svg-triangle-button-hover', isOver);
                }
            });
            svg.append(defs, svgTriangleLeft, svgTriangleRight);
            result.append(svg);
            const leftIm = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: result,
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + p.leftImage + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    width: 20,
                    height: 20,
                    position: 'absolute',
                    left: 10,
                    top: 8,
                    //transform: p.doMirror ? 'scale(-1, 1)' : '',
                    pointerEvents: 'none'
                }
            });
            result.append(leftIm);
            const rightIm = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: result,
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + (p.rightImage ? p.rightImage : p.leftImage) + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    width: 20,
                    height: 20,
                    position: 'absolute',
                    right: 10,
                    bottom: 8,
                    transform: p.rightImage ? '' : 'scale(-1, 1)',
                    pointerEvents: 'none'
                }
            });
            const setIsEnabledLeft = (b)=>{
                svgTriangleLeft.classList.toggle('toolspace-row-button-disabled', !b);
                leftIm.classList.toggle('toolspace-row-button-disabled', !b);
            };
            const setIsEnabledRight = (b)=>{
                svgTriangleRight.classList.toggle('toolspace-row-button-disabled', !b);
                rightIm.classList.toggle('toolspace-row-button-disabled', !b);
            };
            return {
                el: result,
                setIsEnabledLeft: setIsEnabledLeft,
                setIsEnabledRight: setIsEnabledRight,
                leftPointerListener: leftPointerListener,
                rightPointerListener: rightPointerListener
            };
        };
        this.toolDropdown = new (0, $d45d7d6cdafbb300$export$a0a40f8a0b8fee15)({
            onChange: (activeStr)=>{
                this.setActive(activeStr, true);
            }
        });
        this.rootEl.append(this.toolDropdown.getElement());
        this.handButton = createButton({
            onClick: ()=>{
                this.setActive('hand', true);
            },
            image: $3fde918673ae1534$var$toolHandImg,
            contain: true,
            doLighten: true
        });
        this.handButton.el.classList.add('kl-tool-row-border-right');
        this.handButton.el.title = `${(0, $fc42a07754814920$export$ce37e184d908d785)('tool-hand')} [H]`;
        this.rootEl.append(this.handButton.el);
        this.zoomInNOutButton = createTriangleButton({
            onLeft: p.onZoomIn,
            onRight: p.onZoomOut,
            leftImage: $3fde918673ae1534$var$toolZoomInImg,
            rightImage: $3fde918673ae1534$var$toolZoomOutImg
        });
        this.zoomInNOutButton.el.title = (0, $fc42a07754814920$export$ce37e184d908d785)('tool-zoom');
        this.rootEl.append(this.zoomInNOutButton.el);
        this.zoomInButton = createButton({
            onClick: p.onZoomIn,
            image: $3fde918673ae1534$var$toolZoomInImg,
            contain: true
        });
        this.zoomInButton.el.title = (0, $fc42a07754814920$export$ce37e184d908d785)('zoom-in');
        this.rootEl.append(this.zoomInButton.el);
        this.zoomOutButton = createButton({
            onClick: p.onZoomOut,
            image: $3fde918673ae1534$var$toolZoomOutImg,
            contain: true
        });
        this.zoomOutButton.el.title = (0, $fc42a07754814920$export$ce37e184d908d785)('zoom-out');
        this.rootEl.append(this.zoomOutButton.el);
        this.undoNRedoButton = createTriangleButton({
            onLeft: p.onUndo,
            onRight: p.onRedo,
            leftImage: $3fde918673ae1534$var$toolUndoImg,
            rightImage: null
        });
        this.undoNRedoButton.el.title = (0, $fc42a07754814920$export$ce37e184d908d785)('undo') + '/' + (0, $fc42a07754814920$export$ce37e184d908d785)('redo');
        this.undoNRedoButton.setIsEnabledLeft(false);
        this.undoNRedoButton.setIsEnabledRight(false);
        this.rootEl.append(this.undoNRedoButton.el);
        this.undoButton = createButton({
            onClick: p.onUndo,
            image: $3fde918673ae1534$var$toolUndoImg,
            contain: true
        });
        this.undoButton.el.title = (0, $fc42a07754814920$export$ce37e184d908d785)('undo');
        this.undoButton.el.classList.add('toolspace-row-button-disabled');
        this.rootEl.append(this.undoButton.el);
        this.redoButton = createButton({
            onClick: p.onRedo,
            image: $3fde918673ae1534$var$toolUndoImg,
            contain: true,
            doMirror: true
        });
        this.redoButton.el.title = (0, $fc42a07754814920$export$ce37e184d908d785)('redo');
        this.redoButton.el.classList.add('toolspace-row-button-disabled');
        this.rootEl.append(this.redoButton.el);
        this.zoomInButton.el.style.display = 'none';
        this.zoomOutButton.el.style.display = 'none';
        this.undoButton.el.style.display = 'none';
        this.redoButton.el.style.display = 'none';
    }
}





class $e1a1e20314346e6a$export$8162a66cd18867a7 {
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'label',
            className: 'kl-stabilizer',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('stabilizer') + '&nbsp;',
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('stabilizer-title')
        });
        const strengthSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
            optionArr: [
                [
                    '0',
                    '0'
                ],
                [
                    '1',
                    '1'
                ],
                [
                    '2',
                    '2'
                ],
                [
                    '3',
                    '3'
                ],
                [
                    '4',
                    '4'
                ],
                [
                    '5',
                    '5'
                ]
            ],
            initValue: '' + p.smoothing,
            onChange: function(val) {
                p.onSelect(parseInt(val));
            },
            name: 'stabilizer-strength'
        });
        this.rootEl.append(strengthSelect.getElement());
        this.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.rootEl,
            onWheel: function(e) {
                strengthSelect.setDeltaValue(e.deltaY);
            }
        });
    }
}




class $edc0a3ccf2e6e858$export$3c6d17ed0106bfb9 {
    // update
    update() {
        for(let i = 0; i < this.tabArr.length; i++)this.tabArr[i].update(this.activeTab);
    }
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    open(tabId) {
        for(let i = 0; i < this.tabArr.length; i++)if (this.tabArr[i].id === tabId) {
            if (this.activeTab === this.tabArr[i]) // already open
            return;
            this.activeTab.onClose();
            this.activeTab = this.tabArr[i];
            this.activeTab.onOpen();
            this.activeTab.el.append(this.roundRight, this.roundLeft);
            this.update();
            return;
        }
        throw 'TabRow.open - invalid tabId';
    }
    getOpenedTabId() {
        return '' + this.activeTab.id;
    }
    setIsVisible(tabId, isVisible) {
        for(let i = 0; i < this.tabArr.length; i++)if (this.tabArr[i].id === tabId) {
            this.tabArr[i].isVisible = isVisible;
            this.update();
            return;
        }
        throw 'TabRow.setIsVisible - invalid tabId';
    }
    destroy() {
        this.tabArr.forEach((item)=>{
            item.pointerListener.destroy();
        });
        this.destroyer.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        const height = p.height ?? 35;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'tabrow',
            css: {
                height: height + 1
            }
        });
        this.tabArr = []; //creates its own internal arr
        const roundSize = 10;
        this.roundRight = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'tabrow__tab__rounding-left'
        });
        this.roundLeft = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'tabrow__tab__rounding-right'
        });
        const createTab = (pTabObj, initialId, useAccent)=>{
            const isVisible = 'isVisible' in pTabObj && pTabObj.isVisible !== undefined ? pTabObj.isVisible : true;
            const result = {
                id: pTabObj.id,
                isVisible: isVisible,
                onOpen: pTabObj.onOpen,
                onClose: pTabObj.onClose,
                update: (openedTabObj)=>{
                    result.el.className = openedTabObj === result ? useAccent ? 'tabrow__tab tabrow__tab--opened-accented' : 'tabrow__tab tabrow__tab--opened' : 'tabrow__tab';
                    result.el.style.display = result.isVisible ? 'block' : 'none';
                },
                el: (0, $be957da3610487e9$export$921068d8846a1559).el({
                    parent: this.rootEl,
                    content: 'label' in pTabObj ? pTabObj.label : '',
                    title: 'title' in pTabObj ? pTabObj.title : undefined,
                    className: initialId === pTabObj.id ? useAccent ? 'tabrow__tab tabrow__tab--opened-accented' : 'tabrow__tab tabrow__tab--opened' : 'tabrow__tab',
                    css: {
                        lineHeight: height + 'px',
                        display: isVisible ? 'block' : 'none'
                    },
                    destroyer: this.destroyer,
                    onClick: ()=>{
                        if (this.activeTab === result) return;
                        this.open(result.id);
                    }
                }),
                pointerListener: {}
            };
            if ('image' in pTabObj) (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'span',
                parent: result.el,
                className: 'dark-invert',
                css: {
                    backgroundImage: `url("${pTabObj.image}")`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    height: height - 7,
                    justifyContent: 'center',
                    margin: '4px auto'
                }
            });
            if ('css' in pTabObj && pTabObj.css !== undefined) (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(result.el, pTabObj.css);
            result.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                // because :hover causes problems w touch
                target: result.el,
                onEnterLeave: (isOver)=>{
                    result.el.classList.toggle('tabrow__tab-hover', isOver);
                }
            });
            if (initialId === result.id) {
                result.onOpen();
                result.el.append(this.roundRight, this.roundLeft);
            } else result.onClose();
            return result;
        };
        let initTabObj = null;
        for(let i = 0; i < p.tabArr.length; i++){
            const tab = createTab(p.tabArr[i], p.initialId, p.useAccent || false);
            if (tab.id === p.initialId) initTabObj = tab;
            this.tabArr.push(tab);
        }
        if (!initTabObj) throw 'invalid initialId';
        this.activeTab = initTabObj;
    }
}









const $5e18205c4f161db6$var$angleImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('angle');
const $5e18205c4f161db6$var$rotateImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-rotate');
const $5e18205c4f161db6$var$LS_INERTIA_KEY = 'kl-inertia-scroll';
class $5e18205c4f161db6$export$cf20160367bae46c {
    updateUi() {
        this.scaleEl.innerHTML = Math.round(this.scale * 100) + '%';
        this.angleEl.innerHTML = Math.round(this.angleDeg) + "\xb0";
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.angleIm, {
            transform: 'rotate(' + this.angleDeg + 'deg)',
            boxShadow: this.angleDeg % 90 === 0 ? 'inset 0 0 0 1px rgba(255,255,255, 1), 0 0 0 1px rgba(0, 0, 0, 0.3)' : ''
        });
    }
    getElement() {
        return this.rootEl;
    }
    setIsVisible(pIsVisible) {
        this.isVisible = pIsVisible;
        this.rootEl.style.display = this.isVisible ? 'block' : 'none';
        if (this.isVisible) this.updateUi();
    }
    update(pScale, pAngleDeg, pIsMirrored) {
        this.scale = pScale;
        this.angleDeg = pAngleDeg;
        this.flipToggle.setValue(pIsMirrored);
        if (this.isVisible) this.updateUi();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isVisible = true;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                margin: '10px 10px 0'
            }
        });
        this.scale = p.scale;
        this.angleDeg = p.angleDeg;
        const row1 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                marginBottom: 10,
                display: 'flex'
            }
        });
        const row2 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                marginBottom: 10
            }
        });
        const row3 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex'
            }
        });
        this.rootEl.append(row1, row2, row3);
        this.scaleEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: 65,
                userSelect: 'none',
                fontFamily: 'monospace'
            }
        });
        row1.append(this.scaleEl);
        this.angleIm = new Image();
        this.angleIm.src = $5e18205c4f161db6$var$angleImg;
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.angleIm, {
            verticalAlign: 'bottom',
            width: 20,
            height: 20,
            marginRight: 5,
            borderRadius: 10,
            background: 'rgba(0,0,0,0.2)',
            userSelect: 'none'
        });
        row1.append(this.angleIm);
        this.angleEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: row1,
            css: {
                userSelect: 'none'
            }
        });
        this.updateUi();
        const resetButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('hand-reset'),
            onClick: p.onReset
        });
        resetButton.tabIndex = -1;
        const fitButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('hand-fit'),
            css: {
                marginLeft: 10
            },
            onClick: p.onFit
        });
        fitButton.tabIndex = -1;
        row2.append(resetButton, fitButton);
        const leftRotateIcon = new Image();
        leftRotateIcon.height = 20;
        leftRotateIcon.src = $5e18205c4f161db6$var$rotateImg;
        leftRotateIcon.alt = 'Rotate';
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(leftRotateIcon, {
            transform: 'scale(-1, 1)'
        });
        const leftRotateButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: leftRotateIcon,
            onClick: function() {
                p.onAngleChange(-15, true);
            }
        });
        leftRotateButton.tabIndex = -1;
        const resetAngleButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: "0\xb0",
            css: {
                marginLeft: 5
            },
            onClick: function() {
                p.onAngleChange(0);
            }
        });
        resetAngleButton.tabIndex = -1;
        const rightRotateButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: '<img height="20" src="' + $5e18205c4f161db6$var$rotateImg + '" alt="Rotate"/>',
            css: {
                marginLeft: 5
            },
            onClick: function() {
                p.onAngleChange(15, true);
            }
        });
        rightRotateButton.tabIndex = -1;
        this.flipToggle = new (0, $0b383e4686740404$export$2358c75ad3c15b2d)({
            keepOriginalLabel: true,
            label: (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('view-flip', {
                    width: 20,
                    height: 20
                }),
                css: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 30,
                    height: 30,
                    opacity: '1'
                }
            }),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('hand-flip') + ' [M]',
            onChange: p.onChangeIsMirrored
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.flipToggle.getElement(), {
            marginLeft: 10
        });
        row3.append(leftRotateButton, resetAngleButton, rightRotateButton, this.flipToggle.getElement());
        const inertiaToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('hand-inertia-scrolling'),
            init: (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem($5e18205c4f161db6$var$LS_INERTIA_KEY) === 'true',
            callback: (b)=>{
                (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem($5e18205c4f161db6$var$LS_INERTIA_KEY, '' + b);
                p.onChangeUseInertiaScrolling(b);
            },
            name: 'enable-inertia-scrolling'
        });
        setTimeout(()=>{
            p.onChangeUseInertiaScrolling(inertiaToggle.getValue());
        }, 500);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(inertiaToggle.getElement(), {
            marginTop: 10,
            display: 'inline-block'
        });
        this.rootEl.append(inertiaToggle.getElement());
    }
}








class $4a31907be1a52177$export$1e63e3b0645421a2 {
    getElement() {
        return this.rootEl;
    }
    setIsVisible(pIsVisible) {
        this.isVisible = pIsVisible;
        this.rootEl.style.display = this.isVisible ? 'block' : 'none';
        if (this.isVisible) this.colorDiv.append(this.colorSlider.getElement(), this.colorSlider.getOutputElement());
    }
    /**
     * [0, 1]
     */ getTolerance() {
        // slider may display 0 when value is 1 -> avoid confusing users
        if (Math.round(this.toleranceSlider.getDisplayValue()) === 0) return 0;
        return this.toleranceSlider.getValue();
    }
    getOpacity() {
        return this.opacitySlider.getValue();
    }
    getSample() {
        return this.modeSelect.getValue();
    }
    getGrow() {
        return parseInt(this.growSelect.getValue(), 10);
    }
    getContiguous() {
        return this.isContiguous;
    }
    getIsEraser() {
        return this.eraserToggle.getValue();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                margin: '10px 10px 0'
            }
        });
        this.isVisible = true;
        this.colorDiv = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                marginBottom: 10
            }
        });
        this.colorSlider = p.colorSlider;
        this.opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
            width: 250,
            height: 30,
            min: 0.01,
            max: 1,
            value: 1,
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100
        });
        this.rootEl.append(this.opacitySlider.getElement());
        this.toleranceSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('bucket-tolerance'),
            width: 250,
            height: 30,
            min: 0,
            max: 255,
            value: 51,
            toValue: (displayValue)=>displayValue * 2.55,
            toDisplayValue: (value)=>value / 2.55
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.toleranceSlider.getElement(), {
            marginTop: 10
        });
        this.rootEl.append(this.toleranceSlider.getElement());
        const selectRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                marginTop: 10
            }
        });
        const modeWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('bucket-sample') + '&nbsp;',
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('bucket-sample-title'),
            css: {
                fontSize: 15
            }
        });
        this.modeSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
            optionArr: [
                [
                    'all',
                    (0, $fc42a07754814920$export$ce37e184d908d785)('bucket-sample-all')
                ],
                [
                    'current',
                    (0, $fc42a07754814920$export$ce37e184d908d785)('bucket-sample-active')
                ],
                [
                    'above',
                    (0, $fc42a07754814920$export$ce37e184d908d785)('bucket-sample-above')
                ]
            ],
            initValue: 'all',
            name: 'sampling-mode'
        });
        const modePointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.modeSelect.getElement(),
            onWheel: (e)=>{
                this.modeSelect.setDeltaValue(e.deltaY);
            }
        });
        modeWrapper.append(this.modeSelect.getElement());
        selectRow.append(modeWrapper);
        const growWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('bucket-grow') + '&nbsp;',
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('bucket-grow-title'),
            css: {
                fontSize: 15,
                marginLeft: 10
            }
        });
        this.growSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
            optionArr: [
                [
                    '0',
                    '0'
                ],
                [
                    '1',
                    '1'
                ],
                [
                    '2',
                    '2'
                ],
                [
                    '3',
                    '3'
                ],
                [
                    '4',
                    '4'
                ],
                [
                    '5',
                    '5'
                ],
                [
                    '6',
                    '6'
                ],
                [
                    '7',
                    '7'
                ]
            ],
            initValue: '0',
            name: 'fill-growth'
        });
        const growPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.growSelect.getElement(),
            onWheel: (e)=>{
                this.growSelect.setDeltaValue(e.deltaY);
            }
        });
        growWrapper.append(this.growSelect.getElement());
        selectRow.append(growWrapper);
        this.isContiguous = true;
        const contiguousToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('bucket-contiguous'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('bucket-contiguous-title'),
            callback: (b)=>{
                this.isContiguous = b;
            },
            name: 'is-contiguous'
        });
        this.eraserToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('eraser'),
            name: 'eraser-toggle'
        });
        this.rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                contiguousToggle.getElement(),
                this.eraserToggle.getElement()
            ],
            css: {
                display: 'flex',
                marginTop: 10,
                gap: 10
            }
        }));
    }
}




class $64657866f1638f3a$export$32a22540e4b2f123 {
    getElement() {
        return this.rootEl;
    }
    setIsVisible(pIsVisible) {
        this.isVisible = pIsVisible;
        this.rootEl.style.display = this.isVisible ? 'block' : 'none';
        if (this.isVisible) this.colorDiv.append(this.colorSlider.getElement(), this.colorSlider.getOutputElement());
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isVisible = true;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                margin: '10px 10px 0'
            }
        });
        this.colorSlider = p.colorSlider;
        this.colorDiv = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                marginBottom: 10
            }
        });
        const hint = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('text-instruction')
        });
    }
}








class $cf0fd9945673d580$export$a9387b1d4260d39c {
    getElement() {
        return this.rootEl;
    }
    setIsVisible(pIsVisible) {
        this.isVisible = pIsVisible;
        this.rootEl.style.display = this.isVisible ? 'block' : 'none';
        if (this.isVisible) {
            this.colorDiv.append(this.colorSlider.getElement());
            this.colorDiv.append(this.colorSlider.getOutputElement());
        //update();
        }
    }
    getShape() {
        return this.shape;
    }
    getMode() {
        return this.mode;
    }
    getIsEraser() {
        return this.eraserToggle.getValue();
    }
    getOpacity() {
        return this.opacitySlider.getValue();
    }
    getLineWidth() {
        return this.lineWidthSlider.getValue();
    }
    getIsOutwards() {
        return this.outwardsToggle.getValue();
    }
    getIsFixed() {
        return this.fixedToggle.getValue();
    }
    getIsSnap() {
        return this.snapToggle.getValue();
    }
    getDoLockAlpha() {
        return this.lockAlphaToggle.getValue();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.shape = 'rect';
        this.mode = 'stroke';
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                margin: '10px 10px 0'
            }
        });
        this.isVisible = true;
        this.colorDiv = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                marginBottom: 10
            }
        });
        this.colorSlider = p.colorSlider;
        const previewSize = 35;
        const previewPadding = 8;
        const rectStrokeSvgRect = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'rect',
            x: '' + previewPadding,
            width: '' + (previewSize - previewPadding * 2)
        });
        const rectStrokeSvg = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        rectStrokeSvg.classList.add('dark-invert');
        rectStrokeSvg.append(rectStrokeSvgRect);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(rectStrokeSvg, {
            display: 'block'
        });
        const rectFilledSvgRect = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'rect',
            x: '' + previewPadding,
            width: '' + (previewSize - previewPadding * 2)
        });
        const rectFilledSvg = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        rectFilledSvg.classList.add('dark-invert');
        rectFilledSvg.append(rectFilledSvgRect);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(rectFilledSvg, {
            display: 'block'
        });
        const ellipseStrokeSvgEllipse = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'ellipse',
            cx: '' + previewSize / 2,
            cy: '' + previewSize / 2,
            rx: '' + (previewSize / 2 - previewPadding)
        });
        const ellipseStrokeSvg = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        ellipseStrokeSvg.classList.add('dark-invert');
        ellipseStrokeSvg.append(ellipseStrokeSvgEllipse);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(ellipseStrokeSvg, {
            display: 'block'
        });
        const ellipseFilledSvgEllipse = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'ellipse',
            cx: '' + previewSize / 2,
            cy: '' + previewSize / 2,
            rx: '' + (previewSize / 2 - previewPadding)
        });
        const ellipseFilledSvg = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        ellipseFilledSvg.classList.add('dark-invert');
        ellipseFilledSvg.append(ellipseFilledSvgEllipse);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(ellipseFilledSvg, {
            display: 'block'
        });
        const lineSvgLine = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'line',
            x1: '' + previewPadding,
            x2: '' + (previewSize - previewPadding)
        });
        const lineSvg = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        lineSvg.classList.add('dark-invert');
        lineSvg.append(lineSvgLine);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(lineSvg, {
            display: 'block'
        });
        const updatePreviews = ()=>{
            const strokeWidth = (0, $be957da3610487e9$export$921068d8846a1559).clamp(Math.round(this.lineWidthSlider.getValue() / 10), 1, 10);
            const squish = 1.35;
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(rectStrokeSvgRect, {
                fill: 'none',
                stroke: 'black',
                strokeWidth: strokeWidth
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(rectFilledSvgRect, {
                fill: 'black',
                stroke: 'none'
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(ellipseStrokeSvgEllipse, {
                fill: 'none',
                stroke: 'black',
                strokeWidth: strokeWidth
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(ellipseFilledSvgEllipse, {
                fill: 'black',
                stroke: 'none'
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(lineSvgLine, {
                fill: 'none',
                stroke: 'black',
                strokeWidth: strokeWidth
            });
            if (this.fixedToggle.getValue()) {
                rectStrokeSvgRect.setAttribute('y', '' + previewPadding);
                rectStrokeSvgRect.setAttribute('height', '' + (previewSize - previewPadding * 2));
                rectFilledSvgRect.setAttribute('y', '' + previewPadding);
                rectFilledSvgRect.setAttribute('height', '' + (previewSize - previewPadding * 2));
                ellipseStrokeSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding));
                ellipseFilledSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding));
            } else {
                rectStrokeSvgRect.setAttribute('y', '' + previewPadding * squish);
                rectStrokeSvgRect.setAttribute('height', '' + (previewSize - previewPadding * squish * 2));
                rectFilledSvgRect.setAttribute('y', '' + previewPadding * squish);
                rectFilledSvgRect.setAttribute('height', '' + (previewSize - previewPadding * squish * 2));
                ellipseStrokeSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding * squish));
                ellipseFilledSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding * squish));
            }
            if (this.snapToggle.getValue()) {
                lineSvgLine.setAttribute('y1', '' + (previewSize - previewPadding));
                lineSvgLine.setAttribute('y2', '' + previewPadding);
            } else {
                lineSvgLine.setAttribute('y1', '' + (previewSize - previewPadding * squish));
                lineSvgLine.setAttribute('y2', '' + previewPadding * squish);
            }
        };
        const row1 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'start'
            }
        });
        const shapeOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'rect-stroke',
                    label: rectStrokeSvg,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-rect') + ' ' + (0, $fc42a07754814920$export$ce37e184d908d785)('shape-stroke')
                },
                {
                    id: 'ellipse-stroke',
                    label: ellipseStrokeSvg,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-ellipse') + ' ' + (0, $fc42a07754814920$export$ce37e184d908d785)('shape-stroke')
                },
                {
                    id: 'line',
                    label: lineSvg,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-line')
                },
                {
                    id: 'rect-fill',
                    label: rectFilledSvg,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-rect') + ' ' + (0, $fc42a07754814920$export$ce37e184d908d785)('shape-fill')
                },
                {
                    id: 'ellipse-fill',
                    label: ellipseFilledSvg,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-ellipse') + ' ' + (0, $fc42a07754814920$export$ce37e184d908d785)('shape-fill')
                }
            ],
            initId: this.shape + '-' + this.mode,
            onChange: (id)=>{
                const split = id.split('-');
                this.shape = split[0];
                this.mode = split[1];
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.fixedToggle.getElement(), {
                    display: this.shape === 'line' ? 'none' : ''
                });
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.snapToggle.getElement(), {
                    display: this.shape === 'line' ? '' : 'none'
                });
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.lineWidthSlider.getElement(), {
                    display: this.shape !== 'line' && this.mode === 'fill' ? 'none' : ''
                });
            },
            changeOnInit: true,
            css: {
                width: 120
            }
        });
        row1.append(shapeOptions.getElement());
        this.eraserToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('eraser'),
            callback: ()=>{
                updatePreviews();
            },
            name: 'enable-eraser'
        });
        this.lockAlphaToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha-title'),
            doHighlight: true,
            name: 'enable-alpha-lock'
        });
        this.lockAlphaToggle.getElement().style.marginTop = '10px';
        this.panningToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-auto-pan'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-auto-pan-title'),
            callback: (b)=>p.onChangePanning(b),
            name: 'enable-auto-pan'
        });
        this.panningToggle.getElement().style.marginTop = '10px';
        row1.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                this.eraserToggle.getElement(),
                this.lockAlphaToggle.getElement(),
                this.panningToggle.getElement()
            ]
        }));
        this.lineWidthSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-line-width'),
            width: 250,
            height: 30,
            min: 1,
            max: 200,
            value: 4,
            curve: 'quadratic',
            onChange: ()=>{
                updatePreviews();
            }
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.lineWidthSlider.getElement(), {
            marginTop: 10
        });
        this.rootEl.append(this.lineWidthSlider.getElement());
        this.opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
            width: 250,
            height: 30,
            min: 0.01,
            max: 1,
            value: 1,
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.opacitySlider.getElement(), {
            marginTop: 10
        });
        this.rootEl.append(this.opacitySlider.getElement());
        const row2 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: 10,
                gap: 10
            }
        });
        this.outwardsToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-outwards'),
            name: 'enable-outwards'
        });
        row2.append(this.outwardsToggle.getElement());
        this.fixedToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-fixed'),
            callback: ()=>{
                updatePreviews();
            },
            name: 'enable-fixed-proportions'
        });
        row2.append(this.fixedToggle.getElement());
        this.snapToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('angle-snap'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('angle-snap-title'),
            callback: ()=>{
                updatePreviews();
            },
            name: 'enable-angle-snapping'
        });
        row2.append(this.snapToggle.getElement());
        updatePreviews();
    }
}








function $304dd966053166ea$export$9852986a3ec5f6a0(data, cellProps) {
    const result = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'table',
        className: 'kl-table'
    });
    data.forEach((row, rowIndex)=>{
        const rowEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'tr'
        });
        rowEl.append(...row.map((el, colIndex)=>{
            const cellEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'td',
                content: el
            });
            const key = rowIndex + '.' + colIndex;
            if (cellProps !== undefined && key in cellProps) cellEl.rowSpan = cellProps[key].rowspan;
            return cellEl;
        }));
        result.append(rowEl);
    });
    return result;
}




function $fdf168f2047100ce$export$f77a89101d7d6586(p) {
    const currentColor = p.currentColor;
    const secondaryColor = p.secondaryColor;
    const maxCanvasSize = p.maxCanvasSize;
    const canvasWidth = p.canvasWidth;
    const canvasHeight = p.canvasHeight;
    const workspaceWidth = p.workspaceWidth;
    const workspaceHeight = p.workspaceHeight;
    const onConfirm = p.onConfirm;
    const onCancel = p.onCancel;
    function createRatioSize(ratioX, ratioY, width, height, padding) {
        return (0, $be957da3610487e9$export$921068d8846a1559).fitInto(ratioX, ratioY, Math.min(maxCanvasSize, width - padding), Math.min(maxCanvasSize, height - padding), 1);
    }
    const newImDiv = (0, $be957da3610487e9$export$921068d8846a1559).el();
    const widthInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
        type: 'number',
        init: canvasWidth,
        min: 1,
        max: maxCanvasSize,
        step: 1,
        name: 'image-width',
        isFocusIgnored: true,
        css: {
            width: 70
        },
        onChange: ()=>updateRatio()
    });
    const unitStyle = {
        color: '#888',
        fontSize: 12,
        marginLeft: 5
    };
    const widthUnit = (0, $be957da3610487e9$export$921068d8846a1559).el({
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('new-px'),
        css: unitStyle
    });
    const heightInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
        type: 'number',
        init: canvasHeight,
        min: 1,
        max: maxCanvasSize,
        step: 1,
        name: 'image-height',
        isFocusIgnored: true,
        css: {
            width: 70
        },
        onChange: ()=>updateRatio()
    });
    const heightUnit = (0, $be957da3610487e9$export$921068d8846a1559).el({
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('new-px'),
        css: unitStyle
    });
    const sizeTable = (0, $304dd966053166ea$export$9852986a3ec5f6a0)([
        [
            (0, $fc42a07754814920$export$ce37e184d908d785)('width') + ':&nbsp;',
            widthInput.getElement(),
            widthUnit
        ],
        [
            (0, $be957da3610487e9$export$921068d8846a1559).el({
                css: {
                    height: 5
                }
            }),
            '',
            ''
        ],
        [
            (0, $fc42a07754814920$export$ce37e184d908d785)('height') + ':&nbsp;',
            heightInput.getElement(),
            heightUnit
        ]
    ]);
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(sizeTable, {
        marginBottom: 10
    });
    const ratioWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
        css: {
            marginTop: 5,
            color: '#888'
        }
    });
    const templateWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
        css: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5,
            marginBottom: 10
        }
    });
    const presetBtnConfig = {
        tagName: 'button',
        className: 'kl-button',
        css: {
            flexGrow: '1'
        }
    };
    const destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
    const presetFitBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        ...presetBtnConfig,
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('new-fit'),
        destroyer: destroyer,
        onClick: ()=>{
            widthInput.setValue(workspaceWidth, true);
            heightInput.setValue(workspaceHeight, true);
            updateRatio();
        }
    });
    const presetCurrentBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        ...presetBtnConfig,
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('new-current'),
        destroyer: destroyer,
        onClick: ()=>{
            widthInput.setValue(canvasWidth, true);
            heightInput.setValue(canvasHeight, true);
            updateRatio();
        }
    });
    const presetSquareBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        ...presetBtnConfig,
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('new-square'),
        destroyer: destroyer,
        onClick: ()=>{
            const { width: width, height: height } = createRatioSize(1, 1, workspaceWidth, workspaceHeight, templatePadding);
            widthInput.setValue(width, true);
            heightInput.setValue(height, true);
            updateRatio();
        }
    });
    const presetLandscapeBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        ...presetBtnConfig,
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('new-landscape'),
        destroyer: destroyer,
        onClick: ()=>{
            const { width: width, height: height } = createRatioSize(4, 3, workspaceWidth, workspaceHeight, templatePadding);
            widthInput.setValue(width, true);
            heightInput.setValue(height, true);
            updateRatio();
        }
    });
    const presetPortraitBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        ...presetBtnConfig,
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('new-portrait'),
        destroyer: destroyer,
        onClick: ()=>{
            const { width: width, height: height } = createRatioSize(3, 4, workspaceWidth, workspaceHeight, templatePadding);
            widthInput.setValue(width, true);
            heightInput.setValue(height, true);
            updateRatio();
        }
    });
    const presetOversizeBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        ...presetBtnConfig,
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('new-oversize'),
        destroyer: destroyer,
        onClick: ()=>{
            widthInput.setValue(workspaceWidth + 500, true);
            heightInput.setValue(workspaceHeight + 500, true);
            updateRatio();
        }
    });
    templateWrapper.append(presetCurrentBtn, presetFitBtn, presetOversizeBtn, presetSquareBtn, presetLandscapeBtn, presetPortraitBtn);
    const templatePadding = 0;
    const select = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
        isFocusable: true,
        optionArr: [
            [
                'screen',
                (0, $fc42a07754814920$export$ce37e184d908d785)('new-screen')
            ],
            [
                '16 9',
                (0, $fc42a07754814920$export$ce37e184d908d785)('new-video') + ' 16:9'
            ],
            [
                '3 2',
                '3:2'
            ],
            [
                '5 3',
                '5:3'
            ],
            [
                '2 1',
                '2:1'
            ],
            [
                'paper',
                (0, $fc42a07754814920$export$ce37e184d908d785)('new-din-paper') + " \u221A2:1"
            ],
            [
                '9 16',
                '9:16'
            ],
            [
                '2 3',
                '2:3'
            ],
            [
                '3 5',
                '3:5'
            ],
            [
                '1 2',
                '1:2'
            ],
            [
                '1 1.4142135623730951',
                "1:\u221A2"
            ]
        ],
        onChange: function(val) {
            if (val === 'screen') {
                widthInput.setValue(window.screen.width, true);
                heightInput.setValue(window.screen.height, true);
            } else if (val === 'paper') {
                const { width: width, height: height } = createRatioSize(Math.sqrt(2), 1, workspaceWidth, workspaceHeight, templatePadding);
                widthInput.setValue(width, true);
                heightInput.setValue(height, true);
            } else {
                const split = val.split(' ');
                const { width: width, height: height } = createRatioSize(parseFloat(split[0]), parseFloat(split[1]), workspaceWidth, workspaceHeight, templatePadding);
                widthInput.setValue(width, true);
                heightInput.setValue(height, true);
            }
            updateRatio();
            select.setValue(undefined);
        },
        name: 'image-format'
    });
    setTimeout(()=>{
        // safari: not empty without also setting it to null via timeout
        select.setValue(undefined);
    }, 0);
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(select.getElement(), {
        width: 80,
        flexGrow: 1
    });
    templateWrapper.append(select.getElement());
    let backgroundRgba = {
        r: 255,
        g: 255,
        b: 255,
        a: 1
    };
    const colorOptionsArr = [
        {
            r: 255,
            g: 255,
            b: 255,
            a: 1
        },
        {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        },
        {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        },
        {
            r: currentColor.r,
            g: currentColor.g,
            b: currentColor.b,
            a: 1
        },
        {
            r: secondaryColor.r,
            g: secondaryColor.g,
            b: secondaryColor.b,
            a: 1
        }
    ];
    const colorOptions = new (0, $115e148fb390275d$export$24ba9b81662d4366)({
        colorArr: colorOptionsArr,
        initialIndex: 0,
        onChange: function(rgbaObj) {
            backgroundRgba = rgbaObj;
            preview.style.backgroundColor = 'rgba(' + rgbaObj.r + ',' + rgbaObj.g + ',' + rgbaObj.b + ', ' + rgbaObj.a + ')';
        }
    });
    const previewWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: 'kl-transparent-preview',
        css: {
            boxSizing: 'border-box',
            width: 340,
            height: 140,
            display: 'table',
            padding: 10,
            marginTop: 10,
            marginLeft: -20,
            background: 'var(--kl-checkerboard-background)'
        }
    });
    const preview = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: 'kl-transparent-preview__canvas',
        css: {
            width: 200,
            height: 100,
            backgroundColor: 'rgba(' + backgroundRgba.r + ',' + backgroundRgba.g + ',' + backgroundRgba.b + ', ' + backgroundRgba.a + ')',
            marginLeft: 'auto',
            marginRight: 'auto',
            color: '#aaa',
            fontSize: 16,
            fontWeight: 'bold',
            textAlign: 'center',
            verticalAlign: 'center',
            display: 'table',
            overflow: 'hidden'
        }
    });
    (0, $be957da3610487e9$export$921068d8846a1559).el({
        parent: previewWrapper,
        content: preview,
        css: {
            display: 'table-cell',
            verticalAlign: 'middle'
        }
    });
    (0, $be957da3610487e9$export$921068d8846a1559).el({
        parent: preview,
        css: {
            display: 'table-cell',
            verticalAlign: 'middle'
        }
    });
    function updateRatio() {
        function hcf(u, v) {
            let U = u, V = v;
            while(true){
                if (!(U %= V)) return V;
                if (!(V %= U)) return U;
            }
        }
        let w = widthInput.getValue();
        let h = heightInput.getValue();
        //generated canvas size doesn't always match ratio. so check if a common ratio is very close
        const commonRatios = [
            [
                1,
                2
            ],
            [
                2,
                1
            ],
            [
                2,
                3
            ],
            [
                3,
                2
            ],
            [
                3,
                4
            ],
            [
                4,
                3
            ],
            [
                4,
                5
            ],
            [
                5,
                4
            ],
            [
                16,
                9
            ],
            [
                9,
                16
            ],
            [
                3,
                2
            ],
            [
                2,
                3
            ],
            [
                5,
                3
            ],
            [
                3,
                5
            ],
            [
                2,
                1
            ],
            [
                1,
                2
            ],
            [
                1.414,
                1
            ],
            [
                1,
                1.414
            ]
        ];
        const reducedArr = (0, $be957da3610487e9$export$921068d8846a1559).reduce(w, h);
        let closestRatio = commonRatios[0];
        let closestDistance = Math.abs(commonRatios[0][0] / commonRatios[0][1] - reducedArr[0] / reducedArr[1]);
        for(let i = 0; i < commonRatios.length; i++)if (Math.abs(commonRatios[i][0] / commonRatios[i][1] - reducedArr[0] / reducedArr[1]) < closestDistance) {
            closestRatio = commonRatios[i];
            closestDistance = Math.abs(commonRatios[i][0] / commonRatios[i][1] - reducedArr[0] / reducedArr[1]);
        }
        //display ratio
        if (closestDistance > 0 && closestDistance < 0.005) ratioWrapper.innerText = (0, $fc42a07754814920$export$ce37e184d908d785)('new-ratio') + ': ~' + closestRatio[0] + ':' + closestRatio[1];
        else ratioWrapper.innerText = (0, $fc42a07754814920$export$ce37e184d908d785)('new-ratio') + ': ' + reducedArr[0] + ':' + reducedArr[1];
        const realw = w;
        const T = hcf(w, h);
        w /= T;
        h /= T;
        w *= 260;
        h *= 260;
        if (w > 260) {
            h = 260 / w * h;
            w = 260;
        }
        if (h > 100) {
            w = 100 / h * w;
            h = 100;
        }
        preview.style.width = w + 'px';
        preview.style.height = h + 'px';
        previewWrapper.style.backgroundSize = Math.round(Math.max(4, 60 * (w / realw))) + 'px';
    }
    updateRatio();
    newImDiv.append(templateWrapper);
    const secondRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
        parent: newImDiv,
        css: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end'
        }
    });
    const secondRowLeft = (0, $be957da3610487e9$export$921068d8846a1559).el({
        parent: secondRow
    });
    secondRowLeft.append(sizeTable, ratioWrapper);
    secondRow.append(colorOptions.getElement());
    newImDiv.append(previewWrapper);
    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $fc42a07754814920$export$ce37e184d908d785)('new-title')}</b>`,
        div: newImDiv,
        buttons: [
            'Ok',
            'Cancel'
        ],
        callback: function(result) {
            destroyer.destroy();
            select.destroy();
            colorOptions.destroy();
            widthInput.destroy();
            heightInput.destroy();
            if (result === 'Cancel') {
                onCancel();
                return;
            }
            onConfirm(widthInput.getValue(), heightInput.getValue(), backgroundRgba);
        },
        clickOnEnter: 'Ok'
    });
}





const $0fd797091a3b795f$var$collapseImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('ui-collapse');
class $0fd797091a3b795f$export$5b91f641162972fc {
    update() {
        if (this.orientation === 'left') this.icon.style.transform = this.stateIsOpen ? 'rotate(180deg)' : '';
        else this.icon.style.transform = this.stateIsOpen ? '' : 'rotate(180deg)';
    }
    // ---- interface ----
    isOpen() {
        return this.stateIsOpen;
    }
    setIsOpen(b) {
        this.stateIsOpen = b;
        this.update();
    }
    setOrientation(dirStr) {
        this.orientation = dirStr;
        this.update();
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.stateIsOpen = true;
        this.orientation = 'right';
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-toolspace-toggle',
            css: {
                width: 36,
                height: 36,
                background: 'var(--canvas-overlay-bg)',
                color: '#fff',
                textAlign: 'center',
                lineHeight: '36px',
                cursor: 'pointer',
                userSelect: 'none',
                padding: 6,
                boxSizing: 'border-box'
            },
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('toggle-show-tools'),
            onClick: (e)=>{
                e.preventDefault();
                this.stateIsOpen = !this.stateIsOpen;
                this.update();
                p.onChange();
            }
        });
        this.icon = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                backgroundImage: `url(${$0fd797091a3b795f$var$collapseImg})`,
                width: '100%',
                height: '100%',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                userSelect: 'none'
            }
        });
        this.update();
        this.rootEl.oncontextmenu = ()=>{
            return false;
        };
    }
}










class $e4157c295dab4057$export$5cdfb22682d2a5dd {
    getElement() {
        return this.rootEl;
    }
    getValues() {
        const c = this.colorOptions.getValue();
        if (c === null || c?.a === 0) return {
            fill: undefined
        };
        const color = {
            ...c,
            a: this.opacitySlider.getValue()
        };
        return {
            fill: {
                color: color
            }
        };
    }
    destroy() {
        this.colorOptions.destroy();
        this.opacitySlider.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        const emit = ()=>{
            p.onUpdate(this.getValues());
        };
        const colorOptionsArr = [
            null,
            p.fill ? {
                ...p.fill.color,
                a: 1
            } : null,
            {
                ...p.primaryColor,
                a: 1
            },
            {
                ...p.secondaryColor,
                a: 1
            },
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }
        ];
        this.colorOptions = new (0, $115e148fb390275d$export$24ba9b81662d4366)({
            colorArr: colorOptionsArr,
            initialIndex: p.fill ? 1 : 0,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-fill'),
            onChange: (c)=>{
                this.opacitySlider.getElement().style.display = c !== null ? '' : 'none';
                emit();
            }
        });
        this.opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
            width: 150,
            height: 30,
            min: 0.01,
            max: 1,
            value: p.fill ? p.fill.color.a : 1,
            resolution: 225,
            eventResMs: 1000 / 30,
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100,
            onChange: ()=>emit()
        });
        this.opacitySlider.getElement().style.display = p.fill ? '' : 'none';
        const svg = (0, $94f0b2b810d4d191$export$c54fe3b9ecaa84cf)({
            elementType: 'svg',
            class: 'dark-invert',
            width: '25px',
            height: '25px',
            viewBox: '0 0 30 30',
            childrenArr: [
                {
                    elementType: 'polyline',
                    points: '0,0 30,0 30,8 19,8 19,30 11,30 11,8 0,8 0,0 1,0',
                    'transform-origin': '15px 15px',
                    transform: 'scale(0.8)',
                    fill: '#000c'
                }
            ]
        });
        this.rootEl = (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,gap-10,items-center,flexWrap,minh-30', [
            svg,
            this.colorOptions.getElement(),
            this.opacitySlider.getElement()
        ]);
    }
}











var $d2134eb99fdf3fa4$exports = {};
$d2134eb99fdf3fa4$exports = $parcel$resolve("fc1zd");


var $d4944451d0496e65$exports = {};
$d4944451d0496e65$exports = $parcel$resolve("4qRL3");


var $c595842b0fb5abfe$exports = {};
$c595842b0fb5abfe$exports = $parcel$resolve("2B7B7");


var $ef7bdf1056900860$exports = {};
$ef7bdf1056900860$exports = $parcel$resolve("eD12I");


var $9520bb89a0a342de$exports = {};
$9520bb89a0a342de$exports = $parcel$resolve("5457Z");


var $35b3d957f91294b8$exports = {};
$35b3d957f91294b8$exports = $parcel$resolve("1Ei10");


var $0b6772ea74482114$exports = {};
$0b6772ea74482114$exports = $parcel$resolve("7aQdb");


var $6e63d5fe783731a1$exports = {};
$6e63d5fe783731a1$exports = $parcel$resolve("9fGBZ");


var $3f92d62774e68862$exports = {};
$3f92d62774e68862$exports = $parcel$resolve("byuQe");


var $9769b90679b4dde6$exports = {};
$9769b90679b4dde6$exports = $parcel$resolve("iJp7R");


var $16310dc7f06a7c34$exports = {};
$16310dc7f06a7c34$exports = $parcel$resolve("asUYV");


var $af71f096c1d7c1df$exports = {};
$af71f096c1d7c1df$exports = $parcel$resolve("9tbSO");


var $c2270e2632610e40$exports = {};
$c2270e2632610e40$exports = $parcel$resolve("5eBTn");


var $f8fc31e7027a53d8$exports = {};
$f8fc31e7027a53d8$exports = $parcel$resolve("5A31c");


var $e5d676fb9748f6d5$exports = {};
$e5d676fb9748f6d5$exports = $parcel$resolve("jSUxb");


var $3f2455749887e818$exports = {};
$3f2455749887e818$exports = $parcel$resolve("fFcMC");


const $f3ac06e4406a6cdc$export$826128ff895ed268 = [
    {
        name: 'Caveat',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($d2134eb99fdf3fa4$exports)))
    },
    {
        name: 'ClimateCrisis',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($d4944451d0496e65$exports)))
    },
    {
        name: 'CorrectionBrush',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($c595842b0fb5abfe$exports)))
    },
    {
        name: 'DancingScript',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($ef7bdf1056900860$exports)))
    },
    {
        name: 'Diabolik',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($9520bb89a0a342de$exports)))
    },
    {
        name: 'FreckleFace',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($35b3d957f91294b8$exports)))
    },
    {
        name: 'Gloock',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($0b6772ea74482114$exports)))
    },
    {
        name: 'GochiHand',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($3f92d62774e68862$exports)))
    },
    {
        name: 'Pacha',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($6e63d5fe783731a1$exports)))
    },
    {
        name: 'PassionOne',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($9769b90679b4dde6$exports)))
    },
    {
        name: 'PixeloidSans',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($16310dc7f06a7c34$exports)))
    },
    {
        name: 'PlaypenSans',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($af71f096c1d7c1df$exports)))
    },
    {
        name: 'Quicksand',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($c2270e2632610e40$exports)))
    },
    {
        name: 'Silkscreen',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($f8fc31e7027a53d8$exports)))
    },
    {
        name: 'Tehroc',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($e5d676fb9748f6d5$exports)))
    },
    {
        name: 'YUNGA',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($3f2455749887e818$exports)))
    }
];



const $781e11de61455bbc$var$alignLeftImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('align-left');
const $781e11de61455bbc$var$alignCenterImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('align-center');
const $781e11de61455bbc$var$alignRightImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('align-right');
const $781e11de61455bbc$var$typoItalicImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('typo-italic');
const $781e11de61455bbc$var$typoBoldImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('typo-bold');
const $781e11de61455bbc$var$importedFonts = [
    {
        fontFamily: 'sans-serif',
        fontName: 'Sans-serif'
    },
    {
        fontFamily: 'serif',
        fontName: 'Serif'
    },
    {
        fontFamily: 'monospace',
        fontName: 'Monospace'
    },
    {
        fontFamily: 'cursive',
        fontName: 'Cursive'
    },
    {
        fontFamily: 'fantasy',
        fontName: 'Fantasy'
    },
    ...(0, $f3ac06e4406a6cdc$export$826128ff895ed268).map((item)=>{
        return {
            fontFamily: item.name,
            fontName: item.name
        };
    })
];
let $781e11de61455bbc$var$didLoadBundledFonts = false;
async function $781e11de61455bbc$var$loadBundledFonts() {
    if ($781e11de61455bbc$var$didLoadBundledFonts) return;
    $781e11de61455bbc$var$didLoadBundledFonts = true;
    const promises = (0, $f3ac06e4406a6cdc$export$826128ff895ed268).map(async (item)=>{
        const response = await fetch(item.url);
        const buffer = await response.arrayBuffer();
        const font = new FontFace(item.name, buffer);
        // await font.load();
        document.fonts.add(font);
    });
    await Promise.all(promises);
}
class $781e11de61455bbc$export$2e7faedafda1fc85 {
    // only load fonts when interacting with the font input
    loadBundledFonts() {
        !$781e11de61455bbc$var$didLoadBundledFonts && $781e11de61455bbc$var$loadBundledFonts().then(()=>{
            this.onUpdate({
                font: this.fontSelect.getValue()
            });
        });
    }
    importFont() {
        const acceptedExtensions = [
            'ttf',
            'otf',
            'woff',
            'woff2',
            'eot'
        ];
        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.accept = acceptedExtensions.map((item)=>'.' + item).join(', ');
        input.focus();
        input.click();
        input.onchange = async ()=>{
            if (!input.files || input.files.length === 0) return;
            let toSelect = undefined;
            const failedToLoadFilenames = [];
            let acceptedAtLeastOne = false;
            const fontFamilies = $781e11de61455bbc$var$importedFonts.map((i)=>i.fontFamily);
            for(let i = 0; i < input.files.length; i++){
                const file = input.files[i];
                const fontName = 'kl-' + $781e11de61455bbc$var$importedFonts.length;
                if (fontFamilies.includes(fontName)) continue;
                if (!toSelect) {
                    toSelect = fontName;
                    this.importButton.disabled = true;
                    this.importButton.innerText = (0, $fc42a07754814920$export$ce37e184d908d785)('loading');
                }
                const split = file.name.split('.');
                split.pop();
                $781e11de61455bbc$var$importedFonts.push({
                    fontFamily: fontName,
                    fontName: split.join('.')
                });
                const font = new FontFace(fontName, await file.arrayBuffer());
                try {
                    await font.load();
                    document.fonts.add(font);
                    acceptedAtLeastOne = true;
                } catch (err) {
                    failedToLoadFilenames.push(file.name);
                }
            }
            if (failedToLoadFilenames.length > 0) (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    (0, $fc42a07754814920$export$ce37e184d908d785)('text-failed-import'),
                    (0, $8405ecc79d32770a$export$db3b6bfb95261072)('br'),
                    failedToLoadFilenames.join(', '),
                    (0, $8405ecc79d32770a$export$db3b6bfb95261072)('br'),
                    (0, $8405ecc79d32770a$export$db3b6bfb95261072)('br'),
                    (0, $fc42a07754814920$export$ce37e184d908d785)('text-supported-formats'),
                    (0, $8405ecc79d32770a$export$db3b6bfb95261072)('br'),
                    acceptedExtensions.join(', ')
                ]
            }));
            if (!acceptedAtLeastOne) {
                this.importButton.disabled = false;
                this.importButton.innerText = (0, $fc42a07754814920$export$ce37e184d908d785)('file-import');
                return;
            }
            // update font selection
            setTimeout(()=>{
                this.fontSelect.setOptionArr($781e11de61455bbc$var$importedFonts.map((i)=>{
                    return [
                        i.fontFamily,
                        i.fontName,
                        {
                            css: {
                                fontFamily: i.fontFamily,
                                fontSize: '1.2em'
                            }
                        }
                    ];
                }));
                this.fontSelect.setValue(toSelect);
                this.onUpdate({
                    font: toSelect
                });
                this.importButton.disabled = false;
                this.importButton.innerText = (0, $fc42a07754814920$export$ce37e184d908d785)('file-import');
            });
        };
    }
    getElement() {
        return this.rootEl;
    }
    getValues() {
        return {
            font: this.fontSelect.getValue(),
            size: +this.sizeInput.getValue(),
            letterSpacing: +this.letterSpacingInput.getValue(),
            lineHeight: +this.lineHeightInput.getValue(),
            align: this.alignRadioList.getValue(),
            isItalic: this.italicToggle.getValue(),
            isBold: this.boldToggle.getValue()
        };
    }
    destroy() {
        this.fontPointerListener.destroy();
        this.fontSelect.getElement().removeEventListener('focus', this.onFocus);
        this.fontSelect.destroy();
        this.destroyer.destroy();
        this.sizeInput.destroy();
        this.lineHeightInput.destroy();
        this.letterSpacingInput.destroy();
        this.alignRadioList.destroy();
        this.italicToggle.destroy();
        this.boldToggle.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.onUpdate = p.onUpdate;
        this.fontSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
            initValue: p.font,
            optionArr: $781e11de61455bbc$var$importedFonts.map((i)=>{
                return [
                    i.fontFamily,
                    i.fontName,
                    {
                        css: {
                            fontFamily: i.fontFamily,
                            fontSize: '1.2em'
                        }
                    }
                ];
            }),
            isFocusable: true,
            css: {
                width: 180
            },
            onChange: (v)=>{
                this.loadBundledFonts();
                p.onUpdate({
                    font: v
                });
            },
            name: 'font'
        });
        this.onFocus = ()=>this.loadBundledFonts();
        this.fontSelect.getElement().addEventListener('focus', this.onFocus);
        this.fontPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.fontSelect.getElement(),
            onWheel: (e)=>this.fontSelect.setDeltaValue(e.deltaY)
        });
        this.importButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('file-import'),
            destroyer: this.destroyer,
            onClick: ()=>{
                this.importFont();
            }
        });
        const sizeLabel = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'span',
                    content: 'A',
                    css: {
                        fontSize: '0.6em'
                    }
                }),
                'A'
            ],
            css: {
                width: 25,
                height: 25,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '1.2em',
                userSelect: 'none'
            }
        });
        this.sizeInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('text-size'),
            type: 'number',
            min: 0,
            max: 1000,
            init: p.size,
            onChange: (v)=>{
                p.onUpdate({
                    size: v
                });
            },
            css: {
                width: 70
            },
            name: 'font-size'
        });
        this.lineHeightInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('text-line-height'),
            type: 'number',
            min: 0,
            max: 10,
            step: 0.1,
            init: p.lineHeight ?? 1,
            onChange: (v)=>{
                p.onUpdate({
                    lineHeight: v
                });
            },
            css: {
                width: 60
            },
            name: 'line-height'
        });
        this.letterSpacingInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('text-letter-spacing'),
            type: 'number',
            min: -100,
            max: 100,
            init: p.letterSpacing ?? 0,
            onChange: (v)=>{
                p.onUpdate({
                    letterSpacing: v
                });
            },
            css: {
                width: 60
            },
            name: 'letter-spacing'
        });
        this.alignRadioList = new (0, $f3056e554051c8ed$export$7cc1012a658e6ad8)({
            optionArr: [
                {
                    id: 'left',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('text-left'),
                    image: $781e11de61455bbc$var$alignLeftImg,
                    darkInvert: true
                },
                {
                    id: 'center',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('text-center'),
                    image: $781e11de61455bbc$var$alignCenterImg,
                    darkInvert: true
                },
                {
                    id: 'right',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('text-right'),
                    image: $781e11de61455bbc$var$alignRightImg,
                    darkInvert: true
                }
            ],
            initId: p.align,
            onChange: (v)=>p.onUpdate({
                    align: v
                })
        });
        this.italicToggle = new (0, $fdd030cdfa4412e2$export$b6d053cded550773)({
            image: $781e11de61455bbc$var$typoItalicImg,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('text-italic'),
            initValue: p.isItalic,
            onChange: (v)=>p.onUpdate({
                    isItalic: v
                }),
            darkInvert: true
        });
        this.boldToggle = new (0, $fdd030cdfa4412e2$export$b6d053cded550773)({
            image: $781e11de61455bbc$var$typoBoldImg,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('text-bold'),
            initValue: p.isBold,
            onChange: (v)=>p.onUpdate({
                    isBold: v
                }),
            darkInvert: true
        });
        this.rootEl = (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,flexWrap,gap-10-15,items-center', [
            (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,gap-5,items-center', [
                sizeLabel,
                this.sizeInput.getElement()
            ]),
            (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,gap-5', [
                this.fontSelect.getElement(),
                this.importButton
            ]),
            (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,gap-7', [
                this.alignRadioList.getElement(),
                this.italicToggle.getElement(),
                this.boldToggle.getElement()
            ]),
            this.letterSpacingInput.getElement(),
            this.lineHeightInput.getElement()
        ]);
    }
}








class $ad2e43550e069f2e$export$42bb0e3b48d549f6 {
    getElement() {
        return this.rootEl;
    }
    getValues() {
        const c = this.colorOptions.getValue();
        if (c === null || c?.a === 0) return {
            stroke: undefined
        };
        const color = {
            ...c,
            a: this.opacitySlider.getValue()
        };
        return {
            stroke: {
                color: color,
                lineWidth: this.lineWidthSlider.getValue()
            }
        };
    }
    destroy() {
        this.colorOptions.destroy();
        this.opacitySlider.destroy();
        this.lineWidthSlider.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                boxShadow: '0 0 0 1px #aaa'
            }
        });
        const emit = ()=>{
            p.onUpdate(this.getValues());
        };
        const colorOptionsArr = [
            null,
            p.stroke ? {
                ...p.stroke.color,
                a: 1
            } : null,
            {
                ...p.secondaryColor,
                a: 1
            },
            {
                ...p.primaryColor,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            }
        ];
        this.colorOptions = new (0, $115e148fb390275d$export$24ba9b81662d4366)({
            colorArr: colorOptionsArr,
            initialIndex: p.stroke ? 1 : 0,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-stroke'),
            onChange: (c)=>{
                this.opacitySlider.getElement().style.display = c !== null ? '' : 'none';
                this.lineWidthSlider.getElement().style.display = c !== null ? '' : 'none';
                emit();
            }
        });
        this.opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
            width: 150,
            height: 30,
            min: 0.01,
            max: 1,
            value: p.stroke ? p.stroke.color.a : 1,
            resolution: 225,
            eventResMs: 1000 / 30,
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100,
            onChange: ()=>emit()
        });
        this.lineWidthSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-line-width'),
            width: 150,
            height: 30,
            min: 0.5,
            max: 100,
            value: p.stroke ? p.stroke.lineWidth : 2,
            eventResMs: 1000 / 30,
            curve: 'quadratic',
            onChange: ()=>emit()
        });
        this.opacitySlider.getElement().style.display = p.stroke ? '' : 'none';
        this.lineWidthSlider.getElement().style.display = p.stroke ? '' : 'none';
        const svg = (0, $94f0b2b810d4d191$export$c54fe3b9ecaa84cf)({
            elementType: 'svg',
            class: 'dark-invert',
            width: '25px',
            height: '25px',
            viewBox: '0 0 30 30',
            childrenArr: [
                {
                    elementType: 'polyline',
                    points: '0,0 30,0 30,8 19,8 19,30 11,30 11,8 0,8 0,0 1,0',
                    fill: 'none',
                    stroke: '#000c',
                    'stroke-width': '3',
                    'transform-origin': '15px 15px',
                    transform: 'scale(0.8)'
                }
            ]
        });
        this.rootEl = (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,gap-10,items-center,flexWrap,minh-30', [
            svg,
            this.colorOptions.getElement(),
            this.opacitySlider.getElement(),
            this.lineWidthSlider.getElement()
        ]);
    }
}






class $9df21e15bd35e893$export$c6656360602b35c2 {
    emit() {
        const text = this.textInput.value;
        if (text === this.lastEmittedText) return;
        this.lastEmittedText = text;
        this.onUpdate({
            text: text
        });
    }
    getElement() {
        return this.rootEl;
    }
    getValues() {
        return {
            text: this.textInput.value
        };
    }
    focus() {
        this.textInput.focus();
    }
    destroy() {
        this.destroyer.destroy();
        this.textInput.removeEventListener('input', this.onInput);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.onInput = ()=>{
            this.emit();
        };
        this.lastEmittedText = p.text;
        this.onUpdate = p.onUpdate;
        this.rootEl = (0, $8405ecc79d32770a$export$db3b6bfb95261072)('');
        this.textInput = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'textarea',
            parent: this.rootEl,
            content: p.text,
            destroyer: this.destroyer,
            props: {
                placeholder: (0, $fc42a07754814920$export$ce37e184d908d785)('text-placeholder')
            },
            css: {
                whiteSpace: 'pre',
                overflow: 'auto',
                width: '100%',
                height: 70,
                resize: 'vertical'
            },
            onChange: ()=>{
                this.emit();
            }
        });
        this.textInput.addEventListener('input', this.onInput);
    }
}













const $099ab81d0ff36d13$var$toolZoomInImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-zoom-in');
const $099ab81d0ff36d13$var$toolZoomOutImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-zoom-out');
class $099ab81d0ff36d13$export$1d311696e0fb2158 {
    canZoom(d) {
        return this.zoomFac !== Math.min(2, Math.max(-2, this.zoomFac + d));
    }
    changeZoomFac(d) {
        this.zoomFac = Math.min(2, Math.max(-2, this.zoomFac + d));
        this.render();
        this.zoomInBtn.disabled = !this.canZoom(1);
        this.zoomOutBtn.disabled = !this.canZoom(-1);
    }
    // Move text by x y
    move(x, y) {
        const rotated = (0, $be957da3610487e9$export$921068d8846a1559).rotate(x, y, -this.rotationSlider.getValue() / Math.PI * 180);
        this.text.x += rotated.x / this.scale;
        this.text.y += rotated.y / this.scale;
        this.render();
    }
    render() {
        // try to draw very much like klCanvasWorkspace
        const angleRad = this.rotationSlider.getValue();
        // --- draw text ---
        this.textCtx.clearRect(0, 0, this.textCanvas.width, this.textCanvas.height);
        const bounds = (0, $7f7fc3a72d8b806e$export$482c90f94eb9717c)(this.textCanvas, {
            ...this.text,
            x: this.text.x,
            y: this.text.y,
            angleRad: this.rotationSlider.getValue()
        }, this.selectionPath);
        // transform offset
        const transformedOffset = (0, $be957da3610487e9$export$921068d8846a1559).Vec2.mul((0, $be957da3610487e9$export$921068d8846a1559).rotate(this.offset.x, this.offset.y, -angleRad / Math.PI * 180), 1 / this.scale);
        // --- determine transformation of viewport ---
        // text should always be visible
        bounds.x -= 3;
        bounds.y -= 3;
        bounds.width += 6;
        bounds.height += 6;
        const rotatedXY = (0, $be957da3610487e9$export$921068d8846a1559).rotate(bounds.x, bounds.y, -angleRad / Math.PI * 180);
        const rotatedWH = (0, $be957da3610487e9$export$921068d8846a1559).rotate(bounds.width, bounds.height, -angleRad / Math.PI * 180);
        const centerX = this.text.x + rotatedXY.x + rotatedWH.x / 2 + transformedOffset.x;
        const centerY = this.text.y + rotatedXY.y + rotatedWH.y / 2 + transformedOffset.y;
        const padding = 100;
        const fitBounds = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(bounds.width, bounds.height, this.width - padding, this.height - padding);
        this.scale = Math.min(1, fitBounds.width / bounds.width);
        this.scale = Math.min(4, this.scale * 2 ** this.zoomFac);
        // --- compose text and target layer ---
        this.targetCtx.save();
        if (this.scale >= 4) this.targetCtx.imageSmoothingEnabled = false;
        else {
            this.targetCtx.imageSmoothingEnabled = true;
            this.targetCtx.imageSmoothingQuality = this.scale >= 1 ? 'low' : 'medium';
        }
        this.targetCtx.clearRect(0, 0, this.previewCanvas.width, this.previewCanvas.height);
        this.targetCtx.translate(this.width / 2, this.height / 2);
        this.targetCtx.scale(this.scale, this.scale);
        this.targetCtx.rotate(angleRad);
        this.targetCtx.drawImage(this.layerArr[this.layerIndex].canvas, -centerX, -centerY);
        this.targetCtx.drawImage(this.textCanvas, -centerX, -centerY);
        this.targetCtx.restore();
        const isDark = (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).isDark();
        // --- layers ---
        this.layersCtx.save();
        this.layersCtx.fillStyle = isDark ? 'rgb(33,33,33)' : 'rgb(158,158,158)';
        this.layersCtx.fillRect(0, 0, this.width, this.height);
        {
            // bg
            this.layersCtx.save();
            this.layersCtx.translate(this.width / 2, this.height / 2);
            this.layersCtx.scale(this.scale, this.scale);
            this.layersCtx.rotate(angleRad);
            this.layersCtx.imageSmoothingEnabled = false;
            //outline
            const borderSize = 1 / this.scale;
            this.layersCtx.globalAlpha = isDark ? 0.25 : 0.2;
            this.layersCtx.drawImage(isDark ? this.emptyCanvasLight : this.emptyCanvas, -centerX - borderSize, -centerY - borderSize, this.textCanvas.width + borderSize * 2, this.textCanvas.height + borderSize * 2);
            this.layersCtx.globalAlpha = 1;
            //erase
            this.layersCtx.globalCompositeOperation = 'destination-out';
            this.layersCtx.drawImage(this.emptyCanvas, -centerX, -centerY, this.textCanvas.width, this.textCanvas.height);
            this.layersCtx.restore();
        }
        // individual layers
        if (this.scale >= 4) this.layersCtx.imageSmoothingEnabled = false;
        else {
            this.layersCtx.imageSmoothingEnabled = true;
            this.layersCtx.imageSmoothingQuality = this.scale >= 1 ? 'low' : 'medium';
        }
        this.compositor.draw(this.layersCtx, this.layerArr, this.width, this.height, (ctx, layer)=>{
            const layerIndex = this.layerArr.indexOf(layer);
            if (layerIndex === this.layerIndex) ctx.drawImage(this.targetCanvas, 0, 0);
            else {
                ctx.save();
                ctx.translate(this.width / 2, this.height / 2);
                ctx.scale(this.scale, this.scale);
                ctx.rotate(angleRad);
                ctx.drawImage(this.layerArr[layerIndex].canvas, -centerX, -centerY);
                ctx.restore();
            }
        });
        this.layersCtx.restore();
        // --- final composite ---
        this.previewCtx.save();
        this.previewCtx.fillStyle = this.checkerPattern;
        this.previewCtx.fillRect(0, 0, this.previewCanvas.width, this.previewCanvas.height);
        this.previewCtx.drawImage(this.layersCanvas, 0, 0);
        this.previewCtx.restore();
        if (this.selectionPath) {
            const selectionPath = new Path2D();
            selectionPath.addPath(this.selectionPath, new DOMMatrix().translate(this.width / 2, this.height / 2).scale(this.scale).rotate(angleRad / Math.PI * 180).translate(-centerX, -centerY));
            this.previewCtx.save();
            this.previewCtx.setLineDash([
                4
            ]);
            this.previewCtx.lineWidth = 1;
            this.previewCtx.strokeStyle = '#000';
            this.previewCtx.stroke(selectionPath);
            this.previewCtx.lineDashOffset = 4;
            this.previewCtx.strokeStyle = '#fff';
            this.previewCtx.stroke(selectionPath);
            this.previewCtx.restore();
        }
        // bounds
        this.previewCtx.save();
        this.previewCtx.globalCompositeOperation = 'difference';
        this.previewCtx.strokeStyle = '#fff';
        this.previewCtx.lineWidth = 0.5;
        this.previewCtx.translate(-this.offset.x, -this.offset.y);
        this.previewCtx.strokeRect(Math.round(this.width / 2 - bounds.width / 2 * this.scale) + 0.5, Math.round(this.height / 2 - bounds.height / 2 * this.scale) + 0.5, Math.round(bounds.width * this.scale), Math.round(bounds.height * this.scale));
        this.previewCtx.restore();
    }
    getElement() {
        return this.rootEl;
    }
    getInputsElement() {
        return this.inputsRootEl;
    }
    getValues() {
        return {
            x: this.text.x,
            y: this.text.y,
            angleRad: this.rotationSlider.getValue()
        };
    }
    setText(text) {
        const x = this.text.x;
        const y = this.text.y;
        const angleRad = this.text.angleRad;
        this.text = {
            ...text,
            x: x,
            y: y,
            angleRad: angleRad
        };
        this.render();
    }
    setSize(width, height) {
        // prevents: Failed to execute 'drawImage' on 'CanvasRenderingContext2D':
        // The image argument is a canvas element with a width or height of 0.
        width = Math.max(1, width);
        height = Math.max(1, height);
        if (width === this.width && height === this.height) return;
        this.width = width;
        this.height = height;
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.targetCanvas, this.width, this.height);
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.layersCanvas, this.width, this.height);
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.previewCanvas, this.width, this.height);
        this.previewWrapper.style.width = this.width + 'px';
        this.render();
    }
    destroy() {
        clearInterval(this.interval);
        this.rotationSlider.destroy();
        this.destroyer.destroy();
        this.eventCapture.remove();
        this.previewPointerListener.destroy();
        this.keyListener.destroy();
        this.compositor.destroy();
        (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).removeIsDarkListener(this.onDarkChange);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.offset = {
            x: 0,
            y: 0
        };
        this.zoomFac = 0;
        this.scale = 1;
        this.layerArr = [];
        this.compositor = new (0, $7db1a448998b9957$export$fca65d4bf5f27b48)();
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.onDarkChange = ()=>{
            this.checkerPattern = (0, $94f0b2b810d4d191$export$b813e062795b89b5)(this.previewCtx.createPattern((0, $be957da3610487e9$export$921068d8846a1559).createCheckerCanvas(8, (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).isDark()), 'repeat'));
            this.render();
        };
        this.rootEl = (0, $8405ecc79d32770a$export$db3b6bfb95261072)();
        this.text = p.text;
        this.layerIndex = p.layerIndex;
        const selection = p.klCanvas.getSelection();
        this.selectionPath = selection ? new Path2D((0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(selection)) : undefined;
        const isSmallWidth = window.innerWidth < 550;
        const isSmallHeight = window.innerHeight < 630;
        // --- preview ---
        // Text drawn on klCanvas-sized canvas: textCanvas
        // LayerArr[target].canvas & textCanvas then drawn on targetCanvas
        //      they are transformed. canvas size of final preview
        // All layers and targetCanvas drawn on layersCanvas. transformed and size of final preview
        // Checkerboard, layersCanvas, and outline then drawn on previewCanvas
        this.width = isSmallWidth ? 340 : 540;
        this.height = isSmallWidth ? isSmallHeight ? 210 : 260 : isSmallHeight ? 230 : 350;
        this.layerArr = p.klCanvas.getLayers();
        this.textCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(p.klCanvas.getWidth(), p.klCanvas.getHeight());
        this.textCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.textCanvas);
        this.targetCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.width, this.height);
        this.targetCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.targetCanvas);
        this.layersCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.width, this.height);
        this.layersCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.layersCanvas);
        this.previewCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.width, this.height); // the one that is visible
        this.previewCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.previewCanvas);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.previewCanvas, {
            display: 'block'
        });
        this.previewWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                position: 'relative',
                width: this.width,
                cursor: 'move',
                touchAction: 'none'
            }
        });
        (0, $be957da3610487e9$export$921068d8846a1559).el({
            // inset shadow on preview
            parent: this.previewWrapper,
            className: 'kl-text-preview-wrapper'
        });
        this.previewWrapper.append(this.previewCanvas);
        this.checkerPattern = (0, $94f0b2b810d4d191$export$b813e062795b89b5)(this.previewCtx.createPattern((0, $be957da3610487e9$export$921068d8846a1559).createCheckerCanvas(8, (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).isDark()), 'repeat'));
        this.emptyCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(1, 1);
        this.emptyCanvasLight = (0, $be957da3610487e9$export$921068d8846a1559).canvas(1, 1);
        {
            let ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.emptyCanvas);
            ctx.fillRect(0, 0, 1, 1);
            ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.emptyCanvasLight);
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, 1, 1);
        }
        (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).addIsDarkListener(this.onDarkChange);
        this.previewCanvas.oncontextmenu = (e)=>e.preventDefault();
        let dragged = false;
        let isDown = false;
        let offsetDragged = false;
        this.previewPointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.previewCanvas,
            onPointer: (e)=>{
                // drag detect
                if (e.type === 'pointerdown') {
                    dragged = false;
                    isDown = true;
                }
                if (e.type === 'pointermove' && isDown) dragged = true;
                if (e.type === 'pointerup') {
                    if (isDown && dragged && e.pointerType === 'mouse') // With touch/pen it would be annoying to focus again,
                    // because it probably pops out the keyboard.
                    p.onDragEnd();
                    dragged = false;
                    isDown = false;
                }
                if (e.type === 'pointermove' && e.button === 'left') {
                    e.eventPreventDefault();
                    this.offset = {
                        x: 0,
                        y: 0
                    };
                    this.move(-e.dX, -e.dY);
                }
                if (e.type === 'pointerdown' && e.button === 'right') document.body.append(this.eventCapture);
                if (e.type === 'pointerup') setTimeout(()=>this.eventCapture.remove(), 20);
                if (e.type === 'pointermove' && e.button === 'right') {
                    offsetDragged = true;
                    e.eventPreventDefault();
                    this.offset.x -= e.dX;
                    this.offset.y -= e.dY;
                    this.render();
                }
                if (e.type === 'pointerup' && offsetDragged) {
                    let count = 0;
                    clearInterval(this.interval);
                    this.interval = setInterval(()=>{
                        if (count > 8) {
                            clearInterval(this.interval);
                            this.offset = {
                                x: 0,
                                y: 0
                            };
                            this.render();
                        }
                        this.offset = {
                            x: this.offset.x * 0.6,
                            y: this.offset.y * 0.6
                        };
                        this.render();
                        count++;
                    }, 10);
                    this.offset = {
                        x: this.offset.x * 0.6,
                        y: this.offset.y * 0.6
                    };
                    this.render();
                }
            },
            onWheel: (e)=>{
                e.event?.preventDefault();
                this.changeZoomFac(-e.deltaY);
            },
            useDirtyWheel: true
        });
        this.rotationSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-rotation'),
            width: 150,
            height: 30,
            min: -Math.PI,
            max: Math.PI,
            value: p.text.angleRad,
            resolution: 225,
            // eventResMs: 1000 / 30,
            toValue: (deg)=>deg * Math.PI / 180,
            toDisplayValue: (rad)=>rad / Math.PI * 180,
            onChange: ()=>{
                this.offset = {
                    x: 0,
                    y: 0
                };
                this.render();
            },
            unit: "\xb0"
        });
        this.zoomInBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: `<img height="20" src="${$099ab81d0ff36d13$var$toolZoomInImg}">`,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('zoom-in'),
            destroyer: this.destroyer,
            onClick: ()=>this.changeZoomFac(1),
            css: {
                fontWeight: 'bold'
            }
        });
        this.zoomOutBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: `<img height="20" src="${$099ab81d0ff36d13$var$toolZoomOutImg}">`,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('zoom-out'),
            destroyer: this.destroyer,
            onClick: ()=>this.changeZoomFac(-1),
            css: {
                fontWeight: 'bold'
            }
        });
        this.eventCapture = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                zIndex: '999',
                cursor: 'move'
            }
        });
        this.eventCapture.oncontextmenu = (e)=>e.preventDefault();
        this.keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
            onDown: (keyStr)=>{
                if ((0, $be957da3610487e9$export$921068d8846a1559).isInputFocused(true)) return;
                const factor = this.keyListener.isPressed('shift') ? 4 : 1;
                if (keyStr === 'left') this.move(-factor, 0);
                if (keyStr === 'right') this.move(factor, 0);
                if (keyStr === 'up') this.move(0, -factor);
                if (keyStr === 'down') this.move(0, factor);
            }
        });
        this.inputsRootEl = (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,gap-5', [
            this.rotationSlider.getElement(),
            (0, $8405ecc79d32770a$export$db3b6bfb95261072)(),
            this.zoomInBtn,
            this.zoomOutBtn
        ]);
    }
}


var $51d9a6121aaa573a$export$7b388ca536128c6d;
var $51d9a6121aaa573a$export$62d58b1c91e8e902;
var $51d9a6121aaa573a$export$84aa927130f1a919;
var $51d9a6121aaa573a$export$ee483a02838ec162;
var $51d9a6121aaa573a$export$e114d13b1a258938;
$51d9a6121aaa573a$export$7b388ca536128c6d = `_5vlQAW_inputs`;
$51d9a6121aaa573a$export$62d58b1c91e8e902 = `_5vlQAW_tab`;
$51d9a6121aaa573a$export$84aa927130f1a919 = `_5vlQAW_tabWrapper`;
$51d9a6121aaa573a$export$ee483a02838ec162 = `_5vlQAW_viewportInputs`;
$51d9a6121aaa573a$export$e114d13b1a258938 = `_5vlQAW_viewportWrapper`;




function $7cc2fdc4e73ab40f$export$e263e067d6140649(p) {
    const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({});
    let text = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(p.text);
    const viewportWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: $51d9a6121aaa573a$export$e114d13b1a258938
    });
    const viewportUI = new (0, $099ab81d0ff36d13$export$1d311696e0fb2158)({
        text: text,
        klCanvas: p.klCanvas,
        layerIndex: p.layerIndex,
        onDragEnd: ()=>tabs.getOpenedTabId() === 'text' ? textUI.focus() : 0
    });
    viewportUI.render();
    function onUpdate(p) {
        text = {
            ...text,
            ...p
        };
        viewportUI.setText(text);
    }
    const fontUI = new (0, $781e11de61455bbc$export$2e7faedafda1fc85)({
        ...text,
        onUpdate: (p)=>{
            onUpdate(p);
        }
    });
    const colorWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
        css: {
            display: 'flex',
            gap: 10,
            flexDirection: 'column'
        }
    });
    const fillUI = new (0, $e4157c295dab4057$export$5cdfb22682d2a5dd)({
        fill: text.fill,
        primaryColor: p.primaryColor,
        secondaryColor: p.secondaryColor,
        onUpdate: (p)=>{
            onUpdate(p);
        }
    });
    const strokeUI = new (0, $ad2e43550e069f2e$export$42bb0e3b48d549f6)({
        stroke: text.stroke,
        primaryColor: p.primaryColor,
        secondaryColor: p.secondaryColor,
        onUpdate: (p)=>{
            onUpdate(p);
        }
    });
    const textUI = new (0, $9df21e15bd35e893$export$c6656360602b35c2)({
        text: text.text,
        onUpdate: (p)=>{
            p.text !== undefined && modal.setIgnoreBackground(p.text.length > 0);
            onUpdate(p);
        }
    });
    const tabs = new (0, $edc0a3ccf2e6e858$export$3c6d17ed0106bfb9)({
        initialId: 'text',
        height: 40,
        tabArr: [
            {
                id: 'text',
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('text-text'),
                onOpen: ()=>{
                    textUI.getElement().style.display = '';
                    textUI.focus();
                },
                onClose: ()=>{
                    textUI.getElement().style.display = 'none';
                }
            },
            {
                id: 'font',
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('text-font'),
                onOpen: ()=>{
                    fontUI.getElement().style.display = 'flex';
                },
                onClose: ()=>{
                    fontUI.getElement().style.display = 'none';
                }
            },
            {
                id: 'color',
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('text-color'),
                onOpen: ()=>{
                    colorWrapper.style.display = 'flex';
                },
                onClose: ()=>{
                    colorWrapper.style.display = 'none';
                }
            }
        ]
    });
    tabs.getElement().classList.add($51d9a6121aaa573a$export$62d58b1c91e8e902);
    rootEl.append((0, $8405ecc79d32770a$export$db3b6bfb95261072)('', [
        (0, $8405ecc79d32770a$export$db3b6bfb95261072)(viewportWrapper, [
            viewportUI.getElement()
        ]),
        (0, $8405ecc79d32770a$export$db3b6bfb95261072)('.' + $51d9a6121aaa573a$export$ee483a02838ec162, [
            viewportUI.getInputsElement()
        ]),
        (0, $8405ecc79d32770a$export$db3b6bfb95261072)('.tabrow.' + $51d9a6121aaa573a$export$84aa927130f1a919, [
            (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',w-240,h-40'),
            tabs.getElement()
        ]),
        (0, $8405ecc79d32770a$export$db3b6bfb95261072)('.' + $51d9a6121aaa573a$export$7b388ca536128c6d, [
            (0, $8405ecc79d32770a$export$db3b6bfb95261072)(colorWrapper, [
                fillUI.getElement(),
                strokeUI.getElement()
            ]),
            fontUI.getElement(),
            textUI.getElement()
        ])
    ]));
    const onResize = ()=>{
        const b = viewportWrapper.getBoundingClientRect();
        const w = Math.ceil(b.width);
        const h = Math.ceil(b.height);
        viewportUI.setSize(w, h);
    };
    window.addEventListener('resize', onResize);
    setTimeout(()=>{
        onResize();
    });
    setTimeout(()=>{
        textUI.focus();
    }, 100);
    // prevent mobile keyboards scrolling page
    function onScroll() {
        window.scrollTo(0, 0);
    }
    window.addEventListener('scroll', onScroll, {
        passive: false
    });
    const onModalExit = (val)=>{
        window.removeEventListener('resize', onResize);
        window.removeEventListener('scroll', onScroll);
        viewportUI.destroy();
        fontUI.destroy();
        fillUI.destroy();
        strokeUI.destroy();
        textUI.destroy();
        tabs.destroy();
        if (val === 'Ok') p.onConfirm({
            ...viewportUI.getValues(),
            ...fontUI.getValues(),
            ...fillUI.getValues(),
            ...strokeUI.getValues(),
            ...textUI.getValues()
        });
    };
    const modal = (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $fc42a07754814920$export$ce37e184d908d785)('text-title')}</b>`,
        div: rootEl,
        buttons: [
            'Ok',
            'Cancel'
        ],
        ignoreBackground: p.text.text.length > 0,
        callback: onModalExit,
        style: {
            width: 'calc(100% - 50px)',
            maxWidth: 1000,
            minWidth: 300,
            boxSizing: 'border-box'
        },
        clickOnEnter: 'Ok'
    });
}








function $be4deef280a7a6e1$export$1bf16d9bd59fd8f9(p) {
    const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
    const destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
    const isSmall = window.innerWidth < 550 || window.innerHeight < 550;
    const style = isSmall ? {} : {
        width: '540px'
    };
    const resolutionEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
        css: {
            marginTop: 10,
            textAlign: 'center',
            color: '#888',
            lineHeight: '20px'
        }
    });
    const cropCopy = new (0, $67988e2254ac179d$export$40175a5948a88a57)({
        width: isSmall ? 340 : 540,
        height: isSmall ? 300 : 400,
        canvas: p.image.canvas,
        enableRightClickCopy: false,
        onChange: (width, height)=>{
            if (!resolutionEl) return;
            updateResolution(width, height);
        }
    });
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(cropCopy.getElement(), {
        marginLeft: -20
    });
    cropCopy.getElement().title = (0, $fc42a07754814920$export$ce37e184d908d785)('crop-drag-to-crop');
    rootEl.append(cropCopy.getElement(), resolutionEl);
    function updateResolution(w, h) {
        const fit = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(w, h, p.maxSize, p.maxSize);
        if (fit.width < w) {
            resolutionEl.innerHTML = `<span class="kl-text-error">${w} X ${h}</span> \u{27F6} ${Math.round(fit.width)} X ${Math.round(fit.height)}`;
            resolutionEl.title = (0, $fc42a07754814920$export$ce37e184d908d785)('import-too-large');
        } else {
            resolutionEl.innerHTML = `${w} X ${h}`;
            resolutionEl.title = '';
        }
    }
    updateResolution(p.image.width, p.image.height);
    let doFlatten = false;
    function showWarnings(psdWarningArr) {
        const warningMap = {
            mask: 'Masks not supported. Mask was applied.',
            group: 'Groups not supported. Layers were ungrouped.',
            adjustment: 'Adjustment layers not supported.',
            'layer-effect': 'Layer effects not supported.',
            'smart-object': 'Smart objects not supported.',
            'blend-mode': 'Unsupported layer blend mode.',
            'bits-per-channel': 'Unsupported color depth. Only 8bit per channel supported.'
        };
        const contentArr = psdWarningArr.map((warning)=>'- ' + warningMap[warning]);
        alert(contentArr.join('\n'));
    }
    let flattenCheckbox;
    let warningsEl;
    if (p.image.type === 'psd') {
        if (p.image.layers) {
            flattenCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
                init: doFlatten,
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('import-flatten'),
                callback: (b)=>{
                    doFlatten = b;
                },
                name: 'flatten-image'
            });
            rootEl.append(flattenCheckbox.getElement());
            if (p.image.warningArr) {
                const noteEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    className: 'kl-import-note',
                    content: (0, $fc42a07754814920$export$ce37e184d908d785)('import-psd-limited-support')
                });
                const warnings = p.image.warningArr;
                warningsEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    parent: noteEl,
                    tagName: 'a',
                    destroyer: destroyer,
                    content: 'Details',
                    css: {
                        marginLeft: 5
                    },
                    onClick: ()=>showWarnings(warnings)
                });
                rootEl.append(noteEl);
            }
        } else {
            const noteEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'kl-import-note',
                content: (0, $fc42a07754814920$export$ce37e184d908d785)('import-psd-unsupported')
            });
            rootEl.append(noteEl);
        }
    }
    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $fc42a07754814920$export$ce37e184d908d785)('import-title')}</b>`,
        div: rootEl,
        style: style,
        buttons: [
            {
                id: 'as-layer',
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('import-btn-as-layer')
            },
            {
                id: 'as-image',
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('import-btn-as-image')
            },
            'Cancel'
        ],
        primaries: [
            'as-layer',
            'as-image'
        ],
        callback: (result)=>{
            const croppedCanvas = cropCopy.getCroppedCanvas();
            const cropRect = cropCopy.getCropRect();
            const isCropped = p.image.width !== cropRect.width || p.image.height !== cropRect.height;
            cropCopy.destroy();
            destroyer.destroy();
            if (flattenCheckbox) flattenCheckbox.destroy();
            if (result === 'as-layer') {
                p.callback({
                    type: 'as-layer',
                    image: isCropped ? croppedCanvas : p.image.canvas
                });
                if (!isCropped) (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(croppedCanvas);
            } else if (result === 'as-image') {
                if (p.image.type === 'psd') {
                    if (doFlatten) delete p.image.layers;
                    p.callback({
                        type: 'as-image-psd',
                        image: p.image,
                        cropObj: cropRect
                    });
                    (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(croppedCanvas);
                } else if (p.image.type === 'image') p.callback({
                    type: 'as-image',
                    image: croppedCanvas
                });
            } else {
                p.callback({
                    type: 'cancel'
                });
                (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(croppedCanvas);
            }
        },
        autoFocus: 'as-image'
    });
}


var $0db3bfb221211901$exports = {};

$parcel$export($0db3bfb221211901$exports, "blendPsdToKl", function () { return $0db3bfb221211901$export$6df36f0c42d2440f; });
$parcel$export($0db3bfb221211901$exports, "blendKlToPsd", function () { return $0db3bfb221211901$export$4e3b1f7d3ad623b4; });
$parcel$export($0db3bfb221211901$exports, "psdToKlPsd", function () { return $0db3bfb221211901$export$1897162d402ed358; });
$parcel$export($0db3bfb221211901$exports, "klPsdToKlProject", function () { return $0db3bfb221211901$export$56493bf279c387b3; });

var $79I2S = parcelRequire("79I2S");




let $0db3bfb221211901$var$kl2PsdMap;
let $0db3bfb221211901$var$psd2KlMap;
function $0db3bfb221211901$var$init() {
    if ($0db3bfb221211901$var$kl2PsdMap) return;
    $0db3bfb221211901$var$kl2PsdMap = {
        'source-over': 'normal',
        darken: 'darken',
        multiply: 'multiply',
        'color-burn': 'color burn',
        lighten: 'lighten',
        screen: 'screen',
        'color-dodge': 'color dodge',
        overlay: 'overlay',
        'soft-light': 'soft light',
        'hard-light': 'hard light',
        difference: 'difference',
        exclusion: 'exclusion',
        hue: 'hue',
        saturation: 'saturation',
        color: 'color',
        luminosity: 'luminosity'
    };
    $0db3bfb221211901$var$psd2KlMap = Object.fromEntries(Object.entries($0db3bfb221211901$var$kl2PsdMap).map((a)=>a.reverse()));
}
function $0db3bfb221211901$export$6df36f0c42d2440f(str) {
    $0db3bfb221211901$var$init();
    return $0db3bfb221211901$var$psd2KlMap[str];
}
function $0db3bfb221211901$export$4e3b1f7d3ad623b4(str) {
    $0db3bfb221211901$var$init();
    return $0db3bfb221211901$var$kl2PsdMap[str];
}
function $0db3bfb221211901$export$1897162d402ed358(psdObj) {
    if (!psdObj.canvas) throw new Error('psdObj.canvas undefined');
    const result = {
        type: 'psd',
        canvas: psdObj.canvas,
        width: psdObj.width,
        height: psdObj.height
    };
    function addWarning(warningStr) {
        result.warningArr ??= [];
        if (result.warningArr.includes(warningStr)) return;
        result.warningArr.push(warningStr);
    }
    function getMixModeStr(blendMode) {
        let mixModeStr = $0db3bfb221211901$export$6df36f0c42d2440f(blendMode);
        if (!mixModeStr) {
            addWarning('blend-mode');
            mixModeStr = 'source-over';
        }
        return mixModeStr;
    }
    if (psdObj.bitsPerChannel !== 8) addWarning('bits-per-channel');
    if (!psdObj.children) {
        result.error = true;
        return result;
    }
    // count resulting layers
    const maxLayers = (0, $a919a1fb23b6c719$export$9f4f73b1bd7c2f26);
    let layerCount = 0;
    function countWithinGroup(groupObj) {
        let result = 0;
        if (groupObj.blendMode) {
            const mixModeStr = $0db3bfb221211901$export$6df36f0c42d2440f(groupObj.blendMode);
            if (mixModeStr && mixModeStr !== 'source-over') return 1;
        }
        if (groupObj.children) for(let i = 0; i < groupObj.children.length; i++){
            const item = groupObj.children[i];
            if (item.adjustment) continue;
            if (item.children) {
                addWarning('group');
                result += countWithinGroup(item);
            } else result++;
        }
        return result;
    }
    layerCount += countWithinGroup(psdObj);
    if (layerCount > maxLayers) {
        result.error = true;
        return result;
    }
    result.layers = [];
    function prepareMask(maskCanvas, defaultColor) {
        const groupMaskCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(maskCanvas);
        const imData = groupMaskCtx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
        if (defaultColor === 0) for(let i = 0; i < imData.data.length; i += 4)imData.data[i + 3] = imData.data[i];
        else for(let i = 0; i < imData.data.length; i += 4)imData.data[i + 3] = 255 - imData.data[i];
        groupMaskCtx.putImageData(imData, 0, 0);
    }
    function convertGroup(psdGroupObj) {
        let resultArr = [];
        const groupIsVisible = !psdGroupObj.hidden;
        const groupOpacity = (0, $94f0b2b810d4d191$export$5c097f720de072a2)(psdGroupObj.opacity, 'groupOpacity is undefined');
        const groupMixModeStr = getMixModeStr(psdGroupObj.blendMode);
        let groupCanvas;
        let groupCtx;
        if (groupMixModeStr !== 'source-over') {
            groupCanvas = (0, $79I2S.createCanvas)(result.width, result.height);
            groupCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(groupCanvas);
        }
        // prepare group mask
        if (psdGroupObj.mask) {
            addWarning('mask');
            prepareMask(psdGroupObj.mask.canvas, psdGroupObj.mask.defaultColor);
        }
        if (psdGroupObj.children) for(let i = 0; i < psdGroupObj.children.length; i++){
            const item = psdGroupObj.children[i];
            if (item.adjustment) {
                addWarning('adjustment');
                continue;
            }
            if (item.children) {
                const convertedChildGroupItems = convertGroup(item);
                for(let e = 0; e < convertedChildGroupItems.length; e++){
                    const innerItem = convertedChildGroupItems[e];
                    const innerCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(innerItem.image);
                    // group mask
                    if (psdGroupObj.mask) {
                        innerCtx.globalCompositeOperation = psdGroupObj.mask.defaultColor === 0 ? 'destination-in' : 'destination-out';
                        if (psdGroupObj.mask.canvas === undefined) throw new Error('psdGroupObj.mask.canvas undefined');
                        if (psdGroupObj.mask.left === undefined) throw new Error('psdGroupObj.mask.left undefined');
                        if (psdGroupObj.mask.top === undefined) throw new Error('psdGroupObj.mask.top undefined');
                        innerCtx.drawImage(psdGroupObj.mask.canvas, psdGroupObj.mask.left, psdGroupObj.mask.top);
                    }
                    if (groupCanvas) {
                        if (groupCtx === undefined) throw new Error('groupCtx undefined');
                        groupCtx.globalCompositeOperation = innerItem.mixModeStr;
                        groupCtx.globalAlpha = innerItem.opacity;
                        groupCtx.drawImage(innerItem.image, 0, 0);
                    } else {
                        innerItem.opacity = innerItem.opacity * groupOpacity;
                        resultArr.push(innerItem);
                    }
                }
                continue;
            }
            const canvas = (0, $79I2S.createCanvas)(result.width, result.height);
            const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
            if (item.canvas) {
                // if a layer is empty it has no canvas
                if (item.top === undefined) throw new Error('item.top undefined');
                if (item.left === undefined) throw new Error('item.left undefined');
                ctx.drawImage(item.canvas, item.left, item.top);
            }
            // effects
            if (item.effects) addWarning('layer-effect');
            // mask
            if (item.mask) {
                addWarning('mask');
                if (item.mask.canvas === undefined) throw new Error('item.mask.canvas undefined');
                if (item.mask.defaultColor === undefined) throw new Error('item.mask.defaultColor undefined');
                if (item.mask.left === undefined) throw new Error('item.mask.left undefined');
                if (item.mask.top === undefined) throw new Error('item.mask.top undefined');
                prepareMask(item.mask.canvas, item.mask.defaultColor);
                ctx.globalCompositeOperation = item.mask.defaultColor === 0 ? 'destination-in' : 'destination-out';
                ctx.drawImage(item.mask.canvas, item.mask.left, item.mask.top);
            }
            // group mask
            if (psdGroupObj.mask) {
                ctx.globalCompositeOperation = psdGroupObj.mask.defaultColor === 0 ? 'destination-in' : 'destination-out';
                if (psdGroupObj.mask.canvas === undefined) throw new Error('psdGroupObj.mask.canvas undefined');
                if (psdGroupObj.mask.left === undefined) throw new Error('psdGroupObj.mask.left undefined');
                if (psdGroupObj.mask.top === undefined) throw new Error('psdGroupObj.mask.top undefined');
                ctx.drawImage(psdGroupObj.mask.canvas, psdGroupObj.mask.left, psdGroupObj.mask.top);
            }
            if (item.blendMode === undefined) throw new Error('item.blendMode undefined');
            if (item.hidden === undefined) throw new Error('item.hidden  undefined');
            if (item.opacity === undefined) throw new Error('item.opacity undefined');
            if (groupCanvas && groupCtx) {
                if (groupOpacity > 0) {
                    groupCtx.globalCompositeOperation = getMixModeStr(item.blendMode);
                    groupCtx.globalAlpha = item.hidden ? 0 : item.opacity;
                    groupCtx.drawImage(canvas, 0, 0);
                }
            } else {
                if (item.name === undefined) throw new Error('item.name undefined');
                resultArr.push({
                    name: item.name,
                    isVisible: !item.hidden && groupIsVisible,
                    opacity: item.opacity * groupOpacity,
                    mixModeStr: getMixModeStr(item.blendMode),
                    hasClipping: !!item.clipping,
                    image: canvas
                });
            }
        }
        if (groupCanvas) {
            if (psdGroupObj.name === undefined) throw new Error('psdGroupObj.name undefined');
            resultArr = [
                {
                    name: psdGroupObj.name,
                    isVisible: groupIsVisible,
                    opacity: groupOpacity,
                    mixModeStr: groupMixModeStr,
                    hasClipping: !!psdGroupObj.clipping,
                    image: groupCanvas
                }
            ];
        }
        return resultArr;
    }
    result.layers = convertGroup({
        name: 'root',
        opacity: 1,
        blendMode: 'normal',
        children: psdObj.children
    });
    return result;
}
function $0db3bfb221211901$export$56493bf279c387b3(klPsd) {
    // only share references to Canvas elements
    const result = {
        projectId: (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)(),
        width: klPsd.width,
        height: klPsd.height,
        layers: []
    };
    if (klPsd.layers) result.layers = klPsd.layers.map((item)=>{
        return {
            name: item.name,
            isVisible: item.isVisible,
            opacity: item.opacity,
            mixModeStr: item.mixModeStr,
            hasClipping: item.hasClipping,
            image: item.image
        };
    });
    else // flattened
    result.layers = [
        {
            name: (0, $fc42a07754814920$export$ce37e184d908d785)('background'),
            isVisible: true,
            opacity: 1,
            mixModeStr: 'source-over',
            hasClipping: false,
            image: klPsd.canvas
        }
    ];
    return result;
}





var $f2d4b51cf4ad677d$exports = {};
$f2d4b51cf4ad677d$exports = $parcel$resolve("2Iniz");


var $b8706c1d30478530$exports = {};
$b8706c1d30478530$exports = $parcel$resolve("3db7h");


var $a242dddfdf3f6195$exports = {};
$a242dddfdf3f6195$exports = $parcel$resolve("h8wMh");


var $718a6cbed4910a1a$exports = {};
$718a6cbed4910a1a$exports = $parcel$resolve("qDOS1");


const $b20d6b230a6e6f94$var$glBrightnessContrastImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-brightness-contrast');
const $b20d6b230a6e6f94$var$cropExtendImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-crop');
const $b20d6b230a6e6f94$var$glCurvesImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-curves');
const $b20d6b230a6e6f94$var$flipImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-flip');
const $b20d6b230a6e6f94$var$glHueSaturationImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-hue-saturation');
const $b20d6b230a6e6f94$var$glPerspectiveImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-perspective');
const $b20d6b230a6e6f94$var$resizeImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-resize');
const $b20d6b230a6e6f94$var$rotateImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-rotate');
const $b20d6b230a6e6f94$var$toAlphaImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-to-alpha');
const $b20d6b230a6e6f94$var$transformImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-transform');
const $b20d6b230a6e6f94$var$gridImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-grid');
const $b20d6b230a6e6f94$var$noiseImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-noise');
const $b20d6b230a6e6f94$var$patternImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-pattern');
const $b20d6b230a6e6f94$var$vanishPointImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-vanish-point');
const $b20d6b230a6e6f94$var$distortImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-distort');
const $b20d6b230a6e6f94$export$24724bc1f91cba3 = {
    isLoaded: false
};
const $b20d6b230a6e6f94$export$bac24f240bb7727d = {
    brightnessContrast: {
        lang: {
            name: 'filter-bright-contrast-title',
            button: 'filter-bright-contrast',
            description: 'filter-bright-contrast-description'
        },
        icon: $b20d6b230a6e6f94$var$glBrightnessContrastImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    cropExtend: {
        lang: {
            name: 'filter-crop-title',
            button: 'filter-crop-extend',
            description: 'filter-crop-description'
        },
        icon: $b20d6b230a6e6f94$var$cropExtendImg,
        updatePos: true,
        getDialog: null,
        apply: null,
        inEmbed: false
    },
    curves: {
        lang: {
            name: 'filter-curves-title',
            button: 'filter-curves',
            description: 'filter-curves-description'
        },
        icon: $b20d6b230a6e6f94$var$glCurvesImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    distort: {
        lang: {
            name: 'filter-distort',
            button: 'filter-distort',
            description: 'filter-distort-description'
        },
        icon: $b20d6b230a6e6f94$var$distortImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    flip: {
        lang: {
            name: 'filter-flip-title',
            button: 'filter-flip',
            description: 'filter-flip-description'
        },
        icon: $b20d6b230a6e6f94$var$flipImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    hueSaturation: {
        lang: {
            name: 'filter-hue-sat-title',
            button: 'filter-hue-sat',
            description: 'filter-hue-sat-description'
        },
        icon: $b20d6b230a6e6f94$var$glHueSaturationImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    invert: {
        lang: {
            name: 'filter-invert',
            button: 'filter-invert'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f2d4b51cf4ad677d$exports))),
        updatePos: false,
        isInstant: true,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    perspective: {
        lang: {
            name: 'filter-perspective-title',
            button: 'filter-perspective',
            description: 'filter-perspective-description'
        },
        icon: $b20d6b230a6e6f94$var$glPerspectiveImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    resize: {
        lang: {
            name: 'filter-resize-title',
            button: 'filter-resize',
            description: 'filter-resize-description'
        },
        icon: $b20d6b230a6e6f94$var$resizeImg,
        updatePos: true,
        getDialog: null,
        apply: null,
        inEmbed: false
    },
    rotate: {
        lang: {
            name: 'filter-rotate-title',
            button: 'filter-rotate',
            description: 'filter-rotate-description'
        },
        icon: $b20d6b230a6e6f94$var$rotateImg,
        updatePos: true,
        getDialog: null,
        apply: null,
        inEmbed: false
    },
    tiltShift: {
        lang: {
            name: 'filter-tilt-shift-title',
            button: 'filter-tilt-shift',
            description: 'filter-tilt-shift-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b8706c1d30478530$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    toAlpha: {
        lang: {
            name: 'filter-to-alpha-title',
            button: 'filter-to-alpha',
            description: 'filter-to-alpha-description'
        },
        icon: $b20d6b230a6e6f94$var$toAlphaImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    transform: {
        lang: {
            name: 'filter-transform-title',
            button: 'filter-transform',
            description: 'filter-transform-description'
        },
        icon: $b20d6b230a6e6f94$var$transformImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    blur: {
        lang: {
            name: 'filter-triangle-blur-title',
            button: 'filter-triangle-blur',
            description: 'filter-triangle-blur-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a242dddfdf3f6195$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    unsharpMask: {
        lang: {
            name: 'filter-unsharp-mask-title',
            button: 'filter-unsharp-mask',
            description: 'filter-unsharp-mask-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($718a6cbed4910a1a$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    grid: {
        lang: {
            name: 'filter-grid',
            button: 'filter-grid',
            description: 'filter-grid-description'
        },
        icon: $b20d6b230a6e6f94$var$gridImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    noise: {
        lang: {
            name: 'filter-noise',
            button: 'filter-noise',
            description: 'filter-noise-description'
        },
        icon: $b20d6b230a6e6f94$var$noiseImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    pattern: {
        lang: {
            name: 'filter-pattern',
            button: 'filter-pattern',
            description: 'filter-pattern-description'
        },
        icon: $b20d6b230a6e6f94$var$patternImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    vanishPoint: {
        lang: {
            name: 'filter-vanish-point-title',
            button: 'filter-vanish-point',
            description: 'filter-vanish-point-description'
        },
        icon: $b20d6b230a6e6f94$var$vanishPointImg,
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    }
};




/*
 * A speed-improved perlin and simplex noise algorithms for 2D.
 *
 * Based on example code by Stefan Gustavson (stegu@itn.liu.se).
 * Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
 * Better rank ordering method by Stefan Gustavson in 2012.
 * Converted to Javascript by Joseph Gentle.
 *
 * Version 2012-03-09
 *
 * This code was placed in the public domain by its original author,
 * Stefan Gustavson. You may use it as you see fit, but
 * attribution is appreciated.
 *
 */ const $5af44e7ee1fed5d0$var$myModule = {};
class $5af44e7ee1fed5d0$var$Grad {
    dot2(x, y) {
        return this.x * x + this.y * y;
    }
    constructor(x, y, z){
        this.x = x;
        this.y = y;
        this.z = z;
    }
}
/*
Grad.prototype.dot3 = function(x, y, z) {
    return this.x*x + this.y*y + this.z*z;
};*/ const $5af44e7ee1fed5d0$var$grad3 = [
    new $5af44e7ee1fed5d0$var$Grad(1, 1, 0),
    new $5af44e7ee1fed5d0$var$Grad(-1, 1, 0),
    new $5af44e7ee1fed5d0$var$Grad(1, -1, 0),
    new $5af44e7ee1fed5d0$var$Grad(-1, -1, 0),
    new $5af44e7ee1fed5d0$var$Grad(1, 0, 1),
    new $5af44e7ee1fed5d0$var$Grad(-1, 0, 1),
    new $5af44e7ee1fed5d0$var$Grad(1, 0, -1),
    new $5af44e7ee1fed5d0$var$Grad(-1, 0, -1),
    new $5af44e7ee1fed5d0$var$Grad(0, 1, 1),
    new $5af44e7ee1fed5d0$var$Grad(0, -1, 1),
    new $5af44e7ee1fed5d0$var$Grad(0, 1, -1),
    new $5af44e7ee1fed5d0$var$Grad(0, -1, -1)
];
const $5af44e7ee1fed5d0$var$p = [
    151,
    160,
    137,
    91,
    90,
    15,
    131,
    13,
    201,
    95,
    96,
    53,
    194,
    233,
    7,
    225,
    140,
    36,
    103,
    30,
    69,
    142,
    8,
    99,
    37,
    240,
    21,
    10,
    23,
    190,
    6,
    148,
    247,
    120,
    234,
    75,
    0,
    26,
    197,
    62,
    94,
    252,
    219,
    203,
    117,
    35,
    11,
    32,
    57,
    177,
    33,
    88,
    237,
    149,
    56,
    87,
    174,
    20,
    125,
    136,
    171,
    168,
    68,
    175,
    74,
    165,
    71,
    134,
    139,
    48,
    27,
    166,
    77,
    146,
    158,
    231,
    83,
    111,
    229,
    122,
    60,
    211,
    133,
    230,
    220,
    105,
    92,
    41,
    55,
    46,
    245,
    40,
    244,
    102,
    143,
    54,
    65,
    25,
    63,
    161,
    1,
    216,
    80,
    73,
    209,
    76,
    132,
    187,
    208,
    89,
    18,
    169,
    200,
    196,
    135,
    130,
    116,
    188,
    159,
    86,
    164,
    100,
    109,
    198,
    173,
    186,
    3,
    64,
    52,
    217,
    226,
    250,
    124,
    123,
    5,
    202,
    38,
    147,
    118,
    126,
    255,
    82,
    85,
    212,
    207,
    206,
    59,
    227,
    47,
    16,
    58,
    17,
    182,
    189,
    28,
    42,
    223,
    183,
    170,
    213,
    119,
    248,
    152,
    2,
    44,
    154,
    163,
    70,
    221,
    153,
    101,
    155,
    167,
    43,
    172,
    9,
    129,
    22,
    39,
    253,
    19,
    98,
    108,
    110,
    79,
    113,
    224,
    232,
    178,
    185,
    112,
    104,
    218,
    246,
    97,
    228,
    251,
    34,
    242,
    193,
    238,
    210,
    144,
    12,
    191,
    179,
    162,
    241,
    81,
    51,
    145,
    235,
    249,
    14,
    239,
    107,
    49,
    192,
    214,
    31,
    181,
    199,
    106,
    157,
    184,
    84,
    204,
    176,
    115,
    121,
    50,
    45,
    127,
    4,
    150,
    254,
    138,
    236,
    205,
    93,
    222,
    114,
    67,
    29,
    24,
    72,
    243,
    141,
    128,
    195,
    78,
    66,
    215,
    61,
    156,
    180
];
// To remove the need for index wrapping, double the permutation table length
const $5af44e7ee1fed5d0$var$perm = new Array(512).fill(0);
const $5af44e7ee1fed5d0$var$gradP = new Array(512).fill(0);
// This isn't a very good seeding function, but it works ok. It supports 2^16
// different seed values. Write something better if you need more seeds.
$5af44e7ee1fed5d0$var$myModule.seed = function(seed) {
    if (seed > 0 && seed < 1) // Scale the seed out
    seed *= 65536;
    seed = Math.floor(seed);
    if (seed < 256) seed |= seed << 8;
    for(let i = 0; i < 256; i++){
        let v;
        if (i & 1) v = $5af44e7ee1fed5d0$var$p[i] ^ seed & 255;
        else v = $5af44e7ee1fed5d0$var$p[i] ^ seed >> 8 & 255;
        $5af44e7ee1fed5d0$var$perm[i] = $5af44e7ee1fed5d0$var$perm[i + 256] = v;
        $5af44e7ee1fed5d0$var$gradP[i] = $5af44e7ee1fed5d0$var$gradP[i + 256] = $5af44e7ee1fed5d0$var$grad3[v % 12];
    }
};
$5af44e7ee1fed5d0$var$myModule.seed(0);
/*
for (let i=0; i<256; i++) {
  perm[i] = perm[i + 256] = p[i];
  gradP[i] = gradP[i + 256] = grad3[perm[i] % 12];
}*/ // Skewing and unskewing factors for 2, 3, and 4 dimensions
const $5af44e7ee1fed5d0$var$F2 = 0.5 * (Math.sqrt(3) - 1);
const $5af44e7ee1fed5d0$var$G2 = (3 - Math.sqrt(3)) / 6;
/*let F3 = 1/3;
let G3 = 1/6;*/ // 2D simplex noise
$5af44e7ee1fed5d0$var$myModule.simplex2 = function(xin, yin) {
    let n0, n1, n2; // Noise contributions from the three corners
    // Skew the input space to determine which simplex cell we're in
    const s = (xin + yin) * $5af44e7ee1fed5d0$var$F2; // Hairy factor for 2D
    let i = Math.floor(xin + s);
    let j = Math.floor(yin + s);
    const t = (i + j) * $5af44e7ee1fed5d0$var$G2;
    const x0 = xin - i + t; // The x,y distances from the cell origin, unskewed.
    const y0 = yin - j + t;
    // For the 2D case, the simplex shape is an equilateral triangle.
    // Determine which simplex we are in.
    let i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
    if (x0 > y0) {
        // lower triangle, XY order: (0,0)->(1,0)->(1,1)
        i1 = 1;
        j1 = 0;
    } else {
        // upper triangle, YX order: (0,0)->(0,1)->(1,1)
        i1 = 0;
        j1 = 1;
    }
    // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
    // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
    // c = (3-sqrt(3))/6
    const x1 = x0 - i1 + $5af44e7ee1fed5d0$var$G2; // Offsets for middle corner in (x,y) unskewed coords
    const y1 = y0 - j1 + $5af44e7ee1fed5d0$var$G2;
    const x2 = x0 - 1 + 2 * $5af44e7ee1fed5d0$var$G2; // Offsets for last corner in (x,y) unskewed coords
    const y2 = y0 - 1 + 2 * $5af44e7ee1fed5d0$var$G2;
    // Work out the hashed gradient indices of the three simplex corners
    i &= 255;
    j &= 255;
    const gi0 = $5af44e7ee1fed5d0$var$gradP[i + $5af44e7ee1fed5d0$var$perm[j]];
    const gi1 = $5af44e7ee1fed5d0$var$gradP[i + i1 + $5af44e7ee1fed5d0$var$perm[j + j1]];
    const gi2 = $5af44e7ee1fed5d0$var$gradP[i + 1 + $5af44e7ee1fed5d0$var$perm[j + 1]];
    // Calculate the contribution from the three corners
    let t0 = 0.5 - x0 * x0 - y0 * y0;
    if (t0 < 0) n0 = 0;
    else {
        t0 *= t0;
        n0 = t0 * t0 * gi0.dot2(x0, y0); // (x,y) of grad3 used for 2D gradient
    }
    let t1 = 0.5 - x1 * x1 - y1 * y1;
    if (t1 < 0) n1 = 0;
    else {
        t1 *= t1;
        n1 = t1 * t1 * gi1.dot2(x1, y1);
    }
    let t2 = 0.5 - x2 * x2 - y2 * y2;
    if (t2 < 0) n2 = 0;
    else {
        t2 *= t2;
        n2 = t2 * t2 * gi2.dot2(x2, y2);
    }
    // Add contributions from each corner to get the final noise value.
    // The result is scaled to return values in the interval [-1,1].
    return 70 * (n0 + n1 + n2);
};
const $5af44e7ee1fed5d0$export$d3022aad56692482 = $5af44e7ee1fed5d0$var$myModule;


function $750f1a22771b5790$export$74a44bbc21d06a28(w) {
    const scaleFac = w / 500;
    const h = w;
    const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(w, h);
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    const imData = ctx.createImageData(w, h);
    for(let x = 0; x < w; x++)for(let y = 0; y < h; y++){
        const i = (y * w + x) * 4;
        // base noise
        const sFac2 = scaleFac + (0, $5af44e7ee1fed5d0$export$d3022aad56692482).simplex2(x / 50 / scaleFac, y / 50 / scaleFac) * 0.04;
        let noisePattern = 100 + ((0, $5af44e7ee1fed5d0$export$d3022aad56692482).simplex2(x / 50 / sFac2, y / 50 / sFac2) + 1) / 2 * 100;
        noisePattern -= ((0, $5af44e7ee1fed5d0$export$d3022aad56692482).simplex2(x / 10 / scaleFac, y / 10 / scaleFac) + 1) / 2 * 100;
        // fade out in circular shape
        const centerDist = (0, $be957da3610487e9$export$921068d8846a1559).dist(w / 2, h / 2, x, y);
        const falloff = (0, $be957da3610487e9$export$921068d8846a1559).clamp(1 - ((centerDist - w / 2.5) / (w / 14) + (0, $5af44e7ee1fed5d0$export$d3022aad56692482).simplex2(x / 22 / sFac2, y / 22 / sFac2)), 0, 1);
        noisePattern = noisePattern * falloff;
        // make the middle darker
        const falloff2 = (0, $be957da3610487e9$export$921068d8846a1559).clamp(1 - centerDist / w, 0, 1) * 2;
        noisePattern = noisePattern * falloff2;
        imData.data[i] = 0;
        imData.data[i + 1] = 0;
        imData.data[i + 2] = 0;
        imData.data[i + 3] = (0, $be957da3610487e9$export$921068d8846a1559).clamp(noisePattern, 0, 255);
    }
    ctx.putImageData(imData, 0, 0);
    return canvas;
}
// https://www.shadertoy.com/view/3tdSDj
function $750f1a22771b5790$var$udSegment(p, a, b) {
    const ba = (0, $be957da3610487e9$export$921068d8846a1559).Vec2.sub(b, a);
    const pa = (0, $be957da3610487e9$export$921068d8846a1559).Vec2.sub(p, a);
    const h = (0, $be957da3610487e9$export$921068d8846a1559).clamp((0, $be957da3610487e9$export$921068d8846a1559).Vec2.dot(pa, ba) / (0, $be957da3610487e9$export$921068d8846a1559).Vec2.dot(ba, ba), 0.0, 1.0);
    return (0, $be957da3610487e9$export$921068d8846a1559).Vec2.len((0, $be957da3610487e9$export$921068d8846a1559).Vec2.sub(pa, (0, $be957da3610487e9$export$921068d8846a1559).Vec2.mul(ba, h)));
}
function $750f1a22771b5790$export$eaa218d5d17c8f1c(w) {
    const pDist = 1 / 4;
    let centerSize = 2 / 3;
    let transitionSize = 1 / 3;
    centerSize *= pDist;
    transitionSize *= pDist;
    const p1 = {
        x: pDist * w,
        y: w - w * pDist
    };
    const p2 = {
        x: w - w * pDist,
        y: pDist * w
    };
    const h = w;
    const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(w, h);
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    const imData = ctx.createImageData(w, h);
    for(let x = 0; x < w; x++)for(let y = 0; y < h; y++){
        const i = (y * w + x) * 4;
        let col = $750f1a22771b5790$var$udSegment({
            x: x,
            y: y
        }, p1, p2);
        col = (0, $be957da3610487e9$export$921068d8846a1559).clamp(255 - (col - w * centerSize) / (w * transitionSize) * 255, 0, 255);
        imData.data[i] = 0;
        imData.data[i + 1] = 0;
        imData.data[i + 2] = 0;
        imData.data[i + 3] = col;
    }
    ctx.putImageData(imData, 0, 0);
    return canvas;
}


const $704248ce983c152e$export$67a3081d7cc6182d = []; // used by default brush
$704248ce983c152e$export$67a3081d7cc6182d[1] = (0, $750f1a22771b5790$export$74a44bbc21d06a28)(128);
$704248ce983c152e$export$67a3081d7cc6182d[2] = (0, $750f1a22771b5790$export$eaa218d5d17c8f1c)(128);



function $f2ffdc0d3b960f1b$export$263fa670dc037098(composed, imageOrTiles) {
    const activeLayerId = composed.activeLayerId;
    const layerMap = Object.fromEntries(Object.entries(composed.layerMap).map(([layerId, layerItem])=>{
        if (layerId === activeLayerId) return [
            layerId,
            {
                tiles: imageOrTiles instanceof HTMLCanvasElement ? (0, $3aa9c52208735678$export$7b1ba44282f9a519)(imageOrTiles) : [
                    ...imageOrTiles
                ]
            }
        ];
        return [
            layerId,
            {}
        ];
    }));
    return {
        layerMap: layerMap
    };
}







const $056317e1fc5cf742$var$ALPHA_CIRCLE = 0;
const $056317e1fc5cf742$var$ALPHA_CHALK = 1;
const $056317e1fc5cf742$var$ALPHA_CAL = 2; // calligraphy
const $056317e1fc5cf742$var$ALPHA_SQUARE = 3;
const $056317e1fc5cf742$var$TWO_PI = 2 * Math.PI;
class $056317e1fc5cf742$export$6f96c8f9e6ae7341 {
    updateChangedTiles(bounds) {
        const boundsWithinSelection = (0, $4c2c6808296c0d73$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return;
        this.changedTiles = (0, $a0d4fe9620fd4adc$export$1774f90c6da5013c)(this.changedTiles, (0, $a0d4fe9620fd4adc$export$2098fe43203ddd32)(boundsWithinSelection, this.context.canvas.width, this.context.canvas.height));
    }
    updateAlphaCanvas() {
        if (this.settingAlphaId === $056317e1fc5cf742$var$ALPHA_CIRCLE || this.settingAlphaId === $056317e1fc5cf742$var$ALPHA_SQUARE) return;
        const instructionArr = [
            [
                this.alphaCanvas128,
                128
            ],
            [
                this.alphaCanvas64,
                64
            ],
            [
                this.alphaCanvas32,
                32
            ]
        ];
        let ctx;
        for(let i = 0; i < instructionArr.length; i++){
            ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(instructionArr[i][0]);
            ctx.save();
            ctx.clearRect(0, 0, instructionArr[i][1], instructionArr[i][1]);
            ctx.fillStyle = 'rgba(' + this.settingColor.r + ', ' + this.settingColor.g + ', ' + this.settingColor.b + ', ' + this.alphaOpacityArr[this.settingAlphaId] + ')';
            ctx.fillRect(0, 0, instructionArr[i][1], instructionArr[i][1]);
            ctx.globalCompositeOperation = 'destination-in';
            ctx.imageSmoothingQuality = 'high';
            ctx.drawImage((0, $704248ce983c152e$export$67a3081d7cc6182d)[this.settingAlphaId], 0, 0, instructionArr[i][1], instructionArr[i][1]);
            ctx.restore();
        }
    }
    calcOpacity(pressure) {
        return this.settingOpacity * (this.settingHasOpacityPressure ? pressure * pressure : 1);
    }
    calcScatter(pressure) {
        return this.settingScatter * this.settingSize * (this.settingHasScatterPressure ? pressure : 1);
    }
    /**
     * @param x
     * @param y
     * @param size
     * @param opacity
     * @param scatter
     * @param angle
     * @param before - [x, y, size, opacity, angle] the drawDot call before
     */ drawDot(x, y, size, opacity, scatter, angle, before) {
        if (size <= 0) return;
        if (this.settingLockLayerAlpha) this.context.globalCompositeOperation = 'source-atop';
        if (!before || before[3] !== opacity) this.context.globalAlpha = opacity;
        if (!before && (this.settingAlphaId === $056317e1fc5cf742$var$ALPHA_CIRCLE || this.settingAlphaId === $056317e1fc5cf742$var$ALPHA_SQUARE)) this.context.fillStyle = this.settingColorStr;
        if (scatter > 0) {
            // scatter equally distributed over area of a circle
            const scatterAngleRad = Math.random() * 2 * Math.PI;
            const distance = Math.sqrt(Math.random()) * scatter;
            x += Math.cos(scatterAngleRad) * distance;
            y += Math.sin(scatterAngleRad) * distance;
        }
        const boundsSize = this.settingAlphaId === $056317e1fc5cf742$var$ALPHA_CIRCLE || this.settingAlphaId === $056317e1fc5cf742$var$ALPHA_CAL ? size : size * Math.sqrt(2);
        this.updateChangedTiles({
            type: 'index',
            x1: Math.floor(x - boundsSize),
            y1: Math.floor(y - boundsSize),
            x2: Math.ceil(x + boundsSize - 1),
            y2: Math.ceil(y + boundsSize - 1)
        });
        if (this.settingAlphaId === $056317e1fc5cf742$var$ALPHA_CIRCLE) {
            this.context.beginPath();
            this.context.arc(x, y, size, 0, $056317e1fc5cf742$var$TWO_PI);
            this.context.closePath();
            this.context.fill();
            this.hasDrawnDot = true;
        } else if (this.settingAlphaId === $056317e1fc5cf742$var$ALPHA_SQUARE) {
            if (angle !== undefined) {
                this.context.save();
                this.context.translate(x, y);
                this.context.rotate(angle / 180 * Math.PI);
                this.context.fillRect(-size, -size, size * 2, size * 2);
                this.context.restore();
                this.hasDrawnDot = true;
            }
        } else {
            // other brush alphas
            this.context.save();
            this.context.translate(x, y);
            let targetMipmap = this.alphaCanvas128;
            if (size <= 32 && size > 16) targetMipmap = this.alphaCanvas64;
            else if (size <= 16) targetMipmap = this.alphaCanvas32;
            this.context.scale(size, size);
            if (this.settingAlphaId === $056317e1fc5cf742$var$ALPHA_CHALK) this.context.rotate((x + y) * 53123 % $056317e1fc5cf742$var$TWO_PI); // without mod it sometimes looks different
            this.context.drawImage(targetMipmap, -1, -1, 2, 2);
            this.context.restore();
            this.hasDrawnDot = true;
        }
    }
    // continueLine
    continueLine(x, y, size, pressure) {
        if (this.bezierLine === null) {
            this.bezierLine = new (0, $be957da3610487e9$export$921068d8846a1559).BezierLine();
            this.bezierLine.add(this.lastInput.x, this.lastInput.y, 0, ()=>{});
        }
        const drawArr = []; //draw instructions. will be all drawn at once
        const dotCallback = (val)=>{
            const localPressure = (0, $be957da3610487e9$export$921068d8846a1559).mix(this.lastInput2.pressure, pressure, val.t);
            const localOpacity = this.calcOpacity(localPressure);
            const localSize = Math.max(0.1, this.settingSize * (this.settingHasSizePressure ? localPressure : 1));
            const localScatter = this.calcScatter(localPressure);
            drawArr.push([
                val.x,
                val.y,
                localSize,
                localOpacity,
                localScatter,
                val.angle
            ]);
        };
        const localSpacing = size * this.settingSpacing;
        if (x === null || y === null) this.bezierLine.addFinal(localSpacing, dotCallback);
        else this.bezierLine.add(x, y, localSpacing, dotCallback);
        // execute draw instructions
        this.context.save();
        let before = undefined;
        for(let i = 0; i < drawArr.length; i++){
            const item = drawArr[i];
            this.drawDot(item[0], item[1], item[2], item[3], item[4], item[5], before);
            before = item;
        }
        this.context.restore();
    }
    // ---- interface ----
    startLine(x, y, p) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.changedTiles = [];
        p = (0, $be957da3610487e9$export$921068d8846a1559).clamp(p, 0, 1);
        const localOpacity = this.calcOpacity(p);
        const localSize = this.settingHasSizePressure ? Math.max(0.1, p * this.settingSize) : Math.max(0.1, this.settingSize);
        const localScatter = this.calcScatter(p);
        this.hasDrawnDot = false;
        this.inputIsDrawing = true;
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        this.drawDot(x, y, localSize, localOpacity, localScatter);
        this.context.restore();
        this.lineToolLastDot = localSize * this.settingSpacing;
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        this.lastInput2.pressure = p;
        this.inputArr = [
            {
                x: x,
                y: y,
                pressure: p
            }
        ];
    }
    goLine(x, y, p) {
        if (!this.inputIsDrawing) return;
        const pressure = (0, $be957da3610487e9$export$921068d8846a1559).clamp(p, 0, 1);
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        this.continueLine(x, y, localSize, this.lastInput.pressure);
        /*context.fillStyle = 'red';
        context.fillRect(Math.floor(x), Math.floor(y - 10), 1, 20);
        context.fillRect(Math.floor(x - 10), Math.floor(y), 20, 1);*/ this.context.restore();
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput2.pressure = this.lastInput.pressure;
        this.lastInput.pressure = pressure;
        this.inputArr.push({
            x: x,
            y: y,
            pressure: p
        });
    }
    endLine() {
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        this.continueLine(null, null, localSize, this.lastInput.pressure);
        this.context.restore();
        this.inputIsDrawing = false;
        if (this.settingAlphaId === $056317e1fc5cf742$var$ALPHA_SQUARE && !this.hasDrawnDot) {
            // find max pressure input, use that one
            let maxInput = this.inputArr[0];
            this.inputArr.forEach((item)=>{
                if (item.pressure > maxInput.pressure) maxInput = item;
            });
            this.context.save();
            this.selectionPath && this.context.clip(this.selectionPath);
            const p = (0, $be957da3610487e9$export$921068d8846a1559).clamp(maxInput.pressure, 0, 1);
            const localOpacity = this.calcOpacity(p);
            const localScatter = this.calcScatter(p);
            this.drawDot(maxInput.x, maxInput.y, localSize, localOpacity, localScatter, 0);
            this.context.restore();
        }
        this.bezierLine = null;
        if (this.changedTiles.some((item)=>item)) this.klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $3aa9c52208735678$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles)));
        this.hasDrawnDot = false;
        this.inputArr = [];
    }
    drawLineSegment(x1, y1, x2, y2) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.changedTiles = [];
        this.lastInput.x = x2;
        this.lastInput.y = y2;
        this.lastInput.pressure = 1;
        if (this.inputIsDrawing || x1 === undefined) return;
        const angle = (0, $be957da3610487e9$export$921068d8846a1559).pointsToAngleDeg({
            x: x1,
            y: y1
        }, {
            x: x2,
            y: y2
        });
        const mouseDist = Math.sqrt((x2 - x1) ** 2.0 + (y2 - y1) ** 2.0);
        const eX = (x2 - x1) / mouseDist;
        const eY = (y2 - y1) / mouseDist;
        let loopDist;
        const bdist = this.settingSize * this.settingSpacing;
        this.lineToolLastDot = this.settingSize * this.settingSpacing;
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        const localScatter = this.calcScatter(1);
        for(loopDist = this.lineToolLastDot; loopDist <= mouseDist; loopDist += bdist)this.drawDot(x1 + eX * loopDist, y1 + eY * loopDist, this.settingSize, this.settingOpacity, localScatter, angle);
        this.context.restore();
        if (this.changedTiles.some((item)=>item)) this.klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $3aa9c52208735678$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles)));
    }
    //IS
    isDrawing() {
        return this.inputIsDrawing;
    }
    //SET
    setAlpha(a) {
        if (this.settingAlphaId === a) return;
        this.settingAlphaId = a;
        this.updateAlphaCanvas();
    }
    setColor(c) {
        if (this.settingColor === c) return;
        this.settingColor = {
            r: c.r,
            g: c.g,
            b: c.b
        };
        this.settingColorStr = 'rgb(' + this.settingColor.r + ',' + this.settingColor.g + ',' + this.settingColor.b + ')';
        this.updateAlphaCanvas();
    }
    setContext(c) {
        this.context = c;
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    setSize(s) {
        this.settingSize = s;
    }
    setOpacity(o) {
        this.settingOpacity = o;
    }
    setScatter(o) {
        this.settingScatter = o;
    }
    setSpacing(s) {
        this.settingSpacing = s;
    }
    sizePressure(b) {
        this.settingHasSizePressure = b;
    }
    opacityPressure(b) {
        this.settingHasOpacityPressure = b;
    }
    scatterPressure(b) {
        this.settingHasScatterPressure = b;
    }
    setLockAlpha(b) {
        this.settingLockLayerAlpha = b;
    }
    //GET
    getSpacing() {
        return this.settingSpacing;
    }
    getSize() {
        return this.settingSize;
    }
    getOpacity() {
        return this.settingOpacity;
    }
    getScatter() {
        return this.settingScatter;
    }
    getLockAlpha() {
        return this.settingLockLayerAlpha;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.context = {};
        this.klHistory = {};
        this.settingHasOpacityPressure = false;
        this.settingHasScatterPressure = false;
        this.settingHasSizePressure = true;
        this.settingSize = 2;
        this.settingSpacing = 0.8489;
        this.settingOpacity = 1;
        this.settingScatter = 0;
        this.settingColor = {};
        this.settingColorStr = '';
        this.settingAlphaId = $056317e1fc5cf742$var$ALPHA_CIRCLE;
        this.settingLockLayerAlpha = false;
        this.hasDrawnDot = false;
        this.lineToolLastDot = 0;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.inputArr = [];
        this.inputIsDrawing = false;
        this.bezierLine = null;
        // mipmapping
        this.alphaCanvas128 = (0, $be957da3610487e9$export$921068d8846a1559).canvas(128, 128);
        this.alphaCanvas64 = (0, $be957da3610487e9$export$921068d8846a1559).canvas(64, 64);
        this.alphaCanvas32 = (0, $be957da3610487e9$export$921068d8846a1559).canvas(32, 32);
        this.alphaOpacityArr = [
            1,
            0.9,
            1,
            1
        ];
        this.changedTiles = [];
    }
}















class $615bf759035fcabb$export$9659db8d01dd5313 {
    updateRedrawBounds(bounds) {
        const boundsWithinSelection = (0, $4c2c6808296c0d73$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return;
        this.redrawBounds = (0, $be957da3610487e9$export$921068d8846a1559).updateBounds(this.redrawBounds, boundsWithinSelection);
    }
    getCellsWidth() {
        return Math.ceil(this.context.canvas.width / (0, $211b564339712990$export$f7bc58374d6bc9b6));
    }
    /**
     * draw cells onto context
     * @param cells
     */ drawCells(cells) {
        const cellsW = this.getCellsWidth();
        cells.forEach((imageData, index)=>{
            if (!imageData) return;
            const cellOffsetX = index % cellsW * (0, $211b564339712990$export$f7bc58374d6bc9b6);
            const cellOffsetY = Math.floor(index / cellsW) * (0, $211b564339712990$export$f7bc58374d6bc9b6);
            this.context.putImageData(imageData, cellOffsetX, cellOffsetY);
        });
    }
    /**
     * draw changed cells (changed by brushstroke) onto context
     * @private
     */ drawChangedCells() {
        if (!this.redrawBounds) return;
        const cells = this.cells.map(()=>undefined);
        const touchedCells = this.getTouchedCells(this.redrawBounds);
        touchedCells.forEach((isTouched, index)=>{
            if (isTouched) cells[index] = this.cells[index];
        });
        this.drawCells(cells);
        this.redrawBounds = undefined;
    }
    getTouchedCells(bounds) {
        const touchedCells = this.cells.map(()=>false);
        const cellsW = this.getCellsWidth();
        bounds = {
            type: 'index',
            x1: Math.floor(bounds.x1 / (0, $211b564339712990$export$f7bc58374d6bc9b6)),
            y1: Math.floor(bounds.y1 / (0, $211b564339712990$export$f7bc58374d6bc9b6)),
            x2: Math.floor(bounds.x2 / (0, $211b564339712990$export$f7bc58374d6bc9b6)),
            y2: Math.floor(bounds.y2 / (0, $211b564339712990$export$f7bc58374d6bc9b6))
        };
        for(let i = bounds.x1; i <= bounds.x2; i++)for(let e = bounds.y1; e <= bounds.y2; e++)touchedCells[e * cellsW + i] = true;
        return touchedCells;
    }
    /**
     * Slice up bounds according to cells
     * @param bounds
     * @private
     */ sliceBounds(bounds) {
        const boundsWithinSelection = (0, $4c2c6808296c0d73$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return [];
        const cellsW = this.getCellsWidth();
        const result = [];
        const touchedCells = this.getTouchedCells(boundsWithinSelection);
        touchedCells.forEach((cell, i)=>{
            if (!cell) return;
            const cellOffsetX = i % cellsW * (0, $211b564339712990$export$f7bc58374d6bc9b6);
            const cellOffsetY = Math.floor(i / cellsW) * (0, $211b564339712990$export$f7bc58374d6bc9b6);
            const cellWidth = this.cells[i].width;
            const cellHeight = this.cells[i].height;
            const inCellBounds = {
                type: 'index',
                x1: Math.max(0, boundsWithinSelection.x1 - cellOffsetX),
                y1: Math.max(0, boundsWithinSelection.y1 - cellOffsetY),
                x2: Math.min(cellWidth - 1, boundsWithinSelection.x2 - cellOffsetX),
                y2: Math.min(cellHeight - 1, boundsWithinSelection.y2 - cellOffsetY)
            };
            if (inCellBounds.x1 > inCellBounds.x2 || inCellBounds.y1 > inCellBounds.y2) return;
            result.push({
                index: i,
                bounds: inCellBounds
            });
        });
        return result;
    }
    /**
     * update copyImageData. copy over new regions if needed
     */ copyFromCanvas(bounds) {
        if (!bounds) return;
        const touchedCells = this.getTouchedCells(bounds);
        const composedLayer = this.klHistory.getComposed().layerMap[this.layerId];
        let canvas;
        touchedCells.forEach((item, i)=>{
            if (!item || this.cells[i]) // not touched, or already copied
            return;
            // Uncaught TypeError: Cannot read properties of undefined (reading 'tiles')
            const composedTile = composedLayer.tiles[i];
            if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(composedTile)) {
                const { width: width, height: height } = (0, $aab5cae708a98039$export$c849c66042090269)(i, this.context.canvas);
                if (!canvas) canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(width, height);
                else (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(canvas, width, height, {
                    ensureCleared: true
                });
                const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
                ctx.fillStyle = composedTile.fill;
                ctx.fillRect(0, 0, width, height);
                // InvalidStateError: The object is in an invalid state.
                this.cells[i] = ctx.getImageData(0, 0, width, height);
            } else this.cells[i] = (0, $9b7bcd54b484ef9c$export$3d7bd55e322555b1)(composedTile.data);
        });
        if (canvas) (0, $2f436639594531f3$export$2384aff49c9b73c2)(canvas);
    }
    getAverage(x, y, size) {
        size = Math.max(0.5, size * 0.75);
        const x1 = Math.max(0, Math.floor(x - size));
        const y1 = Math.max(0, Math.floor(y - size));
        const x2 = Math.min(this.context.canvas.width - 1, Math.ceil(x + size));
        const y2 = Math.min(this.context.canvas.height - 1, Math.ceil(y + size));
        if (x1 > x2 || y1 > y2) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        };
        let ar = 0, ag = 0, ab = 0, aa = 0;
        const slicedBounds = this.sliceBounds({
            type: 'index',
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        });
        const cellsW = this.getCellsWidth();
        slicedBounds.forEach((slice)=>{
            const cellOffsetX = slice.index % cellsW * (0, $211b564339712990$export$f7bc58374d6bc9b6);
            const cellOffsetY = Math.floor(slice.index / cellsW) * (0, $211b564339712990$export$f7bc58374d6bc9b6);
            const width = this.cells[slice.index].width;
            const data = this.cells[slice.index].data;
            const bounds = slice.bounds;
            for(let i = bounds.y1, globalY = i + cellOffsetY; i <= bounds.y2; i++, globalY++)for(let e = bounds.x1, globalX = e + cellOffsetX, e2 = (i * width + bounds.x1) * 4; e <= bounds.x2; e++, globalX++, e2 += 4){
                if (this.mask && this.mask[globalY * this.context.canvas.width + globalX] === 0) continue;
                const alpha = data[e2 + 3] / 255;
                if (alpha === 0) continue;
                ar += data[e2] * alpha;
                ag += data[e2 + 1] * alpha;
                ab += data[e2 + 2] * alpha;
                aa += alpha;
            }
        });
        if (aa !== 0) {
            ar /= aa;
            ag /= aa;
            ab /= aa;
            aa = Math.min(1, aa);
        }
        return {
            r: ar,
            g: ag,
            b: ab,
            a: aa
        };
    }
    getDotBounds(x, y, size) {
        size = Math.max(0.5, size);
        const x1 = Math.max(0, Math.floor(x - size));
        const y1 = Math.max(0, Math.floor(y - size));
        const x2 = Math.min(this.context.canvas.width - 1, Math.ceil(x + size));
        const y2 = Math.min(this.context.canvas.height - 1, Math.ceil(y + size));
        if (x1 > x2 || y1 > y2) return undefined;
        return {
            type: 'index',
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        };
    }
    drawDot(params) {
        // array with random numbers. faster than Math.random()
        let randI = 0;
        const randLen = params.size > 30 ? 1024 : 512; // lower lengths lead to noticeable patterns
        const randArr = [];
        for(let i = 0; i < randLen; i++)randArr[i] = (Math.random() - 0.5) / 1.001 + 0.5;
        // thin lines take more than just 1 sample
        const sampleArr = [
            8,
            4,
            4,
            4,
            2,
            2,
            2,
            2,
            2,
            2
        ]; // <0.5, 0.5, 1, 1.5, etc.
        const samples = sampleArr[Math.floor(params.size * 2)];
        const samplesSquared = samples ? samples * samples : 0;
        const sampleOffsets = [];
        if (samples) {
            let i = 0;
            for(let n = 0; n < samples; n++)for(let m = 0; m < samples; m++, i += 2){
                sampleOffsets[i] = (n + 1) / samples; // x offset
                sampleOffsets[i + 1] = (m + 1) / samples; // y offset
            }
        }
        const sharpness = params.opacity ** 2 * 0.8;
        // to optimize calculations
        const invSharpness = 1 - sharpness;
        const sharpnessSubtrahend = sharpness / invSharpness;
        const sizeSquared = params.size * params.size;
        const distDivisor = sizeSquared * invSharpness / params.opacity;
        const alphaMinuend = (1 + sharpnessSubtrahend) * params.opacity;
        const slicedBounds = this.sliceBounds({
            type: 'index',
            x1: params.x1,
            y1: params.y1,
            x2: params.x2,
            y2: params.y2
        });
        const cellsW = this.getCellsWidth();
        slicedBounds.forEach((slice)=>{
            const cellOffsetX = slice.index % cellsW * (0, $211b564339712990$export$f7bc58374d6bc9b6);
            const cellOffsetY = Math.floor(slice.index / cellsW) * (0, $211b564339712990$export$f7bc58374d6bc9b6);
            const cellWidth = this.cells[slice.index].width;
            const data = this.cells[slice.index].data;
            // i - y index within cell
            // e - x index within cell
            // e2 - index in image data (a tile)
            // mi - index in mask (one mask for the entire image)
            // ri - y index within image relative to dot-center
            // re - x index within image relative to dot-center
            for(let i = slice.bounds.y1, ri = i + cellOffsetY - params.y; i <= slice.bounds.y2; i++, ri++)for(let e = slice.bounds.x1, mi = (i + cellOffsetY) * this.context.canvas.width + (slice.bounds.x1 + cellOffsetX), e2 = (i * cellWidth + slice.bounds.x1) * 4, re = e + cellOffsetX - params.x; e <= slice.bounds.x2; e++, mi++, e2 += 4, re++){
                if (this.mask && this.mask[mi] === 0) continue;
                // O = over -> brush-dot
                // U = under -> image
                let alphaO = 0;
                if (samplesSquared) {
                    for(let f = 0; f < sampleOffsets.length; f += 2){
                        const dist = (0, $be957da3610487e9$export$921068d8846a1559).lenSquared(re + sampleOffsets[f], ri + sampleOffsets[f + 1]);
                        if (dist >= sizeSquared) continue;
                        alphaO += (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(alphaMinuend - dist / distDivisor, 0, params.opacity);
                    }
                    if (!alphaO) continue;
                    alphaO /= samplesSquared;
                } else {
                    // technically needs + 0.5 offset, but not noticeable with large brush
                    const dist = re ** 2 + ri ** 2;
                    if (dist >= sizeSquared) continue;
                    alphaO = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(alphaMinuend - dist / distDivisor, 0, params.opacity);
                }
                const invAlphaO = 1 - alphaO;
                const alphaU = data[e2 + 3] / 255;
                if (this.settingLockLayerAlpha) {
                    const underR = params.r * alphaO + data[e2] * invAlphaO;
                    const underG = params.g * alphaO + data[e2 + 1] * invAlphaO;
                    const underB = params.b * alphaO + data[e2 + 2] * invAlphaO;
                    if (alphaU) {
                        data[e2] = Math.floor(underR + randArr[randI]);
                        data[e2 + 1] = Math.floor(underG + randArr[randI]);
                        data[e2 + 2] = Math.floor(underB + randArr[randI]);
                    }
                } else {
                    const underR = params.r * alphaO + data[e2] * alphaU * invAlphaO;
                    const underG = params.g * alphaO + data[e2 + 1] * alphaU * invAlphaO;
                    const underB = params.b * alphaO + data[e2 + 2] * alphaU * invAlphaO;
                    const newAlpha = 1 - invAlphaO * (1 - alphaU);
                    data[e2 + 3] = Math.floor(Math.min(255, newAlpha * 255) + 0.5);
                    if (newAlpha) {
                        data[e2] = Math.floor(underR / newAlpha + randArr[randI]);
                        data[e2 + 1] = Math.floor(underG / newAlpha + randArr[randI]);
                        data[e2 + 2] = Math.floor(underB / newAlpha + randArr[randI]);
                    }
                }
                randI = (randI + 1) % randLen;
            }
        });
    }
    calcSpacing(size) {
        return (0, $be957da3610487e9$export$921068d8846a1559).mix(size * 2 / 2, size * 2 / 9, (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)((size - 2.7) / 9.3, 0, 1));
    }
    continueLine(x, y, p, isCoalesced) {
        this.drawBuffer = [];
        let localPressure;
        let localOpacity;
        let localSize = this.settingSizePressure ? Math.max(1, p * this.size) : Math.max(1, this.size);
        const bDist = this.calcSpacing(localSize);
        const avgX = x === undefined ? this.lastInput.x : x;
        const avgY = y === undefined ? this.lastInput.y : y;
        let localColNew;
        if (this.blending === 0) {
            this.mixCol.r = this.color.r;
            this.mixCol.g = this.color.g;
            this.mixCol.b = this.color.b;
        } else {
            let average;
            if (isCoalesced) average = {
                r: this.localColOld.r,
                g: this.localColOld.g,
                b: this.localColOld.b,
                a: 0
            };
            else {
                const avgParams = [
                    avgX,
                    avgY,
                    this.settingSizePressure ? Math.max(0.5, p * this.size) : Math.max(0.5, this.size)
                ];
                const bounds = this.getDotBounds(avgParams[0], avgParams[1], avgParams[2]);
                if (bounds) this.copyFromCanvas(bounds);
                average = this.getAverage(avgParams[0], avgParams[1], avgParams[2]);
            }
            localColNew = {
                r: 0,
                g: 0,
                b: 0,
                a: 0
            };
            if (average.a > 0 && this.blendCol.a === 0) {
                this.blendCol.r = average.r;
                this.blendCol.g = average.g;
                this.blendCol.b = average.b;
                this.blendCol.a = average.a;
                localColNew.r = this.blendCol.r;
                localColNew.g = this.blendCol.g;
                localColNew.b = this.blendCol.b;
                localColNew.a = this.blendCol.a;
            } else {
                if (average.a === 0) {
                    average.r = this.color.r;
                    average.g = this.color.g;
                    average.b = this.color.b;
                    average.a = 1 - this.blending;
                }
                this.blendCol.r = (0, $be957da3610487e9$export$921068d8846a1559).mix(this.blendCol.r, (0, $be957da3610487e9$export$921068d8846a1559).mix(this.blendCol.r, average.r, this.blendMix), average.a);
                this.blendCol.g = (0, $be957da3610487e9$export$921068d8846a1559).mix(this.blendCol.g, (0, $be957da3610487e9$export$921068d8846a1559).mix(this.blendCol.g, average.g, this.blendMix), average.a);
                this.blendCol.b = (0, $be957da3610487e9$export$921068d8846a1559).mix(this.blendCol.b, (0, $be957da3610487e9$export$921068d8846a1559).mix(this.blendCol.b, average.b, this.blendMix), average.a);
                this.blendCol.a = Math.min(1, this.blendCol.a + average.a);
                localColNew.r = this.blendCol.r;
                localColNew.g = this.blendCol.g;
                localColNew.b = this.blendCol.b;
                localColNew.a = this.blendCol.a;
            }
        }
        const dotCallback = (val)=>{
            if (this.blending >= 1 && this.blendCol.a <= 0) return;
            const factor = val.t;
            localPressure = this.lastInput2.pressure * (1 - factor) + p * factor;
            localOpacity = this.settingOpacityPressure ? this.opacity * localPressure * localPressure : this.opacity;
            localSize = this.settingSizePressure ? Math.max(0.1, localPressure * this.size) : Math.max(0.1, this.size);
            if (this.blending !== 0) {
                this.mixCol.r = (0, $be957da3610487e9$export$921068d8846a1559).mix(this.localColOld.r, localColNew.r, factor);
                this.mixCol.g = (0, $be957da3610487e9$export$921068d8846a1559).mix(this.localColOld.g, localColNew.g, factor);
                this.mixCol.b = (0, $be957da3610487e9$export$921068d8846a1559).mix(this.localColOld.b, localColNew.b, factor);
            }
            if (this.blending === 1 && this.localColOld.a === 0) {
                this.mixCol.r = localColNew.r;
                this.mixCol.g = localColNew.g;
                this.mixCol.b = localColNew.b;
            }
            const bounds = this.getDotBounds(val.x, val.y, localSize);
            if (bounds) {
                this.updateRedrawBounds(bounds);
                this.drawBuffer.push({
                    x: val.x,
                    y: val.y,
                    size: localSize,
                    opacity: localOpacity,
                    x1: bounds.x1,
                    y1: bounds.y1,
                    x2: bounds.x2,
                    y2: bounds.y2,
                    r: (0, $be957da3610487e9$export$921068d8846a1559).mix(this.color.r, this.mixCol.r, this.blending),
                    g: (0, $be957da3610487e9$export$921068d8846a1559).mix(this.color.g, this.mixCol.g, this.blending),
                    b: (0, $be957da3610487e9$export$921068d8846a1559).mix(this.color.b, this.mixCol.b, this.blending)
                });
            }
        };
        if (x === undefined || y === undefined) this.bezierLine.addFinal(bDist, dotCallback);
        else this.bezierLine.add(x, y, bDist, dotCallback);
        this.copyFromCanvas(this.redrawBounds);
        this.drawBuffer.forEach((item)=>{
            this.drawDot(item);
        });
        this.drawBuffer = [];
        if (this.blending !== 0) this.localColOld = localColNew;
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    getSize() {
        return this.size;
    }
    setSize(s) {
        this.size = s;
    }
    getOpacity() {
        return this.opacity;
    }
    setOpacity(o) {
        this.opacity = o;
    }
    getBlending() {
        return this.blending;
    }
    setBlending(b) {
        this.blending = b;
    }
    setColor(c) {
        this.color = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(c);
    }
    setContext(c, id) {
        this.context = c;
        this.layerId = id;
    }
    setSizePressure(b) {
        this.settingSizePressure = b;
    }
    setOpacityPressure(b) {
        this.settingOpacityPressure = b;
    }
    getLockAlpha() {
        return this.settingLockLayerAlpha;
    }
    setLockAlpha(b) {
        this.settingLockLayerAlpha = b;
    }
    getIsDrawing() {
        return this.isDrawing;
    }
    startLine(x, y, p) {
        const selection = this.klHistory.getComposed().selection.value;
        this.selectionBounds = selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(selection, 'index') : undefined;
        this.mask = selection ? (0, $21750daad446671b$export$820c5732ce56544)(selection, this.context.canvas.width, this.context.canvas.height) : undefined;
        const totalCells = Math.ceil(this.context.canvas.width / (0, $211b564339712990$export$f7bc58374d6bc9b6)) * Math.ceil(this.context.canvas.height / (0, $211b564339712990$export$f7bc58374d6bc9b6));
        this.cells = (0, $94f0b2b810d4d191$export$7f1ebd623f131021)(totalCells, undefined);
        this.isDrawing = true;
        p = Math.max(0, Math.min(1, p));
        const localOpacity = this.settingOpacityPressure ? this.opacity * p * p : this.opacity;
        const localSize = this.settingSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size);
        if (this.blending === 0) {
            this.mixCol.r = this.color.r;
            this.mixCol.g = this.color.g;
            this.mixCol.b = this.color.b;
        } else {
            this.copyFromCanvas(this.getDotBounds(x, y, localSize));
            const average = this.getAverage(x, y, this.settingSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size));
            if (average.a === 0) this.blendCol = {
                r: this.color.r,
                g: this.color.g,
                b: this.color.b,
                a: 1 - this.blending
            };
            else this.blendCol = {
                r: average.r,
                g: average.g,
                b: average.b,
                a: average.a
            };
            this.mixCol.r = this.blendCol.r;
            this.mixCol.g = this.blendCol.g;
            this.mixCol.b = this.blendCol.b;
        }
        this.localColOld = {
            r: this.mixCol.r,
            g: this.mixCol.g,
            b: this.mixCol.b,
            a: this.blendCol.a
        };
        this.redrawBounds = undefined;
        this.drawBuffer = [];
        if (this.blending < 1 || this.blendCol.a > 0) {
            const bounds = this.getDotBounds(x, y, localSize);
            if (bounds) {
                this.updateRedrawBounds(bounds);
                this.drawBuffer.push({
                    x: x,
                    y: y,
                    size: localSize,
                    opacity: localOpacity,
                    x1: bounds.x1,
                    y1: bounds.y1,
                    x2: bounds.x2,
                    y2: bounds.y2,
                    r: (0, $be957da3610487e9$export$921068d8846a1559).mix(this.color.r, this.mixCol.r, this.blending),
                    g: (0, $be957da3610487e9$export$921068d8846a1559).mix(this.color.g, this.mixCol.g, this.blending),
                    b: (0, $be957da3610487e9$export$921068d8846a1559).mix(this.color.b, this.mixCol.b, this.blending)
                });
            }
        }
        this.copyFromCanvas(this.redrawBounds);
        this.drawBuffer.forEach((item)=>{
            this.drawDot(item);
        });
        this.drawBuffer = [];
        this.bezierLine = new (0, $be957da3610487e9$export$921068d8846a1559).BezierLine();
        this.bezierLine.add(x, y, 0, function() {});
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        this.lastInput2 = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.lastInput);
    }
    goLine(x, y, p, isCoalesced) {
        if (!this.isDrawing) return;
        this.continueLine(x, y, this.lastInput.pressure, isCoalesced);
        this.lastInput2 = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.lastInput);
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
    }
    endLine() {
        if (this.bezierLine) this.continueLine(undefined, undefined, this.lastInput.pressure, false);
        this.isDrawing = false;
        this.bezierLine = undefined;
        this.drawChangedCells();
        if (this.cells.some((item)=>item)) {
            let cells = this.cells;
            if (this.selectionBounds) {
                const tilesInSelection = (0, $a0d4fe9620fd4adc$export$2098fe43203ddd32)(this.selectionBounds, this.context.canvas.width, this.context.canvas.height);
                cells = cells.map((cell, index)=>{
                    return tilesInSelection[index] ? cell : undefined;
                });
            }
            this.klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(this.klHistory.getComposed(), cells.map((cell)=>{
                return cell ? (0, $aab5cae708a98039$export$55941c74c8f934)(cell) : undefined;
            })));
        }
        this.cells = [];
    }
    transferToCanvas() {
        this.drawChangedCells();
    }
    drawLineSegment(x1, y1, x2, y2) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        const distance = Math.sqrt(dx * dx + dy * dy);
        const steps = Math.ceil(distance / 10);
        this.startLine(x1, y1, 1);
        for(let i = 1; i <= steps; i++){
            const t = i / steps;
            const xi = x1 + dx * t;
            const yi = y1 + dy * t;
            this.goLine(xi, yi, 1, false);
        }
        this.endLine();
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.context = {};
        this.layerId = 'NOT_SET';
        this.color = {};
        this.size = 29 // radius - 0.5 - 99999
        ;
        this.opacity = 0.6 // 0-1
        ;
        this.blending = 0.65 // 0-1
        ;
        this.settingLockLayerAlpha = false;
        this.settingSizePressure = true;
        this.settingOpacityPressure = false;
        this.blendCol = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        } // todo docs
        ;
        this.blendMix = 0.45 // todo docs
        ;
        this.mixCol = {
            r: 0,
            g: 0,
            b: 0
        } // todo docs
        ;
        this.localColOld = {} // todo docs
        ;
        this.isDrawing = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        } // todo docs
        ;
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        } // todo docs
        ;
        this.klHistory = {};
        this.cells = [];
        this.drawBuffer = [];
    }
}








const $5efdbfb0f3112f07$var$sampleCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(32, 32);
const $5efdbfb0f3112f07$var$sampleCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx($5efdbfb0f3112f07$var$sampleCanvas);
class $5efdbfb0f3112f07$export$566f9061f0f5ba33 {
    rand() {
        this.sketchySeed++;
        return Math.sin(6324634.2345 * Math.cos(this.sketchySeed * 5342.3423)) * 0.5 + 0.5;
    }
    // ---- interface ----
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    setSeed(s) {
        this.sketchySeed = parseInt('' + s);
    }
    getSeed() {
        return parseInt('' + this.sketchySeed);
    }
    getSize() {
        return this.settingSize / 2;
    }
    setColor(c) {
        this.settingColor = c;
    }
    getOpacity() {
        return this.settingOpacity;
    }
    setOpacity(o) {
        this.settingOpacity = o;
    }
    getBlending() {
        return this.settingBlending;
    }
    setBlending(b) {
        this.settingBlending = b;
    }
    setSize(s) {
        this.settingSize = s * 2;
    }
    getScale() {
        return this.settingScale;
    }
    setScale(s) {
        this.settingScale = s;
    }
    setContext(c) {
        this.context = c;
    }
    startLine(x, y, pressure, shift) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.changedBounds = undefined;
        if (shift && this.lastInput.x) {
            this.inputIsDrawing = true;
            this.endLine();
        } else {
            this.inputIsDrawing = true;
            this.lastX = x;
            this.lastY = y;
            this.lastInput.x = x;
            this.lastInput.y = y;
        }
    }
    goLine(p_x, p_y, pressure, preMixedColor) {
        if (!this.inputIsDrawing || p_x === this.lastInput.x && p_y === this.lastInput.y) return;
        let e, b, a, g;
        const x = parseInt('' + p_x);
        const y = parseInt('' + p_y);
        this.points.push([
            x,
            y
        ]);
        let mixr = this.settingColor.r;
        let mixg = this.settingColor.g;
        let mixb = this.settingColor.b;
        if (preMixedColor) {
            mixr = preMixedColor.r;
            mixg = preMixedColor.g;
            mixb = preMixedColor.b;
        } else {
            if (this.settingBlending !== 0) {
                if (x + 5 >= 0 && y + 5 >= 0 && x - 5 < this.context.canvas.width - 1 && y - 5 < this.context.canvas.height - 1) {
                    mixr = 0;
                    mixg = 0;
                    mixb = 0;
                    const mixX = Math.min(this.context.canvas.width - 1, Math.max(0, x - 5));
                    const mixY = Math.min(this.context.canvas.height - 1, Math.max(0, y - 5));
                    let mixW = Math.min(this.context.canvas.width - 1, Math.max(0, x + 5));
                    let mixH = Math.min(this.context.canvas.height - 1, Math.max(0, y + 5));
                    mixW -= mixX;
                    mixH -= mixY;
                    if (mixW > 0 && mixH > 0) {
                        const imDat = this.context.getImageData(mixX, mixY, mixW, mixH);
                        let countMix = 0;
                        for(let i = 0; i < imDat.data.length; i += 4){
                            mixr += imDat.data[i + 0];
                            mixg += imDat.data[i + 1];
                            mixb += imDat.data[i + 2];
                            countMix++;
                        }
                        mixr /= countMix;
                        mixg /= countMix;
                        mixb /= countMix;
                    }
                    const mixed = this.mixMode[0](new (0, $be957da3610487e9$export$921068d8846a1559).RGB(mixr, mixg, mixb), this.settingColor);
                    mixr = parseInt('' + (0, $be957da3610487e9$export$921068d8846a1559).mix(this.settingColor.r, mixed.r, this.settingBlending));
                    mixg = parseInt('' + (0, $be957da3610487e9$export$921068d8846a1559).mix(this.settingColor.g, mixed.g, this.settingBlending));
                    mixb = parseInt('' + (0, $be957da3610487e9$export$921068d8846a1559).mix(this.settingColor.b, mixed.b, this.settingBlending));
                }
            }
        }
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        this.context.strokeStyle = 'rgba(' + mixr + ', ' + mixg + ', ' + mixb + ', ' + this.settingOpacity + ')';
        this.context.lineWidth = this.settingSize;
        this.context.beginPath();
        this.context.moveTo(this.lastX, this.lastY);
        this.context.lineTo(x, y);
        for(e = 0; e < this.points.length; e++){
            b = this.points[e][0] - this.points[this.count][0];
            a = this.points[e][1] - this.points[this.count][1];
            g = b * b + a * a;
            if (g < 4000 * this.settingScale * this.settingScale && this.rand() > g / 2000 / this.settingScale / this.settingScale) {
                this.context.moveTo(this.points[this.count][0] + b * 0.3, this.points[this.count][1] + a * 0.3);
                this.context.lineTo(this.points[e][0] - b * 0.3, this.points[e][1] - a * 0.3);
            }
        }
        this.context.stroke();
        this.context.restore();
        this.count++;
        this.lastX = x;
        this.lastY = y;
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.changedBounds = (0, $be957da3610487e9$export$921068d8846a1559).updateBounds(this.changedBounds, {
            type: 'index',
            x1: Math.floor(x - this.settingSize / 2),
            y1: Math.floor(y - this.settingSize / 2),
            x2: Math.ceil(x + this.settingSize / 2),
            y2: Math.ceil(y + this.settingSize / 2)
        });
    }
    endLine() {
        this.inputIsDrawing = false;
        this.count = 0;
        this.points = [];
        if (this.changedBounds) {
            const boundsWithinSelection = (0, $4c2c6808296c0d73$export$83720aaadc272d85)(this.changedBounds, this.selectionBounds);
            const layerData = (0, $3aa9c52208735678$export$7b1ba44282f9a519)(this.context.canvas, boundsWithinSelection);
            if (layerData.some((item)=>item)) this.klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(this.klHistory.getComposed(), layerData));
        }
    }
    //cheap 'n' ugly
    drawLineSegment(x1, y1, x2, y2) {
        this.changedBounds = undefined;
        this.lastInput.x = x2;
        this.lastInput.y = y2;
        if (this.inputIsDrawing || x1 === undefined) return;
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        this.context.lineWidth = this.settingSize;
        const mixCol = {
            r: this.settingColor.r,
            g: this.settingColor.g,
            b: this.settingColor.b
        };
        if (x1 + 5 >= 0 && y1 + 5 >= 0 && x1 - 5 < this.context.canvas.width - 1 && y1 - 5 < this.context.canvas.height - 1) {
            mixCol.r = 0;
            mixCol.g = 0;
            mixCol.b = 0;
            const mixX = Math.min(this.context.canvas.width - 1, Math.max(0, x1 - 5));
            const mixY = Math.min(this.context.canvas.height - 1, Math.max(0, y1 - 5));
            let mixW = Math.min(this.context.canvas.width - 1, Math.max(0, x1 + 5));
            let mixH = Math.min(this.context.canvas.height - 1, Math.max(0, y1 + 5));
            mixW -= mixX;
            mixH -= mixY;
            if (mixW > 0 && mixH > 0) {
                const w = Math.min($5efdbfb0f3112f07$var$sampleCanvas.width, mixW);
                const h = Math.min($5efdbfb0f3112f07$var$sampleCanvas.height, mixH);
                $5efdbfb0f3112f07$var$sampleCtx.save();
                $5efdbfb0f3112f07$var$sampleCtx.globalCompositeOperation = 'copy';
                $5efdbfb0f3112f07$var$sampleCtx.drawImage(this.context.canvas, mixX, mixY, mixW, mixH, 0, 0, w, h);
                $5efdbfb0f3112f07$var$sampleCtx.restore();
                const imDat = $5efdbfb0f3112f07$var$sampleCtx.getImageData(mixX, mixY, mixW, mixH);
                let countMix = 0;
                for(let i = 0; i < imDat.data.length; i += 4){
                    mixCol.r += imDat.data[i + 0];
                    mixCol.g += imDat.data[i + 1];
                    mixCol.b += imDat.data[i + 2];
                    countMix++;
                }
                mixCol.r /= countMix;
                mixCol.g /= countMix;
                mixCol.b /= countMix;
            }
        }
        const mixed = this.mixMode[0](new (0, $be957da3610487e9$export$921068d8846a1559).RGB(mixCol.r, mixCol.g, mixCol.b), this.settingColor);
        mixCol.r = parseInt('' + (this.settingBlending * mixed.r + this.settingColor.r * (1 - this.settingBlending)));
        mixCol.g = parseInt('' + (this.settingBlending * mixed.g + this.settingColor.g * (1 - this.settingBlending)));
        mixCol.b = parseInt('' + (this.settingBlending * mixed.b + this.settingColor.b * (1 - this.settingBlending)));
        this.context.strokeStyle = 'rgba(' + mixCol.r + ', ' + mixCol.g + ', ' + mixCol.b + ', ' + this.settingOpacity + ')';
        this.context.beginPath();
        this.context.moveTo(x1, y1);
        this.context.lineTo(x2, y2);
        this.context.stroke();
        this.context.strokeStyle = 'rgba(' + mixCol.r + ', ' + mixCol.g + ', ' + mixCol.b + ', ' + this.settingOpacity + ')';
        this.context.restore();
        this.changedBounds = (0, $be957da3610487e9$export$921068d8846a1559).updateBounds(this.changedBounds, {
            type: 'index',
            x1: Math.floor(x1 - this.settingSize / 2),
            y1: Math.floor(y1 - this.settingSize / 2),
            x2: Math.ceil(x1 + this.settingSize / 2),
            y2: Math.ceil(y1 + this.settingSize / 2)
        });
        this.changedBounds = (0, $be957da3610487e9$export$921068d8846a1559).updateBounds(this.changedBounds, {
            type: 'index',
            x1: Math.floor(x2 - this.settingSize / 2),
            y1: Math.floor(y2 - this.settingSize / 2),
            x2: Math.ceil(x2 + this.settingSize / 2),
            y2: Math.ceil(y2 + this.settingSize / 2)
        });
        if (this.changedBounds) {
            const boundsWithinSelection = (0, $4c2c6808296c0d73$export$83720aaadc272d85)(this.changedBounds, this.selectionBounds);
            const layerData = (0, $3aa9c52208735678$export$7b1ba44282f9a519)(this.context.canvas, boundsWithinSelection);
            if (layerData.some((item)=>item)) this.klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(this.klHistory.getComposed(), layerData));
        }
    }
    isDrawing() {
        return this.inputIsDrawing;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.context = {};
        this.settingColor = {};
        this.settingSize = 1;
        this.settingOpacity = 0.2;
        this.settingBlending = 0.5;
        this.settingScale = 1;
        this.lastX = 0;
        this.lastY = 0;
        this.inputIsDrawing = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.klHistory = {};
        this.sketchySeed = 0;
        this.points = [] // x y
        ;
        this.count = 0;
        this.mixMode = [
            (c1)=>{
                return c1;
            },
            (c1, c2)=>{
                // why
                const result = new (0, $be957da3610487e9$export$921068d8846a1559).RGB(c1.r, c1.g, c1.b);
                result.r *= c2.r / 255;
                result.g *= c2.g / 255;
                result.b *= c2.b / 255;
                return result;
            }
        ];
    }
}












// order in which pixels of a 4x4 cell get filled (ordered dithering)
const $be2bfe057d41ff95$var$DITHER_ORDER = [
    [
        3,
        2
    ],
    [
        1,
        0
    ],
    [
        3,
        0
    ],
    [
        1,
        2
    ],
    [
        2,
        1
    ],
    [
        0,
        3
    ],
    [
        0,
        1
    ],
    [
        2,
        3
    ],
    [
        2,
        0
    ],
    [
        0,
        2
    ],
    [
        0,
        0
    ],
    [
        2,
        2
    ],
    [
        1,
        1
    ],
    [
        3,
        3
    ],
    [
        3,
        1
    ],
    [
        1,
        3
    ]
];
// number of filled pixels per 4x4 cell. 16 -> solid
const $be2bfe057d41ff95$var$DITHER_LEVELS = [
    16,
    15,
    14,
    13,
    12,
    10,
    8,
    6,
    4,
    3,
    2,
    1
];
function $be2bfe057d41ff95$var$createDitherPattern(filledCount) {
    const data = new Array(16).fill(0);
    $be2bfe057d41ff95$var$DITHER_ORDER.slice(0, filledCount).forEach(([x, y])=>data[y * 4 + x] = 1);
    return {
        width: 4,
        height: 4,
        data: data
    };
}
// rows of '0' and '1'
function $be2bfe057d41ff95$var$patternFromRows(rows) {
    return {
        width: rows[0].length,
        height: rows.length,
        data: rows.join('').split('').map(Number)
    };
}
const $be2bfe057d41ff95$export$ebb66c2ece63841a = [
    ...$be2bfe057d41ff95$var$DITHER_LEVELS.map($be2bfe057d41ff95$var$createDitherPattern),
    $be2bfe057d41ff95$var$patternFromRows([
        '11',
        '00'
    ]),
    $be2bfe057d41ff95$var$patternFromRows([
        '10',
        '10'
    ]),
    $be2bfe057d41ff95$var$patternFromRows([
        '0001',
        '0010',
        '0100',
        '1000'
    ]),
    $be2bfe057d41ff95$var$patternFromRows([
        '1000',
        '0100',
        '0010',
        '0001'
    ]),
    $be2bfe057d41ff95$var$patternFromRows([
        '1111',
        '1000',
        '1000',
        '1000'
    ]),
    $be2bfe057d41ff95$var$patternFromRows([
        '1100',
        '1100',
        '0011',
        '0011'
    ]),
    $be2bfe057d41ff95$var$patternFromRows([
        '10000001',
        '01000010',
        '00100100',
        '00011000'
    ])
];
const $be2bfe057d41ff95$export$e164bde6f5f7a06a = [
    4,
    8
];
function $be2bfe057d41ff95$export$4b6ac55e3817f8f8(pattern) {
    const size = pattern.width <= 4 && pattern.height <= 4 ? 4 : 8;
    const data = Array.from({
        length: size * size
    }, (_, i)=>{
        const x = i % size % pattern.width;
        const y = Math.floor(i / size) % pattern.height;
        return pattern.data[y * pattern.width + x];
    });
    return {
        width: size,
        height: size,
        data: data
    };
}
function $be2bfe057d41ff95$var$getIsValidPixelPattern(value) {
    if (!value || typeof value !== 'object') return false;
    const { width: width, height: height, data: data } = value;
    return typeof width === 'number' && typeof height === 'number' && $be2bfe057d41ff95$export$e164bde6f5f7a06a.includes(width) && width === height && Array.isArray(data) && data.length === width * height && data.every((item)=>item === 0 || item === 1);
}
// ----------------------------------- custom patterns -----------------------------------
const $be2bfe057d41ff95$var$LS_CUSTOM_PATTERNS_KEY = 'kl-pixel-brush-patterns';
function $be2bfe057d41ff95$export$1714be800c8f1d7c() {
    const str = (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem($be2bfe057d41ff95$var$LS_CUSTOM_PATTERNS_KEY);
    if (!str) return [];
    let parsed;
    try {
        parsed = JSON.parse(str);
    } catch (e) {
        return [];
    }
    if (!Array.isArray(parsed)) return [];
    return parsed.filter($be2bfe057d41ff95$var$getIsValidPixelPattern).map(({ width: width, height: height, data: data })=>({
            width: width,
            height: height,
            data: data
        }));
}
function $be2bfe057d41ff95$export$784a1f68cbc24d89(patterns) {
    (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem($be2bfe057d41ff95$var$LS_CUSTOM_PATTERNS_KEY, JSON.stringify(patterns.map(({ width: width, height: height, data: data })=>({
            width: width,
            height: height,
            data: data
        }))));
}


function $ce287f0b331aeb2c$export$b843be359a1eb867(diameter) {
    const r = diameter <= 2 ? diameter / 2 : diameter / 2 - 0.3;
    const center = diameter / 2;
    return Array.from({
        length: diameter
    }, (_, y)=>{
        const dY = y + 0.5 - center;
        const halfWidth = Math.sqrt(r * r - dY * dY);
        const x0 = Math.ceil(center - halfWidth - 0.5);
        const x1 = Math.floor(center + halfWidth - 0.5);
        return (x1 - x0 + 1) / 2;
    });
}
class $ce287f0b331aeb2c$export$e8c09364097cacae {
    /**
     * @param discs - bounds of each dab. width === height === diameter.
     * @param clip - spans outside of it are dropped.
     */ getRects(discs, clip) {
        const stride = clip.width + 1;
        const rowStride = stride * stride;
        const clipRight = clip.x + clip.width;
        const clipBottom = clip.y + clip.height;
        const halfWidthsByDiameter = new Map();
        const maxSpanCount = discs.reduce((sum, disc)=>sum + disc.height, 0);
        if (this.spans.length < maxSpanCount) this.spans = new Float64Array(maxSpanCount);
        let spanCount = 0;
        for (const disc of discs){
            let halfWidths = halfWidthsByDiameter.get(disc.width);
            if (!halfWidths) {
                halfWidths = $ce287f0b331aeb2c$export$b843be359a1eb867(disc.width);
                halfWidthsByDiameter.set(disc.width, halfWidths);
            }
            const center = disc.x + disc.width / 2;
            const startY = Math.max(clip.y, disc.y);
            const endY = Math.min(clipBottom, disc.y + disc.height);
            for(let y = startY; y < endY; y++){
                const halfWidth = halfWidths[y - disc.y];
                const left = Math.max(clip.x, center - halfWidth) - clip.x;
                const right = Math.min(clipRight, center + halfWidth) - clip.x;
                if (left < right) this.spans[spanCount++] = (y - clip.y) * rowStride + left * stride + right;
            }
        }
        const spans = this.spans.subarray(0, spanCount).sort();
        // Merge overlapping spans within a row. A merged span continues the rect of
        // the row above if that rect has the exact same left and right edge.
        const rects = [];
        let aboveRects = [];
        let rowRects = [];
        let aboveIndex = 0;
        let spanY = -1;
        let spanLeft = 0;
        let spanRight = 0;
        const addSpan = ()=>{
            const x = clip.x + spanLeft;
            const y = clip.y + spanY;
            const width = spanRight - spanLeft;
            while(aboveIndex < aboveRects.length && aboveRects[aboveIndex].x < x)aboveIndex++;
            let rect = aboveRects[aboveIndex];
            if (rect && rect.x === x && rect.width === width && rect.y + rect.height === y) rect.height++;
            else {
                rect = {
                    x: x,
                    y: y,
                    width: width,
                    height: 1
                };
                rects.push(rect);
            }
            rowRects.push(rect);
        };
        for (const span of spans){
            const y = Math.floor(span / rowStride);
            const left = Math.floor((span - y * rowStride) / stride);
            const right = span - y * rowStride - left * stride;
            if (y === spanY && left <= spanRight) {
                spanRight = Math.max(spanRight, right);
                continue;
            }
            if (spanY !== -1) addSpan();
            if (y !== spanY) {
                aboveRects = rowRects;
                rowRects = [];
                aboveIndex = 0;
            }
            spanY = y;
            spanLeft = left;
            spanRight = right;
        }
        if (spanY !== -1) addSpan();
        return rects;
    }
    constructor(){
        // Reused between calls. Each entry is one row span of one dab, packed into a
        // single number, so sorting them groups spans by row, then by left edge.
        this.spans = new Float64Array(0);
    }
}


class $84ca9200b907548e$export$4de5ef8eecde6f12 {
    updateChangedTiles(bounds) {
        // fix bounds
        bounds = {
            type: 'index',
            x1: Math.min(bounds.x1, bounds.x2),
            y1: Math.min(bounds.y1, bounds.y2),
            x2: Math.max(bounds.x1, bounds.x2),
            y2: Math.max(bounds.y1, bounds.y2)
        };
        const boundsWithinSelection = (0, $4c2c6808296c0d73$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return;
        const changedTiles = (0, $a0d4fe9620fd4adc$export$2098fe43203ddd32)(boundsWithinSelection, this.context.canvas.width, this.context.canvas.height);
        this.redrawBounds = (0, $4c2c6808296c0d73$export$f4467a4f41373bc7)(this.redrawBounds, boundsWithinSelection);
        this.strokeBounds = (0, $4c2c6808296c0d73$export$f4467a4f41373bc7)(this.strokeBounds, boundsWithinSelection);
        this.historyTiles = (0, $a0d4fe9620fd4adc$export$1774f90c6da5013c)(this.historyTiles, changedTiles);
    }
    initClone() {
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        this.canvasClone = (0, $be957da3610487e9$export$921068d8846a1559).canvas(width, height);
        this.ctxClone = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.canvasClone);
        this.ctxClone.drawImage(this.context.canvas, 0, 0);
        if (!this.strokeCanvas || this.strokeCanvas.width !== width || this.strokeCanvas.height !== height) {
            this.strokeCanvas && (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.strokeCanvas);
            this.strokeCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(width, height);
            this.strokeCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.strokeCanvas);
        }
    }
    freeClone() {
        (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.canvasClone);
        this.ctxClone = {};
        // cleared right away, so the next stroke can start immediately
        this.strokeCtx.clearRect(0, 0, this.strokeCtx.canvas.width, this.strokeCtx.canvas.height);
    }
    /**
     * Composites stroke onto ctx within rect.
     */ drawStroke(ctx, rect) {
        ctx.save();
        ctx.globalAlpha = this.settingOpacity;
        if (this.settingLockLayerAlpha) ctx.globalCompositeOperation = 'source-atop';
        else if (this.settingIsEraser) ctx.globalCompositeOperation = 'destination-out';
        ctx.drawImage(this.strokeCtx.canvas, rect.x, rect.y, rect.width, rect.height, rect.x, rect.y, rect.width, rect.height);
        ctx.restore();
    }
    redrawToCanvas() {
        if (!this.redrawBounds) return;
        const boundsRect = (0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)(this.redrawBounds);
        this.context.save();
        this.context.clearRect(boundsRect.x, boundsRect.y, boundsRect.width, boundsRect.height);
        this.context.drawImage(this.canvasClone, boundsRect.x, boundsRect.y, boundsRect.width, boundsRect.height, boundsRect.x, boundsRect.y, boundsRect.width, boundsRect.height);
        this.context.restore();
        this.drawStroke(this.context, boundsRect);
        this.redrawBounds = undefined;
    }
    updateFillStyle() {
        const colorStr = this.settingIsEraser ? `rgb(${0, $bc268e0fc7103648$export$e4203cb02d5e5b28},${0, $bc268e0fc7103648$export$e4203cb02d5e5b28},${0, $bc268e0fc7103648$export$e4203cb02d5e5b28})` : this.settingColorStr;
        // Always a pattern, even when solid. Filling with a plain color is slower in Firefox
        // (lower fps at size 1).
        const pattern = this.settingPattern;
        if (this.patternCanvas.width !== pattern.width || this.patternCanvas.height !== pattern.height) {
            this.patternCanvas.width = pattern.width;
            this.patternCanvas.height = pattern.height;
        }
        this.patternCtx.clearRect(0, 0, pattern.width, pattern.height);
        this.patternCtx.fillStyle = colorStr;
        pattern.data.forEach((value, i)=>{
            if (value) this.patternCtx.fillRect(i % pattern.width, Math.floor(i / pattern.width), 1, 1);
        });
        this.fillStyle = (0, $94f0b2b810d4d191$export$b813e062795b89b5)(// InvalidStateError: The object is in an invalid state.
        this.strokeCtx.createPattern(this.patternCanvas, 'repeat'));
    }
    /**
     * Tests p1->p2 or p3->p4 deviate in their direction more than max, compared to p1->p4
     */ cubicCurveOverThreshold(p1, p2, p3, p4, maxAngleRad) {
        const d = (0, $be957da3610487e9$export$921068d8846a1559).Vec2.nor({
            x: p4.x - p1.x,
            y: p4.y - p1.y
        });
        const d2 = (0, $be957da3610487e9$export$921068d8846a1559).Vec2.nor({
            x: p2.x - p1.x,
            y: p2.y - p1.y
        });
        const d3 = (0, $be957da3610487e9$export$921068d8846a1559).Vec2.nor({
            x: p4.x - p3.x,
            y: p4.y - p3.y
        });
        // const a2 = Math.abs(BB.Vec2.angle(d, d2) % Math.PI) / Math.PI * 180;
        // const a3 = Math.abs(BB.Vec2.angle(d, d3) % Math.PI) / Math.PI * 180;
        return Math.max((0, $be957da3610487e9$export$921068d8846a1559).Vec2.dist(d, d2), (0, $be957da3610487e9$export$921068d8846a1559).Vec2.dist(d, d3)) > maxAngleRad;
    }
    plotCubicBezierLine(p1, p2, p3, p4) {
        const isOverThreshold = this.cubicCurveOverThreshold(p1, p2, p3, p4, 0.1);
        p1.x = Math.floor(p1.x);
        p1.y = Math.floor(p1.y);
        p4.x = Math.floor(p4.x);
        p4.y = Math.floor(p4.y);
        const dist = (0, $be957da3610487e9$export$921068d8846a1559).dist(p1.x, p1.y, p4.x, p4.y);
        if (!isOverThreshold || dist < 7) {
            this.plotLine(p1.x, p1.y, p4.x, p4.y, true);
            return;
        }
        const n = Math.max(2, Math.round(dist / 4));
        const pointArr = [];
        for(let i = 0; i <= n; i++){
            const t = i / n;
            const a = (1 - t) ** 3;
            const b = 3 * t * (1 - t) ** 2;
            const c = 3 * t ** 2 * (1 - t);
            const d = t ** 3;
            pointArr.push({
                x: a * p1.x + b * p2.x + c * p3.x + d * p4.x,
                y: a * p1.y + b * p2.y + c * p3.y + d * p4.y
            });
        }
        for(let i = 0; i < n; i++)this.plotLine(Math.round(pointArr[i].x), Math.round(pointArr[i].y), Math.round(pointArr[i + 1].x), Math.round(pointArr[i + 1].y), true);
    }
    drawDot(x, y, size) {
        const rect = {
            x: Math.round(x + -size),
            y: Math.round(y + -size),
            width: Math.round(size * 2),
            height: Math.round(size * 2)
        };
        this.updateChangedTiles((0, $4c2c6808296c0d73$export$d89ccdf57354a99c)(rect, 'index'));
        if (this.settingTip === 'round') this.discs.push(rect);
        else {
            this.strokeCtx.save();
            this.strokeCtx.fillStyle = this.fillStyle;
            this.strokeCtx.fillRect(rect.x, rect.y, rect.width, rect.height);
            this.strokeCtx.restore();
        }
    }
    /**
     * Round dots are dense and overlap heavily. Filling their union as one path is
     * much cheaper than filling each dot.
     */ fillDiscs() {
        const rects = this.discUnion.getRects(this.discs, {
            x: 0,
            y: 0,
            width: this.strokeCtx.canvas.width,
            height: this.strokeCtx.canvas.height
        });
        this.discs = [];
        if (rects.length === 0) return;
        this.strokeCtx.beginPath();
        rects.forEach((rect)=>this.strokeCtx.rect(rect.x, rect.y, rect.width, rect.height));
        this.strokeCtx.fillStyle = this.fillStyle;
        this.strokeCtx.fill();
    }
    continueLine(x, y, size, pressure) {
        if (this.bezierLine === null) {
            this.bezierLine = new (0, $be957da3610487e9$export$921068d8846a1559).BezierLine();
            this.bezierLine.add(this.lastInput.x, this.lastInput.y, 0, ()=>{});
        }
        this.strokeCtx.save();
        this.selectionPath && this.strokeCtx.clip(this.selectionPath);
        const dotCallback = (val)=>{
            const localPressure = (0, $be957da3610487e9$export$921068d8846a1559).mix(this.lastInput2.pressure, pressure, val.t);
            const localSize = Math.max(0.5, this.settingSize * (this.settingHasSizePressure ? localPressure : 1));
            this.drawDot(val.x, val.y, localSize);
        };
        const controlCallback = (controlObj)=>{
            this.plotCubicBezierLine(controlObj.p1, controlObj.p2, controlObj.p3, controlObj.p4);
        };
        if (Math.round(this.settingSize * 2) === 1) {
            this.bresenheimPath = new Path2D();
            if (x === null || y === null) this.bezierLine.addFinal(4, undefined, controlCallback);
            else this.bezierLine.add(x, y, 4, undefined, controlCallback);
            this.strokeCtx.fillStyle = this.fillStyle;
            this.strokeCtx.fill(this.bresenheimPath);
            this.bresenheimPath = undefined;
        } else {
            // round tip needs dense spacing, otherwise the stroke edges become scalloped
            const localSpacing = this.settingTip === 'round' ? Math.min(1, size * this.settingSpacing) : size * this.settingSpacing;
            if (x === null || y === null) this.bezierLine.addFinal(localSpacing, dotCallback);
            else this.bezierLine.add(x, y, localSpacing, dotCallback);
            this.fillDiscs();
        }
        this.strokeCtx.restore();
    }
    /**
     * bresenheim line drawing
     */ plotLine(x0, y0, x1, y1, skipFirst) {
        this.updateChangedTiles((0, $4c2c6808296c0d73$export$5aa63862e8b9c037)({
            type: 'index',
            x1: x0,
            y1: y0,
            x2: x1,
            y2: y1
        }));
        x0 = Math.floor(x0);
        y0 = Math.floor(y0);
        x1 = Math.floor(x1);
        y1 = Math.floor(y1);
        const dX = Math.abs(x1 - x0);
        const sX = x0 < x1 ? 1 : -1;
        const dY = -Math.abs(y1 - y0);
        const sY = y0 < y1 ? 1 : -1;
        let err = dX + dY;
        while(true){
            if (skipFirst) skipFirst = false;
            else this.bresenheimPath?.rect(x0, y0, 1, 1);
            if (x0 === x1 && y0 === y1) break;
            const e2 = 2 * err;
            if (e2 >= dY) {
                err += dY;
                x0 += sX;
            }
            if (e2 <= dX) {
                err += dX;
                y0 += sY;
            }
        }
    }
    // ---- interface ----
    startLine(x, y, p) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.historyTiles = [];
        this.redrawBounds = undefined;
        this.strokeBounds = undefined;
        this.initClone();
        this.updateFillStyle();
        p = Math.max(0, Math.min(1, p));
        const localSize = this.settingHasSizePressure ? Math.max(0.5, p * this.settingSize) : Math.max(0.5, this.settingSize);
        this.inputIsDrawing = true;
        this.strokeCtx.save();
        this.selectionPath && this.strokeCtx.clip(this.selectionPath);
        this.drawDot(x, y, localSize);
        this.fillDiscs();
        this.strokeCtx.restore();
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        this.lastInput2 = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.lastInput);
    }
    goLine(x, y, p) {
        if (!this.inputIsDrawing) return;
        //debug
        //drawDot(x, y, 1, 0.5);
        const pressure = (0, $be957da3610487e9$export$921068d8846a1559).clamp(p, 0, 1);
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.continueLine(x, y, localSize, this.lastInput.pressure);
        this.lastInput2 = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.lastInput);
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = pressure;
    }
    endLine() {
        if (!this.inputIsDrawing) return;
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.continueLine(null, null, localSize, this.lastInput.pressure);
        //debug
        //drawDot(lastInput.x, lastInput.y, 3, 1);
        //drawDot(x, y, 10, 0.1);
        this.inputIsDrawing = false;
        this.bezierLine = null;
        this.transferToCanvas();
        if (this.strokeBounds) this.drawStroke(this.ctxClone, (0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)(this.strokeBounds));
        if (this.historyTiles.some((item)=>item)) this.klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $3aa9c52208735678$export$6706c882ea9c3dbd)(this.canvasClone, this.historyTiles)));
        this.freeClone();
    }
    transferToCanvas() {
        this.redrawToCanvas();
    }
    drawLineSegment(x1, y1, x2, y2) {
        this.startLine(x1, y1, 1);
        this.goLine(x2, y2, 1);
        this.endLine();
    }
    /**
     * Frees resources that are kept between strokes. E.g. when switching to another tool.
     */ freeResources() {
        if (!this.strokeCanvas || this.inputIsDrawing) return;
        (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.strokeCanvas);
        this.strokeCanvas = undefined;
        this.strokeCtx = {};
    }
    //IS
    isDrawing() {
        return this.inputIsDrawing;
    }
    //SET
    setColor(c) {
        if (this.settingColor === c) return;
        this.settingColor = c;
        this.settingColorStr = 'rgb(' + this.settingColor.r + ',' + this.settingColor.g + ',' + this.settingColor.b + ')';
    }
    setContext(c) {
        this.context = c;
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    setSize(s) {
        this.settingSize = Math.round(s * 2) / 2;
    }
    setOpacity(o) {
        this.settingOpacity = o;
    }
    setSpacing(s) {
        this.settingSpacing = s;
    }
    sizePressure(b) {
        this.settingHasSizePressure = b;
    }
    setLockAlpha(b) {
        this.settingLockLayerAlpha = b;
    }
    setIsEraser(b) {
        this.settingIsEraser = b;
    }
    setPattern(pattern) {
        this.settingPattern = pattern;
    }
    setTip(tip) {
        this.settingTip = tip;
    }
    //GET
    getSpacing() {
        return this.settingSpacing;
    }
    getSize() {
        return this.settingSize;
    }
    getOpacity() {
        return this.settingOpacity;
    }
    getLockAlpha() {
        return this.settingLockLayerAlpha;
    }
    getIsEraser() {
        return this.settingIsEraser;
    }
    getPattern() {
        return this.settingPattern;
    }
    getTip() {
        return this.settingTip;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.klHistory = {};
        this.context = {};
        this.settingHasSizePressure = true;
        this.settingSize = 0.5;
        this.settingSpacing = 0.9;
        this.settingOpacity = 1;
        this.settingColor = {};
        this.settingColorStr = '';
        this.settingLockLayerAlpha = false;
        this.settingIsEraser = false;
        this.settingPattern = (0, $be2bfe057d41ff95$export$ebb66c2ece63841a)[0] // solid
        ;
        this.settingTip = 'round';
        this.inputIsDrawing = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.bezierLine = null;
        this.fillStyle = '';
        /*
        Draw brush into fresh canvas for each line,
        because otherwise chrome slows the main canvas down.
        Multiple reads on a canvas -> canvas moved to CPU. (my guess)
     */ this.canvasClone = {};
        this.ctxClone = {};
        this.strokeCtx = {};
        // changed tiles that will be pushed to history
        this.historyTiles = [];
        // round dots of the current segment. Filled together in fillDiscs.
        this.discs = [];
        this.discUnion = new (0, $ce287f0b331aeb2c$export$e8c09364097cacae)();
        this.patternCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(4, 4);
        this.patternCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.patternCanvas);
    }
}










class $41f901af2c2ec7fa$export$fe52c90afd1cf5ba {
    updateChangedTiles(bounds) {
        const boundsWithinSelection = (0, $4c2c6808296c0d73$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return;
        this.changedTiles = (0, $a0d4fe9620fd4adc$export$1774f90c6da5013c)(this.changedTiles, (0, $a0d4fe9620fd4adc$export$2098fe43203ddd32)(bounds, this.context.canvas.width, this.context.canvas.height));
    }
    drawDot(x, y, size, opacity) {
        this.context.save();
        if (this.isBaseLayer) {
            if (this.isTransparentBG) this.context.globalCompositeOperation = 'destination-out';
            else this.context.globalCompositeOperation = 'source-atop';
        } else this.context.globalCompositeOperation = 'destination-out';
        const radgrad = this.context.createRadialGradient(size, size, 0, size, size, size);
        let sharpness = opacity ** 2;
        sharpness = Math.max(0, Math.min((size - 1) / size, sharpness));
        const oFac = Math.max(0, Math.min(1, opacity));
        const localOpacity = 2 * oFac - oFac * oFac;
        radgrad.addColorStop(sharpness, `rgba(${(0, $bc268e0fc7103648$export$e4203cb02d5e5b28)}, ${(0, $bc268e0fc7103648$export$e4203cb02d5e5b28)}, ${(0, $bc268e0fc7103648$export$e4203cb02d5e5b28)}, ` + localOpacity + ')');
        radgrad.addColorStop(1, `rgba(${(0, $bc268e0fc7103648$export$e4203cb02d5e5b28)}, ${(0, $bc268e0fc7103648$export$e4203cb02d5e5b28)}, ${(0, $bc268e0fc7103648$export$e4203cb02d5e5b28)}, 0)`);
        this.context.fillStyle = radgrad;
        this.context.translate(x - size, y - size);
        this.context.fillRect(0, 0, size * 2, size * 2);
        this.context.restore();
        this.updateChangedTiles({
            type: 'index',
            x1: Math.floor(x - size),
            y1: Math.floor(y - size),
            x2: Math.ceil(x + size - 1),
            y2: Math.ceil(y + size - 1)
        });
    }
    continueLine(x, y, p) {
        p = Math.max(0, Math.min(1, p));
        let localPressure;
        let localOpacity;
        let localSize = this.useSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size);
        const bdist = Math.max(1, Math.max(0.5, 1 - this.opacity) * localSize * this.spacing);
        const bezierCallback = (val)=>{
            const factor = val.t;
            localPressure = this.lastInput2.pressure * (1 - factor) + p * factor;
            localOpacity = this.useOpacityPressure ? this.opacity * localPressure * localPressure : this.opacity;
            localSize = this.useSizePressure ? Math.max(0.1, localPressure * this.size) : Math.max(0.1, this.size);
            this.drawDot(val.x, val.y, localSize, localOpacity);
        };
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        if (x === undefined || y === undefined) this.bezierLine.addFinal(bdist, bezierCallback);
        else this.bezierLine.add(x, y, bdist, bezierCallback);
        this.context.restore();
    }
    // ---- interface ----
    startLine(x, y, p) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.changedTiles = [];
        this.isBaseLayer = 0 === this.layer.index;
        p = Math.max(0, Math.min(1, p));
        const localOpacity = this.useOpacityPressure ? this.opacity * p * p : this.opacity;
        const localSize = this.useSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size);
        this.started = true;
        if (localSize > 1) {
            this.context.save();
            this.selectionPath && this.context.clip(this.selectionPath);
            this.drawDot(x, y, localSize, localOpacity);
            this.context.restore();
        }
        this.lastDot = localSize * this.spacing;
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        this.lastInput2 = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.lastInput);
        this.bezierLine = new (0, $be957da3610487e9$export$921068d8846a1559).BezierLine();
        this.bezierLine.add(x, y, 0, ()=>undefined);
    }
    goLine(x, y, p) {
        if (!this.started) return;
        this.continueLine(x, y, this.lastInput.pressure);
        this.lastInput2 = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.lastInput);
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
    }
    endLine() {
        if (this.bezierLine) this.continueLine(undefined, undefined, this.lastInput.pressure);
        this.started = false;
        this.bezierLine = undefined;
        if (this.changedTiles.some((item)=>item)) this.klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $3aa9c52208735678$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles)));
    }
    drawLineSegment(x1, y1, x2, y2) {
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.changedTiles = [];
        this.isBaseLayer = 0 === this.layer.index;
        this.lastInput.x = x2;
        this.lastInput.y = y2;
        if (this.started || x1 === undefined) return;
        const mouseDist = Math.sqrt((x2 - x1) ** 2.0 + (y2 - y1) ** 2.0);
        const eX = (x2 - x1) / mouseDist;
        const eY = (y2 - y1) / mouseDist;
        let loopDist;
        const bdist = Math.max(1, Math.max(0.5, 1 - this.opacity) * this.size * this.spacing);
        this.lastDot = 0;
        this.context.save();
        this.selectionPath && this.context.clip(this.selectionPath);
        for(loopDist = this.lastDot; loopDist <= mouseDist; loopDist += bdist)this.drawDot(x1 + eX * loopDist, y1 + eY * loopDist, this.size, this.opacity);
        this.context.restore();
        if (this.changedTiles.some((item)=>item)) this.klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $3aa9c52208735678$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles)));
    }
    //IS
    isDrawing() {
        return this.started;
    }
    //SET
    setLayer(layer) {
        this.layer = layer;
        this.context = layer.context;
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    setSize(s) {
        this.size = s;
    }
    setOpacity(o) {
        this.opacity = o;
    }
    sizePressure(b) {
        this.useSizePressure = b;
    }
    opacityPressure(b) {
        this.useOpacityPressure = b;
    }
    setTransparentBG(b) {
        this.isTransparentBG = b;
    }
    //GET
    getSize() {
        return this.size;
    }
    getOpacity() {
        return this.opacity;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.size = 30;
        this.spacing = 0.4;
        this.opacity = 1;
        this.useSizePressure = true;
        this.useOpacityPressure = false;
        this.isTransparentBG = false;
        this.klHistory = {};
        this.isBaseLayer = false;
        this.layer = {};
        this.context = {};
        this.started = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.changedTiles = [];
    }
}









// let statCount = 1;
// let statAcc = 0;
// stats on win10, chrome, size 100, opacity 80, smudge()
// unoptimized: 1 ms
// minimal: 0.09 ms
// minimal + circle: 0.5ms
// minimal + circle + ix, iy: 0.23ms
// unoptimized + ix, iy: 0.64 ms
// unoptimized + ix, iy + sans rounding: 0.61 ms
// ix, iy + sans rounding + sans random: 0.32ms
// ix, iy + sans rounding + fast random: 0.46 ms
// ix, iy + sans rounding + fast random + offset const: 0.48 ms
const $f45c2afbf22d0f87$var$CELL_SIZE = 256;
/**
 * determine bounds of smudge
 * @param imWidth
 * @param imHeight
 * @param aP
 * @param bP
 * @param size
 */ function $f45c2afbf22d0f87$var$prepSmudge(imWidth, imHeight, aP, bP, size) {
    if (aP.x === bP.x && aP.y === bP.y) return null;
    aP = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(aP);
    bP = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(bP);
    size = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(size);
    // corner behavior
    // cut down rectangles, if a or b go outside
    // i.e. if user drags partially or fully outside the canvas
    {
        let top = 0;
        let right = 0;
        let bottom = 0;
        let left = 0;
        if (aP.x < 0) left = -aP.x;
        if (aP.y < 0) top = -aP.y;
        if (bP.x < 0) left = Math.max(left, -bP.x);
        if (bP.y < 0) top = Math.max(top, -bP.y);
        if (aP.x + size.w > imWidth) right = aP.x + size.w - imWidth;
        if (aP.y + size.h > imHeight) bottom = aP.y + size.h - imHeight;
        if (bP.x + size.w > imWidth) right = Math.max(right, bP.x + size.w - imWidth);
        if (bP.y + size.h > imHeight) bottom = Math.max(bottom, bP.y + size.h - imHeight);
        aP.x += left;
        bP.x += left;
        aP.y += top;
        bP.y += top;
        size.w = size.w - left - right;
        size.h = size.h - top - bottom;
        if (size.w <= 0 || size.h <= 0) return null;
    }
    return {
        aP: {
            x: aP.x,
            y: aP.y
        },
        bP: {
            x: bP.x,
            y: bP.y
        },
        size: {
            w: size.w,
            h: size.h
        }
    };
}
/**
 * Pixel operations that do the smudging via ImageData
 * @param imageData
 * @param p
 */ function $f45c2afbf22d0f87$var$smudge(imageData, mask, p) {
    p = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(p);
    const cSize = p.brush.size;
    const cX = p.brush.center.x;
    const cY = p.brush.center.y;
    /*if (statCount % 1000 === 0) {
        console.log(statAcc / 1000);
        statAcc = 0;
    }
    let start = performance.now();*/ // determine offset
    const aIndex = p.aP.y * imageData.width + p.aP.x;
    const bIndex = p.bP.y * imageData.width + p.bP.x;
    const offset = (bIndex - aIndex) * 4;
    // array with random numbers. faster than Math.random()
    let randI = 0;
    const randLen = cSize > 30 ? 1024 : 512; // lower lengths lead to noticeable patterns
    const randArr = [];
    for(let i = 0; i < randLen; i++)randArr[i] = (Math.random() - 0.5) / 1.001 + 0.5;
    const softnessPx = Math.max(3, Math.min(8, p.brush.size - 8));
    const pixel = (ai, bi, ix, iy)=>{
        const dist = (0, $be957da3610487e9$export$921068d8846a1559).dist(cX, cY, ix, iy);
        const fac = 1 - p.brush.opacity * (1 - (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)((dist - (cSize - softnessPx)) / softnessPx, 0, 1));
        if (fac === 1) return;
        if (mask && (mask[ai / 4] === 0 || mask[bi / 4] === 0)) return;
        if (!imageData.data[ai + 3]) ;
        else if (!imageData.data[bi + 3]) {
            // don't mix if target fully transparent. pixel might have a strange color.
            imageData.data[bi] = imageData.data[ai];
            imageData.data[bi + 1] = imageData.data[ai + 1];
            imageData.data[bi + 2] = imageData.data[ai + 2];
        } else {
            // consider alpha ratio. If a has lower alpha than b, then b should be stronger, and vice versa
            // not totally accurate. TODO same compositing as blend brush
            let fac2;
            if (imageData.data[ai + 3] < imageData.data[bi + 3]) fac2 = 1 - imageData.data[ai + 3] / imageData.data[bi + 3] * (1 - fac);
            else fac2 = imageData.data[bi + 3] / imageData.data[ai + 3] * fac;
            // ImageData's Uint8ClampedArray rounds -> 0.5 becomes 1. But not in Safari, so needs to be done manually
            // Offset mixed color by random number noise (-0.5, 0.5), so it doesn't get stuck while mixing.
            // No +0.5, because it cancels out with rand.
            imageData.data[bi] = Math.floor((0, $be957da3610487e9$export$921068d8846a1559).mix(imageData.data[ai], imageData.data[bi + 0], fac2) + randArr[randI]);
            imageData.data[bi + 1] = Math.floor((0, $be957da3610487e9$export$921068d8846a1559).mix(imageData.data[ai + 1], imageData.data[bi + 1], fac2) + randArr[randI]);
            imageData.data[bi + 2] = Math.floor((0, $be957da3610487e9$export$921068d8846a1559).mix(imageData.data[ai + 2], imageData.data[bi + 2], fac2) + randArr[randI]);
            randI = (randI + 1) % randLen;
        }
        // Always mix alpha. unless alpha lock
        if (!p.brush.alphaLock) imageData.data[bi + 3] = Math.floor((0, $be957da3610487e9$export$921068d8846a1559).mix(imageData.data[ai + 3], imageData.data[bi + 3], fac) + 0.5);
    };
    const bx1 = p.bP.x * 4;
    const bx2 = bx1 + (p.size.w - 1) * 4;
    // transfer of pixels depends on direction of smudging if there is overlap
    if (p.aP.y < p.bP.y) for(let y = p.size.h - 1, iy = p.bP.y + p.size.h - 1; y >= 0; y--, iy--){
        const yStart = (y + p.bP.y) * imageData.width * 4;
        for(let x = bx2 + yStart, x2 = bx2 + yStart - offset, ix = p.bP.x + p.size.w - 1; x >= bx1 + yStart; x -= 4, x2 -= 4, ix--)pixel(x2, x, ix, iy);
    }
    else if (p.aP.y > p.bP.y) for(let y = 0, iy = p.bP.y; y < p.size.h; y++, iy++){
        const yStart = (y + p.bP.y) * imageData.width * 4;
        for(let x = bx2 + yStart, x2 = bx2 + yStart - offset, ix = p.bP.x + p.size.w - 1; x >= bx1 + yStart; x -= 4, x2 -= 4, ix--)pixel(x2, x, ix, iy);
    }
    else {
        if (p.aP.x < p.bP.x) for(let y = p.size.h - 1, iy = p.bP.y + p.size.h - 1; y >= 0; y--, iy--){
            const yStart = (y + p.bP.y) * imageData.width * 4;
            for(let x = bx2 + yStart, x2 = bx2 + yStart - offset, ix = p.bP.x + p.size.w - 1; x >= bx1 + yStart; x -= 4, x2 -= 4, ix--)pixel(x2, x, ix, iy);
        }
        else for(let y = 0, iy = p.bP.y; y < p.size.h; y++, iy++){
            const yStart = (y + p.bP.y) * imageData.width * 4;
            for(let x = bx1 + yStart, x2 = bx1 + yStart - offset, ix = p.bP.x; x < bx2 + yStart; x += 4, x2 += 4, ix++)pixel(x2, x, ix, iy);
        }
    }
//statCount++;
//statAcc += performance.now() - start;
}
class $f45c2afbf22d0f87$export$c9f800961903deab {
    // workaround for https://github.com/microsoft/TypeScript/issues/41654
    resetRedrawBounds() {
        this.redrawBounds = undefined;
    }
    updateRedrawBounds(bounds) {
        const boundsWithinSelection = (0, $4c2c6808296c0d73$export$83720aaadc272d85)(bounds, this.selectionBounds);
        if (!boundsWithinSelection) return;
        this.redrawBounds = (0, $be957da3610487e9$export$921068d8846a1559).updateBounds(this.redrawBounds, boundsWithinSelection);
    }
    updateCompleteRedrawBounds(x1, y1, x2, y2) {
        this.completeRedrawBounds = (0, $be957da3610487e9$export$921068d8846a1559).updateBounds(this.completeRedrawBounds, {
            type: 'index',
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        });
    }
    /**
     * update copyImageData. copy over new regions if needed
     */ copyFromCanvas() {
        const touchedCells = this.copiedCells.map(()=>false);
        const bounds = [];
        const cellsW = Math.ceil(this.copyImageData.width / $f45c2afbf22d0f87$var$CELL_SIZE);
        if (!this.redrawBounds) return;
        bounds.push({
            type: 'index',
            x1: Math.floor(this.redrawBounds.x1 / $f45c2afbf22d0f87$var$CELL_SIZE),
            y1: Math.floor(this.redrawBounds.y1 / $f45c2afbf22d0f87$var$CELL_SIZE),
            x2: Math.floor(this.redrawBounds.x2 / $f45c2afbf22d0f87$var$CELL_SIZE),
            y2: Math.floor(this.redrawBounds.y2 / $f45c2afbf22d0f87$var$CELL_SIZE)
        });
        bounds.forEach((item)=>{
            for(let i = item.x1; i <= item.x2; i++)for(let e = item.y1; e <= item.y2; e++)touchedCells[e * cellsW + i] = true;
        });
        touchedCells.forEach((item, i)=>{
            if (!item || this.copiedCells[i]) // not touched, or already copied
            return;
            this.copiedCells[i] = true;
            const x = i % cellsW;
            const y = Math.floor(i / cellsW);
            const w = (Math.min(x * $f45c2afbf22d0f87$var$CELL_SIZE + $f45c2afbf22d0f87$var$CELL_SIZE, this.copyImageData.width) - 1) % $f45c2afbf22d0f87$var$CELL_SIZE + 1;
            const h = (Math.min(y * $f45c2afbf22d0f87$var$CELL_SIZE + $f45c2afbf22d0f87$var$CELL_SIZE, this.copyImageData.height) - 1) % $f45c2afbf22d0f87$var$CELL_SIZE + 1;
            // temp canvas to prevent main canvas from getting slowed down in chrome
            const tmpCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(w, h);
            const tmpCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(tmpCanvas);
            tmpCtx.drawImage(this.context.canvas, -x * $f45c2afbf22d0f87$var$CELL_SIZE, -y * $f45c2afbf22d0f87$var$CELL_SIZE);
            const data = tmpCtx.getImageData(0, 0, w, h);
            for(let i = 0; i < h; i++)for(let e = 0, e2 = i * w * 4, e3 = ((y * $f45c2afbf22d0f87$var$CELL_SIZE + i) * this.copyImageData.width + x * $f45c2afbf22d0f87$var$CELL_SIZE) * 4; e < w; e++, e2 += 4, e3 += 4){
                this.copyImageData.data[e3] = data.data[e2];
                this.copyImageData.data[e3 + 1] = data.data[e2 + 1];
                this.copyImageData.data[e3 + 2] = data.data[e2 + 2];
                this.copyImageData.data[e3 + 3] = data.data[e2 + 3];
            }
        });
    }
    /**
     * fill drawBuffer with params about to be drawn
     * @param x
     * @param y
     * @param size
     * @param opacity
     */ prepDot(x, y, size, opacity) {
        if (!this.lastDot) {
            this.lastDot = {
                x: x,
                y: y
            };
            return;
        }
        size = Math.round(size);
        const w = Math.round(size * 2);
        const h = Math.round(size * 2);
        const bounds = $f45c2afbf22d0f87$var$prepSmudge(this.copyImageData.width, this.copyImageData.height, {
            x: Math.round(this.lastDot.x - size),
            y: Math.round(this.lastDot.y - size)
        }, {
            x: Math.round(x - size),
            y: Math.round(y - size)
        }, {
            w: w,
            h: h
        });
        if (bounds) {
            const params = {
                aP: bounds.aP,
                bP: bounds.bP,
                size: bounds.size,
                brush: {
                    center: {
                        x: x,
                        y: y
                    },
                    size: size,
                    opacity: opacity,
                    alphaLock: this.settingLockLayerAlpha
                }
            };
            this.updateRedrawBounds({
                type: 'index',
                x1: params.bP.x,
                y1: params.bP.y,
                x2: params.bP.x + params.brush.size * 2 - 1,
                y2: params.bP.y + params.brush.size * 2 - 1
            });
            this.drawBuffer.push(params);
        }
        this.lastDot = {
            x: x,
            y: y
        };
    }
    continueLine(x, y, size, pressure) {
        this.drawBuffer = [];
        if (!this.bezierLine) {
            this.bezierLine = new (0, $be957da3610487e9$export$921068d8846a1559).BezierLine();
            this.bezierLine.add(this.lastInput.x, this.lastInput.y, 0, function() {});
        }
        const drawArr = []; //draw instructions. will be all drawn at once
        const dotCallback = (val)=>{
            const localPressure = (0, $be957da3610487e9$export$921068d8846a1559).mix(this.lastInput2.pressure, pressure, val.t);
            const localOpacity = this.settingOpacity * (this.settingHasOpacityPressure ? localPressure * localPressure : 1);
            const localSize = Math.max(0.1, this.settingSize * (this.settingHasSizePressure ? localPressure : 1));
            drawArr.push([
                val.x,
                val.y,
                localSize,
                localOpacity
            ]); //, val.angle]);
        };
        const localSpacing = size * this.settingSpacing / 3;
        if (x === undefined || y === undefined) this.bezierLine.addFinal(localSpacing, dotCallback);
        else this.bezierLine.add(x, y, localSpacing, dotCallback);
        // execute draw instructions
        for(let i = 0; i < drawArr.length; i++){
            const item = drawArr[i];
            this.prepDot(item[0], item[1], item[2], item[3]);
        }
        this.copyFromCanvas();
        for(let i = 0; i < this.drawBuffer.length; i++)$f45c2afbf22d0f87$var$smudge(this.copyImageData, this.mask, this.drawBuffer[i]);
    }
    startLine(x, y, p) {
        this.resetRedrawBounds();
        const selection = this.klHistory.getComposed().selection.value;
        this.selectionBounds = selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(selection, 'index') : undefined;
        this.mask = selection ? (0, $21750daad446671b$export$820c5732ce56544)(selection, this.context.canvas.width, this.context.canvas.height) : undefined;
        p = (0, $be957da3610487e9$export$921068d8846a1559).clamp(p, 0, 1);
        const localOpacity = this.settingHasOpacityPressure ? this.settingOpacity * p * p : this.settingOpacity;
        const localSize = this.settingHasSizePressure ? Math.max(0.1, p * this.settingSize) : Math.max(0.1, this.settingSize);
        this.lastDot = undefined;
        this.isDrawing = true;
        this.copyImageData = new ImageData(this.context.canvas.width, this.context.canvas.height);
        const totalCells = Math.ceil(this.context.canvas.width / $f45c2afbf22d0f87$var$CELL_SIZE) * Math.ceil(this.context.canvas.height / $f45c2afbf22d0f87$var$CELL_SIZE);
        this.copiedCells = (0, $94f0b2b810d4d191$export$7f1ebd623f131021)(totalCells, false);
        this.prepDot(x, y, localSize, localOpacity);
        this.lineToolLastDot = localSize * this.settingSpacing;
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput.pressure = p;
        this.lastInput2.pressure = p;
        this.completeRedrawBounds = undefined;
    }
    goLine(x, y, p) {
        if (!this.isDrawing) return;
        const pressure = (0, $be957da3610487e9$export$921068d8846a1559).clamp(p, 0, 1);
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.continueLine(x, y, localSize, this.lastInput.pressure);
        if (this.redrawBounds) this.updateCompleteRedrawBounds(this.redrawBounds.x1, this.redrawBounds.y1, this.redrawBounds.x2, this.redrawBounds.y2);
        this.lastInput.x = x;
        this.lastInput.y = y;
        this.lastInput2.pressure = this.lastInput.pressure;
        this.lastInput.pressure = pressure;
    }
    endLine() {
        const localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
        this.context.save();
        this.continueLine(undefined, undefined, localSize, this.lastInput.pressure);
        this.context.restore();
        this.isDrawing = false;
        this.bezierLine = undefined;
        if (this.redrawBounds) this.updateCompleteRedrawBounds(this.redrawBounds.x1, this.redrawBounds.y1, this.redrawBounds.x2, this.redrawBounds.y2);
        this.transferToCanvas();
        if (this.completeRedrawBounds) this.klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $3aa9c52208735678$export$7b1ba44282f9a519)(this.context.canvas, this.completeRedrawBounds)));
        this.copyImageData = {};
    }
    transferToCanvas() {
        const bounds = this.redrawBounds;
        if (!bounds) return;
        this.context.putImageData(this.copyImageData, 0, 0, bounds.x1, bounds.y1, bounds.x2 - bounds.x1 + 1, bounds.y2 - bounds.y1 + 1);
        this.resetRedrawBounds();
    }
    drawImage(im, x, y) {
        if (im instanceof ImageData) this.context.putImageData(im, x, y);
        else {
            this.context.clearRect(x, y, im.width, im.height);
            this.context.drawImage(im, x, y);
        }
    }
    drawLineSegment(x1, y1, x2, y2) {
        return;
    /*
        // todo
        lastInput.x = x2;
        lastInput.y = y2;
        lastInput.pressure = 1;

        if (isDrawing || x1 === undefined) {
            return;
        }

        let angle = BB.pointsToAngleDeg({x:x1, y:y1}, {x:x2, y:y2});
        let mouseDist = Math.sqrt(Math.pow(x2 - x1, 2.0) + Math.pow(y2 - y1, 2.0));
        let eX = (x2 - x1) / mouseDist;
        let eY = (y2 - y1) / mouseDist;
        let loopDist;
        let bdist = settingSize * settingSpacing;
        lineToolLastDot = settingSize * settingSpacing;
        for (loopDist = lineToolLastDot; loopDist <= mouseDist; loopDist += bdist) {
            drawDot(x1 + eX * loopDist, y1 + eY * loopDist, settingSize, settingOpacity);
        }


        let historyEntry = {
            tool: ["brush", "SmudgeBrush"],
            actions: []
        };
        // todo
        history.add(historyEntry);*/ }
    getIsDrawing() {
        return this.isDrawing;
    }
    setColor(c) {
        if (this.settingColor.r === c.r && this.settingColor.g === c.g && this.settingColor.b === c.b) return;
        this.settingColor = {
            r: c.r,
            g: c.g,
            b: c.b
        };
    }
    setContext(c) {
        this.context = c;
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    setSize(s) {
        this.settingSize = s;
    }
    setOpacity(o) {
        this.settingOpacity = o;
    }
    setSpacing(s) {
        this.settingSpacing = s;
    }
    sizePressure(b) {
        this.settingHasSizePressure = b;
    }
    opacityPressure(b) {
        this.settingHasOpacityPressure = b;
    }
    setLockAlpha(b) {
        this.settingLockLayerAlpha = b;
    }
    getSpacing() {
        return this.settingSpacing;
    }
    getSize() {
        return this.settingSize;
    }
    getOpacity() {
        return this.settingOpacity;
    }
    getLockAlpha() {
        return this.settingLockLayerAlpha;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.context = {};
        this.klHistory = {};
        this.settingColor = {
            r: 0,
            g: 0,
            b: 0
        };
        this.settingSize = 35;
        this.settingSpacing = 0.20446882736951905;
        this.settingOpacity = 0.8;
        this.settingHasSizePressure = false;
        this.settingHasOpacityPressure = false;
        this.settingLockLayerAlpha = false;
        this.lineToolLastDot = 0;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.isDrawing = false;
        this.copyImageData = {};
        this.drawBuffer = [];
        this.copiedCells = [];
    }
}









class $f522a503fa7451ee$export$38b08aa4ea8f61c6 {
    updateCompleteRedrawBounds(x, y) {
        let bounds = {
            type: 'index',
            x1: x,
            y1: y,
            x2: x,
            y2: y
        };
        if (this.settingXSymmetry) bounds = (0, $be957da3610487e9$export$921068d8846a1559).updateBounds(bounds, {
            type: 'index',
            x1: -x + this.copyCanvas.width,
            y1: y,
            x2: -x + this.copyCanvas.width,
            y2: y
        });
        if (this.settingYSymmetry) bounds = (0, $be957da3610487e9$export$921068d8846a1559).updateBounds(bounds, {
            type: 'index',
            x1: x,
            y1: -y + this.copyCanvas.height,
            x2: x,
            y2: -y + this.copyCanvas.height
        });
        const buffer = this.settingMode === 'stroke' ? this.settingSize + 1 : 1;
        bounds.x1 = Math.floor(bounds.x1 - buffer);
        bounds.y1 = Math.floor(bounds.y1 - buffer);
        bounds.x2 = Math.ceil(bounds.x2 + buffer);
        bounds.y2 = Math.ceil(bounds.y2 + buffer);
        this.completeRedrawBounds = (0, $be957da3610487e9$export$921068d8846a1559).updateBounds(this.completeRedrawBounds, bounds);
    }
    drawShape() {
        this.context.save();
        this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
        this.context.drawImage(this.copyCanvas, 0, 0);
        this.selectionPath && this.context.clip(this.selectionPath);
        const color = {
            ...this.settingColor
        };
        if (this.settingIsEraser) {
            color.r = (0, $bc268e0fc7103648$export$e4203cb02d5e5b28);
            color.g = (0, $bc268e0fc7103648$export$e4203cb02d5e5b28);
            color.b = (0, $bc268e0fc7103648$export$e4203cb02d5e5b28);
            if (this.settingLockLayerAlpha) this.context.globalCompositeOperation = 'source-atop';
            else this.context.globalCompositeOperation = 'destination-out';
        } else if (this.settingLockLayerAlpha) this.context.globalCompositeOperation = 'source-atop';
        if (this.path.length > 1) {
            // path
            const path = new Path2D();
            this.path.forEach((item, index)=>{
                if (index === 0) path.moveTo(item.x, item.y);
                else path.lineTo(item.x, item.y);
            });
            let style = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr({
                r: color.r,
                g: color.g,
                b: color.b,
                a: this.settingOpacity
            });
            if (this.settingGradient) {
                const startAtTop = this.path[0].x > this.path.at(-1).x;
                const gradient = this.context.createLinearGradient(0, startAtTop ? this.minY : this.maxY, 0, startAtTop ? this.maxY : this.minY);
                gradient.addColorStop(0, (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr({
                    r: color.r,
                    g: color.g,
                    b: color.b,
                    a: this.settingOpacity
                }));
                gradient.addColorStop(1, (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbaStr({
                    r: color.r,
                    g: color.g,
                    b: color.b,
                    a: 0
                }));
                style = gradient;
            }
            // setup params
            if (this.settingMode === 'fill') this.context.fillStyle = style;
            else {
                this.context.lineWidth = this.settingSize * 2;
                this.context.lineJoin = 'bevel';
                this.context.strokeStyle = style;
            }
            // draw
            const draw = ()=>{
                if (this.settingMode === 'fill') this.context.fill(path);
                else this.context.stroke(path);
            };
            draw();
            if (this.settingXSymmetry) {
                this.context.save();
                this.context.translate(this.context.canvas.width / 2, 0);
                this.context.scale(-1, 1);
                this.context.translate(-this.context.canvas.width / 2, 0);
                draw();
                this.context.restore();
            }
            if (this.settingYSymmetry) {
                this.context.save();
                this.context.translate(0, this.context.canvas.height / 2);
                this.context.scale(1, -1);
                this.context.translate(0, -this.context.canvas.height / 2);
                draw();
                this.context.restore();
                if (this.settingXSymmetry) {
                    this.context.save();
                    this.context.translate(this.context.canvas.width / 2, this.context.canvas.height / 2);
                    this.context.scale(-1, -1);
                    this.context.translate(-this.context.canvas.width / 2, -this.context.canvas.height / 2);
                    draw();
                    this.context.restore();
                }
            }
        }
        this.context.restore();
    }
    setHistory(klHistory) {
        this.klHistory = klHistory;
    }
    getSize() {
        return this.settingMode === 'stroke' ? this.settingSize : 0;
    }
    setSize(s) {
        this.settingSize = s;
    }
    getOpacity() {
        return this.settingOpacity;
    }
    setOpacity(o) {
        this.settingOpacity = o;
    }
    setColor(c) {
        this.settingColor = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(c);
    }
    setContext(c) {
        this.context = c;
    }
    setMode(mode) {
        this.settingMode = mode;
    }
    getMode() {
        return this.settingMode;
    }
    setDistort(distort) {
        this.settingDistort = (0, $be957da3610487e9$export$921068d8846a1559).clamp(distort, 0, 1);
    }
    getDistort() {
        return this.settingDistort;
    }
    setXSymmetry(b) {
        this.settingXSymmetry = b;
    }
    getXSymmetry() {
        return this.settingXSymmetry;
    }
    setYSymmetry(b) {
        this.settingYSymmetry = b;
    }
    getYSymmetry() {
        return this.settingYSymmetry;
    }
    setGradient(b) {
        this.settingGradient = b;
    }
    getGradient() {
        return this.settingGradient;
    }
    getLockAlpha() {
        return this.settingLockLayerAlpha;
    }
    setLockAlpha(b) {
        this.settingLockLayerAlpha = b;
    }
    getIsEraser() {
        return this.settingIsEraser;
    }
    setIsEraser(b) {
        this.settingIsEraser = b;
    }
    getIsDrawing() {
        return this.isDrawing;
    }
    startLine(x, y) {
        this.needsRedraw = false;
        this.selection = this.klHistory.getComposed().selection.value;
        this.selectionPath = this.selection ? (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.selection) : undefined;
        this.selectionBounds = this.selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
        this.isDrawing = true;
        this.path = [
            {
                x: x,
                y: y
            }
        ];
        this.minY = y;
        this.maxY = y;
        this.copyCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(this.context.canvas.width, this.context.canvas.height);
        (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.copyCanvas).drawImage(this.context.canvas, 0, 0);
        this.completeRedrawBounds = undefined;
        this.updateCompleteRedrawBounds(x, y);
    }
    goLine(x, y) {
        if (!this.isDrawing) return;
        const pos = {
            x: x,
            y: y
        };
        if (this.settingDistort > 0) {
            pos.x += (Math.random() - 0.5) * this.settingDistort * 80;
            pos.y += (Math.random() - 0.5) * this.settingDistort * 80;
        }
        this.minY = Math.min(this.minY, pos.y);
        this.maxY = Math.max(this.maxY, pos.y);
        this.path.push(pos);
        this.updateCompleteRedrawBounds(x, y);
        this.needsRedraw = true;
    }
    endLine() {
        this.transferToCanvas();
        this.isDrawing = false;
        this.completeRedrawBounds = (0, $be957da3610487e9$export$921068d8846a1559).indexBoundsInArea(this.completeRedrawBounds, this.copyCanvas.width, this.copyCanvas.height);
        if (this.selectionBounds) this.completeRedrawBounds = (0, $4c2c6808296c0d73$export$83720aaadc272d85)(this.completeRedrawBounds, this.selectionBounds);
        if (this.path.length > 1 && this.completeRedrawBounds) {
            const layerData = (0, $3aa9c52208735678$export$7b1ba44282f9a519)(this.context.canvas, this.completeRedrawBounds);
            this.klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(this.klHistory.getComposed(), layerData));
        }
        this.path = [];
        this.copyCanvas = {};
    }
    transferToCanvas() {
        if (!this.needsRedraw) return;
        this.drawShape();
        this.needsRedraw = false;
    }
    drawLineSegment(x1, y1, x2, y2) {
    // might make sense for stroke
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.context = {};
        this.settingColor = {};
        this.settingSize = 0.25 // radius - 0.5 - 99999
        ;
        this.settingOpacity = 1 // 0-1
        ;
        this.settingLockLayerAlpha = false;
        this.settingIsEraser = false;
        this.settingMode = 'fill';
        this.settingDistort = 0 // 0 - 1
        ;
        this.settingXSymmetry = false;
        this.settingYSymmetry = false;
        this.settingGradient = false;
        this.isDrawing = false;
        this.needsRedraw = false;
        this.klHistory = {};
        this.copyCanvas = {};
        this.path = [];
        this.minY = 0;
        this.maxY = 0;
    }
}


const $5f374c2505ee6174$export$32510733a89b2eab = {
    PenBrush: $056317e1fc5cf742$export$6f96c8f9e6ae7341,
    BlendBrush: $615bf759035fcabb$export$9659db8d01dd5313,
    SketchyBrush: $5efdbfb0f3112f07$export$566f9061f0f5ba33,
    PixelBrush: $84ca9200b907548e$export$4de5ef8eecde6f12,
    ChemyBrush: $f522a503fa7451ee$export$38b08aa4ea8f61c6,
    SmudgeBrush: $f45c2afbf22d0f87$export$c9f800961903deab,
    EraserBrush: $41f901af2c2ec7fa$export$fe52c90afd1cf5ba
};





const $13222f1aece36a46$export$f02de051ab70b20e = 20;








const $916f0530599142b6$export$a0d4983f3b0b5c8e = function() {
    const brushInterface = {
        image: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('brush-pen'),
        tooltip: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pen'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $be957da3610487e9$export$921068d8846a1559).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1,
            curve: [
                [
                    0,
                    0.01
                ],
                [
                    0.5,
                    0.3
                ],
                [
                    1,
                    1
                ]
            ]
        }
    };
    const scatterSliderConfig = {
        min: 0,
        max: 100,
        curve: (0, $be957da3610487e9$export$921068d8846a1559).powerSplineInput(0, 100, 0.1, 2.5)
    };
    let alphaNames = [
        (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pen-circle'),
        (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pen-chalk'),
        (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pen-calligraphy'),
        (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pen-square')
    ];
    (0, $fc42a07754814920$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pen');
        alphaNames = [
            (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pen-circle'),
            (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pen-chalk'),
            (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pen-calligraphy'),
            (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pen-square')
        ];
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $5f374c2505ee6174$export$32510733a89b2eab).PenBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        let scatterSlider;
        const alphaOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: [
                0,
                1,
                2,
                3
            ].map((id)=>{
                const alpha = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    className: 'dark-invert',
                    css: {
                        width: 31,
                        height: 31,
                        backgroundSize: 'contain',
                        margin: 2
                    }
                });
                const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(70, 70);
                const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
                if (id === 0 || id === 3) {
                    if (id === 0) {
                        ctx.beginPath();
                        ctx.arc(35, 35, 30, 0, 2 * Math.PI);
                        ctx.closePath();
                        ctx.fill();
                    } else ctx.fillRect(5, 5, 60, 60);
                } else if (id === 1) ctx.drawImage((0, $750f1a22771b5790$export$74a44bbc21d06a28)(60), 5, 5);
                else if (id === 2) ctx.drawImage((0, $750f1a22771b5790$export$eaa218d5d17c8f1c)(60), 5, 5);
                alpha.style.backgroundImage = 'url(' + canvas.toDataURL('image/png') + ')';
                return {
                    id: id,
                    label: alpha,
                    title: alphaNames[id]
                };
            }),
            initId: 0,
            onChange: (id)=>{
                brush.setAlpha(id);
            }
        });
        const lockAlphaToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: brush.getLockAlpha(),
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha'),
            callback: function(b) {
                brush.setLockAlpha(b);
            },
            doHighlight: true,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha-title'),
            css: {
                display: 'inline-block'
            },
            name: 'lock-alpha-toggle'
        });
        const spacingSpline = new (0, $be957da3610487e9$export$921068d8846a1559).SplineInterpolator([
            [
                0,
                15
            ],
            [
                8,
                7
            ],
            [
                14,
                4
            ],
            [
                30,
                3
            ],
            [
                50,
                2.7
            ],
            [
                100,
                2
            ]
        ]);
        function setSize(size) {
            brush.setSize(size);
            brush.setSpacing(Math.max(2, spacingSpline.interpolate(size)) / 15);
        }
        function init() {
            sizeSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 10) return (0, $be957da3610487e9$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brushInterface.opacitySlider.max,
                curve: brushInterface.opacitySlider.curve,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            scatterSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('scatter'),
                width: 225,
                height: 30,
                min: scatterSliderConfig.min,
                max: scatterSliderConfig.max,
                value: scatterSliderConfig.min,
                curve: scatterSliderConfig.curve,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                onChange: (val)=>{
                    brush.setScatter(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 10) return (0, $be957da3610487e9$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            const pressureSizeToggle = (0, $7a8db4f517a189fb$export$9da2e8821e6cbb57)(true, function(b) {
                brush.sizePressure(b);
            });
            const pressureOpacityToggle = (0, $7a8db4f517a189fb$export$9da2e8821e6cbb57)(false, function(b) {
                brush.opacityPressure(b);
            });
            const pressureScatterToggle = (0, $7a8db4f517a189fb$export$9da2e8821e6cbb57)(false, function(b) {
                brush.scatterPressure(b);
            });
            div.append((0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10
                }
            }), (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10
                }
            }), (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    scatterSlider.getElement(),
                    pressureScatterToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }), (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: alphaOptions.getElement(),
                css: {
                    marginTop: 10
                }
            }), (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: lockAlphaToggle.getElement(),
                css: {
                    marginTop: 10
                }
            }));
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();










const $a69ad8af8547ad95$export$156bb4fe8f4bcb4b = function() {
    const brushInterface = {
        image: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('brush-blend'),
        tooltip: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-blend'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $be957da3610487e9$export$921068d8846a1559).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $fc42a07754814920$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $fc42a07754814920$export$ce37e184d908d785)('brush-blend');
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $5f374c2505ee6174$export$32510733a89b2eab).BlendBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        function setSize(size) {
            brush.setSize(size);
        }
        function init() {
            sizeSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: 58,
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                }
            });
            opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                curve: brushInterface.opacitySlider.curve,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            const blendingSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-blending'),
                width: 225,
                height: 30,
                min: 0,
                max: 1,
                value: brush.getBlending(),
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: function(val) {
                    brush.setBlending(val);
                }
            });
            blendingSlider.getElement().style.marginTop = '10px';
            const pressureSizeToggle = (0, $7a8db4f517a189fb$export$9da2e8821e6cbb57)(true, function(b) {
                brush.setSizePressure(b);
            });
            const pressureOpacityToggle = (0, $7a8db4f517a189fb$export$9da2e8821e6cbb57)(false, function(b) {
                brush.setOpacityPressure(b);
            });
            const lockAlphaToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
                init: brush.getLockAlpha(),
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha'),
                callback: function(b) {
                    brush.setLockAlpha(b);
                },
                doHighlight: true,
                title: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha-title'),
                css: {
                    marginTop: 10,
                    display: 'inline-block'
                },
                name: 'lock-alpha'
            });
            div.append((0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10
                }
            }), (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }), blendingSlider.getElement(), lockAlphaToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context, layer.id);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p, isCoalesced) {
            brush.goLine(x, y, p, false); // looks weird with isCoalesced
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.getIsDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();





var $7693aba942933f74$exports = {};
$7693aba942933f74$exports = $parcel$resolve("dc3Cy");





const $58bc5d14d6b5fb8b$export$ffae56164d1bde68 = function() {
    const brushInterface = {
        image: (0, $9e4d66c06c67fa7f$export$a1d71d17ef0b64b3)((0, (/*@__PURE__*/$parcel$interopDefault($7693aba942933f74$exports)))),
        tooltip: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-sketchy'),
        sizeSlider: {
            min: 0.5,
            max: 10
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        },
        Ui: {}
    };
    (0, $fc42a07754814920$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $fc42a07754814920$export$ce37e184d908d785)('brush-sketchy');
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $5f374c2505ee6174$export$32510733a89b2eab).SketchyBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        function setSize(size) {
            brush.setSize(size);
        }
        function init() {
            sizeSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-size'),
                width: 250,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize() * 2,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: function(val) {
                    brush.setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 10) return (0, $be957da3610487e9$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
                width: 250,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            const blendSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-blending'),
                width: 250,
                height: 30,
                min: 0,
                max: 1,
                value: brush.getBlending(),
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: function(val) {
                    brush.setBlending(val);
                }
            });
            const scaleSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-sketchy-scale'),
                width: 250,
                height: 30,
                min: 1,
                max: 20,
                value: brush.getScale(),
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                onChange: function(val) {
                    brush.setScale(val);
                }
            });
            opacitySlider.getElement().style.marginTop = '10px';
            blendSlider.getElement().style.marginTop = '10px';
            scaleSlider.getElement().style.marginTop = '10px';
            div.append(sizeSlider.getElement(), opacitySlider.getElement(), blendSlider.getElement(), scaleSlider.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, pressure) {
            brush.startLine(x, y, pressure);
        };
        this.goLine = function(x, y, pressure) {
            brush.goLine(x, y, pressure, undefined);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getSeed = function() {
            return parseInt('' + brush.getSeed());
        };
        this.setSeed = function(s) {
            brush.setSeed(parseInt('' + s));
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();
















var $79I2S = parcelRequire("79I2S");






class $634c85655c4c1f52$export$6c14c4cb1f26a0eb {
    stop() {
        if (this.animationFrameHandle === undefined) return;
        cancelAnimationFrame(this.animationFrameHandle);
        this.animationFrameHandle = undefined;
    }
    dampen(timeFactor) {
        const vecLen = (0, $be957da3610487e9$export$921068d8846a1559).Vec2.len(this.momentum);
        if (vecLen < 0.3) {
            this.momentum.x = 0;
            this.momentum.y = 0;
            this.stop();
        } else if (vecLen < 5) {
            this.momentum.x *= 0.85 ** timeFactor;
            this.momentum.y *= 0.85 ** timeFactor;
        } else {
            this.momentum.x *= 0.95 ** timeFactor;
            this.momentum.y *= 0.95 ** timeFactor;
        }
    }
    // only call through requestAnimationFrame when animationFrameHandle undefined
    physicsLoop() {
        this.animationFrameHandle = requestAnimationFrame(()=>this.physicsLoop());
        const nowMs = performance.now();
        const deltaMs = nowMs - this.lastTimestamp;
        const timeFactor = deltaMs / this.defaultDeltaMs;
        this.lastTimestamp = nowMs;
        if (this.momentum.x === 0 && this.momentum.y === 0 || this.isDragging) {
            if (this.isDragging) this.dampen(timeFactor);
            else this.stop();
            return;
        }
        const transform = this.getTransform();
        if (this.lastTransform && (this.lastTransform.x !== transform.x || this.lastTransform.y !== transform.y)) {
            this.momentum.x = 0;
            this.momentum.y = 0;
            this.lastTransform = undefined;
            this.stop();
            return;
        }
        transform.x += this.momentum.x;
        transform.y += this.momentum.y;
        this.lastTransform = transform;
        this.dampen(timeFactor);
        this.setTransform(transform);
    }
    dragStart() {
        if (!this.isEnabled) return;
        this.isDragging = true;
        this.momentum.x = 0;
        this.momentum.y = 0;
        this.stop();
    }
    dragMove(dX, dY) {
        if (!this.isEnabled) return;
        this.momentum = {
            x: (0, $be957da3610487e9$export$921068d8846a1559).mix(this.momentum.x, dX, 0.6),
            y: (0, $be957da3610487e9$export$921068d8846a1559).mix(this.momentum.y, dY, 0.6)
        };
        this.lastDragTimestamp = Date.now();
    }
    dragEnd() {
        if (!this.isEnabled) return;
        if (Date.now() - this.lastDragTimestamp > 80) {
            this.momentum.x = 0;
            this.momentum.y = 0;
        } else {
            this.lastTimestamp = performance.now();
            this.animationFrameHandle = requestAnimationFrame(()=>this.physicsLoop());
        }
        this.lastTransform = undefined;
        this.lastDragTimestamp = 0;
        this.isDragging = false;
    }
    // true while a fling is still moving
    getIsActive() {
        return this.animationFrameHandle !== undefined;
    }
    setIsEnabled(b) {
        this.isEnabled = b;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.defaultDeltaMs = 1000 / 60 // time factor is 1 for 60fps, 2 for 120fps
        ;
        this.momentum = {
            x: 0,
            y: 0
        };
        this.isDragging = false;
        this.lastDragTimestamp = 0;
        this.lastTimestamp = 0;
        this.isEnabled = false;
        this.getTransform = p.getTransform;
        this.setTransform = p.setTransform;
    }
}



var $1f28a73d47f157c4$export$76174c80c75f9baa;
var $1f28a73d47f157c4$export$e8e78c978b129247;
var $1f28a73d47f157c4$export$6b2a7d5132615086;
var $1f28a73d47f157c4$export$d7b7311ec04a3e8f;
$1f28a73d47f157c4$export$76174c80c75f9baa = `OxeErW_addButton`;
$1f28a73d47f157c4$export$e8e78c978b129247 = `OxeErW_root`;
$1f28a73d47f157c4$export$6b2a7d5132615086 = `OxeErW_track`;
$1f28a73d47f157c4$export$d7b7311ec04a3e8f = `OxeErW_viewport`;


const $03c03c0e4ec3629c$var$FADE_WIDTH = 28; // same as in the CSS
const $03c03c0e4ec3629c$var$DRAG_THRESHOLD_PX = 6;
const $03c03c0e4ec3629c$var$REVEAL_SPRING_STIFFNESS = 0.00035; // critically damped spring, per ms²
const $03c03c0e4ec3629c$var$previewUrlCache = new Map();
function $03c03c0e4ec3629c$var$createPatternPreview(pattern) {
    // displayed at 2x, so it's easier to see
    const key = `${pattern.width}x${pattern.height}:${pattern.data.join('')}`;
    let url = $03c03c0e4ec3629c$var$previewUrlCache.get(key);
    if (!url) {
        const canvas = (0, $79I2S.createCanvas)(pattern.width * 2, pattern.height * 2);
        const canvasCtx = (0, $2f436639594531f3$export$39f92e86d1722f3a)(canvas);
        pattern.data.forEach((value, i)=>{
            if (value) canvasCtx.fillRect(i % pattern.width * 2, Math.floor(i / pattern.width) * 2, 2, 2);
        });
        url = canvas.toDataURL('image/png');
        (0, $2f436639594531f3$export$2384aff49c9b73c2)(canvas);
        $03c03c0e4ec3629c$var$previewUrlCache.set(key, url);
    }
    return (0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
        className: 'dark-invert',
        css: {
            // padding matches tip preview. option size stays the same (35)
            width: 27,
            height: 27,
            margin: 4,
            backgroundImage: `url(${url})`,
            backgroundSize: `${pattern.width * 2}px ${pattern.height * 2}px`,
            imageRendering: 'pixelated'
        }
    });
}
class $03c03c0e4ec3629c$export$d5c33c8a29c1dcdc {
    getIsVisible() {
        return this.viewportEl.clientWidth > 0;
    }
    measure() {
        // While hidden there's nothing to measure. Keep the old values, so the scroll position
        // is still there when it's shown again.
        if (!this.getIsVisible()) return;
        this.maxScrollX = Math.max(0, this.trackEl.scrollWidth - this.viewportEl.clientWidth);
    }
    // isInstant -> fades switch without transition
    setScrollX(x, isInstant = false) {
        this.scrollX = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(x, 0, this.maxScrollX);
        this.trackEl.style.transform = `translateX(${-this.scrollX}px)`;
        this.updateFades(isInstant);
    }
    updateFades(isInstant = false) {
        if (!this.getIsVisible()) return;
        if (isInstant) this.viewportEl.style.transition = 'none';
        // Use where it's heading. Otherwise the fade only starts fading out once the slow tail
        // of the animation reaches the end.
        const heading = this.revealTarget ?? this.scrollX;
        this.viewportEl.style.setProperty('--kl-fade-left', heading > 2 ? '1' : '0');
        this.viewportEl.style.setProperty('--kl-fade-right', heading < this.maxScrollX - 2 ? '1' : '0');
        if (isInstant) {
            // apply the values before the transition is back
            this.viewportEl.offsetWidth;
            this.viewportEl.style.transition = '';
        }
    }
    // jump there right away, no animation
    scrollToInstant(x) {
        this.stopReveal();
        this.setScrollX(x, true);
    }
    stopReveal() {
        if (this.revealAnimationFrame !== undefined) {
            cancelAnimationFrame(this.revealAnimationFrame);
            this.revealAnimationFrame = undefined;
        }
        this.revealTarget = undefined;
        this.revealVelocity = 0;
    }
    revealLoop() {
        this.revealAnimationFrame = requestAnimationFrame(()=>this.revealLoop());
        const nowMs = performance.now();
        let remainingMs = Math.min(32, nowMs - this.revealLastMs);
        this.revealLastMs = nowMs;
        const target = this.revealTarget;
        const k = $03c03c0e4ec3629c$var$REVEAL_SPRING_STIFFNESS;
        let x = this.scrollX;
        // small fixed sub steps keep the spring stable
        while(remainingMs > 0){
            const dt = Math.min(4, remainingMs);
            remainingMs -= dt;
            this.revealVelocity += (-k * (x - target) - 2 * Math.sqrt(k) * this.revealVelocity) * dt;
            x += this.revealVelocity * dt;
        }
        if (Math.abs(x - target) < 0.3 && Math.abs(this.revealVelocity) < 0.02) {
            this.stopReveal();
            this.setScrollX(target);
            return;
        }
        this.setScrollX(x);
    }
    scrollToAnimated(x) {
        const target = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(x, 0, this.maxScrollX);
        if (target === this.scrollX) {
            this.stopReveal();
            return;
        }
        this.revealTarget = target;
        if (this.revealAnimationFrame === undefined) {
            this.revealLastMs = performance.now();
            this.revealAnimationFrame = requestAnimationFrame(()=>this.revealLoop());
        }
        this.updateFades();
    }
    // keep selected pattern in view, clear of the fades
    revealSelected(isAnimated) {
        if (!this.getIsVisible()) return; // happens when it's shown again
        this.measure();
        const scrollTo = (x)=>isAnimated ? this.scrollToAnimated(x) : this.scrollToInstant(x);
        const index = this.selectedIndex;
        if (index === this.patterns.length - 1) {
            scrollTo(this.maxScrollX);
            return;
        }
        const button = this.trackEl.querySelectorAll('button')[index];
        if (!button) return;
        const left = button.offsetLeft;
        const right = left + button.offsetWidth;
        const current = this.revealTarget ?? this.scrollX;
        const width = this.viewportEl.clientWidth;
        if (left < current + $03c03c0e4ec3629c$var$FADE_WIDTH) scrollTo(left - $03c03c0e4ec3629c$var$FADE_WIDTH);
        else if (right > current + width - $03c03c0e4ec3629c$var$FADE_WIDTH) scrollTo(right - width + $03c03c0e4ec3629c$var$FADE_WIDTH);
    }
    onPointer(e) {
        if (e.type === 'pointerdown') {
            if (e.button !== 'left') return;
            this.isPointerDown = true;
            this.isDragging = false;
            this.stopReveal();
            this.measure();
            // a tap that stops a moving row doesn't pick anything
            this.didCatchFling = this.inertiaScrolling.getIsActive();
            this.inertiaScrolling.dragStart();
        }
        if (e.type === 'pointermove' && e.button === 'left' && this.isPointerDown) {
            if (!this.isDragging) {
                if (Math.abs(e.pageX - (e.downPageX ?? e.pageX)) < $03c03c0e4ec3629c$var$DRAG_THRESHOLD_PX) return;
                this.isDragging = true;
            }
            this.setScrollX(this.scrollX - e.dX);
            this.inertiaScrolling.dragMove(e.dX, 0);
        }
        if (e.type === 'pointerup' && this.isPointerDown) {
            this.isPointerDown = false;
            this.inertiaScrolling.dragEnd();
            if (this.isDragging || this.didCatchFling) {
                this.doSuppressClick = true;
                setTimeout(()=>this.doSuppressClick = false);
            }
            this.isDragging = false;
        }
    }
    // replaces all patterns, e.g. after adding or editing one
    setPatterns(patterns, selectedIndex) {
        const didSelectionChange = selectedIndex !== this.selectedIndex;
        this.patterns = patterns;
        this.selectedIndex = selectedIndex;
        this.options?.destroy();
        this.options = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: patterns.map((pattern, index)=>({
                    id: index,
                    label: $03c03c0e4ec3629c$var$createPatternPreview(pattern)
                })),
            initId: selectedIndex,
            onChange: (index)=>{
                this.selectedIndex = index;
                this.revealSelected(true);
                this.onSelect(index);
            },
            onClickSelected: (index)=>this.onClickSelected(index),
            ariaLabel: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pixel-dither')
        });
        this.trackEl.append(this.options.getElement());
        this.measure();
        this.scrollToInstant(this.scrollX);
        if (didSelectionChange) // e.g. after creating a pattern. jump, no animation
        this.revealSelected(false);
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.stopReveal();
        this.options?.destroy();
        this.pointerListener.destroy();
        this.resizeObserver?.disconnect();
        this.viewportEl.removeEventListener('click', this.onClickCapture, true);
        this.viewportEl.removeEventListener('wheel', this.onNativeWheel);
        this.viewportEl.removeEventListener('scroll', this.onNativeScroll);
        this.rootEl.remove();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.patterns = [];
        this.scrollX = 0;
        this.maxScrollX = 0;
        this.isPointerDown = false;
        this.isDragging = false;
        this.didCatchFling = false;
        this.doSuppressClick = false;
        this.revealVelocity = 0 // px per ms
        ;
        this.revealLastMs = 0;
        // hidden, e.g. while another brush is selected
        this.isHidden = true;
        this.onClickCapture = (e)=>{
            if (this.doSuppressClick) {
                e.stopPropagation();
                e.preventDefault();
            }
        };
        // trackpads: sideways swipe scrolls. (vertical is handled by the pointer listener)
        this.onNativeWheel = (e)=>{
            if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
            e.preventDefault();
            this.stopReveal();
            this.measure();
            this.setScrollX(this.scrollX + e.deltaX);
        };
        // hidden overflow can still be scrolled by the browser, e.g. when focusing a button
        this.onNativeScroll = ()=>{
            this.viewportEl.scrollLeft = 0;
        };
        this.onSelect = p.onSelect;
        this.onClickSelected = p.onClickSelected;
        this.selectedIndex = p.selectedIndex;
        this.trackEl = (0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
            className: $1f28a73d47f157c4$export$6b2a7d5132615086
        });
        this.viewportEl = (0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
            className: $1f28a73d47f157c4$export$d7b7311ec04a3e8f,
            content: [
                this.trackEl
            ]
        });
        this.viewportEl.addEventListener('click', this.onClickCapture, true);
        this.viewportEl.addEventListener('wheel', this.onNativeWheel, {
            passive: false
        });
        this.viewportEl.addEventListener('scroll', this.onNativeScroll);
        this.addButton = (0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
            tagName: 'button',
            className: [
                'kl-button',
                $1f28a73d47f157c4$export$76174c80c75f9baa
            ],
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pixel-pattern-add'),
            content: [
                (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('add-layer', {
                    width: 20,
                    height: 20
                })
            ],
            onClick: ()=>p.onAdd()
        });
        this.addButton.type = 'button';
        this.addButton.tabIndex = -1;
        this.rootEl = (0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
            className: $1f28a73d47f157c4$export$e8e78c978b129247,
            content: [
                this.viewportEl,
                this.addButton
            ]
        });
        p.css && (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, p.css);
        this.inertiaScrolling = new (0, $634c85655c4c1f52$export$6c14c4cb1f26a0eb)({
            getTransform: ()=>({
                    scale: 1,
                    angleDeg: 0,
                    x: -this.scrollX,
                    y: 0,
                    isMirrored: false
                }),
            // clamping at the ends makes the inertia stop (it notices the transform changed)
            setTransform: (transform)=>this.setScrollX(-transform.x)
        });
        this.inertiaScrolling.setIsEnabled(true);
        this.pointerListener = new (0, $3a4865bce5f52590$export$9371bd96776f4e82)({
            target: this.viewportEl,
            onPointer: (e)=>this.onPointer(e),
            onWheel: (e)=>{
                e.event?.preventDefault();
                // down -> right, up -> left
                const newIndex = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(this.selectedIndex + e.deltaY, 0, this.patterns.length - 1);
                if (newIndex !== this.selectedIndex) this.options?.setValue(newIndex);
            }
        });
        if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(()=>{
                if (!this.getIsVisible()) {
                    this.isHidden = true;
                    return;
                }
                this.measure();
                if (this.isHidden) {
                    // shown again (e.g. switched back to this brush): no fade transition,
                    // selected pattern in view right away
                    this.isHidden = false;
                    this.scrollToInstant(this.scrollX);
                    this.revealSelected(false);
                } else this.setScrollX(this.scrollX);
            });
            this.resizeObserver.observe(this.viewportEl);
        }
        this.setPatterns(p.patterns, p.selectedIndex);
    }
}





var $79I2S = parcelRequire("79I2S");







const $a49f0c171741af96$var$GRID_SIZE = 281; // css px. 4 * 69 or 8 * 34 cells, plus 1px lines
const $a49f0c171741af96$var$GRID_LINE_COLOR = '#bbb';
// tiled preview, in pattern pixels. displayed at 200%
const $a49f0c171741af96$var$PREVIEW_WIDTH = 150;
const $a49f0c171741af96$var$PREVIEW_HEIGHT = 28;
function $a49f0c171741af96$export$35cb60a4a13d25a5(p) {
    let draft = (0, $be2bfe057d41ff95$export$4b6ac55e3817f8f8)(p.pattern);
    const dpr = window.devicePixelRatio || 1;
    const gridCanvas = (0, $79I2S.createCanvas)(Math.round($a49f0c171741af96$var$GRID_SIZE * dpr), Math.round($a49f0c171741af96$var$GRID_SIZE * dpr));
    const gridCtx = (0, $2f436639594531f3$export$39f92e86d1722f3a)(gridCanvas);
    gridCanvas.className = 'dark-invert';
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(gridCanvas, {
        display: 'block',
        width: $a49f0c171741af96$var$GRID_SIZE,
        height: $a49f0c171741af96$var$GRID_SIZE,
        margin: '0 auto',
        touchAction: 'none'
    });
    const previewCanvas = (0, $79I2S.createCanvas)($a49f0c171741af96$var$PREVIEW_WIDTH, $a49f0c171741af96$var$PREVIEW_HEIGHT);
    const previewCtx = (0, $2f436639594531f3$export$39f92e86d1722f3a)(previewCanvas);
    previewCanvas.className = 'dark-invert';
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(previewCanvas, {
        display: 'block',
        width: '100%',
        aspectRatio: `${$a49f0c171741af96$var$PREVIEW_WIDTH} / ${$a49f0c171741af96$var$PREVIEW_HEIGHT}`,
        marginTop: 12,
        imageRendering: 'pixelated',
        boxShadow: `0 0 0 1px ${$a49f0c171741af96$var$GRID_LINE_COLOR}`
    });
    function draw() {
        const size = draft.width;
        const cellSize = ($a49f0c171741af96$var$GRID_SIZE - (size + 1)) / size;
        gridCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
        gridCtx.fillStyle = $a49f0c171741af96$var$GRID_LINE_COLOR;
        gridCtx.fillRect(0, 0, $a49f0c171741af96$var$GRID_SIZE, $a49f0c171741af96$var$GRID_SIZE);
        draft.data.forEach((value, i)=>{
            gridCtx.fillStyle = value ? '#000' : '#fff';
            gridCtx.fillRect(1 + i % size * (cellSize + 1), 1 + Math.floor(i / size) * (cellSize + 1), cellSize, cellSize);
        });
        // drawn directly. A new background image per change would flicker while it loads.
        previewCtx.fillStyle = '#fff';
        previewCtx.fillRect(0, 0, $a49f0c171741af96$var$PREVIEW_WIDTH, $a49f0c171741af96$var$PREVIEW_HEIGHT);
        previewCtx.fillStyle = '#000';
        for(let y = 0; y < $a49f0c171741af96$var$PREVIEW_HEIGHT; y++){
            for(let x = 0; x < $a49f0c171741af96$var$PREVIEW_WIDTH; x++)if (draft.data[y % draft.height * draft.width + x % draft.width]) previewCtx.fillRect(x, y, 1, 1);
        }
    }
    // the first touched pixel decides if the drag draws or erases
    let paintValue;
    let lastCell;
    function getCellAt(e) {
        const rect = gridCanvas.getBoundingClientRect();
        const size = draft.width;
        return [
            (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(Math.floor((e.clientX - rect.left) / rect.width * size), 0, size - 1),
            (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(Math.floor((e.clientY - rect.top) / rect.height * size), 0, size - 1)
        ];
    }
    function paintAt(e) {
        const size = draft.width;
        const [x1, y1] = getCellAt(e);
        if (paintValue === undefined) paintValue = draft.data[y1 * size + x1] ? 0 : 1;
        // fill the cells between events, fast drags skip cells otherwise
        const [x0, y0] = lastCell ?? [
            x1,
            y1
        ];
        const steps = Math.max(Math.abs(x1 - x0), Math.abs(y1 - y0), 1);
        for(let i = 0; i <= steps; i++){
            const x = Math.round(x0 + (x1 - x0) * i / steps);
            const y = Math.round(y0 + (y1 - y0) * i / steps);
            draft.data[y * size + x] = paintValue;
        }
        lastCell = [
            x1,
            y1
        ];
        draw();
    }
    const pointerListener = new (0, $3a4865bce5f52590$export$9371bd96776f4e82)({
        target: gridCanvas,
        onPointer: (e)=>{
            if (e.type === 'pointerdown' && e.button === 'left') {
                e.eventPreventDefault();
                paintValue = undefined;
                lastCell = undefined;
                paintAt(e);
            }
            if (e.type === 'pointermove' && e.button === 'left' && paintValue !== undefined) paintAt(e);
            if (e.type === 'pointerup') paintValue = undefined;
        }
    });
    const sizeOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
        optionArr: (0, $be2bfe057d41ff95$export$e164bde6f5f7a06a).map((size)=>({
                id: size,
                label: `${size}\xd7${size}`
            })),
        initId: draft.width,
        isSmall: true,
        isFocusable: true,
        onChange: (size)=>{
            const old = draft;
            draft = {
                width: size,
                height: size,
                // bigger: repeats the tile, so it looks the same. smaller: crops the top left.
                data: Array.from({
                    length: size * size
                }, (_, i)=>{
                    const x = i % size % old.width;
                    const y = Math.floor(i / size) % old.height;
                    return old.data[y * old.width + x];
                })
            };
            draw();
        }
    });
    const invertButton = (0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
        tagName: 'button',
        className: 'kl-button',
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-invert'),
        onClick: ()=>{
            draft.data = draft.data.map((value)=>value ? 0 : 1);
            draw();
        }
    });
    const rootEl = (0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
        content: [
            (0, $9e4d66c06c67fa7f$export$c3da0dad1b44eea9)({
                content: [
                    sizeOptions.getElement(),
                    invertButton
                ],
                css: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    marginBottom: 10
                }
            }),
            gridCanvas,
            previewCanvas
        ]
    });
    draw();
    const buttons = p.onDelete ? [
        {
            id: 'delete',
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pixel-pattern-delete')
        },
        'Ok',
        'Cancel'
    ] : [
        'Ok',
        'Cancel'
    ];
    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
        message: '',
        div: rootEl,
        buttons: buttons,
        deleteButton: 'delete',
        clickOnEnter: 'Ok',
        callback: (result)=>{
            pointerListener.destroy();
            sizeOptions.destroy();
            (0, $2f436639594531f3$export$2384aff49c9b73c2)(gridCanvas);
            (0, $2f436639594531f3$export$2384aff49c9b73c2)(previewCanvas);
            if (result === 'Ok') p.onOk(draft);
            else if (result === 'delete') p.onDelete?.();
        }
    });
}



function $b16050fcb7c0035e$var$createTipPreview(tip) {
    // drawn at 1x, displayed at 3x -> crisp pixels. odd scale, so it can be centered in odd sized option
    const size = 7;
    const scale = 3;
    const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(size, size);
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    if (tip === 'round') (0, $ce287f0b331aeb2c$export$b843be359a1eb867)(size).forEach((halfWidth, y)=>{
        ctx.fillRect(size / 2 - halfWidth, y, halfWidth * 2, 1);
    });
    else ctx.fillRect(0, 0, size, size);
    return (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: 'dark-invert',
        css: {
            // option size stays the same (35)
            width: size * scale,
            height: size * scale,
            margin: 7,
            backgroundImage: 'url(' + canvas.toDataURL('image/png') + ')',
            backgroundSize: `${size * scale}px ${size * scale}px`,
            imageRendering: 'pixelated'
        }
    });
}
const $b16050fcb7c0035e$export$d001f3406562d07 = function() {
    const brushInterface = {
        image: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('brush-pixel'),
        tooltip: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pixel'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $be957da3610487e9$export$921068d8846a1559).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1,
            curve: [
                [
                    0,
                    0.01
                ],
                [
                    0.5,
                    0.3
                ],
                [
                    1,
                    1
                ]
            ]
        }
    };
    (0, $fc42a07754814920$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $fc42a07754814920$export$ce37e184d908d785)('brush-pixel');
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $5f374c2505ee6174$export$32510733a89b2eab).PixelBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        const tipOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: [
                'round',
                'square'
            ].map((tip)=>({
                    id: tip,
                    label: $b16050fcb7c0035e$var$createTipPreview(tip),
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)(tip === 'round' ? 'brush-pen-circle' : 'brush-pen-square')
                })),
            initId: brush.getTip(),
            onChange: (tip)=>{
                brush.setTip(tip);
                p.onConfigChange();
            },
            css: {
                marginTop: 10
            }
        });
        const lockAlphaToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: brush.getLockAlpha(),
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha'),
            callback: function(b) {
                brush.setLockAlpha(b);
            },
            doHighlight: true,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha-title'),
            name: 'lock-alpha-toggle'
        });
        const eraserToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: brush.getIsEraser(),
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('eraser'),
            callback: function(b) {
                brush.setIsEraser(b);
            },
            name: 'eraser-toggle'
        });
        // patterns: defaults + the user's own. Identified by index, custom ones come after defaults.
        let customPatterns = (0, $be2bfe057d41ff95$export$1714be800c8f1d7c)();
        const getPatterns = ()=>[
                ...(0, $be2bfe057d41ff95$export$ebb66c2ece63841a),
                ...customPatterns
            ];
        const selectPattern = (index)=>{
            brush.setPattern(getPatterns()[index]);
        };
        const updateCustomPatterns = (patterns, selectedIndex)=>{
            customPatterns = patterns;
            (0, $be2bfe057d41ff95$export$784a1f68cbc24d89)(customPatterns);
            patternPicker.setPatterns(getPatterns(), selectedIndex);
            selectPattern(selectedIndex);
        };
        const patternPicker = new (0, $03c03c0e4ec3629c$export$d5c33c8a29c1dcdc)({
            patterns: getPatterns(),
            selectedIndex: 0,
            onSelect: selectPattern,
            onClickSelected: (index)=>{
                const customIndex = index - (0, $be2bfe057d41ff95$export$ebb66c2ece63841a).length;
                if (customIndex < 0) {
                    (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('brush-pixel-pattern-edit-default-error'));
                    return;
                }
                (0, $a49f0c171741af96$export$35cb60a4a13d25a5)({
                    pattern: customPatterns[customIndex],
                    onOk: (pattern)=>{
                        updateCustomPatterns(customPatterns.map((item, i)=>i === customIndex ? pattern : item), index);
                    },
                    onDelete: ()=>{
                        updateCustomPatterns(customPatterns.filter((_, i)=>i !== customIndex), 0);
                    }
                });
            },
            onAdd: ()=>{
                (0, $a49f0c171741af96$export$35cb60a4a13d25a5)({
                    // new patterns start fully filled
                    pattern: {
                        width: 4,
                        height: 4,
                        data: new Array(16).fill(1)
                    },
                    onOk: (pattern)=>{
                        const patterns = [
                            ...customPatterns,
                            pattern
                        ];
                        updateCustomPatterns(patterns, (0, $be2bfe057d41ff95$export$ebb66c2ece63841a).length + patterns.length - 1);
                    }
                });
            },
            css: {
                marginTop: 10
            }
        });
        const spacingSpline = new (0, $be957da3610487e9$export$921068d8846a1559).SplineInterpolator([
            [
                0.5,
                0.45
            ],
            [
                100,
                4
            ]
        ]);
        function setSize(size) {
            brush.setSize(size);
            brush.setSpacing(spacingSpline.interpolate(size) / size);
        }
        function init() {
            sizeSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                }
            });
            opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brushInterface.opacitySlider.max,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            const pressureSizeToggle = (0, $7a8db4f517a189fb$export$9da2e8821e6cbb57)(true, function(b) {
                brush.sizePressure(b);
            });
            div.append((0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10
                }
            }), opacitySlider.getElement(), tipOptions.getElement(), patternPicker.getElement());
            const toggleRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: div,
                css: {
                    display: 'flex',
                    marginTop: 10,
                    gap: 10,
                    flexWrap: 'wrap'
                }
            });
            toggleRow.append(lockAlphaToggle.getElement(), eraserToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size * 2);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity * 100);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.freeResources = ()=>{
            brush.freeResources();
        };
        this.toggleEraser = ()=>{
            eraserToggle.setValue(!eraserToggle.getValue());
            brush.setIsEraser(eraserToggle.getValue());
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();










const $23fca815708942b8$export$cf481ecf227135a8 = function() {
    const brushInterface = {
        image: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('brush-eraser'),
        tooltip: (0, $fc42a07754814920$export$ce37e184d908d785)('eraser') + ' [E]',
        sizeSlider: {
            min: 0.5,
            max: 200,
            curve: (0, $be957da3610487e9$export$921068d8846a1559).powerSplineInput(0.5, 200, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $fc42a07754814920$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $fc42a07754814920$export$ce37e184d908d785)('eraser') + ' [E]';
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $5f374c2505ee6174$export$32510733a89b2eab).EraserBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        let isTransparentBg = false;
        function setSize(size) {
            brush.setSize(size);
        }
        function init() {
            sizeSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: 30,
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 10) return (0, $be957da3610487e9$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brushInterface.opacitySlider.max,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            const pressureSizeToggle = (0, $7a8db4f517a189fb$export$9da2e8821e6cbb57)(true, function(b) {
                brush.sizePressure(b);
            });
            const pressureOpacityToggle = (0, $7a8db4f517a189fb$export$9da2e8821e6cbb57)(false, function(b) {
                brush.opacityPressure(b);
            });
            div.append((0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10
                }
            }), (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }));
            const transparencyToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
                init: false,
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-eraser-transparent-bg'),
                callback: function(b) {
                    isTransparentBg = b;
                    brush.setTransparentBG(b);
                },
                css: {
                    marginTop: 10
                },
                name: 'transparency-toggle'
            });
            div.append(transparencyToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function() {};
        this.setLayer = function(layer) {
            brush.setLayer(layer);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.getIsTransparentBg = function() {
            return isTransparentBg;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();










const $67579593f045d4a6$export$84831662ba707e7a = function() {
    const brushInterface = {
        image: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('brush-smudge'),
        tooltip: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-smudge'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $be957da3610487e9$export$921068d8846a1559).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1,
            curve: [
                [
                    0,
                    0.01
                ],
                [
                    0.5,
                    0.3
                ],
                [
                    1,
                    1
                ]
            ]
        }
    };
    (0, $fc42a07754814920$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $fc42a07754814920$export$ce37e184d908d785)('brush-smudge');
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $5f374c2505ee6174$export$32510733a89b2eab).SmudgeBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        const lockAlphaToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: brush.getLockAlpha(),
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha'),
            callback: function(b) {
                brush.setLockAlpha(b);
            },
            doHighlight: true,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha-title'),
            css: {
                display: 'inline-block'
            },
            name: 'lock-alpha-toggle'
        });
        const spacingSpline = new (0, $be957da3610487e9$export$921068d8846a1559).SplineInterpolator([
            [
                0,
                15
            ],
            [
                8,
                7
            ],
            [
                14,
                4
            ],
            [
                30,
                3
            ],
            [
                50,
                2.7
            ],
            [
                100,
                2
            ]
        ]);
        function setSize(size) {
            brush.setSize(size);
            brush.setSpacing(Math.max(2, spacingSpline.interpolate(size)) / 15);
        }
        function init() {
            sizeSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 10) return (0, $be957da3610487e9$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                curve: brushInterface.opacitySlider.curve,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            const pressureSizeToggle = (0, $7a8db4f517a189fb$export$9da2e8821e6cbb57)(false, function(b) {
                brush.sizePressure(b);
            });
            const pressureOpacityToggle = (0, $7a8db4f517a189fb$export$9da2e8821e6cbb57)(false, function(b) {
                brush.opacityPressure(b);
            });
            div.append((0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10
                }
            }), (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }));
            const bottomRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: div,
                css: {
                    marginTop: 10
                }
            });
            bottomRow.append(lockAlphaToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.getIsDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();












const $c19b38e66ec44f39$export$80819a93636ebb04 = function() {
    const brushInterface = {
        image: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('brush-chemy'),
        tooltip: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-chemy'),
        sizeSlider: {
            min: 0.25,
            max: 25,
            curve: (0, $be957da3610487e9$export$921068d8846a1559).powerSplineInput(0.25, 25, 0.1),
            isDisabled: true
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $fc42a07754814920$export$e4ce066d17694649).subscribe(()=>{
        brushInterface.tooltip = (0, $fc42a07754814920$export$ce37e184d908d785)('brush-chemy');
    });
    brushInterface.Ui = function(p) {
        const div = document.createElement('div'); // the gui
        const brush = new (0, $5f374c2505ee6174$export$32510733a89b2eab).ChemyBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        let sizeSlider;
        let opacitySlider;
        function setSize(size) {
            brush.setSize(size);
        }
        let eraserToggle;
        function init() {
            sizeSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-size'),
                width: 250,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                isEnabled: brush.getMode() === 'stroke',
                toDisplayValue: (val)=>val * 2,
                toValue: (displayValue)=>displayValue / 2,
                onChange: (val)=>{
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: (displayValue)=>{
                    if (displayValue < 5) return (0, $be957da3610487e9$export$921068d8846a1559).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
                width: 250,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                eventResMs: (0, $13222f1aece36a46$export$f02de051ab70b20e),
                toDisplayValue: (val)=>val * 100,
                toValue: (displayValue)=>displayValue / 100,
                onChange: (val)=>{
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(opacitySlider.getElement(), {
                marginTop: 10
            });
            eraserToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
                init: brush.getIsEraser(),
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('eraser'),
                callback: function(b) {
                    brush.setIsEraser(b);
                },
                css: {
                    marginTop: 10,
                    marginLeft: 10
                },
                name: 'eraser-toggle'
            });
            const lockAlphaToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
                init: brush.getLockAlpha(),
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha'),
                callback: function(b) {
                    brush.setLockAlpha(b);
                },
                doHighlight: true,
                title: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha-title'),
                css: {
                    marginTop: 10
                },
                name: 'lock-alpha-toggle'
            });
            const toggleRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
                css: {
                    display: 'flex',
                    marginTop: 10
                }
            });
            const iconSize = 35;
            const padding = 8;
            const actualIconSize = iconSize - padding * 2;
            const halfSize = actualIconSize / 2;
            const modeOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
                optionArr: [
                    {
                        id: 'fill',
                        label: (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
                            class: 'dark-invert',
                            elementType: 'svg',
                            width: iconSize + '',
                            height: iconSize + '',
                            childrenArr: [
                                {
                                    elementType: 'path',
                                    fill: '#000',
                                    css: {
                                        transformOrigin: '0 0',
                                        transform: `translate(-0.5px, -0.5px) scale(${actualIconSize}, ${actualIconSize}) translate(0.5px, 0.5px)`
                                    },
                                    d: 'M 0,0 C 1.5,0 -0.5,1 1,1'
                                }
                            ]
                        }),
                        title: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-chemy-fill')
                    },
                    {
                        id: 'stroke',
                        label: (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
                            class: 'dark-invert',
                            elementType: 'svg',
                            width: iconSize + '',
                            height: iconSize + '',
                            childrenArr: [
                                {
                                    elementType: 'path',
                                    fill: 'none',
                                    stroke: '#000',
                                    css: {
                                        strokeWidth: '0.12px',
                                        transformOrigin: '0 0',
                                        transform: `translate(-0.5px, -0.5px) scale(${actualIconSize}, ${actualIconSize}) translate(0.5px, 0.5px)`
                                    },
                                    d: 'M 0,0 C 1.5,0 -0.5,1 1,1'
                                }
                            ]
                        }),
                        title: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-chemy-stroke')
                    }
                ],
                initId: brush.getMode(),
                onChange: (id)=>{
                    brush.setMode(id);
                    brushInterface.sizeSlider.isDisabled = brush.getMode() === 'fill';
                    sizeSlider.setIsEnabled(!brushInterface.sizeSlider.isDisabled);
                    const brushSize = brush.getSize();
                    sizeSlider.setValue(brushSize);
                    p.onSizeChange(brushSize);
                    p.onConfigChange();
                }
            });
            const mirrorXToggle = new (0, $0b383e4686740404$export$2358c75ad3c15b2d)({
                label: (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
                    class: 'dark-invert',
                    elementType: 'svg',
                    width: iconSize + '',
                    height: iconSize + '',
                    childrenArr: [
                        {
                            elementType: 'path',
                            fill: 'none',
                            stroke: '#000',
                            css: {
                                strokeWidth: 1
                            },
                            d: `M ${halfSize + padding},${padding} ${halfSize + padding},${actualIconSize + padding}`
                        }
                    ]
                }),
                title: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-chemy-mirror-x'),
                init: brush.getXSymmetry(),
                onChange: (b)=>{
                    brush.setXSymmetry(b);
                }
            });
            const mirrorYToggle = new (0, $0b383e4686740404$export$2358c75ad3c15b2d)({
                label: (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
                    class: 'dark-invert',
                    elementType: 'svg',
                    width: iconSize + '',
                    height: iconSize + '',
                    childrenArr: [
                        {
                            elementType: 'path',
                            fill: 'none',
                            stroke: '#000',
                            css: {
                                strokeWidth: 1
                            },
                            d: `M ${padding},${halfSize + padding} ${actualIconSize + padding},${halfSize + padding}`
                        }
                    ]
                }),
                title: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-chemy-mirror-y'),
                init: brush.getYSymmetry(),
                onChange: (b)=>{
                    brush.setYSymmetry(b);
                }
            });
            const gradientToggle = new (0, $0b383e4686740404$export$2358c75ad3c15b2d)({
                label: (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
                    class: 'dark-invert',
                    elementType: 'svg',
                    width: iconSize + '',
                    height: iconSize + '',
                    childrenArr: [
                        {
                            elementType: 'defs',
                            childrenArr: [
                                {
                                    elementType: 'linearGradient',
                                    id: 'gradient',
                                    x1: '0',
                                    y1: '0',
                                    x2: '0',
                                    y2: '1',
                                    childrenArr: [
                                        {
                                            elementType: 'stop',
                                            offset: '0%',
                                            'stop-color': 'rgba(0,0,0,0)'
                                        },
                                        {
                                            elementType: 'stop',
                                            offset: '100%',
                                            'stop-color': 'rgba(0,0,0,1)'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            elementType: 'rect',
                            fill: "url('#gradient')",
                            x: '' + padding,
                            y: '' + padding,
                            width: '' + actualIconSize,
                            height: '' + actualIconSize
                        }
                    ]
                }),
                title: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-chemy-gradient'),
                init: brush.getGradient(),
                onChange: (b)=>{
                    brush.setGradient(b);
                }
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(mirrorXToggle.getElement(), {
                marginLeft: 10
            });
            {
                const margin = {
                    marginLeft: 4
                };
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(mirrorYToggle.getElement(), margin);
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(gradientToggle.getElement(), margin);
            }
            toggleRow.append(modeOptions.getElement(), mirrorXToggle.getElement(), mirrorYToggle.getElement(), gradientToggle.getElement());
            div.append(sizeSlider.getElement(), opacitySlider.getElement(), toggleRow, (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    lockAlphaToggle.getElement(),
                    eraserToggle.getElement()
                ],
                css: {
                    display: 'flex'
                }
            }));
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.getIsDrawing() && brush.getMode() === 'stroke') sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.getIsDrawing() && brush.getMode() === 'stroke') sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y);
        };
        this.goLine = function(x, y, p, isCoalesced) {
            brush.goLine(x, y);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.getIsDrawing();
        };
        this.toggleEraser = ()=>{
            eraserToggle.setValue(!eraserToggle.getValue());
            brush.setIsEraser(eraserToggle.getValue());
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();


const $3349ef033c680bf8$export$d1a79a5ce7e46547 = {
    penBrush: (0, $916f0530599142b6$export$a0d4983f3b0b5c8e),
    blendBrush: (0, $a69ad8af8547ad95$export$156bb4fe8f4bcb4b),
    sketchyBrush: (0, $58bc5d14d6b5fb8b$export$ffae56164d1bde68),
    pixelBrush: (0, $b16050fcb7c0035e$export$d001f3406562d07),
    chemyBrush: (0, $c19b38e66ec44f39$export$80819a93636ebb04),
    smudgeBrush: (0, $67579593f045d4a6$export$84831662ba707e7a),
    eraserBrush: (0, $23fca815708942b8$export$cf481ecf227135a8)
};






function $331e59f8d60fc7d5$export$35fa34e5af64bd4a(url, isEmbed, options) {
    // window very small, modal might look bad
    if (!isEmbed && options?.allowSmallScreenWindowOpen !== false && (window.innerHeight < 500 || window.innerWidth < 700)) {
        window.open(url);
        return;
    }
    const destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
    const iframe = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'iframe',
        props: {
            src: url,
            title: options?.iframeTitle || 'Iframe Content'
        },
        css: {
            width: options?.iframeWidth || '100%',
            height: options?.iframeHeight || '100%',
            border: 0,
            opacity: 0
        }
    });
    setTimeout(()=>{
        iframe.style.opacity = ''; // fallback
    }, 500);
    const titleEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
    const showOpenInNewTabLink = !isEmbed && options?.showOpenInNewTabLink !== false;
    let linkEl;
    if (showOpenInNewTabLink) {
        linkEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'a',
            parent: titleEl,
            destroyer: destroyer,
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('modal-new-tab'),
            props: {
                href: url,
                target: '_blank'
            },
            onClick: function() {
                popup.close();
            }
        });
        iframe.onload = ()=>{
            if (linkEl && iframe.contentWindow) try {
                (0, $be957da3610487e9$export$921068d8846a1559).setAttributes(linkEl, {
                    href: '' + iframe.contentWindow.location
                });
            } catch (e) {
            // might not have access
            }
            iframe.style.opacity = '';
        };
    }
    const onMessage = options?.closeOnMessage ? (event)=>{
        if (event.origin !== options.closeOnMessage?.origin) return;
        if (typeof event.data !== 'object' || !event.data || event.data.action !== options.closeOnMessage?.action) return;
        if (event.source !== iframe.contentWindow) return;
        popup.close();
    } : undefined;
    if (onMessage) window.addEventListener('message', onMessage);
    const popup = new (0, $5b46848ca200986a$export$185108a9b725b68)({
        title: titleEl,
        content: iframe,
        width: options?.modalWidth || 880,
        height: options?.modalHeight,
        onClose: ()=>{
            if (onMessage) window.removeEventListener('message', onMessage);
            iframe.src = 'about:blank';
            if (linkEl) {
                destroyer.destroy();
                linkEl = undefined;
            }
        }
    });
}



class $5b8a0fd740d86863$export$3dff5655255b5729 {
    getValue() {
        for(let i = 0; i < this.inputs.length; i++){
            if (this.inputs[i].checked) return this.inputs[i].value;
        }
        return null;
    }
    getElement() {
        return this.el;
    }
    constructor({ name: name, init: init, items: items, ignoreFocus: ignoreFocus }){
        this.inputs = [];
        this.el = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-radio'
        });
        items.forEach((item)=>{
            const label = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'label'
            });
            const input = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'input',
                parent: label,
                props: {
                    name: name,
                    value: item.value,
                    type: 'radio'
                }
            });
            if (ignoreFocus) input.setAttribute('data-ignore-focus', 'true');
            if (init === item.value) input.checked = true;
            label.append(item.label);
            this.el.append(label);
            this.inputs.push(input);
        });
    }
}







function $f8f5a7dee6742712$export$1b9ca798405c9eb6(timestamp) {
    let age = Date.now() - timestamp;
    let ageStr;
    age = Math.floor(age / 1000 / 60);
    ageStr = (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-min-ago').replace('{x}', '' + age);
    if (age > 60) {
        age = Math.floor(age / 60);
        ageStr = (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-hours-ago').replace('{x}', '' + age);
        if (age > 24) {
            age = Math.floor(age / 24);
            ageStr = (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-days-ago').replace('{x}', '' + age);
            if (age > 31) ageStr = (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-month-ago');
        }
    }
    return ageStr;
}







function $f62dcbe3649ee07c$export$8d6339e7e16ba0e(p) {
    const result = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'button',
        className: 'kl-help-btn',
        content: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('help', {
            width: 19,
            height: 19
        }),
        title: p.title,
        destroyer: p.destroyer,
        props: {
            type: 'button',
            ariaLabel: p.title
        },
        onClick: p.onClick
    });
    if (p.isFocusable === false) result.tabIndex = -1;
    return result;
}



class $38dbae5cb4c4bb3c$export$852ebaa1b01c8b5a {
    getElement() {
        return this.rootEl;
    }
    show() {}
    destroy() {
        this.destroyer.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(helpPath){
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.infoButton = (0, $f62dcbe3649ee07c$export$8d6339e7e16ba0e)({
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-about'),
            isFocusable: false,
            destroyer: this.destroyer,
            onClick: ()=>{
                (0, $331e59f8d60fc7d5$export$35fa34e5af64bd4a)(helpPath + '#help-browser-storage', false);
            }
        });
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage'),
            css: {
                display: 'flex',
                margin: '-5px 0',
                gap: 6
            }
        });
        this.rootEl.append(this.infoButton);
    }
}


var $5557ea4a31ac6530$export$bd46b8ab3689edc4;
var $5557ea4a31ac6530$export$b5381822af66064b;
$5557ea4a31ac6530$export$bd46b8ab3689edc4 = `a9LdEW_anim`;
$5557ea4a31ac6530$export$bd46b8ab3689edc4;
$5557ea4a31ac6530$export$b5381822af66064b = `a9LdEW_animEl`;


/**
 * https://developer.mozilla.org/en-US/docs/Web/API/StorageManager/persist
 * Might reduce deletions of indexedDB data by browser.
 *
 * "The best time to request your storage be marked as persistent is when you save critical user
 * data, and the request should ideally be **wrapped in a user gesture**."
 * from https://web.dev/articles/persistent-storage
 */ async function $e2768fb1f61c700a$export$f565b71ad023b7df() {
    if ('storage' in navigator && 'persist' in navigator.storage) await navigator.storage.persist();
}




class $293199167ef511c0$export$9c72cf485ef46673 {
    updateAge() {
        if (!this.timestamp) return;
        this.ageEl.textContent = (0, $f8f5a7dee6742712$export$1b9ca798405c9eb6)(this.timestamp);
    }
    resetButtons() {
        this.previewEl.classList.remove('kl-storage-preview--disabled');
        if (this.timestamp) {
            if (this.openButtonEl) this.openButtonEl.disabled = false;
            this.storeButtonEl.textContent = (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-overwrite');
            this.storeButtonEl.disabled = false;
            this.clearButtonEl.disabled = false;
        } else {
            if (this.openButtonEl) this.openButtonEl.disabled = true;
            this.storeButtonEl.textContent = (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-store');
            this.storeButtonEl.disabled = false;
            this.clearButtonEl.disabled = true;
        }
    }
    updateThumb(timestamp, thumbnail) {
        this.timestamp = timestamp;
        this.thumbnail?.remove();
        this.thumbnail = thumbnail ? (0, $2f436639594531f3$export$83cbd513f10a842b)(thumbnail) : undefined;
        const thumbnailCanvas = this.thumbnail; // typescript being weird
        if (thumbnailCanvas && timestamp) {
            thumbnailCanvas.classList.add('kl-storage-preview__im');
            this.ageEl.remove();
            this.emptyEl.remove();
            this.updateAge();
            this.previewEl.append(thumbnailCanvas, this.ageEl);
            this.previewEl.style.pointerEvents = this.onOpen ? '' : 'none';
            if (typeof performance !== 'undefined' && timestamp > performance.timeOrigin) {
                const animEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    parent: this.previewEl,
                    className: $5557ea4a31ac6530$export$b5381822af66064b
                });
                setTimeout(()=>{
                    animEl.remove();
                }, 500);
            }
        } else {
            this.ageEl.remove();
            this.previewEl.append(this.emptyEl);
            this.previewEl.style.pointerEvents = 'none'; // prevent title
        }
        this.resetButtons();
    }
    async store() {
        this.applyUncommitted();
        const meta = this.projectStore.getCurrentMeta();
        const project = this.getProject();
        if (meta && meta.projectId !== project.projectId) {
            const doOverwrite = await new Promise((resolve, reject)=>{
                (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                    type: 'warning',
                    message: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-overwrite-confirm'),
                    buttons: [
                        {
                            id: 'overwrite',
                            label: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-overwrite')
                        },
                        'Cancel'
                    ],
                    callback: async (result)=>{
                        if (result === 'Cancel') {
                            resolve(false);
                            return;
                        }
                        resolve(true);
                    }
                });
            });
            if (!doOverwrite) return;
        }
        await (0, $e2768fb1f61c700a$export$f565b71ad023b7df)();
        if (this.openButtonEl) this.openButtonEl.disabled = true;
        this.storeButtonEl.textContent = (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-storing');
        this.storeButtonEl.disabled = true;
        this.clearButtonEl.disabled = true;
        this.previewEl.classList.add('kl-storage-preview--disabled');
        await new Promise((resolve)=>{
            setTimeout(()=>resolve(null), 20);
        });
        try {
            await this.projectStore.store(project);
            this.onStored();
        } catch (e) {
            this.resetButtons();
            (0, $5f9f54d39d868ac2$export$3879b24e8245693d)([
                `${(0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-failed-1')}<ul>`,
                `<li>${(0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-failed-2')}</li>`,
                `<li>${(0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-failed-3')}</li>`,
                `<li>${(0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-failed-4')}</li>`,
                '</ul>'
            ].join(''));
            (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(new Error('storage-ui: failed to store browser storage, ' + e));
        }
    }
    async clear() {
        (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
            type: 'warning',
            message: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-clear-prompt'),
            buttons: [
                {
                    id: 'clear',
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-clear')
                },
                'Cancel'
            ],
            deleteButton: 'clear',
            callback: async (result)=>{
                if (result === 'Cancel') return;
                if (this.openButtonEl) this.openButtonEl.disabled = true;
                this.storeButtonEl.disabled = true;
                this.clearButtonEl.disabled = true;
                try {
                    await this.projectStore.clear();
                } catch (e) {
                    this.resetButtons();
                    (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-failed-clear'));
                    (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(new Error('storage-ui: failed to clear browser storage, ' + e));
                }
            }
        });
    }
    showError() {
        this.contentEl.innerHTML = '';
        (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.contentEl,
            content: "\uD83D\uDD34 " + (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-cant-access'),
            css: {
                marginTop: 10
            }
        });
    }
    getElement() {
        return this.rootEl;
    }
    show() {
        if (this.isFirst) {
            this.isFirst = false;
            if (!this.projectStore.getIsAvailable()) this.showError();
            else (async ()=>{
                try {
                    await this.projectStore.update();
                    const meta = this.projectStore.getCurrentMeta();
                    if (meta) this.updateThumb(meta.timestamp, meta.thumbnail);
                    else this.updateThumb();
                } catch (e) {
                    this.showError();
                    throw new Error('browser-storage-ui: failed initial read browser storage, ' + e);
                }
            })();
        }
    }
    hide() {
    // ...
    }
    destroy() {
        this.header.destroy();
        this.destroyer.destroy();
        clearInterval(this.updateAgeInterval);
        this.projectStore.unsubscribe(this.storeListener);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.previewEl = {};
        this.ageEl = {};
        this.emptyEl = {};
        this.storeButtonEl = {};
        this.clearButtonEl = {};
        this.storeListener = {};
        this.isFirst = true;
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.updateAgeInterval = setInterval(()=>this.updateAge(), 60000);
        this.projectStore = p.projectStore;
        this.getProject = p.getProject;
        this.onStored = p.onStored;
        this.applyUncommitted = p.applyUncommitted;
        this.options = p.options;
        this.onOpen = p.onOpen;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({});
        this.header = new (0, $38dbae5cb4c4bb3c$export$852ebaa1b01c8b5a)(p.helpPath);
        this.rootEl.append(this.header.getElement());
        this.contentEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl
        });
        if (!this.projectStore.getIsAvailable()) {
            this.showError();
            return;
        }
        this.previewEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-storage-preview',
            destroyer: this.destroyer,
            onClick: ()=>this.onOpen?.(),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-open')
        });
        this.emptyEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-empty')
        });
        this.ageEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                textAlign: 'center',
                background: 'rgba(0,0,0,0.7)',
                color: '#fff',
                fontSize: 13
            }
        });
        if (this.onOpen) this.openButtonEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button grid-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-open'),
            destroyer: this.destroyer,
            css: {
                margin: 0
            },
            onClick: ()=>this.onOpen?.(),
            props: !this.options?.isFocusable ? {
                tabIndex: -1
            } : undefined
        });
        this.storeButtonEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button grid-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-store'),
            destroyer: this.destroyer,
            css: {
                margin: 0
            },
            onClick: ()=>this.store()
        });
        this.clearButtonEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button grid-button kl-button-delete',
            content: [
                (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('remove-layer', {
                    height: 20
                }),
                (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-clear')
            ],
            destroyer: this.destroyer,
            css: {
                margin: 0
            },
            onClick: ()=>this.clear()
        });
        if (!this.options?.isFocusable) {
            this.storeButtonEl.tabIndex = -1;
            this.clearButtonEl.tabIndex = -1;
        }
        if (this.options?.hideClearButton) this.clearButtonEl.style.visibility = 'hidden';
        this.contentEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    content: this.previewEl,
                    css: {
                        alignSelf: 'stretch',
                        flexGrow: 1
                    }
                }),
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    content: [
                        this.openButtonEl,
                        this.storeButtonEl,
                        this.clearButtonEl
                    ],
                    css: {
                        display: 'flex',
                        gap: 10,
                        flexDirection: 'column'
                    }
                })
            ],
            css: {
                marginTop: 10,
                display: 'flex',
                gap: 10
            }
        }));
        this.storeListener = {
            onUpdate: (project)=>{
                this.updateThumb(project?.timestamp, project?.thumbnail);
            }
        };
        this.projectStore.subscribe(this.storeListener);
        this.updateThumb();
    }
}






const $5ce1a52596b51fa5$export$f14c2a28fc1e9841 = 240;
class $5ce1a52596b51fa5$export$f3c1ac6650038646 {
    static createThumbnail(project) {
        const size = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(project.width, project.height, $5ce1a52596b51fa5$export$f14c2a28fc1e9841, $5ce1a52596b51fa5$export$f14c2a28fc1e9841);
        const factor = size.width / project.width;
        return (0, $3efd55021d1b8d84$export$5f63a7b18dc4503a)(project, factor);
    }
    static async createStorageProject(project) {
        const layers = [];
        for (const item of project.layers){
            let blob;
            if (item.image instanceof HTMLCanvasElement) blob = await (0, $2f436639594531f3$export$403d539f215df596)(item.image, 'image/png');
            else // todo image
            throw new Error('Not implemented');
            layers.push({
                name: item.name,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr,
                hasClipping: item.hasClipping,
                blob: blob
            });
        }
        return {
            id: 1,
            projectId: project.projectId,
            timestamp: Date.now(),
            thumbnail: await (0, $2f436639594531f3$export$403d539f215df596)($5ce1a52596b51fa5$export$f3c1ac6650038646.createThumbnail(project), 'image/png'),
            width: project.width,
            height: project.height,
            layers: layers
        };
    }
    static async readStorageProject(storageProject) {
        if (!storageProject.width || !storageProject.height || isNaN(storageProject.width) || isNaN(storageProject.height) || storageProject.width < 1 || storageProject.height < 1) throw new Error('readStorageProject invalid canvas size: ' + storageProject.width + ', ' + storageProject.height);
        const project = {
            projectId: storageProject.projectId,
            width: storageProject.width,
            height: storageProject.height,
            layers: (await Promise.all(storageProject.layers.map((layer)=>{
                if (layer.blob) return (0, $2e475852c551fcab$export$99cbfa07c2ec1e27)(layer.blob).catch(()=>new Image(storageProject.width, storageProject.height));
                return new Image(storageProject.width, storageProject.height);
            }))).map((image, i)=>{
                const storageLayer = storageProject.layers[i];
                return {
                    name: storageLayer.name,
                    isVisible: storageLayer.isVisible,
                    opacity: storageLayer.opacity,
                    mixModeStr: storageLayer.mixModeStr,
                    hasClipping: storageLayer.hasClipping ?? false,
                    image: image
                };
            })
        };
        return {
            project: project,
            timestamp: storageProject.timestamp,
            thumbnail: await (0, $2e475852c551fcab$export$99cbfa07c2ec1e27)(storageProject.thumbnail).catch(()=>new Image($5ce1a52596b51fa5$export$f14c2a28fc1e9841, $5ce1a52596b51fa5$export$f14c2a28fc1e9841))
        };
    }
    static async readStorageMeta(rawMeta) {
        return {
            projectId: rawMeta.projectId,
            timestamp: rawMeta.timestamp,
            thumbnail: rawMeta.thumbnail ? await (0, $2e475852c551fcab$export$99cbfa07c2ec1e27)(rawMeta.thumbnail).catch(()=>new Image($5ce1a52596b51fa5$export$f14c2a28fc1e9841, $5ce1a52596b51fa5$export$f14c2a28fc1e9841)) : (0, $be957da3610487e9$export$921068d8846a1559).canvas(10, 10)
        };
    }
}




function $2d9e24284881643c$var$requestToPromise(request) {
    return new Promise((resolve, reject)=>{
        request.onsuccess = ()=>resolve(request.result);
        request.onerror = ()=>reject(request.error);
    });
}
class $2d9e24284881643c$export$3ccf5709175ad9cb {
    getObjectStore(store) {
        return this.transaction.objectStore(store);
    }
    async get(store, key) {
        return $2d9e24284881643c$var$requestToPromise(this.getObjectStore(store).get(key));
    }
    async getAll(store) {
        return $2d9e24284881643c$var$requestToPromise(this.getObjectStore(store).getAll());
    }
    async getAllKeys(store) {
        return $2d9e24284881643c$var$requestToPromise(this.getObjectStore(store).getAllKeys());
    }
    async getAllRecords(store) {
        const objectStore = this.getObjectStore(store);
        if (objectStore.getAllRecords) return $2d9e24284881643c$var$requestToPromise(objectStore.getAllRecords());
        // getAllRecords was added to browsers 2025/2026. So we have a fallback.
        // same ordering
        const [keys, values] = await Promise.all([
            $2d9e24284881643c$var$requestToPromise(objectStore.getAllKeys()),
            $2d9e24284881643c$var$requestToPromise(objectStore.getAll())
        ]);
        return keys.map((key, index)=>({
                key: key,
                primaryKey: key,
                value: values[index]
            }));
    }
    async set(store, key, value) {
        await $2d9e24284881643c$var$requestToPromise(this.getObjectStore(store).put(value, key));
    }
    async remove(store, key) {
        await $2d9e24284881643c$var$requestToPromise(this.getObjectStore(store).delete(key));
    }
    async bulkGet(store, keys) {
        const objectStore = this.getObjectStore(store);
        const entries = await Promise.all([
            ...new Set(keys)
        ].map(async (key)=>[
                key,
                await $2d9e24284881643c$var$requestToPromise(objectStore.get(key))
            ]));
        return new Map(entries);
    }
    async bulkSet(store, entries) {
        const objectStore = this.getObjectStore(store);
        await Promise.all(entries.map(({ key: key, value: value })=>$2d9e24284881643c$var$requestToPromise(objectStore.put(value, key))));
    }
    async bulkRemove(store, keys) {
        const objectStore = this.getObjectStore(store);
        await Promise.all([
            ...new Set(keys)
        ].map((key)=>$2d9e24284881643c$var$requestToPromise(objectStore.delete(key))));
    }
    constructor(transaction){
        this.transaction = transaction;
    }
}
// 2025-05-20
// Blobs not supported on iPad in private tabs.
// Blobs are required for indexed db to be useful. Data urls would be wasteful.
const $2d9e24284881643c$var$areBlobUrlsSupported = async function() {
    let result = true;
    const dbName = 'kl-blob-url-test';
    try {
        const blob = new Blob([
            'test'
        ], {
            type: 'text/plain'
        });
        const db = await (0, $94f0b2b810d4d191$export$f85d414d081200d8)(new Promise((resolve, reject)=>{
            const request = indexedDB.open(dbName, 1);
            request.onerror = ()=>reject(request.error);
            request.onsuccess = ()=>resolve(request.result);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                db.createObjectStore('testStore');
            };
        }), 'areBlobUrlsSupported.createDb');
        await (0, $94f0b2b810d4d191$export$f85d414d081200d8)(new Promise((resolve, reject)=>{
            const transaction = db.transaction('testStore', 'readwrite');
            const store = transaction.objectStore('testStore');
            transaction.onabort = ()=>reject(transaction.error);
            transaction.oncomplete = ()=>resolve();
            store.put(blob, 'testStore');
        }), 'areBlobUrlsSupported.storeBlob');
        db.close();
    } catch (e) {
        result = false;
    }
    try {
        indexedDB.deleteDatabase(dbName);
    } catch (e) {
    // IDBFactory.deleteDatabase() called in an invalid security context
    }
    return result;
};
class $2d9e24284881643c$export$7d13d7c63364db4b {
    disconnect() {
        this.db?.close();
        this.db = undefined;
    }
    async disconnectAfterwardsWrapper(activity) {
        try {
            this.openTransactionCount++;
            clearTimeout(this.disconnectTimeout);
            return await activity();
        } finally{
            this.openTransactionCount--;
            if (this.openTransactionCount === 0) {
                // When a new version of the app upgrades the DB, old tabs holding open connections would
                // block the upgrade.
                // -> Close DB connections when inactive.
                clearTimeout(this.disconnectTimeout);
                this.disconnectTimeout = setTimeout(()=>this.disconnect(), 1000);
            }
        }
    }
    openDb() {
        if (this.db) return Promise.resolve(this.db);
        if (this.openingPromise) return this.openingPromise;
        // ensure only one db connection
        const openingPromise = new Promise((resolve, reject)=>{
            const openDbRequest = indexedDB.open(this.dbName, this.dbVersion);
            openDbRequest.onupgradeneeded = (event)=>{
                this.upgrader(event);
            };
            openDbRequest.onsuccess = ()=>{
                const db = openDbRequest.result;
                // a different tab wants to upgrade the database (most likely a newer version of the app)
                db.onversionchange = ()=>{
                    // this tab can't work with the upgraded database. disable indexed db for this tab.
                    this.isAvailable = false;
                    // close connection so other tab can upgrade the db
                    db.close();
                    if (this.db === db) this.db = undefined;
                    throw new Error('IndexedDB onversionchange');
                };
                // when the database connection is unexpectedly closed
                db.onclose = ()=>{
                    if (this.db === db) this.db = undefined;
                    throw new Error('IndexedDB closed');
                };
                this.db = db;
                resolve(db);
            };
            openDbRequest.onerror = ()=>{
                this.isAvailable = false;
                reject(openDbRequest.error ?? new Error(`Could not open IndexedDB "${this.dbName}"`));
            };
            openDbRequest.onblocked = ()=>{
                throw new Error('IndexedDB blocked');
            };
        });
        this.openingPromise = openingPromise;
        const clearOpeningPromise = ()=>{
            if (this.openingPromise === openingPromise) this.openingPromise = undefined;
        };
        openingPromise.then(clearOpeningPromise, clearOpeningPromise);
        return openingPromise;
    }
    init(dbName) {
        if (this.dbName !== '') throw new Error('IndexedDb already initialized');
        this.dbName = dbName;
    }
    async testConnection() {
        this.isAvailable = this.isAvailable && await $2d9e24284881643c$var$areBlobUrlsSupported();
        if (!this.isAvailable) return this.isAvailable;
        try {
            for (const name of this.storeNames){
                const db = await (0, $94f0b2b810d4d191$export$f85d414d081200d8)(this.openDb(), 'indexed-db.testConnection.openDb');
                const transaction = db.transaction(name, 'readonly');
                transaction.abort();
            }
        } catch (e) {
            this.isAvailable = false;
        } finally{
            this.disconnect();
        }
        return this.isAvailable;
    }
    /**
     * Runs requests within a single native IndexedDB transaction. If the transaction aborts,
     * IndexedDB rolls back all changes made by it, preventing partial updates.
     */ async runTransaction(storeNames, mode, // Throw inside activity to abort the transaction.
    // Do not await async work unrelated to IndexedDB, or the transaction will commit early.
    activity, options) {
        return this.disconnectAfterwardsWrapper(async ()=>{
            const { durability: durability, signal: signal } = options ?? {};
            if (signal?.aborted) throw (0, $94f0b2b810d4d191$export$bb3ff0b2339c52db)(signal);
            const db = await this.openDb();
            if (signal?.aborted) throw (0, $94f0b2b810d4d191$export$bb3ff0b2339c52db)(signal);
            for (const storeName of storeNames){
                if (!this.storeNames.includes(storeName)) throw new Error(`indexedDb store "${storeName}" not found in "${this.dbName}"`);
            }
            const transaction = db.transaction([
                ...storeNames
            ], mode, durability ? {
                durability: durability
            } : undefined);
            const transactionResultPromise = new Promise((resolve)=>{
                transaction.oncomplete = ()=>resolve({
                        status: 'complete'
                    });
                transaction.onabort = ()=>resolve({
                        status: 'abort',
                        error: transaction.error ?? new Error('IndexedDB transaction aborted for unknown reason')
                    });
            });
            const wrappedTransaction = new $2d9e24284881643c$export$3ccf5709175ad9cb(transaction);
            const abortTransaction = ()=>{
                try {
                    transaction.abort();
                } catch  {
                // The transaction already completed.
                }
            };
            signal?.addEventListener('abort', abortTransaction, {
                once: true
            });
            try {
                let result;
                try {
                    result = await activity(wrappedTransaction);
                } catch (error) {
                    if (!signal?.aborted) abortTransaction();
                    const transactionResult = await transactionResultPromise;
                    if (transactionResult.status === 'complete') // a strange case you might want to know about
                    console.error('IndexedDB transaction completed, but its activity threw an error.', error);
                    throw signal?.aborted ? (0, $94f0b2b810d4d191$export$bb3ff0b2339c52db)(signal) : error;
                }
                const transactionResult = await transactionResultPromise;
                if (transactionResult.status === 'abort') throw signal?.aborted ? (0, $94f0b2b810d4d191$export$bb3ff0b2339c52db)(signal) : transactionResult.error;
                return result;
            } finally{
                signal?.removeEventListener('abort', abortTransaction);
            }
        });
    }
    getIsAvailable() {
        return this.isAvailable;
    }
    destroy() {
        this.disconnect();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.dbName = '';
        this.isAvailable = true;
        this.openTransactionCount = 0;
        this.storeNames = [
            ...p.objectStoreNames
        ];
        this.dbVersion = p.version;
        this.upgrader = p.upgrader;
    }
}


let $f603d6ecd683b596$var$dbName = 'Klecks';
function $f603d6ecd683b596$export$d21786ffb58aa58a(name) {
    $f603d6ecd683b596$var$dbName = name;
}
function $f603d6ecd683b596$export$620c18ffd80459f1() {
    return $f603d6ecd683b596$var$dbName;
}
const $f603d6ecd683b596$export$aa8c311c20a0e91f = 'RecoveryStore';
const $f603d6ecd683b596$export$ca20f3c4ac3fef1e = 'ImageDataStore';
const $f603d6ecd683b596$export$cb74a94e2496f165 = 'ProjectStore';
const $f603d6ecd683b596$export$889f6d04a9c72786 = 2;
const $f603d6ecd683b596$export$a11d3f631bfac1e6 = (event)=>{
    const oldVersion = event.oldVersion;
    const db = event.target.result;
    if (oldVersion < 1) {
        const store = db.createObjectStore($f603d6ecd683b596$export$cb74a94e2496f165, {
            keyPath: 'id'
        });
        store.createIndex('id', 'id', {
            unique: true
        });
    }
    if (oldVersion < 2) {
        db.createObjectStore($f603d6ecd683b596$export$ca20f3c4ac3fef1e);
        db.createObjectStore($f603d6ecd683b596$export$aa8c311c20a0e91f);
    }
};
const $f603d6ecd683b596$export$8d693ea241b9d9a6 = new (0, $2d9e24284881643c$export$7d13d7c63364db4b)({
    objectStoreNames: [
        $f603d6ecd683b596$export$aa8c311c20a0e91f,
        $f603d6ecd683b596$export$ca20f3c4ac3fef1e,
        $f603d6ecd683b596$export$cb74a94e2496f165
    ],
    version: $f603d6ecd683b596$export$889f6d04a9c72786,
    upgrader: $f603d6ecd683b596$export$a11d3f631bfac1e6
});






function $37813638caeb4048$export$a2a26d8de8cf9775(input) {
    return typeof input === 'object' && input !== null && 'id' in input && typeof input.id === 'string';
}
async function $37813638caeb4048$var$createFallbackThumbnail() {
    // very basic fallback. only affects data stored before version 0.5.1 (2022)
    return await (0, $2f436639594531f3$export$403d539f215df596)((0, $be957da3610487e9$export$921068d8846a1559).canvas((0, $5ce1a52596b51fa5$export$f14c2a28fc1e9841), (0, $5ce1a52596b51fa5$export$f14c2a28fc1e9841)), 'image/png');
}
function $37813638caeb4048$export$a03da4173e824dd3(raw) {
    return [
        ...$37813638caeb4048$export$a2a26d8de8cf9775(raw.thumbnail) ? [
            raw.thumbnail.id
        ] : [],
        ...raw.layers.flatMap((layer)=>$37813638caeb4048$export$a2a26d8de8cf9775(layer.blob) ? [
                layer.blob.id
            ] : [])
    ];
}
class $37813638caeb4048$export$93d91060b9af7e2a {
    async lowLevelStore(project) {
        const imageDataList = [];
        const thumbnail = {
            id: (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)()
        };
        imageDataList.push({
            id: thumbnail.id,
            data: project.thumbnail
        });
        const layers = [];
        for (const layer of project.layers){
            const blob = {
                id: (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)()
            };
            imageDataList.push({
                id: blob.id,
                data: layer.blob
            });
            layers.push({
                ...layer,
                blob: blob
            });
        }
        const raw = {
            ...project,
            thumbnail: thumbnail,
            layers: layers
        };
        await (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).runTransaction([
            (0, $f603d6ecd683b596$export$cb74a94e2496f165),
            (0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e)
        ], 'readwrite', async (transaction)=>{
            // remove old
            const rawOld = await transaction.get((0, $f603d6ecd683b596$export$cb74a94e2496f165), 1);
            if (rawOld) await transaction.bulkRemove((0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e), $37813638caeb4048$export$a03da4173e824dd3(rawOld));
            // save new
            await transaction.bulkSet((0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e), imageDataList.map(({ id: id, data: data })=>({
                    key: id,
                    value: data
                })));
            await transaction.set((0, $f603d6ecd683b596$export$cb74a94e2496f165), undefined, raw);
        }, {
            durability: 'strict'
        });
    }
    async lowLevelReadMeta() {
        const raw = await (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).runTransaction([
            (0, $f603d6ecd683b596$export$cb74a94e2496f165),
            (0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e)
        ], 'readonly', async (transaction)=>{
            const raw = await transaction.get((0, $f603d6ecd683b596$export$cb74a94e2496f165), 1);
            if (!raw) return undefined;
            return {
                projectId: raw.projectId,
                timestamp: raw.timestamp,
                thumbnail: $37813638caeb4048$export$a2a26d8de8cf9775(raw.thumbnail) ? await transaction.get((0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e), raw.thumbnail.id) : raw.thumbnail
            };
        });
        if (!raw) return undefined;
        // for now ignores the ImageData case because we only write blobs for browser storage projects
        let thumbnail = (0, $94f0b2b810d4d191$export$5bcd6e94ed871c88)(raw.thumbnail) ? raw.thumbnail : undefined;
        thumbnail = thumbnail ?? await $37813638caeb4048$var$createFallbackThumbnail();
        return {
            projectId: raw.projectId ?? (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)(),
            timestamp: raw.timestamp,
            thumbnail: thumbnail
        };
    }
    async lowLevelRead() {
        const transactionResult = await (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).runTransaction([
            (0, $f603d6ecd683b596$export$cb74a94e2496f165),
            (0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e)
        ], 'readonly', async (transaction)=>{
            const raw = await transaction.get((0, $f603d6ecd683b596$export$cb74a94e2496f165), 1);
            if (!raw) return undefined;
            const imageDataIds = [
                ...new Set($37813638caeb4048$export$a03da4173e824dd3(raw))
            ];
            return {
                imageDataById: await transaction.bulkGet((0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e), imageDataIds),
                raw: raw
            };
        });
        if (!transactionResult) return undefined;
        let thumbnail = $37813638caeb4048$export$a2a26d8de8cf9775(transactionResult.raw.thumbnail) ? transactionResult.imageDataById.get(transactionResult.raw.thumbnail.id) : transactionResult.raw.thumbnail;
        // for now ignores the ImageData case because we only write blobs for browser storage projects
        thumbnail = (0, $94f0b2b810d4d191$export$5bcd6e94ed871c88)(thumbnail) ? thumbnail : undefined;
        thumbnail = thumbnail ?? await $37813638caeb4048$var$createFallbackThumbnail();
        const layers = transactionResult.raw.layers.map((layer)=>{
            const storedBlob = $37813638caeb4048$export$a2a26d8de8cf9775(layer.blob) ? transactionResult.imageDataById.get(layer.blob.id) : layer.blob;
            return {
                ...layer,
                isVisible: layer.isVisible ?? true,
                mixModeStr: (0, $60b53242b35ddd35$export$21e46d5143f188b8)(layer.mixModeStr),
                hasClipping: layer.hasClipping ?? false,
                // for now ignores the ImageData case because we only write blobs for browser storage projects
                blob: (0, $94f0b2b810d4d191$export$5bcd6e94ed871c88)(storedBlob) ? storedBlob : undefined
            };
        });
        return {
            ...transactionResult.raw,
            projectId: transactionResult.raw.projectId ?? (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)(),
            thumbnail: thumbnail,
            layers: layers
        };
    }
    async lowLevelClear() {
        await (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).runTransaction([
            (0, $f603d6ecd683b596$export$cb74a94e2496f165),
            (0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e)
        ], 'readwrite', async (transaction)=>{
            const rawOld = await transaction.get((0, $f603d6ecd683b596$export$cb74a94e2496f165), 1);
            await transaction.remove((0, $f603d6ecd683b596$export$cb74a94e2496f165), 1);
            if (rawOld) await transaction.bulkRemove((0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e), $37813638caeb4048$export$a03da4173e824dd3(rawOld));
        });
    }
    emit(meta) {
        this.currentMeta = meta ? {
            ...meta
        } : undefined;
        this.listeners.forEach((item)=>{
            item.onUpdate(meta);
        });
    }
    updateTimestamp() {
        (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem('indexedDbUpdatedAt', '' + Date.now());
    }
    async update() {
        try {
            this.emit(await this.readMeta());
        } catch (e) {
            if (e instanceof Error && e.message.indexOf('db-error') === 0) this.isAvailable = false;
        }
    }
    async read() {
        let storageProject;
        try {
            storageProject = await this.lowLevelRead();
        } catch (e) {
            this.isAvailable = false;
            throw new Error('db-error: ' + e);
        }
        if (!storageProject) return undefined;
        let result;
        try {
            result = await (0, $5ce1a52596b51fa5$export$f3c1ac6650038646).readStorageProject(storageProject);
        } catch (e) {
            throw new Error('format-error: ' + e);
        }
        return result;
    }
    async readMeta() {
        let blobMeta;
        try {
            blobMeta = await this.lowLevelReadMeta();
        } catch (e) {
            this.isAvailable = false;
            throw new Error('db-error: ' + e);
        }
        if (!blobMeta) return undefined;
        let result;
        try {
            result = await (0, $5ce1a52596b51fa5$export$f3c1ac6650038646).readStorageMeta(blobMeta);
        } catch (e) {
            throw new Error('format-error: ' + e);
        }
        return result;
    }
    async store(project) {
        try {
            const storageProject = await (0, $5ce1a52596b51fa5$export$f3c1ac6650038646).createStorageProject(project);
            await this.lowLevelStore(storageProject);
        } catch (e) {
            this.isAvailable = false;
            throw new Error('db-error: ' + e);
        }
        this.updateTimestamp();
        setTimeout(async ()=>{
            const meta = await this.readMeta();
            this.emit(meta);
        });
    }
    async clear() {
        await this.lowLevelClear();
        this.updateTimestamp();
        setTimeout(()=>this.emit(), 0);
    }
    subscribe(listener) {
        if (this.listeners.includes(listener)) return;
        this.listeners.push(listener);
    }
    unsubscribe(listener) {
        for(let i = 0; i < this.listeners.length; i++)if (listener === this.listeners[i]) {
            this.listeners.splice(i, 1);
            return;
        }
    }
    getIsAvailable() {
        this.isAvailable = this.isAvailable && (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).getIsAvailable();
        return this.isAvailable;
    }
    getCurrentMeta() {
        return this.currentMeta;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.listeners = [];
        this.isAvailable = true;
        if (!(0, $f603d6ecd683b596$export$8d693ea241b9d9a6).getIsAvailable()) {
            this.isAvailable = false;
            return;
        }
        window.addEventListener('storage', async (e)=>{
            if (e.key !== 'indexedDbUpdatedAt' || this.listeners.length === 0) return;
            await this.update();
        });
    }
}




























function $1923b022c61aeb20$export$23589fbad773081d(recovery) {
    return [
        recovery.thumbnail,
        ...recovery.layers.flatMap((layer)=>layer.image.flatMap((tile)=>(0, $2bd547100370cd3c$export$dba0834b723f37f4)(tile) ? [] : [
                    tile.id
                ]))
    ];
}
function $1923b022c61aeb20$export$68db238a9f09e565(composed, thumbnail, previousRecovery) {
    const previousImageDataIdSet = new Set(previousRecovery ? $1923b022c61aeb20$export$23589fbad773081d(previousRecovery) : []);
    // create the recovery layers and image data entries, and sum up the memory use
    const layers = [];
    const imageDataEntries = [
        {
            key: thumbnail.id,
            value: thumbnail.data
        }
    ];
    let memoryEstimateBytes = (0, $9b522b7d78a163d0$export$d295ad2aaa1da9f9)(thumbnail.data);
    const sortedComposedLayers = Object.values(composed.layerMap).sort((0, $6b58556e30cebed5$export$87eabc555ccfbb9f));
    for (const composedLayer of sortedComposedLayers){
        const image = [];
        for (const tile of composedLayer.tiles)if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(tile)) {
            memoryEstimateBytes += (0, $9b522b7d78a163d0$export$7e1e7fdda5538f3d)(tile.fill);
            image.push(tile);
        } else {
            imageDataEntries.push({
                key: tile.id,
                value: tile.data
            });
            const size = (0, $9b522b7d78a163d0$export$d295ad2aaa1da9f9)(tile.data);
            memoryEstimateBytes += size;
            image.push({
                id: tile.id,
                sizeBytes: size
            });
        }
        layers.push({
            name: composedLayer.name,
            isVisible: composedLayer.isVisible,
            opacity: composedLayer.opacity,
            mixModeStr: composedLayer.mixModeStr,
            hasClipping: composedLayer.hasClipping,
            image: image
        });
    }
    const newImageDataEntries = imageDataEntries.filter((item)=>!previousImageDataIdSet.has(item.key));
    const obsoleteImageDataIds = [
        ...previousImageDataIdSet.difference(new Set(imageDataEntries.map((item)=>item.key)))
    ];
    return {
        recovery: {
            projectId: composed.projectId.value,
            width: composed.size.width,
            height: composed.size.height,
            timestamp: Date.now(),
            thumbnail: thumbnail.id,
            layers: layers,
            memoryEstimateBytes: memoryEstimateBytes
        },
        newImageDataEntries: newImageDataEntries,
        obsoleteImageDataIds: obsoleteImageDataIds
    };
}
function $1923b022c61aeb20$var$throwIfAborted(signal) {
    if (signal?.aborted) throw (0, $94f0b2b810d4d191$export$bb3ff0b2339c52db)(signal);
}
async function $1923b022c61aeb20$var$deserializeImageDataTile(id, readResult, commonCtx, expectedSize) {
    let imageData;
    if ((0, $94f0b2b810d4d191$export$5bcd6e94ed871c88)(readResult)) {
        const result = await (0, $94f0b2b810d4d191$export$77f9e426014f6edd)(async ()=>{
            const image = await (0, $2e475852c551fcab$export$99cbfa07c2ec1e27)(readResult);
            (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(commonCtx.canvas, image.width, image.height, {
                ensureCleared: true
            });
            commonCtx.drawImage(image, 0, 0);
            return commonCtx.getImageData(0, 0, image.width, image.height);
        });
        if (result instanceof ImageData) imageData = result;
    } else imageData = readResult;
    if (imageData?.width === expectedSize.width && imageData.height === expectedSize.height) // all good
    return {
        id: id,
        data: imageData
    };
    // Either no imageData, or imageData has wrong size.
    // Before 0.10.2 it was possible that the blend brush created tiles of the wrong size (always HISTORY_TILE_SIZE).
    // We fix those here, so nothing breaks.
    (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(commonCtx.canvas, expectedSize.width, expectedSize.height, {
        ensureCleared: true
    });
    if (imageData) {
        // fixing tile with wrong size
        commonCtx.putImageData(imageData, 0, 0);
        return {
            id: id,
            data: commonCtx.getImageData(0, 0, expectedSize.width, expectedSize.height)
        };
    }
    // If we fail to load the tile, we still create an image data tile with the same ID.
    // This has the advantage that it might still get restored another time (if the user does not change it).
    // A layer fill tile would always overwrite the image data tile on the next store, causing a permanent loss.
    return {
        id: id,
        data: commonCtx.getImageData(0, 0, expectedSize.width, expectedSize.height)
    };
}
async function $1923b022c61aeb20$export$c544233adbfa53ac(readResult, signal) {
    $1923b022c61aeb20$var$throwIfAborted(signal);
    const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas((0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6));
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    const layers = [];
    for (const layer of readResult.recovery.layers){
        const deserializedTiles = [];
        for (const [tileIndex, tile] of layer.image.entries()){
            $1923b022c61aeb20$var$throwIfAborted(signal);
            if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(tile)) deserializedTiles.push(tile);
            else deserializedTiles.push(await $1923b022c61aeb20$var$deserializeImageDataTile(tile.id, readResult.imageDataById.get(tile.id), ctx, (0, $aab5cae708a98039$export$c849c66042090269)(tileIndex, readResult.recovery)));
        }
        layers.push({
            ...layer,
            mixModeStr: (0, $60b53242b35ddd35$export$21e46d5143f188b8)(layer.mixModeStr),
            hasClipping: layer.hasClipping ?? false,
            image: deserializedTiles
        });
    }
    $1923b022c61aeb20$var$throwIfAborted(signal);
    const thumbnail = await $1923b022c61aeb20$export$18c7093318f1ea61(readResult.imageDataById.get(readResult.recovery.thumbnail));
    return {
        project: {
            projectId: readResult.recovery.projectId ?? (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)(),
            width: readResult.recovery.width,
            height: readResult.recovery.height,
            layers: layers
        },
        timestamp: 0,
        thumbnail: thumbnail
    };
}
async function $1923b022c61aeb20$export$18c7093318f1ea61(readResult) {
    const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas((0, $211b564339712990$export$f7bc58374d6bc9b6), (0, $211b564339712990$export$f7bc58374d6bc9b6));
    const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
    if (!readResult) return canvas;
    if ((0, $94f0b2b810d4d191$export$5bcd6e94ed871c88)(readResult)) {
        await (0, $94f0b2b810d4d191$export$77f9e426014f6edd)(async ()=>{
            const image = await (0, $2e475852c551fcab$export$99cbfa07c2ec1e27)(readResult);
            (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(canvas, image.width, image.height);
            ctx.drawImage(image, 0, 0);
        });
        return canvas;
    }
    (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(canvas, readResult.width, readResult.height);
    ctx.putImageData(readResult, 0, 0);
    return canvas;
}


function $35310ea0297174f0$var$genNewId(takenIds) {
    const limit = 1000;
    const idSet = new Set(takenIds);
    const pool = (0, $94f0b2b810d4d191$export$7f1ebd623f131021)(limit, 0).map((_, index)=>index).filter((id)=>!idSet.has(id));
    const index = Math.floor(Math.random() * pool.length);
    if (pool[index] === undefined) {
        // just pick a larger number if nothing left. 1000, then 1001, then 1002, ...
        const largest = Math.max(...takenIds);
        return largest + 1;
    }
    return pool[index];
}
async function $35310ea0297174f0$var$getRecoveryEntriesInTransaction(transaction) {
    const records = await transaction.getAllRecords((0, $f603d6ecd683b596$export$aa8c311c20a0e91f));
    return records.map(({ key: key, value: value })=>({
            id: key,
            recovery: value
        }));
}
async function $35310ea0297174f0$var$removeOrphansInTransaction(transaction, // only the candidates will be removed that are actually orphans
imageDataCandidateIds) {
    // get all image data ids
    const allIds = imageDataCandidateIds ? imageDataCandidateIds : await transaction.getAllKeys((0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e));
    if (allIds.length === 0) return;
    // determine which ids are used in recoveries
    const recoveries = await transaction.getAll((0, $f603d6ecd683b596$export$aa8c311c20a0e91f));
    const usedIds = recoveries.flatMap((0, $1923b022c61aeb20$export$23589fbad773081d));
    // determine which ids are used in browser storage
    const browserStorageRaw = await transaction.get((0, $f603d6ecd683b596$export$cb74a94e2496f165), 1);
    if (browserStorageRaw) usedIds.push(...(0, $37813638caeb4048$export$a03da4173e824dd3)(browserStorageRaw));
    // remove unused ones
    const unusedIds = [
        ...new Set(allIds).difference(new Set(usedIds))
    ];
    await transaction.bulkRemove((0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e), unusedIds);
}
async function $35310ea0297174f0$export$4484d7cddf79b0c1(candidateIds) {
    await (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).runTransaction([
        (0, $f603d6ecd683b596$export$aa8c311c20a0e91f),
        (0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e),
        (0, $f603d6ecd683b596$export$cb74a94e2496f165)
    ], 'readwrite', (transaction)=>$35310ea0297174f0$var$removeOrphansInTransaction(transaction, candidateIds));
}
async function $35310ea0297174f0$export$907f896f070645af() {
    const oldestAllowedTimestamp = Date.now() - (0, $cc19f288fbbad83c$export$9c6f65e1c28cc08e);
    await (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).runTransaction([
        (0, $f603d6ecd683b596$export$aa8c311c20a0e91f),
        (0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e),
        (0, $f603d6ecd683b596$export$cb74a94e2496f165)
    ], 'readwrite', async (transaction)=>{
        const entries = await $35310ea0297174f0$var$getRecoveryEntriesInTransaction(transaction);
        const expiredEntries = entries.filter(({ recovery: recovery })=>recovery.timestamp < oldestAllowedTimestamp);
        if (expiredEntries.length === 0) return;
        await transaction.bulkRemove((0, $f603d6ecd683b596$export$aa8c311c20a0e91f), expiredEntries.map(({ id: id })=>id));
        await $35310ea0297174f0$var$removeOrphansInTransaction(transaction, expiredEntries.flatMap(({ recovery: recovery })=>(0, $1923b022c61aeb20$export$23589fbad773081d)(recovery)));
    });
}
async function $35310ea0297174f0$export$204730d36a05adf9(excludedRecoveryIds) {
    const excludedIdSet = new Set(excludedRecoveryIds.map((item)=>item.toString()));
    const readResult = await (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).runTransaction([
        (0, $f603d6ecd683b596$export$aa8c311c20a0e91f),
        (0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e)
    ], 'readonly', async (transaction)=>{
        const entries = await $35310ea0297174f0$var$getRecoveryEntriesInTransaction(transaction);
        const entriesWithThumbnail = entries.filter(({ id: id })=>!excludedIdSet.has(id));
        const thumbnailIds = entriesWithThumbnail.map(({ recovery: recovery })=>recovery.thumbnail);
        return {
            entries: entries,
            entriesWithThumbnail: entriesWithThumbnail,
            thumbnailDataById: await transaction.bulkGet((0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e), thumbnailIds)
        };
    });
    const metas = await Promise.all(readResult.entriesWithThumbnail.map(async ({ id: id, recovery: recovery })=>({
            id: id,
            thumbnail: readResult.thumbnailDataById.get(recovery.thumbnail),
            /*thumbnail: await deserializeRecoveryThumbnail(
                readResult.thumbnailDataById.get(recovery.thumbnail),
            ),*/ timestamp: recovery.timestamp,
            memoryEstimateBytes: recovery.memoryEstimateBytes
        })));
    return {
        metas: metas,
        totalMemoryUsedBytes: readResult.entries.reduce((sum, { recovery: recovery })=>sum + recovery.memoryEstimateBytes, 0)
    };
}
const $35310ea0297174f0$var$debugSlowLoading = false;
async function $35310ea0297174f0$export$e38e2ce4214240f6(id, signal) {
    const transactionResult = await (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).runTransaction([
        (0, $f603d6ecd683b596$export$aa8c311c20a0e91f),
        (0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e)
    ], 'readwrite', async (transaction)=>{
        if ($35310ea0297174f0$var$debugSlowLoading) {
            // DEBUG: Keep the transaction busy to explore slow recovery loading and cancellation.
            const debugEndTimestamp = Date.now() + 20000;
            while(Date.now() < debugEndTimestamp)await transaction.get((0, $f603d6ecd683b596$export$aa8c311c20a0e91f), id.toString());
        }
        const recoveryIds = (await transaction.getAllKeys((0, $f603d6ecd683b596$export$aa8c311c20a0e91f))).map((id)=>id.toString());
        const oldId = id.toString();
        const recovery = await transaction.get((0, $f603d6ecd683b596$export$aa8c311c20a0e91f), oldId);
        if (recovery) // remove the old one before storing the new one
        await transaction.remove((0, $f603d6ecd683b596$export$aa8c311c20a0e91f), oldId);
        else return undefined;
        const newId = $35310ea0297174f0$var$genNewId(recoveryIds.map((id)=>+id));
        const updatedRecovery = {
            ...recovery,
            timestamp: Date.now(),
            layers: recovery.layers.map((layer)=>({
                    ...layer,
                    hasClipping: layer.hasClipping ?? false
                }))
        };
        // We lazily write in the same format we just read, otherwise this would be more effort. Should be fine.
        await transaction.set((0, $f603d6ecd683b596$export$aa8c311c20a0e91f), newId.toString(), updatedRecovery);
        return {
            newId: newId,
            data: {
                recovery: updatedRecovery,
                imageDataById: await transaction.bulkGet((0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e), (0, $1923b022c61aeb20$export$23589fbad773081d)(updatedRecovery))
            }
        };
    }, signal ? {
        signal: signal
    } : undefined);
    if (!transactionResult) return {
        status: 'not-found'
    };
    return {
        status: 'success',
        newId: transactionResult.newId,
        data: transactionResult.data
    };
}
async function $35310ea0297174f0$export$b9ecabbf4820fa1b(tabId, composed, getThumbnail) {
    // prepare the thumbnail. less transaction blocking
    const fit = (0, $94f0b2b810d4d191$export$fa55905620c22535)(composed.size.width, composed.size.height, (0, $cc19f288fbbad83c$export$b5a0d0be1c619a31), (0, $cc19f288fbbad83c$export$c9c3d910b57c6d44));
    const thumbCanvas = getThumbnail(fit.width / composed.size.width);
    const thumbCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(thumbCanvas);
    const thumbImageData = {
        id: (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)(),
        data: thumbCtx.getImageData(0, 0, thumbCanvas.width, thumbCanvas.height)
    };
    return (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).runTransaction([
        (0, $f603d6ecd683b596$export$aa8c311c20a0e91f),
        (0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e),
        (0, $f603d6ecd683b596$export$cb74a94e2496f165)
    ], 'readwrite', async (transaction)=>{
        // get the existing recoveries and resolve the id to store under
        const recoveryEntries = await $35310ea0297174f0$var$getRecoveryEntriesInTransaction(transaction);
        const resolvedTabId = tabId ?? $35310ea0297174f0$var$genNewId(recoveryEntries.map(({ id: id })=>+id));
        const storedRecovery = recoveryEntries.find(({ id: id })=>id === resolvedTabId.toString())?.recovery;
        // serialize the project and collect new image data to store
        const { recovery: recovery, newImageDataEntries: newImageDataEntries, obsoleteImageDataIds: obsoleteImageDataIds } = (0, $1923b022c61aeb20$export$68db238a9f09e565)(composed, thumbImageData, storedRecovery);
        // if the new total size exceeds the limit, remove the oldest other recoveries
        const otherRecoveryEntries = recoveryEntries.filter((entry)=>entry.id !== resolvedTabId.toString());
        const otherRecoveriesBytes = otherRecoveryEntries.reduce((sum, entry)=>sum + entry.recovery.memoryEstimateBytes, 0);
        const toRemoveRecoveryIds = [];
        const toRemoveImageDataIds = [];
        const overLimitByBytes = otherRecoveriesBytes + recovery.memoryEstimateBytes - (0, $cc19f288fbbad83c$export$2740edb783d24e35);
        if (overLimitByBytes > 0) {
            let toRemoveBytes = 0;
            const oldestFirstEntries = otherRecoveryEntries.sort((a, b)=>a.recovery.timestamp - b.recovery.timestamp);
            for (const entry of oldestFirstEntries){
                if (toRemoveBytes >= overLimitByBytes) break;
                toRemoveRecoveryIds.push(entry.id);
                toRemoveImageDataIds.push(...(0, $1923b022c61aeb20$export$23589fbad773081d)(entry.recovery));
                toRemoveBytes += entry.recovery.memoryEstimateBytes;
            }
        }
        // update the recoveries and image data atomically
        await transaction.bulkRemove((0, $f603d6ecd683b596$export$aa8c311c20a0e91f), toRemoveRecoveryIds);
        await transaction.bulkSet((0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e), newImageDataEntries);
        await transaction.set((0, $f603d6ecd683b596$export$aa8c311c20a0e91f), resolvedTabId.toString(), recovery);
        await $35310ea0297174f0$var$removeOrphansInTransaction(transaction, [
            ...obsoleteImageDataIds,
            ...toRemoveImageDataIds
        ]);
        return resolvedTabId;
    });
}
async function $35310ea0297174f0$export$9c7685b8d5826628(id) {
    await (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).runTransaction([
        (0, $f603d6ecd683b596$export$aa8c311c20a0e91f),
        (0, $f603d6ecd683b596$export$ca20f3c4ac3fef1e),
        (0, $f603d6ecd683b596$export$cb74a94e2496f165)
    ], 'readwrite', async (transaction)=>{
        const recovery = await transaction.get((0, $f603d6ecd683b596$export$aa8c311c20a0e91f), id);
        if (!recovery) return;
        await transaction.remove((0, $f603d6ecd683b596$export$aa8c311c20a0e91f), id);
        await $35310ea0297174f0$var$removeOrphansInTransaction(transaction, (0, $1923b022c61aeb20$export$23589fbad773081d)(recovery));
    });
}






const $c7ee49b4041304a6$var$originId = (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)();
class $c7ee49b4041304a6$export$84f7c9d87f70395e {
    getLsKey() {
        return this.localStoragePrefix + this.name;
    }
    getEntries() {
        let entries = [];
        try {
            const raw = (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem(this.getLsKey());
            if (raw !== null) {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) entries = parsed;
            }
        } catch (error) {
            // invalid value -> reset
            (0, $7a8f101d3676d17a$export$19fffca37ef3e106).removeItem(this.getLsKey());
        }
        return entries;
    }
    postMessage(message) {
        if (this.broadcastChannel) this.broadcastChannel.postMessage(message);
        else {
            const now = Date.now();
            const entries = this.getEntries().filter((entry)=>{
                // delete old entries
                return entry.timestamp > now - this.maxAgeMs;
            });
            entries.push({
                timestamp: now,
                originId: $c7ee49b4041304a6$var$originId,
                message: message
            });
            (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem(this.getLsKey(), JSON.stringify(entries));
        }
    }
    subscribe(listener) {
        if (this.broadcastChannel) {
            const nativeListener = (message)=>listener(message.data);
            this.broadcastChannelListeners.add({
                nativeListener: nativeListener,
                listener: listener
            });
            this.broadcastChannel.addEventListener('message', nativeListener);
        } else {
            if (this.localStorageListeners.size === 0) window.addEventListener('storage', this.onLocalStorageChange);
            this.localStorageListeners.add(listener);
        }
    }
    unsubscribe(listener) {
        if (this.broadcastChannel) {
            const match = [
                ...this.broadcastChannelListeners
            ].find((item)=>item.listener === listener);
            if (match) {
                this.broadcastChannel.removeEventListener('message', match.nativeListener);
                this.broadcastChannelListeners.delete(match);
            }
        } else {
            this.localStorageListeners.delete(listener);
            if (this.localStorageListeners.size === 0) window.removeEventListener('storage', this.onLocalStorageChange);
        }
    }
    close() {
        if (this.broadcastChannel) this.broadcastChannel.close();
        else if (this.localStorageListeners.size > 0) {
            window.removeEventListener('storage', this.onLocalStorageChange);
            this.localStorageListeners.clear();
        }
    }
    // ----------------------------------- public ----------------------------------
    constructor(name){
        this.name = name;
        this.broadcastChannelListeners = new Set();
        this.lastReadTimestamp = Date.now();
        this.maxAgeMs = 5000;
        this.localStoragePrefix = 'cross-tab-channel--';
        this.localStorageListeners = new Set();
        this.onLocalStorageChange = (e)=>{
            if (e.key !== this.getLsKey() || e.newValue === null) // case 1: irrelevant key changed
            // case 2: null means no new message
            // -> noop
            return;
            try {
                const entries = JSON.parse(e.newValue);
                entries.forEach((entry)=>{
                    if (entry.originId === $c7ee49b4041304a6$var$originId || entry.timestamp <= this.lastReadTimestamp) // ignore messages from our own tab, or that aren't new
                    return;
                    this.lastReadTimestamp = entry.timestamp;
                    this.localStorageListeners.forEach((listener)=>listener(entry.message));
                });
            } catch (error) {
                // probably invalid value -> reset
                (0, $7a8f101d3676d17a$export$19fffca37ef3e106).removeItem(this.getLsKey());
            }
        };
        if (typeof BroadcastChannel !== 'undefined') this.broadcastChannel = new BroadcastChannel(name);
    }
}



var $7c2e67a7cc9b2390$exports = {};
$7c2e67a7cc9b2390$exports = $parcel$resolve("i0cln");


const $cc19f288fbbad83c$export$b5a0d0be1c619a31 = 300;
const $cc19f288fbbad83c$export$c9c3d910b57c6d44 = 180;
const $cc19f288fbbad83c$export$9c6f65e1c28cc08e = 604800000; // 1 week
const $cc19f288fbbad83c$export$2740edb783d24e35 = 1e9;
const $cc19f288fbbad83c$var$FIRST_RECOVERY_AFTER_MS = 300000;
const $cc19f288fbbad83c$export$9bd5f64d90351bc8 = 8;
const $cc19f288fbbad83c$var$SUBSEQUENT_RECOVERY_AFTER_MS = 60000;
const $cc19f288fbbad83c$var$SUBSEQUENT_RECOVERY_AFTER_CHANGES = 4;
const $cc19f288fbbad83c$export$c72bbe997bb2ffd = false;
const $cc19f288fbbad83c$export$fc41dada2b63b3f2 = false;
const $cc19f288fbbad83c$export$9c5176374bfc8851 = false;
function $cc19f288fbbad83c$export$42c3f3255a992e7(value) {
    if (value === undefined) {
        history.replaceState(null, '', ' ');
        return;
    }
    // avoid creating a new history state
    history.replaceState(null, '', window.location.origin + window.location.pathname + window.location.search + '#' + value);
}
function $cc19f288fbbad83c$var$getHash() {
    // returns without the "#"
    return window.location.hash ? window.location.hash.substring(1) : undefined;
}
const $cc19f288fbbad83c$var$ignoredHashes = [
    'licenses'
];
function $cc19f288fbbad83c$var$hashToTabId(rawHash) {
    if (rawHash === undefined || $cc19f288fbbad83c$var$ignoredHashes.includes(rawHash)) return undefined;
    const num = +rawHash;
    if (isNaN(num) || num < 0 || num % 1 !== 0) return undefined;
    return num;
}
class $cc19f288fbbad83c$export$36c5c4b26ead79bd {
    setIsStoring(isStoring) {
        this.isStoring = isStoring;
        $cc19f288fbbad83c$export$9c5176374bfc8851 && $cc19f288fbbad83c$var$showSyncIndicator(isStoring);
    }
    announceTabId() {
        this.crossTabChannel.postMessage({
            type: 'new-tab'
        });
    }
    delayedUpdate() {
        clearTimeout(this.updateTimeout);
        // timeout makes it more likely it can register that a tab was closed
        this.updateTimeout = setTimeout(()=>{
            this.updateTimeout = undefined;
            this.update();
        }, 500);
    }
    initListeners() {
        document.addEventListener('visibilitychange', ()=>{
            if (document.hidden) return;
            // changes may have happened since tab last visible
            this.delayedUpdate();
        });
        window.addEventListener('focus', ()=>{
            // Imagine you have two windows with the app open. You work in one, then focus the other window
            // and work there. Changes may have happened.
            this.delayedUpdate();
        });
        this.crossTabChannel.subscribe((message)=>{
            if (message.type === 'new-tab') {
                if (document.hidden) // we'll update when tab visible. noop.
                return;
                this.delayedUpdate();
            }
            if (message.type === 'request-ids') {
                if (this.tabId !== undefined) this.crossTabChannel.postMessage({
                    type: 'response-ids',
                    id: this.tabId
                });
            }
        });
    }
    async emitUpdate() {
        if (!(0, $f603d6ecd683b596$export$8d693ea241b9d9a6).getIsAvailable()) return;
        const otherTabIds = await this.getIdsFromTabs();
        const idsToExclude = $cc19f288fbbad83c$export$c72bbe997bb2ffd ? [] : [
            ...otherTabIds,
            ...this.tabId === undefined ? [] : [
                this.tabId
            ]
        ];
        const { metas: metas, totalMemoryUsedBytes: totalMemoryUsedBytes } = await (0, $35310ea0297174f0$export$204730d36a05adf9)(idsToExclude);
        this.listeners.forEach((listener)=>{
            listener(metas, totalMemoryUsedBytes);
        });
    }
    setHash(id) {
        $cc19f288fbbad83c$export$42c3f3255a992e7(id === undefined ? undefined : '' + id);
        this.announceTabId();
    }
    async getIdsFromTabs() {
        this.crossTabChannel.postMessage({
            type: 'request-ids'
        });
        const result = [];
        const onMessage = (message)=>{
            if (message.type === 'response-ids') result.push(+message.id);
        };
        this.crossTabChannel.subscribe(onMessage);
        await (0, $94f0b2b810d4d191$export$e772c8ff12451969)(100);
        this.crossTabChannel.unsubscribe(onMessage);
        return result;
    }
    async getRecovery(signal) {
        try {
            // is there a tabId?
            const initialTabId = $cc19f288fbbad83c$var$hashToTabId($cc19f288fbbad83c$var$getHash());
            if (initialTabId === undefined) {
                this.noRecoveryReason = 'noTabIdHash';
                // we get a tabId later
                return undefined;
            }
            // is there another tab with the same tabId?
            const openTabIds = await this.getIdsFromTabs();
            if (openTabIds.includes(initialTabId)) {
                this.noRecoveryReason = 'alreadyOpened';
                // Already exists -> unset tabId. Nothing to load.
                this.setHash(undefined);
                return undefined;
            }
            const recoveryResult = await (0, $35310ea0297174f0$export$e38e2ce4214240f6)(initialTabId, signal);
            if (recoveryResult.status === 'not-found') {
                this.noRecoveryReason = 'idNotFound';
                this.setHash(undefined);
                return undefined;
            }
            this.setHash(recoveryResult.newId);
            const result = await (0, $1923b022c61aeb20$export$c544233adbfa53ac)(recoveryResult.data, signal);
            // Everything ready at this point. So we can ignore abort signal.
            this.tabId = recoveryResult.newId;
            return result;
        } finally{
            if (!signal?.aborted) // don't disrupt loading
            setTimeout(()=>{
                // Older versions of the app didn't have atomized transactions, leading to orphans sometimes.
                // Also, you never know if the current code has bugs, which could also create orphans.
                (0, $35310ea0297174f0$export$4484d7cddf79b0c1)();
            }, 2000);
        }
    }
    setKlHistory(klHistory) {
        this.klHistory = klHistory;
        let startTime = Date.now();
        let lastStoredChangeCount = 0;
        const checkAndMaybeStore = async ()=>{
            if (this.isStoring) return;
            const changeCount = this.klHistory.getChangeCount();
            if (!$cc19f288fbbad83c$export$fc41dada2b63b3f2) {
                const deltaMs = Date.now() - startTime;
                if (this.tabId === undefined && (deltaMs < $cc19f288fbbad83c$var$FIRST_RECOVERY_AFTER_MS || changeCount < $cc19f288fbbad83c$export$9bd5f64d90351bc8)) // initial store threshold not reached
                return;
                if (this.tabId !== undefined && (deltaMs < $cc19f288fbbad83c$var$SUBSEQUENT_RECOVERY_AFTER_MS || changeCount - lastStoredChangeCount < $cc19f288fbbad83c$var$SUBSEQUENT_RECOVERY_AFTER_CHANGES)) // subsequent store threshold not reached
                return;
            }
            // must set isStoring here, or high frequency history events may cause multiple recovery entries
            this.setIsStoring(true);
            const isFreshDrawing = this.tabId === undefined;
            try {
                this.tabId = await (0, $35310ea0297174f0$export$b9ecabbf4820fa1b)(this.tabId, this.klHistory.getComposed(), this.getThumbnail);
                startTime = Date.now();
            } catch (e) {
                (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
                return;
            } finally{
                this.setIsStoring(false);
            }
            if (isFreshDrawing) {
                this.setHash(this.tabId);
                await (0, $35310ea0297174f0$export$907f896f070645af)();
            }
            startTime = Date.now();
            lastStoredChangeCount = changeCount;
        };
        this.klHistory.addListener(checkAndMaybeStore);
        setInterval(checkAndMaybeStore, 60000);
    }
    setGetThumbnail(getThumbnail) {
        this.getThumbnail = getThumbnail;
    }
    subscribe(listener) {
        this.listeners.add(listener);
    }
    unsubscribe(listener) {
        this.listeners.delete(listener);
    }
    // re-checks what recoveries exist
    async update() {
        if (this.listeners.size > 0) await this.emitUpdate();
    }
    async remove(recoveryId) {
        await (0, $35310ea0297174f0$export$9c7685b8d5826628)('' + recoveryId);
        this.update();
    }
    getTabId() {
        return this.tabId;
    }
    getNoRecoveryReason() {
        return this.noRecoveryReason;
    }
    destroy() {
    // todo
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.klHistory = {};
        this.isStoring = false;
        this.listeners = new Set();
        this.crossTabChannel = new (0, $c7ee49b4041304a6$export$84f7c9d87f70395e)('kl-tab-communication');
        this.initListeners();
    }
}
const $cc19f288fbbad83c$var$showSyncIndicator = (()=>{
    let syncIndicator;
    return (isStoring)=>{
        if (!isStoring) {
            syncIndicator?.remove();
            syncIndicator = undefined;
            return;
        }
        syncIndicator = document.createElement('img');
        syncIndicator.src = (0, (/*@__PURE__*/$parcel$interopDefault($7c2e67a7cc9b2390$exports)));
        syncIndicator.alt = '';
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(syncIndicator, {
            position: 'fixed',
            top: 8,
            left: 8,
            zIndex: 2147483647,
            pointerEvents: 'none'
        });
        document.body.append(syncIndicator);
    };
})();




var $12691d222ecd00cc$export$48c2d0f2f545ac27;
$12691d222ecd00cc$export$48c2d0f2f545ac27 = `-c3MRW_preview`;






class $6edc7e9ba297094f$export$feb3da9ac0115d49 {
    async update(metas, totalMemoryUsedBytes) {
        this.destroyer.destroy();
        const elements = [];
        metas.sort((a, b)=>{
            if (a.timestamp > b.timestamp) return -1;
            if (a.timestamp < b.timestamp) return 1;
            return 0;
        }).forEach((meta)=>{
            const recoverBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'a',
                className: 'kl-button kl-button-link',
                content: (0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-recover'),
                props: {
                    href: '#' + meta.id,
                    target: '_blank'
                }
            });
            const deleteBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button kl-button-delete',
                content: [
                    (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('remove-layer', {
                        height: 20
                    }),
                    (0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-delete')
                ],
                destroyer: this.destroyer,
                onClick: ()=>{
                    deleteBtn.blur();
                    const thumbnail2 = (0, $be957da3610487e9$export$921068d8846a1559).el();
                    (async ()=>{
                        const preview = await (0, $1923b022c61aeb20$export$18c7093318f1ea61)(meta.thumbnail);
                        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview, {
                            alignSelf: 'start',
                            background: 'var(--kl-checkerboard-background)',
                            maxWidth: '100%'
                        });
                        thumbnail2.append(preview);
                    })();
                    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                        type: 'warning',
                        message: (0, $be957da3610487e9$export$921068d8846a1559).el({
                            content: [
                                (0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-delete-confirmation'),
                                thumbnail2
                            ],
                            css: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 10
                            }
                        }),
                        buttons: [
                            {
                                id: 'delete',
                                label: (0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-delete')
                            },
                            'Cancel'
                        ],
                        deleteButton: 'delete',
                        callback: async (result)=>{
                            if (result === 'Cancel') return;
                            await this.klRecoveryManager.remove(+meta.id);
                        }
                    });
                }
            });
            const previewWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'a',
                className: $12691d222ecd00cc$export$48c2d0f2f545ac27,
                title: (0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-recover'),
                css: {
                    minHeight: (0, $cc19f288fbbad83c$export$c9c3d910b57c6d44)
                },
                props: {
                    href: '#' + meta.id,
                    target: '_blank'
                }
            });
            (async ()=>{
                const preview = await (0, $1923b022c61aeb20$export$18c7093318f1ea61)(meta.thumbnail);
                previewWrapper.append(preview);
            })();
            const infoEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    (0, $f8f5a7dee6742712$export$1b9ca798405c9eb6)(meta.timestamp),
                    ', ' + (0, $be957da3610487e9$export$921068d8846a1559).round(meta.memoryEstimateBytes / 1000000, 1) + ' MB'
                ],
                css: {
                    textAlign: 'center'
                }
            });
            elements.push((0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    previewWrapper,
                    infoEl,
                    recoverBtn,
                    deleteBtn
                ],
                css: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 5,
                    maxWidth: '100%'
                }
            }));
        });
        this.rootEl.innerHTML = '';
        if (0, $cc19f288fbbad83c$export$c72bbe997bb2ffd) this.rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: 'Debug On - SHOWING ALL TABS',
            css: {
                background: 'red'
            }
        }));
        this.rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-explanation'),
            className: 'kl-toolspace-note'
        }), (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-total-quota-label') + ' ' + (0, $be957da3610487e9$export$921068d8846a1559).round(totalMemoryUsedBytes / 1000000, 1) + ' MB / ' + (0, $be957da3610487e9$export$921068d8846a1559).round((0, $cc19f288fbbad83c$export$2740edb783d24e35) / 1000000, 1) + ' MB',
            css: {
                margin: '10px 0'
            }
        }), (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                ...elements
            ],
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px 10px',
                justifyContent: 'space-evenly'
            }
        }));
        if (elements.length === 0) this.rootEl.append((0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-empty'));
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.klRecoveryManager.unsubscribe(this.recoveryListener);
        this.destroyer.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.recoveryListener = (metas, totalMemoryUsedBytes)=>{
            this.update(metas, totalMemoryUsedBytes);
        };
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.klRecoveryManager = p.klRecoveryManager;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('loading')
        });
        this.klRecoveryManager.subscribe(this.recoveryListener);
        const refresh = async ()=>{
            try {
                this.rootEl.innerHTML = '';
                this.rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'img',
                    props: {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7c2e67a7cc9b2390$exports))),
                        alt: ''
                    }
                }));
                await this.klRecoveryManager.update();
            } catch (error) {
                (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(error);
                const errorText = error instanceof Error ? `${error.name}: ${error.message}` : String(error);
                this.rootEl.innerHTML = '';
                this.rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
                    textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('error')
                }), (0, $be957da3610487e9$export$921068d8846a1559).el({
                    className: 'info-hint',
                    textContent: errorText,
                    css: {
                        marginTop: 5,
                        fontFamily: 'monospace',
                        overflowWrap: 'anywhere'
                    }
                }), (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'button',
                    className: 'kl-button',
                    textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('retry'),
                    destroyer: this.destroyer,
                    onClick: (e)=>{
                        e.target.disabled = true;
                        refresh();
                    }
                }));
            }
        };
        setTimeout(refresh);
    }
}




function $535b6511c750758d$export$abc0e2c9b0afece1(klRecoveryManager) {
    if (!klRecoveryManager || !(0, $f603d6ecd683b596$export$8d693ea241b9d9a6).getIsAvailable()) {
        (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-cant-access'));
        return;
    }
    const recoveryManager = new (0, $6edc7e9ba297094f$export$feb3da9ac0115d49)({
        klRecoveryManager: klRecoveryManager
    });
    const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
        content: [
            recoveryManager.getElement()
        ]
    });
    const modal = (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-recover-tabs')}</b>`,
        div: rootEl,
        buttons: [
            {
                id: 'close',
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('modal-close')
            }
        ],
        callback: ()=>{
            recoveryManager.destroy();
        },
        style: {
            width: 'calc(100% - 50px)',
            maxWidth: 1000,
            minWidth: 300,
            boxSizing: 'border-box'
        }
    });
}


var $268124c3c7684514$export$bd7a7a9fa7e7f04b;
$268124c3c7684514$export$bd7a7a9fa7e7f04b = `Tt6aiG_recoveryBubble`;




const $cde4cf070b2d06de$var$newImageImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('new-image');
const $cde4cf070b2d06de$var$exportImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('export');
const $cde4cf070b2d06de$var$shareImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('share');
const $cde4cf070b2d06de$var$uploadImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('upload');
const $cde4cf070b2d06de$var$importImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('import');
const $cde4cf070b2d06de$var$LS_SHOW_SAVE_DIALOG = 'kl-save-dialog';
const $cde4cf070b2d06de$var$createSpacer = ()=>{
    const el = document.createElement('div');
    const clearer = document.createElement('div');
    const line = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: 'grid-hr'
    });
    el.append(clearer, line);
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(clearer, {
        clear: 'both'
    });
    return el;
};
const $cde4cf070b2d06de$var$createButtonContent = (text, icon, noInvert)=>{
    return `<img ${noInvert ? 'class="dark-no-invert"' : ''} src='${icon}' alt='icon' height='20'/>${text}`;
};
class $cde4cf070b2d06de$export$409b892ffe02580b {
    refresh() {}
    getElement() {
        return this.rootEl;
    }
    setIsVisible(isVisible) {
        if (isVisible) {
            this.refresh();
            this.browserStorageUi?.show();
            if (this.klRecoveryManager) {
                this.klRecoveryManager.subscribe(this.recoveryListener);
                this.klRecoveryManager.update();
            }
        } else if (this.klRecoveryManager) this.klRecoveryManager.unsubscribe(this.recoveryListener);
    }
    triggerImport() {
        this.importInput && this.importInput.click();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.recoveryListener = (metas)=>{
            if (!this.recoveryCountBubble) return;
            const count = metas.length;
            if (count === 0) this.recoveryCountBubble.style.display = 'none';
            else {
                this.recoveryCountBubble.textContent = '' + count;
                this.recoveryCountBubble.style.display = 'inline-block';
            }
        };
        this.exportType = p.exportType;
        this.applyUncommitted = p.applyUncommitted;
        this.rootEl = document.createElement('div');
        const asyncCreation = ()=>{
            // --- hint ---
            const saveNote = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'kl-toolspace-note',
                textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('file-no-autosave'),
                css: {
                    margin: '10px 10px 0 10px'
                }
            });
            // --- new, import, save ---
            const newButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button grid-button',
                content: $cde4cf070b2d06de$var$createButtonContent((0, $fc42a07754814920$export$ce37e184d908d785)('file-new'), $cde4cf070b2d06de$var$newImageImg, true),
                props: {
                    tabIndex: -1
                },
                css: {
                    float: 'left'
                },
                onClick: ()=>p.onNewImage()
            });
            const importButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button grid-button',
                content: $cde4cf070b2d06de$var$createButtonContent((0, $fc42a07754814920$export$ce37e184d908d785)('file-import'), $cde4cf070b2d06de$var$importImg, true),
                css: {
                    position: 'relative',
                    cursor: 'pointer',
                    float: 'left'
                },
                props: {
                    tabIndex: -1
                },
                onClick: ()=>this.importInput.click()
            });
            this.importInput = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'input',
                css: {
                    display: 'none'
                },
                onChange: ()=>{
                    this.applyUncommitted();
                    this.importInput.files && p.onFileSelect(this.importInput.files, 'default');
                    this.importInput.value = '';
                },
                props: {
                    tabIndex: -1
                }
            });
            this.importInput.type = 'file';
            this.importInput.multiple = true;
            this.importInput.accept = 'image/*,.psd'; // .psd needed for chrome, although it's image/vnd.adobe.photoshop
            const saveButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button',
                content: $cde4cf070b2d06de$var$createButtonContent((0, $fc42a07754814920$export$ce37e184d908d785)('file-save'), $cde4cf070b2d06de$var$exportImg),
                props: {
                    tabIndex: -1
                },
                onClick: ()=>p.onSaveImageToComputer()
            });
            const canShowSaveDialog = 'showSaveFilePicker' in window;
            const showSaveDialogRaw = (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem($cde4cf070b2d06de$var$LS_SHOW_SAVE_DIALOG);
            const initialShowSaveDialog = showSaveDialogRaw === null ? false : showSaveDialogRaw === 'true';
            const saveDialogCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
                init: initialShowSaveDialog,
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('file-show-save-dialog'),
                callback: (value)=>{
                    if (value) (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem($cde4cf070b2d06de$var$LS_SHOW_SAVE_DIALOG, 'true');
                    else (0, $7a8f101d3676d17a$export$19fffca37ef3e106).removeItem($cde4cf070b2d06de$var$LS_SHOW_SAVE_DIALOG); // default is false
                    p.onChangeShowSaveDialog(value);
                },
                css: {
                    maxWidth: 'fit-content'
                },
                name: 'show-save-dialog'
            });
            p.onChangeShowSaveDialog(initialShowSaveDialog);
            // export filetype dropdown
            const exportTypeSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
                optionArr: [
                    [
                        'png',
                        'PNG'
                    ],
                    [
                        'jpg',
                        'JPG'
                    ],
                    [
                        'psd',
                        'PSD'
                    ],
                    [
                        'layers',
                        (0, $fc42a07754814920$export$ce37e184d908d785)('layers') + ' (PNG)'
                    ]
                ],
                initValue: this.exportType,
                onChange: (val)=>{
                    this.exportType = val;
                    p.onExportTypeChange(this.exportType);
                    p.onSaveImageToComputer();
                },
                title: (0, $fc42a07754814920$export$ce37e184d908d785)('file-format'),
                name: 'export-type'
            });
            // --- browser storage ---
            let browserStorageFallbackEl;
            if (p.projectStore) {
                this.browserStorageUi = new (0, $293199167ef511c0$export$9c72cf485ef46673)({
                    helpPath: p.helpPath,
                    projectStore: p.projectStore,
                    getProject: p.getProject,
                    applyUncommitted: this.applyUncommitted,
                    onOpen: p.onOpenBrowserStorage,
                    onStored: ()=>p.onStoredToBrowserStorage()
                });
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.browserStorageUi.getElement(), {
                    margin: 10
                });
            } else {
                const header = new (0, $38dbae5cb4c4bb3c$export$852ebaa1b01c8b5a)(p.helpPath);
                browserStorageFallbackEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    content: [
                        header.getElement(),
                        (0, $be957da3610487e9$export$921068d8846a1559).el({
                            content: "\uD83D\uDD34 " + (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-cant-access'),
                            css: {
                                marginTop: 10
                            }
                        })
                    ],
                    css: {
                        margin: '10px 10px 0 10px'
                    }
                });
            }
            const saveRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    (0, $be957da3610487e9$export$921068d8846a1559).el({
                        content: [
                            saveButton,
                            exportTypeSelect.getElement()
                        ],
                        css: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                            gap: 10
                        }
                    }),
                    ...canShowSaveDialog ? [
                        saveDialogCheckbox.getElement()
                    ] : []
                ],
                css: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                    margin: '10px 10px 0 10px'
                }
            });
            // --- recovery ---
            this.klRecoveryManager = p.klRecoveryManager;
            const recoveryWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({});
            this.recoveryCountBubble = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: $268124c3c7684514$export$bd7a7a9fa7e7f04b
            });
            const recoveryBrowserButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button',
                content: [
                    (0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-recover-tabs'),
                    this.recoveryCountBubble
                ],
                onClick: ()=>(0, $535b6511c750758d$export$abc0e2c9b0afece1)(this.klRecoveryManager),
                props: {
                    tabIndex: -1
                },
                css: {
                    margin: '10px 0 0 10px',
                    width: 'calc(100% - 20px)'
                }
            });
            recoveryWrapper.append(recoveryBrowserButton, $cde4cf070b2d06de$var$createSpacer());
            (async ()=>{
                if (!this.klRecoveryManager) return;
                this.klRecoveryManager.subscribe(this.recoveryListener);
                await this.klRecoveryManager.update();
                this.klRecoveryManager.unsubscribe(this.recoveryListener);
            })();
            // --- upload, share ---
            const shareButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button grid-button',
                content: $cde4cf070b2d06de$var$createButtonContent((0, $fc42a07754814920$export$ce37e184d908d785)('file-share'), $cde4cf070b2d06de$var$shareImg),
                props: {
                    tabIndex: -1
                },
                css: {
                    float: 'left'
                },
                onClick: ()=>{
                    shareButton.disabled = true;
                    p.onShareImage(()=>{
                        shareButton.disabled = false;
                    });
                }
            });
            const uploadImgurButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button grid-button',
                content: $cde4cf070b2d06de$var$createButtonContent((0, $fc42a07754814920$export$ce37e184d908d785)('file-upload'), $cde4cf070b2d06de$var$uploadImg),
                props: {
                    tabIndex: -1
                },
                css: {
                    float: 'left'
                },
                onClick: ()=>{
                    p.onUpload();
                }
            });
            (0, $be957da3610487e9$export$921068d8846a1559).append(this.rootEl, [
                saveNote,
                newButton,
                importButton,
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    css: {
                        clear: 'both'
                    }
                }),
                saveRow,
                $cde4cf070b2d06de$var$createSpacer(),
                this.browserStorageUi?.getElement(),
                browserStorageFallbackEl,
                $cde4cf070b2d06de$var$createSpacer(),
                recoveryWrapper,
                uploadImgurButton,
                (0, $be957da3610487e9$export$921068d8846a1559).canShareFiles() ? shareButton : undefined,
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    css: {
                        clear: 'both'
                    }
                })
            ]);
        };
        setTimeout(asyncCreation, 1);
    }
}







function $5fe79db1088ebcc2$export$d731e22ecd0c25d3(shader, uniforms, textureIn, textureOut) {
    const texture = this._.texture;
    const spareTexture = this._.spareTexture;
    if (texture === undefined || spareTexture === undefined) throw new Error('FX canvas is not initialized');
    (textureIn || texture).use();
    spareTexture.drawTo(function() {
        shader.uniforms(uniforms).drawRect();
    });
    spareTexture.swapWith(textureOut || texture);
}


let $56c020f64b9c3c25$export$5822a9d0880a5d82;
let $56c020f64b9c3c25$export$72a5a96ec5bfe017;
function $56c020f64b9c3c25$export$b59c6427db8463f4(newGl) {
    $56c020f64b9c3c25$export$72a5a96ec5bfe017 = newGl;
    $56c020f64b9c3c25$export$5822a9d0880a5d82 = newGl.gl;
}



const $4e0480503a88a2cb$var$defaultVertexSource = '\
    attribute vec2 vertex;\
    attribute vec2 _texCoord;\
    varying vec2 texCoord;\
    void main() {\
        texCoord = _texCoord;\
        gl_Position = vec4(vertex * 2.0 - 1.0, 0.0, 1.0);\
    }';
const $4e0480503a88a2cb$var$defaultFragmentSource = '\
    uniform sampler2D texture;\
    varying vec2 texCoord;\
    void main() {\
        gl_FragColor = texture2D(texture, texCoord);\
    }';
let $4e0480503a88a2cb$var$floatPrecision;
class $4e0480503a88a2cb$export$7d9b0d118d0c4108 {
    // ---- static ----
    static getDefaultShader() {
        (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).defaultShader ??= new $4e0480503a88a2cb$export$7d9b0d118d0c4108();
        return (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).defaultShader;
    }
    // ---- private ----
    compileSource(type, source, nameStr) {
        const shader = (0, $be957da3610487e9$export$921068d8846a1559).throwIfNull((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).createShader(type));
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).shaderSource(shader, source.replace(/#define.*/, '')); // glslify adds a line add the beginning that breaks it
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).compileShader(shader);
        if (!(0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getShaderParameter(shader, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).COMPILE_STATUS)) throw 'compile error: ' + nameStr + ' - ' + (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getShaderInfoLog(shader);
        return shader;
    }
    /**
     * HIGH_FLOAT | MEDIUM_FLOAT
     */ testPrecisionSupport(precisionType) {
        const format = (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getShaderPrecisionFormat((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FRAGMENT_SHADER, precisionType);
        return format !== null && format.precision !== 0;
    }
    destroy() {
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).deleteProgram(this.program);
        this.program = null;
    }
    uniforms(uniforms) {
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).useProgram(this.program);
        Object.entries(uniforms).forEach(([name, value])=>{
            const location = (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getUniformLocation(this.program, name);
            if (location === null) // will be null if the uniform isn't used in the shader
            return;
            if (Array.isArray(value)) switch(value.length){
                case 1:
                    (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).uniform1fv(location, new Float32Array(value));
                    break;
                case 2:
                    (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).uniform2fv(location, new Float32Array(value));
                    break;
                case 3:
                    (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).uniform3fv(location, new Float32Array(value));
                    break;
                case 4:
                    (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).uniform4fv(location, new Float32Array(value));
                    break;
                case 9:
                    (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).uniformMatrix3fv(location, false, new Float32Array(value));
                    break;
                case 16:
                    (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).uniformMatrix4fv(location, false, new Float32Array(value));
                    break;
                default:
                    throw 'don\'t know how to load uniform "' + name + '" of length ' + value.length;
            }
            else if (typeof value === 'number') (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).uniform1f(location, value);
            else throw 'attempted to set uniform "' + name + '" to invalid value ' + (value || 'undefined').toString();
        });
        // allow chaining
        return this;
    }
    //
    /**
     * textures are uniforms too but for some reason can't be specified by gl.uniform1f,
     * even though floating point numbers represent the integers 0 through 7 exactly
     */ textures(textures) {
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).useProgram(this.program);
        Object.entries(textures).forEach(([name, value])=>{
            (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).uniform1i((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getUniformLocation(this.program, name), value);
        });
        // allow chaining
        return this;
    }
    drawRect(left, top, right, bottom) {
        let undefined;
        const viewport = (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getParameter((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).VIEWPORT);
        top = top !== undefined ? (top - viewport[1]) / viewport[3] : 0;
        left = left !== undefined ? (left - viewport[0]) / viewport[2] : 0;
        right = right !== undefined ? (right - viewport[0]) / viewport[2] : 1;
        bottom = bottom !== undefined ? (bottom - viewport[1]) / viewport[3] : 1;
        (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).vertexBuffer ??= (0, $be957da3610487e9$export$921068d8846a1559).throwIfNull((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).createBuffer());
        const vertexBuffer = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).vertexBuffer;
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindBuffer((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).ARRAY_BUFFER, vertexBuffer);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bufferData((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).ARRAY_BUFFER, new Float32Array([
            left,
            top,
            left,
            bottom,
            right,
            top,
            right,
            bottom
        ]), (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).STATIC_DRAW);
        let texCoordBuffer = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).texCoordBuffer;
        if (texCoordBuffer === undefined) {
            texCoordBuffer = (0, $be957da3610487e9$export$921068d8846a1559).throwIfNull((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).createBuffer());
            (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).texCoordBuffer = texCoordBuffer;
            (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindBuffer((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).ARRAY_BUFFER, texCoordBuffer);
            (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bufferData((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).ARRAY_BUFFER, new Float32Array([
                0,
                0,
                0,
                1,
                1,
                0,
                1,
                1
            ]), (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).STATIC_DRAW);
        }
        if (this.vertexAttribute === undefined) {
            this.vertexAttribute = (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getAttribLocation(this.program, 'vertex');
            (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).enableVertexAttribArray(this.vertexAttribute);
        }
        if (this.texCoordAttribute === undefined) {
            this.texCoordAttribute = (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getAttribLocation(this.program, '_texCoord');
            (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).enableVertexAttribArray(this.texCoordAttribute);
        }
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).useProgram(this.program);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindBuffer((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).ARRAY_BUFFER, vertexBuffer);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).vertexAttribPointer(this.vertexAttribute, 2, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FLOAT, false, 0, 0);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindBuffer((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).ARRAY_BUFFER, texCoordBuffer);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).vertexAttribPointer(this.texCoordAttribute, 2, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FLOAT, false, 0, 0);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).drawArrays((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TRIANGLE_STRIP, 0, 4);
    }
    // ----------------------------------- public -----------------------------------
    constructor(vertexSource, fragmentSource, nameStr){
        this.program = (0, $be957da3610487e9$export$921068d8846a1559).throwIfNull((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).createProgram());
        vertexSource = vertexSource || $4e0480503a88a2cb$var$defaultVertexSource;
        fragmentSource = fragmentSource || $4e0480503a88a2cb$var$defaultFragmentSource;
        if (!$4e0480503a88a2cb$var$floatPrecision) $4e0480503a88a2cb$var$floatPrecision = this.testPrecisionSupport((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).HIGH_FLOAT) ? 'highp' : this.testPrecisionSupport((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).MEDIUM_FLOAT) ? 'mediump' : 'lowp';
        fragmentSource = 'precision ' + $4e0480503a88a2cb$var$floatPrecision + ' float;' + fragmentSource; // annoying requirement is annoying
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).attachShader(this.program, this.compileSource((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).VERTEX_SHADER, vertexSource, nameStr + '(vertex)'));
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).attachShader(this.program, this.compileSource((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FRAGMENT_SHADER, fragmentSource, nameStr + '(fragment)'));
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).linkProgram(this.program);
        if (!(0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getProgramParameter(this.program, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).LINK_STATUS)) throw 'link error: ' + (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getProgramInfoLog(this.program);
    }
}



const $17f3527a25c945f4$export$6408eeb1703e74b8 = function(brightness, contrast) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).brightnessContrast = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).brightnessContrast || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform float brightness;\
        uniform float contrast;\
        varying vec2 texCoord;\
        void main() {\
            vec4 color = texture2D(texture, texCoord);\
            color.rgb += brightness;\
            if (contrast > 0.0) {\
                color.rgb = (color.rgb - 0.5) / (1.0 - contrast) + 0.5;\
            } else {\
                color.rgb = (color.rgb - 0.5) * (1.0 + contrast) + 0.5;\
            }\
            gl_FragColor = clamp(color, 0.0, 1.0);\
        }\
    ', 'brightnessContrast');
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).brightnessContrast, {
        brightness: (0, $be957da3610487e9$export$921068d8846a1559).clamp(brightness, -1, 1),
        contrast: (0, $be957da3610487e9$export$921068d8846a1559).clamp(contrast, -1, 1)
    });
    return this;
};






class $583c57863818143f$export$7e6fd232cff50dd1 {
    // ---- static ----
    static fromElement(element) {
        const texture = new $583c57863818143f$export$7e6fd232cff50dd1(0, 0, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).UNSIGNED_BYTE);
        texture.loadContentsOf(element);
        return texture;
    }
    setSampling(minification, magnification = minification) {
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindTexture((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).texParameteri((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_MIN_FILTER, minification === 'nearest' ? (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).NEAREST : (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).LINEAR);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).texParameteri((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_MAG_FILTER, magnification === 'nearest' ? (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).NEAREST : (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).LINEAR);
    }
    loadContentsOf(element) {
        this.width = element.width || element.videoWidth;
        this.height = element.height || element.videoHeight;
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindTexture((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).texImage2D((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, 0, this.format, this.format, this.type, element);
    }
    initFromBytes(width, height, data) {
        this.width = width;
        this.height = height;
        this.format = (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA;
        this.type = (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).UNSIGNED_BYTE;
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindTexture((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).texImage2D((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, 0, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA, width, height, 0, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA, this.type, new Uint8Array(data));
    }
    destroy() {
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).deleteTexture(this.id);
        this.id = null;
    }
    use(unit) {
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).activeTexture((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE0 + (unit || 0));
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindTexture((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
    }
    unuse(unit) {
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).activeTexture((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE0 + (unit || 0));
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindTexture((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, null);
    }
    ensureFormat(width, height, format, type) {
        // change the format only if required
        if (width !== this.width || height !== this.height || format !== this.format || type !== this.type) {
            this.width = width;
            this.height = height;
            this.format = format;
            this.type = type;
            (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindTexture((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
            (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).texImage2D((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, 0, this.format, width, height, 0, this.format, this.type, null);
        }
    }
    ensureFormatViaTexture(texture) {
        this.ensureFormat(texture.width, texture.height, texture.format, texture.type);
    }
    drawTo(callback) {
        // start rendering to this texture
        (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).framebuffer ??= (0, $be957da3610487e9$export$921068d8846a1559).throwIfNull((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).createFramebuffer());
        const framebuffer = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).framebuffer;
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindFramebuffer((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FRAMEBUFFER, framebuffer);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).framebufferTexture2D((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FRAMEBUFFER, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).COLOR_ATTACHMENT0, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, this.id, 0);
        const fbStatus = (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).checkFramebufferStatus((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FRAMEBUFFER);
        if (fbStatus !== (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FRAMEBUFFER_COMPLETE) {
            if (this.id === null) throw new Error('incomplete framebuffer: texture already destroyed');
            if ((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).isContextLost()) throw new Error('incomplete framebuffer: context lost');
            if (this.width === 0 || this.height === 0) throw new Error(`incomplete framebuffer: texture has zero dimension (${this.width}x${this.height})`);
            if (fbStatus === (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FRAMEBUFFER_UNSUPPORTED) throw new Error(`incomplete framebuffer: unsupported format/type combination (format=0x${this.format.toString(16)}, type=0x${this.type.toString(16)})`);
            throw new Error(`incomplete framebuffer: status 0x${fbStatus.toString(16)}`);
        }
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).viewport(0, 0, this.width, this.height);
        // do the drawing
        callback();
        // stop rendering to this texture
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindFramebuffer((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FRAMEBUFFER, null);
    }
    swapWith(other) {
        let temp;
        temp = other.id;
        other.id = this.id;
        this.id = temp;
        temp = other.width;
        other.width = this.width;
        this.width = temp;
        temp = other.height;
        other.height = this.height;
        this.height = temp;
        temp = other.format;
        other.format = this.format;
        this.format = temp;
    // type?
    }
    // ----------------------------------- public -----------------------------------
    constructor(width, height, format, type){
        this.fxGl = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017);
        this.id = (0, $be957da3610487e9$export$921068d8846a1559).throwIfNull((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).createTexture());
        this.width = width;
        this.height = height;
        this.format = format;
        this.type = type;
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).bindTexture((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
        this.setSampling('linear');
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).texParameteri((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_WRAP_S, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).CLAMP_TO_EDGE);
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).texParameteri((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_WRAP_T, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).CLAMP_TO_EDGE);
        if (width && height) (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).texImage2D((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).TEXTURE_2D, 0, this.format, width, height, 0, this.format, this.type, null);
    }
}



function $bbf2542d2ce3d387$export$4f237735eca1f248(points) {
    const interpolator = new (0, $be957da3610487e9$export$921068d8846a1559).SplineInterpolator(points);
    const array = [];
    for(let i = 0; i < 256; i++)array.push((0, $be957da3610487e9$export$921068d8846a1559).clamp(Math.floor(interpolator.interpolate(i / 255) * 256), 0, 255));
    return array;
}





const $3452d41e06984911$export$6894093bf294bea5 = function(red, green, blue) {
    // Create the ramp texture
    const redRamp = (0, $bbf2542d2ce3d387$export$4f237735eca1f248)(red);
    const greenRamp = (0, $bbf2542d2ce3d387$export$4f237735eca1f248)(green);
    const blueRamp = (0, $bbf2542d2ce3d387$export$4f237735eca1f248)(blue);
    const array = [];
    for(let i = 0; i < 256; i++)array.splice(array.length, 0, redRamp[i], greenRamp[i], blueRamp[i], 255);
    const extraTexture = this._.extraTexture;
    extraTexture.initFromBytes(256, 1, array);
    extraTexture.use(1);
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).curves = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).curves || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform sampler2D map;\
        varying vec2 texCoord;\
        void main() {\
            vec4 color = texture2D(texture, texCoord);\
            color.r = texture2D(map, vec2(color.r)).r;\
            color.g = texture2D(map, vec2(color.g)).g;\
            color.b = texture2D(map, vec2(color.b)).b;\
            gl_FragColor = color;\
        }\
    ', 'curves');
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).curves.textures({
        map: 1
    });
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).curves, {});
    return this;
};






const $c075778d4e1db17b$export$ef28bbbd731e79bf = function(hue, saturation) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).hueSaturation = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).hueSaturation || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform float hue;\
        uniform float saturation;\
        varying vec2 texCoord;\
        void main() {\
            vec4 color = texture2D(texture, texCoord);\
            \
            /* hue adjustment, wolfram alpha: RotationTransform[angle, {1, 1, 1}][{x, y, z}] */\
            float angle = hue * 3.14159265;\
            float s = sin(angle), c = cos(angle);\
            vec3 weights = (vec3(2.0 * c, -sqrt(3.0) * s - c, sqrt(3.0) * s - c) + 1.0) / 3.0;\
            float len = length(color.rgb);\
            color.rgb = vec3(\
                dot(color.rgb, weights.xyz),\
                dot(color.rgb, weights.zxy),\
                dot(color.rgb, weights.yzx)\
            );\
            \
            /* saturation adjustment */\
            float average = (color.r + color.g + color.b) / 3.0;\
            if (saturation > 0.0) {\
                color.rgb += (average - color.rgb) * (1.0 - 1.0 / (1.001 - saturation));\
            } else {\
                color.rgb += (average - color.rgb) * (-saturation);\
            }\
            \
            gl_FragColor = color;\
        }\
    ', 'hueSaturation');
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).hueSaturation, {
        hue: (0, $be957da3610487e9$export$921068d8846a1559).clamp(hue, -1, 1),
        saturation: (0, $be957da3610487e9$export$921068d8846a1559).clamp(saturation, -1, 1)
    });
    return this;
};





var $41e6b82080fd0f37$exports = {};
$41e6b82080fd0f37$exports = "#define GLSLIFY 1\nuniform sampler2D texture;\nvarying vec2 texCoord;\nuniform vec2 texSize;\n\nuniform float seed;\nuniform float type;\nuniform vec2 scale;\nuniform vec2 offset;\nuniform float octaves;\nuniform float samples;\n\nuniform float peaks;\nuniform float contrast;\nuniform float brightness;\nuniform float isReversed;\n\nuniform vec3 colA;\nuniform vec3 colB;\n\nuniform float channels; // 0 - rgb, 1 - alpha\n\n// fbm, cellular_noise based on\n// https://github.com/Gonkee/Gonkees-Shaders\n// MIT, Copyright \xa9 Gonkee\n\n// hash & simplex based on\n// https://www.shadertoy.com/view/Msf3WH\n// MIT, Copyright \xa9 2013 Inigo Quilez\n// https://www.youtube.com/c/InigoQuilez\n// https://iquilezles.org\n\nfloat rand(vec2 co) {\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nfloat value_noise(vec2 coord){\n    return rand(floor(coord) / 100.0);\n}\n\nfloat cellular_noise(vec2 coord) {\n    vec2 i = floor(coord);\n    vec2 f = fract(coord);\n\n    float min_dist = 99999.0;\n    for (float x = -1.0; x <= 1.0; x++) {\n        for (float y = -1.0; y <= 1.0; y++) {\n            vec2 node = rand(i + vec2(x, y)) + vec2(x, y);\n            float dist = sqrt((f - node).x * (f - node).x + (f - node).y * (f - node).y);\n            min_dist = min(min_dist, dist);\n        }\n    }\n    return min_dist;\n}\n\n// ---------- Simplex Alternative ---------------------\n\nvec3 hash(vec3 p)\n{ p=vec3(dot(p, vec3(127.1, 311.7, 74.7))\n, dot(p, vec3(269.5, 183.3, 246.1))\n, dot(p, vec3(113.5, 271.9, 124.6)))\n;return fract(sin(p)*43758.5453123)*2.-1.; }\n\nmat3 hash(mat3 p)\n{ return mat3(hash(p[0]), hash(p[1]), hash(p[2])); }\n\nvec3 dots(mat3 a, vec3 w, mat3 b){ return vec3\n(dot(a[0], w-b[0]), dot(a[1], w-b[1]), dot(a[2], w-b[2])); }\n\n//return noiseGra13dx as .x, and its derivatives as .yzw\n// https://www.shadertoy.com/view/llByD1\nvec3 noiseGra13dx(in vec3 x) {\n    vec3 p=floor(x), w=fract(x)\n    #if 1\n    , u=w*w*w*(w*(w*6.-15.)+10.), v=30.*w*w*(w*(w-2.)+1.)//quintic hermite\n    #else\n    , u=w*w*(3.-2.*w), v=6.*w*(1.-w)//cubic hermite\n    #endif\n    //gradients\n    , G=hash(p+vec3(0)), F=hash(p+vec3(1))\n    ;mat3 D=hash(mat3(p, p, p)+mat3(1)), E=hash(mat3(p, p, p)+1.-mat3(1));\n    //projections\n    vec3 d=dots(D, w, mat3(1)), e=dots(E, w, 1.-mat3(1));\n    //interpolations\n    float g=dot(G, w), f=dot(F, w-vec3(1));\n    vec3 h=u.yzx*(g-d.xyx-d.yzz+e.zxy)+d-g, U=u*h, a=d-e;\n    mat3 S=D-mat3(G, G, G), W=D-E;\n    a.x=(a.x+a.y+a.z)+f-g;\n    ;float b=u.x*u.y*u.z;\n\n    vec4 result = vec4(g+U.x+U.y+U.z+a.x*b// value\n    , G*(1.-b)+b*(W[0]+W[1]+W[2]+F)//https://www.shadertoy.com/view/llByD1\n    +u.x*(S[0]+u.y*(G-D[0]-D[1]+E[2]))// derivatives\n    +u.y*(S[1]+u.z*(G-D[1]-D[2]+E[0]))\n    +u.z*(S[2]+u.x*(G-D[0]-D[2]+E[1]))\n    +v*(u.zxy*(g-d.xxy-d.zyz+e.yzx)+h+u.yzx*u.zxy*a.x));\n    return 0.5 + 0.5 * result.xxx;\n}\n\nfloat fbm(vec2 coord) {\n    float normalize_factor = 0.0;\n    float value = 0.0;\n    float scale = 0.5;\n\n    for (float i = 0.0; i < 7.0; i++){\n        if (i < octaves) {\n            if (type == 0.0) {\n                value += value_noise(coord) * scale;\n            } else if (type == 1.0) {\n                value += noiseGra13dx(vec3(coord.x, coord.y, 0.0)).r * scale;\n            } else if (type == 2.0) {\n                value += cellular_noise(coord) * scale;\n            }\n            normalize_factor += scale;\n            coord *= 2.0;\n            scale *= 0.5;\n        }\n    }\n    return value / normalize_factor;\n}\n\nfloat render (vec2 pos) {\n    float result = fbm(pos);\n    //\n\n    if (peaks > 0.0) {\n        result = abs(mod(result * peaks - 0.5, 1.0) - 0.5) * 2.0;// triangle\n        //result = mod(result * (peaks + 1.0), 1.0); // sawtooth\n    }\n\n    result += brightness;\n    if (contrast > 0.0) {\n        result = clamp((result - 0.5) / (1.0 - contrast) + 0.5, 0.0, 1.0);\n    } else if (contrast < 0.0) {\n        result = clamp((result - 0.5) * (1.0 + contrast) + 0.5, 0.0, 1.0);\n    }\n\n    if (isReversed == 1.0) {\n        result = 1.0 - result;\n    }\n    return result;\n}\n\nvoid main() {\n    vec4 color;\n\n    vec2 seedOffset;\n    seedOffset.x = (rand(vec2(seed, 0.0)) * 100.0 - 50.0);\n    seedOffset.y = (rand(vec2(0.0, seed)) * 100.0 - 50.0);\n\n    float val = 0.0;\n    vec2 basePos = texCoord * texSize / scale - offset / scale + seedOffset;\n\n    if (samples == 1.0) {\n        val = render(basePos);\n\n    }/* else if (samples == 4.0) {\n        for (float i = 0.0; i < 2.0; i++) {\n            for (float e = 0.0; e < 2.0; e++) {\n                val += render(basePos + (vec2(i, e) - 0.5) * 0.5 / scale);\n            }\n        }\n        val /= 4.0;\n\n    }*/ else if (samples == 16.0) {\n        for (float i = 0.0; i < 4.0; i++) {\n            for (float e = 0.0; e < 4.0; e++) {\n                val += render(basePos + (vec2(i, e) - 0.25) * 0.25 / scale);\n            }\n        }\n        val /= 16.0;\n    }\n\n    if (channels == 0.0) {\n        gl_FragColor = vec4(vec3(mix(colA, colB, val)), 1.0);\n    } else {\n        gl_FragColor = vec4(vec3(1.0), val);\n    }\n}";


const $a3da0e53ff8f2911$export$d3022aad56692482 = function(seed, type, scale, offset, octaves, samples, peaks, brightness, contrast, isReversed, colA, colB, channels) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).noise = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).noise || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, (0, (/*@__PURE__*/$parcel$interopDefault($41e6b82080fd0f37$exports))).replace(/#define.*/, ''), 'noise');
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).noise, {
        seed: seed || 0,
        type: type,
        scale: [
            scale[0],
            scale[1]
        ],
        offset: offset,
        octaves: octaves,
        samples: samples,
        texSize: [
            this.canvas.width,
            this.canvas.height
        ],
        peaks: peaks,
        brightness: brightness,
        contrast: contrast,
        isReversed: isReversed ? 1.0 : 0.0,
        colA: colA ? [
            colA.r / 255,
            colA.g / 255,
            colA.b / 255
        ] : [
            0,
            0,
            0
        ],
        colB: colB ? [
            colB.r / 255,
            colB.g / 255,
            colB.b / 255
        ] : [
            1,
            1,
            1
        ],
        channels: channels === 'rgb' ? 0 : 1
    });
    return this;
};




// returns a random number between 0 and 1
const $1eef4f2056940253$export$af69f7ca07da04c9 = '\
    float random(vec3 scale, float seed) {\
        /* use the fragment position for a different seed per-pixel */\
        return fract(sin(dot(gl_FragCoord.xyz + seed, scale)) * 43758.5453 + seed);\
    }\
';



const $846ffbef90a8f25a$export$6e852234f1597a14 = function(radius) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).triangleBlur = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).triangleBlur || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform vec2 delta;\
        varying vec2 texCoord;\
        ' + (0, $1eef4f2056940253$export$af69f7ca07da04c9) + '\
        void main() {\
            vec4 color = vec4(0.0);\
            float total = 0.0;\
            \
            /* randomize the lookup values to hide the fixed number of samples */\
            float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);\
            \
            for (float t = -30.0; t <= 30.0; t++) {\
                float percent = (t + offset - 0.5) / 30.0;\
                float weight = 1.0 - abs(percent);\
                vec4 sample = texture2D(texture, texCoord + delta * percent);\
                \
                color += sample * weight;\
                total += weight;\
            }\
            \
            gl_FragColor = color / total;\
        }\
    ', 'triangleBlur');
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).triangleBlur, {
        delta: [
            radius / this.canvas.width,
            0
        ]
    });
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).triangleBlur, {
        delta: [
            0,
            radius / this.canvas.height
        ]
    });
    return this;
};






const $dc6770c9c57a1e92$export$4545acb2b6bb8f22 = function(startX, startY, endX, endY, blurRadius, gradientRadius) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).tiltShift = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).tiltShift || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform float blurRadius;\
        uniform float gradientRadius;\
        uniform vec2 start;\
        uniform vec2 end;\
        uniform vec2 delta;\
        uniform vec2 texSize;\
        varying vec2 texCoord;\
        ' + (0, $1eef4f2056940253$export$af69f7ca07da04c9) + '\
        void main() {\
            vec4 color = vec4(0.0);\
            float total = 0.0;\
            \
            /* randomize the lookup values to hide the fixed number of samples */\
            float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);\
            \
            vec2 normal = normalize(vec2(start.y - end.y, end.x - start.x));\
            float radius = smoothstep(0.0, 1.0, abs(dot(texCoord * texSize - start, normal)) / gradientRadius) * blurRadius;\
            for (float t = -30.0; t <= 30.0; t++) {\
                float percent = (t + offset - 0.5) / 30.0;\
                float weight = 1.0 - abs(percent);\
                vec4 sample = texture2D(texture, texCoord + delta / texSize * percent * radius);\
                \
                color += sample * weight;\
                total += weight;\
            }\
            \
            gl_FragColor = color / total;\
        }\
    ', 'tiltShift');
    const dx = endX - startX;
    const dy = endY - startY;
    const d = Math.sqrt(dx * dx + dy * dy);
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).tiltShift, {
        blurRadius: blurRadius,
        gradientRadius: gradientRadius,
        start: [
            startX,
            startY
        ],
        end: [
            endX,
            endY
        ],
        delta: [
            dx / d,
            dy / d
        ],
        texSize: [
            this.canvas.width,
            this.canvas.height
        ]
    });
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).tiltShift, {
        blurRadius: blurRadius,
        gradientRadius: gradientRadius,
        start: [
            startX,
            startY
        ],
        end: [
            endX,
            endY
        ],
        delta: [
            -dy / d,
            dx / d
        ],
        texSize: [
            this.canvas.width,
            this.canvas.height
        ]
    });
    return this;
};




function $06c60d220c95265d$export$820b3a44cb7b2b21(uniformsStr, warpStr) {
    return new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, uniformsStr + '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    void main() {\
        vec2 coord = texCoord * texSize;\
        ' + warpStr + '\
        gl_FragColor = texture2D(texture, coord / texSize);\
        vec2 clampedCoord = clamp(coord, vec2(0.0), texSize);\
        if (coord != clampedCoord) {\
            /* fade to transparent if we are outside the image */\
            gl_FragColor.a *= max(0.0, 1.0 - length(coord - clampedCoord));\
        }\
    }', 'warp');
}



function $5208875c540a5086$export$1c447127d27d7be4(x0, y0, x1, y1, x2, y2, x3, y3) {
    const dx1 = x1 - x2;
    const dy1 = y1 - y2;
    const dx2 = x3 - x2;
    const dy2 = y3 - y2;
    const dx3 = x0 - x1 + x2 - x3;
    const dy3 = y0 - y1 + y2 - y3;
    const det = dx1 * dy2 - dx2 * dy1;
    const a = (dx3 * dy2 - dx2 * dy3) / det;
    const b = (dx1 * dy3 - dx3 * dy1) / det;
    return [
        x1 - x0 + a * x1,
        y1 - y0 + a * y1,
        a,
        x3 - x0 + b * x3,
        y3 - y0 + b * y3,
        b,
        x0,
        y0,
        1
    ];
}
function $5208875c540a5086$export$68b3343017e80691(m) {
    const a = m[0], b = m[1], c = m[2];
    const d = m[3], e = m[4], f = m[5];
    const g = m[6], h = m[7], i = m[8];
    const det = a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    return [
        (e * i - f * h) / det,
        (c * h - b * i) / det,
        (b * f - c * e) / det,
        (f * g - d * i) / det,
        (a * i - c * g) / det,
        (c * d - a * f) / det,
        (d * h - e * g) / det,
        (b * g - a * h) / det,
        (a * e - b * d) / det
    ];
}
function $5208875c540a5086$export$2060d2db72cce88f(a, b) {
    return [
        a[0] * b[0] + a[1] * b[3] + a[2] * b[6],
        a[0] * b[1] + a[1] * b[4] + a[2] * b[7],
        a[0] * b[2] + a[1] * b[5] + a[2] * b[8],
        a[3] * b[0] + a[4] * b[3] + a[5] * b[6],
        a[3] * b[1] + a[4] * b[4] + a[5] * b[7],
        a[3] * b[2] + a[4] * b[5] + a[5] * b[8],
        a[6] * b[0] + a[7] * b[3] + a[8] * b[6],
        a[6] * b[1] + a[7] * b[4] + a[8] * b[7],
        a[6] * b[2] + a[7] * b[5] + a[8] * b[8]
    ];
}


const $715bb4561efc2b29$export$a93b0222aeadc54b = function(matrix, inverse, useTextureSpace) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).matrixWarp = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).matrixWarp || (0, $06c60d220c95265d$export$820b3a44cb7b2b21)('\
        uniform mat3 matrix;\
        uniform bool useTextureSpace;\
    ', '\
        if (useTextureSpace) coord = coord / texSize * 2.0 - 1.0;\
        vec3 warp = matrix * vec3(coord, 1.0);\
        coord = warp.xy / warp.z;\
        if (useTextureSpace) coord = (coord * 0.5 + 0.5) * texSize;\
    ');
    // Flatten all members of matrix into one big list
    matrix = matrix.flat();
    // Extract a 3x3 matrix out of the arguments
    if (matrix.length === 4) matrix = [
        matrix[0],
        matrix[1],
        0,
        matrix[2],
        matrix[3],
        0,
        0,
        0,
        1
    ];
    else if (matrix.length !== 9) throw 'can only warp with 2x2 or 3x3 matrix';
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).matrixWarp, {
        matrix: inverse ? (0, $5208875c540a5086$export$68b3343017e80691)(matrix) : matrix,
        texSize: [
            this.canvas.width,
            this.canvas.height
        ],
        useTextureSpace: useTextureSpace ? 1 : 0
    });
    return this;
};





const $a1f9ba186f5440c0$export$915fb7313c578ba2 = function(radius, strength) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).unsharpMask = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).unsharpMask || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D blurredTexture;\
        uniform sampler2D originalTexture;\
        uniform float strength;\
        uniform float threshold;\
        varying vec2 texCoord;\
        void main() {\
            vec4 blurred = texture2D(blurredTexture, texCoord);\
            vec4 original = texture2D(originalTexture, texCoord);\
            gl_FragColor = mix(blurred, original, 1.0 + strength);\
        }\
    ', 'unsharpMask');
    const texture = this._.texture;
    const extraTexture = this._.extraTexture;
    // Store a copy of the current texture in the second texture unit
    extraTexture.ensureFormatViaTexture(texture);
    texture.use();
    extraTexture.drawTo(function() {
        (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108).getDefaultShader().drawRect();
    });
    // Blur the current texture, then use the stored texture to detect edges
    extraTexture.use(1);
    this.triangleBlur(radius);
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).unsharpMask.textures({
        originalTexture: 1
    });
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).unsharpMask, {
        strength: strength
    });
    extraTexture.unuse(1);
    return this;
};





const $19564069122a8d4c$export$be1ee5ea42904fdc = function(isInverted, replaceRGBA) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).toAlpha = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).toAlpha || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, '\
    uniform bool isInverted;\
    uniform vec4 replace;\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        float alpha = (color.r + color.g + color.b) / 3.0;\
        if (isInverted) alpha = 1.0 - alpha;\
        alpha = min(color.a, alpha);\
        if (replace.a > 0.0) color = replace;\
        gl_FragColor = vec4(color.r, color.g, color.b, alpha);\
    }\
', 'toAlpha');
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).toAlpha, {
        isInverted: isInverted ? 1 : 0,
        replace: replaceRGBA ? [
            replaceRGBA.r / 255,
            replaceRGBA.g / 255,
            replaceRGBA.b / 255,
            replaceRGBA.a
        ] : [
            0,
            0,
            0,
            0
        ],
        texSize: [
            this.canvas.width,
            this.canvas.height
        ]
    });
    return this;
};





const $163ee1db165b30ac$export$6897c284b6f9f4dc = function() {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).invert = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).invert || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        color.rgb = 1.0 - color.rgb;\
        gl_FragColor = color;\
    }\
', 'invert');
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).invert, {
        texSize: [
            this.canvas.width,
            this.canvas.height
        ]
    });
    return this;
};



const $650588de11b27975$export$541149539f3a4684 = function(before, after) {
    const a = (0, $5208875c540a5086$export$1c447127d27d7be4)(...after);
    const b = (0, $5208875c540a5086$export$1c447127d27d7be4)(...before);
    const c = (0, $5208875c540a5086$export$2060d2db72cce88f)((0, $5208875c540a5086$export$68b3343017e80691)(a), b);
    return this.matrixWarp(c);
};





const $a469ed6c96bc855f$export$b324c80262feb891 = function() {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).unmultiplyAlpha = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).unmultiplyAlpha || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        if(color.a > 0.0) {\
            color.rgb /= color.a;\
        }\
        gl_FragColor = color;\
    }\
', 'unmultiplyAlpha');
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).unmultiplyAlpha, {
        texSize: [
            this.canvas.width,
            this.canvas.height
        ]
    });
    return this;
};





const $56f5e85540615622$export$7c9b924528782480 = function(settings) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).distort = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).distort || (0, $06c60d220c95265d$export$820b3a44cb7b2b21)(`
    uniform float stepSize;
    uniform vec2 scale;
    uniform vec2 strength;
    uniform vec2 phase;
    uniform float type;
    uniform vec2 offset;
`, `
    const float PI = 3.14159265;
    float x = coord.x + offset.x;
    float y = coord.y + offset.y;
    if (stepSize > 1.0) {
        x = floor(x / stepSize) * stepSize;
        y = floor(y / stepSize) * stepSize;
    }
    float distortX = sin((x/scale.x + phase.x) * PI * 2.0) * strength.x;
    float distortY = sin((y/scale.y + phase.y) * PI * 2.0) * strength.y;
    if (type == 0.0) {
        coord.y += distortX;
        coord.x += distortY;
    } else if (type == 1.0) {
        coord.x += distortX;
        coord.y += distortY;
    } else if (type == 2.0) {
        x -= offset.x;
        y -= offset.y;
        gl_FragColor = texture2D(texture, vec2(x, y) / texSize);
        coord.y += sin(gl_FragColor.r/scale.x*200.0 + phase.x * PI * 2.0) * strength.x;
        coord.x += cos(gl_FragColor.g/scale.y*200.0 + phase.y * PI * 2.0) * strength.y;
    }
    coord.x = mod(coord.x, texSize.x);
    coord.y = mod(coord.y, texSize.y);
`);
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).distort, {
        stepSize: settings.stepSize,
        type: settings.distortType,
        scale: [
            settings.scale.x,
            settings.scale.y
        ],
        strength: [
            settings.strength.x,
            settings.strength.y
        ],
        phase: [
            settings.phase.x,
            settings.phase.y
        ],
        offset: [
            settings.offset.x,
            settings.offset.y
        ],
        texSize: [
            this.canvas.width,
            this.canvas.height
        ]
    });
    return this;
};





const $25021b6b14dde21f$export$57b05c961ff98d6a = function() {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).multiplyAlpha = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).multiplyAlpha || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        color.rgb *= color.a;\
        gl_FragColor = color;\
    }\
', 'multiplyAlpha');
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).multiplyAlpha, {
        texSize: [
            this.canvas.width,
            this.canvas.height
        ]
    });
    return this;
};







const $f45bd8848ea4ae5a$export$d99f0801a68bbcf1 = function(maskTexture, originalTexture, premultiplyOriginal) {
    maskTexture._.use(1);
    if (originalTexture) originalTexture._.use(2);
    else {
        // should be faster than introducing a conditional in the shader
        const extraTexture = this._.extraTexture;
        extraTexture.use(2);
        extraTexture.initFromBytes(1, 1, [
            0,
            0,
            0,
            0
        ]);
    }
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).mask = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).mask || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, `
        uniform sampler2D texture;
        uniform sampler2D mask;
        uniform sampler2D original;
        uniform bool premultiplyOriginal;
        varying vec2 texCoord;

        void main() {
            vec4 filteredCol = texture2D(texture, texCoord);
            vec4 originalCol = texture2D(original, texCoord);
            if (premultiplyOriginal) {
                originalCol.rgb *= originalCol.a;
            }
            float maskStrength = texture2D(mask, texCoord).r;
            gl_FragColor = mix(originalCol, filteredCol, maskStrength);
        }
        `, 'mask');
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).mask.textures({
        mask: 1,
        original: 2
    });
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).mask, {
        premultiplyOriginal: premultiplyOriginal ? 1 : 0
    });
    return this;
};






const $d5bdfb667ad106e2$export$eea46f84626e452a = function(texture, transformMatrix) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).drawTransformed = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).drawTransformed || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, `
uniform sampler2D texture;
uniform mat3 matrix;
uniform vec2 texSize;
varying vec2 texCoord;
void main() {
    vec2 coord = texCoord * texSize;
    vec3 transformedCoord = matrix * vec3(coord, 1.0);
    coord = transformedCoord.xy / transformedCoord.z;
    gl_FragColor = texture2D(texture, coord / texSize);
}
            `, 'drawTransformed');
    const inverseTransform = (0, $fd04355d00b81239$export$70ae2c07e401031b)(transformMatrix);
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).drawTransformed, {
        matrix: [
            inverseTransform.a,
            inverseTransform.b,
            0,
            inverseTransform.c,
            inverseTransform.d,
            0,
            inverseTransform.e,
            inverseTransform.f,
            1
        ],
        texSize: [
            this.canvas.width,
            this.canvas.height
        ]
    }, texture._);
    return this;
};






const $c8219668ae0404f4$export$c6b81c3f9061f10a = function(transformMatrix) {
    (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).maskRect = (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).maskRect || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, `
uniform sampler2D texture;
uniform mat3 matrix;
uniform vec2 texSize;
varying vec2 texCoord;
void main() {
    vec2 coord = texCoord * texSize;
    vec3 rectCoord = matrix * vec3(coord, 1.0);
    if (
        rectCoord.x < 0.0 ||
        rectCoord.y < 0.0 ||
        rectCoord.x > texSize.x ||
        rectCoord.y > texSize.y
    ) {
        gl_FragColor = vec4(0.0);
    } else {
        gl_FragColor = texture2D(texture, texCoord);
    }
}
        `, 'maskRect');
    const inverseTransform = (0, $fd04355d00b81239$export$70ae2c07e401031b)(transformMatrix);
    (0, $5fe79db1088ebcc2$export$d731e22ecd0c25d3).call(this, (0, $56c020f64b9c3c25$export$72a5a96ec5bfe017).maskRect, {
        matrix: [
            inverseTransform.a,
            inverseTransform.b,
            0,
            inverseTransform.c,
            inverseTransform.d,
            0,
            inverseTransform.e,
            inverseTransform.f,
            1
        ],
        texSize: [
            this.canvas.width,
            this.canvas.height
        ]
    });
    return this;
};


const $19e726538c4603a6$export$a04cfca62fd2892f = function() {
    function wrapTexture(texture) {
        return {
            _: texture,
            loadContentsOf: function(element) {
                // Make sure that we're using the correct global WebGL context
                (0, $56c020f64b9c3c25$export$b59c6427db8463f4)(this._.fxGl);
                this._.loadContentsOf(element);
            },
            setSampling: function(minification, magnification) {
                // Make sure that we're using the correct global WebGL context
                (0, $56c020f64b9c3c25$export$b59c6427db8463f4)(this._.fxGl);
                this._.setSampling(minification, magnification);
            },
            destroy: function() {
                // Make sure that we're using the correct global WebGL context
                (0, $56c020f64b9c3c25$export$b59c6427db8463f4)(this._.fxGl);
                this._.destroy();
            }
        };
    }
    function texture(element) {
        return wrapTexture((0, $583c57863818143f$export$7e6fd232cff50dd1).fromElement(element));
    }
    function getTextureType() {
        let textureType = (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).UNSIGNED_BYTE;
        // Go for floating point buffer textures if we can, it'll make the bokeh
        // filter look a lot better. Note that on Windows, ANGLE does not let you
        // render to a floating-point texture when linear filtering is enabled.
        // See http://crbug.com/172278 for more information.
        if ((0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getExtension('WEBGL_color_buffer_float') && // firefox shows warning without this line
        (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getExtension('OES_texture_float') && (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).getExtension('OES_texture_float_linear')) {
            const testTexture = new (0, $583c57863818143f$export$7e6fd232cff50dd1)(100, 100, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FLOAT);
            try {
                // Only use gl.FLOAT if we can render to it
                testTexture.drawTo(function() {
                    textureType = (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).FLOAT;
                });
            } catch (e) {
            /* empty */ }
            testTexture.destroy();
        }
        return textureType;
    }
    let textureType;
    function getIsInitialized() {
        return this._.isInitialized;
    }
    function initialize(width, height) {
        textureType = textureType ?? getTextureType();
        this._.texture?.destroy();
        this._.spareTexture?.destroy();
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.canvas, width, height);
        this._.texture = new (0, $583c57863818143f$export$7e6fd232cff50dd1)(width, height, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA, textureType);
        this._.spareTexture = new (0, $583c57863818143f$export$7e6fd232cff50dd1)(width, height, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA, textureType);
        this._.extraTexture = this._.extraTexture || new (0, $583c57863818143f$export$7e6fd232cff50dd1)(0, 0, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA, textureType);
        this._.flippedShader = this._.flippedShader || new (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108)(null, `
uniform sampler2D texture;
varying vec2 texCoord;
void main() {
    gl_FragColor = texture2D(texture, vec2(texCoord.x, 1.0 - texCoord.y));
}
        `, 'flippedShader');
        this._.isInitialized = true;
    }
    function draw(texture, width, height) {
        if (!this._.isInitialized || texture._.width !== this.canvas.width || texture._.height !== this.canvas.height) initialize.call(this, width ? width : texture._.width, height ? height : texture._.height);
        texture._.use();
        const targetTexture = this._.texture;
        targetTexture.drawTo(function() {
            (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108).getDefaultShader().drawRect();
        });
        return this;
    }
    function update() {
        this._.texture.use();
        this._.flippedShader.drawRect();
        return this;
    }
    function copyTo(target) {
        const sourceTexture = this._.texture;
        if (target._.fxGl !== sourceTexture.fxGl) throw new Error('Cannot copy FX canvas contents between WebGL contexts');
        const targetTexture = target._;
        targetTexture.ensureFormat(sourceTexture.width, sourceTexture.height, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).UNSIGNED_BYTE);
        sourceTexture.use();
        targetTexture.drawTo(function() {
            (0, $4e0480503a88a2cb$export$7d9b0d118d0c4108).getDefaultShader().drawRect();
        });
    }
    function contents() {
        const sourceTexture = this._.texture;
        const target = wrapTexture(new (0, $583c57863818143f$export$7e6fd232cff50dd1)(sourceTexture.width, sourceTexture.height, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).UNSIGNED_BYTE));
        copyTo.call(this, target);
        return target;
    }
    /*
       Get a Uint8 array of pixel values: [r, g, b, a, r, g, b, a, ...]
       Length of the array will be width * height * 4.
    */ function getPixelArray() {
        const texture = this._.texture;
        const w = texture.width;
        const h = texture.height;
        const array = new Uint8Array(w * h * 4);
        texture.drawTo(function() {
            (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).readPixels(0, 0, w, h, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).RGBA, (0, $56c020f64b9c3c25$export$5822a9d0880a5d82).UNSIGNED_BYTE, array);
        });
        return array;
    }
    function wrap(fn) {
        return function(...args) {
            // Make sure that we're using the correct global WebGL context
            (0, $56c020f64b9c3c25$export$b59c6427db8463f4)(this._.fxGl);
            // Now that the context has been switched, we can call the wrapped function
            return fn.apply(this, args);
        };
    }
    function getWebGlContext(canvas, options) {
        const contextNames = [
            'webgl',
            'experimental-webgl',
            'webgl2'
        ];
        let context = null;
        contextNames.forEach((name)=>{
            if (context) return;
            // get.webgl.org does a try-catch
            try {
                context = canvas.getContext(name, options);
            } catch (e) {
            /* empty */ }
        });
        return context;
    }
    return ()=>{
        if (!window.WebGLRenderingContext) throw 'WebGLRenderingContext not set. Browser does not support WebGL.';
        const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(1, 1);
        const context = getWebGlContext(canvas, {
            premultipliedAlpha: false
        });
        if (!context) throw 'This browser does not support WebGL';
        const fxGl = {
            gl: context
        };
        (0, $56c020f64b9c3c25$export$b59c6427db8463f4)(fxGl);
        return {
            canvas: canvas,
            _: {
                fxGl: fxGl,
                isInitialized: false
            },
            // Core methods
            texture: wrap(texture),
            getIsInitialized: wrap(getIsInitialized),
            initialize: wrap(initialize),
            draw: wrap(draw),
            drawTransformed: wrap((0, $d5bdfb667ad106e2$export$eea46f84626e452a)),
            maskRect: wrap((0, $c8219668ae0404f4$export$c6b81c3f9061f10a)),
            update: wrap(update),
            copyTo: wrap(copyTo),
            contents: wrap(contents),
            getPixelArray: wrap(getPixelArray),
            isContextLost: ()=>{
                return context.isContextLost();
            },
            // Filter methods
            brightnessContrast: wrap((0, $17f3527a25c945f4$export$6408eeb1703e74b8)),
            hueSaturation: wrap((0, $c075778d4e1db17b$export$ef28bbbd731e79bf)),
            triangleBlur: wrap((0, $846ffbef90a8f25a$export$6e852234f1597a14)),
            unsharpMask: wrap((0, $a1f9ba186f5440c0$export$915fb7313c578ba2)),
            perspective: wrap((0, $650588de11b27975$export$541149539f3a4684)),
            matrixWarp: wrap((0, $715bb4561efc2b29$export$a93b0222aeadc54b)),
            tiltShift: wrap((0, $dc6770c9c57a1e92$export$4545acb2b6bb8f22)),
            noise: wrap((0, $a3da0e53ff8f2911$export$d3022aad56692482)),
            curves: wrap((0, $3452d41e06984911$export$6894093bf294bea5)),
            invert: wrap((0, $163ee1db165b30ac$export$6897c284b6f9f4dc)),
            multiplyAlpha: wrap((0, $25021b6b14dde21f$export$57b05c961ff98d6a)),
            unmultiplyAlpha: wrap((0, $a469ed6c96bc855f$export$b324c80262feb891)),
            toAlpha: wrap((0, $19564069122a8d4c$export$be1ee5ea42904fdc)),
            distort: wrap((0, $56f5e85540615622$export$7c9b924528782480)),
            mask: wrap((0, $f45bd8848ea4ae5a$export$d99f0801a68bbcf1))
        };
    };
}();



let $b225623fe00a4a24$var$failed = false;
let $b225623fe00a4a24$var$fx = null;
function $b225623fe00a4a24$export$8c4423af32b21158() {
    // failed previously, don't need to try again.
    if ($b225623fe00a4a24$var$failed) return $b225623fe00a4a24$var$fx;
    if (!$b225623fe00a4a24$var$fx || $b225623fe00a4a24$var$fx.isContextLost()) try {
        $b225623fe00a4a24$var$fx = (0, $19e726538c4603a6$export$a04cfca62fd2892f)();
    } catch (e) {
        $b225623fe00a4a24$var$failed = true;
        $b225623fe00a4a24$var$fx = null;
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
    }
    return $b225623fe00a4a24$var$fx;
}







const $e17225f381c762c7$var$copyImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('copy');
class $e17225f381c762c7$export$aeb1a0a0e64541b5 {
    testHasWebGL() {
        return !!(0, $b225623fe00a4a24$export$8c4423af32b21158)();
    }
    init() {
        const filters = (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).FILTER_LIB;
        const buttons = [];
        if (!(0, $25422d204ef184a3$export$6e4a713ddcda1e5e).FILTER_LIB_STATUS.isLoaded) throw new Error('filters not loaded');
        const hasWebGL = this.testHasWebGL();
        if (!hasWebGL) {
            const note = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: this.rootEl,
                className: 'kl-toolspace-note',
                content: 'Features disabled because WebGL is failing.',
                css: {
                    margin: 10,
                    marginBottom: 0
                }
            });
            const noteButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: note,
                tagName: 'button',
                className: 'kl-button',
                textContent: 'Learn More',
                css: {
                    marginLeft: 5
                }
            });
            noteButton.onclick = ()=>{
                (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                    message: '<b>WebGL is not working</b>',
                    div: (0, $be957da3610487e9$export$921068d8846a1559).el({
                        content: `
See if your browser supports WebGL and has it enabled: <a href="https://get.webgl.org" target="_blank" rel="noopener noreferrer">get.webgl.org</a><br>
<br>
Recently (2023-05) a number of Chrome users on Chrome OS reported that WebGL fails, although it is enabled & supported.
This has been reported to Google.
`
                    }),
                    buttons: [
                        'Ok'
                    ],
                    clickOnEnter: 'Ok'
                });
            };
        }
        const createButton = (filterKey)=>{
            const filter = filters[filterKey];
            const button = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button grid-button grid-button--filter',
                content: [
                    (0, $9e4d66c06c67fa7f$export$ec664d7487540b)({
                        alt: 'icon',
                        src: filter.icon,
                        width: 18,
                        height: 20,
                        className: filter.darkNoInvert ? 'dark-no-invert' : '',
                        css: {
                            marginRight: 3
                        }
                    }),
                    (0, $fc42a07754814920$export$ce37e184d908d785)(filter.lang.button)
                ],
                css: {
                    lineHeight: '20px',
                    fontSize: 12
                },
                props: {
                    tabIndex: -1
                }
            });
            const filterName = (0, $fc42a07754814920$export$ce37e184d908d785)(filter.lang.name);
            let isEnabled = true;
            if (filter.webGL && !hasWebGL) isEnabled = false;
            if (isEnabled) button.onclick = ()=>{
                this.applyUncommitted();
                const dialogButtons = [
                    'Ok',
                    'Cancel'
                ];
                const finishedDialog = (result, filterDialog)=>{
                    if ('error' in filterDialog) return;
                    if (result === 'Cancel') {
                        if (filterDialog.destroy) filterDialog.destroy();
                        return;
                    }
                    let input;
                    try {
                        input = filterDialog.getInput(); // also destroys
                    } catch (e) {
                        if (e.message.includes('.getInput is not a function')) throw 'filterDialog.getInput is not a function, filter: ' + filterName;
                        else throw e;
                    }
                    applyFilter(input);
                };
                if (!('apply' in filters[filterKey])) {
                    (0, $5f9f54d39d868ac2$export$3879b24e8245693d)('Application not fully loaded');
                    return;
                }
                const applyFilter = (input)=>{
                    const filterResult = filters[filterKey].apply({
                        layer: this.klCanvas.getLayer(this.getCurrentLayerIndex()),
                        klCanvas: this.klCanvas,
                        klHistory: this.klHistory,
                        input: input
                    });
                    if (!filterResult) (0, $5f9f54d39d868ac2$export$3879b24e8245693d)("Couldn't apply the edit action");
                    filters[filterKey].updatePos && this.onCanvasChanged();
                    this.layersUi.update();
                };
                if (filters[filterKey].isInstant) {
                    button.blur();
                    applyFilter(null);
                    this.statusOverlay.out((0, $fc42a07754814920$export$ce37e184d908d785)('filter-applied', {
                        x: filterName
                    }), true);
                } else {
                    const secondaryColorRGB = this.klColorSlider.getSecondaryRGB();
                    let filterDialog = undefined;
                    try {
                        filterDialog = filters[filterKey].getDialog({
                            selectedLayerIndex: this.getCurrentLayerIndex(),
                            klCanvas: this.klCanvas,
                            maxWidth: this.maxCanvasSize,
                            maxHeight: this.maxCanvasSize,
                            currentColorRgb: {
                                r: this.getCurrentColor().r,
                                g: this.getCurrentColor().g,
                                b: this.getCurrentColor().b
                            },
                            secondaryColorRgb: {
                                r: secondaryColorRGB.r,
                                g: secondaryColorRGB.g,
                                b: secondaryColorRGB.b
                            },
                            composed: this.klHistory.getComposed()
                        });
                    } catch (e) {
                        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
                    }
                    if (!filterDialog || 'error' in filterDialog) {
                        (0, $5f9f54d39d868ac2$export$3879b24e8245693d)(filterDialog ? filterDialog.error : 'Error: Could not perform action.');
                        return;
                    }
                    let closeFunc;
                    // Todo should move into getDialogParams
                    filterDialog.errorCallback = (e)=>{
                        (0, $5f9f54d39d868ac2$export$3879b24e8245693d)('Error: Could not perform action.');
                        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
                        closeFunc();
                    };
                    const style = {};
                    if ('width' in filterDialog) style.width = filterDialog.width + 'px';
                    let title;
                    {
                        const els = [
                            (0, $8405ecc79d32770a$export$db3b6bfb95261072)('b', filterName)
                        ];
                        if (filter.lang.description !== undefined) {
                            const description = (0, $fc42a07754814920$export$ce37e184d908d785)(filter.lang.description);
                            els.push((0, $f62dcbe3649ee07c$export$8d6339e7e16ba0e)({
                                onClick: ()=>{
                                    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                                        message: description
                                    });
                                },
                                title: description
                            }));
                        }
                        title = (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,gap-5', els);
                    }
                    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                        message: title,
                        div: filterDialog.element,
                        style: style,
                        buttons: dialogButtons,
                        clickOnEnter: 'Ok',
                        callback: (result)=>{
                            finishedDialog(result, filterDialog);
                        },
                        closeFunc: (func)=>{
                            closeFunc = func;
                        }
                    });
                }
            };
            else button.disabled = true;
            buttons.push(button);
            return button;
        };
        const addGroup = (groupArr)=>{
            Object.entries(filters).forEach(([filterKey, filter])=>{
                if (!groupArr.includes(filterKey)) return;
                if (this.isEmbed && !filter.inEmbed) return;
                this.rootEl.append(createButton(filterKey));
            });
        };
        const groupA = [
            'cropExtend',
            'flip',
            'perspective',
            'resize',
            'rotate',
            'transform'
        ];
        const groupB = [
            'brightnessContrast',
            'curves',
            'distort',
            'hueSaturation',
            'invert',
            'tiltShift',
            'toAlpha',
            'blur',
            'unsharpMask'
        ];
        const groupC = [
            'grid',
            'noise',
            'pattern',
            'vanishPoint'
        ];
        if (!this.isEmbed) {
            const copyBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button grid-button grid-button--filter',
                content: [
                    (0, $9e4d66c06c67fa7f$export$ec664d7487540b)({
                        alt: 'icon',
                        src: $e17225f381c762c7$var$copyImg,
                        width: 18,
                        height: 20,
                        css: {
                            marginRight: 3
                        }
                    }),
                    (0, $fc42a07754814920$export$ce37e184d908d785)('file-copy')
                ],
                onClick: ()=>this.onCopyToClipboard(),
                title: (0, $fc42a07754814920$export$ce37e184d908d785)('file-copy-title'),
                props: {
                    tabIndex: -1
                },
                css: {
                    lineHeight: '20px'
                }
            });
            const pasteBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'button',
                className: 'kl-button grid-button grid-button--filter',
                content: [
                    (0, $be957da3610487e9$export$921068d8846a1559).el({
                        css: {
                            height: 20,
                            float: 'left'
                        }
                    }),
                    (0, $fc42a07754814920$export$ce37e184d908d785)('file-paste')
                ],
                props: {
                    tabIndex: -1
                },
                css: {
                    lineHeight: '20px'
                },
                onClick: ()=>this.onPaste()
            });
            this.rootEl.append(copyBtn, pasteBtn, (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'grid-hr'
            }));
        }
        addGroup(groupA);
        this.rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'grid-hr'
        }));
        addGroup(groupB);
        this.rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'grid-hr'
        }));
        addGroup(groupC);
        this.isInit = true;
    }
    getElement() {
        return this.rootEl;
    }
    show() {
        if (!this.isInit) this.init();
        this.rootEl.style.display = 'block';
    }
    hide() {
        this.rootEl.style.display = 'none';
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isInit = false;
        this.klRootEl = p.klRootEl;
        this.klColorSlider = p.klColorSlider;
        this.layersUi = p.layersUi;
        this.getCurrentColor = p.getCurrentColor;
        this.maxCanvasSize = p.maxCanvasSize;
        this.klCanvas = p.klCanvas;
        this.getCurrentLayerIndex = p.getCurrentLayerIndex;
        this.isEmbed = p.isEmbed;
        this.statusOverlay = p.statusOverlay;
        this.onCanvasChanged = p.onCanvasChanged;
        this.applyUncommitted = p.applyUncommitted;
        this.klHistory = p.klHistory;
        this.onCopyToClipboard = p.onCopyToClipboard;
        this.onPaste = p.onPaste;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
    }
}











// uploads canvas, opens new tab with the upload progress & then opens the image page.
// returns undefined if upload fails
async function $7397051ecf5bd725$var$upload(canvas, title, description, type, imgurKey) {
    // open tab before any awaits
    const newTab = window.open('', '_blank');
    if (!newTab) {
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(new Error('could not create new tab'));
        return undefined;
    }
    // Keep the redirected Imgur tab from accessing the app through window.opener.
    newTab.opener = null;
    let imageBlob;
    try {
        imageBlob = await (0, $2f436639594531f3$export$403d539f215df596)(canvas, 'image/' + type);
    } catch (e) {
        newTab.close();
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
        return undefined;
    }
    const label = newTab.document.createElement('div');
    const gif = newTab.document.createElement('img');
    gif.src = (0, (/*@__PURE__*/$parcel$interopDefault($7c2e67a7cc9b2390$exports)));
    label.append(gif);
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(gif, {
        filter: 'invert(1)'
    });
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(newTab.document.body, {
        backgroundColor: '#121211',
        backgroundImage: 'linear-gradient(#2b2b2b 0%, #121211 50%)',
        backgroundRepeat: 'no-repeat'
    });
    const labelText = newTab.document.createElement('div');
    labelText.style.marginTop = '10px';
    label.append(labelText);
    labelText.textContent = (0, $fc42a07754814920$export$ce37e184d908d785)('upload-uploading');
    newTab.document.body.append(label);
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(label, {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 100,
        fontFamily: 'system-ui, sans-serif',
        fontSize: 20,
        textAlign: 'center',
        transition: 'opacity 0.3s ease-in-out',
        opacity: 0,
        color: '#ccc'
    });
    setTimeout(function() {
        label.style.opacity = '1';
    }, 20);
    let response;
    try {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('image', imageBlob);
        response = await fetch('https://api.imgur.com/3/image', {
            method: 'POST',
            headers: {
                Authorization: 'Client-ID ' + imgurKey
            },
            body: formData
        });
    } catch (e) {
        newTab.close();
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
        return undefined;
    }
    if (!response.ok) {
        newTab.close();
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)('imgur upload failed');
        return undefined;
    }
    let data;
    try {
        data = (await response.json()).data;
    } catch (e) {
        newTab.close();
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)('failed to parse imgur response');
        return undefined;
    }
    if (!data) {
        newTab.close();
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)('imgur response is missing data');
        return undefined;
    }
    newTab.location.href = data.link.replace(/\.(jpg|png)/, '');
    return data;
}
function $7397051ecf5bd725$export$b1dd62fa0b5f32f5(klCanvas, imgurKey, onUploaded) {
    if (!imgurKey) throw new Error('imgur key missing');
    const tileInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
        init: (0, $fc42a07754814920$export$ce37e184d908d785)('upload-title-untitled'),
        name: 'image-title'
    });
    const descriptionInput = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'textarea',
        props: {
            rows: 2,
            name: 'image-description'
        },
        css: {
            width: '100%',
            maxWidth: '100%'
        }
    });
    const titleLabel = (0, $be957da3610487e9$export$921068d8846a1559).el({
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('upload-name') + ':'
    });
    const descriptionLabel = (0, $be957da3610487e9$export$921068d8846a1559).el({
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('upload-caption') + ':',
        css: {
            marginTop: 10
        }
    });
    const tos = (0, $be957da3610487e9$export$921068d8846a1559).el({
        content: `<br/><a href="https://imgur.com/tos" target="_blank" rel="noopener noreferrer">${(0, $fc42a07754814920$export$ce37e184d908d785)('terms-of-service')}</a>`
    });
    const typeRadio = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).RadioList({
        name: 'filetype',
        init: 'jpeg',
        items: [
            {
                label: 'JPG',
                value: 'jpeg'
            },
            {
                label: 'PNG',
                value: 'png'
            }
        ],
        ignoreFocus: true
    });
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(typeRadio.getElement(), {
        marginBottom: 10
    });
    const outDiv = (0, $be957da3610487e9$export$921068d8846a1559).el();
    const infoHint = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: 'info-hint',
        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('upload-link-notice')
    });
    outDiv.append(infoHint, typeRadio.getElement(), titleLabel, tileInput.getElement(), descriptionLabel, descriptionInput, tos);
    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $fc42a07754814920$export$ce37e184d908d785)('upload-title')}</b>`,
        type: 'upload',
        div: outDiv,
        buttons: [
            {
                id: 'submit',
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('upload-submit')
            },
            'Cancel'
        ],
        clickOnEnter: 'submit',
        primaries: [
            'submit'
        ],
        autoFocus: 'submit',
        callback: async function(val) {
            const title = tileInput.getValue();
            tileInput.destroy();
            if (val === 'submit') {
                const result = await $7397051ecf5bd725$var$upload(klCanvas.getCanvas(), title, descriptionInput.value, typeRadio.getValue(), imgurKey);
                if (result === undefined) {
                    (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('upload-failed'));
                    return;
                }
                const deletePath = 'imgur.com/delete/' + result.deletehash;
                const deleteUrl = 'https://' + deletePath;
                (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                    type: 'ok',
                    message: (0, $8405ecc79d32770a$export$db3b6bfb95261072)('', [
                        (0, $8405ecc79d32770a$export$db3b6bfb95261072)('strong', [
                            (0, $fc42a07754814920$export$ce37e184d908d785)('upload-success')
                        ]),
                        (0, $8405ecc79d32770a$export$db3b6bfb95261072)('br'),
                        (0, $fc42a07754814920$export$ce37e184d908d785)('upload-delete'),
                        (0, $8405ecc79d32770a$export$db3b6bfb95261072)('br'),
                        (0, $8405ecc79d32770a$export$db3b6bfb95261072)({
                            tagName: 'a',
                            props: {
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                href: deleteUrl
                            }
                        }, [
                            deletePath
                        ])
                    ]),
                    buttons: [
                        'Ok'
                    ]
                });
                onUploaded();
            }
        }
    });
}


let $feca221947269811$var$agPsdLazy;

async function $feca221947269811$export$ab3d838b1d336b38() {
    $feca221947269811$var$agPsdLazy ??= await (parcelRequire("ay6hC"));
    return $feca221947269811$var$agPsdLazy;
}






var $257a371442d59800$export$d4ef1ef99f1461a4;
$257a371442d59800$export$d4ef1ef99f1461a4 = `WKn-vG_psdWrapper`;





const $0e4cfd755d2d08c9$var$DEBUG_TIME_LIMIT_MS = undefined;
const $0e4cfd755d2d08c9$var$DEBUG_UNSAVED_ACTIONS_LIMIT = undefined;
// minimum number of actions required for reminder to show up (regardless of time limit)
const $0e4cfd755d2d08c9$var$UNSAVED_ACTIONS_LIMIT = $0e4cfd755d2d08c9$var$DEBUG_UNSAVED_ACTIONS_LIMIT ?? 100;
const $0e4cfd755d2d08c9$var$LS_REMINDER_KEY = 'kl-save-reminder';
class $0e4cfd755d2d08c9$export$befc6437ad34b28a {
    showPopup() {
        const min = Math.round((performance.now() - this.lastSavedAt) / 1000 / 60);
        const contentEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        contentEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('save-reminder-text', {
                a: '<strong>' + min,
                b: '</strong>'
            }),
            css: {
                marginBottom: 20
            }
        }));
        const psdWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: $257a371442d59800$export$d4ef1ef99f1461a4
        });
        const storageWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                margin: '0 -20px',
                padding: 20,
                paddingBottom: 0
            }
        });
        contentEl.append(psdWrapper, storageWrapper);
        const destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        const psdBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button kl-button-primary kl-button--extra-focus',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('save-reminder-save-psd'),
            destroyer: destroyer,
            onClick: ()=>{
                this.applyUncommitted();
                this.onSaveAsPsd();
            },
            css: {
                padding: 14
            }
        });
        psdWrapper.append(psdBtn, (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: "\u2714 " + (0, $fc42a07754814920$export$ce37e184d908d785)('save-reminder-psd-layers'),
            css: {
                marginTop: 10
            }
        }));
        const storageUi = new (0, $293199167ef511c0$export$9c72cf485ef46673)({
            helpPath: this.helpPath,
            projectStore: this.projectStore,
            getProject: this.getProject,
            applyUncommitted: this.applyUncommitted,
            options: {
                hideClearButton: true,
                isFocusable: true
            },
            onStored: ()=>this.onStored()
        });
        storageUi.show();
        storageWrapper.append(storageUi.getElement());
        (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
            type: 'warning',
            message: `<b>${(0, $fc42a07754814920$export$ce37e184d908d785)('save-reminder-title')}</b>`,
            div: contentEl,
            ignoreBackground: true,
            callback: ()=>{
                storageUi.destroy();
                destroyer.destroy();
                this.closeFunc = undefined;
                this.lastReminderShownAt = performance.now();
            },
            closeFunc: (f)=>{
                this.closeFunc = f;
            }
        });
        setTimeout(()=>{
            psdBtn.focus();
        }, 40);
    }
    init() {
        if (this.lastSavedHistoryIndex !== undefined) // already initialized
        return;
        this.lastSavedHistoryIndex = this.klHistory.getTotalIndex();
        this.lastReminderShownAt = performance.now();
        this.lastSavedAt = performance.now();
        setInterval(()=>{
            if (document.visibilityState !== 'visible') return;
            const unsavedActions = Math.abs(this.klHistory.getTotalIndex() - this.lastSavedHistoryIndex);
            const timeLimitMs = $0e4cfd755d2d08c9$var$DEBUG_TIME_LIMIT_MS ?? 60000 * ({
                '20min': 20,
                '40min': 40,
                disabled: 0
            })[this.setting];
            if (timeLimitMs > 0 && (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() === 0 && !this.isDrawing() && this.lastReminderShownAt + timeLimitMs < performance.now() && unsavedActions >= $0e4cfd755d2d08c9$var$UNSAVED_ACTIONS_LIMIT) this.showPopup();
        }, 5000);
    }
    reset() {
        if (this.lastSavedHistoryIndex === undefined) // not initialized
        return;
        this.lastSavedHistoryIndex = this.klHistory.getTotalIndex();
        this.lastReminderShownAt = performance.now();
        this.lastSavedAt = performance.now();
        // todo central onbeforeunload service
        window.onbeforeunload = null;
        if (this.closeFunc) this.closeFunc();
    }
    getSetting() {
        return this.setting;
    }
    setSetting(setting) {
        this.setting = setting;
        (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem($0e4cfd755d2d08c9$var$LS_REMINDER_KEY, this.setting);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.klHistory = {};
        this.lastSavedAt = 0;
        this.lastReminderShownAt = 0;
        this.helpPath = p.helpPath;
        this.onSaveAsPsd = p.onSaveAsPsd;
        this.isDrawing = p.isDrawing;
        this.projectStore = p.projectStore;
        this.getProject = p.getProject;
        this.onStored = p.onStored;
        this.applyUncommitted = p.applyUncommitted;
        this.klHistory = p.klHistory;
        const storedSetting = (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem($0e4cfd755d2d08c9$var$LS_REMINDER_KEY);
        this.setting = storedSetting === '20min' || storedSetting === '40min' || storedSetting === 'disabled' ? storedSetting : '40min';
    }
}



const $df54dad6f3bf5943$var$pickerTypes = {
    'image/png': {
        description: 'PNG Image',
        accept: {
            'image/png': [
                '.png'
            ]
        }
    },
    'image/jpeg': {
        description: 'JPEG Image',
        accept: {
            'image/jpeg': [
                '.jpg',
                '.jpeg'
            ]
        }
    },
    'image/vnd.adobe.photoshop': {
        description: 'Adobe Photoshop Document',
        accept: {
            'image/vnd.adobe.photoshop': [
                '.psd'
            ]
        }
    }
};
async function $df54dad6f3bf5943$export$2bc2a80e311129ac(fileName, mimeType, createBlob, showsFilePicker = false) {
    let fileHandle;
    // Open the picker before creating the blob while the user gesture is still active.
    if (showsFilePicker && 'showSaveFilePicker' in window) try {
        fileHandle = await window.showSaveFilePicker({
            suggestedName: fileName,
            types: [
                $df54dad6f3bf5943$var$pickerTypes[mimeType]
            ]
        });
        if (!fileHandle) (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(new Error('showSaveFilePicker returned no file handle'));
    } catch (error) {
        const name = typeof error === 'object' && error !== null && 'name' in error ? error.name : undefined;
        if (name === 'AbortError') return 'cancel';
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(error);
    }
    const blob = await (0, $94f0b2b810d4d191$export$77f9e426014f6edd)(createBlob);
    if (blob instanceof (0, $94f0b2b810d4d191$export$6d5e6de05c94f9f)) {
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(blob.error);
        return 'error';
    }
    if (fileHandle) try {
        const writableStream = await fileHandle.createWritable();
        await writableStream.write(blob);
        await writableStream.close();
        return 'saved';
    } catch (e) {
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
    // Still try to save the regular way now.
    }
    try {
        // Namespace is used to prevent conflict w/ Chrome Poper Blocker extension (Issue https://github.com/eligrey/FileSaver.js/issues/561)
        const a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        a.download = fileName;
        a.rel = 'noopener';
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        setTimeout(()=>URL.revokeObjectURL(objectUrl), 40000);
        setTimeout(()=>{
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }, 1);
    } catch (e) {
        (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
        return 'error';
    }
    return 'saved';
}


const $00d7ded47eb0b8eb$export$67ac20532b9ededa = {
    filenameBase: 'Klecks'
};







async function $c6d7c75246b86b1e$export$513413382cb95fd6(psd) {
    const agPsd = await (0, $feca221947269811$export$ab3d838b1d336b38)();
    const buffer = agPsd.writePsdBuffer(psd);
    return new Blob([
        buffer
    ], {
        type: 'image/vnd.adobe.photoshop'
    });
}



async function $2f59a00fe0e77e1d$export$92433b641be3f7a(klCanvas, isPreviewIncluded = true) {
    const layerArr = klCanvas.getLayers();
    let canvas;
    if (isPreviewIncluded) {
        // makes saving less likely to fail
        const c = (0, $94f0b2b810d4d191$export$77f9e426014f6edd)(()=>klCanvas.getCanvas());
        if (!(c instanceof (0, $94f0b2b810d4d191$export$6d5e6de05c94f9f))) canvas = c;
    }
    const psdConfig = {
        width: klCanvas.getWidth(),
        height: klCanvas.getHeight(),
        canvas: canvas,
        children: layerArr.map((item)=>{
            // todo - can be optimized if layer mostly empty
            return {
                name: item.name,
                hidden: !item.isVisible,
                opacity: item.opacity,
                canvas: item.canvas,
                blendMode: (0, $0db3bfb221211901$export$4e3b1f7d3ad623b4)(item.mixModeStr),
                clipping: item.hasClipping,
                left: 0,
                top: 0
            };
        })
    };
    return await (0, $c6d7c75246b86b1e$export$513413382cb95fd6)(psdConfig);
}


class $f55d3ab4307affe5$export$75e7b60500bb415b {
    async save(format = this.getExportType()) {
        const fileBase = (0, $94f0b2b810d4d191$export$27be2b2470a97a3)() + (0, $00d7ded47eb0b8eb$export$67ac20532b9ededa).filenameBase;
        if (format === 'layers') {
            const layers = this.klCanvas.getLayers();
            for(let i = 0; i < layers.length; i++){
                const layer = layers[i];
                const result = await (0, $df54dad6f3bf5943$export$2bc2a80e311129ac)(`${fileBase}_${(i + 1).toString().padStart(2, '0')}_${layer.name}.png`, 'image/png', ()=>(0, $2f436639594531f3$export$403d539f215df596)(layer.canvas, 'image/png'));
                if (result !== 'saved') {
                    if (result === 'error') // todo localise
                    (0, $5f9f54d39d868ac2$export$3879b24e8245693d)('failed PNG export');
                    return result;
                }
            }
            this.onSaved();
            return 'saved';
        }
        let result;
        if (format === 'psd') result = await (0, $df54dad6f3bf5943$export$2bc2a80e311129ac)(`${fileBase}.psd`, 'image/vnd.adobe.photoshop', ()=>(0, $2f59a00fe0e77e1d$export$92433b641be3f7a)(this.klCanvas), this.showsSaveDialog);
        else {
            const mimeType = format === 'jpg' ? 'image/jpeg' : 'image/png';
            result = await (0, $df54dad6f3bf5943$export$2bc2a80e311129ac)(`${fileBase}.${format}`, mimeType, ()=>(0, $2f436639594531f3$export$403d539f215df596)(this.klCanvas.getCanvas(), mimeType), this.showsSaveDialog);
        }
        if (result === 'error') // todo localise
        (0, $5f9f54d39d868ac2$export$3879b24e8245693d)(`failed ${format.toUpperCase()} export`);
        if (result === 'saved') this.onSaved();
        return result;
    }
    setShowsSaveDialog(b) {
        this.showsSaveDialog = b;
    }
    // ----------------------------------- public -----------------------------------
    constructor(getExportType, klCanvas, onSaved){
        this.getExportType = getExportType;
        this.klCanvas = klCanvas;
        this.onSaved = onSaved;
        this.showsSaveDialog = true;
    }
}


class $43d41db2dd7b96c7$export$272bfd3ef9ef2f48 {
    emit(obj, skipSubscriber) {
        for(let i = 0; i < this.subscriberArr.length; i++){
            if (this.subscriberArr[i] === skipSubscriber) continue;
            this.subscriberArr[i](obj);
        }
    }
    emitColor(color, skipSubscriber) {
        this.emit({
            type: 'color',
            value: color
        }, skipSubscriber);
    }
    emitSize(size, skipSubscriber) {
        this.emit({
            type: 'size',
            value: size
        }, skipSubscriber);
    }
    emitOpacity(opacity, skipSubscriber) {
        this.emit({
            type: 'opacity',
            value: opacity
        }, skipSubscriber);
    }
    emitSliderConfig(sliderConfig, skipSubscriber) {
        this.emit({
            type: 'sliderConfig',
            value: sliderConfig
        }, skipSubscriber);
    }
    /**
     * set current brush color
     * @param color
     * @param skipSubscriber
     */ setColor(color, skipSubscriber) {
        this.onSetColor(color);
        this.emitColor(color, skipSubscriber);
    }
    /**
     * set current brush size
     * @param size
     * @param skipSubscriber
     */ setSize(size, skipSubscriber) {
        this.onSetSize(size);
    // why not emitting?
    }
    /**
     * set current opacity
     * @param opacity
     * @param skipSubscriber
     */ setOpacity(opacity, skipSubscriber) {
        this.onSetOpacity(opacity);
    // why not emitting?
    }
    /**
     * get current brush color
     */ getColor() {
        return this.onGetColor();
    }
    getSize() {
        return this.onGetSize();
    }
    getOpacity() {
        return this.onGetOpacity();
    }
    getSliderConfig() {
        return this.onGetSliderConfig();
    }
    /**
     * subscribe to changes
     * @param func
     */ subscribe(func) {
        if (this.subscriberArr.includes(func)) return;
        this.subscriberArr.push(func);
    }
    unsubscribe(func) {
        for(let i = 0; i < this.subscriberArr.length; i++)if (func === this.subscriberArr[i]) {
            this.subscriberArr.splice(i, 1);
            i--;
        }
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.subscriberArr = [];
        this.onSetColor = p.onSetColor;
        this.onSetSize = p.onSetSize;
        this.onSetOpacity = p.onSetOpacity;
        this.onGetColor = p.onGetColor;
        this.onGetSize = p.onGetSize;
        this.onGetOpacity = p.onGetOpacity;
        this.onGetSliderConfig = p.onGetSliderConfig;
        if ($43d41db2dd7b96c7$export$272bfd3ef9ef2f48.instance) throw new Error('BrushSettingService already instantiated');
        $43d41db2dd7b96c7$export$272bfd3ef9ef2f48.instance = this;
    }
}













var $dbd98804af74022e$export$1c6ca1c73436aa3c;
$dbd98804af74022e$export$1c6ca1c73436aa3c = `ttl1Ia_licenses`;







function $0984fe4822f7d2f3$export$d3fe39c7bff44f23() {
    const libraries = (0, $8405ecc79d32770a$export$db3b6bfb95261072)('.' + $dbd98804af74022e$export$1c6ca1c73436aa3c, (0, $fc42a07754814920$export$ce37e184d908d785)('loading'));
    const fonts = (0, $8405ecc79d32770a$export$db3b6bfb95261072)('.' + $dbd98804af74022e$export$1c6ca1c73436aa3c, (0, $fc42a07754814920$export$ce37e184d908d785)('loading'));
    const content = (0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,flexCol,gap-10', [
        libraries,
        fonts
    ]);
    new (0, $5b46848ca200986a$export$185108a9b725b68)({
        title: (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('licenses')
        }),
        content: (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: content,
            css: {
                height: '100%',
                overflowY: 'auto',
                padding: 10,
                boxSizing: 'border-box'
            }
        }),
        width: 800,
        onClose: ()=>{
            if (window.location.hash === '#licenses') history.replaceState('', document.title, window.location.pathname + window.location.search);
        }
    });
    (parcelRequire("l5xTI")).then((result)=>{
        libraries.innerHTML = '';
        result.LICENSES.forEach((item)=>{
            libraries.append((0, $8405ecc79d32770a$export$db3b6bfb95261072)('details', [
                (0, $8405ecc79d32770a$export$db3b6bfb95261072)('summary', item.title),
                (0, $8405ecc79d32770a$export$db3b6bfb95261072)('', item.full.replace(/\n/g, '<br>'))
            ]));
        });
    });
    (parcelRequire("14mcD")).then((result)=>{
        fonts.innerHTML = '';
        result.FONT_LICENSES.forEach((item)=>{
            fonts.append((0, $8405ecc79d32770a$export$db3b6bfb95261072)('details', [
                (0, $8405ecc79d32770a$export$db3b6bfb95261072)('summary', 'Font: ' + item.title),
                (0, $8405ecc79d32770a$export$db3b6bfb95261072)('', item.full.replace(/\n/g, '<br>'))
            ]));
        });
    });
}






const $da7ed42c6ed6e91e$var$bitbofLogoImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('bitbof-logo');
const $da7ed42c6ed6e91e$var$uiSwapImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('ui-swap-lr');
class $da7ed42c6ed6e91e$export$ad7f6c626a2cdfad {
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor({ onLeftRight: onLeftRight, saveReminder: saveReminder, customAbout: customAbout }){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                margin: '10px 10px 0'
            }
        });
        // ---- language ----
        const autoLanguage = (0, $fc42a07754814920$export$e4ce066d17694649).getAutoLanguage();
        const langWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            content: (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: [
                    (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('language', {
                        height: 20
                    }),
                    (0, $fc42a07754814920$export$ce37e184d908d785)('settings-language') + ':'
                ],
                css: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5,
                    marginRight: 5,
                    marginBottom: 2
                }
            }),
            css: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap'
            }
        });
        const options = [
            [
                'auto',
                (0, $fc42a07754814920$export$ce37e184d908d785)('auto') + ` \u{2192} ${autoLanguage.name} (${autoLanguage.code})`
            ],
            ...(0, $a5daeddf2bf68f96$export$d0d68bb9ed2c643d).map((item)=>{
                return [
                    item.code,
                    item.name + ` (${item.code})`
                ];
            })
        ];
        const languageSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
            initValue: (0, $94f0b2b810d4d191$export$d802c22d109d9806)((0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem((0, $fc42a07754814920$export$991796128b2ca217)) ? (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem((0, $fc42a07754814920$export$991796128b2ca217)) : 'auto'),
            optionArr: options,
            onChange: (val)=>{
                if (val === 'auto') (0, $7a8f101d3676d17a$export$19fffca37ef3e106).removeItem((0, $fc42a07754814920$export$991796128b2ca217));
                else (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem((0, $fc42a07754814920$export$991796128b2ca217), val);
                languageHint.style.display = 'block';
            },
            name: 'language'
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(languageSelect.getElement(), {
            flexGrow: 1
        });
        const languageHint = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-toolspace-note',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('settings-language-reload'),
            css: {
                display: 'none',
                marginTop: 5,
                flexGrow: 1
            }
        });
        langWrapper.append(languageSelect.getElement(), languageHint);
        // ---- theme ----
        function themeToLabel(theme) {
            return theme === 'dark' ? "\u2B1B " + (0, $fc42a07754814920$export$ce37e184d908d785)('theme-dark') : "\u2B1C " + (0, $fc42a07754814920$export$ce37e184d908d785)('theme-light');
        }
        const themeSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
            optionArr: [
                [
                    'auto',
                    (0, $fc42a07754814920$export$ce37e184d908d785)('auto') + " \u2192 " + themeToLabel((0, $96c8dd5f33e03504$export$5714e40777c1bcc2).getMediaQueryTheme())
                ],
                [
                    'light',
                    themeToLabel('light')
                ],
                [
                    'dark',
                    themeToLabel('dark')
                ]
            ],
            initValue: (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).getStoredTheme() || 'auto',
            onChange: (val)=>{
                (0, $96c8dd5f33e03504$export$5714e40777c1bcc2).setStoredTheme(val === 'auto' ? undefined : val);
            },
            name: 'ui-theme'
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(themeSelect.getElement(), {
            flexGrow: 1
        });
        (0, $94f0b2b810d4d191$export$a9dfd81f95a8a526)(()=>{
            themeSelect.updateLabel('auto', (0, $fc42a07754814920$export$ce37e184d908d785)('auto') + " \u2192 " + themeToLabel((0, $96c8dd5f33e03504$export$5714e40777c1bcc2).getMediaQueryTheme()));
        });
        (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            content: [
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    content: (0, $fc42a07754814920$export$ce37e184d908d785)('settings-theme') + ':',
                    css: {
                        marginRight: 5,
                        marginBottom: 2
                    }
                }),
                themeSelect.getElement()
            ],
            css: {
                marginTop: 15,
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap'
            }
        });
        // ---- pixelated zoom ----
        const pixelatedZoomToggle = new (0, $2ca2f462d49915a5$export$25614a4cab357476)();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(pixelatedZoomToggle.getElement(), {
            marginTop: 15
        });
        this.rootEl.append(pixelatedZoomToggle.getElement());
        // ---- save reminder ----
        if (saveReminder) {
            const reminderSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
                optionArr: [
                    [
                        '20min',
                        (0, $fc42a07754814920$export$ce37e184d908d785)('x-minutes', {
                            x: '20'
                        })
                    ],
                    [
                        '40min',
                        (0, $fc42a07754814920$export$ce37e184d908d785)('x-minutes', {
                            x: '40'
                        })
                    ],
                    [
                        'disabled',
                        "\u26A0\uFE0F " + (0, $fc42a07754814920$export$ce37e184d908d785)('settings-save-reminder-disabled')
                    ]
                ],
                initValue: saveReminder.getSetting(),
                onChange: (val)=>{
                    if (val !== 'disabled') {
                        saveReminder.setSetting(val);
                        return;
                    }
                    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                        message: "\u26A0\uFE0F" + (0, $fc42a07754814920$export$ce37e184d908d785)('settings-save-reminder-confirm-title'),
                        div: (0, $8405ecc79d32770a$export$db3b6bfb95261072)('', [
                            (0, $8405ecc79d32770a$export$db3b6bfb95261072)('.info-hint', (0, $fc42a07754814920$export$ce37e184d908d785)('settings-save-reminder-confirm-a')),
                            (0, $fc42a07754814920$export$ce37e184d908d785)('settings-save-reminder-confirm-b')
                        ]),
                        buttons: [
                            {
                                id: 'disable',
                                label: (0, $fc42a07754814920$export$ce37e184d908d785)('settings-save-reminder-confirm-disable')
                            },
                            'Cancel'
                        ],
                        callback: (result)=>{
                            if (result === 'disable') saveReminder.setSetting(val);
                            else reminderSelect.setValue(saveReminder.getSetting());
                        }
                    });
                },
                name: 'save-reminder-interval'
            });
            reminderSelect.getElement().style.flexGrow = '1';
            this.rootEl.append((0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,items-center,gap-5,mt-15,flexWrap', [
                (0, $fc42a07754814920$export$ce37e184d908d785)('settings-save-reminder-label') + ':',
                reminderSelect.getElement()
            ]));
        }
        // ---- flip ui ----
        (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            parent: this.rootEl,
            content: [
                (0, $9e4d66c06c67fa7f$export$ec664d7487540b)({
                    alt: 'icon',
                    src: $da7ed42c6ed6e91e$var$uiSwapImg,
                    width: 18,
                    height: 20,
                    css: {
                        marginRight: 5
                    }
                }),
                (0, $fc42a07754814920$export$ce37e184d908d785)('switch-ui-left-right')
            ],
            onClick: ()=>onLeftRight(),
            css: {
                marginTop: 15
            },
            props: {
                tabIndex: -1
            }
        });
        // ---- about ----
        this.rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'grid-hr',
            css: {
                margin: '10px 0'
            }
        }));
        function makeLicenses() {
            return (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'a',
                content: (0, $fc42a07754814920$export$ce37e184d908d785)('licenses'),
                onClick: ()=>(0, $0984fe4822f7d2f3$export$d3fe39c7bff44f23)()
            });
        }
        if (customAbout) {
            this.rootEl.append(customAbout);
            if (!customAbout.innerHTML) {
                const minimalAbout = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    parent: customAbout,
                    css: {
                        textAlign: 'center'
                    }
                });
                minimalAbout.append((0, $be957da3610487e9$export$921068d8846a1559).el({
                    content: [
                        (0, $9e4d66c06c67fa7f$export$ec664d7487540b)({
                            alt: 'icon',
                            height: 20,
                            src: $da7ed42c6ed6e91e$var$bitbofLogoImg,
                            css: {
                                verticalAlign: 'middle'
                            }
                        }),
                        ' ',
                        (0, $be957da3610487e9$export$921068d8846a1559).el({
                            tagName: 'a',
                            content: 'bitbof',
                            props: {
                                href: 'https://bitbof.com',
                                target: '_blank',
                                tabIndex: -1
                            }
                        }),
                        " \xa9 2026",
                        (0, $be957da3610487e9$export$921068d8846a1559).el({
                            tagName: 'br'
                        })
                    ]
                }), makeLicenses());
            }
        } else {
            const versionEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: this.rootEl,
                css: {
                    textAlign: 'center'
                },
                content: [
                    (0, $9e4d66c06c67fa7f$export$ec664d7487540b)({
                        alt: 'Klecks',
                        className: 'dark-invert',
                        height: 25,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b7b1802c3f8fdaa5$exports)))
                    }),
                    (0, $be957da3610487e9$export$921068d8846a1559).el({
                        tagName: 'br'
                    }),
                    (0, $9e4d66c06c67fa7f$export$ec664d7487540b)({
                        alt: 'icon',
                        height: 20,
                        src: $da7ed42c6ed6e91e$var$bitbofLogoImg,
                        css: {
                            verticalAlign: 'middle'
                        }
                    }),
                    ' ',
                    (0, $be957da3610487e9$export$921068d8846a1559).el({
                        tagName: 'a',
                        content: 'bitbof',
                        props: {
                            href: 'https://bitbof.com',
                            target: '_blank',
                            tabIndex: -1
                        }
                    }),
                    " \xa9 2025",
                    (0, $be957da3610487e9$export$921068d8846a1559).el({
                        tagName: 'br'
                    })
                ]
            });
            versionEl.append(makeLicenses(), document.createTextNode(' | '), (0, $be957da3610487e9$export$921068d8846a1559).el({
                tagName: 'a',
                content: (0, $fc42a07754814920$export$ce37e184d908d785)('source-code'),
                props: {
                    href: 'https://klecks.org',
                    target: '_blank'
                }
            }));
        }
        window.addEventListener('storage', (e)=>{
            if (e.key !== (0, $fc42a07754814920$export$991796128b2ca217)) return;
            languageSelect.setValue((0, $94f0b2b810d4d191$export$d802c22d109d9806)((0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem((0, $fc42a07754814920$export$991796128b2ca217)) ? (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem((0, $fc42a07754814920$export$991796128b2ca217)) : 'auto'));
        });
    }
}






class $1cc127d09feb3354$export$42a534af7eb650e8 {
    update() {
        let newUpDisplay = this.upBtn.style.display;
        let newDownDisplay = this.downBtn.style.display;
        if (this.toolspace.scrollHeight > this.toolspace.offsetHeight + 3) {
            // small buffer where it's not worth it
            if (!this.upInterval) newUpDisplay = this.toolspace.scrollTop === 0 ? 'none' : 'block';
            if (!this.downInterval) newDownDisplay = this.toolspace.scrollTop + this.toolspace.offsetHeight + 1 >= this.toolspace.scrollHeight ? 'none' : 'block';
        } else {
            newUpDisplay = 'none';
            newDownDisplay = 'none';
        }
        // check to prevent infinite MutationObserver loop in Pale Moon
        if (newUpDisplay !== this.upBtn.style.display) this.upBtn.style.display = newUpDisplay;
        if (newDownDisplay !== this.downBtn.style.display) this.downBtn.style.display = newDownDisplay;
    }
    updateUiState(uiState) {
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.upBtn, {
            left: uiState === 'left' ? 0 : '',
            right: uiState === 'right' ? 0 : ''
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.downBtn, {
            left: uiState === 'left' ? 0 : '',
            right: uiState === 'right' ? 0 : ''
        });
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.toolspace = p.toolspace;
        this.upBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.toolspace,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('scroll'),
            className: 'kl-scroller',
            css: {
                top: 0,
                transform: 'rotate(180deg)'
            }
        });
        this.downBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.toolspace,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('scroll'),
            className: 'kl-scroller',
            css: {
                bottom: 0
            }
        });
        this.updateUiState(p.uiState);
        const upListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.upBtn,
            onPointer: (e)=>{
                if (e.type === 'pointerdown') {
                    clearInterval(this.upInterval);
                    this.upInterval = setInterval(()=>{
                        this.toolspace.scrollBy(0, -13);
                        this.update();
                    }, 20);
                }
                if (e.type === 'pointerup') {
                    const interval = this.upInterval;
                    clearInterval(interval);
                    setTimeout(()=>{
                        if (this.upInterval !== interval) return;
                        // prevent ff clicking something underneath
                        this.upInterval = undefined;
                        this.update();
                    }, 50);
                }
            }
        });
        const downListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.downBtn,
            onPointer: (e)=>{
                if (e.type === 'pointerdown') {
                    clearInterval(this.downInterval);
                    this.downInterval = setInterval(()=>{
                        this.toolspace.scrollBy(0, 13);
                        this.update();
                    }, 20);
                }
                if (e.type === 'pointerup') {
                    const interval = this.downInterval;
                    clearInterval(interval);
                    setTimeout(()=>{
                        if (this.downInterval !== interval) return;
                        // prevent ff clicking something underneath
                        this.downInterval = undefined;
                        this.update();
                    }, 50);
                }
            }
        });
        const wheelListener = (e)=>{
            this.toolspace.scrollBy(0, Math.round(0.7 * e.deltaY));
            this.update();
        };
        this.upBtn.addEventListener('wheel', wheelListener, {
            passive: false
        });
        this.downBtn.addEventListener('wheel', wheelListener, {
            passive: false
        });
        this.update();
        const observer = new MutationObserver(()=>this.update());
        observer.observe(this.toolspace, {
            attributes: true,
            childList: true,
            subtree: true
        });
        window.addEventListener('resize', ()=>this.update());
        // hide if in dialog because that can have its own scrollbar
        (0, $a0bbbeb927a78bac$export$d3d1650bc39c4419).subscribe((v)=>{
            // ignores the 0.5 by tool dropdown
            this.upBtn.style.opacity = v >= 1 ? '0' : '';
            this.downBtn.style.opacity = v >= 1 ? '0' : '';
        });
    }
}








class $935716a523cb7d78$export$7fa03d1ef9d3489e {
    updateIcons() {
        const col1 = this.settings.isReversed ? '#0000' : '#000';
        const col2 = this.settings.isReversed ? '#000' : '#0000';
        this.iconArr[0].style.background = `linear-gradient(${col1}, ${col2})`;
        this.iconArr[1].style.background = `linear-gradient(${col2}, ${col1}, ${col2})`;
        this.iconArr[2].style.background = `radial-gradient(${col1}, ${col2})`;
    }
    getElement() {
        return this.rootEl;
    }
    setIsVisible(isVisible) {
        this.isVisible = isVisible;
        this.rootEl.style.display = isVisible ? 'block' : 'none';
        if (isVisible) this.colorDiv.append(this.colorSlider.getElement(), this.colorSlider.getOutputElement());
    }
    getSettings() {
        return (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.settings);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.settings = {
            opacity: 1,
            type: 'linear',
            doLockAlpha: false,
            doSnap: false,
            isReversed: false,
            isEraser: false
        };
        this.colorSlider = p.colorSlider;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                margin: '10px 10px 0'
            }
        });
        this.isVisible = true;
        this.colorDiv = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                marginBottom: 10
            }
        });
        this.iconArr = [];
        {
            const size = 33;
            [
                0,
                1,
                2
            ].forEach(()=>{
                const el = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    className: 'dark-invert',
                    css: {
                        width: size,
                        height: size,
                        borderRadius: 3,
                        margin: 1
                    }
                });
                this.iconArr.push(el);
            });
        }
        this.updateIcons();
        const typeOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'linear',
                    label: this.iconArr[0],
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('gradient-linear')
                },
                {
                    id: 'linear-mirror',
                    label: this.iconArr[1],
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('gradient-linear-mirror')
                },
                {
                    id: 'radial',
                    label: this.iconArr[2],
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('gradient-radial')
                }
            ],
            initId: 'linear',
            onChange: (id)=>{
                this.settings.type = id;
            }
        });
        this.rootEl.append(typeOptions.getElement());
        const opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
            width: 250,
            height: 30,
            min: 0.01,
            max: 1,
            value: this.settings.opacity,
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100,
            onChange: (val)=>{
                this.settings.opacity = val;
            }
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(opacitySlider.getElement(), {
            marginTop: 10
        });
        this.rootEl.append(opacitySlider.getElement());
        const row1 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: 10
            }
        });
        const reverseToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('reverse'),
            callback: (b)=>{
                this.settings.isReversed = b;
                this.updateIcons();
            },
            css: {
                width: '50%'
            },
            name: 'reverse-gradient'
        });
        const doSnapToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('angle-snap'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('angle-snap-title'),
            callback: (b)=>{
                this.settings.doSnap = b;
            },
            css: {
                width: '50%'
            },
            name: 'enable-snapping'
        });
        row1.append(reverseToggle.getElement(), doSnapToggle.getElement());
        const row2 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: 10
            }
        });
        const eraserToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: this.settings.isEraser,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('eraser'),
            callback: (b)=>{
                this.settings.isEraser = b;
            },
            css: {
                width: '50%'
            },
            name: 'enable-eraser'
        });
        const lockAlphaToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('lock-alpha-title'),
            callback: (b)=>{
                this.settings.doLockAlpha = b;
            },
            doHighlight: true,
            css: {
                width: '50%'
            },
            name: 'enable-alpha-lock'
        });
        row2.append(eraserToggle.getElement(), lockAlphaToggle.getElement());
    }
}



const $25422d204ef184a3$export$6e4a713ddcda1e5e = {
    BRUSHES: // --- brushes ---
    $5f374c2505ee6174$export$32510733a89b2eab,
    BRUSHES_UI: $3349ef033c680bf8$export$d1a79a5ce7e46547,
    BrushSettingService: $43d41db2dd7b96c7$export$272bfd3ef9ef2f48,
    KlCanvas: // --- canvas ---
    $a919a1fb23b6c719$export$4a819bde91671014,
    KlCanvasPreview: // --- canvas ui ---
    $8960a416cd34201a$export$e258ade1648009b7,
    FILTER_LIB_STATUS: // --- filters ---
    $b20d6b230a6e6f94$export$24724bc1f91cba3,
    FILTER_LIB: $b20d6b230a6e6f94$export$bac24f240bb7727d,
    ShapeTool: // --- image operations ---
    $03d72c2b76715beb$export$27550cc14d7ae85a,
    drawShape: $03d72c2b76715beb$export$71b514a25c47df50,
    GradientTool: $abbf5f9031f83ecb$export$74d12f09ff9f1956,
    drawGradient: $abbf5f9031f83ecb$export$b1f70a113e3b5c1b,
    PSD: // --- storage ---
    $0db3bfb221211901$exports,
    ProjectStore: $37813638caeb4048$export$93d91060b9af7e2a,
    loadAgPsd: $feca221947269811$export$ab3d838b1d336b38,
    SaveToComputer: $f55d3ab4307affe5$export$75e7b60500bb415b,
    Checkbox: // --- ui - components ---
    $be3050d362858227$export$48513f6b9f8ce62d,
    Select: $5b4df30e3b8eea04$export$ef9b1a59e592288f,
    ImageToggle: $fdd030cdfa4412e2$export$b6d053cded550773,
    ImageRadioList: $f3056e554051c8ed$export$7cc1012a658e6ad8,
    RadioList: $5b8a0fd740d86863$export$3dff5655255b5729,
    createPenPressureToggle: $7a8db4f517a189fb$export$9da2e8821e6cbb57,
    KlSlider: $886527ea181efb50$export$a1855b925e534de7,
    KlColorSlider: $14647f881f00eb2f$export$4e5102252876c5d7,
    KlColorSliderSmall: $845fa9514537a3d1$export$66306bf21a9ff39e,
    PointSlider: $94a8fc3859482fa7$export$ac00cea56cec3037,
    ColorOptions: $115e148fb390275d$export$24ba9b81662d4366,
    Options: $bf43abcd46abf209$export$c019608e5b5bb4cb,
    BoxToggle: $0b383e4686740404$export$2358c75ad3c15b2d,
    StatusOverlay: $d36f61f1e82ce977$export$5ee0af1d5c87e856,
    CropCopy: $67988e2254ac179d$export$40175a5948a88a57,
    FreeTransform: $93e6a53ec76e8c56$export$79a74567acf241b0,
    FreeTransformCanvas: $6f7fb59adaa892d0$export$205c2dd29f8a66b5,
    Cropper: $0a5c1a04b3d5c21e$export$71ed2b85d4ca43d3,
    LayerPreview: $d68260f31c92ba6d$export$d25420b53e16716f,
    KlImageDropper: $78d0d4fee3100d15$export$e789742143ba5b1,
    OverlayToolspace: $a77c2094a41ced02$export$9f0da9b942594e99,
    ToolspaceTopRow: $e3cc87398ab80fdb$export$665d2c76b1eb8459,
    ToolDropdown: $d45d7d6cdafbb300$export$a0a40f8a0b8fee15,
    ToolspaceToolRow: $3fde918673ae1534$export$c744a22bef9e0b97,
    ToolspaceStabilizerRow: $e1a1e20314346e6a$export$8162a66cd18867a7,
    TabRow: $edc0a3ccf2e6e858$export$3c6d17ed0106bfb9,
    ToolspaceCollapser: $0fd797091a3b795f$export$5b91f641162972fc,
    BrowserStorageUi: $293199167ef511c0$export$9c72cf485ef46673,
    SaveReminder: $0e4cfd755d2d08c9$export$befc6437ad34b28a,
    ToolspaceScroller: $1cc127d09feb3354$export$42a534af7eb650e8,
    DIALOG_COUNTER: // --- ui - modals ---
    $a0bbbeb927a78bac$export$d3d1650bc39c4419,
    Popup: (0, $5b46848ca200986a$export$185108a9b725b68),
    clipboardDialog: $9e1eaf0318480dae$export$32b89bc9bb92706a,
    showImportAsLayerDialog: $e8feadb2d03819a1$export$962af7e240721d88,
    newImageDialog: $fdf168f2047100ce$export$f77a89101d7d6586,
    textToolDialog: $7cc2fdc4e73ab40f$export$e263e067d6140649,
    showImportImageDialog: $be4deef280a7a6e1$export$1bf16d9bd59fd8f9,
    showIframePopup: (0, $331e59f8d60fc7d5$export$35fa34e5af64bd4a),
    imgurUpload: $7397051ecf5bd725$export$b1dd62fa0b5f32f5,
    HandUi: // --- ui - tool tabs ---
    $5e18205c4f161db6$export$cf20160367bae46c,
    FillUi: $4a31907be1a52177$export$1e63e3b0645421a2,
    GradientUi: $935716a523cb7d78$export$7fa03d1ef9d3489e,
    TextUi: $64657866f1638f3a$export$32a22540e4b2f123,
    ShapeUi: $cf0fd9945673d580$export$a9387b1d4260d39c,
    FileUi: $cde4cf070b2d06de$export$409b892ffe02580b,
    EditUi: $e17225f381c762c7$export$aeb1a0a0e64541b5,
    SettingsUi: $da7ed42c6ed6e91e$export$ad7f6c626a2cdfad,
    LayersUi: $385cb86a8c70e1f3$export$c3bf51e04f391d6d
};
Object.keys($25422d204ef184a3$export$6e4a713ddcda1e5e); // without this, parcel build may break this object







const $6bf9aa70e7adafe5$var$uiSwapImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('ui-swap-lr');
class $6bf9aa70e7adafe5$export$ce26cd3db18613a3 {
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-toolspace-row',
            css: {
                height: 36,
                display: 'flex'
            }
        });
        function createButton(p) {
            const padding = 6 + (p.extraPadding ? p.extraPadding : 0);
            const el = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'toolspace-row-button nohighlight',
                title: p.title,
                onClick: p.onClick,
                css: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: p.content ? '' : p.contain ? padding + 'px 0' : ''
                }
            });
            if (p.content) el.append(p.content);
            else {
                const im = (0, $be957da3610487e9$export$921068d8846a1559).el({
                    className: 'dark-invert',
                    css: {
                        backgroundImage: "url('" + p.image + "')",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: p.contain ? 'contain' : '',
                        width: '100%',
                        height: '100%'
                    }
                });
                im.style.pointerEvents = 'none';
                el.append(im);
            }
            const pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                // because :hover causes problems w touch
                target: el,
                onEnterLeave: function(isOver) {
                    el.classList.toggle('toolspace-row-button-hover', isOver);
                }
            });
            return {
                el: el,
                pointerListener: pointerListener
            };
        }
        const submitButton = createButton({
            onClick: p.onSubmit,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('submit-title'),
            content: (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: (0, $fc42a07754814920$export$ce37e184d908d785)('submit'),
                className: 'toolspace-row-button__submit',
                css: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%'
                }
            }),
            contain: true
        });
        submitButton.el.style.width = '45px';
        const helpButton = createButton({
            onClick: p.onHelp,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('help'),
            content: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('help', {
                width: 24,
                height: 24,
                opacity: 0.9
            }),
            contain: true
        });
        helpButton.el.style.flexBasis = '0';
        const leftRightButton = createButton({
            onClick: p.onLeftRight,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('switch-ui-left-right'),
            image: $6bf9aa70e7adafe5$var$uiSwapImg,
            contain: true
        });
        this.rootEl.append(submitButton.el, leftRightButton.el, helpButton.el);
    }
}




const $e4c19eeb23d51669$export$f02de051ab70b20e = 60;












class $edd68b64db3c6175$export$94ec999f33a691e3 {
    ensureViewportSize(width, height) {
        width = Math.max(1, Math.round(width));
        height = Math.max(1, Math.round(height));
        if (!this.fxCanvas.getIsInitialized() || this.fxCanvas.canvas.width !== width || this.fxCanvas.canvas.height !== height) this.fxCanvas.initialize(width, height);
        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.textureSource, width, height);
        if (this.selection) {
            if (!this.maskCanvas) this.maskCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(width, height);
            else (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(this.maskCanvas, width, height, {
                ensureCleared: true
            });
        }
        return {
            width: width,
            height: height
        };
    }
    updateMask(viewportMat) {
        if (!this.selection || !this.maskCanvas) return undefined;
        const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.maskCanvas);
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = 'source-over';
        ctx.fillStyle = 'black';
        const transformedSelection = (0, $5f00e0232038b1be$export$aa391dbbf8073422)(this.selection, viewportMat);
        (0, $2f436639594531f3$export$f7b95c0f504bef8b)(transformedSelection, ctx);
        if (this.maskTexture) this.maskTexture.loadContentsOf(this.maskCanvas);
        else this.maskTexture = this.fxCanvas.texture(this.maskCanvas);
        return this.maskTexture;
    }
    getImageToFxTransform(viewportTransform, width, height) {
        const viewportMat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(viewportTransform);
        const viewportToImageMat = (0, $fd04355d00b81239$export$70ae2c07e401031b)(viewportMat);
        const visibleWidth = Math.abs(viewportToImageMat.a) * width + Math.abs(viewportToImageMat.c) * height;
        const visibleHeight = Math.abs(viewportToImageMat.b) * width + Math.abs(viewportToImageMat.d) * height;
        if (visibleWidth > width || visibleHeight > height) return {
            matrix: viewportMat,
            transform: viewportTransform
        };
        const viewportCenterInImage = (0, $43e83319b765a157$export$9b20165a36586806)(viewportToImageMat, {
            x: width / 2,
            y: height / 2
        });
        const imageOriginX = Math.round(viewportCenterInImage.x - width / 2);
        const imageOriginY = Math.round(viewportCenterInImage.y - height / 2);
        const transform = {
            scaleX: 1,
            scaleY: 1,
            angleDeg: 0,
            x: -imageOriginX,
            y: -imageOriginY
        };
        return {
            matrix: (0, $15f17d2145582868$export$d73ee8ef04f5226a)(transform.x, transform.y),
            transform: transform
        };
    }
    setPostMix(postMix) {
        this.postMix = postMix;
    }
    destroy() {
        (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.textureSource);
        this.maskCanvas && (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.maskCanvas);
        this.texture.destroy();
        this.maskTexture?.destroy();
        this.unfilteredTexture?.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.maskTexture = undefined;
        this.unfilteredTexture = undefined;
        this.render = (viewportTransform, viewportWidth, viewportHeight)=>{
            const viewportSize = this.ensureViewportSize(viewportWidth, viewportHeight);
            const imageToFx = this.getImageToFxTransform(viewportTransform, viewportSize.width, viewportSize.height);
            const adjustedDrawMatrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)(imageToFx.matrix, (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(this.original.width / viewportSize.width, this.original.height / viewportSize.height));
            const maskTexture = this.updateMask(imageToFx.matrix);
            this.fxCanvas.drawTransformed(this.texture, adjustedDrawMatrix);
            if (maskTexture && !this.isMaskingWithEmptyOriginal) {
                if (this.unfilteredTexture) this.fxCanvas.copyTo(this.unfilteredTexture);
                else this.unfilteredTexture = this.fxCanvas.contents();
            }
            this.onUpdate(this.fxCanvas, imageToFx.transform);
            if (maskTexture) this.fxCanvas.multiplyAlpha().mask(maskTexture, this.isMaskingWithEmptyOriginal ? undefined : this.unfilteredTexture, true).unmultiplyAlpha();
            this.fxCanvas.maskRect(adjustedDrawMatrix).update();
            if (this.postMix) {
                // original
                this.ctx.save();
                this.ctx.setTransform(...(0, $2f436639594531f3$export$83e8ab53904f8022));
                this.ctx.clearRect(0, 0, this.textureSource.width, this.textureSource.height);
                this.ctx.imageSmoothingEnabled = false;
                this.ctx.setTransform(...(0, $f7c026d16783f524$export$2b60e7dafdbde18a)(imageToFx.matrix));
                this.ctx.drawImage(this.original, 0, 0);
                this.ctx.restore();
                // mix with filtered
                this.ctx.save();
                this.ctx.setTransform(...(0, $2f436639594531f3$export$83e8ab53904f8022));
                this.ctx.globalAlpha = this.postMix.opacity;
                this.ctx.globalCompositeOperation = this.postMix.operation;
                this.ctx.drawImage(this.fxCanvas.canvas, 0, 0);
                this.ctx.restore();
                return {
                    image: this.textureSource,
                    transform: (0, $fd04355d00b81239$export$70ae2c07e401031b)(imageToFx.matrix)
                };
            }
            return {
                image: this.fxCanvas.canvas,
                transform: (0, $fd04355d00b81239$export$70ae2c07e401031b)(imageToFx.matrix)
            };
        };
        this.original = p.original;
        this.onUpdate = p.onUpdate;
        this.textureSource = (0, $be957da3610487e9$export$921068d8846a1559).canvas(1, 1);
        this.ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(this.textureSource);
        this.fxCanvas = (0, $94f0b2b810d4d191$export$b813e062795b89b5)((0, $b225623fe00a4a24$export$8c4423af32b21158)());
        this.texture = this.fxCanvas.texture(this.original);
        this.texture.setSampling('linear', 'nearest');
        this.postMix = p.postMix;
        this.selection = p.selection;
        this.isMaskingWithEmptyOriginal = !!p.isMaskingWithEmptyOriginal;
    }
}












function $6b8a42764b141679$export$66c6ccb6bcae2c94(context, selection, applyFn, klHistory) {
    const fxCanvas = (0, $b225623fe00a4a24$export$8c4423af32b21158)();
    if (!fxCanvas) return false; // todo more specific error?
    let maskTexture;
    if (selection) {
        const maskCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(context.canvas.width, context.canvas.height);
        const maskContext = (0, $be957da3610487e9$export$921068d8846a1559).ctx(maskCanvas);
        (0, $2f436639594531f3$export$f7b95c0f504bef8b)(selection, maskContext);
        maskTexture = fxCanvas.texture(maskCanvas);
        (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(maskCanvas);
    }
    const originalTexture = fxCanvas.texture(context.canvas);
    fxCanvas.draw(originalTexture);
    applyFn(fxCanvas);
    if (maskTexture) {
        fxCanvas.multiplyAlpha().mask(maskTexture, originalTexture, true).unmultiplyAlpha();
        maskTexture.destroy();
    }
    originalTexture.destroy();
    fxCanvas.update();
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    context.drawImage(fxCanvas.canvas, 0, 0);
    klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(klHistory.getComposed(), (0, $3aa9c52208735678$export$7b1ba44282f9a519)(context.canvas, selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(selection, 'index') : undefined)));
    return true;
}



const $723c041f93902536$export$af433fb90aa90a38 = {
    getDialog (params) {
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        let brightness = 0, contrast = 0;
        const fxPreviewRenderer = new (0, $edd68b64db3c6175$export$94ec999f33a691e3)({
            original: layer.canvas,
            onUpdate: (fxCanvas)=>{
                return fxCanvas.brightnessContrast(brightness, contrast);
            },
            selection: klCanvas.getSelection()
        });
        const brightnessSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-bright-contrast-brightness'),
            width: 300,
            height: 30,
            min: 0,
            max: 100,
            value: (brightness + 1) * 50,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            onChange: function(val) {
                brightness = val / 50 - 1;
                preview.render();
            }
        });
        const contrastSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-bright-contrast-contrast'),
            width: 300,
            height: 30,
            min: 0,
            max: 100,
            value: (contrast + 1) * 50,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            onChange: function(val) {
                contrast = val / 50 - 1;
                preview.render();
            }
        });
        brightnessSlider.getElement().style.marginBottom = '10px';
        contrastSlider.getElement().style.marginBottom = '10px';
        rootEl.append(brightnessSlider.getElement(), contrastSlider.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: -20,
            marginRight: -20
        });
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            brightnessSlider.destroy();
            contrastSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                brightness: brightness,
                contrast: contrast
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const brightness = params.input.brightness;
        const contrast = params.input.contrast;
        const klHistory = params.klHistory;
        if (!context) return false;
        return (0, $6b8a42764b141679$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.brightnessContrast(brightness, contrast);
        }, klHistory);
    }
};









function $0ae6ca2088382149$var$cornersToRect({ tl: tl, br: br }) {
    return {
        x: tl.x,
        y: tl.y,
        width: br.x - tl.x,
        height: br.y - tl.y
    };
}
function $0ae6ca2088382149$var$rectToCorners(rect) {
    return {
        tl: {
            x: rect.x,
            y: rect.y
        },
        br: {
            x: rect.x + rect.width,
            y: rect.y + rect.height
        }
    };
}
const $0ae6ca2088382149$var$minSize = 1;
function $0ae6ca2088382149$var$resizeTop(corners, d, { maxHeight: maxHeight }) {
    const y = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(corners.tl.y + d.y, corners.br.y - maxHeight, corners.br.y - $0ae6ca2088382149$var$minSize);
    return {
        tl: {
            x: corners.tl.x,
            y: y
        },
        br: corners.br
    };
}
function $0ae6ca2088382149$var$resizeBottom(corners, d, { maxHeight: maxHeight }) {
    const y = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(corners.br.y + d.y, corners.tl.y + $0ae6ca2088382149$var$minSize, corners.tl.y + maxHeight);
    return {
        tl: corners.tl,
        br: {
            x: corners.br.x,
            y: y
        }
    };
}
function $0ae6ca2088382149$var$resizeLeft(corners, d, { maxWidth: maxWidth }) {
    const x = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(corners.tl.x + d.x, corners.br.x - maxWidth, corners.br.x - $0ae6ca2088382149$var$minSize);
    return {
        tl: {
            x: x,
            y: corners.tl.y
        },
        br: corners.br
    };
}
function $0ae6ca2088382149$var$resizeRight(corners, d, { maxWidth: maxWidth }) {
    const x = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(corners.br.x + d.x, corners.tl.x + $0ae6ca2088382149$var$minSize, corners.tl.x + maxWidth);
    return {
        tl: corners.tl,
        br: {
            x: x,
            y: corners.br.y
        }
    };
}
function $0ae6ca2088382149$var$resizeWidth(corners, dWidth, { maxWidth: maxWidth }) {
    const centerX = (corners.tl.x + corners.br.x) / 2;
    const width = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(corners.br.x - corners.tl.x + dWidth, $0ae6ca2088382149$var$minSize, maxWidth);
    return {
        tl: {
            x: centerX - width / 2,
            y: corners.tl.y
        },
        br: {
            x: centerX + width / 2,
            y: corners.br.y
        }
    };
}
function $0ae6ca2088382149$var$resizeHeight(corners, dHeight, { maxHeight: maxHeight }) {
    const centerY = (corners.tl.y + corners.br.y) / 2;
    const height = (0, $4c2c6808296c0d73$export$7d15b64cf5a3a4c4)(corners.br.y - corners.tl.y + dHeight, $0ae6ca2088382149$var$minSize, maxHeight);
    return {
        tl: {
            x: corners.tl.x,
            y: centerY - height / 2
        },
        br: {
            x: corners.br.x,
            y: centerY + height / 2
        }
    };
}
class $0ae6ca2088382149$export$e6a7b4950e556057 extends (0, $0a5c1a04b3d5c21e$export$71ed2b85d4ca43d3) {
    setViewportTransform(viewportTransform) {
        this.viewportTransform = {
            ...viewportTransform
        };
        this.render();
    }
    constructor(p){
        const options = {
            maxWidth: p.maxWidth,
            maxHeight: p.maxHeight
        };
        let wasSymmetric = false;
        super({
            ...p,
            processEvent: (change)=>{
                if (change.type === 'start') {
                    const value = this.getValue();
                    this.cropCorners = $0ae6ca2088382149$var$rectToCorners(value);
                    return value;
                }
                // no rotation for now
                const dX = change.dX / this.viewportTransform.scale;
                const dY = change.dY / this.viewportTransform.scale;
                const d = {
                    x: dX,
                    y: dY
                };
                if (change.type === 'move') this.cropCorners = {
                    tl: (0, $77055f1820134609$export$ac4bca90992eed1).add(this.cropCorners.tl, d),
                    br: (0, $77055f1820134609$export$ac4bca90992eed1).add(this.cropCorners.br, d)
                };
                else if (change.type === 'resize') {
                    if (change.isSymmetric && !wasSymmetric) // else they're not in sync
                    this.cropCorners = $0ae6ca2088382149$var$rectToCorners(this.getValue());
                    wasSymmetric = change.isSymmetric;
                    if (change.direction.includes('w')) {
                        if (change.isSymmetric) this.cropCorners = $0ae6ca2088382149$var$resizeWidth(this.cropCorners, -2 * d.x, options);
                        else this.cropCorners = $0ae6ca2088382149$var$resizeLeft(this.cropCorners, d, options);
                    } else if (change.direction.includes('e')) {
                        if (change.isSymmetric) this.cropCorners = $0ae6ca2088382149$var$resizeWidth(this.cropCorners, 2 * d.x, options);
                        else this.cropCorners = $0ae6ca2088382149$var$resizeRight(this.cropCorners, d, options);
                    }
                    if (change.direction.includes('n')) {
                        if (change.isSymmetric) this.cropCorners = $0ae6ca2088382149$var$resizeHeight(this.cropCorners, -2 * d.y, options);
                        else this.cropCorners = $0ae6ca2088382149$var$resizeTop(this.cropCorners, d, options);
                    } else if (change.direction.includes('s')) {
                        if (change.isSymmetric) this.cropCorners = $0ae6ca2088382149$var$resizeHeight(this.cropCorners, 2 * d.y, options);
                        else this.cropCorners = $0ae6ca2088382149$var$resizeBottom(this.cropCorners, d, options);
                    }
                }
                const roundedCrop = {
                    tl: {
                        x: Math.round(this.cropCorners.tl.x),
                        y: Math.round(this.cropCorners.tl.y)
                    },
                    br: {
                        x: Math.round(this.cropCorners.br.x),
                        y: Math.round(this.cropCorners.br.y)
                    }
                };
                return $0ae6ca2088382149$var$cornersToRect(roundedCrop);
            },
            toRendered: (crop)=>{
                const transform = this.viewportTransform;
                return {
                    x: transform.x + crop.x * transform.scale,
                    y: transform.y + crop.y * transform.scale,
                    width: crop.width * transform.scale,
                    height: crop.height * transform.scale
                };
            }
        });
        this.viewportTransform = p.viewportTransform;
        this.cropCorners = $0ae6ca2088382149$var$rectToCorners(p.value);
        this.render();
    }
}












const $45089719b604186a$export$e5937df51b9e1d86 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        const tempCanvas = klCanvas.getCanvas();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const initialCrop = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        const maxWidth = params.maxWidth, maxHeight = params.maxHeight;
        const selection = klCanvas.getSelection();
        let selectionBounds = selection ? (0, $4c2c6808296c0d73$export$ddc1c0069d484d49)((0, $c005e974076b5b75$export$a04a50ae6d6450f8)(selection, 'index'), klCanvas.getWidth(), klCanvas.getHeight()) : undefined;
        if (selectionBounds) {
            const boundsWidth = selectionBounds.x2 - selectionBounds.x1 + 1;
            const boundsHeight = selectionBounds.y2 - selectionBounds.y1 + 1;
            if (boundsWidth <= maxWidth && boundsHeight <= maxHeight) {
                initialCrop.top = selectionBounds.y1;
                initialCrop.right = selectionBounds.x2 - klCanvas.getWidth();
                initialCrop.bottom = selectionBounds.y2 - klCanvas.getHeight();
                initialCrop.left = selectionBounds.x1;
            } else selectionBounds = undefined;
        }
        // --- input elements ---
        const leftInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: initialCrop.left,
            type: 'number',
            name: 'crop-left',
            css: {
                width: 75
            },
            step: 1,
            onChange: function() {
                onInputChange();
            }
        });
        const rightInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: initialCrop.right,
            type: 'number',
            name: 'crop-right',
            css: {
                width: 75
            },
            step: 1,
            onChange: function() {
                onInputChange();
            }
        });
        const topInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: initialCrop.top,
            type: 'number',
            name: 'crop-top',
            css: {
                width: 75
            },
            step: 1,
            onChange: function() {
                onInputChange();
            }
        });
        const bottomInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: initialCrop.bottom,
            type: 'number',
            name: 'crop-bottom',
            css: {
                width: 75
            },
            step: 1,
            onChange: function() {
                onInputChange();
            }
        });
        function getValues() {
            return {
                left: leftInput.getValue(),
                right: rightInput.getValue(),
                top: topInput.getValue(),
                bottom: bottomInput.getValue()
            };
        }
        function updateInputRanges() {
            const { left: left, right: right, top: top, bottom: bottom } = getValues();
            const width = klCanvas.getWidth();
            const height = klCanvas.getHeight();
            leftInput.setRange(-width - right + 1, -width - right + maxWidth);
            rightInput.setRange(-width - left + 1, -width - left + maxWidth);
            topInput.setRange(-height - bottom + 1, -height - bottom + maxHeight);
            bottomInput.setRange(-height - top + 1, -height - top + maxHeight);
        }
        updateInputRanges();
        const sharedCss = {
            display: 'flex',
            flexDirection: 'column',
            width: 'calc(50% - 5px)',
            gap: 3
        };
        const leftWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                (0, $fc42a07754814920$export$ce37e184d908d785)('filter-crop-left') + ':',
                leftInput.getElement()
            ],
            css: sharedCss
        });
        const rightWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                (0, $fc42a07754814920$export$ce37e184d908d785)('filter-crop-right') + ':',
                rightInput.getElement()
            ],
            css: sharedCss
        });
        const topWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                (0, $fc42a07754814920$export$ce37e184d908d785)('filter-crop-top') + ':',
                topInput.getElement()
            ],
            css: sharedCss
        });
        const bottomWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                (0, $fc42a07754814920$export$ce37e184d908d785)('filter-crop-bottom') + ':',
                bottomInput.getElement()
            ],
            css: sharedCss
        });
        const wrapWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: 10
            }
        });
        wrapWrapper.append(leftWrapper, rightWrapper, topWrapper, bottomWrapper);
        rootEl.append(wrapWrapper);
        function onInputChange() {
            const { left: left, right: right, top: top, bottom: bottom } = getValues();
            const width = klCanvas.getWidth() + left + right;
            const height = klCanvas.getHeight() + top + bottom;
            const newCrop = {
                x: -left,
                y: -top,
                width: width,
                height: height
            };
            updateInputRanges();
            cropper.setValue(newCrop);
        }
        let useRuleOfThirds = true;
        const ruleOThirdsCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-crop-rule-thirds'),
            allowTab: true,
            callback: function(b) {
                useRuleOfThirds = b;
                cropper.setShowThirds(useRuleOfThirds);
            },
            name: 'rule-of-thirds'
        });
        rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                clear: 'both'
            }
        }));
        let selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        };
        const colorOptionsArr = [
            {
                r: 0,
                g: 0,
                b: 0,
                a: 0
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            }
        ];
        colorOptionsArr.push({
            r: params.currentColorRgb.r,
            g: params.currentColorRgb.g,
            b: params.currentColorRgb.b,
            a: 1
        });
        colorOptionsArr.push({
            r: params.secondaryColorRgb.r,
            g: params.secondaryColorRgb.g,
            b: params.secondaryColorRgb.b,
            a: 1
        });
        const colorOptions = new (0, $115e148fb390275d$export$24ba9b81662d4366)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-crop-fill'),
            colorArr: colorOptionsArr,
            onChange: function(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                preview.setBackground(selectedRgbaObj.a === 0 ? 'checker' : (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr(selectedRgbaObj));
            }
        });
        const flexRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: 10
            }
        });
        rootEl.append(flexRow);
        flexRow.append(ruleOThirdsCheckbox.getElement(), colorOptions.getElement());
        function updateInputValues(crop) {
            leftInput.setValue(-crop.x);
            topInput.setValue(-crop.y);
            rightInput.setValue(crop.x + crop.width - klCanvas.getWidth());
            bottomInput.setValue(crop.y + crop.height - klCanvas.getHeight());
            updateInputRanges();
        }
        const previewPadding = 40;
        const previewWidth = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        const previewHeight = (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall);
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: previewWidth,
            height: previewHeight,
            project: {
                width: klCanvas.getWidth(),
                height: klCanvas.getHeight(),
                layers: [
                    {
                        image: tempCanvas,
                        isVisible: true,
                        opacity: 1,
                        mixModeStr: 'source-over',
                        hasClipping: false
                    }
                ]
            },
            hasEditMode: true,
            editIcon: (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('edit-crop'),
            onModeChange: (mode)=>{
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(cropper.getElement(), {
                    pointerEvents: mode === 'edit' ? undefined : 'none',
                    opacity: mode === 'edit' ? undefined : 0.5
                });
            },
            onTransformChange: (transform)=>{
                cropper.setViewportTransform(transform);
            },
            padding: previewPadding,
            background: 'checker'
        });
        if (selectionBounds) {
            const selectionWidth = selectionBounds.x2 - selectionBounds.x1 + 1;
            const selectionHeight = selectionBounds.y2 - selectionBounds.y1 + 1;
            const fit = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(selectionWidth, selectionHeight, previewWidth - previewPadding * 2, previewHeight - previewPadding * 2);
            const scale = Math.min((0, $00631e3d51f88f11$export$ac82c07320907c00), fit.width / selectionWidth);
            preview.setTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)({
                x: previewWidth / 2,
                y: previewHeight / 2
            }, {
                x: selectionBounds.x1 + selectionWidth / 2,
                y: selectionBounds.y1 + selectionHeight / 2
            }, scale, 0, false));
        }
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            overflow: 'hidden',
            marginLeft: -20,
            marginRight: -20,
            marginTop: 10
        });
        rootEl.append(preview.getElement());
        const cropper = new (0, $0ae6ca2088382149$export$e6a7b4950e556057)({
            width: previewWidth,
            height: previewHeight,
            value: selectionBounds ? (0, $4c2c6808296c0d73$export$3488993c9d026384)(selectionBounds) : {
                x: 0,
                y: 0,
                width: klCanvas.getWidth(),
                height: klCanvas.getHeight()
            },
            viewportTransform: preview.getTransform(),
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            showThirds: useRuleOfThirds,
            onChange: updateInputValues
        });
        updateInputValues(cropper.getValue());
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(cropper.getElement(), {
            position: 'absolute',
            left: 0,
            top: 0,
            zIndex: 0
        });
        preview.getElement().append(cropper.getElement());
        const cropperWheelListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: cropper.getElement(),
            onWheel: preview.onWheel,
            useDirtyWheel: true
        });
        preview.render();
        result.destroy = ()=>{
            cropperWheelListener.destroy();
            cropper.destroy();
            preview.destroy();
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(tempCanvas);
            ruleOThirdsCheckbox.destroy();
            colorOptions.destroy();
            leftInput.destroy();
            rightInput.destroy();
            topInput.destroy();
            bottomInput.destroy();
        };
        result.getInput = function() {
            const inputs = {
                left: leftInput.getValue(),
                right: rightInput.getValue(),
                top: topInput.getValue(),
                bottom: bottomInput.getValue(),
                fillColor: selectedRgbaObj.a === 0 ? undefined : selectedRgbaObj
            };
            result.destroy();
            return inputs;
        };
        return result;
    },
    apply (params) {
        const klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        return klCanvas.cropExtend(params.input);
    }
};







function $c357aece6a63af94$export$4300cf0a0df418a6() {
    return (0, $be957da3610487e9$export$921068d8846a1559).copyObj({
        r: [
            [
                0,
                0
            ],
            [
                1 / 3,
                1 / 3
            ],
            [
                2 / 3,
                2 / 3
            ],
            [
                1,
                1
            ]
        ],
        g: [
            [
                0,
                0
            ],
            [
                1 / 3,
                1 / 3
            ],
            [
                2 / 3,
                2 / 3
            ],
            [
                1,
                1
            ]
        ],
        b: [
            [
                0,
                0
            ],
            [
                1 / 3,
                1 / 3
            ],
            [
                2 / 3,
                2 / 3
            ],
            [
                1,
                1
            ]
        ]
    });
}
class $c357aece6a63af94$export$1c43bf66c2a2e4da {
    // ---- interface ----
    getElement() {
        return this.rootEl;
    }
    getModeButtons() {
        return this.modeButtons;
    }
    destroy() {
        this.p0.pointerListener.destroy();
        this.p1.pointerListener.destroy();
        this.p2.pointerListener.destroy();
        this.p3.pointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'relative',
                marginBottom: 10
            }
        });
        this.rootEl.oncontextmenu = ()=>false;
        let mode = 'All';
        let curves = p.curves;
        this.modeButtons = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            isFocusable: true,
            optionArr: [
                {
                    id: 'All',
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-curves-all')
                },
                {
                    id: 'Red',
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('red')
                },
                {
                    id: 'Green',
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('green')
                },
                {
                    id: 'Blue',
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('blue')
                }
            ],
            initId: 'All',
            onChange: (id)=>{
                mode = id;
                if (mode === 'All') curves = $c357aece6a63af94$export$4300cf0a0df418a6();
                let curve = curves.r;
                if (mode === 'Green') curve = curves.g;
                if (mode === 'Blue') curve = curves.b;
                this.p0.setPos(0, areaH - curve[0][1] * areaH);
                this.p1.setPos(curve[1][0] * areaW, areaH - curve[1][1] * areaH);
                this.p2.setPos(curve[2][0] * areaW, areaH - curve[2][1] * areaH);
                this.p3.setPos(areaW, areaH - curve[3][1] * areaH);
                update();
            }
        });
        this.rootEl.append(this.modeButtons.getElement());
        const curveArea = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            className: 'kl-curves-graph',
            css: {
                position: 'relative',
                marginTop: 10
            }
        });
        const areaW = 300, areaH = 100;
        const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(areaW, areaH);
        let ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
        curveArea.append(canvas);
        const fit = (v)=>{
            return Math.max(0, Math.min(1, v));
        };
        const createPoint = (x, y, callback, lock)=>{
            const gripSize = 14;
            let internalY = y, internalX = x;
            const pointEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
                className: 'kl-curves-graph__grip',
                css: {
                    left: x - gripSize / 2,
                    top: y - gripSize / 2,
                    width: gripSize,
                    height: gripSize,
                    borderRadius: gripSize
                }
            });
            const update = ()=>{
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(pointEl, {
                    left: x - gripSize / 2,
                    top: y - gripSize / 2
                });
            };
            const pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
                target: pointEl,
                onPointer: (event)=>{
                    event.eventPreventDefault();
                    if (event.type === 'pointerdown') {
                        internalX = x;
                        internalY = y;
                    }
                    if (event.button === 'left' && event.type === 'pointermove') {
                        if (!lock) internalX += event.dX;
                        x = Math.max(0, Math.min(areaW, internalX));
                        internalY += event.dY;
                        y = Math.max(0, Math.min(areaH, internalY));
                        update();
                        callback({
                            x: x,
                            y: y
                        });
                    }
                }
            });
            curveArea.append(pointEl);
            const setPos = (newX, newY)=>{
                x = newX;
                y = newY;
                internalY = y;
                internalX = x;
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(pointEl, {
                    left: x - gripSize / 2,
                    top: y - gripSize / 2
                });
            };
            return {
                el: pointEl,
                setPos: setPos,
                pointerListener: pointerListener
            };
        };
        const updateControl = (i, x, y)=>{
            if (mode === 'All') {
                curves.r[i] = [
                    fit(x / areaW),
                    fit(1 - y / areaH)
                ];
                curves.g[i] = [
                    fit(x / areaW),
                    fit(1 - y / areaH)
                ];
                curves.b[i] = [
                    fit(x / areaW),
                    fit(1 - y / areaH)
                ];
            }
            if (mode === 'Red') curves.r[i] = [
                fit(x / areaW),
                fit(1 - y / areaH)
            ];
            if (mode === 'Green') curves.g[i] = [
                fit(x / areaW),
                fit(1 - y / areaH)
            ];
            if (mode === 'Blue') curves.b[i] = [
                fit(x / areaW),
                fit(1 - y / areaH)
            ];
        };
        this.p0 = createPoint(0, areaH, (val)=>{
            updateControl(0, val.x, val.y);
            update();
        }, true);
        this.p1 = createPoint(areaW / 3, areaH / 3 * 2, (val)=>{
            updateControl(1, val.x, val.y);
            update();
        });
        this.p2 = createPoint(areaW / 3 * 2, areaH / 3, (val)=>{
            updateControl(2, val.x, val.y);
            update();
        });
        this.p3 = createPoint(areaW, 0, (val)=>{
            updateControl(3, val.x, val.y);
            update();
        }, true);
        const update = ()=>{
            ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const outCurves = {
                r: [],
                g: [],
                b: []
            };
            for(let i = 0; i < curves.r.length; i++){
                outCurves.r.push(curves.r[i]);
                outCurves.g.push(curves.g[i]);
                outCurves.b.push(curves.b[i]);
            }
            const drawCurve = (curve)=>{
                ctx.beginPath();
                const spline = new (0, $be957da3610487e9$export$921068d8846a1559).SplineInterpolator(curve);
                for(let i = 0; i < 100; i++){
                    let y = spline.interpolate(i / 100);
                    y = Math.max(0, Math.min(1, y));
                    if (i === 0) ctx.moveTo(i / 100 * areaW, areaH - y * areaH);
                    else ctx.lineTo(i / 100 * areaW, areaH - y * areaH);
                }
                ctx.stroke();
            };
            ctx.save();
            if (mode === 'All') {
                ctx.strokeStyle = 'black';
                drawCurve(outCurves.r);
            } else {
                ctx.globalAlpha = 0.5;
                ctx.strokeStyle = 'red';
                drawCurve(outCurves.r);
                ctx.strokeStyle = 'green';
                drawCurve(outCurves.g);
                ctx.strokeStyle = 'blue';
                drawCurve(outCurves.b);
            }
            ctx.restore();
            p.callback(outCurves);
        };
        update();
    }
}








const $f60dcaccc6e56a8f$export$309483fcb6d5c7ca = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        let curves = (0, $c357aece6a63af94$export$4300cf0a0df418a6)();
        const fxPreviewRenderer = new (0, $edd68b64db3c6175$export$94ec999f33a691e3)({
            original: layer.canvas,
            onUpdate: (fxCanvas)=>{
                return fxCanvas.curves(curves.r, curves.g, curves.b);
            },
            selection: klCanvas.getSelection()
        });
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: -20,
            marginRight: -20
        });
        const input = new (0, $c357aece6a63af94$export$1c43bf66c2a2e4da)({
            curves: curves,
            callback: function(val) {
                curves = val;
                preview.render();
            }
        });
        const modeButtons = input.getModeButtons();
        rootEl.append(input.getElement(), preview.getElement());
        result.destroy = ()=>{
            input.destroy();
            modeButtons.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                curves: curves
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const curves = params.input.curves;
        const klHistory = params.klHistory;
        if (!context) return false;
        return (0, $6b8a42764b141679$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.curves(curves.r, curves.g, curves.b);
        }, klHistory);
    }
};








const $6e94dbe15dd1f87a$export$9b1b7b3985b9625a = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        const fit = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(layer.canvas.width, layer.canvas.height, 280, 200, 1);
        const w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        let isHorizontal = true;
        let isVertical = false;
        let doFlipCanvas = true;
        const horizontalCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: isHorizontal,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-flip-horizontal') + " \u27F7",
            allowTab: true,
            callback: function(v) {
                isHorizontal = v;
                updatePreview();
            },
            css: {
                marginBottom: 10
            },
            name: 'flip-horizontal'
        });
        const verticalCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: isVertical,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-flip-vertical') + " \u2195",
            allowTab: true,
            callback: function(v) {
                isVertical = v;
                updatePreview();
            },
            css: {
                marginBottom: 10
            },
            name: 'flip-vertical'
        });
        rootEl.append(horizontalCheckbox.getElement());
        rootEl.append(verticalCheckbox.getElement());
        const targetOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            isFocusable: true,
            optionArr: [
                {
                    id: true,
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-flip-image')
                },
                {
                    id: false,
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-flip-layer')
                }
            ],
            onChange: (val)=>{
                doFlipCanvas = val;
                updatePreview();
            }
        });
        rootEl.append(targetOptions.getElement());
        const previewWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper',
            css: {
                width: (0, $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768).width,
                height: (0, $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768).height
            }
        });
        const previewLayers = layers.map((item)=>({
                image: item.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr,
                hasClipping: item.hasClipping
            }));
        const composedCanvas = klCanvas.getCanvas();
        const flippedCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(composedCanvas.width, composedCanvas.height);
        function drawFlipped(source, horizontal, vertical) {
            const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(flippedCanvas);
            ctx.save();
            ctx.globalCompositeOperation = 'copy';
            if (horizontal) {
                ctx.translate(flippedCanvas.width, 0);
                ctx.scale(-1, 1);
            }
            if (vertical) {
                ctx.translate(0, flippedCanvas.height);
                ctx.scale(1, -1);
            }
            ctx.drawImage(source, 0, 0);
            ctx.restore();
            return flippedCanvas;
        }
        function buildLayers() {
            if (doFlipCanvas) return [
                {
                    image: drawFlipped(composedCanvas, isHorizontal, isVertical),
                    isVisible: true,
                    opacity: 1,
                    mixModeStr: 'source-over',
                    hasClipping: false
                }
            ];
            return previewLayers.map((item, i)=>i === selectedLayerIndex ? {
                    ...item,
                    image: drawFlipped(item.image, isHorizontal, isVertical)
                } : item);
        }
        const klCanvasPreview = new (0, $8960a416cd34201a$export$e258ade1648009b7)({
            width: Math.round(w),
            height: Math.round(h),
            layers: buildLayers()
        });
        function updatePreview() {
            klCanvasPreview.setLayers(buildLayers());
        }
        const previewInnerWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper__canvas',
            css: {
                width: parseInt('' + w),
                height: parseInt('' + h)
            }
        });
        previewInnerWrapper.append(klCanvasPreview.getElement());
        previewWrapper.append(previewInnerWrapper);
        rootEl.append(previewWrapper);
        result.destroy = ()=>{
            horizontalCheckbox.destroy();
            verticalCheckbox.destroy();
            targetOptions.destroy();
            klCanvasPreview.destroy();
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(composedCanvas);
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(flippedCanvas);
        };
        result.getInput = function() {
            result.destroy();
            return {
                horizontal: isHorizontal,
                vertical: isVertical,
                flipCanvas: doFlipCanvas
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klCanvas = params.klCanvas;
        const horizontal = params.input.horizontal;
        const vertical = params.input.vertical;
        const flipCanvas = params.input.flipCanvas;
        if (!context || !klCanvas) return false;
        klCanvas.flip(horizontal, vertical, flipCanvas ? undefined : params.layer.index);
        return true;
    }
};












const $0033f73fa7e53276$export$2aa46bd5587f0eb = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        let hue = 0, saturation = 0;
        const fxPreviewRenderer = new (0, $edd68b64db3c6175$export$94ec999f33a691e3)({
            original: layer.canvas,
            onUpdate: (fxCanvas)=>{
                return fxCanvas.hueSaturation(hue, saturation);
            },
            selection: klCanvas.getSelection()
        });
        const hueSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-hue-sat-hue'),
            width: 300,
            height: 30,
            min: -100,
            max: 100,
            value: hue * 100,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            onChange: function(val) {
                hue = val / 100;
                preview.render();
            }
        });
        const saturationSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-hue-sat-saturation'),
            width: 300,
            height: 30,
            min: 0,
            max: 100,
            value: (saturation + 1) * 50,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            onChange: function(val) {
                saturation = val / 50 - 1;
                preview.render();
            }
        });
        hueSlider.getElement().style.marginBottom = '10px';
        saturationSlider.getElement().style.marginBottom = '10px';
        rootEl.append(hueSlider.getElement(), saturationSlider.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: -20,
            marginRight: -20
        });
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            hueSlider.destroy();
            saturationSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                hue: hue,
                saturation: saturation
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const hue = params.input.hue;
        const klHistory = params.klHistory;
        const saturation = params.input.saturation;
        if (!context || hue === null || saturation === null) return false;
        return (0, $6b8a42764b141679$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.hueSaturation(hue, saturation);
        }, klHistory);
    }
};



const $3d06d8c74be27f29$export$b7ebcfbdc840ef76 = {
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        if (!context) return false;
        return (0, $6b8a42764b141679$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.invert();
        }, klHistory);
    }
};






class $56442e020adf49f2$export$b1241e74876d9bbe {
    update() {
        this.leftTab.classList.toggle('kl-2-tabs--active', this.value === 0);
        this.rightTab.classList.toggle('kl-2-tabs--active', this.value === 1);
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.value = p.init;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-2-tabs'
        });
        this.leftTab = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            content: p.left,
            className: 'kl-2-tabs__left'
        });
        this.leftTab.onpointerdown = ()=>false;
        this.rightTab = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.rootEl,
            content: p.right,
            className: 'kl-2-tabs__right'
        });
        this.rightTab.onpointerdown = ()=>false;
        this.update();
        this.leftTab.onclick = ()=>{
            if (this.value === 0) return;
            this.value = 0;
            this.update();
            p.onChange(this.value);
        };
        this.rightTab.onclick = ()=>{
            if (this.value === 1) return;
            this.value = 1;
            this.update();
            p.onChange(this.value);
        };
    }
}









const $d11119184bb857f3$var$SIZE = 16;
class $d11119184bb857f3$export$87247fc399965417 {
    update() {
        const p = (0, $43e83319b765a157$export$9b20165a36586806)((0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.transform), this.value);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
            left: p.x - $d11119184bb857f3$var$SIZE / 2,
            top: p.y - $d11119184bb857f3$var$SIZE / 2
        });
    }
    setTransform(transform) {
        if (JSON.stringify(this.transform) === JSON.stringify(transform)) return;
        this.transform = transform;
        this.update();
    }
    getValue() {
        return this.value;
    }
    setValue(p) {
        this.value = {
            ...p
        };
        this.update();
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.rootEl.remove();
        this.pointerListener.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.value = {
            ...p.value
        };
        this.transform = {
            x: 0,
            y: 0,
            scale: 1,
            angleDeg: 0,
            isMirrored: false
        };
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: $d11119184bb857f3$var$SIZE,
                height: $d11119184bb857f3$var$SIZE,
                backgroundColor: '#fff',
                border: '2px solid #000',
                borderRadius: $d11119184bb857f3$var$SIZE,
                position: 'absolute',
                cursor: 'move',
                userSelect: 'none',
                touchAction: 'none'
            }
        });
        this.pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: this.rootEl,
            onPointer: (event)=>{
                event.eventPreventDefault();
                if (event.button === 'left' && event.type === 'pointermove') {
                    this.value.x += event.dX / this.transform.scale;
                    this.value.y += event.dY / this.transform.scale;
                    this.update();
                    p.onChange(this.value);
                }
            }
        });
    }
}





const $1731ad5d3c728068$export$a76d798fa7d85e4e = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        const layers = klCanvas.getLayers();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$3a4a74a7d8c44e62).width;
        const fxCanvas = (0, $94f0b2b810d4d191$export$b813e062795b89b5)((0, $b225623fe00a4a24$export$8c4423af32b21158)());
        const texture = (0, $94f0b2b810d4d191$export$5c097f720de072a2)(fxCanvas?.texture(layer.canvas));
        function update() {
            if (isBefore) fxCanvas.draw(texture).update();
            else fxCanvas.draw(texture).perspective(getFlatArr(beforeInputs), getFlatArr(afterInputs)).update();
            preview.render();
        }
        const rectPoints = [
            {
                x: 0,
                y: 0
            },
            {
                x: layer.canvas.width,
                y: 0
            },
            {
                x: layer.canvas.width,
                y: layer.canvas.height
            },
            {
                x: 0,
                y: layer.canvas.height
            }
        ];
        const beforeInputs = rectPoints.map((point)=>{
            return new (0, $d11119184bb857f3$export$87247fc399965417)({
                value: point,
                onChange: ()=>{
                    update();
                }
            });
        });
        beforeInputs.forEach((item)=>item.getElement().style.display = 'none');
        const afterInputs = rectPoints.map((point)=>{
            return new (0, $d11119184bb857f3$export$87247fc399965417)({
                value: point,
                onChange: ()=>{
                    update();
                }
            });
        });
        function getFlatArr(inputs, matrix) {
            return inputs.flatMap((item)=>{
                let value = item.getValue();
                if (matrix) value = (0, $43e83319b765a157$export$9b20165a36586806)(matrix, value);
                return [
                    value.x,
                    value.y
                ];
            });
        }
        let isBefore = false;
        const beforeAfterTabs = new (0, $56442e020adf49f2$export$b1241e74876d9bbe)({
            left: (0, $fc42a07754814920$export$ce37e184d908d785)('compare-before'),
            right: (0, $fc42a07754814920$export$ce37e184d908d785)('compare-after'),
            init: 1,
            onChange: (val)=>{
                isBefore = val === 0;
                if (isBefore) {
                    beforeInputs.forEach((item)=>item.getElement().style.display = 'block');
                    afterInputs.forEach((item)=>item.getElement().style.display = 'none');
                } else {
                    beforeInputs.forEach((item, index)=>{
                        afterInputs[index].setValue(item.getValue());
                    });
                    beforeInputs.forEach((item)=>item.getElement().style.display = 'none');
                    afterInputs.forEach((item)=>item.getElement().style.display = 'block');
                }
                update();
            }
        });
        rootEl.append(beforeAfterTabs.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxCanvas.canvas : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            },
            onTransformChange: (transform)=>{
                beforeInputs.forEach((item)=>item.setTransform(transform));
                afterInputs.forEach((item)=>item.setTransform(transform));
            }
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            overflow: 'hidden',
            marginLeft: -20,
            marginRight: -20
        });
        preview.getElement().append(...beforeInputs.map((item)=>item.getElement()), ...afterInputs.map((item)=>item.getElement()));
        rootEl.append(preview.getElement());
        update();
        result.destroy = ()=>{
            preview.destroy();
            texture.destroy();
            beforeInputs.forEach((item)=>item.destroy());
            afterInputs.forEach((item)=>item.destroy());
        };
        result.getInput = ()=>{
            result.destroy();
            return {
                before: getFlatArr(beforeInputs),
                after: getFlatArr(afterInputs)
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        const before = params.input.before;
        const after = params.input.after;
        if (!context || !before || !after) return false;
        const fxCanvas = (0, $b225623fe00a4a24$export$8c4423af32b21158)();
        if (!fxCanvas) return false; // todo more specific error?
        const texture = fxCanvas.texture(context.canvas);
        fxCanvas.draw(texture).multiplyAlpha().perspective(before, after).unmultiplyAlpha().update();
        context.clearRect(0, 0, context.canvas.width, context.canvas.height);
        context.drawImage(fxCanvas.canvas, 0, 0);
        texture.destroy();
        {
            const layerMap = Object.fromEntries(params.klCanvas.getLayers().map((layerItem)=>{
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $3aa9c52208735678$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};













const $18f19ceb2efa24ec$var$constrainImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('constrain');
const $18f19ceb2efa24ec$export$5705240d31427a82 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        const fit = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(klCanvas.getWidth(), klCanvas.getHeight(), 280, 200, 1);
        const w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        let previewFactor = w / klCanvas.getWidth();
        const tempCanvas = klCanvas.getCanvas();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const maxWidth = params.maxWidth, maxHeight = params.maxHeight;
        let isConstrained = true;
        const ratio = klCanvas.getWidth() / klCanvas.getHeight();
        const widthInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            type: 'number',
            init: klCanvas.getWidth(),
            name: 'resize-width',
            step: 1,
            css: {
                width: 90
            },
            onChange: (value)=>{
                if (isConstrained) heightInput.setValue(Math.max(1, Math.floor(value / ratio)));
                update();
            }
        });
        const heightInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            type: 'number',
            init: klCanvas.getHeight(),
            name: 'resize-height',
            step: 1,
            css: {
                width: 90
            },
            onChange: (value)=>{
                if (isConstrained) widthInput.setValue(Math.max(1, Math.floor(value * ratio)));
                update();
            }
        });
        function updateRanges() {
            if (isConstrained) {
                widthInput.setRange(Math.max(1, Math.ceil(ratio)), Math.max(1, Math.min(maxWidth, Math.floor(maxHeight * ratio))));
                heightInput.setRange(Math.max(1, Math.ceil(1 / ratio)), Math.max(1, Math.min(maxHeight, Math.floor(maxWidth / ratio))));
                return;
            }
            widthInput.setRange(1, maxWidth);
            heightInput.setRange(1, maxHeight);
        }
        updateRanges();
        function scale(factor) {
            widthInput.setValue(widthInput.getValue() * factor, true);
            if (!isConstrained) heightInput.setValue(heightInput.getValue() * factor, true);
        }
        const buttonRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                marginBottom: 10
            }
        });
        (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            className: 'kl-button',
            content: '2&times;',
            onClick: ()=>{
                scale(2);
            }
        });
        (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            className: 'kl-button',
            content: '&frac12;&times;',
            onClick: ()=>{
                scale(0.5);
            }
        });
        const constrainIm = new Image();
        constrainIm.src = $18f19ceb2efa24ec$var$constrainImg;
        constrainIm.height = 40;
        const sizeTable = (0, $304dd966053166ea$export$9852986a3ec5f6a0)([
            [
                (0, $fc42a07754814920$export$ce37e184d908d785)('width') + ':&nbsp;',
                widthInput.getElement(),
                constrainIm
            ],
            [
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    css: {
                        height: 5
                    }
                }),
                '',
                ''
            ],
            [
                (0, $fc42a07754814920$export$ce37e184d908d785)('height') + ':&nbsp;',
                heightInput.getElement()
            ]
        ], {
            '0.2': {
                rowspan: 3
            }
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(sizeTable, {
            marginBottom: 10
        });
        rootEl.append(sizeTable);
        const constrainCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('constrain-proportions'),
            allowTab: true,
            callback: function(newIsConstrained) {
                isConstrained = newIsConstrained;
                constrainIm.style.display = isConstrained ? '' : 'none';
                if (isConstrained) {
                    widthInput.setValue(klCanvas.getWidth());
                    heightInput.setValue(klCanvas.getHeight());
                    update();
                }
                updateRanges();
            },
            name: 'constrain-proportions'
        });
        rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                clear: 'both'
            }
        }));
        const algorithmToggle = new (0, $451c2c6773f98d8b$export$6152f1e421c68434)({
            initValue: 'smooth',
            isFocusable: true,
            onChange: ()=>{
                update();
            }
        });
        const secondRowElement = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }
        });
        secondRowElement.append(constrainCheckbox.getElement(), algorithmToggle.getElement());
        const previewCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(w, h);
        previewCanvas.style.imageRendering = 'pixelated';
        const previewCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(previewCanvas);
        function update() {
            const width = widthInput.getValue();
            const height = heightInput.getValue();
            const preview = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(width, height, 280, 200, 1);
            const previewW = Math.max(1, Math.round(preview.width)), previewH = Math.max(1, Math.round(preview.height));
            previewFactor = previewW / width;
            previewCtx.save();
            if (algorithmToggle.getValue() === 'smooth') {
                previewCanvas.style.imageRendering = previewFactor > 1 ? 'pixelated' : '';
                (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(previewCanvas, klCanvas.getWidth(), klCanvas.getHeight(), {
                    ensureCleared: true
                });
                previewCtx.imageSmoothingQuality = 'high';
                previewCtx.drawImage(tempCanvas, 0, 0);
                (0, $be957da3610487e9$export$921068d8846a1559).resizeCanvas(previewCanvas, width, height);
            } else {
                previewCanvas.style.imageRendering = 'pixelated';
                (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(previewCanvas, width, height, {
                    ensureCleared: true
                });
                previewCtx.imageSmoothingEnabled = false;
                previewCtx.drawImage(tempCanvas, 0, 0, previewCanvas.width, previewCanvas.height);
            }
            previewCtx.restore();
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(previewCanvas, {
                width: previewW,
                height: previewH
            });
            const offset = (0, $be957da3610487e9$export$921068d8846a1559).centerWithin((0, $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768).width, (0, $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768).height, previewW, previewH);
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(canvasWrapper, {
                left: offset.x,
                top: offset.y,
                width: previewW,
                height: previewH
            });
        }
        const previewWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-transparent-preview',
            css: {
                width: (0, $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768).width,
                height: (0, $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768).height,
                marginLeft: -20,
                display: 'table',
                marginTop: 10,
                position: 'relative',
                userSelect: 'none',
                background: 'var(--kl-checkerboard-background)',
                backgroundSize: 16
            }
        });
        const canvasWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: previewWrapper,
            content: previewCanvas,
            className: 'kl-transparent-preview__canvas',
            css: {
                width: w,
                height: h,
                position: 'absolute',
                overflow: 'hidden'
            }
        });
        rootEl.append(previewWrapper);
        update();
        result.destroy = ()=>{
            widthInput.destroy();
            heightInput.destroy();
            constrainCheckbox.destroy();
            algorithmToggle.destroy();
            (0, $2f436639594531f3$export$2384aff49c9b73c2)(previewCanvas);
            (0, $2f436639594531f3$export$2384aff49c9b73c2)(tempCanvas);
        };
        result.getInput = function() {
            const algorithm = algorithmToggle.getValue();
            const width = widthInput.getValue();
            const height = heightInput.getValue();
            result.destroy();
            return {
                width: width,
                height: height,
                algorithm: algorithm
            };
        };
        return result;
    },
    apply (params) {
        const klCanvas = params.klCanvas;
        const width = params.input.width;
        const height = params.input.height;
        const algorithm = params.input.algorithm;
        if (!klCanvas) return false;
        klCanvas.resize(width, height, algorithm);
        return true;
    }
};





const $7303a640f83f6ee9$export$ac7e9efc751d5791 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        const fit = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(klCanvas.getWidth(), klCanvas.getHeight(), 280, 200, 1);
        const w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        const previewFactor = w / klCanvas.getWidth();
        const tempCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(w, h);
        tempCanvas.style.display = 'block';
        (0, $be957da3610487e9$export$921068d8846a1559).ctx(tempCanvas).drawImage(klCanvas.getCanvas(previewFactor), 0, 0, w, h);
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        const result = {
            element: rootEl
        };
        let deg = 0;
        function update() {
            canvasWrapper.style.transform = 'rotate(' + deg + 'deg)';
            if (Math.abs(deg % 180) === 90) {
                //height has to fit width because of rotation
                const fit = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(h, w, 280, 200, 1);
                const scale = parseInt('' + fit.height) / w;
                canvasWrapper.style.transform = 'rotate(' + deg + 'deg) scale(' + scale + ')';
            }
        }
        const minusBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: [
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'span',
                    content: "\u27F2",
                    css: {
                        fontSize: '1.3em'
                    }
                }),
                " 90\xb0"
            ],
            destroyer: destroyer,
            onClick: ()=>{
                deg -= 90;
                update();
            }
        });
        const plusBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: [
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'span',
                    content: "\u27F3",
                    css: {
                        fontSize: '1.3em'
                    }
                }),
                " 90\xb0"
            ],
            destroyer: destroyer,
            onClick: ()=>{
                deg += 90;
                update();
            },
            css: {
                marginLeft: 5
            }
        });
        rootEl.append(minusBtn, plusBtn);
        const previewWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper',
            css: {
                width: (0, $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768).width,
                height: (0, $0cebc8ae8ef681f1$export$ec2d17c6d3ae0768).height,
                display: 'table'
            }
        });
        const previewcell = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: previewWrapper,
            css: {
                display: 'table-cell',
                verticalAlign: 'middle'
            }
        });
        const canvasWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: previewcell,
            content: tempCanvas,
            className: 'kl-preview-wrapper__canvas',
            css: {
                width: w,
                height: h,
                marginLeft: 'auto',
                marginRight: 'auto',
                overflow: 'hidden',
                background: 'var(--kl-checkerboard-background)',
                backgroundSize: 16
            }
        });
        canvasWrapper.style.transition = 'transform 0.2s ease-out';
        rootEl.append(previewWrapper);
        update();
        result.destroy = ()=>{
            destroyer.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                deg: deg
            };
        };
        return result;
    },
    apply (params) {
        const klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        klCanvas.rotate(params.input.deg);
        return true;
    }
};















const $68ca153b95a94dbd$export$1b8796b18b7c19ed = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        let blur = 20, gradient = 200;
        let fxPreviewRenderer = {
            destroy: ()=>{}
        };
        fxPreviewRenderer = new (0, $edd68b64db3c6175$export$94ec999f33a691e3)({
            original: layer.canvas,
            onUpdate: (fxCanvas, transform)=>{
                fa.setTransform(preview.getTransform());
                fb.setTransform(preview.getTransform());
                const m = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(transform);
                const a = (0, $43e83319b765a157$export$9b20165a36586806)(m, fa.getValue());
                const b = (0, $43e83319b765a157$export$9b20165a36586806)(m, fb.getValue());
                return fxCanvas.multiplyAlpha().tiltShift(a.x, a.y, b.x, b.y, blur * transform.scaleX, gradient * transform.scaleX).unmultiplyAlpha();
            },
            selection: klCanvas.getSelection()
        });
        function update() {
            preview.render();
        }
        // focus line control points
        const fa = new (0, $d11119184bb857f3$export$87247fc399965417)({
            value: {
                x: layer.canvas.width / 4,
                y: layer.canvas.height / 2
            },
            onChange: ()=>{
                update();
            }
        });
        const fb = new (0, $d11119184bb857f3$export$87247fc399965417)({
            value: {
                x: 3 * layer.canvas.width / 4,
                y: layer.canvas.height / 2
            },
            onChange: ()=>{
                update();
            }
        });
        const gradientSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-tilt-shift-gradient'),
            width: 300,
            height: 30,
            min: 0,
            max: 1000,
            value: gradient,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            onChange: function(val) {
                gradient = val;
                update();
            }
        });
        gradientSlider.getElement().style.marginBottom = '10px';
        rootEl.append(gradientSlider.getElement());
        const blurSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-tilt-shift-blur'),
            width: 300,
            height: 30,
            min: 0,
            max: 200,
            value: blur,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            onChange: function(val) {
                blur = val;
                update();
            }
        });
        blurSlider.getElement().style.marginBottom = '10px';
        rootEl.append(blurSlider.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            overflow: 'hidden',
            marginLeft: -20,
            marginRight: -20
        });
        preview.getElement().append(fa.getElement(), fb.getElement());
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            blurSlider.destroy();
            gradientSlider.destroy();
            fa.destroy();
            fb.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                a: fa.getValue(),
                b: fb.getValue(),
                blur: blur,
                gradient: gradient
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        const a = params.input.a;
        const b = params.input.b;
        const blur = params.input.blur;
        const gradient = params.input.gradient;
        if (!context) return false;
        return (0, $6b8a42764b141679$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.multiplyAlpha().tiltShift(a.x, a.y, b.x, b.y, blur, gradient).unmultiplyAlpha();
        }, klHistory);
    }
};















function $58a3332bd07c6dd1$export$6be4733fa804854c(selection, context) {
    const selectionBounds = (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(selection, 'index');
    // integer bounds that are within the canvas
    const canvasSelectionBounds = (0, $4c2c6808296c0d73$export$ddc1c0069d484d49)(selectionBounds, context.canvas.width, context.canvas.height);
    // selection area outside of canvas
    if (!canvasSelectionBounds) return undefined;
    // bounds of where pixels are non-transparent
    return (0, $2f436639594531f3$export$c1fcf1f93aeabfbf)(context, canvasSelectionBounds);
}









// ---- Helper Functions ----
// Precomputed factorials for n = 0..8 (sufficient for lattice degrees up to 8×8).
// Gave slight performance improvement.
const $cb638405dd43878a$var$factorials = [
    1,
    1,
    2,
    6,
    24,
    120,
    720,
    5040,
    40320
];
function $cb638405dd43878a$export$b10970dad17863b6(n, k, t) {
    const coeff = $cb638405dd43878a$var$factorials[n] / ($cb638405dd43878a$var$factorials[k] * $cb638405dd43878a$var$factorials[n - k]);
    return coeff * (1 - t) ** (n - k) * t ** k;
}
function $cb638405dd43878a$export$1dc7cad4a5f0f0a6(cols, rows, rect) {
    const controlPoints = [];
    for(let i = 0; i < rows; i++){
        controlPoints[i] = [];
        for(let j = 0; j < cols; j++)controlPoints[i][j] = {
            x: rect.x + j / (cols - 1) * rect.width,
            y: rect.y + i / (rows - 1) * rect.height
        };
    }
    return {
        cols: cols,
        rows: rows,
        controlPoints: controlPoints
    };
}
function $cb638405dd43878a$export$24b0a92fce6b8497(s, t, lattice) {
    const n = lattice.cols - 1;
    const m = lattice.rows - 1;
    let x = 0;
    let y = 0;
    for(let i = 0; i <= m; i++)for(let j = 0; j <= n; j++){
        const weight = $cb638405dd43878a$export$b10970dad17863b6(n, j, s) * $cb638405dd43878a$export$b10970dad17863b6(m, i, t);
        x += lattice.controlPoints[i][j].x * weight;
        y += lattice.controlPoints[i][j].y * weight;
    }
    return {
        x: x,
        y: y
    };
}
function $cb638405dd43878a$export$81dc197f519ea47(resolutionX, resolutionY, ffd, selectionSample, outputWidth, outputHeight, useCanvasSpace) {
    /**
     * Compute the parametric s/t ranges so that mesh only covers the texture's
     * portion of the lattice — UVs stay in [0, 1] and nothing outside the texture is drawn.
     */ const textureWidth = selectionSample.image.width;
    const textureHeight = selectionSample.image.height;
    const offset = selectionSample.imageOffset;
    const selWidth = selectionSample.selectionSize.width;
    const selHeight = selectionSample.selectionSize.height;
    const sRange = [
        offset.x / selWidth,
        (offset.x + textureWidth) / selWidth
    ];
    const tRange = [
        offset.y / selHeight,
        (offset.y + textureHeight) / selHeight
    ];
    return $cb638405dd43878a$export$d6a0409d5640315a(resolutionX, resolutionY, ffd, outputWidth, outputHeight, useCanvasSpace, sRange, tRange);
}
function $cb638405dd43878a$export$d6a0409d5640315a(resolutionX, resolutionY, lattice, // ignored if useCanvasSpace true
canvasWidth, canvasHeight, // if false will use vertex space
useCanvasSpace, /**
     * Parametric horizontal range to generate mesh for. Default: [0, 1].
     * Clips the mesh to the portion of the lattice covered by the texture,
     * so UVs stay in [0, 1] and we avoid texture wrapping issues.
     */ sRange, /**
     * Parametric vertical range to generate mesh for. Default: [0, 1].
     * Clips the mesh to the portion of the lattice covered by the texture,
     * so UVs stay in [0, 1] and we avoid texture wrapping issues.
     */ tRange) {
    const vertices = [];
    const texCoords = [];
    const frontIndices = [];
    const backIndices = [];
    const sMin = sRange ? sRange[0] : 0;
    const sMax = sRange ? sRange[1] : 1;
    const tMin = tRange ? tRange[0] : 0;
    const tMax = tRange ? tRange[1] : 1;
    // Generate mesh vertices
    for(let i = 0; i <= resolutionY; i++)for(let j = 0; j <= resolutionX; j++){
        // Parametric coords within the texture's sub-range of the lattice
        const s = sMin + j / resolutionX * (sMax - sMin);
        const t = tMin + i / resolutionY * (tMax - tMin);
        // Evaluate FFD to get canvas space position
        const canvasPos = $cb638405dd43878a$export$24b0a92fce6b8497(s, t, lattice);
        let x, y;
        if (useCanvasSpace) {
            // Keep in canvas space for hit testing
            x = canvasPos.x;
            y = canvasPos.y;
        } else {
            // Convert to normalized vertex space [-1, 1]
            // Top-left is (-1, 1), bottom-right is (1, -1)
            x = canvasPos.x / canvasWidth * 2.0 - 1.0;
            y = 1.0 - canvasPos.y / canvasHeight * 2.0;
        }
        vertices.push(x, y);
        // UV maps linearly from the sub-range to [0, 1]
        const u = (s - sMin) / (sMax - sMin);
        const v = (t - tMin) / (tMax - tMin);
        texCoords.push(u, v);
    }
    // Generate indices, classifying each triangle as front- or back-facing inline
    for(let i = 0; i < resolutionY; i++)for(let j = 0; j < resolutionX; j++){
        const topLeft = i * (resolutionX + 1) + j;
        const topRight = topLeft + 1;
        const bottomLeft = topLeft + (resolutionX + 1);
        const bottomRight = bottomLeft + 1;
        const x0 = vertices[topLeft * 2], y0 = vertices[topLeft * 2 + 1];
        const x1 = vertices[bottomLeft * 2], y1 = vertices[bottomLeft * 2 + 1];
        const x2 = vertices[topRight * 2], y2 = vertices[topRight * 2 + 1];
        const x3 = vertices[bottomRight * 2], y3 = vertices[bottomRight * 2 + 1];
        const cross0 = (x1 - x0) * (y2 - y0) - (y1 - y0) * (x2 - x0);
        (cross0 > 0 ? frontIndices : backIndices).push(topLeft, bottomLeft, topRight);
        const cross1 = (x1 - x2) * (y3 - y2) - (y1 - y2) * (x3 - x2);
        (cross1 > 0 ? frontIndices : backIndices).push(topRight, bottomLeft, bottomRight);
    }
    return {
        resolutionX: resolutionX,
        resolutionY: resolutionY,
        vertices: vertices,
        texCoords: texCoords,
        frontIndices: frontIndices,
        backIndices: backIndices
    };
}
function $cb638405dd43878a$export$2d232ae0b526c96b(// same space as mesh vertices
x, y, mesh) {
    const { vertices: vertices, texCoords: texCoords, frontIndices: frontIndices, backIndices: backIndices } = mesh;
    let frontHit = undefined;
    let backHit = undefined;
    function checkTriangles(indices) {
        for(let i = 0; i < indices.length; i += 3){
            const i0 = indices[i];
            const i1 = indices[i + 1];
            const i2 = indices[i + 2];
            const x0 = vertices[i0 * 2];
            const y0 = vertices[i0 * 2 + 1];
            const x1 = vertices[i1 * 2];
            const y1 = vertices[i1 * 2 + 1];
            const x2 = vertices[i2 * 2];
            const y2 = vertices[i2 * 2 + 1];
            // Barycentric coordinates
            const denom = (y1 - y2) * (x0 - x2) + (x2 - x1) * (y0 - y2);
            if (Math.abs(denom) < 0.00001) continue;
            const a = ((y1 - y2) * (x - x2) + (x2 - x1) * (y - y2)) / denom;
            const b = ((y2 - y0) * (x - x2) + (x0 - x2) * (y - y2)) / denom;
            const c = 1 - a - b;
            // Inside triangle?
            if (a >= 0 && b >= 0 && c >= 0) {
                // Get texture coordinates (which are the same as parametric coords)
                const s0 = texCoords[i0 * 2];
                const t0 = texCoords[i0 * 2 + 1];
                const s1 = texCoords[i1 * 2];
                const t1 = texCoords[i1 * 2 + 1];
                const s2 = texCoords[i2 * 2];
                const t2 = texCoords[i2 * 2 + 1];
                // Check winding order
                const cross = (x1 - x0) * (y2 - y0) - (y1 - y0) * (x2 - x0);
                const isBackFacing = cross > 0;
                const hit = {
                    s: a * s0 + b * s1 + c * s2,
                    t: a * t0 + b * t1 + c * t2
                };
                if (isBackFacing) backHit = hit;
                else frontHit = hit;
            }
        }
    }
    checkTriangles(frontIndices);
    checkTriangles(backIndices);
    // Prioritize back, because back faces are also rendered in front.
    return backHit || frontHit;
}
function $cb638405dd43878a$export$fd7a293c27db611b(paramCoordinate, target, lattice) {
    lattice = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(lattice);
    // via trial and error these felt good
    // so the entire mesh doesn't move when warping. Somewhat localized.
    const influenceRadius = 1 / 3;
    // smaller -> edge folds less easily over
    const edgeFalloff = 0.5;
    const n = lattice.cols - 1;
    const m = lattice.rows - 1;
    const controlPoints = lattice.controlPoints;
    // Calculate basis function values at the drag point
    const basisWeights = [];
    for(let i = 0; i <= m; i++)for(let j = 0; j <= n; j++){
        const w = $cb638405dd43878a$export$b10970dad17863b6(n, j, paramCoordinate.s) * $cb638405dd43878a$export$b10970dad17863b6(m, i, paramCoordinate.t);
        // Calculate distance for influence radius
        const si = j / n;
        const ti = i / m;
        const paramDist = Math.sqrt((si - paramCoordinate.s) ** 2 + (ti - paramCoordinate.t) ** 2);
        // Calculate a ramp from 1 to 0
        let strength = Math.max(0, 1 - paramDist / influenceRadius);
        const dragDistFromCenterX = Math.abs(paramCoordinate.s - 0.5);
        const cpDistFromCenterX = Math.abs(si - 0.5);
        const dragDistFromCenterY = Math.abs(paramCoordinate.t - 0.5);
        const cpDistFromCenterY = Math.abs(ti - 0.5);
        // weirdly feels right when warping
        if (cpDistFromCenterX > dragDistFromCenterX || cpDistFromCenterY > dragDistFromCenterY) strength *= edgeFalloff;
        basisWeights.push({
            i: i,
            j: j,
            w: w,
            strength: strength
        });
    }
    const start = $cb638405dd43878a$export$24b0a92fce6b8497(paramCoordinate.s, paramCoordinate.t, lattice);
    const dx = target.x - start.x;
    const dy = target.y - start.y;
    // Direct manipulation: solve for control point displacements.
    // Invariant: evalFFD(paramCoordinate, updatedLattice) === target exactly.
    let sumWeightsSq = 0;
    for (const { w: w, strength: strength } of basisWeights)sumWeightsSq += w * w * strength;
    for (const { i: i, j: j, w: w, strength: strength } of basisWeights){
        const scale = w / sumWeightsSq * strength;
        controlPoints[i][j].x += dx * scale;
        controlPoints[i][j].y += dy * scale;
    }
    return {
        cols: lattice.cols,
        rows: lattice.rows,
        controlPoints: controlPoints
    };
}







// returns bounds of mesh that ffd lattice would create



function $2a95441a1b997bbf$var$getFfdMeshBounds(mesh) {
    const { vertices: vertices } = mesh;
    let x1 = Infinity;
    let y1 = Infinity;
    let x2 = -Infinity;
    let y2 = -Infinity;
    for(let i = 0; i < vertices.length; i += 2){
        x1 = Math.min(x1, vertices[i]);
        y1 = Math.min(y1, vertices[i + 1]);
        x2 = Math.max(x2, vertices[i]);
        y2 = Math.max(y2, vertices[i + 1]);
    }
    // round bernstein floating point errors
    const precision = 1e6;
    return {
        type: 'coordinate',
        x1: Math.round(x1 * precision) / precision,
        y1: Math.round(y1 * precision) / precision,
        x2: Math.round(x2 * precision) / precision,
        y2: Math.round(y2 * precision) / precision
    };
}
function $2a95441a1b997bbf$export$da260002c67d0dd(ffd) {
    // Use a dummy canvas size of 1x1 since we request canvas space — the actual
    // canvas dimensions don't matter here because useCanvasSpace bypasses the
    // NDC conversion entirely.
    const mesh = (0, $cb638405dd43878a$export$d6a0409d5640315a)((0, $b14ff3017e98e7d9$export$6ba60dd123964f3e), (0, $b14ff3017e98e7d9$export$6ba60dd123964f3e), ffd, 1, 1, true);
    return $2a95441a1b997bbf$var$getFfdMeshBounds(mesh);
}
function $2a95441a1b997bbf$export$b8704036eca28391(mesh, width, height) {
    const ffdBounds = (0, $4c2c6808296c0d73$export$b0036cbc597df324)($2a95441a1b997bbf$var$getFfdMeshBounds(mesh));
    return (0, $4c2c6808296c0d73$export$ddc1c0069d484d49)(ffdBounds, width, height);
}


const $b14ff3017e98e7d9$export$6ba60dd123964f3e = 64;
function $b14ff3017e98e7d9$export$552b36716f27e91b(transform, center) {
    transform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') return {
        ...transform,
        freeTransform: (0, $8c752cc1d7c845be$export$958c2bfe8d7142a9)({
            ...transform.freeTransform,
            x: center.x,
            y: center.y
        })
    };
    // ffd
    const bounds = (0, $2a95441a1b997bbf$export$da260002c67d0dd)(transform.ffd);
    // use freeTransform so we can use snapToPixel
    const freeTransform = $b14ff3017e98e7d9$export$928f0648354c9a2f((0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)(bounds));
    const snappedTransform = (0, $8c752cc1d7c845be$export$958c2bfe8d7142a9)({
        ...freeTransform,
        x: center.x,
        y: center.y
    });
    const matrix = $b14ff3017e98e7d9$export$e464a809f7257768(snappedTransform, (0, $4c2c6808296c0d73$export$b0036cbc597df324)(bounds));
    return {
        type: 'ffd',
        ffd: $b14ff3017e98e7d9$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $b14ff3017e98e7d9$export$44831334ca780533(transform, axis) {
    transform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') {
        const ft = transform.freeTransform;
        return {
            ...transform,
            freeTransform: {
                ...ft,
                width: -ft.width,
                height: ft.height,
                angleDeg: axis === 'y' ? -ft.angleDeg + 180 : -ft.angleDeg
            }
        };
    }
    // ffd
    const bounds = (0, $2a95441a1b997bbf$export$da260002c67d0dd)(transform.ffd);
    const center = {
        x: (bounds.x1 + bounds.x2) / 2,
        y: (bounds.y1 + bounds.y2) / 2
    };
    const matrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $15f17d2145582868$export$d73ee8ef04f5226a)(center.x, center.y), (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(axis === 'x' ? -1 : 1, axis === 'y' ? -1 : 1), (0, $15f17d2145582868$export$d73ee8ef04f5226a)(-center.x, -center.y));
    return {
        type: 'ffd',
        ffd: $b14ff3017e98e7d9$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $b14ff3017e98e7d9$export$7eaa413076082bd7(transform, factor) {
    transform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') {
        const before = transform.freeTransform;
        // prevent edge cases (leading to NaN) where width and height are 0.
        if (factor > 1 && (factor * before.width === 0 || factor * before.height === 0)) return transform;
        if (factor < 1 && (factor * before.width < 1 || factor * before.height < 1)) return transform;
        return {
            ...transform,
            freeTransform: (0, $8c752cc1d7c845be$export$958c2bfe8d7142a9)({
                ...transform.freeTransform,
                width: transform.freeTransform.width * factor,
                height: transform.freeTransform.height * factor
            })
        };
    }
    // ffd
    const bounds = (0, $2a95441a1b997bbf$export$da260002c67d0dd)(transform.ffd);
    const center = {
        x: (bounds.x1 + bounds.x2) / 2,
        y: (bounds.y1 + bounds.y2) / 2
    };
    const matrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $15f17d2145582868$export$d73ee8ef04f5226a)(center.x, center.y), (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(factor), (0, $15f17d2145582868$export$d73ee8ef04f5226a)(-center.x, -center.y));
    return {
        type: 'ffd',
        ffd: $b14ff3017e98e7d9$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $b14ff3017e98e7d9$export$71dd993772432b93(transform, deltaAngleDeg) {
    transform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') return {
        ...transform,
        freeTransform: (0, $8c752cc1d7c845be$export$958c2bfe8d7142a9)({
            ...transform.freeTransform,
            angleDeg: (transform.freeTransform.angleDeg + deltaAngleDeg) % 360
        })
    };
    // ffd
    const bounds = (0, $2a95441a1b997bbf$export$da260002c67d0dd)(transform.ffd);
    // use freeTransform so we can use snapToPixel
    const freeTransform = $b14ff3017e98e7d9$export$928f0648354c9a2f((0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)(bounds));
    const snappedTransform = (0, $8c752cc1d7c845be$export$958c2bfe8d7142a9)({
        ...freeTransform,
        angleDeg: deltaAngleDeg % 360
    });
    const matrix = $b14ff3017e98e7d9$export$e464a809f7257768(snappedTransform, (0, $4c2c6808296c0d73$export$b0036cbc597df324)(bounds));
    return {
        type: 'ffd',
        ffd: $b14ff3017e98e7d9$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $b14ff3017e98e7d9$export$e464a809f7257768(transform, bounds) {
    const rect = (0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)(bounds);
    const centerBefore = {
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2
    };
    const scaleX = transform.width / rect.width;
    const scaleY = transform.height / rect.height;
    const angleRad = transform.angleDeg / 180 * Math.PI;
    return (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $15f17d2145582868$export$d73ee8ef04f5226a)(transform.x, transform.y), (0, $648ca1a32d748118$export$bb628a54ab399bc9)(angleRad), (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(scaleX, scaleY), (0, $15f17d2145582868$export$d73ee8ef04f5226a)(-centerBefore.x, -centerBefore.y));
}
function $b14ff3017e98e7d9$export$928f0648354c9a2f(rect) {
    return {
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2,
        width: rect.width,
        height: rect.height,
        angleDeg: 0
    };
}
// warps and automatically subdivides and optimizes the selection polygon
function $b14ff3017e98e7d9$var$warpSelection(ffd, selection, selectionBounds) {
    const { width: width, height: height } = (0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)(selectionBounds);
    const result = selection.map((polygon)=>polygon.map((ring)=>{
            // ring 1 - subdivide based on edge delta relative to selection bounds
            const ring1 = [];
            for(let i = 0; i < ring.length; i++){
                const p1 = ring[i];
                const p2 = ring[(i + 1) % ring.length];
                // Add current point
                ring1.push(p1);
                // Subdivide based on whichever axis delta is proportionally larger
                const dx = p2[0] - p1[0];
                const dy = p2[1] - p1[1];
                const ratioX = Math.abs(dx) / width;
                const ratioY = Math.abs(dy) / height;
                const dominantRatio = Math.max(ratioX, ratioY);
                const segments = Math.max(1, Math.round(dominantRatio * 4));
                for(let j = 1; j < segments; j++){
                    const t = j / segments;
                    ring1.push([
                        p1[0] + dx * t,
                        p1[1] + dy * t
                    ]);
                }
            }
            // ring 2 - subdivide based on edge delta in warped space. but subdivide in the original space
            const ring2 = [];
            for(let i = 0; i < ring1.length; i++){
                const p1 = ring1[i];
                const p2 = ring1[(i + 1) % ring1.length];
                ring2.push(p1);
                // Warp both endpoints to measure edge length in warped space
                const s1 = (p1[0] - selectionBounds.x1) / width;
                const t1 = (p1[1] - selectionBounds.y1) / height;
                const w1 = (0, $cb638405dd43878a$export$24b0a92fce6b8497)(s1, t1, ffd);
                const s2 = (p2[0] - selectionBounds.x1) / width;
                const t2 = (p2[1] - selectionBounds.y1) / height;
                const w2 = (0, $cb638405dd43878a$export$24b0a92fce6b8497)(s2, t2, ffd);
                const wdx = w2.x - w1.x;
                const wdy = w2.y - w1.y;
                const warpedLength = Math.sqrt(wdx * wdx + wdy * wdy);
                const segments = Math.max(1, Math.ceil(warpedLength / 4));
                const dx = p2[0] - p1[0];
                const dy = p2[1] - p1[1];
                for(let j = 1; j < segments; j++){
                    const t = j / segments;
                    ring2.push([
                        p1[0] + dx * t,
                        p1[1] + dy * t
                    ]);
                }
            }
            const warpedRing = ring2.map((point)=>{
                // Convert point to normalized coordinates [0, 1]
                const s = (point[0] - selectionBounds.x1) / width;
                const t = (point[1] - selectionBounds.y1) / height;
                // Evaluate FFD at normalized coordinates
                const warped = (0, $cb638405dd43878a$export$24b0a92fce6b8497)(s, t, ffd);
                return [
                    warped.x,
                    warped.y
                ];
            });
            // optimized ring - remove collinear points
            const angleDegThreshold = 1;
            const cosThreshold = Math.cos(angleDegThreshold / 180 * Math.PI);
            const optimizedRing = [];
            for(let i = 0; i < warpedRing.length - 1; i++){
                const prev = optimizedRing.at(-1) ?? warpedRing.at(-1);
                const curr = warpedRing[i];
                const next = warpedRing[(i + 1) % warpedRing.length];
                const ax = curr[0] - prev[0];
                const ay = curr[1] - prev[1];
                const bx = next[0] - curr[0];
                const by = next[1] - curr[1];
                const lenA = Math.sqrt(ax * ax + ay * ay);
                const lenB = Math.sqrt(bx * bx + by * by);
                if (lenA !== 0 && lenB !== 0 && (ax * bx + ay * by) / (lenA * lenB) <= cosThreshold) optimizedRing.push(curr);
            }
            optimizedRing.push(warpedRing.at(-1));
            return optimizedRing;
        }));
    return result;
}
function $b14ff3017e98e7d9$export$c17d845d16ec8ae(transform, selection) {
    const selectionBounds = (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(selection, 'index');
    if (transform.type === 'ffd') return $b14ff3017e98e7d9$var$warpSelection(transform.ffd, selection, selectionBounds);
    if (transform.type === 'ffd+free') return $b14ff3017e98e7d9$var$warpSelection($b14ff3017e98e7d9$export$a56ca41a0dbe2002(transform.ffd, $b14ff3017e98e7d9$export$e464a809f7257768(transform.freeTransform, (0, $4c2c6808296c0d73$export$d89ccdf57354a99c)(transform.ffdBounds, 'index'))), selection, selectionBounds);
    const transformationMatrix = $b14ff3017e98e7d9$export$e464a809f7257768(transform.freeTransform, selectionBounds);
    return (0, $5f00e0232038b1be$export$aa391dbbf8073422)(selection, transformationMatrix);
}
function $b14ff3017e98e7d9$export$a56ca41a0dbe2002(ffd, matrix) {
    return {
        cols: ffd.cols,
        rows: ffd.rows,
        controlPoints: ffd.controlPoints.map((row)=>row.map((point)=>(0, $43e83319b765a157$export$9b20165a36586806)(matrix, point)))
    };
}




function $d4ff44c295f41b68$var$parseCssColor(colorString) {
    if (colorString === 'transparent') return {
        r: 0,
        g: 0,
        b: 0,
        a: 0
    };
    if (colorString.startsWith('#')) {
        let hex = colorString.slice(1);
        if (hex.length === 3) hex = hex.split('').map((c)=>c + c).join('');
        if (hex.length === 6) // assume full alpha
        hex += 'ff';
        const intVal = parseInt(hex, 16);
        return {
            r: intVal >> 24 & 255,
            g: intVal >> 16 & 255,
            b: intVal >> 8 & 255,
            a: (intVal & 255) / 255
        };
    }
    const rgbMatch = colorString.match(/rgba?\(([^)]+)\)/);
    if (rgbMatch) {
        const [r, g, b, a = 1] = rgbMatch[1].split(',').map((v)=>parseFloat(v.trim()));
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    return undefined;
}
function $d4ff44c295f41b68$export$784dd829176d2fbc(layer) {
    for (const tile of layer.tiles)if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(tile)) {
        const color = $d4ff44c295f41b68$var$parseCssColor(tile.fill);
        if (color && color.a < 1) return true;
    } else {
        const data = tile.data.data;
        for(let i = 3; i < data.length; i += 4){
            if (data[i] < 255) return true;
        }
    }
    return false;
}


// preference expressed by user
let $19404419558f247b$var$preferenceIsTransparentBg;
function $19404419558f247b$var$getIsTransparentBg(isBgLayer, layerHasTransparency, preference) {
    if (!isBgLayer) return true;
    if (preference !== undefined) return preference;
    return layerHasTransparency;
}
function $19404419558f247b$var$drawTransform(ctx, copiedCanvas, isPixelated, transform, selection, boundsObj, doClone, isTransparentBg) {
    const width = ctx.canvas.width;
    const height = ctx.canvas.height;
    ctx.save();
    ctx.clearRect(0, 0, width, height);
    ctx.save();
    if (selection) {
        // draw original with clipped selection
        ctx.drawImage(copiedCanvas, 0, 0);
        if (!doClone) {
            const selectionPath = (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(selection);
            ctx.clip(selectionPath);
            ctx.globalCompositeOperation = isTransparentBg ? 'destination-out' : 'source-atop';
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, width, height);
        }
    } else {
        if (isTransparentBg) {
            if (doClone) ctx.drawImage(copiedCanvas, 0, 0);
        } else {
            ctx.drawImage(copiedCanvas, 0, 0);
            if (!doClone) {
                ctx.fillStyle = 'white';
                ctx.globalCompositeOperation = 'source-atop';
                ctx.fillRect(0, 0, width, height);
            }
        }
    }
    ctx.restore();
    let matrix;
    if (selection) {
        const bounds = boundsObj ?? {
            x: 0,
            y: 0,
            width: ctx.canvas.width,
            height: ctx.canvas.height
        };
        if (isPixelated || (0, $be957da3610487e9$export$921068d8846a1559).testShouldPixelate(transform, transform.width / bounds.width, transform.height / bounds.height)) ctx.imageSmoothingEnabled = false;
        else {
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
        }
        // derived from drawTransformedImageWithBounds
        matrix = (0, $1122233c3b48b24e$export$f672e0b6f7222cd7)((0, $15f17d2145582868$export$d73ee8ef04f5226a)(transform.x, transform.y), (0, $648ca1a32d748118$export$bb628a54ab399bc9)(transform.angleDeg / 180 * Math.PI), (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(transform.width > 0 ? 1 : -1, transform.height > 0 ? 1 : -1), (0, $15f17d2145582868$export$d73ee8ef04f5226a)(-Math.abs(transform.width) / 2, -Math.abs(transform.height) / 2), (0, $c78f6b9ad5de5188$export$dcdf75081b88279d)(Math.abs(transform.width / bounds.width), Math.abs(transform.height / bounds.height)), (0, $15f17d2145582868$export$d73ee8ef04f5226a)(-bounds.x, -bounds.y));
        ctx.setTransform(...(0, $f7c026d16783f524$export$2b60e7dafdbde18a)(matrix));
        const selectionPath = (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(selection);
        ctx.clip(selectionPath);
        ctx.drawImage(copiedCanvas, 0, 0);
    } else (0, $be957da3610487e9$export$921068d8846a1559).drawTransformedImageWithBounds(ctx, copiedCanvas, transform, boundsObj, isPixelated);
    ctx.restore();
    return matrix;
}
const $19404419558f247b$export$dc15474d94cdc2b3 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const context = layer.context;
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        const layers = klCanvas.getLayers();
        const isBgLayer = selectedLayerIndex === 0;
        let hasTransparency = false;
        if (isBgLayer) {
            const layer = Object.entries(params.composed.layerMap).find(([_, layer])=>layer.index === selectedLayerIndex)[1];
            hasTransparency = (0, $d4ff44c295f41b68$export$784dd829176d2fbc)(layer);
        }
        const selection = klCanvas.getSelection();
        // determine bounds and initial transformation
        const boundsObj = selection ? (0, $58a3332bd07c6dd1$export$6be4733fa804854c)(selection, context) : (0, $2f436639594531f3$export$c1fcf1f93aeabfbf)(context);
        if (!boundsObj) return {
            error: (0, $fc42a07754814920$export$ce37e184d908d785)(selection ? 'filter-transform-empty-selection' : 'filter-transform-empty')
        };
        const initTransform = {
            x: boundsObj.x + boundsObj.width / 2,
            y: boundsObj.y + boundsObj.height / 2,
            width: boundsObj.width,
            height: boundsObj.height,
            angleDeg: 0
        };
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        const result = {
            element: rootEl
        };
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$3a4a74a7d8c44e62).width;
        const keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
            onDown: function(keyStr) {
                if ((0, $be957da3610487e9$export$921068d8846a1559).isInputFocused(true)) return;
                if (keyStr === 'left') {
                    inputX.setValue(inputX.getValue() - 1);
                    onInputsChanged();
                }
                if (keyStr === 'right') {
                    inputX.setValue(inputX.getValue() + 1);
                    onInputsChanged();
                }
                if (keyStr === 'up') {
                    inputY.setValue(inputY.getValue() - 1);
                    onInputsChanged();
                }
                if (keyStr === 'down') {
                    inputY.setValue(inputY.getValue() + 1);
                    onInputsChanged();
                }
            }
        });
        const leftWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: 100,
                height: 30,
                display: 'inline-block'
            }
        });
        const rightWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: 100,
                height: 30,
                display: 'inline-block'
            }
        });
        const rotWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: 150,
                height: 30,
                display: 'inline-block'
            }
        });
        const inputX = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            type: 'number',
            init: 0,
            step: 1,
            name: 'transform-x',
            label: 'X:',
            css: {
                width: 70
            },
            onChange: ()=>onInputsChanged()
        });
        const inputY = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            type: 'number',
            init: 0,
            step: 1,
            name: 'transform-y',
            label: 'Y:',
            css: {
                width: 70
            },
            onChange: ()=>onInputsChanged()
        });
        const inputR = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            type: 'number',
            init: 0,
            step: 1,
            name: 'transform-rotation',
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-rotation') + ':',
            css: {
                width: 70
            },
            onChange: ()=>onInputsChanged()
        });
        leftWrapper.append(inputX.getElement());
        rightWrapper.append(inputY.getElement());
        rotWrapper.append(inputR.getElement());
        if (!isSmall) {
            const inputRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: rootEl,
                css: {
                    marginTop: 10
                }
            });
            inputRow.append(leftWrapper, rightWrapper, rotWrapper);
        }
        // buttons
        const buttonRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 10,
                marginTop: 10
            }
        });
        const flipXBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-flip') + ' X',
            destroyer: destroyer,
            onClick: ()=>{
                const transformed = (0, $b14ff3017e98e7d9$export$44831334ca780533)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 'x');
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        const flipYBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-flip') + ' Y',
            destroyer: destroyer,
            onClick: ()=>{
                const transformed = (0, $b14ff3017e98e7d9$export$44831334ca780533)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 'y');
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        const scaleRotLeftBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            className: 'kl-button',
            content: "-90\xb0",
            destroyer: destroyer,
            onClick: ()=>{
                const transformed = (0, $b14ff3017e98e7d9$export$71dd993772432b93)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, -90);
                freeTransform.initialise(transformed.freeTransform);
                inputR.setValue(Math.round(transformed.freeTransform.angleDeg));
                updatePreview();
            }
        });
        const scaleRotRightBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            className: 'kl-button',
            content: "+90\xb0",
            destroyer: destroyer,
            onClick: ()=>{
                const transformed = (0, $b14ff3017e98e7d9$export$71dd993772432b93)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 90);
                freeTransform.initialise(transformed.freeTransform);
                inputR.setValue(Math.round(transformed.freeTransform.angleDeg));
                updatePreview();
            }
        });
        const scaleDoubleBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            className: 'kl-button',
            content: '2&times;',
            destroyer: destroyer,
            onClick: ()=>{
                const transformed = (0, $b14ff3017e98e7d9$export$7eaa413076082bd7)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 2);
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        const scaleHalfBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            className: 'kl-button',
            content: '&frac12;&times;',
            destroyer: destroyer,
            onClick: ()=>{
                const transformed = (0, $b14ff3017e98e7d9$export$7eaa413076082bd7)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 0.5);
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        const centerBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: buttonRow,
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('center'),
            destroyer: destroyer,
            onClick: ()=>{
                const transformed = (0, $b14ff3017e98e7d9$export$552b36716f27e91b)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, {
                    x: context.canvas.width / 2,
                    y: context.canvas.height / 2
                });
                freeTransform.initialise(transformed.freeTransform);
                inputX.setValue(Math.round(transformed.freeTransform.x - initTransform.x));
                inputY.setValue(Math.round(transformed.freeTransform.y - initTransform.y));
                updatePreview();
            }
        });
        let doClone = false;
        const cloneCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: doClone,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('select-transform-clone'),
            allowTab: true,
            callback: function(b) {
                doClone = b;
                updatePreview(true);
            },
            css: {
                display: 'inline-block'
            },
            name: 'clone-before-transforming'
        });
        let isTransparentBg = $19404419558f247b$var$getIsTransparentBg(isBgLayer, hasTransparency, $19404419558f247b$var$preferenceIsTransparentBg);
        let transparentBgCheckboxTouched = false;
        const transparentBgCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: isTransparentBg,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-eraser-transparent-bg'),
            allowTab: true,
            callback: function(b) {
                transparentBgCheckboxTouched = true;
                isTransparentBg = b;
                updatePreview(true);
            },
            css: {
                display: 'inline-block'
            },
            name: 'transparent-background'
        });
        buttonRow.append(cloneCheckbox.getElement());
        if (isBgLayer) buttonRow.append(transparentBgCheckbox.getElement());
        let isConstrained = true;
        const constrainCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-constrain'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('constrain-proportions'),
            allowTab: true,
            callback: function(b) {
                isConstrained = b;
                freeTransform.setIsConstrained(isConstrained);
            },
            css: {
                display: 'inline-block'
            },
            name: 'constrain-proportions'
        });
        let isSnapping = false;
        const snappingCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-snap'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-snap-title'),
            allowTab: true,
            callback: function(b) {
                isSnapping = b;
                freeTransform.setSnapping(isSnapping);
            },
            css: {
                display: 'inline-block',
                marginLeft: 10
            },
            name: 'enable-snapping'
        });
        const checkboxWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el();
        checkboxWrapper.append(constrainCheckbox.getElement(), snappingCheckbox.getElement());
        rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                clear: 'both',
                height: 10
            }
        }));
        const bottomRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 10
            }
        });
        const algorithmToggle = new (0, $451c2c6773f98d8b$export$6152f1e421c68434)({
            initValue: 'smooth',
            isFocusable: true,
            onChange: ()=>{
                updatePreview(true);
            }
        });
        bottomRow.append(checkboxWrapper, algorithmToggle.getElement());
        const previewCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(context.canvas.width, context.canvas.height);
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? previewCanvas : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            hasEditMode: true,
            onModeChange: (m)=>{
                freeTransform.getElement().style.pointerEvents = m === 'edit' ? '' : 'none';
                freeTransform.getElement().style.opacity = m === 'edit' ? '' : '0.5';
            },
            onTransformChange: (transform)=>{
                freeTransform.setViewportTransform(transform);
            },
            padding: 30
        });
        preview.render();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            overflow: 'hidden',
            marginLeft: -20,
            marginRight: -20
        });
        rootEl.append(preview.getElement());
        let lastDrawnTransformStr = '';
        function updatePreview(doForce = false) {
            if (!freeTransform) return;
            const transform = freeTransform.getValue();
            if (JSON.stringify(transform) === lastDrawnTransformStr && !doForce) return;
            lastDrawnTransformStr = JSON.stringify(transform);
            const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(previewCanvas);
            $19404419558f247b$var$drawTransform(ctx, layers[selectedLayerIndex].canvas, algorithmToggle.getValue() === 'pixelated', transform, selection, boundsObj, doClone, isTransparentBg || selectedLayerIndex > 0);
            preview.render();
        }
        const freeTransform = new (0, $93e6a53ec76e8c56$export$79a74567acf241b0)({
            x: initTransform.x,
            y: initTransform.y,
            width: initTransform.width,
            height: initTransform.height,
            angleDeg: initTransform.angleDeg,
            isConstrained: true,
            snapX: [
                0,
                context.canvas.width
            ],
            snapY: [
                0,
                context.canvas.height
            ],
            callback: function(t) {
                inputX.setValue(Math.round(t.x - initTransform.x));
                inputY.setValue(Math.round(t.y - initTransform.y));
                inputR.setValue(Math.round(t.angleDeg));
                updatePreview();
            },
            viewportTransform: preview.getTransform()
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(freeTransform.getElement(), {
            position: 'absolute',
            left: 0,
            top: 0
        });
        preview.getElement().append(freeTransform.getElement());
        function onInputsChanged() {
            freeTransform.setPos({
                x: inputX.getValue() + initTransform.x,
                y: inputY.getValue() + initTransform.y
            });
            freeTransform.setAngleDeg(inputR.getValue());
            updatePreview();
        }
        updatePreview();
        result.destroy = ()=>{
            keyListener.destroy();
            freeTransform.destroy();
            constrainCheckbox.destroy();
            snappingCheckbox.destroy();
            algorithmToggle.destroy();
            inputX.destroy();
            inputY.destroy();
            inputR.destroy();
            destroyer.destroy();
            preview.destroy();
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(previewCanvas);
        };
        result.getInput = function() {
            const transform = freeTransform.getValue();
            if (transparentBgCheckboxTouched) $19404419558f247b$var$preferenceIsTransparentBg = isTransparentBg;
            const input = {
                transform: transform,
                bounds: boundsObj,
                isPixelated: algorithmToggle.getValue() === 'pixelated',
                doClone: doClone,
                isTransparentBg: isTransparentBg
            };
            result.destroy();
            return (0, $be957da3610487e9$export$921068d8846a1559).copyObj(input);
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        if (!context) return false;
        const input = params.input;
        const selectedLayerIndex = params.layer.index;
        const copyCanvas = (0, $be957da3610487e9$export$921068d8846a1559).copyToCanvas(context.canvas);
        let selection = params.klCanvas.getSelection();
        const matrix = $19404419558f247b$var$drawTransform(context, copyCanvas, input.isPixelated, input.transform, selection, input.bounds, input.doClone, input.isTransparentBg || selectedLayerIndex > 0);
        if (selection && matrix) {
            selection = (0, $5f00e0232038b1be$export$aa391dbbf8073422)(selection, matrix);
            klHistory.pause(true);
            try {
                params.klCanvas.setSelection(selection);
            } finally{
                klHistory.pause(false);
            }
        }
        {
            const layerMap = Object.fromEntries(params.klCanvas.getLayers().map((layerItem)=>{
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $3aa9c52208735678$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap,
                ...selection ? {
                    selection: {
                        value: selection
                    }
                } : undefined
            });
        }
        return true;
    }
};












const $974b8fa45a89d6ae$export$55e7eb2ebd0db869 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        let radius = 10;
        const fxPreviewRenderer = new (0, $edd68b64db3c6175$export$94ec999f33a691e3)({
            original: layer.canvas,
            onUpdate: (fxCanvas, transform)=>{
                return fxCanvas.multiplyAlpha().triangleBlur(radius * transform.scaleX).unmultiplyAlpha();
            },
            selection: klCanvas.getSelection()
        });
        const radiusSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('radius'),
            width: 300,
            height: 30,
            min: 1,
            max: 200,
            value: radius,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            onChange: (val)=>{
                radius = val;
                preview.render();
            }
        });
        radiusSlider.getElement().style.marginBottom = '10px';
        rootEl.append(radiusSlider.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: -20,
            marginRight: -20
        });
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            radiusSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                radius: radius
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        const radius = params.input.radius;
        if (!context || !radius) return false;
        return (0, $6b8a42764b141679$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.multiplyAlpha().triangleBlur(radius).unmultiplyAlpha();
        }, klHistory);
    }
};











const $d21b2890cdc4e8be$export$62ac74a5ea43bd5c = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        let radius = 2, strength = 0.51;
        const fxPreviewRenderer = new (0, $edd68b64db3c6175$export$94ec999f33a691e3)({
            original: layer.canvas,
            onUpdate: (fxCanvas, transform)=>{
                return fxCanvas.unsharpMask(radius * transform.scaleX, strength);
            },
            selection: klCanvas.getSelection()
        });
        function update() {
            preview.render();
        }
        const radiusSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('radius'),
            width: 300,
            height: 30,
            min: 0,
            max: 200,
            value: 2,
            //eventResMs: eventResMs,
            onChange: function(val) {
                radius = val;
                update();
            },
            curve: [
                [
                    0,
                    0
                ],
                [
                    0.1,
                    2
                ],
                [
                    0.5,
                    50
                ],
                [
                    1,
                    200
                ]
            ]
        });
        const strengthSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-unsharp-mask-strength'),
            width: 300,
            height: 30,
            min: 0,
            max: 50,
            value: 5.1,
            //eventResMs: eventResMs,
            onChange: function(val) {
                strength = val / 10;
                update();
            },
            curve: [
                [
                    0,
                    0
                ],
                [
                    0.1,
                    2
                ],
                [
                    0.5,
                    10
                ],
                [
                    1,
                    50
                ]
            ]
        });
        radiusSlider.getElement().style.marginBottom = '10px';
        strengthSlider.getElement().style.marginBottom = '10px';
        rootEl.append(radiusSlider.getElement());
        rootEl.append(strengthSlider.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        update();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: -20,
            marginRight: -20
        });
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            radiusSlider.destroy();
            strengthSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                radius: radius,
                strength: strength
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        const radius = params.input.radius;
        const strength = params.input.strength;
        if (!context || radius === null || strength === null) return false;
        return (0, $6b8a42764b141679$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.unsharpMask(radius, strength);
        }, klHistory);
    }
};












const $411358ccecdab2ba$export$6158ed2b22ebf4d9 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        const fxPreviewRenderer = new (0, $edd68b64db3c6175$export$94ec999f33a691e3)({
            original: layer.canvas,
            onUpdate: (fxCanvas)=>{
                return fxCanvas.toAlpha(sourceId === 'inverted-luminance', selectedRgbaObj);
            },
            selection: klCanvas.getSelection()
        });
        // source
        let sourceId = 'inverted-luminance';
        const sourceOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            isFocusable: true,
            optionArr: [
                {
                    id: 'inverted-luminance',
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-to-alpha-inverted-lum')
                },
                {
                    id: 'luminance',
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-to-alpha-lum')
                }
            ],
            initId: sourceId,
            onChange: function(id) {
                sourceId = id;
                preview.render();
            }
        });
        rootEl.append(sourceOptions.getElement());
        // color
        let selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        const colorOptionsArr = [
            null,
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },
            {
                r: params.currentColorRgb.r,
                g: params.currentColorRgb.g,
                b: params.currentColorRgb.b,
                a: 1
            },
            {
                r: params.secondaryColorRgb.r,
                g: params.secondaryColorRgb.g,
                b: params.secondaryColorRgb.b,
                a: 1
            }
        ];
        const colorOptions = new (0, $115e148fb390275d$export$24ba9b81662d4366)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-to-alpha-replace'),
            colorArr: colorOptionsArr,
            initialIndex: 1,
            onChange: function(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                preview.render();
            },
            css: {
                margin: '10px 0'
            }
        });
        rootEl.append(colorOptions.getElement());
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: -20,
            marginRight: -20
        });
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            sourceOptions.destroy();
            colorOptions.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                sourceId: sourceId,
                selectedRgbaObj: selectedRgbaObj
            };
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klHistory = params.klHistory;
        const sourceId = params.input.sourceId;
        const selectedRgbaObj = params.input.selectedRgbaObj;
        if (!context || !sourceId) return false;
        return (0, $6b8a42764b141679$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.toAlpha(sourceId === 'inverted-luminance', selectedRgbaObj);
        }, klHistory);
    }
};






// ideas: padding, gutter, other shapes
function $59d723a0fd026236$export$20d2db9c68afeac(ctx, cellsX, cellsY, thickness, color, opacity) {
    ctx.save();
    const w = ctx.canvas.width;
    const h = ctx.canvas.height;
    thickness = Math.round(thickness);
    const thickIsRound = thickness % 2 === 0;
    ctx.beginPath();
    ctx.lineWidth = thickness;
    ctx.strokeStyle = color;
    ctx.globalAlpha = opacity;
    for(let i = 0; i < cellsX - 1; i++){
        const cw = w / cellsX;
        let pos = cw * (i + 1);
        if (thickIsRound) pos = Math.round(pos);
        else pos = Math.round(pos + 0.5) - 0.5;
        ctx.moveTo(pos, 0);
        ctx.lineTo(pos, h);
    }
    for(let i = 0; i < cellsY - 1; i++){
        const ch = h / cellsY;
        let pos = ch * (i + 1);
        if (thickIsRound) pos = Math.round(pos);
        else pos = Math.round(pos + 0.5) - 0.5;
        ctx.moveTo(0, pos);
        ctx.lineTo(w, pos);
    }
    ctx.stroke();
    ctx.restore();
}







const $91098c12a55394b9$export$50020de79e1bc23 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        const settingsObj = {
            x: 2,
            y: 2,
            thickness: 8,
            color: '#000',
            opacity: 1
        };
        const line1 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        const line2 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: 10,
                marginBottom: 10
            }
        });
        const xInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: 2,
            type: 'number',
            name: 'grid-x',
            min: 1,
            step: 1,
            css: {
                width: 75,
                marginRight: 20
            },
            onChange: function(v) {
                settingsObj.x = v;
                updatePreview();
            }
        });
        const yInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: 2,
            type: 'number',
            name: 'grid-y',
            min: 1,
            step: 1,
            css: {
                width: 75,
                marginRight: 20
            },
            onChange: function(v) {
                settingsObj.y = v;
                updatePreview();
            }
        });
        const thicknessInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: settingsObj.thickness,
            type: 'number',
            name: 'grid-thickness',
            min: 1,
            step: 1,
            css: {
                width: 75,
                marginRight: 20
            },
            onChange: function(v) {
                settingsObj.thickness = v;
                updatePreview();
            }
        });
        let selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        const colorOptionsArr = [
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }
        ];
        colorOptionsArr.push({
            r: params.currentColorRgb.r,
            g: params.currentColorRgb.g,
            b: params.currentColorRgb.b,
            a: 1
        });
        colorOptionsArr.push({
            r: params.secondaryColorRgb.r,
            g: params.secondaryColorRgb.g,
            b: params.secondaryColorRgb.b,
            a: 1
        });
        settingsObj.color = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr(selectedRgbaObj);
        const colorOptions = new (0, $115e148fb390275d$export$24ba9b81662d4366)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-stroke'),
            colorArr: colorOptionsArr,
            onChange: function(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                settingsObj.color = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr(selectedRgbaObj);
                updatePreview();
            }
        });
        const labelStyle = {
            display: 'inline-block',
            marginRight: 5
        };
        line1.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: 'X:',
            css: labelStyle
        }), xInput.getElement(), (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: 'Y:',
            css: labelStyle
        }), yInput.getElement());
        line2.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-line-width') + ':',
            css: labelStyle
        }), thicknessInput.getElement(), (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                flexGrow: 1
            }
        }), colorOptions.getElement());
        const previewCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(layer.canvas.width, layer.canvas.height);
        const previewCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(previewCanvas);
        const previewLayerArr = layers.map((item, i)=>{
            return {
                image: i === selectedLayerIndex ? previewCanvas : item.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr,
                hasClipping: item.hasClipping
            };
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            }
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: -20,
            marginRight: -20
        });
        rootEl.append(preview.getElement());
        function updatePreview() {
            const ctx = previewCtx;
            ctx.save();
            ctx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
            ctx.drawImage(layer.canvas, 0, 0);
            (0, $59d723a0fd026236$export$20d2db9c68afeac)(ctx, settingsObj.x, settingsObj.y, Math.max(settingsObj.thickness, 1), settingsObj.color, settingsObj.opacity);
            ctx.restore();
            preview.render();
        }
        updatePreview();
        preview.render();
        result.destroy = ()=>{
            preview.destroy();
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(previewCanvas);
            colorOptions.destroy();
            xInput.destroy();
            yInput.destroy();
            thicknessInput.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return (0, $be957da3610487e9$export$921068d8846a1559).copyObj(settingsObj);
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klCanvas = params.klCanvas;
        const klHistory = params.klHistory;
        if (!context || !klCanvas) return false;
        (0, $59d723a0fd026236$export$20d2db9c68afeac)(context, params.input.x, params.input.y, params.input.thickness, params.input.color, params.input.opacity);
        {
            const layerMap = Object.fromEntries(params.klCanvas.getLayers().map((layerItem)=>{
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $3aa9c52208735678$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};























var $7547f9b3bd28fab0$export$2ba01fb71ed41cb6;
var $7547f9b3bd28fab0$export$35e9368ef982300f;
$7547f9b3bd28fab0$export$2ba01fb71ed41cb6 = `_-5j8a_button`;
$7547f9b3bd28fab0$export$35e9368ef982300f = `_-5j8a_color`;



class $21096068e085338c$export$5a1d7ca0a925d9c2 {
    update() {
        const colorStr = '#' + (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toHexString(this.color);
        this.colorEl.style.backgroundColor = colorStr;
        this.rootEl.title = this.title ?? colorStr;
        this.rootEl.setAttribute('aria-label', this.ariaLabel ? `${this.ariaLabel}: ${colorStr}` : colorStr);
    }
    closeColorPicker() {
        if (this.colorPickerWindow) {
            this.colorPickerWindow.destroy();
            this.colorPickerWindow = undefined;
            return true;
        }
        return false;
    }
    toggleColorPicker() {
        if (this.closeColorPicker()) return;
        if (!this.colorPickerPosition) {
            const rect = this.rootEl.getBoundingClientRect();
            this.colorPickerPosition = {
                x: rect.left,
                y: rect.bottom + 8
            };
        }
        this.colorPickerWindow = new (0, $364f444c1ac877b6$export$214507535a0fe5b2)({
            color: this.color,
            onChange: (newColor)=>{
                this.color = {
                    ...newColor
                };
                this.update();
                this.onChange({
                    ...this.color
                });
            },
            onMove: (position)=>{
                this.colorPickerPosition = position;
            },
            onClose: ()=>this.closeColorPicker(),
            position: this.colorPickerPosition,
            closeOnOutsideClick: true,
            triggerElement: this.rootEl
        });
    }
    getElement() {
        return this.rootEl;
    }
    getValue() {
        return {
            ...this.color
        };
    }
    setValue(color) {
        this.color = {
            ...color
        };
        this.colorPickerWindow?.setColor(this.color);
        this.update();
    }
    destroy() {
        this.closeColorPicker();
        this.rootEl.remove();
        this.destroyer.destroy();
    }
    constructor(p){
        this.destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
        this.color = {
            ...p.init
        };
        this.onChange = p.onChange;
        this.title = p.title;
        this.ariaLabel = p.ariaLabel;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: [
                $7547f9b3bd28fab0$export$2ba01fb71ed41cb6,
                (0, $9e4d66c06c67fa7f$export$e11d0f35da1b29a3)
            ],
            destroyer: this.destroyer,
            onClick: ()=>this.toggleColorPicker(),
            css: p.css,
            props: {
                type: 'button',
                name: p.name
            }
        });
        this.colorEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'span',
            parent: this.rootEl,
            className: $7547f9b3bd28fab0$export$35e9368ef982300f
        });
        this.update();
    }
}


const $4b84d0d85c234f83$var$presetArr = [
    // each pixel random value
    {
        type: 0,
        scaleX: 1,
        scaleY: 1,
        offsetX: 0,
        offsetY: 0,
        octaves: 1,
        samples: 1,
        peaks: 0,
        brightness: 0,
        contrast: 0,
        isReversed: true
    },
    // cloud
    {
        type: 1,
        scaleX: 166,
        scaleY: 164,
        offsetX: 105,
        offsetY: 30,
        octaves: 6,
        samples: 1,
        peaks: 0,
        brightness: 0.055,
        contrast: 0.23,
        isReversed: true
    },
    // thin lines
    {
        type: 1,
        scaleX: 235,
        scaleY: 190,
        offsetX: 3227,
        offsetY: 2156,
        octaves: 4,
        samples: 16,
        peaks: 22,
        brightness: -0.375,
        contrast: 1,
        isReversed: false
    },
    // soft large simplex, only 1 octave
    {
        type: 1,
        scaleX: 40,
        scaleY: 40,
        offsetX: 0,
        offsetY: 0,
        octaves: 1,
        samples: 1,
        peaks: 0,
        brightness: 0,
        contrast: 0,
        isReversed: false
    },
    // two value large pixels
    {
        type: 0,
        scaleX: 26,
        scaleY: 26,
        offsetX: 557,
        offsetY: 365,
        octaves: 1,
        samples: 1,
        peaks: 0,
        brightness: 0.02,
        contrast: 1,
        isReversed: true
    },
    // zebra
    {
        type: 1,
        scaleX: 1500,
        scaleY: 1500,
        offsetX: 745,
        offsetY: 2871,
        octaves: 5,
        samples: 16,
        peaks: 156.02,
        brightness: 0.03,
        contrast: 1,
        isReversed: true
    },
    // sparse dots / stars
    {
        type: 1,
        scaleX: 11,
        scaleY: 11,
        offsetX: 2940,
        offsetY: 2045,
        octaves: 1,
        samples: 16,
        peaks: 1,
        brightness: -0.045,
        contrast: 1,
        isReversed: true
    },
    // pseudo marble
    {
        type: 2,
        scaleX: 74,
        scaleY: 74,
        offsetX: 4816,
        offsetY: 1304,
        octaves: 3,
        samples: 1,
        peaks: 2.78,
        brightness: 0,
        contrast: 0,
        isReversed: false
    }
];
function $4b84d0d85c234f83$var$createNoiseSettings(input) {
    const result = (0, $be957da3610487e9$export$921068d8846a1559).copyObj($4b84d0d85c234f83$var$presetArr[input.presetIndex]);
    result.seed = input.seed;
    result.scaleX = result.scaleX * input.scale / 50;
    result.scaleY = result.scaleY * input.scale / 50;
    result.colA = input.colA;
    result.colB = input.colB;
    result.isReversed = input.isReversed ? !result.isReversed : result.isReversed;
    result.channels = input.channels;
    return result;
}
function $4b84d0d85c234f83$var$createNoiseParameters(settings) {
    return [
        settings.seed,
        settings.type,
        [
            settings.scaleX,
            settings.scaleY
        ],
        [
            settings.offsetX,
            settings.offsetY
        ],
        settings.octaves,
        settings.samples,
        settings.peaks,
        settings.brightness,
        settings.contrast,
        settings.isReversed,
        settings.colA,
        settings.colB,
        settings.channels ? settings.channels : 'rgb'
    ];
}
const $4b84d0d85c234f83$export$1dab0536099042f5 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        const thumbImgArr = [];
        const thumbSize = 32;
        {
            const fxCanvas = (0, $94f0b2b810d4d191$export$b813e062795b89b5)((0, $b225623fe00a4a24$export$8c4423af32b21158)());
            const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(thumbSize, thumbSize);
            const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
            const texture = fxCanvas.texture(canvas);
            fxCanvas.draw(texture).update(); // update fxCanvas size
            texture.destroy();
            $4b84d0d85c234f83$var$presetArr.forEach((preset)=>{
                const thumbImg = new Image();
                const settings = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(preset);
                settings.scaleX /= 10;
                settings.scaleY /= 10;
                fxCanvas.noise(...$4b84d0d85c234f83$var$createNoiseParameters(settings)).update();
                ctx.drawImage(fxCanvas.canvas, 0, 0);
                thumbImg.src = canvas.toDataURL('image/png');
                thumbImgArr.push(thumbImg);
            });
            texture.destroy();
        }
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        const noiseInput = {
            seed: Math.random() * 300,
            presetIndex: 0,
            scale: 50,
            opacity: 0.5,
            isReversed: false,
            channels: 'rgb',
            mixModeStr: 'source-over',
            colA: {
                r: 0,
                g: 0,
                b: 0
            },
            colB: {
                r: 255,
                g: 255,
                b: 255
            }
        };
        const presetOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            isFocusable: true,
            optionArr: thumbImgArr.map((img, index)=>{
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(img, {
                    margin: 1,
                    borderRadius: 3,
                    transition: 'all 0.1s ease-in-out'
                });
                return {
                    id: '' + index,
                    label: img
                };
            }),
            initId: '0',
            onChange: (id)=>{
                noiseInput.presetIndex = Number(id);
                update();
            },
            css: {
                marginBottom: 10
            }
        });
        rootEl.append(presetOptions.getElement());
        const scaleSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-noise-scale'),
            width: 300,
            height: 30,
            min: 1,
            max: 1000,
            value: noiseInput.scale,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            curve: (0, $be957da3610487e9$export$921068d8846a1559).powerSplineInput(1, 1000, 0.1),
            onChange: (value)=>{
                noiseInput.scale = value;
                update();
            }
        });
        scaleSlider.getElement().style.marginBottom = '10px';
        const opacitySlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('opacity'),
            width: 300,
            height: 30,
            min: 0.01,
            max: 1,
            value: noiseInput.opacity,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            toValue: (displayValue)=>displayValue / 100,
            toDisplayValue: (value)=>value * 100,
            onChange: (value)=>{
                noiseInput.opacity = value;
                update();
            }
        });
        opacitySlider.getElement().style.marginBottom = '10px';
        const row1El = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                alignItems: 'center',
                marginBottom: 10
            }
        });
        const row2El = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                marginBottom: 10
            }
        });
        const channelsOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            isFocusable: true,
            optionArr: [
                {
                    id: 'rgb',
                    label: 'RGB'
                },
                {
                    id: 'alpha',
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-noise-alpha')
                }
            ],
            initId: 'rgb',
            onChange: (id)=>{
                noiseInput.channels = id;
                if (id === 'rgb') row2El.style.visibility = '';
                else row2El.style.visibility = 'hidden';
                update();
            }
        });
        const reverseToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('reverse'),
            callback: (val)=>{
                noiseInput.isReversed = val;
                update();
            },
            allowTab: true,
            name: 'reverse-gradient'
        });
        const mixModes = [
            'source-over',
            undefined,
            'darken',
            'multiply',
            'color-burn',
            undefined,
            'lighten',
            'screen',
            'color-dodge',
            undefined,
            'overlay',
            'soft-light',
            'hard-light',
            undefined,
            'difference',
            'exclusion',
            undefined,
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
        const blendSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
            isFocusable: true,
            optionArr: mixModes.map((item)=>{
                return item ? [
                    item,
                    (0, $2af5569ab072fe29$export$6e1bedb2a6cdff30)(item)
                ] : undefined;
            }),
            initValue: noiseInput.mixModeStr,
            onChange: (val)=>{
                noiseInput.mixModeStr = val;
                update();
            },
            name: 'blend-mode'
        });
        blendSelect.getElement().title = (0, $fc42a07754814920$export$ce37e184d908d785)('layers-blending');
        const colorWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex'
            }
        });
        const colInputStyle = {
            width: 34,
            height: 34,
            marginRight: 5
        };
        const colAInput = new (0, $21096068e085338c$export$5a1d7ca0a925d9c2)({
            init: noiseInput.colA,
            name: 'noise-color-a',
            ariaLabel: 'Color A',
            onChange: (color)=>{
                noiseInput.colA = color;
                update();
            },
            css: colInputStyle
        });
        const colBInput = new (0, $21096068e085338c$export$5a1d7ca0a925d9c2)({
            init: noiseInput.colB,
            name: 'noise-color-b',
            ariaLabel: 'Color B',
            onChange: (color)=>{
                noiseInput.colB = color;
                update();
            },
            css: colInputStyle
        });
        colorWrapper.append(colAInput.getElement(), colBInput.getElement());
        row1El.append(channelsOptions.getElement(), (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                flexGrow: 1
            }
        }), reverseToggle.getElement());
        row2El.append(blendSelect.getElement(), (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                flexGrow: 1
            }
        }), colorWrapper);
        rootEl.append(scaleSlider.getElement(), opacitySlider.getElement(), row1El, row2El);
        const fxPreviewRenderer = new (0, $edd68b64db3c6175$export$94ec999f33a691e3)({
            original: layer.canvas,
            onUpdate: (fxCanvas, transform)=>{
                const settings = $4b84d0d85c234f83$var$createNoiseSettings(noiseInput);
                settings.scaleX *= transform.scaleX;
                settings.scaleY *= transform.scaleY;
                settings.offsetX = layer.canvas.width / 2 * transform.scaleX + transform.x;
                settings.offsetY = layer.canvas.height / 2 * transform.scaleY + transform.y;
                return fxCanvas.noise(...$4b84d0d85c234f83$var$createNoiseParameters(settings));
            },
            postMix: {
                opacity: noiseInput.opacity,
                operation: noiseInput.channels === 'alpha' ? 'destination-out' : noiseInput.mixModeStr
            },
            selection: klCanvas.getSelection(),
            isMaskingWithEmptyOriginal: true
        });
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: -20,
            marginRight: -20
        });
        rootEl.append(preview.getElement());
        function update() {
            fxPreviewRenderer.setPostMix({
                opacity: noiseInput.opacity,
                operation: noiseInput.channels === 'alpha' ? 'destination-out' : noiseInput.mixModeStr
            });
            preview.render();
        }
        result.destroy = ()=>{
            presetOptions.destroy();
            scaleSlider.destroy();
            opacitySlider.destroy();
            reverseToggle.destroy();
            channelsOptions.destroy();
            blendSelect.destroy();
            preview.destroy();
            fxPreviewRenderer.destroy();
            colAInput.destroy();
            colBInput.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return (0, $be957da3610487e9$export$921068d8846a1559).copyObj(noiseInput);
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klCanvas = params.klCanvas;
        const klHistory = params.klHistory;
        if (!context || !klCanvas) return false;
        const fxCanvas = (0, $b225623fe00a4a24$export$8c4423af32b21158)();
        if (!fxCanvas) return false; // todo more specific error?
        const input = params.input;
        const selection = klCanvas.getSelection();
        let maskTexture;
        if (selection) {
            const maskCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(context.canvas.width, context.canvas.height);
            const maskContext = (0, $be957da3610487e9$export$921068d8846a1559).ctx(maskCanvas);
            (0, $2f436639594531f3$export$f7b95c0f504bef8b)(selection, maskContext);
            maskTexture = fxCanvas.texture(maskCanvas);
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(maskCanvas);
        }
        fxCanvas.initialize(context.canvas.width, context.canvas.height);
        {
            const settings = $4b84d0d85c234f83$var$createNoiseSettings(input);
            settings.offsetX = context.canvas.width / 2;
            settings.offsetY = context.canvas.height / 2;
            fxCanvas.noise(...$4b84d0d85c234f83$var$createNoiseParameters(settings)).update();
        }
        if (maskTexture) {
            fxCanvas.multiplyAlpha().mask(maskTexture).unmultiplyAlpha();
            maskTexture.destroy();
        }
        fxCanvas.update();
        context.save();
        context.globalAlpha = input.opacity;
        if (input.channels === 'alpha') context.globalCompositeOperation = 'destination-out';
        else context.globalCompositeOperation = input.mixModeStr;
        context.drawImage(fxCanvas.canvas, 0, 0);
        context.restore();
        klHistory.push((0, $f2ffdc0d3b960f1b$export$263fa670dc037098)(klHistory.getComposed(), (0, $3aa9c52208735678$export$7b1ba44282f9a519)(context.canvas, selection ? (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(selection, 'index') : undefined)));
        return true;
    }
};














/**
 * Draws pattern onto context. Pattern generated from context.
 * Can use blending for smoother transition. Will use area outside of bounds for blending.
 *
 * @param context
 * @param settings
 */ function $821a7c040c666285$var$drawPattern(context, settings) {
    // keep bounds in center via offset
    // because blending done towards bottom right
    const blendOffsetX = settings.blend ? Math.round(settings.blend * settings.width / 2) : 0;
    const blendOffsetY = settings.blend ? Math.round(settings.blend * settings.height / 2) : 0;
    const finalPatternCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(settings.width, settings.height);
    if (settings.blend) {
        // construct pattern via linear blending
        const blendCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(settings.width * 2, settings.height * 2);
        const blendCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(blendCanvas);
        const colTransparent = '#0000';
        const colOpaque = '#000';
        // transfer source to blendCanvas
        blendCtx.drawImage(context.canvas, -settings.x + blendOffsetX, -settings.y + blendOffsetY);
        // --- 1 cross-fade vertical ------------------------
        // erase vertical gradient bottom half
        blendCtx.save();
        let blendGradient = blendCtx.createLinearGradient(0, settings.height, 0, settings.height * 2);
        blendGradient.addColorStop(0, colOpaque);
        blendGradient.addColorStop(settings.blend, colTransparent);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, blendCanvas.width, blendCanvas.height);
        blendCtx.restore();
        // erase vertical gradient top half
        blendCtx.save();
        blendGradient = blendCtx.createLinearGradient(0, 0, 0, settings.height);
        blendGradient.addColorStop(0, colTransparent);
        blendGradient.addColorStop(settings.blend, colOpaque);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, settings.width * 2, settings.height * 2);
        blendCtx.restore();
        // draw bottom half over top half
        blendCtx.save();
        // lighter needed for accurate cross-fade
        blendCtx.globalCompositeOperation = 'lighter';
        blendCtx.drawImage(blendCanvas, 0, -settings.height);
        blendCtx.restore();
        // --- 2 cross-fade horizontal ------------------------
        // erase horizontal gradient right half
        blendCtx.save();
        blendGradient = blendCtx.createLinearGradient(settings.width, 0, settings.width * 2, 0);
        blendGradient.addColorStop(0, colOpaque);
        blendGradient.addColorStop(settings.blend, colTransparent);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, blendCanvas.width, blendCanvas.height);
        blendCtx.restore();
        // erase horizontal gradient left half
        blendCtx.save();
        blendGradient = blendCtx.createLinearGradient(0, 0, settings.width, 0);
        blendGradient.addColorStop(0, colTransparent);
        blendGradient.addColorStop(settings.blend, colOpaque);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, settings.width * 2, settings.height * 2);
        blendCtx.restore();
        // draw right half over left half
        blendCtx.save();
        // lighter needed for accurate cross-fade
        blendCtx.globalCompositeOperation = 'lighter';
        blendCtx.drawImage(blendCanvas, -settings.width, 0);
        blendCtx.restore();
        // transfer to pattern canvas
        (0, $be957da3610487e9$export$921068d8846a1559).ctx(finalPatternCanvas).drawImage(blendCanvas, 0, 0);
    } else (0, $be957da3610487e9$export$921068d8846a1559).ctx(finalPatternCanvas).drawImage(context.canvas, -settings.x, -settings.y);
    context.save();
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    context.translate(settings.offsetX - blendOffsetX, settings.offsetY - blendOffsetY);
    // InvalidStateError: The object is in an invalid state.
    context.fillStyle = (0, $94f0b2b810d4d191$export$b813e062795b89b5)(context.createPattern(finalPatternCanvas, 'repeat'));
    context.fillRect(-settings.offsetX + blendOffsetX, -settings.offsetY + blendOffsetY, context.canvas.width, context.canvas.height);
    context.restore();
}
const $821a7c040c666285$export$5b48b77a483d9b33 = {
    getDialog (params) {
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        const maxSize = 1024;
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const klCanvas = params.klCanvas;
        const layer = klCanvas.getLayer(params.selectedLayerIndex);
        const context = layer.context;
        const width = layer.canvas.width;
        const height = layer.canvas.height;
        let settings = {
            x: 0,
            y: 0,
            width: width <= 250 ? Math.round(width / 4) : 200,
            height: height <= 250 ? Math.round(height / 4) : 200,
            blend: 0,
            offsetX: 0,
            offsetY: 0
        };
        let lastDrawnSettings;
        // determine bounds
        const bounds = (0, $2f436639594531f3$export$c1fcf1f93aeabfbf)(context);
        // adjust settings according to bounds
        if (// use layer bounds if:
        bounds && bounds.width <= maxSize && bounds.height <= maxSize && // don't exceed max size
        (bounds.width < width * 0.75 || bounds.height < height * 0.75 // aren't too large (heuristic)
        )) {
            settings.x = bounds.x;
            settings.y = bounds.y;
            settings.width = bounds.width;
            settings.height = bounds.height;
        } else {
            // otherwise use default size in center
            settings.x = Math.round(width / 2 - settings.width / 2);
            settings.y = Math.round(height / 2 - settings.height / 2);
        }
        // ---- controls ----
        const xInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: settings.x,
            type: 'number',
            name: 'pattern-x',
            min: 0,
            step: 1,
            max: width,
            css: {
                width: '100%'
            },
            onChange: function(v) {
                settings.x = v;
                updatePreview();
            }
        });
        const yInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: settings.y,
            type: 'number',
            name: 'pattern-y',
            min: 0,
            step: 1,
            max: height,
            css: {
                width: '100%'
            },
            onChange: function(v) {
                settings.y = v;
                updatePreview();
            }
        });
        const widthInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: settings.width,
            type: 'number',
            name: 'pattern-width',
            min: 1,
            step: 1,
            max: Math.min(maxSize, width),
            css: {
                width: '100%'
            },
            onChange: function(v) {
                settings.width = v;
                updatePreview();
            }
        });
        const heightInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: settings.height,
            type: 'number',
            name: 'pattern-height',
            min: 1,
            step: 1,
            max: Math.min(maxSize, height),
            css: {
                width: '100%'
            },
            onChange: function(v) {
                settings.height = v;
                updatePreview();
            }
        });
        const inputStyle = {
            marginLeft: 5,
            flex: 1
        };
        rootEl.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'div',
                    content: [
                        'X:',
                        xInput.getElement()
                    ],
                    css: inputStyle
                }),
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'div',
                    content: [
                        'Y:',
                        yInput.getElement()
                    ],
                    css: inputStyle
                }),
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'div',
                    content: [
                        (0, $fc42a07754814920$export$ce37e184d908d785)('width') + ':',
                        widthInput.getElement()
                    ],
                    css: inputStyle
                }),
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    tagName: 'div',
                    content: [
                        (0, $fc42a07754814920$export$ce37e184d908d785)('height') + ':',
                        heightInput.getElement()
                    ],
                    css: inputStyle
                })
            ],
            css: {
                display: 'flex',
                marginLeft: -5
            }
        }));
        const blendSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-blending'),
            width: 300,
            height: 30,
            min: 0,
            max: 1,
            value: settings.blend,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            onChange: function(val) {
                settings.blend = val;
                updatePreview();
            },
            formatFunc: (val)=>{
                return (0, $be957da3610487e9$export$921068d8846a1559).round(val, 2);
            },
            manualInputRoundDigits: 2
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(blendSlider.getElement(), {
            margin: '10px 0'
        });
        rootEl.append(blendSlider.getElement());
        // ---- preview tabs ----
        let previewMode = 1; // 0 before, 1 after
        const beforeAfterTabs = new (0, $56442e020adf49f2$export$b1241e74876d9bbe)({
            left: (0, $fc42a07754814920$export$ce37e184d908d785)('compare-before'),
            right: (0, $fc42a07754814920$export$ce37e184d908d785)('compare-after'),
            init: previewMode,
            onChange: (val)=>{
                previewMode = val;
                overlayCanvas.style.display = val === 0 ? 'block' : 'none';
                updatePreview(true);
            }
        });
        rootEl.append(beforeAfterTabs.getElement());
        // ---- previews ----
        const layers = klCanvas.getLayers();
        const selectedLayerIndex = params.selectedLayerIndex;
        const fit = (0, $be957da3610487e9$export$921068d8846a1559).fitInto(context.canvas.width, context.canvas.height, isSmall ? 280 : 490, isSmall ? 200 : 240, 1);
        const w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        const renderW = Math.min(w, context.canvas.width);
        const renderH = Math.min(h, context.canvas.height);
        // const renderFactor = renderW / context.canvas.width;
        const previewFactor = w / context.canvas.width;
        const previewWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper',
            css: {
                width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
                height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
                marginTop: 0
            }
        });
        const previewLayer = {
            image: (0, $be957da3610487e9$export$921068d8846a1559).canvas(renderW, renderH),
            isVisible: layers[selectedLayerIndex].isVisible,
            opacity: layers[selectedLayerIndex].opacity,
            mixModeStr: layers[selectedLayerIndex].mixModeStr,
            hasClipping: layers[selectedLayerIndex].hasClipping
        };
        const previewLayerArr = layers.map((item, i)=>{
            if (i === selectedLayerIndex) return previewLayer;
            else return {
                image: item.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr,
                hasClipping: item.hasClipping
            };
        });
        const klCanvasPreview = new (0, $8960a416cd34201a$export$e258ade1648009b7)({
            width: Math.round(w),
            height: Math.round(h),
            layers: previewLayerArr
        });
        const overlayCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(w, h);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(overlayCanvas, {
            position: 'absolute',
            left: 0,
            top: 0,
            mixBlendMode: 'difference',
            imageRendering: 'pixelated'
        });
        const previewInnerWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-preview-wrapper__canvas',
            css: {
                width: parseInt('' + w),
                height: parseInt('' + h)
            }
        });
        previewInnerWrapper.append(klCanvasPreview.getElement(), overlayCanvas);
        previewWrapper.append(previewInnerWrapper);
        rootEl.append(previewWrapper);
        // ---- preview input processing ----
        const inputs = {};
        function syncInputs() {
            xInput.setValue(settings.x);
            yInput.setValue(settings.y);
            widthInput.setValue(settings.width);
            heightInput.setValue(settings.height);
        }
        previewWrapper.oncontextmenu = function() {
            return false;
        };
        previewInnerWrapper.style.touchAction = 'none';
        const pointerListener = new (0, $be957da3610487e9$export$921068d8846a1559).PointerListener({
            target: previewInnerWrapper,
            onPointer: (event)=>{
                if (previewMode === 0) {
                    if (event.type === 'pointerdown') {
                        if (!inputs.state) {
                            inputs.oldSettings = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(settings);
                            const x = event.relX / previewFactor;
                            const y = event.relY / previewFactor;
                            if ((0, $be957da3610487e9$export$921068d8846a1559).isInsideRect({
                                x: x,
                                y: y
                            }, {
                                x: settings.x,
                                y: settings.y,
                                width: settings.width,
                                height: settings.height
                            })) inputs.state = 'move';
                            else inputs.state = 'select';
                            inputs.start = {
                                x: x,
                                y: y
                            };
                        }
                    } else if (event.type === 'pointermove') {
                        const x = event.relX / previewFactor;
                        const y = event.relY / previewFactor;
                        if (inputs.state === 'select') {
                            inputs.end = {
                                x: x,
                                y: y
                            };
                            const x1 = Math.max(0, Math.min(inputs.start.x, inputs.end.x));
                            const y1 = Math.max(0, Math.min(inputs.start.y, inputs.end.y));
                            const x2 = Math.min(width, Math.max(inputs.start.x, inputs.end.x));
                            const y2 = Math.min(height, Math.max(inputs.start.y, inputs.end.y));
                            settings.x = Math.floor(x1);
                            settings.y = Math.floor(y1);
                            settings.width = Math.min(maxSize, Math.ceil(x2 - settings.x));
                            settings.height = Math.min(maxSize, Math.ceil(y2 - settings.y));
                            if (event.shiftKey) {
                                settings.width = Math.min(settings.width, settings.height);
                                settings.height = Math.min(settings.width, settings.height);
                            }
                            if (settings.width === 0 || settings.height === 0) settings = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(inputs.oldSettings);
                            syncInputs();
                            updatePreview();
                        } else if (inputs.state === 'move') {
                            const dX = Math.round(x - inputs.start.x);
                            const dY = Math.round(y - inputs.start.y);
                            settings.x = (0, $be957da3610487e9$export$921068d8846a1559).clamp(inputs.oldSettings.x + dX, 0, width - settings.width);
                            settings.y = (0, $be957da3610487e9$export$921068d8846a1559).clamp(inputs.oldSettings.y + dY, 0, height - settings.height);
                            syncInputs();
                            updatePreview();
                        }
                    } else if (event.type === 'pointerup') {
                        if (inputs.state) inputs.state = null;
                    }
                } else {
                    if (event.type === 'pointerdown') {
                        if (!inputs.state) {
                            inputs.state = 'move';
                            inputs.oldSettings = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(settings);
                            inputs.start = {
                                x: event.relX / previewFactor,
                                y: event.relY / previewFactor
                            };
                            inputs.end = null;
                        }
                    } else if (event.type === 'pointermove') {
                        if (inputs.state) {
                            inputs.end = {
                                x: event.relX / previewFactor,
                                y: event.relY / previewFactor
                            };
                            settings.offsetX = Math.round(inputs.end.x - inputs.start.x) + inputs.oldSettings.offsetX;
                            settings.offsetY = Math.round(inputs.end.y - inputs.start.y) + inputs.oldSettings.offsetY;
                            updatePreview();
                        }
                    } else if (event.type === 'pointerup') {
                        if (inputs.state) {
                            if (!inputs.end) {
                                settings.offsetX = 0;
                                settings.offsetY = 0;
                                updatePreview();
                            }
                            inputs.state = null;
                        }
                    }
                }
            }
        });
        // ---------- rendering ---------------------
        const fullSizeCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(width, height);
        const fullSizeCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(fullSizeCanvas);
        function sharpStrokeRect(context, x, y, width, height) {
            const drawX = Math.round(x + 0.5) - 0.5;
            const drawY = Math.round(y + 0.5) - 0.5;
            const drawWidth = Math.round(x + width - drawX);
            const drawHeight = Math.round(y + height - drawY);
            context.strokeRect(drawX, drawY, drawWidth, drawHeight);
        }
        function updatePreview(doForce) {
            if (!doForce && lastDrawnSettings && JSON.stringify(lastDrawnSettings) === JSON.stringify(settings)) return;
            if (previewMode === 0) {
                // before
                fullSizeCtx.clearRect(0, 0, width, height);
                fullSizeCtx.drawImage(context.canvas, 0, 0);
                const previewCanvas = previewLayer.image;
                const previewCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(previewCanvas);
                previewCtx.save();
                previewCtx.clearRect(0, 0, renderW, renderH);
                previewCtx.drawImage(fullSizeCanvas, 0, 0, renderW, renderH);
                previewCtx.restore();
                const pW = settings.width * previewFactor;
                const pH = settings.height * previewFactor;
                const overlayCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(overlayCanvas);
                overlayCtx.save();
                overlayCtx.clearRect(0, 0, w, h);
                overlayCtx.strokeStyle = '#fff';
                sharpStrokeRect(overlayCtx, settings.x * previewFactor, settings.y * previewFactor, pW, pH);
                if (settings.blend > 0.05) {
                    overlayCtx.strokeStyle = '#f0f';
                    sharpStrokeRect(overlayCtx, settings.x * previewFactor - pW / 2 * settings.blend, settings.y * previewFactor - pH / 2 * settings.blend, pW * (1 + settings.blend), pH * (1 + settings.blend));
                }
                overlayCtx.restore();
            } else {
                // after
                fullSizeCtx.clearRect(0, 0, width, height);
                fullSizeCtx.drawImage(context.canvas, 0, 0);
                $821a7c040c666285$var$drawPattern(fullSizeCtx, settings);
                const previewCanvas = previewLayer.image;
                const previewCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(previewCanvas);
                previewCtx.clearRect(0, 0, renderW, renderH);
                previewCtx.drawImage(fullSizeCanvas, 0, 0, renderW, renderH);
            }
            klCanvasPreview.render();
            lastDrawnSettings = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(settings);
        }
        updatePreview();
        // ----- result -------------------
        const destroy = ()=>{
            blendSlider.destroy();
            pointerListener.destroy();
            klCanvasPreview.destroy();
            xInput.destroy();
            yInput.destroy();
            widthInput.destroy();
            heightInput.destroy();
        };
        const result = {
            element: rootEl,
            destroy: destroy,
            getInput: ()=>{
                destroy();
                return (0, $be957da3610487e9$export$921068d8846a1559).copyObj(settings);
            }
        };
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$3a4a74a7d8c44e62).width;
        return result;
    },
    apply (params) {
        const klCanvas = params.klCanvas;
        const ctx = params.layer.context;
        const klHistory = params.klHistory;
        if (!klCanvas) return false;
        $821a7c040c666285$var$drawPattern(ctx, params.input);
        {
            const layerMap = Object.fromEntries(params.klCanvas.getLayers().map((layerItem)=>{
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $3aa9c52208735678$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};















const $d26e1cdf748581ad$export$77c344cc65ad0ed2 = {
    getDialog (params) {
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        let isSynced = true;
        const settings = {
            stepSize: 1,
            distortType: 0,
            scale: {
                x: 100,
                y: 100
            },
            strength: {
                x: 20,
                y: 20
            },
            phase: {
                x: 0,
                y: 0
            },
            offset: {
                x: 0,
                y: 0
            }
        };
        // let lastDrawnSettings = null;
        // ---- thumb -------
        const thumbImgArr = [];
        const thumbSize = 32;
        {
            const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(thumbSize, thumbSize);
            const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
            ctx.beginPath();
            ctx.arc(thumbSize / 2, thumbSize / 2, thumbSize / 2.5, 0, Math.PI * 2);
            ctx.fill();
            let gradient = ctx.createLinearGradient(0, 0, thumbSize, thumbSize);
            gradient.addColorStop(0, '#00f');
            gradient.addColorStop(0.5, '#f00');
            gradient.addColorStop(1, '#fff');
            ctx.fillStyle = gradient;
            ctx.globalCompositeOperation = 'source-atop';
            ctx.fillRect(0, 0, thumbSize, thumbSize);
            gradient = ctx.createLinearGradient(thumbSize, 0, 0, thumbSize);
            gradient.addColorStop(0, '#000');
            gradient.addColorStop(1, '#000');
            ctx.fillStyle = gradient;
            ctx.globalCompositeOperation = 'destination-atop';
            ctx.fillRect(0, 0, thumbSize, thumbSize);
            const fxCanvas = (0, $94f0b2b810d4d191$export$b813e062795b89b5)((0, $b225623fe00a4a24$export$8c4423af32b21158)());
            const texture = fxCanvas.texture(canvas);
            fxCanvas.draw(texture).update(); // update fxCanvas size
            const scaleFactor = 20;
            [
                0,
                1,
                2
            ].forEach((item)=>{
                const thumbImg = new Image();
                const settingsCopy = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(settings);
                settingsCopy.distortType = item;
                settingsCopy.scale.x /= scaleFactor;
                settingsCopy.scale.y /= scaleFactor;
                settingsCopy.strength.x /= scaleFactor;
                settingsCopy.strength.y /= scaleFactor;
                fxCanvas.draw(texture).multiplyAlpha().distort(settingsCopy).unmultiplyAlpha().update();
                ctx.clearRect(0, 0, thumbSize, thumbSize);
                ctx.drawImage(fxCanvas.canvas, 0, 0);
                thumbImg.src = canvas.toDataURL('image/png');
                thumbImgArr.push(thumbImg);
            });
            texture.destroy();
        }
        // ---- controls ----
        const topRowEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        const typeOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            isFocusable: true,
            optionArr: thumbImgArr.map((img, index)=>{
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(img, {
                    margin: 1,
                    borderRadius: 3,
                    transition: 'all 0.1s ease-in-out'
                });
                return {
                    id: '' + index,
                    label: img
                };
            }),
            initId: '0',
            onChange: (id)=>{
                settings.distortType = Number(id);
                preview.render();
            }
        });
        function sync(from) {
            if (from === 'x') {
                settings.scale.y = settings.scale.x;
                settings.strength.y = settings.strength.x;
                settings.phase.y = settings.phase.x;
                sliderArr[3].setValue(settings.scale.y);
                sliderArr[4].setValue(settings.strength.y);
                sliderArr[5].setValue(settings.phase.y);
            } else {
                settings.scale.x = settings.scale.y;
                settings.strength.x = settings.strength.y;
                settings.phase.x = settings.phase.y;
                sliderArr[0].setValue(settings.scale.x);
                sliderArr[1].setValue(settings.strength.x);
                sliderArr[2].setValue(settings.phase.x);
            }
            preview.render();
        }
        const syncToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-distort-sync-xy'),
            callback: (val)=>{
                isSynced = val;
                if (isSynced) sync('x');
            },
            name: 'sync-xy'
        });
        topRowEl.append(typeOptions.getElement(), (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                flexGrow: 1
            }
        }), syncToggle.getElement());
        const xyRowEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                flexWrap: 'wrap'
            }
        });
        const leftCol = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: xyRowEl,
            css: {
                marginRight: 10
            }
        });
        const rightCol = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: xyRowEl
        });
        const sliderWidth = isSmall ? 300 : 245;
        const sliderArr = [];
        [
            'x',
            'y'
        ].forEach((item, index)=>{
            const targetEl = index === 0 ? leftCol : rightCol;
            const scaleSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-noise-scale') + ' ' + item.toUpperCase(),
                width: sliderWidth,
                height: 30,
                min: 1,
                max: 1000,
                curve: 'quadratic',
                value: settings.scale[item],
                eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
                onChange: (val)=>{
                    settings.scale[item] = val;
                    if (isSynced) sync(item);
                    else preview.render();
                }
            });
            scaleSlider.getElement().style.marginTop = '20px';
            targetEl.append(scaleSlider.getElement());
            const strengthSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-unsharp-mask-strength') + ' ' + item.toUpperCase(),
                width: sliderWidth,
                height: 30,
                min: 0,
                max: 200,
                curve: 'quadratic',
                value: settings.strength[item],
                eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
                onChange: (val)=>{
                    settings.strength[item] = val;
                    if (isSynced) sync(item);
                    else preview.render();
                }
            });
            strengthSlider.getElement().style.marginTop = '10px';
            targetEl.append(strengthSlider.getElement());
            const phaseSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
                label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-distort-phase') + ' ' + item.toUpperCase(),
                width: sliderWidth,
                height: 30,
                min: 0,
                max: 1,
                value: settings.phase[item],
                manualInputRoundDigits: 2,
                eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
                formatFunc: (val)=>(0, $be957da3610487e9$export$921068d8846a1559).round(val, 2),
                onChange: (val)=>{
                    settings.phase[item] = val;
                    if (isSynced) sync(item);
                    else preview.render();
                }
            });
            phaseSlider.getElement().style.marginTop = '10px';
            targetEl.append(phaseSlider.getElement());
            sliderArr.push(scaleSlider);
            sliderArr.push(strengthSlider);
            sliderArr.push(phaseSlider);
        });
        const stepSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-distort-stepsize'),
            width: 300,
            height: 30,
            min: 1,
            max: 300,
            curve: 'quadratic',
            value: settings.stepSize,
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            onChange: (val)=>{
                settings.stepSize = Math.round(val);
                preview.render();
            }
        });
        stepSlider.getElement().style.marginTop = '20px';
        stepSlider.getElement().style.marginBottom = '10px';
        rootEl.append(stepSlider.getElement());
        // ---- preview ----
        const layers = klCanvas.getLayers();
        const fxPreviewRenderer = new (0, $edd68b64db3c6175$export$94ec999f33a691e3)({
            original: layer.canvas,
            onUpdate: (fxCanvas, transform)=>{
                const scaledSettings = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(settings);
                scaledSettings.stepSize *= transform.scaleX;
                scaledSettings.strength.x *= transform.scaleX;
                scaledSettings.strength.y *= transform.scaleY;
                if (scaledSettings.distortType !== 2) {
                    scaledSettings.scale.x *= transform.scaleX;
                    scaledSettings.scale.y *= transform.scaleY;
                }
                scaledSettings.offset.x = -transform.x;
                scaledSettings.offset.y = -transform.y;
                return fxCanvas.multiplyAlpha().distort(scaledSettings).unmultiplyAlpha();
            },
            selection: klCanvas.getSelection()
        });
        const previewLayerArr = layers.map((item, i)=>{
            return {
                image: i === selectedLayerIndex ? fxPreviewRenderer.render : item.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr,
                hasClipping: item.hasClipping
            };
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: -20,
            marginRight: -20
        });
        rootEl.append(preview.getElement());
        const destroy = ()=>{
            typeOptions.destroy();
            sliderArr.forEach((item)=>item.destroy());
            stepSlider.destroy();
            syncToggle.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        // ----- result -------------------
        const result = {
            element: rootEl,
            destroy: destroy,
            getInput: ()=>{
                destroy();
                return (0, $be957da3610487e9$export$921068d8846a1559).copyObj(settings);
            }
        };
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$3a4a74a7d8c44e62).width;
        return result;
    },
    apply (params) {
        const klCanvas = params.klCanvas;
        const context = params.layer.context;
        const klHistory = params.klHistory;
        if (!klCanvas) return false;
        return (0, $6b8a42764b141679$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), (fxCanvas)=>{
            fxCanvas.multiplyAlpha().distort(params.input).unmultiplyAlpha();
        }, klHistory);
    }
};








function $3bdd7f82e6bcbfb3$export$8f57d6bdbceb36d0(ctx, x, y, lines, thickness, color, opacity) {
    ctx.save();
    const degIncrement = 180 / lines;
    for(let deg = 0; deg < 180; deg += degIncrement){
        const p2 = (0, $be957da3610487e9$export$921068d8846a1559).rotateAround({
            x: x,
            y: y
        }, {
            x: x + 9999,
            y: y
        }, deg);
        (0, $03d72c2b76715beb$export$71b514a25c47df50)(ctx, {
            type: 'line',
            x1: x,
            y1: y,
            x2: p2.x,
            y2: p2.y,
            //angleRad: 0,
            isOutwards: true,
            opacity: opacity,
            //isEraser: false,
            strokeRgb: color,
            lineWidth: thickness
        });
    }
    ctx.restore();
}











const $b977f64b145e5666$export$a77e8ecd2a7fa9a5 = {
    getDialog (params) {
        const klCanvas = params.klCanvas;
        const selectedLayerIndex = params.selectedLayerIndex;
        const layer = klCanvas.getLayer(selectedLayerIndex);
        const layers = klCanvas.getLayers();
        const previewCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(layer.canvas.width, layer.canvas.height);
        const previewCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(previewCanvas);
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const result = {
            element: rootEl
        };
        const isSmall = (0, $9a26bc0f26acb8b1$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall);
        const settingsObj = {
            x: layer.canvas.width / 2,
            y: layer.canvas.height / 2,
            lines: 8,
            thickness: 2,
            color: {
                r: 0,
                g: 0,
                b: 0
            },
            opacity: 1
        };
        const linesSlider = new (0, $886527ea181efb50$export$a1855b925e534de7)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-vanish-point-lines'),
            width: 300,
            height: 30,
            min: 2,
            max: 40,
            value: settingsObj.lines,
            curve: 'quadratic',
            eventResMs: (0, $e4c19eeb23d51669$export$f02de051ab70b20e),
            onChange: function(val) {
                settingsObj.lines = Math.round(val);
                update();
            }
        });
        linesSlider.getElement().style.marginBottom = '10px';
        rootEl.append(linesSlider.getElement());
        const line1 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        const line2 = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: 10,
                marginBottom: 10
            }
        });
        const xInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: settingsObj.x,
            type: 'number',
            name: 'vanish-point-x',
            css: {
                width: 75,
                marginRight: 20
            },
            onChange: function(v) {
                settingsObj.x = v;
                dragInput.setValue({
                    x: settingsObj.x,
                    y: settingsObj.y
                });
                update();
            }
        });
        const yInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: settingsObj.y,
            type: 'number',
            name: 'vanish-point-y',
            css: {
                width: 75,
                marginRight: 20
            },
            onChange: function(v) {
                settingsObj.y = v;
                dragInput.setValue({
                    x: settingsObj.x,
                    y: settingsObj.y
                });
                update();
            }
        });
        const thicknessInput = new (0, $781553b3646364b0$export$f5b8910cec6cf069)({
            init: 2,
            type: 'number',
            name: 'vanish-point-thickness',
            min: 1,
            step: 1,
            css: {
                width: 75,
                marginRight: 20
            },
            onChange: function(v) {
                settingsObj.thickness = v;
                update();
            }
        });
        let selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        const colorOptionsArr = [
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }
        ];
        colorOptionsArr.push({
            r: params.currentColorRgb.r,
            g: params.currentColorRgb.g,
            b: params.currentColorRgb.b,
            a: 1
        });
        colorOptionsArr.push({
            r: params.secondaryColorRgb.r,
            g: params.secondaryColorRgb.g,
            b: params.secondaryColorRgb.b,
            a: 1
        });
        settingsObj.color = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(selectedRgbaObj);
        const colorOptions = new (0, $115e148fb390275d$export$24ba9b81662d4366)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-stroke'),
            colorArr: colorOptionsArr,
            onChange: function(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                settingsObj.color = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(selectedRgbaObj);
                update();
            }
        });
        const labelStyle = {
            display: 'inline-block',
            marginRight: 5
        };
        line1.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: 'X:',
            css: labelStyle
        }), xInput.getElement(), (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: 'Y:',
            css: labelStyle
        }), yInput.getElement());
        line2.append((0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-line-width') + ':',
            css: labelStyle
        }), thicknessInput.getElement(), (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                flexGrow: 1
            }
        }), colorOptions.getElement());
        // ---- preview input processing ----
        function syncInputs() {
            xInput.setValue(settingsObj.x);
            yInput.setValue(settingsObj.y);
        }
        function update() {
            const ctx = previewCtx;
            const w = previewCanvas.width;
            const h = previewCanvas.height;
            ctx.save();
            ctx.clearRect(0, 0, w, h);
            ctx.drawImage(layer.canvas, 0, 0, w, h);
            (0, $3bdd7f82e6bcbfb3$export$8f57d6bdbceb36d0)(ctx, settingsObj.x, settingsObj.y, settingsObj.lines, Math.max(settingsObj.thickness, 1), settingsObj.color, settingsObj.opacity);
            ctx.restore();
            preview.render();
        }
        const onRender = ()=>{
            dragInput.setTransform(preview.getTransform());
            return previewCanvas;
        };
        const previewLayerArr = [];
        for(let i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? onRender : layers[i].canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: layers[i].hasClipping
        });
        const preview = new (0, $1e2e9186a42c4ae7$export$133773870222880f)({
            width: (0, $0cebc8ae8ef681f1$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $0cebc8ae8ef681f1$export$94cffdbcf128864a)(isSmall),
            project: {
                width: layer.canvas.width,
                height: layer.canvas.height,
                layers: previewLayerArr
            }
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(preview.getElement(), {
            marginLeft: -20,
            marginRight: -20,
            overflow: 'hidden'
        });
        const dragInput = new (0, $d11119184bb857f3$export$87247fc399965417)({
            value: {
                x: settingsObj.x,
                y: settingsObj.y
            },
            onChange: (val)=>{
                settingsObj.x = Math.round(val.x);
                settingsObj.y = Math.round(val.y);
                syncInputs();
                update();
            }
        });
        update();
        preview.getElement().append(dragInput.getElement());
        rootEl.append(preview.getElement());
        result.destroy = ()=>{
            linesSlider.destroy();
            colorOptions.destroy();
            preview.destroy();
            xInput.destroy();
            yInput.destroy();
            thicknessInput.destroy();
            dragInput.destroy();
            (0, $2f436639594531f3$export$2384aff49c9b73c2)(previewCanvas);
        };
        result.getInput = function() {
            result.destroy();
            return (0, $be957da3610487e9$export$921068d8846a1559).copyObj(settingsObj);
        };
        return result;
    },
    apply (params) {
        const context = params.layer.context;
        const klCanvas = params.klCanvas;
        const klHistory = params.klHistory;
        if (!context || !klCanvas) return false;
        (0, $3bdd7f82e6bcbfb3$export$8f57d6bdbceb36d0)(context, params.input.x, params.input.y, params.input.lines, params.input.thickness, params.input.color, params.input.opacity);
        {
            const layerMap = Object.fromEntries(params.klCanvas.getLayers().map((layerItem)=>{
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $3aa9c52208735678$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};


function $5e9f44c5ddf923e3$var$importFilter(libObj, moduleObj) {
    if (moduleObj.getDialog) libObj.getDialog = moduleObj.getDialog;
    libObj.apply = moduleObj.apply;
}
function $5e9f44c5ddf923e3$export$4283b00eae4a6956() {
    if ((0, $b20d6b230a6e6f94$export$24724bc1f91cba3).isLoaded) return;
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).brightnessContrast, (0, $723c041f93902536$export$af433fb90aa90a38));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).cropExtend, (0, $45089719b604186a$export$e5937df51b9e1d86));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).curves, (0, $f60dcaccc6e56a8f$export$309483fcb6d5c7ca));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).flip, (0, $6e94dbe15dd1f87a$export$9b1b7b3985b9625a));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).hueSaturation, (0, $0033f73fa7e53276$export$2aa46bd5587f0eb));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).invert, (0, $3d06d8c74be27f29$export$b7ebcfbdc840ef76));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).perspective, (0, $1731ad5d3c728068$export$a76d798fa7d85e4e));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).resize, (0, $18f19ceb2efa24ec$export$5705240d31427a82));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).rotate, (0, $7303a640f83f6ee9$export$ac7e9efc751d5791));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).tiltShift, (0, $68ca153b95a94dbd$export$1b8796b18b7c19ed));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).transform, (0, $19404419558f247b$export$dc15474d94cdc2b3));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).blur, (0, $974b8fa45a89d6ae$export$55e7eb2ebd0db869));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).unsharpMask, (0, $d21b2890cdc4e8be$export$62ac74a5ea43bd5c));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).toAlpha, (0, $411358ccecdab2ba$export$6158ed2b22ebf4d9));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).grid, (0, $91098c12a55394b9$export$50020de79e1bc23));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).noise, (0, $4b84d0d85c234f83$export$1dab0536099042f5));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).pattern, (0, $821a7c040c666285$export$5b48b77a483d9b33));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).distort, (0, $d26e1cdf748581ad$export$77c344cc65ad0ed2));
    $5e9f44c5ddf923e3$var$importFilter((0, $b20d6b230a6e6f94$export$bac24f240bb7727d).vanishPoint, (0, $b977f64b145e5666$export$a77e8ecd2a7fa9a5));
    (0, $b20d6b230a6e6f94$export$24724bc1f91cba3).isLoaded = true;
}








class $ba111226d39f0ec4$export$c57e2ed65bcf4d6a {
    chainIn(event) {
        event = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(event);
        clearTimeout(this.timeout);
        clearInterval(this.interval);
        if (event.type === 'down') this.lastMixedInput = {
            x: event.x,
            y: event.y,
            pressure: event.pressure
        };
        if (event.type === 'move') {
            const inputX = event.x;
            const inputY = event.y;
            const inputPressure = event.pressure;
            event.x = (0, $be957da3610487e9$export$921068d8846a1559).mix(event.x, this.lastMixedInput.x, this.smoothing);
            event.y = (0, $be957da3610487e9$export$921068d8846a1559).mix(event.y, this.lastMixedInput.y, this.smoothing);
            event.pressure = (0, $be957da3610487e9$export$921068d8846a1559).mix(event.pressure, this.lastMixedInput.pressure, this.smoothing);
            this.lastMixedInput = {
                x: event.x,
                y: event.y,
                pressure: event.pressure
            };
            if (this.smoothing > 0) this.timeout = setTimeout(()=>{
                this.interval = setInterval(()=>{
                    event = JSON.parse(JSON.stringify(event));
                    event.x = (0, $be957da3610487e9$export$921068d8846a1559).mix(inputX, this.lastMixedInput.x, this.smoothing);
                    event.y = (0, $be957da3610487e9$export$921068d8846a1559).mix(inputY, this.lastMixedInput.y, this.smoothing);
                    event.pressure = (0, $be957da3610487e9$export$921068d8846a1559).mix(inputPressure, this.lastMixedInput.pressure, this.smoothing);
                    this.lastMixedInput = {
                        x: event.x,
                        y: event.y,
                        pressure: event.pressure
                    };
                    this.chainOut?.(event);
                }, 35);
            }, 80);
        }
        return event;
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    setSmoothing(s) {
        this.smoothing = (0, $be957da3610487e9$export$921068d8846a1559).clamp(s, 0, 1);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.smoothing = (0, $be957da3610487e9$export$921068d8846a1559).clamp(p.smoothing, 0, 1);
    }
}


class $675f74f720367ea9$export$91dcf4209534d21f {
    // ----------------------------------- public -----------------------------------
    chainIn(event) {
        if (event.type === 'down') {
            if (this.isDrawing) //console.log('line sanitizer - down, but already drawing');
            this.chainOut && this.chainOut({
                type: 'up',
                scale: event.scale,
                shiftIsPressed: event.shiftIsPressed,
                isCoalesced: false
            });
            else this.isDrawing = true;
        }
        if (!this.isDrawing && (event.type === 'move' || event.type === 'up')) //console.log('line sanitizer - ' + event.type + ' but not drawing');
        return null;
        if (event.type === 'up' && this.isDrawing) this.isDrawing = false;
        return event;
    }
    setChainOut(func) {
        this.chainOut = func;
    }
    getIsDrawing() {
        return this.isDrawing;
    }
    constructor(){
        this.isDrawing = false;
    }
}


/**
 * from stabilizer dropdown value to line-smoothing value
 */ function $603f5a48e1f92529$export$bcd109042a2e4bb5(s) {
    if (s === 1) return 0.5;
    if (s === 2) return 0.84;
    if (s === 3) return 0.965;
    if (s === 4) return 0.9825;
    if (s === 5) return 0.99125;
    return s;
}









// image - png, jpg, webp, whatever the browser natively supports
function $8bcac57fac5624c8$var$isBufferMatch(buffer, bytes) {
    return bytes.every((byte, index)=>{
        if (byte === undefined) return true;
        return buffer[index] === byte;
    });
}
async function $8bcac57fac5624c8$export$16b40d0fc7becfe6(file) {
    // photoshop is sub type of image.* - so check first
    const nameSplit = file.name.split('.');
    const extension = nameSplit.at(-1).toLowerCase();
    const mimeType = file.type.toLowerCase();
    if (mimeType.match('image/vnd.adobe.photoshop') || extension === 'psd') return 'psd';
    if (mimeType.startsWith('image/')) return 'image';
    // check for headers
    try {
        const arr = await new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result === null) {
                    reject();
                    return;
                }
                // we did read as array buffer
                resolve(new Uint8Array(reader.result));
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(file.slice(0, 12));
        });
        // PSD: '8BPS'
        if ($8bcac57fac5624c8$var$isBufferMatch(arr, [
            56,
            66,
            80,
            83
        ])) return 'psd';
        // PNG: 89 50 4E 47 0D 0A 1A 0A
        if ($8bcac57fac5624c8$var$isBufferMatch(arr, [
            0x89,
            0x50,
            0x4e,
            0x47,
            0x0d,
            0x0a,
            0x1a,
            0x0a
        ])) return 'image';
        // JPEG: 0xFF 0xD8
        if ($8bcac57fac5624c8$var$isBufferMatch(arr, [
            0xff,
            0xd8
        ])) return 'image';
        // WebP: 'RIFF....WEBP'
        if ($8bcac57fac5624c8$var$isBufferMatch(arr, [
            0x52,
            0x49,
            0x46,
            0x46,
            undefined,
            undefined,
            undefined,
            undefined,
            0x57,
            0x45,
            0x42,
            0x50
        ])) return 'image';
    } catch (e) {
    // ...
    }
    return undefined;
}



class $2f6676beceb707bc$export$1ec1306c0c05d48d {
    importFinishedLoading(importedImage, filename, optionStr) {
        if (!importedImage || isNaN(importedImage.width) || isNaN(importedImage.height) || importedImage.width <= 0 || importedImage.height <= 0) {
            (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('import-broken-file'));
            return;
        }
        const getResizedDimensions = (width, height)=>{
            let w = parseInt('' + width);
            let h = parseInt('' + height);
            if (w > this.klMaxCanvasSize) {
                h = this.klMaxCanvasSize / w * h;
                w = this.klMaxCanvasSize;
            }
            if (h > this.klMaxCanvasSize) {
                w = this.klMaxCanvasSize / h * w;
                h = this.klMaxCanvasSize;
            }
            w = parseInt('' + w);
            h = parseInt('' + h);
            return {
                width: w,
                height: h
            };
        };
        const importAsImage = (canvas)=>{
            this.applyUncommitted();
            const resizedDimensions = getResizedDimensions(canvas.width, canvas.height);
            //resize first
            const tempCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(canvas.width, canvas.height);
            const tempCanvasCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(tempCanvas);
            tempCanvasCtx.drawImage(canvas, 0, 0);
            (0, $be957da3610487e9$export$921068d8846a1559).resizeCanvas(tempCanvas, resizedDimensions.width, resizedDimensions.height);
            this.klCanvas.reset({
                width: resizedDimensions.width,
                height: resizedDimensions.height,
                image: tempCanvas,
                layerName: filename
            });
            this.layersUi.update(0);
            this.setCurrentLayer(0);
            this.onImportConfirm();
        };
        /**
         * convertedPsdObj has no layers if flattened
         */ const importAsImagePsd = (convertedPsdObj, cropObj)=>{
            this.applyUncommitted();
            // crop
            const crop = (targetCanvas, cropCanvas, cropObj)=>{
                const cropCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(cropCanvas);
                cropCtx.clearRect(0, 0, cropCanvas.width, cropCanvas.height);
                cropCtx.drawImage(targetCanvas, -cropObj.x, -cropObj.y);
                (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(targetCanvas, cropObj.width, cropObj.height, {
                    ensureCleared: true
                });
                (0, $be957da3610487e9$export$921068d8846a1559).ctx(targetCanvas).drawImage(cropCanvas, 0, 0);
            };
            if (cropObj && (cropObj.width !== convertedPsdObj.width || cropObj.height !== convertedPsdObj.height)) {
                const cropCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(cropObj.width, cropObj.height);
                convertedPsdObj.width = cropObj.width;
                convertedPsdObj.height = cropObj.height;
                if (!convertedPsdObj.layers) crop(convertedPsdObj.canvas, cropCanvas, cropObj);
                if (convertedPsdObj.layers) for(let i = 0; i < convertedPsdObj.layers.length; i++){
                    const item = convertedPsdObj.layers[i];
                    crop(item.image, cropCanvas, cropObj);
                }
            }
            // resize
            const resizedDimensions = getResizedDimensions(convertedPsdObj.width, convertedPsdObj.height);
            convertedPsdObj.width = resizedDimensions.width;
            convertedPsdObj.height = resizedDimensions.height;
            if (!convertedPsdObj.layers) (0, $be957da3610487e9$export$921068d8846a1559).resizeCanvas(convertedPsdObj.canvas, convertedPsdObj.width, convertedPsdObj.height);
            if (convertedPsdObj.layers) for(let i = 0; i < convertedPsdObj.layers.length; i++){
                const item = convertedPsdObj.layers[i];
                (0, $be957da3610487e9$export$921068d8846a1559).resizeCanvas(item.image, convertedPsdObj.width, convertedPsdObj.height);
            }
            let layerIndex;
            if (convertedPsdObj.layers) layerIndex = this.klCanvas.reset({
                width: convertedPsdObj.width,
                height: convertedPsdObj.height,
                layers: convertedPsdObj.layers.map((layer)=>{
                    return {
                        id: (0, $f13a819f841fbdb5$export$b2ce7a8a096070e2)(),
                        name: layer.name,
                        isVisible: layer.isVisible,
                        opacity: layer.opacity,
                        mixModeStr: layer.mixModeStr,
                        hasClipping: layer.hasClipping,
                        image: layer.image
                    };
                })
            });
            else layerIndex = this.klCanvas.reset({
                width: convertedPsdObj.width,
                height: convertedPsdObj.height,
                image: convertedPsdObj.canvas
            });
            this.layersUi.update(layerIndex);
            this.setCurrentLayer(layerIndex);
            this.onImportConfirm();
        };
        const importAsLayer = (canvas)=>{
            this.applyUncommitted();
            (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).showImportAsLayerDialog({
                target: this.klRootEl,
                klCanvas: this.klCanvas,
                importImage: canvas,
                callback: (transformObj, isPixelated)=>{
                    if (!transformObj) return;
                    const operation = (ctx)=>{
                        (0, $be957da3610487e9$export$921068d8846a1559).drawTransformedImageWithBounds(ctx, canvas, transformObj, undefined, isPixelated);
                    };
                    if (!this.klCanvas.addLayer(undefined, {
                        name: filename,
                        mixModeStr: 'source-over',
                        isVisible: true,
                        opacity: 1,
                        image: operation
                    })) this.klCanvas.drawOperation(this.klCanvas.getLayers().length - 1, operation);
                    const layers = this.klCanvas.getLayers();
                    const activeLayerIndex = layers.length - 1;
                    this.setCurrentLayer(activeLayerIndex);
                    this.layersUi.update(activeLayerIndex);
                }
            });
        };
        if (optionStr === 'default' || !optionStr) (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).showImportImageDialog({
            image: importedImage,
            target: this.klRootEl,
            maxSize: this.klMaxCanvasSize,
            callback: (res)=>{
                if (res.type === 'as-image') importAsImage(res.image);
                else if (res.type === 'as-image-psd') importAsImagePsd(res.image, res.cropObj);
                else if (res.type === 'as-layer') importAsLayer(res.image);
                else res.type;
            }
        });
        if (optionStr === 'layer') importAsLayer(importedImage.canvas);
        if (optionStr === 'image') {
            if (importedImage.type === 'psd') importAsImagePsd(importedImage);
            else importAsImage(importedImage.canvas);
        }
    }
    // ---- interface ----
    async readClipboard() {
        try {
            // May freeze the app until it read the clipboard
            // But if you show a loading indicator on this line, it will show up too early.
            const clipboardItems = await navigator.clipboard.read();
            // On this line it's already done freezing.
            let hasImage = false;
            for (const item of clipboardItems){
                for (const type of item.types)if (type.startsWith('image')) {
                    hasImage = true;
                    const blob = await item.getType(type);
                    const img = await (0, $2e475852c551fcab$export$99cbfa07c2ec1e27)(blob);
                    this.importFinishedLoading({
                        type: 'image',
                        width: img.width,
                        height: img.height,
                        canvas: img
                    }, undefined, 'default');
                    return;
                }
            }
            if (!hasImage) (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('clipboard-no-image'));
        } catch (error) {
            (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('clipboard-read-fail'));
        }
    }
    onPaste(e) {
        if ((0, $25422d204ef184a3$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0 || (0, $be957da3610487e9$export$921068d8846a1559).isInputFocused(true)) return;
        const retrieveImageFromClipboardAsBlob = (items, callback)=>{
            if (!items) return;
            for(let i = 0; i < items.length; i++){
                if (!items[i].type.includes('image')) continue;
                const file = items[i].getAsFile();
                file && callback(file);
            }
        };
        e.stopPropagation();
        e.preventDefault();
        if (!e.clipboardData) return;
        if (e.clipboardData.files[0]) retrieveImageFromClipboardAsBlob(e.clipboardData.items, (imageBlob)=>{
            (0, $2e475852c551fcab$export$99cbfa07c2ec1e27)(imageBlob).then((img)=>{
                this.importFinishedLoading({
                    type: 'image',
                    width: img.width,
                    height: img.height,
                    canvas: img
                }, undefined, 'default');
            }).catch(()=>(0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('clipboard-read-fail')));
        });
        else if (e.clipboardData.items[0]) e.clipboardData.items[0].getAsString((pasteStr)=>{
            pasteStr = pasteStr.trim();
            if (pasteStr.match(/^https?/)) // url
            (0, $2e475852c551fcab$export$fe58198efe02b173)(pasteStr, {
                crossOrigin: 'anonymous'
            }).then((img)=>{
                this.importFinishedLoading({
                    type: 'image',
                    width: img.width,
                    height: img.height,
                    canvas: img
                }, undefined, 'default');
            }).catch((error)=>console.log('error loading', error));
            else if (pasteStr.match(/^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/)) {
                // url
                const rgbObj = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.hexToRGB(pasteStr.replace('#', ''));
                rgbObj && this.onColor(rgbObj);
            }
        });
    }
    async handleFileSelect(files, optionStr) {
        const showWarningPsdFlattened = ()=>{
            (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                type: 'warning',
                message: (0, $fc42a07754814920$export$ce37e184d908d785)('import-psd-unsupported') + '<br /><br />',
                buttons: [
                    'Ok'
                ]
            });
        };
        // files need to be copied, because the input is reset
        const fileArr = [
            ...files
        ];
        if (fileArr.length > 1) {
            const shouldImport = await new Promise((resolve)=>{
                (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                    type: 'warning',
                    message: (0, $fc42a07754814920$export$ce37e184d908d785)('import-many-files-warning', {
                        x: '' + fileArr.length
                    }),
                    buttons: [
                        {
                            id: 'import',
                            label: (0, $fc42a07754814920$export$ce37e184d908d785)('import-many-files-confirm', {
                                x: '' + fileArr.length
                            })
                        },
                        'Cancel'
                    ],
                    callback: (result)=>{
                        resolve(result === 'import');
                    }
                });
            });
            if (!shouldImport) return;
        }
        let hasUnsupportedFile = false;
        for(let i = 0; i < fileArr.length; i++){
            const file = fileArr[i];
            const fileType = await (0, $8bcac57fac5624c8$export$16b40d0fc7becfe6)(file);
            if (fileType === 'image') (0, $2e475852c551fcab$export$99cbfa07c2ec1e27)(file).then((image)=>{
                this.importFinishedLoading({
                    type: 'image',
                    width: image.width,
                    height: image.height,
                    canvas: image
                }, file.name, optionStr);
            }).catch(()=>(0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('import-broken-file')));
            else if (fileType === 'psd') {
                const loaderSizeBytes = 26214400; // 25mb
                const maxSizeBytes = 1073741824; // 1gb
                const maxResolution = 4096;
                if (file.size >= maxSizeBytes) {
                    // pretty likely to break stuff
                    (0, $5f9f54d39d868ac2$export$3879b24e8245693d)('File too big. Unable to import.');
                    return;
                }
                const doShowLoader = fileArr.length === 1 && file.size >= loaderSizeBytes;
                let loaderIsOpen = true;
                let closeLoader;
                if (doShowLoader) (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                    message: (0, $fc42a07754814920$export$ce37e184d908d785)('import-opening'),
                    callback: (result)=>{
                        loaderIsOpen = false;
                        closeLoader = null;
                    },
                    closeFunc: (f)=>{
                        closeLoader = f;
                    }
                });
                const reader = new FileReader();
                reader.onload = (readerResult)=>{
                    const target = (0, $94f0b2b810d4d191$export$b813e062795b89b5)(readerResult.target);
                    (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).loadAgPsd().then((agPsdLazy)=>{
                        if (doShowLoader && !loaderIsOpen) return;
                        try {
                            let psd;
                            // first pass, only read metadata
                            psd = agPsdLazy.readPsd(target.result, {
                                skipLayerImageData: true,
                                skipThumbnail: true,
                                skipCompositeImageData: true
                            });
                            if (psd.width > maxResolution || psd.height > maxResolution) {
                                if (closeLoader) closeLoader();
                                (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('import-psd-too-large').replace(/{x}/g, '' + maxResolution) + '<br /><br />' + (0, $fc42a07754814920$export$ce37e184d908d785)('import-psd-size') + ': ' + psd.width + ' x ' + psd.height + ' pixels');
                                return;
                            }
                            // second pass, now load actual data.
                            psd = null;
                            const parsed = (0, $94f0b2b810d4d191$export$77f9e426014f6edd)(()=>agPsdLazy.readPsd(target.result));
                            psd = parsed instanceof (0, $94f0b2b810d4d191$export$6d5e6de05c94f9f) ? undefined : parsed;
                            if (psd) {
                                //console.log('psd', psd);
                                const convertedPsd = (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).PSD.psdToKlPsd(psd);
                                //console.log('converted', convertedPsd);
                                if (optionStr === 'image' && convertedPsd.error) showWarningPsdFlattened();
                                if (closeLoader) closeLoader();
                                this.importFinishedLoading(convertedPsd, file.name, optionStr);
                            } else {
                                psd = agPsdLazy.readPsd(target.result, {
                                    skipLayerImageData: true,
                                    skipThumbnail: true
                                });
                                if (optionStr === 'image') showWarningPsdFlattened();
                                if (closeLoader) closeLoader();
                                this.importFinishedLoading({
                                    type: 'psd',
                                    width: psd.width,
                                    height: psd.height,
                                    canvas: (0, $94f0b2b810d4d191$export$5c097f720de072a2)(psd.canvas),
                                    error: true
                                }, file.name, optionStr);
                            }
                        } catch (e) {
                            closeLoader?.();
                            (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $be957da3610487e9$export$921068d8846a1559).el({
                                // error messages can be influenced. safer to avoid innerHTML
                                textContent: // todo localize
                                'Failed to load PSD: ' + (e instanceof Error ? e.message : String(e))
                            }));
                            (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
                        }
                    }).catch((e)=>{
                        closeLoader?.();
                        (0, $5f9f54d39d868ac2$export$3879b24e8245693d)('Error: failed to load PSD library');
                    });
                };
                reader.readAsArrayBuffer(file);
            } else hasUnsupportedFile = true;
        }
        if (hasUnsupportedFile) (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('import-unsupported-file'));
    }
    // ----------------------------------- public -----------------------------------
    constructor(input, callback){
        this.klRootEl = input.klRootEl;
        this.klMaxCanvasSize = input.maxCanvasSize;
        this.layersUi = input.layersUi;
        this.setCurrentLayer = input.setCurrentLayer;
        this.klCanvas = input.klCanvas;
        this.onImportConfirm = input.onImportConfirm;
        this.applyUncommitted = input.applyUncommitted;
        this.onColor = callback.onColor;
    }
}



function $29243e5a58a0dfdb$export$982e7602957287fa(p) {
    const output = [
        'Draw via the console! Learn more: %cKL.help()',
        'background: #000; color: #0f0;'
    ];
    'info' in console ? console.info(...output) : console.log(...output);
    return Object.freeze({
        draw: (path)=>{
            p.onDraw(path);
        },
        help: ()=>{
            console.log(`KL.draw({x: number; y: number}[]) // draw a line
KL.help() // print help
`);
        }
    });
}













class $1bda5714fda10099$export$ae7d5b5c7fa00e77 {
    chainIn(e) {
        this.pointerEventChain.chainIn(e);
    }
    setDoubleTapPointerTypes(p) {
        this.mainDoubleTapper.setAllowedPointerTypeArr(p);
    }
    destroy() {
    // todo
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        const nFingerSubChain = [];
        if (p.onUndo) {
            this.twoFingerTap = new (0, $be957da3610487e9$export$921068d8846a1559).NFingerTapper({
                fingers: 2,
                onTap: p.onUndo
            });
            nFingerSubChain.push(this.twoFingerTap);
        }
        if (p.onRedo) {
            this.threeFingerTap = new (0, $be957da3610487e9$export$921068d8846a1559).NFingerTapper({
                fingers: 3,
                onTap: p.onRedo
            });
            nFingerSubChain.push(this.threeFingerTap);
        }
        this.mainDoubleTapper = new (0, $be957da3610487e9$export$921068d8846a1559).DoubleTapper({
            onDoubleTap: p.onDoubleTap
        });
        this.mainDoubleTapper.setAllowedPointerTypeArr([
            'touch'
        ]);
        this.middleDoubleTapper = new (0, $be957da3610487e9$export$921068d8846a1559).DoubleTapper({
            onDoubleTap: p.onDoubleTap
        });
        this.middleDoubleTapper.setAllowedButtonArr([
            'middle'
        ]);
        this.pinchZoomer = new (0, $be957da3610487e9$export$921068d8846a1559).PinchZoomer({
            onPinch: p.onPinch
        });
        this.pointerEventChain = new (0, $29dd970aa1f95ac5$export$649a211db9812745)({
            chainArr: [
                ...nFingerSubChain,
                this.mainDoubleTapper,
                this.middleDoubleTapper,
                this.pinchZoomer,
                new (0, $be957da3610487e9$export$921068d8846a1559).OnePointerLimiter()
            ]
        });
        this.pointerEventChain.setChainOut(p.onChainOut);
    }
}








function $b33623abb2c50d19$export$296b597c2b22784a(a, b) {
    const isPositionChanged = a.x !== b.x || a.y !== b.y;
    const isScaleOrAngleChanged = a.scale !== b.scale || a.angleDeg !== b.angleDeg;
    return !isPositionChanged && !isScaleOrAngleChanged && a.isMirrored === b.isMirrored;
}








function $60d2a051955684ec$export$e5cb90f7d2eee96c(currentTransform, targetTransform, projectSize, viewportCenter, easeFactor) {
    // equal
    if ((0, $b33623abb2c50d19$export$296b597c2b22784a)(currentTransform, targetTransform)) return {
        ...targetTransform
    };
    // approximately equal
    if ((currentTransform.x === targetTransform.x || Math.abs(currentTransform.x - targetTransform.x) < 2) && (currentTransform.y === targetTransform.y || Math.abs(currentTransform.y - targetTransform.y) < 2) && (currentTransform.scale === targetTransform.scale || Math.abs(currentTransform.scale - targetTransform.scale) < 0.08 * targetTransform.scale)) return {
        ...targetTransform
    };
    // same angle, just translate and scale
    if (currentTransform.angleDeg === targetTransform.angleDeg) return {
        x: (0, $be957da3610487e9$export$921068d8846a1559).mix(currentTransform.x, targetTransform.x, easeFactor),
        y: (0, $be957da3610487e9$export$921068d8846a1559).mix(currentTransform.y, targetTransform.y, easeFactor),
        angleDeg: targetTransform.angleDeg,
        scale: (0, $be957da3610487e9$export$921068d8846a1559).mix(currentTransform.scale, targetTransform.scale, easeFactor),
        isMirrored: targetTransform.isMirrored
    };
    // rotating around a point
    const currentMeta = (0, $a04467f1089650ac$export$935bc53f7df03c95)(currentTransform, viewportCenter);
    const targetMeta = (0, $a04467f1089650ac$export$935bc53f7df03c95)(targetTransform, viewportCenter);
    if ((0, $be957da3610487e9$export$921068d8846a1559).Vec2.dist(currentMeta.canvasP, targetMeta.canvasP) < 1) {
        // move angles closer to each other. assumes [-180, 180] angle range.
        let closerCurrentAngleDeg = currentMeta.angleDeg;
        // -180 180 -> 180 + 180 = 360
        // 180 -180 -> -180 - 180 = -360
        const angleDelta = targetMeta.angleDeg - currentMeta.angleDeg;
        if (angleDelta > 180) closerCurrentAngleDeg += 360;
        if (angleDelta < -180) closerCurrentAngleDeg -= 360;
        const mixedMeta = {
            viewportP: viewportCenter,
            canvasP: targetMeta.canvasP,
            scale: (0, $be957da3610487e9$export$921068d8846a1559).mix(currentTransform.scale, targetTransform.scale, easeFactor),
            angleDeg: (0, $be957da3610487e9$export$921068d8846a1559).mix(closerCurrentAngleDeg, targetTransform.angleDeg, easeFactor),
            isMirrored: targetTransform.isMirrored
        };
        return (0, $cdf37dcca656673a$export$99c68a89351e15c0)(mixedMeta.viewportP, mixedMeta.canvasP, mixedMeta.scale, mixedMeta.angleDeg, mixedMeta.isMirrored);
    }
    // rotate around center of canvas
    const canvasCenter = {
        x: projectSize.width / 2,
        y: projectSize.height / 2
    };
    const currentMatrix = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(currentTransform);
    const targetMatrix = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(targetTransform);
    const currentCenter = (0, $43e83319b765a157$export$9b20165a36586806)(currentMatrix, canvasCenter);
    const targetCenter = (0, $43e83319b765a157$export$9b20165a36586806)(targetMatrix, canvasCenter);
    const mixedCenter = {
        x: (0, $be957da3610487e9$export$921068d8846a1559).mix(currentCenter.x, targetCenter.x, easeFactor),
        y: (0, $be957da3610487e9$export$921068d8846a1559).mix(currentCenter.y, targetCenter.y, easeFactor)
    };
    return (0, $cdf37dcca656673a$export$99c68a89351e15c0)(mixedCenter, canvasCenter, (0, $be957da3610487e9$export$921068d8846a1559).mix(currentTransform.scale, targetTransform.scale, easeFactor), (0, $be957da3610487e9$export$921068d8846a1559).mix(currentTransform.angleDeg, targetTransform.angleDeg, easeFactor), targetTransform.isMirrored);
}







function $214074e70e75aa6b$export$29dc1c77cb35d1c5(rect, viewportTransform, easelSize, snapRotation, padding = 0, maxScale = (0, $00631e3d51f88f11$export$ac82c07320907c00)) {
    // rotate
    let newAngleDeg = viewportTransform.angleDeg;
    if (snapRotation) {
        if (newAngleDeg === 45) // would otherwise get rounded to 90
        newAngleDeg = 0;
        newAngleDeg = (0, $4c2c6808296c0d73$export$c0156198713d0f0)(newAngleDeg, 90, 90);
    }
    // calc width and height of bounds after rotation
    const rectCenterX = rect.x + rect.width / 2;
    const rectCenterY = rect.y + rect.height / 2;
    const canvasPointsArr = [
        [
            rect.x,
            rect.y
        ],
        [
            rect.x + rect.width,
            rect.y
        ],
        [
            rect.x + rect.width,
            rect.y + rect.height
        ],
        [
            rect.x,
            rect.y + rect.height
        ]
    ];
    // setup transformation matrix
    let matrix = (0, $bf8a1df6cb389ef0$export$5b12bf1653c0dd85).getIdentity();
    matrix = (0, $bf8a1df6cb389ef0$export$5b12bf1653c0dd85).multiplyMatrices(matrix, (0, $bf8a1df6cb389ef0$export$5b12bf1653c0dd85).createRotationMatrix(newAngleDeg / 180 * Math.PI));
    // rotate points
    for(let i = 0; i < canvasPointsArr.length; i++){
        let coords = [
            canvasPointsArr[i][0],
            canvasPointsArr[i][1],
            0,
            1
        ];
        coords = (0, $bf8a1df6cb389ef0$export$5b12bf1653c0dd85).multiplyMatrixAndPoint(matrix, coords);
        canvasPointsArr[i][0] = coords[0];
        canvasPointsArr[i][1] = coords[1];
    }
    const boundsObj = {};
    for(let i = 0; i < canvasPointsArr.length; i++){
        if (boundsObj.x1 === undefined || canvasPointsArr[i][0] < boundsObj.x1) boundsObj.x1 = canvasPointsArr[i][0];
        if (boundsObj.y1 === undefined || canvasPointsArr[i][1] < boundsObj.y1) boundsObj.y1 = canvasPointsArr[i][1];
        if (boundsObj.x2 === undefined || canvasPointsArr[i][0] > boundsObj.x2) boundsObj.x2 = canvasPointsArr[i][0];
        if (boundsObj.y2 === undefined || canvasPointsArr[i][1] > boundsObj.y2) boundsObj.y2 = canvasPointsArr[i][1];
    }
    const boundsWidth = boundsObj.x2 - boundsObj.x1;
    const boundsHeight = boundsObj.y2 - boundsObj.y1;
    // fit bounds
    const { width: fitWidth } = (0, $94f0b2b810d4d191$export$fa55905620c22535)(boundsWidth, boundsHeight, easelSize.width - padding * 2, easelSize.height - padding * 2, 1);
    // determine scale
    const factor = Math.min(maxScale, fitWidth / boundsWidth);
    return (0, $cdf37dcca656673a$export$99c68a89351e15c0)({
        x: easelSize.width / 2,
        y: easelSize.height / 2
    }, {
        x: rectCenterX,
        y: rectCenterY
    }, factor, newAngleDeg, viewportTransform.isMirrored);
}





function $ed70604d5995cba6$var$getToolEntries(tools) {
    return Object.entries(tools);
}
class $ed70604d5995cba6$export$2732362bcaeb02c2 {
    setTargetTransform(transform, isImmediate) {
        if (isImmediate) this.viewport.setTransform(transform);
        this.targetTransform = transform;
        this.doRender = true;
    }
    updateToolSvgs() {
        const targetTool = this.tempToolId ?? this.toolId;
        $ed70604d5995cba6$var$getToolEntries(this.toolsMap).forEach(([toolId, tool])=>{
            tool.getSvgElement().style.display = toolId === targetTool ? '' : 'none';
        });
    }
    // different tools allow different pointer types to trigger the gesture
    updateDoubleTapPointerTypes() {
        const pointerTypes = this.toolsMap[this.tempToolId ?? this.toolId].doubleTapPointerTypes ?? (0, $00631e3d51f88f11$export$31ee023005d8c68f);
        this.pointerPreprocessor.setDoubleTapPointerTypes(pointerTypes);
    }
    /**
     * Only call once from outside. Will perpetuate itself and render when doRender = true
     */ renderLoop() {
        const now = performance.now();
        const deltaMs = now - this.lastFrameTimestamp;
        this.lastFrameTimestamp = now;
        this.animationFrameId = requestAnimationFrame(()=>this.renderLoop());
        if (!this.doRender) return;
        const tool = this.getActiveTool();
        const oldTransform = this.viewport.getTransform();
        let newTransform = oldTransform;
        if ((0, $b33623abb2c50d19$export$296b597c2b22784a)(oldTransform, this.targetTransform)) this.doRender = false;
        else {
            const defaultDeltaMs = 1000 / 60;
            const timeFactor = deltaMs / defaultDeltaMs;
            const easeFactor = 1 - 0.7 ** timeFactor;
            newTransform = (0, $60d2a051955684ec$export$e5cb90f7d2eee96c)(oldTransform, this.targetTransform, {
                width: this.project.width,
                height: this.project.height
            }, {
                x: this.width / 2,
                y: this.height / 2
            }, easeFactor);
            this.viewport.setTransform(newTransform);
        }
        // todo: is last renderedTransform needed?
        const isPositionChanged = newTransform.x !== this.lastRenderedTransform.x || newTransform.y !== this.lastRenderedTransform.y;
        const isScaleOrAngleChanged = newTransform.scale !== this.lastRenderedTransform.scale || newTransform.angleDeg !== this.lastRenderedTransform.angleDeg;
        const isMirroredChanged = newTransform.isMirrored !== this.lastRenderedTransform.isMirrored;
        this.viewport.render(!(0, $b33623abb2c50d19$export$296b597c2b22784a)(oldTransform, newTransform));
        if (isPositionChanged || isScaleOrAngleChanged || isMirroredChanged) {
            tool.onUpdateTransform?.(newTransform);
            this.selectionRenderer.setTransform(newTransform);
            this.onTransformChange(this.targetTransform, isScaleOrAngleChanged);
            this.lastRenderedTransform = newTransform;
        }
    }
    /**
     * activate temporary tool. Can only push one.
     */ pushTempTool(toolId) {
        if (this.tempToolId !== undefined || toolId === undefined) return;
        const tool = this.toolsMap[this.toolId];
        if (tool.getIsLocked?.()) return;
        this.tempToolId = toolId;
        const activeToolId = this.getActiveToolId();
        this.toolsMap[activeToolId].activate?.(this.cursorPos);
        Object.values(this.toolsMap).forEach((tool)=>tool.onTool?.(activeToolId));
        this.updateToolSvgs();
        this.updateDoubleTapPointerTypes();
    }
    /**
     * Turn off temporary tool
     */ popTempTool(toolId) {
        if (this.tempToolId !== toolId || toolId === undefined) return;
        this.tempToolId = undefined;
        this.getActiveTool().activate?.(this.cursorPos, true);
        const activeToolId = this.getActiveToolId();
        Object.values(this.toolsMap).forEach((tool)=>tool.onTool?.(activeToolId));
        this.updateToolSvgs();
        this.updateDoubleTapPointerTypes();
    }
    getActiveToolId() {
        return this.tempToolId ?? this.toolId;
    }
    getActiveTool() {
        return this.toolsMap[this.getActiveToolId()];
    }
    getResetTransform(isMirrored = false) {
        return (0, $cdf37dcca656673a$export$99c68a89351e15c0)({
            x: this.width / 2,
            y: this.height / 2
        }, {
            x: this.project.width / 2,
            y: this.project.height / 2
        }, 1, 0, isMirrored);
    }
    getFitTransform() {
        return (0, $214074e70e75aa6b$export$29dc1c77cb35d1c5)({
            x: 0,
            y: 0,
            width: this.project.width,
            height: this.project.height
        }, this.viewport.getTransform(), {
            width: this.width,
            height: this.height
        }, true);
    }
    // update and render
    setProject(project) {
        this.project = project;
        this.viewport.setProject({
            width: this.project.width,
            height: this.project.height,
            layers: this.project.layers
        });
        this.selectionRenderer.setSelection(this.project.selection);
        this.selectionIndicatorEl.style.display = this.project.selection ? '' : 'none';
        this.getActiveTool().onUpdateSelection?.(this.project.selection);
        this.requestRender();
    }
    // update and render
    setSize(width, height) {
        const m = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.viewport.getTransform());
        const canvasCenterPoint = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(m), {
            x: this.width / 2,
            y: this.height / 2
        });
        this.width = width;
        this.height = height;
        (0, $be957da3610487e9$export$921068d8846a1559).setAttributes(this.svgEl, {
            width: '' + this.width,
            height: '' + this.height
        });
        this.selectionRenderer.setSize(width, height);
        this.getActiveTool().onResize?.(width, height);
        this.viewport.setSize(width, height);
        const transform = this.viewport.getTransform();
        this.setTargetTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)({
            x: this.width / 2,
            y: this.height / 2
        }, canvasCenterPoint, transform.scale, transform.angleDeg, transform.isMirrored), true);
        this.requestRender();
    }
    requestRender() {
        this.doRender = true;
    }
    getTransform() {
        return this.viewport.getTransform();
    }
    setTransform(transform) {
        this.setTargetTransform(transform, true);
    }
    setTool(toolId) {
        if (toolId === this.toolId) return;
        this.toolId = toolId;
        this.toolsMap[this.toolId].activate?.(this.cursorPos);
        Object.values(this.toolsMap).forEach((tool)=>tool.onTool?.(this.toolId));
        this.onChangeTool(toolId);
        this.updateToolSvgs();
        this.updateDoubleTapPointerTypes();
        this.requestRender();
    }
    getTool() {
        return this.toolId;
    }
    translate(dX, dY) {
        const transform = this.targetTransform;
        this.setTargetTransform({
            ...transform,
            x: transform.x + dX,
            y: transform.y + dY
        });
    }
    scale(factor, viewportX, viewportY) {
        const before = this.targetTransform;
        const viewportRect = {
            width: this.width,
            height: this.height
        };
        viewportX = viewportX ?? viewportRect.width / 2;
        viewportY = viewportY ?? viewportRect.height / 2;
        const metaTransform = (0, $a04467f1089650ac$export$935bc53f7df03c95)(before, {
            x: viewportX,
            y: viewportY
        });
        metaTransform.scale = (0, $be957da3610487e9$export$921068d8846a1559).clamp(metaTransform.scale * factor, (0, $00631e3d51f88f11$export$5e2c057e240c0b8c), (0, $00631e3d51f88f11$export$ac82c07320907c00));
        this.setTargetTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg, metaTransform.isMirrored));
    }
    resetTransform(isImmediate) {
        const transform = this.getResetTransform(this.targetTransform.isMirrored);
        this.setTargetTransform(transform, isImmediate);
        this.requestRender();
    }
    fitTransform(isImmediate) {
        const oldTransform = this.viewport.getTransform();
        const transform = this.getFitTransform();
        const isPositionChanged = transform.x !== oldTransform.x || transform.y !== oldTransform.y;
        const isScaleOrAngleChanged = transform.scale !== oldTransform.scale || transform.angleDeg !== oldTransform.angleDeg;
        if (!isPositionChanged && !isScaleOrAngleChanged) return false;
        this.setTargetTransform(transform, isImmediate);
        return true;
    }
    /**
     * Automatically decide what is best. E.g. if it's pixel art, Fit might be better.
     */ resetOrFitTransform(isImmediate) {
        const threshold = 4; // >= 400% zoom. pixelated, not blurry
        if (!(0, $00d7ded47eb0b8eb$export$67ac20532b9ededa).disableAutoFit && this.project.width <= this.width / threshold && this.project.height <= this.height / threshold) this.fitTransform(isImmediate);
        else this.resetTransform(isImmediate);
    }
    setAngleDeg(angleDeg, isRelative) {
        const viewportTransform = this.targetTransform;
        const viewportMat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(viewportTransform);
        const viewportRect = {
            width: this.width,
            height: this.height
        };
        const viewportCenterP = {
            x: viewportRect.width / 2,
            y: viewportRect.height / 2
        };
        const newAngleDeg = (0, $4c2c6808296c0d73$export$ec85425cac357ca9)(isRelative ? viewportTransform.angleDeg + angleDeg : angleDeg);
        const newViewportTransform = (0, $cdf37dcca656673a$export$99c68a89351e15c0)(viewportCenterP, (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(viewportMat), viewportCenterP), viewportTransform.scale, newAngleDeg, viewportTransform.isMirrored);
        this.setTargetTransform(newViewportTransform);
    }
    setIsMirrored(isMirrored) {
        if (isMirrored === this.getIsMirrored()) return;
        const transform = this.targetTransform;
        const viewportCenterP = {
            x: this.width / 2,
            y: this.height / 2
        };
        this.setTargetTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)(viewportCenterP, (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)((0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(transform)), viewportCenterP), transform.scale, (0, $4c2c6808296c0d73$export$ec85425cac357ca9)(-transform.angleDeg), isMirrored), true);
        this.mirrorIndicatorEl.style.display = isMirrored ? '' : 'none';
    }
    getIsMirrored() {
        return this.targetTransform.isMirrored;
    }
    getIsLocked() {
        return this.getActiveTool().getIsLocked?.() ?? false;
    }
    setIsFrozen(b) {
        this.isFrozen = b;
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.viewport.destroy();
        this.pointerListener.destroy();
        this.keyListener.destroy();
        this.animationFrameId !== undefined && cancelAnimationFrame(this.animationFrameId);
        this.selectionRenderer.destroy();
        window.removeEventListener('pointerdown', this.windowPointerListener);
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.doRender = false // true -> will render on next renderLoop
        ;
        this.isFrozen = false // disable interaction with the easel whatsoever
        ;
        this.lastRenderedTransform = {} // previously rendered viewport transformation
        ;
        // custom interface passed to tools
        this.easelInterface = {
            setCursor: (cursor)=>this.rootEl.style.cursor = cursor,
            getTransform: ()=>this.viewport.getTransform(),
            getTargetTransform: ()=>this.targetTransform,
            getSize: ()=>({
                    width: this.width,
                    height: this.height
                }),
            getProjectSize: ()=>({
                    width: this.project.width,
                    height: this.project.height
                }),
            setTransform: (transform, isImmediate)=>this.setTargetTransform(transform, isImmediate),
            requestRender: ()=>this.requestRender(),
            isKeyPressed: (keyStr)=>this.keyListener.isPressed(keyStr),
            minScale: (0, $00631e3d51f88f11$export$5e2c057e240c0b8c),
            maxScale: (0, $00631e3d51f88f11$export$ac82c07320907c00),
            setAngleDeg: (...args)=>this.setAngleDeg(...args),
            keyListener: {},
            updateDoubleTapPointerTypes: ()=>this.updateDoubleTapPointerTypes(),
            setRenderedSelection: (selection)=>this.selectionRenderer.setRenderedSelection(selection),
            clearRenderedSelection: (isImmediate)=>this.selectionRenderer.clearRenderedSelection(isImmediate),
            onWheel: (e)=>this.onWheel(e),
            getElement: ()=>this.rootEl
        };
        this.lastFrameTimestamp = 0;
        this.onWheel = (e)=>{
            e.event?.preventDefault();
            let isImmediate = false;
            if (Math.abs(e.deltaY) < 0.8) isImmediate = true;
            if (e.event && e.event.ctrlKey && !this.keyListener.isPressed('ctrl')) {
                isImmediate = true;
                let factor = 1;
                if (e.event.deltaMode === 0) factor = 6;
                e.deltaY *= factor;
            }
            if (this.keyListener.isPressed('shift')) e.deltaY /= 4;
            // zoom
            const transform = this.targetTransform;
            const viewportPoint = {
                x: e.relX,
                y: e.relY
            };
            const mat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(transform);
            const canvasPoint = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(mat), viewportPoint);
            const newScale = (0, $be957da3610487e9$export$921068d8846a1559).clamp(transform.scale * 1.4 ** -e.deltaY, (0, $00631e3d51f88f11$export$5e2c057e240c0b8c), (0, $00631e3d51f88f11$export$ac82c07320907c00));
            this.setTargetTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)(viewportPoint, canvasPoint, newScale, transform.angleDeg, transform.isMirrored), isImmediate);
        };
        this.project = p.project;
        this.width = p.width;
        this.height = p.height;
        this.toolId = p.tool;
        this.toolsMap = {
            ...p.tools
        };
        this.onChangeTool = p.onChangeTool;
        this.onTransformChange = p.onTransformChange;
        this.onUndo = p.onUndo;
        this.onRedo = p.onRedo;
        this.tempTools = Object.fromEntries((0, $00631e3d51f88f11$export$c5299001bfb7de59).map((trigger)=>{
            return [
                trigger,
                $ed70604d5995cba6$var$getToolEntries(this.toolsMap).filter(([toolName, tool])=>{
                    return tool.tempTriggers && tool.tempTriggers.includes(trigger);
                }).map((i)=>i[0])[0]
            ];
        }));
        this.viewport = new (0, $5e9856f8e33534aa$export$a140ed60c2ca052c)({
            width: this.width,
            height: this.height,
            project: {
                width: this.project.width,
                height: this.project.height,
                layers: this.project.layers
            },
            transform: this.getResetTransform(),
            onBeforeRender: p.onBeforeRender,
            renderAfter: (ctx, renderedTransform)=>{
                const tool = this.getActiveTool();
                tool.renderAfterViewport?.(ctx, renderedTransform);
            }
        });
        this.targetTransform = this.viewport.getTransform();
        Object.values(this.toolsMap).forEach((tool)=>{
            tool.setEaselInterface?.(this.easelInterface);
            tool.onResize?.(this.width, this.height);
        });
        let mouseMiddleIsDown = false;
        let mouseRightIsDown = false;
        let angleIsExtraSticky = false;
        this.pointerPreprocessor = new (0, $1bda5714fda10099$export$ae7d5b5c7fa00e77)({
            onUndo: this.onUndo,
            onRedo: this.onRedo,
            onPinch: (event)=>{
                if (event.type === 'move') {
                    const transform = this.viewport.getTransform();
                    if (!this.pinchInitialTransform) {
                        this.pinchInitialTransform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(transform);
                        angleIsExtraSticky = this.pinchInitialTransform.angleDeg % 180 === 0;
                    }
                    let newAngleDeg = this.pinchInitialTransform.angleDeg + event.angleRad / Math.PI * 180;
                    newAngleDeg = (0, $4c2c6808296c0d73$export$ec85425cac357ca9)((0, $4c2c6808296c0d73$export$c0156198713d0f0)(newAngleDeg, 90, angleIsExtraSticky ? 12 : 4));
                    if (newAngleDeg % 90 !== 0) angleIsExtraSticky = false;
                    const metaTransform = (0, $a04467f1089650ac$export$935bc53f7df03c95)(this.pinchInitialTransform, {
                        x: event.downRelX,
                        y: event.downRelY
                    });
                    metaTransform.scale = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.pinchInitialTransform.scale * event.scale, (0, $00631e3d51f88f11$export$5e2c057e240c0b8c), (0, $00631e3d51f88f11$export$ac82c07320907c00));
                    metaTransform.viewportP.x += event.relX - event.downRelX;
                    metaTransform.viewportP.y += event.relY - event.downRelY;
                    metaTransform.angleDeg = newAngleDeg;
                    this.setTargetTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg, metaTransform.isMirrored), true);
                    this.requestRender();
                } else if (event.type === 'end') this.pinchInitialTransform = undefined;
            },
            onDoubleTap: (e)=>{
                if (this.fitTransform()) this.requestRender();
                else this.scale(2, e.relX, e.relY);
            },
            onChainOut: (e)=>{
                this.cursorPos = {
                    x: e.relX,
                    y: e.relY
                };
                if (e.type === 'pointerdown') {
                    if (e.button === 'middle') {
                        mouseMiddleIsDown = true;
                        this.pushTempTool(this.tempTools['mouse-middle']);
                    }
                    if (e.button === 'right') {
                        mouseRightIsDown = true;
                        this.pushTempTool(this.tempTools['mouse-right']);
                    }
                } else if (e.type === 'pointermove') ;
                else if (e.type === 'pointerup') {
                    if (mouseMiddleIsDown) {
                        mouseMiddleIsDown = false;
                        this.getActiveTool().onPointer(e);
                        this.popTempTool(this.tempTools['mouse-middle']);
                        return;
                    }
                    if (mouseRightIsDown) {
                        mouseRightIsDown = false;
                        this.getActiveTool().onPointer(e);
                        this.popTempTool(this.tempTools['mouse-right']);
                        return;
                    }
                }
                this.getActiveTool().onPointer(e);
            }
        });
        /*
        // My trackpad pinching (via PointerListener) doesn't currently work with Safari on macOS.
        // So I tried GestureListener, which works, but doesn't mesh well with the other event listeners.
        let lastScale = 0;
        this.gestureListener = new GestureListener({
            target: this.viewport.getElement(),
            onStart: (e) => {
                lastScale = e.scale;
            },
            onChange: (e) => {
                const deltaScale = e.scale / lastScale;
                lastScale = e.scale;

                // zoom
                const transform = this.viewport.getTransform();
                const viewportPoint = {
                    x: e.layerX,
                    y: e.layerY,
                };
                const mat = createMatrixFromTransform(transform);
                const canvasPoint = applyToPoint(inverse(mat), viewportPoint);
                const newScale = BB.clamp(
                    transform.scale * deltaScale,
                    EASEL_MIN_SCALE,
                    EASEL_MAX_SCALE,
                );
                this.setTransform(
                    createTransform(viewportPoint, canvasPoint, newScale, transform.angleDeg),
                );
                this.requestRender();
            },
        });*/ this.pointerListener = new (0, $3a4865bce5f52590$export$9371bd96776f4e82)({
            target: this.viewport.getElement(),
            onPointer: (e)=>{
                this.pointerPreprocessor.chainIn(e);
            },
            onWheel: this.onWheel,
            onEnterLeave: (isOver)=>{
                const tool = this.getActiveTool();
                if (!isOver) {
                    this.cursorPos = undefined;
                    tool.onPointerLeave?.();
                }
            },
            useDirtyWheel: true,
            isWheelPassive: false,
            maxPointers: 3
        });
        this.windowPointerListener = (e)=>{
            if (this.isFrozen) return;
            if (!(e.target instanceof Node && this.rootEl.contains(e.target))) this.getActiveTool().onClickOutside?.();
        };
        window.addEventListener('pointerdown', this.windowPointerListener);
        this.keyListener = new (0, $26d18c1211450b7d$export$f17908c5de22d32e)({
            onDown: (keyStr, e, comboStr, isRepeat)=>{
                if (this.isFrozen || (0, $be957da3610487e9$export$921068d8846a1559).isInputFocused(true)) return;
                if (comboStr === 'plus') {
                    const oldScale = this.getTransform().scale;
                    const newScale = (0, $b9d080b8d62d48af$export$8c03162b1a39d183)(oldScale, this.keyListener.isPressed('shift') ? 1 / 8 : 0.5);
                    this.scale(newScale / oldScale);
                }
                if (comboStr === 'minus') {
                    const oldScale = this.getTransform().scale;
                    const newScale = (0, $b9d080b8d62d48af$export$8c03162b1a39d183)(oldScale, this.keyListener.isPressed('shift') ? -1 / 8 : -0.5);
                    this.scale(newScale / oldScale);
                }
                if (comboStr !== 'shift' && this.keyListener.comboOnlyContains([
                    'shift',
                    'left',
                    'right',
                    'up',
                    'down'
                ])) {
                    const arrowKey = comboStr.split('+').find((item)=>item !== 'shift');
                    const activeTool = this.getActiveTool();
                    if (!activeTool.onArrowKeys?.(arrowKey)) {
                        const stepSize = 40;
                        if (arrowKey === 'left') this.translate(stepSize, 0);
                        if (arrowKey === 'right') this.translate(-stepSize, 0);
                        if (arrowKey === 'up') this.translate(0, stepSize);
                        if (arrowKey === 'down') this.translate(0, -stepSize);
                    }
                }
                // activate temporary tool
                (0, $00631e3d51f88f11$export$4f41ddbc92f66d7d).forEach((keyTrigger)=>{
                    if (comboStr === keyTrigger && this.toolsMap[this.toolId].blockTrigger !== keyTrigger) this.pushTempTool(this.tempTools[keyTrigger]);
                });
                const tool = this.toolsMap[this.tempToolId ?? this.toolId];
                tool.onKeyDown?.(keyStr, e, comboStr, isRepeat);
            },
            onUp: (keyStr, e, oldComboStr)=>{
                if (this.isFrozen) return;
                // turn off temporary tool again
                (0, $00631e3d51f88f11$export$4f41ddbc92f66d7d).forEach((keyTrigger)=>{
                    if (keyStr === keyTrigger && this.toolsMap[this.toolId].blockTrigger !== keyTrigger) this.popTempTool(this.tempTools[keyTrigger]);
                });
                const tool = this.toolsMap[this.tempToolId ?? this.toolId];
                tool.onKeyUp?.(keyStr, e, oldComboStr);
            },
            onBlur: ()=>{
                const tool = this.toolsMap[this.tempToolId ?? this.toolId];
                tool.onBlur?.();
            }
        });
        this.easelInterface.keyListener = this.keyListener;
        this.selectionRenderer = new (0, $276b775cfacb0889$export$c61ab90e0d3eb9b1)({
            transform: this.viewport.getTransform(),
            selection: this.project.selection,
            width: this.width,
            height: this.height
        });
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'svg',
            width: '' + this.width,
            height: '' + this.height
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.svgEl, {
            position: 'absolute',
            left: 0,
            top: 0,
            pointerEvents: 'none'
        });
        this.svgEl.append(this.selectionRenderer.getElement(), ...Object.values(this.toolsMap).map((item)=>item.getSvgElement()));
        this.htmlOverlayEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                left: 0,
                top: 0
            }
        });
        this.htmlOverlayEl.append(...Object.values(this.toolsMap).map((item)=>item.getHtmlOverlayElement?.() || undefined).filter((item)=>item !== undefined));
        this.updateToolSvgs();
        const createIndicator = (icon, title, onClick)=>{
            const el = (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)(icon, {
                    width: 20,
                    height: 20
                }),
                title: title,
                onClick: onClick,
                css: {
                    display: 'none',
                    padding: 5,
                    borderRadius: 5,
                    background: 'var(--canvas-overlay-bg)',
                    color: '#fff',
                    cursor: 'pointer',
                    pointerEvents: 'auto'
                }
            });
            // rootEl prevents default on touchend, which would suppress the click
            el.addEventListener('touchend', (e)=>e.stopPropagation());
            return el;
        };
        this.mirrorIndicatorEl = createIndicator('view-flip', (0, $fc42a07754814920$export$ce37e184d908d785)('hand-flip'), ()=>this.setIsMirrored(false));
        this.selectionIndicatorEl = createIndicator('select-mode-select', (0, $fc42a07754814920$export$ce37e184d908d785)('select-deselect'), p.onResetSelection);
        this.selectionIndicatorEl.style.display = this.project.selection ? '' : 'none';
        const indicatorsEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                left: 5,
                bottom: 5,
                display: 'flex',
                gap: 5,
                pointerEvents: 'none'
            }
        });
        indicatorsEl.append(this.mirrorIndicatorEl, this.selectionIndicatorEl);
        this.rootEl = (0, $8405ecc79d32770a$export$db3b6bfb95261072)({
            css: {
                userSelect: 'none',
                touchAction: 'none',
                overscrollBehaviorX: 'none'
            }
        }, [
            this.viewport.getElement(),
            this.svgEl,
            this.htmlOverlayEl,
            indicatorsEl
        ]);
        // prevent contextmenu
        this.rootEl.addEventListener('contextmenu', (e)=>{
            e.preventDefault();
            return false;
        }, {
            passive: false
        });
        // Carried over from old KlCanvasWorkspace. Prevent some default browser behavior. Todo what breaks if removed?
        this.rootEl.addEventListener('touchend', (e)=>{
            e.preventDefault();
            return false;
        });
        // Carried over from old KlCanvasWorkspace. Prevent some default browser behavior. Todo what breaks if removed?
        this.rootEl.addEventListener('dragstart', (e)=>{
            e.preventDefault();
            return false;
        });
        this.toolsMap[this.toolId].activate?.(this.cursorPos);
        Object.values(this.toolsMap).forEach((tool)=>tool.onTool?.(this.toolId));
        {
            // adjust the transform without triggering a render
            const doRender = this.doRender;
            this.resetOrFitTransform(true);
            this.doRender = doRender;
        }
        this.renderLoop();
    }
}




class $5ca5d42f583e32e1$export$8202a4a90789f655 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor('grab');
        if (e.type === 'pointerdown' && [
            'left',
            'middle'
        ].includes(e.button)) {
            this.inertiaScrolling.dragStart();
            this.easel.setCursor('grabbing');
        }
        if (e.type === 'pointermove' && [
            'left',
            'middle'
        ].includes(e.button)) {
            const vTransform = {
                ...this.easel.getTransform()
            };
            vTransform.x += e.dX;
            vTransform.y += e.dY;
            this.easel.setTransform(vTransform, true);
            this.easel.requestRender();
            this.easel.setCursor('grabbing');
            this.inertiaScrolling.dragMove(e.dX, e.dY);
        }
        if (e.type === 'pointerup' && e.button === undefined) this.inertiaScrolling.dragEnd();
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor('grab');
    }
    setUseInertiaScrolling(b) {
        this.inertiaScrolling.setIsEnabled(b);
    }
    constructor(p){
        this.easel = {};
        // ----------------------------------- public -----------------------------------
        this.doubleTapPointerTypes = [
            'touch',
            'mouse',
            'pen'
        ];
        this.tempTriggers = [
            'space',
            'mouse-middle'
        ];
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.inertiaScrolling = new (0, $634c85655c4c1f52$export$6c14c4cb1f26a0eb)({
            getTransform: ()=>this.easel.getTransform(),
            setTransform: (transform)=>this.easel.setTransform(transform, true)
        });
    }
}












/**
 * Outline of a mask made of centered pixel rows, shrunk by inset.
 * x relative to center, y relative to top.
 */ function $664a14254435e004$var$getOutline(halfWidths, inset) {
    // right side, top to bottom
    const right = [];
    halfWidths.forEach((halfWidth, y)=>{
        const above = halfWidths[y - 1] ?? 0;
        const below = halfWidths[y + 1] ?? 0;
        if (halfWidth !== above) right.push([
            halfWidth - inset,
            y + (halfWidth > above ? inset : -inset)
        ]);
        if (halfWidth !== below) right.push([
            halfWidth - inset,
            y + 1 + (halfWidth > below ? -inset : inset)
        ]);
    });
    // left side is mirrored, bottom to top
    const left = right.map(([x, y])=>[
            -x,
            y
        ]).reverse();
    return [
        ...right,
        ...left
    ];
}
class $664a14254435e004$export$1b678dbb43c691f9 {
    update(transform, position, size) {
        // brush pixels -> viewport
        const mat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(transform);
        const canvasPos = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(mat), position);
        // same placement as PixelBrush.drawDot at pressure 1
        size = Math.round(size * 2) / 2;
        const diameter = size * 2;
        const centerX = Math.round(canvasPos.x - size) + size;
        const top = Math.round(canvasPos.y - size);
        const halfWidths = this.tip === 'round' ? (0, $ce287f0b331aeb2c$export$b843be359a1eb867)(diameter) : new Array(diameter).fill(size);
        const getPath = (inset)=>{
            const points = $664a14254435e004$var$getOutline(halfWidths, inset).map(([x, y])=>(0, $43e83319b765a157$export$9b20165a36586806)(mat, [
                    centerX + x,
                    top + y
                ]).join(','));
            return 'M ' + points.join(' ') + ' Z';
        };
        (0, $94f0b2b810d4d191$export$74da2cba014bdc09)(this.rootEl.firstChild, {
            d: getPath(1 / transform.scale)
        });
        (0, $94f0b2b810d4d191$export$74da2cba014bdc09)(this.rootEl.children[1], {
            d: getPath(0)
        });
    }
    setTip(tip) {
        this.tip = tip;
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.tip = 'round';
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g',
            childrenArr: [
                {
                    elementType: 'path',
                    fill: 'none',
                    stroke: 'rgba(255,255,255,0.7)',
                    'stroke-width': '1'
                },
                {
                    elementType: 'path',
                    fill: 'none',
                    stroke: 'rgba(0,0,0,0.7)',
                    'stroke-width': '1'
                }
            ]
        });
    }
}



class $98ab571189377d55$export$249b9041c848ec46 {
    update(transform, position, size) {
        (0, $be957da3610487e9$export$921068d8846a1559).setAttributes(this.rootEl.children[0], {
            r: '' + Math.max(0, size * transform.scale - 1)
        });
        (0, $be957da3610487e9$export$921068d8846a1559).setAttributes(this.rootEl.children[1], {
            r: '' + size * transform.scale
        });
        (0, $be957da3610487e9$export$921068d8846a1559).setAttributes(this.rootEl, {
            transform: `translate(${position.x} ${position.y})`
        });
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g',
            childrenArr: [
                {
                    elementType: 'circle',
                    cx: '0',
                    cy: '0',
                    fill: 'none',
                    stroke: 'rgba(255,255,255,0.7)',
                    'stroke-width': '1'
                },
                {
                    elementType: 'circle',
                    cx: '0',
                    cy: '0',
                    fill: 'none',
                    stroke: 'rgba(0,0,0,0.7)',
                    'stroke-width': '1'
                }
            ]
        });
    }
}


class $eefd099c1f1ae66b$export$dfeedd8879a1038a {
    onExplodedPointer(e) {
        const vTransform = this.easel.getTransform();
        const m = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(vTransform);
        // canvas coordinates
        const p = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        const x = p.x;
        const y = p.y;
        if (vTransform.scale !== this.oldScale) this.oldScale = vTransform.scale;
        if (!e.isCoalesced) {
            this.lastPos.x = e.relX;
            this.lastPos.y = e.relY;
            this.currentCursor.update(this.easel.getTransform(), {
                x: e.relX,
                y: e.relY
            }, this.radius);
            if (!this.isOver && e.type !== 'pointerup') this._onPointerEnter();
        }
        const pressure = e.pressure ?? 1;
        const isCoalesced = e.isCoalesced;
        const shiftIsPressed = this.easel.keyListener.isPressed('shift');
        if (shiftIsPressed && !this.firstShiftPos) this.firstShiftPos = {
            x: e.relX,
            y: e.relY
        };
        if (!shiftIsPressed) {
            this.firstShiftPos = undefined;
            this.lineToolDirection = undefined;
        }
        if (e.type === 'pointerdown' && e.button === 'left') {
            this.isDragging = true;
            if (shiftIsPressed) {
                if (this.lastLineEnd) this.onLine(this.lastLineEnd, {
                    x: x,
                    y: y
                });
                return;
            }
            this.onLineStart({
                x: x,
                y: y,
                pressure: pressure,
                isCoalesced: isCoalesced
            });
        }
        if (e.type === 'pointermove' && e.button === 'left') {
            if (shiftIsPressed) {
                if (!this.lineToolDirection) {
                    const dX = Math.abs(e.relX - this.firstShiftPos.x);
                    const dY = Math.abs(e.relY - this.firstShiftPos.y);
                    if (dX > 5 || dY > 5) this.lineToolDirection = dX > dY ? 'x' : 'y';
                }
                if (this.lineToolDirection) {
                    const viewportP = {
                        x: this.lineToolDirection === 'x' ? e.relX : this.firstShiftPos.x,
                        y: this.lineToolDirection === 'y' ? e.relY : this.firstShiftPos.y
                    };
                    const canvasP = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(m), viewportP);
                    this.onLineGo({
                        ...canvasP,
                        pressure: pressure,
                        isCoalesced: isCoalesced
                    });
                }
            } else this.onLineGo({
                x: x,
                y: y,
                pressure: pressure,
                isCoalesced: isCoalesced
            });
        }
        if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
            this.isDragging = false;
            if (e.pointerType === 'touch') // due to delay of double-tap listener, pointerleave fires to early
            this.onPointerLeave();
            this.onLineEnd();
        }
    }
    _onPointerEnter() {
        clearTimeout(this.hideCursorTimeout);
        this.svgEl.setAttribute('opacity', '1');
        this.isOver = true;
    }
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.eventChain.chainIn(e);
    }
    onPointerLeave() {
        clearTimeout(this.hideCursorTimeout);
        this.svgEl.setAttribute('opacity', '0');
        this.isOver = false;
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    onUpdateTransform(transform) {
        this.currentCursor.update(transform, {
            x: this.lastPos.x,
            y: this.lastPos.y
        }, this.radius);
    }
    getIsLocked() {
        return this.isDragging;
    }
    setBrush(p) {
        if (p.radius !== undefined) {
            this.radius = p.radius;
            if (!this.isOver) {
                this.svgEl.setAttribute('opacity', '1');
                clearTimeout(this.hideCursorTimeout);
                this.hideCursorTimeout = setTimeout(()=>{
                    this.svgEl.setAttribute('opacity', '0');
                }, 500);
            }
            const { width: width, height: height } = this.easel.getSize();
            this.currentCursor.update(this.easel.getTransform(), this.isOver ? this.lastPos : {
                x: width / 2,
                y: height / 2
            }, this.radius);
        }
        if (p.pixelTip !== undefined) this.brushCursorPixel.setTip(p.pixelTip);
        if (p.type !== undefined) {
            const newBrushCursor = p.type === 'round' ? this.brushCursorRound : this.brushCursorPixel;
            if (newBrushCursor !== this.currentCursor) {
                this.currentCursor.getElement().remove();
                this.currentCursor = newBrushCursor;
                this.getSvgElement().append(this.currentCursor.getElement());
            }
        }
    }
    setLastDrawEvent(p) {
        this.lastLineEnd = p ? {
            ...p
        } : undefined;
    }
    activate(cursorPos) {
        this.easel.setCursor('crosshair');
        this.isDragging = false;
        if (cursorPos) {
            this.lastPos.x = cursorPos.x;
            this.lastPos.y = cursorPos.y;
            this.currentCursor.update(this.easel.getTransform(), {
                x: cursorPos.x,
                y: cursorPos.y
            }, this.radius);
        } else this.onPointerLeave();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.easel = {};
        this.oldScale = 1;
        this.isDragging = false;
        this.lastPos = {
            x: 0,
            y: 0
        };
        this.isOver = false;
        this.radius = p.radius;
        this.onLineStart = p.onLineStart;
        this.onLineGo = p.onLineGo;
        this.onLineEnd = p.onLineEnd;
        this.onLine = p.onLine;
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.brushCursorRound = new (0, $98ab571189377d55$export$249b9041c848ec46)();
        this.brushCursorPixel = new (0, $664a14254435e004$export$1b678dbb43c691f9)();
        this.currentCursor = this.brushCursorRound;
        this.svgEl.append(this.currentCursor.getElement());
        this.eventChain = new (0, $29dd970aa1f95ac5$export$649a211db9812745)({
            chainArr: [
                new (0, $403644a346975e30$export$fe11e0afe623a677)()
            ]
        });
        this.eventChain.setChainOut((e)=>{
            this.onExplodedPointer(e);
        });
    }
}





class $47fa1687308adf8f$export$abfede0290e9bfba {
    update() {
        const width = this.klCanvas.getWidth();
        const height = this.klCanvas.getHeight();
        const layers = this.klCanvas.getLayers();
        // free resources if no compositing being done
        if (layers.some((layer)=>layer.compositeObj)) {
            if (!this.compositeCanvas) this.compositeCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(width, height);
        } else if (this.compositeCanvas) {
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.compositeCanvas);
            this.compositeCanvas = undefined;
        }
        const compositeCanvas = this.compositeCanvas;
        this.easel.setProject({
            width: width,
            height: height,
            layers: layers.map((layer)=>{
                return {
                    image: layer.compositeObj && compositeCanvas ? ()=>{
                        (0, $419f77660d9ca0bd$export$b40690970a79d0ef)(compositeCanvas, width, height, {
                            ensureCleared: true
                        });
                        const ctx = compositeCanvas.getContext('2d');
                        ctx.drawImage(layer.canvas, 0, 0);
                        layer.compositeObj?.draw((0, $94f0b2b810d4d191$export$b813e062795b89b5)(compositeCanvas.getContext('2d')));
                        return compositeCanvas;
                    } : layer.canvas,
                    isVisible: layer.isVisible,
                    opacity: layer.opacity,
                    mixModeStr: layer.mixModeStr,
                    hasClipping: layer.hasClipping
                };
            }),
            selection: this.klCanvas.getSelection()
        });
    }
    // if you're not rendering easel for a while
    freeCompositeCanvas() {
        if (this.compositeCanvas) {
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.compositeCanvas);
            this.compositeCanvas = undefined;
        }
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.klCanvas = p.klCanvas;
        this.easel = p.easel;
        this.update();
    }
}




var $b8d1085361974a72$exports = {};
$b8d1085361974a72$exports = $parcel$resolve("23yGC");




class $eccddf41322a390c$export$1fda302750a9ba48 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($b8d1085361974a72$exports))) + "') 0 15, crosshair");
        const transform = this.easel.getTransform();
        const m = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(transform);
        const p = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        let color = undefined;
        const isDown = [
            'left',
            'right'
        ].includes(e.button);
        if (isDown) {
            this.svgEl.setAttribute('transform', `translate(${e.relX},${e.relY})`);
            this.svgEl.style.opacity = '1';
        } else this.svgEl.style.opacity = '0';
        if (e.type === 'pointerdown' && isDown) {
            this.isDragging = true;
            color = this.onPick(p);
        }
        if (e.type === 'pointermove' && isDown) color = this.onPick(p);
        if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
            this.isDragging = false;
            this.onPickEnd();
        }
        if (color && isDown) {
            this.previewColor.setAttribute('stroke', (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr(color));
            const borderColor = (0, $be957da3610487e9$export$921068d8846a1559).testIsWhiteBestContrast(color) ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)';
            this.previewBorder.setAttribute('stroke', borderColor);
        }
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($b8d1085361974a72$exports))) + "') 0 15, crosshair");
        this.isDragging = false;
        this.svgEl.style.opacity = '0';
    }
    onPointerLeave() {
        if (this.isDragging) return;
        this.svgEl.style.opacity = '0';
    }
    constructor(p){
        this.easel = {};
        this.isDragging = false;
        // ----------------------------------- public -----------------------------------
        this.tempTriggers = [
            'mouse-right',
            'alt'
        ];
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.onPick = p.onPick;
        this.onPickEnd = p.onPickEnd;
        //color picker preview circle
        this.previewBorder = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'circle',
            r: '47',
            stroke: 'black',
            'stroke-width': '22',
            fill: 'none'
        });
        this.previewColor = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'circle',
            r: '47',
            stroke: 'black',
            'stroke-width': '20',
            fill: 'none'
        });
        this.svgEl.append(this.previewBorder, this.previewColor);
    }
}



var $06b1eba37ffb772a$exports = {};
$06b1eba37ffb772a$exports = $parcel$resolve("2K3uA");




class $15c0e2366e5fdeef$export$9b29623161064b87 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($06b1eba37ffb772a$exports))) + "') 1 12, crosshair");
        const vTransform = this.easel.getTransform();
        const m = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(vTransform);
        const p = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        if (e.type === 'pointerdown' && e.button === 'left') this.onFill({
            x: Math.floor(p.x),
            y: Math.floor(p.y)
        });
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($06b1eba37ffb772a$exports))) + "') 1 12, crosshair");
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.easel = {};
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.onFill = p.onFill;
    }
}




function $547fb7c986fda60e$export$ffc17cb954bc6d52(transform) {
    const angleDeg = transform.isMirrored ? -transform.angleDeg : transform.angleDeg;
    return angleDeg / 180 * Math.PI;
}



class $dec404f7e2a863cb$export$11badb1ec62816a1 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor('crosshair');
        const vTransform = this.easel.getTransform();
        const m = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(vTransform);
        const p = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        if (e.type === 'pointerdown' && e.button === 'left') {
            this.isDragging = true;
            this.onDown(p, (0, $547fb7c986fda60e$export$ffc17cb954bc6d52)(vTransform));
        }
        if (e.type === 'pointermove' && e.button === 'left') this.onMove(p);
        if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
            this.isDragging = false;
            this.onUp(p);
        }
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    getIsLocked() {
        return this.isDragging;
    }
    activate(cursorPos) {
        this.easel.setCursor('crosshair');
        this.isDragging = false;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.easel = {};
        this.isDragging = false;
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.onDown = p.onDown;
        this.onMove = p.onMove;
        this.onUp = p.onUp;
    }
}



var $c7b77d47494e9734$exports = {};
$c7b77d47494e9734$exports = $parcel$resolve("hp9Hj");





class $ec661ae45b234a5a$export$b10c22a3fee9197f {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($c7b77d47494e9734$exports))) + "') 1 12, crosshair");
        const vTransform = this.easel.getTransform();
        const m = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(vTransform);
        const p = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        if (e.type === 'pointerdown' && e.button === 'left') this.onDown(p, (0, $547fb7c986fda60e$export$ffc17cb954bc6d52)(vTransform));
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($c7b77d47494e9734$exports))) + "') 1 12, crosshair");
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.easel = {};
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.onDown = p.onDown;
    }
}






class $b5defa6ba00b208a$export$4deed4c512c630c2 {
    // only call through requestAnimationFrame when animationFrameHandle undefined
    movementLoop() {
        this.animationFrameHandle = undefined;
        if (!this.cornerDirection) {
            this.lastFrameTimestamp = 0;
            return;
        }
        this.animationFrameHandle = requestAnimationFrame(()=>this.movementLoop());
        const now = performance.now();
        const deltaMs = now - this.lastFrameTimestamp;
        const defaultDeltaMs = 1000 / 60;
        const timeFactor = Math.min(deltaMs / defaultDeltaMs, 10);
        this.lastFrameTimestamp = now;
        const transform = this.getTransform();
        transform.x += this.cornerDirection.x * timeFactor;
        transform.y += this.cornerDirection.y * timeFactor;
        this.setTransform(transform);
        this.onRepeatEvent(this.repeatEvent);
    }
    getSpeed(thresholdDelta) {
        return Math.min(thresholdDelta, this.thresholdPx) * 0.4;
    }
    onPointer(event) {
        let isMoving = false;
        this.cornerDirection = {
            x: 0,
            y: 0
        };
        if (this.testCanPan(event.button !== undefined) && event.type === 'pointermove') {
            if (event.relX > this.getEaselSize().width - this.thresholdPx) {
                this.cornerDirection.x -= this.getSpeed(event.relX - (this.getEaselSize().width - this.thresholdPx));
                isMoving = true;
            }
            if (event.relX < this.thresholdPx) {
                this.cornerDirection.x += this.getSpeed(this.thresholdPx - event.relX);
                isMoving = true;
            }
            if (event.relY > this.getEaselSize().height - this.thresholdPx) {
                this.cornerDirection.y -= this.getSpeed(event.relY - (this.getEaselSize().height - this.thresholdPx));
                isMoving = true;
            }
            if (event.relY < this.thresholdPx) {
                this.cornerDirection.y += this.getSpeed(this.thresholdPx - event.relY);
                isMoving = true;
            }
        }
        if (isMoving) {
            if (this.lastFrameTimestamp === 0) this.lastFrameTimestamp = performance.now();
            this.repeatEvent = event;
            this.animationFrameHandle ??= requestAnimationFrame(()=>this.movementLoop());
        } else this.cornerDirection = undefined;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.thresholdPx = 25;
        this.lastFrameTimestamp = 0;
        this.repeatEvent = {};
        this.getEaselSize = p.getEaselSize;
        this.getTransform = p.getTransform;
        this.setTransform = p.setTransform;
        this.testCanPan = p.testCanPan;
        this.onRepeatEvent = p.onRepeatEvent;
    }
}


class $aa7e232d5dcb3944$export$f4821fa73b1145e5 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e, isRepeat) {
        if (this.doPan && !isRepeat) this.cornerPanning.onPointer(e);
        this.easel.setCursor('crosshair');
        const vTransform = this.easel.getTransform();
        const m = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(vTransform);
        const p = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(m), {
            x: e.relX,
            y: e.relY
        });
        if (e.type === 'pointerdown' && e.button === 'left') {
            this.isDragging = true;
            this.onDown(p, (0, $547fb7c986fda60e$export$ffc17cb954bc6d52)(vTransform));
        }
        if (e.type === 'pointermove' && e.button === 'left') this.onMove(p);
        if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
            this.isDragging = false;
            this.onUp(p);
        }
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    getIsLocked() {
        return this.isDragging;
    }
    activate(cursorPos) {
        this.easel.setCursor('crosshair');
        this.isDragging = false;
    }
    setPanning(doPan) {
        this.doPan = doPan;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.easel = {};
        this.isDragging = false;
        this.doPan = false;
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.onDown = p.onDown;
        this.onMove = p.onMove;
        this.onUp = p.onUp;
        this.cornerPanning = new (0, $b5defa6ba00b208a$export$4deed4c512c630c2)({
            getEaselSize: ()=>this.easel.getSize(),
            getTransform: ()=>this.easel.getTargetTransform(),
            setTransform: (transform)=>this.easel.setTransform(transform, true),
            testCanPan: (buttonIsPressed)=>{
                return buttonIsPressed;
            },
            onRepeatEvent: (e)=>{
                this.onPointer(e, true);
            }
        });
    }
}








class $48668e17d9112bf7$export$f3b0846760df78b {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor(e.button === 'left' ? 'grabbing' : 'grab');
        if (e.type === 'pointerdown' && e.button === 'left') {
            this.downPos = {
                x: e.relX,
                y: e.relY
            };
            this.downTransform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.easel.getTargetTransform());
        } else if (e.button === 'left' && this.downPos && this.downTransform) {
            const { width: width, height: height } = this.easel.getSize();
            const centerObj = {
                x: width / 2,
                y: height / 2
            };
            const startAngleRad = (0, $be957da3610487e9$export$921068d8846a1559).Vec2.angle(centerObj, this.downPos);
            const newAngleRad = (0, $be957da3610487e9$export$921068d8846a1559).Vec2.angle(centerObj, {
                x: e.relX,
                y: e.relY
            });
            const dAngleDeg = (newAngleRad - startAngleRad) / Math.PI * 180;
            let newAngleDeg = this.downTransform.angleDeg + dAngleDeg;
            if (this.easel.isKeyPressed('shift')) newAngleDeg = Math.round(newAngleDeg / 45) * 45;
            newAngleDeg = (0, $4c2c6808296c0d73$export$ec85425cac357ca9)(newAngleDeg);
            //rotate transform
            const mat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.downTransform);
            const canvasPoint = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(mat), centerObj);
            this.easel.setTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)(centerObj, canvasPoint, this.downTransform.scale, newAngleDeg, this.downTransform.isMirrored), !this.easel.isKeyPressed('shift'));
            this.easel.requestRender();
        } else if (e.type === 'pointerup' && this.downPos) {
            this.downPos = undefined;
            this.downTransform = undefined;
        }
    }
    onUpdateTransform(transform) {
        const targetTransform = this.easel.getTargetTransform();
        this.needleWrapper.setAttribute('transform', 'rotate(' + transform.angleDeg + ')');
        this.compassLineCircle.style.opacity = targetTransform.angleDeg % 90 === 0 ? '1' : '0';
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor('grab');
        const { width: width, height: height } = this.easel.getSize();
        this.compass.setAttribute('transform', 'translate(' + width / 2 + ', ' + height / 2 + ')');
        this.onUpdateTransform(this.easel.getTransform());
    }
    onKeyDown(keyStr, event, comboStr) {
        if ([
            'r+left',
            'r+right'
        ].includes(comboStr)) {
            if (keyStr === 'left') this.easel.setAngleDeg(-15, true);
            if (keyStr === 'right') this.easel.setAngleDeg(15, true);
        }
        if ([
            'r+up'
        ].includes(comboStr)) this.easel.setAngleDeg(0, false);
    }
    onResize(width, height) {
        this.compass.setAttribute('transform', 'translate(' + width / 2 + ', ' + height / 2 + ')');
    }
    constructor(p){
        this.easel = {};
        this.downPos = undefined;
        // ----------------------------------- public -----------------------------------
        this.tempTriggers = [
            'r'
        ];
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        //rotation compass
        this.compassSize = 30;
        this.compass = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.compass, {
            transition: 'opacity 0.25s ease-in-out'
        });
        this.compassInner = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.compassBaseCircle = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'circle',
            fill: 'rgba(0,0,0,0.9)',
            stroke: 'none',
            cx: '0',
            cy: '0',
            r: '' + this.compassSize
        });
        this.compassLineCircle = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'circle',
            fill: 'none',
            stroke: 'rgba(255,255,255,0.75)',
            'stroke-width': '1',
            cx: '0',
            cy: '0',
            r: '' + this.compassSize * 0.9
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.compassLineCircle, {
            transition: 'opacity 0.1s ease-in-out'
        });
        this.needleWrapper = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g',
            'transform-origin': '0 0'
        });
        this.compassUpperTriangle = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'path',
            fill: '#f00',
            stroke: 'none',
            d: 'M -' + this.compassSize * 0.25 + ',0 ' + this.compassSize * 0.25 + ',0 0,-' + this.compassSize * 0.9 + ' z'
        });
        this.compassLowerTriangle = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'path',
            fill: '#fff',
            stroke: 'none',
            d: 'M -' + this.compassSize * 0.25 + ',0 ' + this.compassSize * 0.25 + ',0 0,' + this.compassSize * 0.9 + ' z'
        });
        this.needleWrapper.append(this.compassUpperTriangle, this.compassLowerTriangle);
        this.compassInner.append(this.compassBaseCircle, this.compassLineCircle, this.needleWrapper);
        this.compass.append(this.compassInner);
        this.svgEl.append(this.compass);
    }
}



var $3df13245383fd6d2$exports = {};
$3df13245383fd6d2$exports = $parcel$resolve("3DJrH");





class $b2bad4693d9c09c9$export$6c389c8425707374 {
    getSvgElement() {
        return this.svgEl;
    }
    onPointer(e) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($3df13245383fd6d2$exports))) + "') 7 7, zoom-in");
        if (e.type === 'pointerdown' && [
            'left'
        ].includes(e.button)) {
            this.downPos = {
                x: e.relX,
                y: e.relY
            };
            this.downTransform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.easel.getTransform());
        }
        if (e.type === 'pointermove' && [
            'left'
        ].includes(e.button) && this.downPos && this.downTransform) {
            const viewportPoint = this.downPos;
            const mat = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.downTransform);
            const canvasPoint = (0, $43e83319b765a157$export$9b20165a36586806)((0, $fd04355d00b81239$export$70ae2c07e401031b)(mat), viewportPoint);
            const dX = e.relX - this.downPos.x;
            const newScale = (0, $be957da3610487e9$export$921068d8846a1559).clamp(this.downTransform.scale * (1 + 1 / 400) ** dX, this.easel.minScale, this.easel.maxScale);
            this.easel.setTransform((0, $cdf37dcca656673a$export$99c68a89351e15c0)(viewportPoint, canvasPoint, newScale, this.downTransform.angleDeg, this.downTransform.isMirrored), true);
            this.easel.requestRender();
        }
        if (e.type === 'pointerup' && e.button === undefined) {
            this.downPos = undefined;
            this.downTransform = undefined;
        }
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
    }
    activate(cursorPos) {
        this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($3df13245383fd6d2$exports))) + "') 7 7, zoom-in");
    }
    constructor(p){
        this.easel = {};
        this.downPos = undefined;
        // ----------------------------------- public -----------------------------------
        this.tempTriggers = [
            'z'
        ];
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
    }
}











class $9a4caa1ec0cbd978$export$f04a61298a47a40f {
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: p.darkInvert ? 'dark-invert' : '',
            css: {
                backgroundImage: `url("${p.imageUrl}")`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: p.width,
                height: p.height,
                ...p.css
            }
        });
    }
}



var $79I2S = parcelRequire("79I2S");

function $50ebb6fbce8e845b$export$b9cf8e4fed0549e8() {
    let webgl2IsSupported = false;
    const canvas = (0, $79I2S.createCanvas)();
    try {
        const gl = canvas.getContext('webgl2');
        webgl2IsSupported = gl !== null;
    } catch (_) {
    // noop
    }
    (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(canvas);
    return webgl2IsSupported;
}
class $50ebb6fbce8e845b$export$382d1cdfd2c9e133 {
    compileShader(source, type) {
        const shader = this.gl.createShader(type);
        if (!shader) return null;
        this.gl.shaderSource(shader, source);
        this.gl.compileShader(shader);
        if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) {
            console.error('Shader compile error:', this.gl.getShaderInfoLog(shader));
            this.gl.deleteShader(shader);
            return null;
        }
        return shader;
    }
    createProgram() {
        const vertexShaderSource = `#version 300 es
            in vec2 a_position;
            in vec2 a_texCoord;
            out vec2 v_texCoord;
            void main() {
                gl_Position = vec4(a_position, 0.0, 1.0);
                v_texCoord = a_texCoord;
            }
        `;
        const fragmentShaderSource = `#version 300 es
            precision mediump float;
            in vec2 v_texCoord;
            out vec4 outColor;
            uniform sampler2D u_texture;
            void main() {
                outColor = texture(u_texture, v_texCoord);
            }
        `;
        const vertexShader = this.compileShader(vertexShaderSource, this.gl.VERTEX_SHADER);
        if (!vertexShader) throw new Error('Failed to compile vertex shader');
        const fragmentShader = this.compileShader(fragmentShaderSource, this.gl.FRAGMENT_SHADER);
        if (!fragmentShader) throw new Error('Failed to compile fragment shader');
        this.program = this.gl.createProgram();
        this.gl.attachShader(this.program, vertexShader);
        this.gl.attachShader(this.program, fragmentShader);
        this.gl.linkProgram(this.program);
        if (!this.gl.getProgramParameter(this.program, this.gl.LINK_STATUS)) {
            console.error('Program link error:', this.gl.getProgramInfoLog(this.program));
            throw new Error('Failed to link program');
        }
        this.gl.deleteShader(vertexShader);
        this.gl.deleteShader(fragmentShader);
        this.gl.useProgram(this.program);
        this.positionLocation = this.gl.getAttribLocation(this.program, 'a_position');
        this.texCoordLocation = this.gl.getAttribLocation(this.program, 'a_texCoord');
        this.textureLocation = this.gl.getUniformLocation(this.program, 'u_texture');
        this.gl.useProgram(null);
    }
    createMultisampleFramebuffer() {
        const gl = this.gl;
        const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
        this.msaaSamples = Math.min(maxSamples, 8);
        this.multisampleRenderbuffer = gl.createRenderbuffer();
        gl.bindRenderbuffer(gl.RENDERBUFFER, this.multisampleRenderbuffer);
        gl.renderbufferStorageMultisample(gl.RENDERBUFFER, this.msaaSamples, gl.RGBA8, this.canvas.width, this.canvas.height);
        this.multisampleFramebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.multisampleFramebuffer);
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, this.multisampleRenderbuffer);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindRenderbuffer(gl.RENDERBUFFER, null);
    }
    detectAnisotropicFiltering() {
        // Check for anisotropic filtering extension
        this.anisotropicExtension = this.gl.getExtension('EXT_texture_filter_anisotropic') || this.gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || this.gl.getExtension('MOZ_EXT_texture_filter_anisotropic');
        if (this.anisotropicExtension) this.maxAnisotropy = this.gl.getParameter(this.anisotropicExtension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    }
    /**
     * Creates a mesh (vertex array object)
     * @param positions - x,y positions in clip space top-left: (-1,1), bottom-right: (1,-1)
     * @param texCoords - u,v texture coordinates top-left: (0,0), bottom-right: (1,1)
     * @param indices - indices specifying triangles
     */ createMesh(positions, texCoords, indices) {
        const vao = this.gl.createVertexArray();
        this.gl.bindVertexArray(vao);
        const positionBuffer = this.gl.createBuffer();
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, positionBuffer);
        this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array(positions), this.gl.STATIC_DRAW);
        this.gl.enableVertexAttribArray(this.positionLocation);
        this.gl.vertexAttribPointer(this.positionLocation, 2, this.gl.FLOAT, false, 0, 0);
        const texCoordBuffer = this.gl.createBuffer();
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, texCoordBuffer);
        this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array(texCoords), this.gl.STATIC_DRAW);
        this.gl.enableVertexAttribArray(this.texCoordLocation);
        this.gl.vertexAttribPointer(this.texCoordLocation, 2, this.gl.FLOAT, false, 0, 0);
        const indexBuffer = this.gl.createBuffer();
        this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
        this.gl.bufferData(this.gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), this.gl.STATIC_DRAW);
        const id = this.nextMeshId++;
        this.meshes.set(id, {
            id: id,
            vao: vao,
            positionBuffer: positionBuffer,
            texCoordBuffer: texCoordBuffer,
            indexBuffer: indexBuffer,
            indexCount: indices.length
        });
        return {
            id: id,
            destroy: ()=>this.destroyMesh(id)
        };
    }
    destroyMesh(id) {
        const mesh = this.meshes.get(id);
        if (mesh) {
            this.gl.deleteVertexArray(mesh.vao);
            this.gl.deleteBuffer(mesh.positionBuffer);
            this.gl.deleteBuffer(mesh.texCoordBuffer);
            this.gl.deleteBuffer(mesh.indexBuffer);
            this.meshes.delete(id);
        }
    }
    createTexture(source) {
        const texture = this.gl.createTexture();
        this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
        if (source instanceof HTMLImageElement || source instanceof HTMLCanvasElement) this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA8, this.gl.RGBA, this.gl.UNSIGNED_BYTE, source);
        else this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA8, source.width, source.height, 0, this.gl.RGBA, this.gl.UNSIGNED_BYTE, source.data);
        // texture filtering
        if (this.interpolation === 'pixelated') {
            this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.NEAREST);
            this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.NEAREST);
        } else {
            this.gl.generateMipmap(this.gl.TEXTURE_2D);
            this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR_MIPMAP_LINEAR);
            this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);
            if (this.anisotropicExtension) this.gl.texParameterf(this.gl.TEXTURE_2D, this.anisotropicExtension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(this.maxAnisotropy, 8));
        }
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
        const id = this.nextTextureId++;
        this.textures.set(id, {
            id: id,
            texture: texture
        });
        return {
            id: id,
            destroy: ()=>this.destroyTexture(id)
        };
    }
    destroyTexture(id) {
        const texture = this.textures.get(id);
        if (texture) {
            this.gl.deleteTexture(texture.texture);
            this.textures.delete(id);
        }
    }
    clear() {
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.multisampleFramebuffer ?? null);
        this.gl.clearColor(0, 0, 0, 0);
        this.gl.clear(this.gl.COLOR_BUFFER_BIT);
    }
    draw(mesh, texture) {
        const meshData = this.meshes.get(mesh.id);
        const textureData = this.textures.get(texture.id);
        if (!meshData || !textureData) throw new Error('Invalid mesh or texture');
        // null -> directly onto the canvas
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.multisampleFramebuffer ?? null);
        this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
        this.gl.useProgram(this.program);
        this.gl.bindVertexArray(meshData.vao);
        this.gl.activeTexture(this.gl.TEXTURE0);
        this.gl.bindTexture(this.gl.TEXTURE_2D, textureData.texture);
        this.gl.uniform1i(this.textureLocation, 0);
        this.gl.drawElements(this.gl.TRIANGLES, meshData.indexCount, this.gl.UNSIGNED_SHORT, 0);
    }
    present() {
        if (!this.multisampleFramebuffer) // pixelated: already drew directly to canvas
        return;
        // Resolve the multisample FBO to the canvas by blitting.
        const gl = this.gl;
        const w = this.canvas.width;
        const h = this.canvas.height;
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.multisampleFramebuffer);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null); // canvas
        gl.blitFramebuffer(0, 0, w, h, 0, 0, w, h, gl.COLOR_BUFFER_BIT, gl.NEAREST);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    }
    getCanvas() {
        return this.canvas;
    }
    isContextLost() {
        // Yes, every browser supports this for WebGL2RenderingContext.
        return this.gl.isContextLost();
    }
    destroy() {
        for (const [id] of this.meshes)this.destroyMesh(id);
        for (const [id] of this.textures)this.destroyTexture(id);
        if (this.multisampleFramebuffer) {
            this.gl.deleteFramebuffer(this.multisampleFramebuffer);
            this.multisampleFramebuffer = null;
        }
        if (this.multisampleRenderbuffer) {
            this.gl.deleteRenderbuffer(this.multisampleRenderbuffer);
            this.multisampleRenderbuffer = null;
        }
        if (this.program) this.gl.deleteProgram(this.program);
        (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.canvas);
    }
    // ----------------------------------- public -----------------------------------
    constructor(canvas, interpolation = 'smooth'){
        this.program = null;
        this.positionLocation = -1;
        this.texCoordLocation = -1;
        this.textureLocation = null;
        this.meshes = new Map();
        this.textures = new Map();
        this.nextMeshId = 1;
        this.nextTextureId = 1;
        this.anisotropicExtension = null;
        this.maxAnisotropy = 1;
        this.multisampleFramebuffer = null;
        this.multisampleRenderbuffer = null;
        this.msaaSamples = 0;
        this.canvas = canvas;
        this.interpolation = interpolation;
        const gl = canvas.getContext('webgl2', {
            alpha: true,
            // All textures and framebuffers have premultiplied alpha
            premultipliedAlpha: true,
            // we manually handle MSAA via a framebuffer
            antialias: false
        });
        if (!gl) throw new Error('WebGL2 not supported');
        // init
        this.gl = gl;
        this.createProgram();
        if (this.interpolation === 'smooth') {
            this.detectAnisotropicFiltering();
            this.createMultisampleFramebuffer();
        }
        // we always want textures with premultiplied alpha
        this.gl.pixelStorei(this.gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        // we always want blending
        this.gl.enable(this.gl.BLEND);
        this.gl.blendFunc(this.gl.ONE, this.gl.ONE_MINUS_SRC_ALPHA);
    }
}



const $27738b416db1ff7a$var$modeSelectImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('select-mode-select');
const $27738b416db1ff7a$var$modeMoveImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('select-mode-move');
const $27738b416db1ff7a$var$duplicateLayerImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('duplicate-layer');
const $27738b416db1ff7a$var$warpImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('select-transform-warp');
class $27738b416db1ff7a$export$b3e6ed306341f794 {
    update() {
        this.selectResetBtn.style.display = this.hasSelection ? 'block' : 'none';
    }
    setIsVisible(isVisible) {
        this.isVisible = isVisible;
        this.rootEl.style.display = this.isVisible ? 'block' : 'none';
        if (this.isVisible) this.operationOptions.setValue('new');
    }
    setMode(mode) {
        this.modeOptions.setValue(mode);
    }
    setLayers(layers) {
        this.moveToLayerSelect.setOptionArr(layers.map((layer, index)=>{
            return [
                '' + index,
                layer
            ];
        }).reverse());
    }
    setMoveToLayer(targetIndex) {
        this.moveToLayerSelect.setValue(targetIndex === undefined ? undefined : '' + targetIndex);
    }
    setHasSelection(b) {
        this.hasSelection = b;
        this.update();
    }
    setBackgroundIsTransparent(b) {
        this.transparentBackgroundToggle.setValue(b);
    }
    setAlgorithm(algorithm) {
        this.algorithmOptions.setValue(algorithm);
    }
    setFreeTransformTransformation(transform) {
        const x = (0, $be957da3610487e9$export$921068d8846a1559).round(transform.x, 0);
        const y = (0, $be957da3610487e9$export$921068d8846a1559).round(transform.y, 0);
        const rotation = (0, $be957da3610487e9$export$921068d8846a1559).round(transform.angleDeg, 0);
        this.positionOutput.innerText = `X:${x} Y:${y} ${(0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-rotation')}:${rotation}\xb0`;
    }
    setShowTransparentBackgroundToggle(show) {
        this.transparentBackgroundToggle.getElement().style.display = show ? 'block' : 'none';
    }
    setIsWarping(isWarping) {
        this.warpCheckbox.setValue(isWarping);
        this.constrainCheckbox.setEnabled(!isWarping);
        this.snappingCheckbox.setEnabled(!isWarping);
    }
    getIsWarping() {
        return this.warpCheckbox.getValue();
    }
    getAlgorithm() {
        return this.algorithmOptions.getValue();
    }
    getElement() {
        return this.rootEl;
    }
    destroy() {
        this.algorithmOptions.destroy();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.isVisible = true;
        this.hasSelection = false;
        this.onChangeMode = p.onChangeMode;
        this.modeOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'select',
                    label: (0, $8405ecc79d32770a$export$db3b6bfb95261072)('', [
                        (0, $8405ecc79d32770a$export$db3b6bfb95261072)({
                            content: "<img class='dark-invert' src='" + $27738b416db1ff7a$var$modeSelectImg + "' height='20'/>" + '<span>' + (0, $fc42a07754814920$export$ce37e184d908d785)('select-select') + '</span>',
                            css: {
                                display: 'flex',
                                gap: 5,
                                alignItems: 'center',
                                height: '100%',
                                margin: '10px 4px',
                                justifyContent: 'center'
                            }
                        })
                    ])
                },
                {
                    id: 'transform',
                    label: (0, $8405ecc79d32770a$export$db3b6bfb95261072)('', [
                        (0, $8405ecc79d32770a$export$db3b6bfb95261072)({
                            content: "<img class='dark-invert' src='" + $27738b416db1ff7a$var$modeMoveImg + "' height='20'/>" + '<span>' + (0, $fc42a07754814920$export$ce37e184d908d785)('select-transform') + '</span>',
                            css: {
                                display: 'flex',
                                gap: 5,
                                alignItems: 'center',
                                height: '100%',
                                margin: '10px 4px',
                                justifyContent: 'center'
                            }
                        })
                    ])
                }
            ],
            initId: 'select',
            onChange: (val)=>{
                if (val === 'select') this.operationOptions.setValue('new');
                updateMode();
            },
            onBeforeChange: (val)=>{
                // change to "transform" can be rejected if selection is empty
                return this.onChangeMode(val);
            },
            optionCss: {
                flexGrow: 1,
                flexBasis: 0
            },
            css: {
                marginBottom: 10
            }
        });
        // --- select ---
        const selectModeEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const selectOptionImageStyle = {
            width: 32,
            height: 32
        };
        const defaultIm = (0, $1b4b6b9aff0ae5e5$export$dd7d56122b36f42e)('select-default', selectOptionImageStyle);
        defaultIm.classList.add('dark-invert');
        const unionIm = (0, $1b4b6b9aff0ae5e5$export$dd7d56122b36f42e)('select-union', selectOptionImageStyle);
        unionIm.classList.add('dark-invert');
        const subtractIm = (0, $1b4b6b9aff0ae5e5$export$dd7d56122b36f42e)('select-subtract', selectOptionImageStyle);
        subtractIm.classList.add('dark-invert');
        this.operationOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'new',
                    label: defaultIm,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('select-boolean-replace')
                },
                {
                    id: 'union',
                    label: unionIm,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('select-boolean-add')
                },
                {
                    id: 'difference',
                    label: subtractIm,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('select-boolean-subtract')
                }
            ],
            initId: 'new',
            onChange: (v)=>{
                p.onChangeBooleanOperation(v);
            },
            css: {
                marginBottom: 10
            }
        });
        const rectIm = (0, $1b4b6b9aff0ae5e5$export$dd7d56122b36f42e)('select-shape-rect', selectOptionImageStyle);
        rectIm.classList.add('dark-invert');
        const ellipseIm = (0, $1b4b6b9aff0ae5e5$export$dd7d56122b36f42e)('select-shape-ellipse', selectOptionImageStyle);
        ellipseIm.classList.add('dark-invert');
        const lassoIm = (0, $1b4b6b9aff0ae5e5$export$dd7d56122b36f42e)('select-shape-lasso', selectOptionImageStyle);
        lassoIm.classList.add('dark-invert');
        const polyIm = (0, $1b4b6b9aff0ae5e5$export$dd7d56122b36f42e)('select-shape-poly', selectOptionImageStyle);
        polyIm.classList.add('dark-invert');
        const shapeOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'rect',
                    label: rectIm,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-rect')
                },
                {
                    id: 'ellipse',
                    label: ellipseIm,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('shape-ellipse')
                },
                {
                    id: 'lasso',
                    label: lassoIm,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('select-lasso')
                },
                {
                    id: 'poly',
                    label: polyIm,
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('select-polygon')
                }
            ],
            initId: p.select.shape,
            onChange: (val)=>{
                p.select.onChangeShape(val);
            },
            css: {
                marginBottom: 10
            }
        });
        selectModeEl.append(shapeOptions.getElement(), this.operationOptions.getElement());
        const actionRow = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: selectModeEl,
            css: {
                display: 'flex',
                gap: 5,
                flexWrap: 'wrap'
            }
        });
        const selectAllBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: actionRow,
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('select-all'),
            onClick: ()=>p.select.onAll(),
            props: {
                tabIndex: -1
            },
            css: {
                minHeight: 30
            }
        });
        const selectInvertBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: actionRow,
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('select-invert'),
            onClick: ()=>p.select.onInvert(),
            props: {
                tabIndex: -1
            },
            css: {
                minHeight: 30
            }
        });
        this.selectResetBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: actionRow,
            tagName: 'button',
            content: [
                (0, $1b4b6b9aff0ae5e5$export$1838b56fa99d7234)('remove-layer', {
                    height: 20,
                    marginRight: 3
                }),
                (0, $fc42a07754814920$export$ce37e184d908d785)('select-reset')
            ],
            className: 'kl-button kl-button-primary',
            css: {
                paddingRight: 8,
                display: 'none'
            },
            onClick: ()=>p.select.onReset(),
            props: {
                tabIndex: -1
            }
        });
        (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'grid-hr',
            parent: selectModeEl,
            css: {
                margin: '10px 0'
            }
        });
        const actionsWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: selectModeEl,
            css: {
                display: 'flex',
                gap: 5
            }
        });
        const eraseBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: actionsWrapper,
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('select-erase'),
            onClick: ()=>p.onErase(),
            props: {
                tabIndex: -1
            }
        });
        const fillBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: actionsWrapper,
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('select-fill'),
            onClick: ()=>p.onFill(),
            props: {
                tabIndex: -1
            }
        });
        // --- transform ---
        const transformModeEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                flexDirection: 'column',
                gap: 10
            }
        });
        this.positionOutput = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                fontFamily: 'monospace',
                fontSize: 13
            }
        });
        transformModeEl.append(this.positionOutput);
        const transformFlipXBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-flip') + ' X',
            className: 'kl-button',
            onClick: ()=>p.transform.onFlipX(),
            props: {
                tabIndex: -1
            }
        });
        const transformFlipYBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-flip') + ' Y',
            onClick: ()=>p.transform.onFlipY(),
            props: {
                tabIndex: -1
            }
        });
        const rotateNegativeBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: "-90\xb0",
            onClick: ()=>p.transform.onRotateDeg(-90),
            props: {
                tabIndex: -1
            }
        });
        const rotatePositiveBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: "+90\xb0",
            onClick: ()=>p.transform.onRotateDeg(90),
            props: {
                tabIndex: -1
            }
        });
        const duplicateIcon = new (0, $9a4caa1ec0cbd978$export$f04a61298a47a40f)({
            imageUrl: $27738b416db1ff7a$var$duplicateLayerImg,
            width: 20,
            height: 20,
            darkInvert: true
        });
        const transformDuplicateBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: [
                duplicateIcon.getElement(),
                (0, $fc42a07754814920$export$ce37e184d908d785)('select-transform-clone')
            ],
            onClick: ()=>p.transform.onClone(),
            css: {
                display: 'flex',
                gap: 5
            },
            props: {
                tabIndex: -1
            }
        });
        const scaleDoubleBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: '2&times;',
            onClick: ()=>p.transform.onScale(2),
            props: {
                tabIndex: -1
            }
        });
        const scaleHalfBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: '&frac12;&times;',
            onClick: ()=>p.transform.onScale(0.5),
            props: {
                tabIndex: -1
            }
        });
        const centerBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('center'),
            onClick: ()=>p.transform.onCenter(),
            props: {
                tabIndex: -1
            }
        });
        (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: transformModeEl,
            content: [
                transformDuplicateBtn,
                transformFlipXBtn,
                transformFlipYBtn,
                rotateNegativeBtn,
                rotatePositiveBtn,
                scaleDoubleBtn,
                scaleHalfBtn,
                centerBtn
            ],
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: 5
            }
        });
        this.constrainCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-constrain'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('constrain-proportions'),
            callback: function(b) {
                p.transform.onChangeConstrain(b);
            },
            css: {
                display: 'inline-block'
            },
            name: 'constrain-proportions'
        });
        this.snappingCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-snap'),
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('filter-transform-snap-title'),
            callback: function(b) {
                p.transform.onChangeSnapping(b);
            },
            css: {
                display: 'inline-block',
                marginLeft: 10
            },
            name: 'enable-snapping'
        });
        this.warpCheckbox = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            init: false,
            isEnabled: (0, $50ebb6fbce8e845b$export$b9cf8e4fed0549e8)(),
            label: `<img src="${$27738b416db1ff7a$var$warpImg}" class="dark-invert" height="23">` + (0, $fc42a07754814920$export$ce37e184d908d785)('select-transform-warp'),
            callback: (b)=>{
                p.transform.onChangeWarp(b);
                // Disable constrain and snapping checkboxes when warping
                this.constrainCheckbox.setEnabled(!b);
                this.snappingCheckbox.setEnabled(!b);
            },
            css: {
                width: 'fit-content'
            },
            name: 'transform-warp'
        });
        transformModeEl.append(this.warpCheckbox.getElement());
        const checkboxWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el();
        checkboxWrapper.append(this.constrainCheckbox.getElement(), this.snappingCheckbox.getElement());
        transformModeEl.append(checkboxWrapper);
        this.algorithmOptions = new (0, $451c2c6773f98d8b$export$6152f1e421c68434)({
            onChange: (algorithm)=>{
                p.transform.onChangeAlgorithm(algorithm);
            }
        });
        transformModeEl.append(this.algorithmOptions.getElement());
        this.moveToLayerSelect = new (0, $ba1c791155c758a7$export$388c3f18f9e173f3)({
            optionArr: [
                [
                    '1',
                    'Layer 2'
                ],
                [
                    '0',
                    'Layer 1'
                ]
            ],
            onChange: (val)=>{
                p.transform.onMoveToLayer(+val);
            },
            name: 'move-to-layer',
            css: {
                width: '100%'
            }
        });
        transformModeEl.append((0, $8405ecc79d32770a$export$db3b6bfb95261072)(',flex,items-center,gap-5,flexWrap', [
            (0, $fc42a07754814920$export$ce37e184d908d785)('select-transform-move-to-layer'),
            this.moveToLayerSelect.getElement()
        ]));
        this.transparentBackgroundToggle = new (0, $be3050d362858227$export$48513f6b9f8ce62d)({
            label: (0, $fc42a07754814920$export$ce37e184d908d785)('brush-eraser-transparent-bg'),
            callback: (b)=>{
                p.transform.onChangeTransparentBackground(b);
            },
            name: 'enable-transparent-background'
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.transparentBackgroundToggle.getElement(), {
            display: 'inline-block'
        });
        transformModeEl.append(this.transparentBackgroundToggle.getElement());
        const updateMode = ()=>{
            if (this.modeOptions.getValue() === 'select') {
                this.rootEl.append(selectModeEl);
                transformModeEl.remove();
            } else {
                selectModeEl.remove();
                this.rootEl.append(transformModeEl);
            }
        };
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: [
                this.modeOptions.getElement()
            ],
            css: {
                margin: '10px 10px 0'
            }
        });
        updateMode();
    }
}







function $197f445a4ae1d495$export$eca13ebc72c99beb(rect, viewportTransform, easelSize, padding = 0) {
    const rectCenterX = rect.x + rect.width / 2;
    const rectCenterY = rect.y + rect.height / 2;
    // compute AABB of the rotated rect in viewport space
    const angleRad = viewportTransform.angleDeg / 180 * Math.PI;
    const cos = Math.abs(Math.cos(angleRad));
    const sin = Math.abs(Math.sin(angleRad));
    const aabbWidth = (rect.width * cos + rect.height * sin) * viewportTransform.scale;
    const aabbHeight = (rect.width * sin + rect.height * cos) * viewportTransform.scale;
    const matrix = (0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(viewportTransform);
    const centerInViewport = (0, $43e83319b765a157$export$9b20165a36586806)(matrix, {
        x: rectCenterX,
        y: rectCenterY
    });
    const halfW = aabbWidth / 2;
    const halfH = aabbHeight / 2;
    return centerInViewport.x - halfW >= padding && centerInViewport.x + halfW <= easelSize.width - padding && centerInViewport.y - halfH >= padding && centerInViewport.y + halfH <= easelSize.height - padding;
}










const $05cb3bfcad3beff7$var$FFD_DEBUG = false;
const $05cb3bfcad3beff7$var$operationToCursor = {
    new: 'default',
    union: 'copy',
    difference: 'alias'
};
class $05cb3bfcad3beff7$export$24961ed376c522a3 {
    viewportToCanvas(p) {
        const matrix = (0, $fd04355d00b81239$export$70ae2c07e401031b)((0, $e1e2f7367ca96a19$export$ad1d215dd03fe75a)(this.easel.getTransform()));
        return (0, $43e83319b765a157$export$9b20165a36586806)(matrix, p);
    }
    updateSelectionPath() {
        this.selectionPath = (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(this.canvasSelection);
    }
    resetPolyShape() {
        if (this.polyShape.length === 0) return false;
        this.polyShape = [];
        this.doubleTapPointerTypes = [
            'touch'
        ];
        this.easel.updateDoubleTapPointerTypes();
        this.easel.requestRender(); // because polyShape might have changed
        return true;
    }
    // boolean operation if you also consider keys
    getEffectiveBooleanOperation() {
        const isSubtract = this.defaultBooleanOperation === 'new' ? this.easel.keyListener.isPressed('alt') : this.defaultBooleanOperation === 'difference';
        const isAdd = this.defaultBooleanOperation === 'new' ? this.easel.keyListener.isPressed('shift') : this.defaultBooleanOperation === 'union';
        if (isSubtract) return 'difference';
        if (isAdd) return 'union';
        return 'new';
    }
    getDoMoveSelection(effectiveOperation, cursorCanvasPos) {
        const isOverSelection = this.polyShape.length < 2 && this.selectionPath && this.tempCtx.isPointInPath(this.selectionPath, cursorCanvasPos.x, cursorCanvasPos.y);
        return effectiveOperation === 'new' && isOverSelection;
    }
    // can be repeatedly called with the same event
    selectOnPointer(event) {
        const effectiveOperation = this.getEffectiveBooleanOperation();
        const wasDragging = this.isDragging;
        const cursorCanvasPos = this.viewportToCanvas({
            x: event.relX,
            y: event.relY
        });
        const doMove = this.getDoMoveSelection(effectiveOperation, cursorCanvasPos);
        if (event.type === 'pointerdown') {
            this.isDragging = true;
            if (doMove) this.selectSelectMode = 'move';
            else this.selectSelectMode = 'select';
        }
        if (event.type === 'pointerup') this.isDragging = false;
        if (this.selectSelectMode === 'move') {
            if (event.type === 'pointerdown' && event.button === 'left') {
                this.didSelectionMove = false;
                this.onStartMoveSelect(cursorCanvasPos);
            }
            if (event.type === 'pointermove' && event.button === 'left') {
                this.didSelectionMove = true;
                this.onGoMoveSelect(cursorCanvasPos, this.easel.keyListener.isPressed('shift'));
            }
            if (event.type === 'pointerup') {
                this.onEndMoveSelect();
                if (!this.didSelectionMove) this.onResetSelection();
            }
        } else // select
        if (this.selectShape === 'poly') {
            if (event.type === 'pointermove') {
                if (this.polyShape.at(-1)?.temp) this.polyShape.pop();
                this.polyShape.push({
                    ...cursorCanvasPos,
                    temp: true
                });
                this.easel.requestRender();
            }
            if (event.type === 'pointerup' && wasDragging) {
                if (this.polyShape.length < 2) this.appliedBooleanOperation = effectiveOperation;
                this.doubleTapPointerTypes = [];
                this.easel.updateDoubleTapPointerTypes();
                if (this.polyShape.at(-1)?.temp) this.polyShape.pop();
                const lastPolyShapePoint = this.polyShape.at(-1);
                if (!lastPolyShapePoint || cursorCanvasPos.x !== lastPolyShapePoint.x || cursorCanvasPos.y !== lastPolyShapePoint.y) {
                    this.polyShape.push(cursorCanvasPos);
                    this.easel.requestRender();
                }
                const first = this.polyShape[0];
                const last = this.polyShape.at(-1);
                if (this.polyShape.length > 2 && (0, $be957da3610487e9$export$921068d8846a1559).dist(first.x, first.y, last.x, last.y) * this.viewportTransform.scale < 4) {
                    this.polyShape.pop();
                    this.polyShape.push({
                        ...this.polyShape[0]
                    });
                    const shape = this.polyShape;
                    this.resetPolyShape();
                    this.onSelectAddPoly(shape, this.appliedBooleanOperation);
                    this.appliedBooleanOperation = undefined;
                }
            }
        } else {
            if (event.type === 'pointerdown' && event.button === 'left') {
                this.appliedBooleanOperation = effectiveOperation;
                this.onStartSelect(cursorCanvasPos, this.appliedBooleanOperation);
            }
            if (event.type === 'pointermove' && event.button === 'left' && this.isDragging) this.onGoSelect(cursorCanvasPos, this.easel.keyListener.isPressed('shift'));
            if (event.type === 'pointerup' && wasDragging) {
                this.onEndSelect();
                this.clearRenderedSelection(true);
                this.appliedBooleanOperation = undefined;
            }
        }
        if (!event.button) {
            if (doMove) this.selectSelectMode = 'move';
            else this.selectSelectMode = 'select';
        }
        if (this.selectSelectMode === 'move') this.easel.setCursor('move');
        else this.easel.setCursor($05cb3bfcad3beff7$var$operationToCursor[this.appliedBooleanOperation ?? effectiveOperation]);
    }
    // can be repeatedly called with the same event
    transformOnPointer(event) {
        if (!this.transformation || this.transformation.type !== 'ffd' || !this.ffdMesh) {
            this.easel.setCursor('default');
            // handled via this.freeTransform
            return;
        }
        // warping
        const cursorCanvasPos = this.viewportToCanvas({
            x: event.relX,
            y: event.relY
        });
        const parametricCoordinate = (0, $cb638405dd43878a$export$2d232ae0b526c96b)(cursorCanvasPos.x, cursorCanvasPos.y, this.ffdMesh);
        if (event.type === 'pointerdown' && event.button === 'left') {
            if (parametricCoordinate) {
                this.warpStart = {
                    parametricCoordinate: parametricCoordinate,
                    lattice: this.transformation.ffd
                };
                this.easel.setCursor('move');
            }
        }
        if (event.type === 'pointermove' && this.warpStart) {
            // Apply warp
            this.transformation.ffd = (0, $cb638405dd43878a$export$fd7a293c27db611b)(this.warpStart.parametricCoordinate, cursorCanvasPos, this.warpStart.lattice);
            const { width: width, height: height } = this.easel.getProjectSize();
            this.ffdMesh = (0, $cb638405dd43878a$export$d6a0409d5640315a)((0, $b14ff3017e98e7d9$export$6ba60dd123964f3e), (0, $b14ff3017e98e7d9$export$6ba60dd123964f3e), this.transformation.ffd, width, height, true);
            this.updateLatticePath();
            this.easel.requestRender();
            this.onTransform(this.transformation);
        }
        if (event.type === 'pointerup') {
            if (this.warpStart) this.onTransformEnd();
            this.warpStart = undefined;
        }
        if (!this.warpStart) // Update cursor if not already dragging
        this.easel.setCursor(parametricCoordinate ? 'move' : 'default');
    }
    onPointerChainOut(event) {
        if (this.mode === 'select') {
            this.cornerPanning.onPointer(event);
            this.selectOnPointer(event);
        } else this.transformOnPointer(event);
    }
    createFreeTransform() {
        this.freeTransform = new (0, $93e6a53ec76e8c56$export$79a74567acf241b0)({
            x: 1,
            y: 1,
            width: 1,
            height: 1,
            angleDeg: 0,
            isConstrained: this.freeTransformIsConstrained,
            snapX: [],
            snapY: [],
            viewportTransform: {
                scale: 1,
                x: 0,
                y: 0,
                angleDeg: 0,
                isMirrored: false
            },
            callback: (transform)=>{
                if (this.mode === 'select' || !this.transformation || !(this.transformation.type === 'free' || this.transformation.type === 'ffd+free')) return;
                if (isNaN(transform.x) || isNaN(transform.y) || isNaN(transform.width) || isNaN(transform.height)) //can be provoked by repeatedly x0.5, then dragging a corner
                return;
                this.onTransform({
                    ...this.transformation,
                    freeTransform: transform
                });
                // avoid spamming undo steps
                if (this.freeTransformTimeout) clearTimeout(this.freeTransformTimeout);
                this.freeTransformTimeout = setTimeout(()=>this.onTransformEnd(), 250);
            },
            onWheel: this.easel.onWheel,
            wheelParent: this.easel.getElement()
        });
        this.freeTransform.setSnapping(this.freeTransformIsSnapping);
        this.htmlEl.append(this.freeTransform.getElement());
        this.freeTransform.setViewportTransform(this.viewportTransform);
    }
    destroyFreeTransform() {
        this.freeTransform?.getElement().remove();
        this.freeTransform?.destroy();
        this.freeTransform = undefined;
    }
    updateFreeTransformVisibility() {
        this.freeTransform?.getElement().style.setProperty('display', this.transformation?.type === 'ffd' ? 'none' : '');
    }
    updateLatticePath() {
        if (!this.transformation || this.transformation.type !== 'ffd') {
            this.latticePath = undefined;
            return;
        }
        const lattice = this.transformation.ffd;
        const sampleCount = (0, $b14ff3017e98e7d9$export$6ba60dd123964f3e);
        const path = new Path2D();
        function addPolyline(path, points) {
            path.moveTo(points[0].x, points[0].y);
            for(let i = 1; i < points.length; i++)path.lineTo(points[i].x, points[i].y);
        }
        // horizontal lines
        for(let i = 0; i < lattice.rows; i++){
            const t = i / (lattice.rows - 1);
            const pts = [];
            for(let e = 0; e <= sampleCount; e++)pts.push((0, $cb638405dd43878a$export$24b0a92fce6b8497)(e / sampleCount, t, lattice));
            addPolyline(path, pts);
        }
        // vertical lines
        for(let i = 0; i < lattice.cols; i++){
            const s = i / (lattice.cols - 1);
            const pts = [];
            for(let e = 0; e <= sampleCount; e++)pts.push((0, $cb638405dd43878a$export$24b0a92fce6b8497)(s, e / sampleCount, lattice));
            addPolyline(path, pts);
        }
        this.latticePath = path;
    }
    renderLattice(ctx, scale) {
        if (!this.latticePath) return;
        ctx.save();
        ctx.lineWidth = 1 / scale;
        // globalCompositeOperation = 'difference' is slow in firefox,
        // and it doesn't look all that nice in any browser.
        ctx.strokeStyle = 'rgb(128, 128, 128)';
        ctx.stroke(this.latticePath);
        if ($05cb3bfcad3beff7$var$FFD_DEBUG && this.transformation?.type === 'ffd') {
            const lattice = this.transformation.ffd;
            for(let i = 0; i < lattice.rows; i++)for(let j = 0; j < lattice.cols; j++){
                const cp = lattice.controlPoints[i][j];
                ctx.beginPath();
                ctx.arc(cp.x, cp.y, 4 / scale, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(255, 100, 100, 0.8)';
                ctx.fill();
                ctx.strokeStyle = 'rgba(255, 255, 255, 0.6)';
                ctx.lineWidth = 1.5 / scale;
                ctx.stroke();
            }
        }
        ctx.restore();
    }
    getSvgElement() {
        return this.svgEl;
    }
    getHtmlOverlayElement() {
        return this.htmlEl;
    }
    onPointer(event) {
        this.onPointerChainOut(event);
        this.pointerChain.chainIn(event);
    }
    setEaselInterface(easelInterface) {
        this.easel = easelInterface;
        this.viewportTransform = this.easel.getTransform();
    }
    setMode(mode) {
        this.mode = mode;
        this.resetPolyShape();
        if (this.mode === 'transform') this.createFreeTransform();
        else {
            this.ffdMesh = undefined;
            this.destroyFreeTransform();
        }
    }
    onTool(toolId) {
        if (toolId === 'select') this.htmlEl.style.display = 'block';
        else this.htmlEl.style.display = 'none';
    }
    activate(cursorPos, poppedTemp) {
        if (cursorPos && this.transformation && this.ffdMesh) {
            const cursorCanvasPos = this.viewportToCanvas(cursorPos);
            const param = (0, $cb638405dd43878a$export$2d232ae0b526c96b)(cursorCanvasPos.x, cursorCanvasPos.y, this.ffdMesh);
            this.easel.setCursor(param ? 'move' : 'default');
        } else this.easel.setCursor('default');
        this.isDragging = false;
        this.onUpdateTransform(this.easel.getTransform());
        if (!poppedTemp) this.resetPolyShape();
    }
    onUpdateTransform(transform) {
        this.viewportTransform = transform;
        this.updateSelectionPath();
        this.freeTransform?.setViewportTransform(transform);
    }
    onUpdateSelection(selection) {
        this.canvasSelection = selection || [];
        this.updateSelectionPath();
    }
    setRenderedSelection(selection) {
        this.selection = selection;
        this.easel.setRenderedSelection(selection);
    }
    bringTransformRectIntoView(freeTransform) {
        const viewportTransform = this.easel.getTransform();
        const easelSize = this.easel.getSize();
        const padding = 40;
        const rect = {
            x: freeTransform.x - freeTransform.width / 2,
            y: freeTransform.y - freeTransform.height / 2,
            width: freeTransform.width,
            height: freeTransform.height
        };
        if ((0, $197f445a4ae1d495$export$eca13ebc72c99beb)(rect, viewportTransform, easelSize, 0)) return;
        // Don't zoom in further than we are currently. It's less annoying.
        const maxScale = Math.max(viewportTransform.scale, 1);
        this.easel.setTransform((0, $214074e70e75aa6b$export$29dc1c77cb35d1c5)(rect, viewportTransform, easelSize, false, padding, maxScale));
    }
    initialiseTransform(transform) {
        transform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(transform);
        if (transform.type !== 'free') throw new Error('must call initialiseTransform with transform.type = "free"');
        this.transformation = transform;
        this.freeTransform?.initialise(transform.freeTransform);
        const { width: width, height: height } = this.easel.getProjectSize();
        this.freeTransform?.setSnappingPoints([
            0,
            width
        ], [
            0,
            height
        ]);
        this.bringTransformRectIntoView(transform.freeTransform);
    }
    setTransform(transform) {
        transform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(transform);
        this.transformation = transform;
        if (transform.type === 'ffd') {
            const { width: width, height: height } = this.easel.getProjectSize();
            this.ffdMesh = (0, $cb638405dd43878a$export$d6a0409d5640315a)((0, $b14ff3017e98e7d9$export$6ba60dd123964f3e), (0, $b14ff3017e98e7d9$export$6ba60dd123964f3e), transform.ffd, width, height, true);
            this.easel.requestRender();
        } else {
            this.freeTransform?.initialise(transform.freeTransform);
            this.ffdMesh = undefined;
        }
        this.updateLatticePath();
        this.updateFreeTransformVisibility();
    }
    clearRenderedSelection(isImmediate) {
        this.easel.clearRenderedSelection(isImmediate);
    }
    setBooleanOperation(operation) {
        this.defaultBooleanOperation = operation;
    }
    setSelectShape(shape) {
        this.resetPolyShape();
        this.selectShape = shape;
    }
    getIsLocked() {
        return this.isDragging;
    }
    renderAfterViewport(ctx, transform) {
        if (this.mode === 'transform' && this.transformation?.type === 'ffd') {
            ctx.save();
            this.renderLattice(ctx, transform.scaleY);
            ctx.restore();
        }
        if (this.polyShape.length < 2) return;
        ctx.save();
        ctx.globalCompositeOperation = 'difference';
        ctx.beginPath();
        const shape = this.polyShape;
        ctx.moveTo(shape[0].x, shape[0].y);
        for(let i = 1; i < shape.length; i++)ctx.lineTo(shape[i].x, shape[i].y);
        ctx.lineWidth = 1 / transform.scaleY;
        ctx.strokeStyle = 'white';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.stroke();
        ctx.restore();
    }
    onKeyDown(keyStr, e) {
        if (keyStr === 'esc') {
            if (this.resetPolyShape()) e.preventDefault();
        }
    }
    onClickOutside() {
        this.resetPolyShape();
    }
    onBlur() {
        this.resetPolyShape();
    }
    onArrowKeys(direction) {
        if (!this.freeTransform) return false;
        const movementMap = {
            left: {
                x: -1,
                y: 0
            },
            right: {
                x: 1,
                y: 0
            },
            up: {
                x: 0,
                y: -1
            },
            down: {
                x: 0,
                y: 1
            }
        };
        const multiplier = this.easel.isKeyPressed('shift') ? 5 : 1;
        const movement = movementMap[direction];
        this.freeTransform.move(movement.x * multiplier, movement.y * multiplier);
        return true;
    }
    setIsConstrained(isConstrained) {
        this.freeTransformIsConstrained = isConstrained;
        this.freeTransform?.setIsConstrained(isConstrained);
    }
    setIsSnapping(isSnapping) {
        this.freeTransformIsSnapping = isSnapping;
        this.freeTransform?.setSnapping(isSnapping);
    }
    constructor(p){
        this.easel = {};
        this.viewportTransform = {};
        this.tempCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx((0, $be957da3610487e9$export$921068d8846a1559).canvas(1, 1)) // used for isPointInPath()
        ;
        // state
        this.canvasSelection = [];
        this.selectionPath = (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)([]);
        this.mode = 'select';
        this.isDragging = false;
        // select-mode state
        this.selectSelectMode = 'select';
        this.didSelectionMove = false;
        this.defaultBooleanOperation = 'new' // set by the UI
        ;
        this.selectShape = 'rect';
        this.polyShape = [];
        this.freeTransformIsConstrained = true;
        this.freeTransformIsSnapping = true;
        // ----------------------------------- public -----------------------------------
        this.doubleTapPointerTypes = [
            'touch'
        ];
        this.blockTrigger = 'alt';
        this.mode = p.selectMode;
        this.onStartSelect = p.onStartSelect;
        this.onGoSelect = p.onGoSelect;
        this.onEndSelect = p.onEndSelect;
        this.onStartMoveSelect = p.onStartMoveSelect;
        this.onGoMoveSelect = p.onGoMoveSelect;
        this.onEndMoveSelect = p.onEndMoveSelect;
        this.onSelectAddPoly = p.onSelectAddPoly;
        this.onResetSelection = p.onResetSelection;
        this.onTransform = p.onTransform;
        this.onTransformEnd = p.onTransformEnd;
        this.cornerPanning = new (0, $b5defa6ba00b208a$export$4deed4c512c630c2)({
            getEaselSize: ()=>this.easel.getSize(),
            getTransform: ()=>this.easel.getTargetTransform(),
            setTransform: (transform)=>this.easel.setTransform(transform, true),
            testCanPan: (buttonIsPressed)=>{
                return (buttonIsPressed || this.polyShape.length > 1) && !(this.selectShape === 'lasso' && this.selectSelectMode === 'select');
            },
            onRepeatEvent: (e)=>{
                if (this.mode === 'select') this.selectOnPointer(e);
                else this.transformOnPointer(e);
            }
        });
        this.pointerChain = new (0, $29dd970aa1f95ac5$export$649a211db9812745)({
            chainArr: [
                new (0, $c61fdfd84bc32c60$export$db3963a21c01d803)({
                    onDoubleTap: (e)=>{
                        if (this.mode !== 'select' || this.selectShape !== 'poly') return;
                        if (this.polyShape.length < 3) {
                            this.resetPolyShape();
                            return;
                        }
                        const shape = this.polyShape.map((item)=>({
                                x: item.x,
                                y: item.y
                            }));
                        this.resetPolyShape();
                        if (shape.length > 1) {
                            shape.push({
                                ...shape[0]
                            });
                            p.onSelectAddPoly(shape, this.appliedBooleanOperation);
                        }
                    },
                    isInstant: true
                })
            ]
        });
        this.svgEl = (0, $be957da3610487e9$export$921068d8846a1559).createSvg({
            elementType: 'g'
        });
        this.htmlEl = (0, $be957da3610487e9$export$921068d8846a1559).el();
    }
}



function $a36456bde4f55961$export$1b1b9d54d324857f(cx, cy, rx, ry, steps) {
    const result = [];
    const d = 2 * Math.PI / steps;
    for(let i = 0; i < 2 * Math.PI; i += d)result.push([
        Math.cos(i) * rx + cx,
        Math.sin(i) * ry + cy
    ]);
    return [
        result
    ];
}





const $a84c23e387f87f52$export$6f71e8a0179bd005 = 2;
function $a84c23e387f87f52$export$1f0b3b9c2ff2269f(num) {
    return parseFloat(num.toFixed($a84c23e387f87f52$export$6f71e8a0179bd005));
}
function $a84c23e387f87f52$export$9ff2e12a5746572e(poly) {
    return poly.map((ring)=>ring.map(([x, y])=>[
                $a84c23e387f87f52$export$1f0b3b9c2ff2269f(x),
                $a84c23e387f87f52$export$1f0b3b9c2ff2269f(y)
            ]));
}
// bounds smaller than 1px (canvas coordinates) in either dimension
function $a84c23e387f87f52$var$isTooThin(multiPolygon) {
    const bounds = (0, $c005e974076b5b75$export$a04a50ae6d6450f8)(multiPolygon, 'coordinate');
    return bounds.x2 - bounds.x1 < 1 || bounds.y2 - bounds.y1 < 1;
}
class $a84c23e387f87f52$export$53d9e71218013355 {
    reset() {
        this.selection = undefined;
    }
    combineSelection(polygon) {
        let result = this.selection ?? [];
        if (this.selectOperation === 'new') result = [
            polygon
        ];
        else {
            if (this.selection && this.selection.length > 0) {
                const operation = this.selectOperation === 'difference' ? 'difference' : 'union';
                result = (0, $95437e6a4f5261a8$export$7ec1a3fdd6e82838)(operation, this.selection, polygon);
            } else if (this.selectOperation === 'union') result = [
                polygon
            ];
        }
        return result;
    }
    // ignores polygon if too thin. empties selection if result too thin.
    commit(polygon) {
        if ($a84c23e387f87f52$var$isTooThin([
            polygon
        ])) {
            if (this.selectOperation === 'new') this.selection = undefined;
            return;
        }
        const selection = this.combineSelection(polygon);
        this.selection = selection.length === 0 || $a84c23e387f87f52$var$isTooThin(selection) ? undefined : selection;
    }
    // polygon of shape currently being inputted
    getDragPolygon() {
        if (this.selectDragInputs.length <= 1) return undefined;
        const first = this.selectDragInputs[0];
        const last = this.selectDragInputs.at(-1);
        if (this.shape === 'rect') {
            // floor and ceil already limit precision
            const minX = Math.floor(Math.min(first.x, last.x));
            const minY = Math.floor(Math.min(first.y, last.y));
            const maxX = Math.ceil(Math.max(first.x, last.x));
            const maxY = Math.ceil(Math.max(first.y, last.y));
            return [
                [
                    [
                        minX,
                        minY
                    ],
                    [
                        maxX,
                        minY
                    ],
                    [
                        maxX,
                        maxY
                    ],
                    [
                        minX,
                        maxY
                    ]
                ]
            ];
        }
        if (this.shape === 'ellipse') {
            const cx = (first.x + last.x) / 2;
            const cy = (first.y + last.y) / 2;
            const rx = Math.abs(last.x - first.x) / 2;
            const ry = Math.abs(last.y - first.y) / 2;
            return $a84c23e387f87f52$export$9ff2e12a5746572e((0, $a36456bde4f55961$export$1b1b9d54d324857f)(cx, cy, rx, ry, 50));
        }
        if (this.shape === 'lasso') return [
            this.selectDragInputs.map((p)=>[
                    $a84c23e387f87f52$export$1f0b3b9c2ff2269f(p.x),
                    $a84c23e387f87f52$export$1f0b3b9c2ff2269f(p.y)
                ])
        ];
        return undefined;
    }
    // current state of selection
    getSelection() {
        const dragPolygon = this.getDragPolygon();
        const selection = dragPolygon ? this.combineSelection(dragPolygon) : this.selection ?? [];
        return selection.length === 0 ? undefined : selection;
    }
    // --- selecting ---
    startSelect(pos, operation) {
        this.selectOperation = operation;
        if (this.selectOperation === 'new') this.reset();
        this.selectDragInputs = [
            pos
        ];
    }
    goSelect(pos, isShiftPressed = false) {
        let p = pos;
        if ((this.shape === 'ellipse' || this.shape === 'rect') && isShiftPressed && this.selectDragInputs.length > 0) {
            const start = this.selectDragInputs[0];
            const dx = pos.x - start.x;
            const dy = pos.y - start.y;
            const size = Math.min(Math.abs(dx), Math.abs(dy));
            p = {
                x: start.x + Math.sign(dx) * size,
                y: start.y + Math.sign(dy) * size
            };
        }
        this.selectDragInputs.push({
            x: p.x,
            y: p.y
        });
    }
    endSelect() {
        const dragPolygon = this.getDragPolygon();
        if (dragPolygon) this.commit(dragPolygon);
        else this.reset();
        this.selectDragInputs = [];
    }
    addPoly(polygon, operation) {
        this.selectOperation = operation;
        this.commit([
            polygon.map((p)=>[
                    $a84c23e387f87f52$export$1f0b3b9c2ff2269f(p.x),
                    $a84c23e387f87f52$export$1f0b3b9c2ff2269f(p.y)
                ])
        ]);
    }
    // --- moving selection ---
    startMoveSelect(pos) {
        this.moveStartPos = pos;
        this.selectionAtMoveStart = this.selection ? (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.selection) : undefined;
        this.didMove = false;
    }
    goMoveSelect(pos, isShiftPressed = false) {
        if (!this.moveStartPos) return;
        this.didMove = true;
        let dx = pos.x - this.moveStartPos.x;
        let dy = pos.y - this.moveStartPos.y;
        if (isShiftPressed) {
            // snap to 0°, 45°, 90°, 135° axes from start position
            const angle = Math.atan2(dy, dx);
            const snapAngle = Math.round(angle / (Math.PI / 4)) * (Math.PI / 4);
            const dist = Math.sqrt(dx * dx + dy * dy);
            dx = Math.cos(snapAngle) * dist;
            dy = Math.sin(snapAngle) * dist;
        }
        dx = Math.round(dx);
        dy = Math.round(dy);
        if (this.selectionAtMoveStart) this.selection = (0, $58f7addd70485099$export$199acb5b15c43176)(this.selectionAtMoveStart, dx, dy);
    }
    endMoveSelect() {
        this.moveStartPos = undefined;
        this.selectionAtMoveStart = undefined;
    }
    getDidMove() {
        return this.didMove;
    }
    selectAll() {
        this.reset();
        const width = this.klCanvas.getWidth();
        const height = this.klCanvas.getHeight();
        this.selection = [
            [
                [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        0
                    ],
                    [
                        width,
                        height
                    ],
                    [
                        0,
                        height
                    ],
                    [
                        0,
                        0
                    ]
                ]
            ]
        ];
    }
    invertSelection() {
        const selection = this.selection ?? [];
        const width = this.klCanvas.getWidth();
        const height = this.klCanvas.getHeight();
        this.selection = (0, $95437e6a4f5261a8$export$7ec1a3fdd6e82838)('difference', [
            [
                [
                    0,
                    0
                ],
                [
                    width,
                    0
                ],
                [
                    width,
                    height
                ],
                [
                    0,
                    height
                ]
            ]
        ], selection);
    }
    setShape(shape) {
        this.shape = shape;
    }
    getShape() {
        return this.shape;
    }
    setSelection(selection) {
        this.selection = selection ? (0, $be957da3610487e9$export$921068d8846a1559).copyObj(selection).map($a84c23e387f87f52$export$9ff2e12a5746572e) : undefined;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.shape = 'rect';
        this.selectOperation = 'new';
        this.selectDragInputs = [];
        this.didMove = false // was selection moved
        ;
        this.klCanvas = p.klCanvas;
    }
}





var $79I2S = parcelRequire("79I2S");

class $9bb2c73649417f74$export$348ded3d52c9ce4c {
    invalidateCompositeCanvas() {
        try {
            this.texture?.destroy();
            this.texture = undefined;
            this.canvas?.destroy();
            this.canvas = undefined;
        } catch (_) {
        // noop
        }
        this.cachedSelectionSample = undefined;
        this.cachedAlgorithm = undefined;
        this.cachedWidth = undefined;
        this.cachedHeight = undefined;
        this.cachedFfdLattice = undefined;
    }
    ensureCompositeCanvas(width, height, algorithm) {
        if (!this.canvas || this.canvas.isContextLost() || this.cachedAlgorithm !== algorithm || this.cachedWidth !== width || this.cachedHeight !== height) {
            this.invalidateCompositeCanvas();
            try {
                this.canvas = new (0, $50ebb6fbce8e845b$export$382d1cdfd2c9e133)((0, $79I2S.createCanvas)(width, height), algorithm);
                this.cachedAlgorithm = algorithm;
                this.cachedWidth = width;
                this.cachedHeight = height;
            } catch (_) {
            // noop
            }
        }
    }
    ensureTexture(selectionSample) {
        if (this.cachedSelectionSample !== selectionSample || !this.texture) {
            this.texture?.destroy();
            this.texture = undefined;
            try {
                this.texture = this.canvas.createTexture(selectionSample.image);
                this.cachedSelectionSample = selectionSample;
            } catch (_) {
            // noop
            }
        }
    }
    // ---- public ----
    render(p) {
        if (p.ffdLattice === this.cachedFfdLattice && p.selectionSample === this.cachedSelectionSample && p.algorithm === this.cachedAlgorithm && p.outputWidth === this.cachedWidth && p.outputHeight === this.cachedHeight) return; // output canvas already holds the correct result
        this.ensureCompositeCanvas(p.outputWidth, p.outputHeight, p.algorithm);
        if (!this.canvas) return;
        this.ensureTexture(p.selectionSample);
        if (!this.texture) return;
        this.cachedFfdLattice = p.ffdLattice;
        const ffdMesh = (0, $cb638405dd43878a$export$81dc197f519ea47)((0, $b14ff3017e98e7d9$export$6ba60dd123964f3e), (0, $b14ff3017e98e7d9$export$6ba60dd123964f3e), p.ffdLattice, p.selectionSample, p.outputWidth, p.outputHeight, undefined);
        let frontMesh;
        let backMesh;
        try {
            frontMesh = this.canvas.createMesh(ffdMesh.vertices, ffdMesh.texCoords, ffdMesh.frontIndices);
            backMesh = this.canvas.createMesh(ffdMesh.vertices, ffdMesh.texCoords, ffdMesh.backIndices);
            this.canvas.clear();
            this.canvas.draw(frontMesh, this.texture);
            this.canvas.draw(backMesh, this.texture);
            this.canvas.present();
        } catch (_) {
        // noop
        } finally{
            frontMesh?.destroy();
            backMesh?.destroy();
        }
    }
    getCanvas() {
        return this.canvas?.getCanvas();
    }
    freeResources() {
        this.invalidateCompositeCanvas();
    }
    // when you want to discard this object
    destroy() {
        this.invalidateCompositeCanvas();
    }
}







function $08c423c0549b6f9e$export$13786f381c8abcf1(selectionSample) {
    const x = selectionSample.x - selectionSample.imageOffset.x;
    const y = selectionSample.y - selectionSample.imageOffset.y;
    return (0, $4c2c6808296c0d73$export$d89ccdf57354a99c)({
        x: x,
        y: y,
        width: selectionSample.selectionSize.width,
        height: selectionSample.selectionSize.height
    }, 'index');
}
function $08c423c0549b6f9e$export$a70ad15f9d5e7f79(selectionSample, transformation) {
    const rect = {
        x: selectionSample.x,
        y: selectionSample.y,
        width: selectionSample.image.width,
        height: selectionSample.image.height
    };
    if (transformation) return (0, $4c2c6808296c0d73$export$b0036cbc597df324)((0, $e54f3e9fe3a16a29$export$5dd60a54dd55622)((0, $4c2c6808296c0d73$export$d89ccdf57354a99c)(rect, 'coordinate'), transformation));
    return (0, $4c2c6808296c0d73$export$d89ccdf57354a99c)(rect, 'index');
}
function $08c423c0549b6f9e$export$f97155819e62dfa1(selectionSample, transformation) {
    const bounds = (0, $4c2c6808296c0d73$export$86989866a3954672)($08c423c0549b6f9e$export$a70ad15f9d5e7f79(selectionSample, transformation));
    return [
        [
            [
                [
                    bounds.x1,
                    bounds.y1
                ],
                [
                    bounds.x2,
                    bounds.y1
                ],
                [
                    bounds.x2,
                    bounds.y2
                ],
                [
                    bounds.x1,
                    bounds.y2
                ],
                [
                    bounds.x1,
                    bounds.y1
                ]
            ]
        ]
    ];
}



function $dcdc76e520c24e49$export$a8cb0d8fd60b16e8(ctx, algorithm) {
    ctx.imageSmoothingEnabled = algorithm === 'smooth';
    if (algorithm === 'smooth') ctx.imageSmoothingQuality = 'high';
}






function $b9b81497a8375e23$export$7c52f4d84a7cbc6e(layers, changes) {
    const result = {};
    const layerEntries = [];
    for (const change of changes)if ('selection' in change) result.selection = {
        value: change.selection
    };
    else {
        const existing = layerEntries.find((e)=>e.layerId === change.layerId);
        if (existing) existing.bounds = (0, $4c2c6808296c0d73$export$f4467a4f41373bc7)(existing.bounds, change.bounds);
        else layerEntries.push({
            layerId: change.layerId,
            attributes: [
                'tiles'
            ],
            bounds: change.bounds
        });
    }
    if (layerEntries.length > 0) result.layerMap = (0, $0957b1eeba070f0f$export$7cefb04ac49374c4)(layers, ...layerEntries);
    return result;
}


function $6c09ad18bebe19fe$var$drawTransformedSelectionSample(algorithm, selectionSample, ctx, transformation) {
    ctx.save();
    ctx.setTransform(...(0, $f7c026d16783f524$export$2b60e7dafdbde18a)(transformation));
    (0, $dcdc76e520c24e49$export$a8cb0d8fd60b16e8)(ctx, algorithm);
    ctx.drawImage(selectionSample.image, selectionSample.x, selectionSample.y);
    ctx.restore();
}
function $6c09ad18bebe19fe$export$2f6704cc6a7abecb(p) {
    const backgroundIsTransparent = p.backgroundIsTransparent ?? false;
    const klHistory = p.klCanvas.getKlHistory();
    const layers = p.klCanvas.getLayersReference();
    const targetLayer = layers[p.targetLayerIndex];
    const matrix = (0, $b14ff3017e98e7d9$export$e464a809f7257768)(p.freeTransform, (0, $08c423c0549b6f9e$export$13786f381c8abcf1)(p.selectionSample));
    let transformedSelection;
    klHistory.pause(true);
    try {
        if (p.eraseLayerIndex !== undefined) p.klCanvas.eraseLayer({
            layerIndex: p.eraseLayerIndex,
            useSelection: true,
            useAlphaLock: p.eraseLayerIndex === 0 && !backgroundIsTransparent
        });
        $6c09ad18bebe19fe$var$drawTransformedSelectionSample(p.algorithm, p.selectionSample, targetLayer.context, matrix);
        transformedSelection = p.selection ? (0, $b14ff3017e98e7d9$export$c17d845d16ec8ae)({
            type: 'free',
            freeTransform: p.freeTransform
        }, p.selection) : undefined;
        p.klCanvas.setSelection(transformedSelection);
    } finally{
        klHistory.pause(false);
    }
    if (!klHistory.isPaused()) {
        const eraseLayer = p.eraseLayerIndex !== undefined ? layers[p.eraseLayerIndex] : undefined;
        const targetBounds = (0, $4c2c6808296c0d73$export$ddc1c0069d484d49)((0, $08c423c0549b6f9e$export$a70ad15f9d5e7f79)(p.selectionSample, matrix), p.klCanvas.getWidth(), p.klCanvas.getHeight());
        const changes = [];
        transformedSelection && changes.push({
            selection: transformedSelection
        });
        eraseLayer && changes.push({
            layerId: eraseLayer.id,
            bounds: (0, $08c423c0549b6f9e$export$a70ad15f9d5e7f79)(p.selectionSample)
        });
        targetBounds && changes.push({
            layerId: targetLayer.id,
            bounds: targetBounds
        });
        klHistory.push((0, $b9b81497a8375e23$export$7c52f4d84a7cbc6e)(layers, changes));
    }
}








function $b23a3da840927596$var$drawWarpedSelectionSample(algorithm, selectionSample, ctx, ffdLattice, ffdRenderer) {
    ffdRenderer.render({
        ffdLattice: ffdLattice,
        selectionSample: selectionSample,
        algorithm: algorithm,
        outputWidth: ctx.canvas.width,
        outputHeight: ctx.canvas.height
    });
    const outputCanvas = ffdRenderer.getCanvas();
    if (outputCanvas) {
        ctx.save();
        ctx.drawImage(outputCanvas, 0, 0);
        ctx.restore();
    }
}
function $b23a3da840927596$export$d43d373c54e74296(p) {
    const backgroundIsTransparent = p.backgroundIsTransparent ?? false;
    const klHistory = p.klCanvas.getKlHistory();
    const layers = p.klCanvas.getLayersReference();
    const targetLayer = layers[p.targetLayerIndex];
    let transformedSelection;
    klHistory.pause(true);
    try {
        if (p.eraseLayerIndex !== undefined) p.klCanvas.eraseLayer({
            layerIndex: p.eraseLayerIndex,
            useSelection: true,
            useAlphaLock: p.eraseLayerIndex === 0 && !backgroundIsTransparent
        });
        $b23a3da840927596$var$drawWarpedSelectionSample(p.algorithm, p.selectionSample, targetLayer.context, p.ffd, p.ffdRenderer);
        transformedSelection = p.selection ? (0, $b14ff3017e98e7d9$export$c17d845d16ec8ae)({
            type: 'ffd',
            ffd: p.ffd
        }, p.selection) : undefined;
        p.klCanvas.setSelection(transformedSelection);
    } finally{
        klHistory.pause(false);
    }
    if (!klHistory.isPaused()) {
        const ffdMesh = (0, $cb638405dd43878a$export$81dc197f519ea47)((0, $b14ff3017e98e7d9$export$6ba60dd123964f3e), (0, $b14ff3017e98e7d9$export$6ba60dd123964f3e), p.ffd, p.selectionSample, 1, 1, true);
        const width = p.klCanvas.getWidth();
        const height = p.klCanvas.getHeight();
        const targetBounds = (0, $2a95441a1b997bbf$export$b8704036eca28391)(ffdMesh, width, height);
        const eraseLayer = p.eraseLayerIndex !== undefined ? layers[p.eraseLayerIndex] : undefined;
        const changes = [];
        transformedSelection && changes.push({
            selection: transformedSelection
        });
        eraseLayer && changes.push({
            layerId: eraseLayer.id,
            bounds: (0, $08c423c0549b6f9e$export$a70ad15f9d5e7f79)(p.selectionSample)
        });
        targetBounds && changes.push({
            layerId: targetLayer.id,
            bounds: targetBounds
        });
        klHistory.push((0, $b9b81497a8375e23$export$7c52f4d84a7cbc6e)(layers, changes));
    }
}












function $7539d28c58618686$export$fbfe89095a95dee(config, // "same" when (source layer === destination layer)
layer) {
    const selectionPath = (0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(config.selection ?? (0, $08c423c0549b6f9e$export$f97155819e62dfa1)(config.selectionSample));
    const erase = (ctx)=>{
        if (!config.doClone && (layer === 'same' || layer === 'src')) {
            // erase
            ctx.save();
            ctx.clip(selectionPath);
            if (config.backgroundIsTransparent) ctx.clearRect(0, 0, config.klCanvasWidth, config.klCanvasHeight);
            else {
                // fastest in firefox like so
                ctx.globalCompositeOperation = 'source-atop';
                ctx.fillStyle = '#fff';
                ctx.fillRect(0, 0, config.klCanvasWidth, config.klCanvasHeight);
            }
            ctx.restore();
        }
    };
    // ffd
    if (config.transform.type === 'ffd' || config.transform.type === 'ffd+free') {
        let ffd = config.transform.ffd;
        if (config.transform.type === 'ffd+free') // apply further free transform
        ffd = (0, $b14ff3017e98e7d9$export$a56ca41a0dbe2002)(ffd, (0, $b14ff3017e98e7d9$export$e464a809f7257768)(config.transform.freeTransform, (0, $4c2c6808296c0d73$export$d89ccdf57354a99c)(config.transform.ffdBounds, 'index')));
        return {
            draw: (ctx)=>{
                ctx.save();
                erase(ctx);
                if (layer === 'same' || layer === 'dest') {
                    config.ffdRenderer.render({
                        ffdLattice: ffd,
                        selectionSample: config.selectionSample,
                        algorithm: config.algorithm,
                        outputWidth: config.klCanvasWidth,
                        outputHeight: config.klCanvasHeight
                    });
                    const outputCanvas = config.ffdRenderer.getCanvas();
                    outputCanvas && ctx.drawImage(outputCanvas, 0, 0);
                }
                ctx.restore();
            }
        };
    }
    // free transform
    const selectionBounds = (0, $08c423c0549b6f9e$export$13786f381c8abcf1)(config.selectionSample);
    const transformMatrix = (0, $b14ff3017e98e7d9$export$e464a809f7257768)(config.transform.freeTransform, selectionBounds);
    return {
        draw: (ctx)=>{
            ctx.save();
            erase(ctx);
            if (layer === 'same' || layer === 'dest') {
                (0, $dcdc76e520c24e49$export$a8cb0d8fd60b16e8)(ctx, config.algorithm);
                ctx.setTransform(...(0, $f7c026d16783f524$export$2b60e7dafdbde18a)(transformMatrix));
                ctx.drawImage(config.selectionSample.image, config.selectionSample.x, config.selectionSample.y);
            }
            ctx.restore();
        }
    };
}







function $058f1453ec687140$export$bf78d14945c1101(layerIndex, klCanvas) {
    const srcLayer = klCanvas.getLayer(layerIndex);
    const klCanvasSelection = klCanvas.getSelection();
    const hasSelection = !!klCanvasSelection;
    let selectionBounds;
    let imageBounds;
    if (hasSelection) {
        selectionBounds = (0, $4c2c6808296c0d73$export$3488993c9d026384)((0, $c005e974076b5b75$export$a04a50ae6d6450f8)(klCanvasSelection, 'index'));
        imageBounds = (0, $58a3332bd07c6dd1$export$6be4733fa804854c)(klCanvasSelection, srcLayer.context);
    } else {
        const width = klCanvas.getWidth();
        const height = klCanvas.getHeight();
        imageBounds = (0, $58a3332bd07c6dd1$export$6be4733fa804854c)(klCanvas.getSelection() ?? [
            [
                [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        0
                    ],
                    [
                        width,
                        height
                    ],
                    [
                        0,
                        height
                    ],
                    [
                        0,
                        0
                    ]
                ]
            ]
        ], srcLayer.context);
        selectionBounds = imageBounds ? {
            ...imageBounds
        } : undefined;
    }
    // empty
    if (!selectionBounds || !imageBounds) return undefined;
    const sampleCanvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(imageBounds.width, imageBounds.height);
    const sampleCtx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(sampleCanvas);
    sampleCtx.save();
    sampleCtx.translate(-imageBounds.x, -imageBounds.y);
    if (klCanvasSelection) sampleCtx.clip((0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(klCanvasSelection));
    sampleCtx.drawImage(srcLayer.canvas, 0, 0);
    sampleCtx.restore();
    return {
        image: sampleCanvas,
        x: imageBounds.x,
        y: imageBounds.y,
        imageOffset: {
            x: imageBounds.x - selectionBounds.x,
            y: imageBounds.y - selectionBounds.y
        },
        selectionSize: {
            width: selectionBounds.width,
            height: selectionBounds.height
        }
    };
}



function $959ada5c6d90f030$var$isSelectTransformTempEntry(entry) {
    return entry.type === 'select-transform' && !!entry.data;
}
function $959ada5c6d90f030$var$initialiseTransformState(p) {
    const selectionSample = p.selectionSample;
    const selectionBounds = (0, $08c423c0549b6f9e$export$13786f381c8abcf1)(p.selectionSample);
    const transform = {
        // no ffd initially
        type: 'free',
        freeTransform: (0, $b14ff3017e98e7d9$export$928f0648354c9a2f)((0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)(selectionBounds))
    };
    return {
        selection: p.selection,
        selectionSample: selectionSample,
        transform: transform,
        algorithm: p.algorithm,
        doClone: false,
        isWarping: false,
        targetLayerIndex: p.targetLayerIndex,
        backgroundIsTransparent: p.backgroundIsTransparent
    };
}
class $959ada5c6d90f030$export$e471993a29671b7 {
    // ----------------------------------- private methods -----------------------------------
    isTransformationChanged() {
        if (!this.transformState) return false;
        const initial = this.tempHistory.getEntries()[0];
        if (!$959ada5c6d90f030$var$isSelectTransformTempEntry(initial)) throw new Error('initial temp history entry has wrong type');
        if (this.transformState.doClone !== initial.data.doClone) return true;
        if (this.transformState.targetLayerIndex !== initial.data.targetLayerIndex) return true;
        // not perfect but would be a lot of effort to determine if two transforms are equivalent
        return JSON.stringify(this.transformState.transform) !== JSON.stringify(initial.data.transform);
    }
    /** reset KlCanvas layer composites **/ resetKlCanvasLayerComposites() {
        const srcLayerIndex = this.getCurrentLayerIndex();
        this.klCanvas.setComposite(srcLayerIndex, undefined);
        if (this.transformState && this.transformState.targetLayerIndex !== srcLayerIndex) this.klCanvas.setComposite(this.transformState.targetLayerIndex, undefined);
    }
    updateComposites() {
        if (!this.transformState) return;
        const srcLayerIndex = this.getCurrentLayerIndex();
        const config = {
            klCanvasWidth: this.klCanvas.getWidth(),
            klCanvasHeight: this.klCanvas.getHeight(),
            transform: this.transformState.transform,
            selection: this.transformState.selection,
            selectionSample: this.transformState.selectionSample,
            algorithm: this.transformState.algorithm,
            doClone: this.transformState.doClone,
            backgroundIsTransparent: srcLayerIndex !== 0 || this.transformState.backgroundIsTransparent,
            ffdRenderer: this.ffdRenderer
        };
        if (srcLayerIndex === this.transformState.targetLayerIndex) this.klCanvas.setComposite(srcLayerIndex, (0, $7539d28c58618686$export$fbfe89095a95dee)(config, 'same'));
        else {
            this.klCanvas.setComposite(srcLayerIndex, (0, $7539d28c58618686$export$fbfe89095a95dee)(config, 'src'));
            this.klCanvas.setComposite(this.transformState.targetLayerIndex, (0, $7539d28c58618686$export$fbfe89095a95dee)(config, 'dest'));
        }
    }
    updateUiLayerList() {
        this.selectUi.setLayers(this.klCanvas.getLayers().map((layer)=>{
            return layer.name;
        }));
    }
    tempHistoryPush() {
        if (!this.transformState) return;
        const newEntry = {
            type: 'select-transform',
            data: {
                transform: (0, $be957da3610487e9$export$921068d8846a1559).copyObj(this.transformState.transform),
                doClone: this.transformState.doClone,
                targetLayerIndex: this.transformState.targetLayerIndex,
                backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                algorithm: this.transformState.algorithm
            }
        };
        const topEntry = this.tempHistory.getEntries().at(-1);
        // skip if no change
        if (JSON.stringify(newEntry) === JSON.stringify(topEntry)) return;
        this.tempHistory.push(newEntry);
    }
    propagateTransformationChange(skipPushUndo = false) {
        if (!this.transformState) return;
        if (this.transformState.selection) {
            const selection = (0, $b14ff3017e98e7d9$export$c17d845d16ec8ae)(this.transformState.transform, this.transformState.selection);
            this.easelSelect.setRenderedSelection(selection);
        }
        this.updateComposites();
        this.onUpdateProject();
        this.updateSelectUi();
        !skipPushUndo && this.tempHistoryPush();
    }
    updateSelectUi() {
        if (!this.transformState) return;
        if (this.transformState.transform.type !== 'ffd') this.selectUi.setFreeTransformTransformation(this.transformState.transform.freeTransform);
    }
    clearTransformState() {
        if (this.transformState) {
            (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(this.transformState.selectionSample.image);
            this.transformState = undefined;
        }
    }
    getSelectUi() {
        return this.selectUi;
    }
    getEaselSelect() {
        return this.easelSelect;
    }
    getSelectMode() {
        return this.selectMode;
    }
    resetSelection() {
        if (this.selectMode === 'transform') return;
        this.selectTool.reset();
        const selection = this.selectTool.getSelection();
        this.klCanvas.setSelection(selection);
        this.selectUi.setHasSelection(!!selection);
    }
    /**
     * If transform changed something, changes are applied. -> return true
     * If no changes applied -> return false
     */ commitTransform() {
        let result = false;
        if (this.selectMode === 'transform') {
            this.selectUi.setMode('select'); // this triggers selectUi.onMode
            result = true;
        }
        return result;
    }
    /** if transforming, changes are discarded */ discardTransform() {
        if (this.selectMode === 'transform') {
            // so there's no transformation to apply.
            this.clearTransformState();
            // this triggers selectUi.onMode synchronously, which does the cleanup
            this.selectUi.setMode('select');
            return true;
        }
        return false;
    }
    onHistory(type) {
        if (this.transformState && (type === 'tempUndo' || type === 'tempRedo')) {
            this.resetKlCanvasLayerComposites();
            // recreate
            const entries = this.tempHistory.getEntries();
            const top = entries.at(-1);
            if (!$959ada5c6d90f030$var$isSelectTransformTempEntry(top)) return;
            const state = top.data;
            this.transformState.transform = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(state.transform);
            this.transformState.doClone = state.doClone;
            this.transformState.targetLayerIndex = state.targetLayerIndex;
            this.transformState.backgroundIsTransparent = state.backgroundIsTransparent;
            this.transformState.algorithm = state.algorithm;
            this.transformState.isWarping = state.transform.type === 'ffd';
            this.selectUi.setBackgroundIsTransparent(state.backgroundIsTransparent);
            this.selectUi.setAlgorithm(state.algorithm);
            this.selectUi.setIsWarping(state.transform.type === 'ffd');
            if (this.transformState.selection) {
                const selection = (0, $b14ff3017e98e7d9$export$c17d845d16ec8ae)(this.transformState.transform, this.transformState.selection);
                this.easelSelect.setRenderedSelection(selection);
            }
            this.easelSelect.setTransform(this.transformState.transform);
            this.selectUi.setMoveToLayer(this.getCurrentLayerIndex() === state.targetLayerIndex ? undefined : state.targetLayerIndex);
            this.updateComposites();
            this.onUpdateProject();
            this.updateSelectUi();
        }
    }
    destroy() {
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    // not a proper cleanup yet
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        // state
        this.selectMode = 'select';
        this.klCanvas = p.klCanvas;
        this.onUpdateProject = p.onUpdateProject;
        this.getCurrentLayerIndex = p.getCurrentLayerIndex;
        this.klHistory = p.klHistory;
        this.tempHistory = p.tempHistory;
        this.statusOverlay = p.statusOverlay;
        this.onFill = p.onFill;
        this.onErase = p.onErase;
        // keep layer list up-to-date
        this.klHistory.addListener(()=>{
            this.selectUi.setHasSelection(!!this.klCanvas.getSelection());
            if (this.selectMode === 'transform') this.updateUiLayerList();
        });
        this.selectTool = new (0, $a84c23e387f87f52$export$53d9e71218013355)({
            klCanvas: this.klCanvas
        });
        this.ffdRenderer = new (0, $9bb2c73649417f74$export$348ded3d52c9ce4c)();
        this.onVisibilityChange = ()=>{
            if (document.hidden && this.selectMode === 'transform') this.ffdRenderer.freeResources();
        };
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.easelSelect = new (0, $05cb3bfcad3beff7$export$24961ed376c522a3)({
            selectMode: this.selectMode,
            onStartSelect: (p, operation)=>this.selectTool.startSelect(p, operation),
            onGoSelect: (p, isShiftPressed)=>{
                this.selectTool.goSelect(p, isShiftPressed);
                this.easelSelect.setRenderedSelection(this.selectTool.getSelection());
            },
            onEndSelect: ()=>{
                this.selectTool.endSelect();
                const selection = this.selectTool.getSelection();
                this.klCanvas.setSelection(selection);
                this.selectUi.setHasSelection(!!selection);
            },
            onStartMoveSelect: (p)=>{
                this.selectTool.startMoveSelect(p);
            },
            onGoMoveSelect: (p, isShiftPressed)=>{
                this.selectTool.goMoveSelect(p, isShiftPressed);
                this.easelSelect.setRenderedSelection(this.selectTool.getSelection());
            },
            onEndMoveSelect: ()=>{
                this.selectTool.endMoveSelect();
                if (!this.selectTool.getDidMove()) return;
                const selection = this.selectTool.getSelection();
                this.easelSelect.clearRenderedSelection();
                this.klCanvas.setSelection(selection);
                this.selectUi.setHasSelection(!!selection);
            },
            onSelectAddPoly: (p, operation)=>{
                this.selectTool.addPoly(p, operation);
                const selection = this.selectTool.getSelection();
                this.klCanvas.setSelection(selection);
                this.selectUi.setHasSelection(!!selection);
            },
            onResetSelection: ()=>this.resetSelection(),
            onTransform: (transform)=>{
                if (!this.transformState) return;
                this.transformState.transform = transform;
                this.propagateTransformationChange(true);
            },
            onTransformEnd: ()=>{
                this.tempHistoryPush();
            }
        });
        this.selectUi = new (0, $27738b416db1ff7a$export$b3e6ed306341f794)({
            onChangeMode: (mode)=>{
                if (mode === 'select') {
                    const layerIndex = this.getCurrentLayerIndex();
                    if (this.transformState && (this.isTransformationChanged() || this.transformState.doClone || layerIndex !== this.transformState.targetLayerIndex || this.selectUi.getIsWarping())) {
                        // something changed -> apply
                        const transform = this.transformState.transform;
                        if (transform.type === 'free') (0, $6c09ad18bebe19fe$export$2f6704cc6a7abecb)({
                            klCanvas: this.klCanvas,
                            selectionSample: this.transformState.selectionSample,
                            ...this.transformState.doClone ? {} : {
                                eraseLayerIndex: layerIndex
                            },
                            targetLayerIndex: this.transformState.targetLayerIndex,
                            freeTransform: transform.freeTransform,
                            backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                            algorithm: this.transformState.algorithm,
                            selection: this.transformState.selection
                        });
                        else {
                            const ffd = transform.type === 'ffd+free' ? (0, $b14ff3017e98e7d9$export$a56ca41a0dbe2002)(transform.ffd, (0, $b14ff3017e98e7d9$export$e464a809f7257768)(transform.freeTransform, (0, $4c2c6808296c0d73$export$d89ccdf57354a99c)(transform.ffdBounds, 'index'))) : transform.ffd;
                            if (this.transformState.doClone) (0, $b23a3da840927596$export$d43d373c54e74296)({
                                klCanvas: this.klCanvas,
                                selectionSample: this.transformState.selectionSample,
                                targetLayerIndex: this.transformState.targetLayerIndex,
                                ffd: ffd,
                                algorithm: this.transformState.algorithm,
                                selection: this.transformState.selection,
                                ffdRenderer: this.ffdRenderer
                            });
                            else (0, $b23a3da840927596$export$d43d373c54e74296)({
                                klCanvas: this.klCanvas,
                                selectionSample: this.transformState.selectionSample,
                                eraseLayerIndex: layerIndex,
                                targetLayerIndex: this.transformState.targetLayerIndex,
                                ffd: ffd,
                                backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                                algorithm: this.transformState.algorithm,
                                selection: this.transformState.selection,
                                ffdRenderer: this.ffdRenderer
                            });
                        }
                        this.clearTransformState();
                        p.statusOverlay.out((0, $fc42a07754814920$export$ce37e184d908d785)('select-transform-applied'), true);
                    }
                    this.tempHistory.clear();
                    this.tempHistory.setIsActive(false);
                    this.selectUi.setIsWarping(false);
                    this.resetKlCanvasLayerComposites();
                    this.ffdRenderer.freeResources();
                    this.easelSelect.clearRenderedSelection(true);
                    const selection = this.klCanvas.getSelection();
                    this.selectTool.setSelection(selection);
                    this.selectUi.setHasSelection(!!selection);
                    this.onUpdateProject();
                    this.easelSelect.setMode(mode);
                } else {
                    // -> transform
                    // avoid changing state while mode-change can be rejected
                    const layerIndex = this.getCurrentLayerIndex();
                    const selectionSample = (0, $058f1453ec687140$export$bf78d14945c1101)(layerIndex, this.klCanvas);
                    if (!selectionSample) {
                        setTimeout(()=>{
                            (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('select-transform-empty'));
                        });
                        return false;
                    }
                    this.tempHistory.setIsActive(true);
                    const isBgLayer = layerIndex === 0;
                    let isTransparent = false;
                    if (isBgLayer) {
                        const layer = Object.entries(this.klHistory.getComposed().layerMap).find(([_, layer])=>layer.index === layerIndex)[1];
                        isTransparent = (0, $d4ff44c295f41b68$export$784dd829176d2fbc)(layer);
                        this.selectUi.setBackgroundIsTransparent(isTransparent);
                    }
                    this.transformState = $959ada5c6d90f030$var$initialiseTransformState({
                        selection: this.klCanvas.getSelection(),
                        selectionSample: selectionSample,
                        algorithm: this.selectUi.getAlgorithm(),
                        targetLayerIndex: layerIndex,
                        backgroundIsTransparent: isTransparent
                    });
                    // push initial state
                    this.tempHistoryPush();
                    this.selectUi.setShowTransparentBackgroundToggle(isBgLayer);
                    this.updateComposites();
                    this.updateUiLayerList();
                    this.selectUi.setMoveToLayer(undefined);
                    this.onUpdateProject();
                    this.easelSelect.setMode(mode);
                    if (this.transformState.selection) {
                        const transformedSelection = (0, $b14ff3017e98e7d9$export$c17d845d16ec8ae)(this.transformState.transform, this.transformState.selection);
                        this.easelSelect.setRenderedSelection(transformedSelection);
                    }
                    this.easelSelect.initialiseTransform(this.transformState.transform);
                    this.updateSelectUi();
                }
                this.selectMode = mode;
                return true;
            },
            onChangeBooleanOperation: (operation)=>{
                this.easelSelect.setBooleanOperation(operation);
            },
            select: {
                shape: this.selectTool.getShape(),
                onChangeShape: (shape)=>{
                    this.selectTool.setShape(shape);
                    this.easelSelect.setSelectShape(shape);
                },
                onReset: ()=>this.resetSelection(),
                onAll: ()=>{
                    this.selectTool.selectAll();
                    const selection = this.selectTool.getSelection();
                    this.klCanvas.setSelection(selection);
                    this.selectUi.setHasSelection(!!selection);
                },
                onInvert: ()=>{
                    this.selectTool.invertSelection();
                    const selection = this.selectTool.getSelection();
                    this.klCanvas.setSelection(selection);
                    this.selectUi.setHasSelection(!!selection);
                }
            },
            transform: {
                onFlipY: ()=>{
                    if (!this.transformState) return;
                    this.transformState.transform = (0, $b14ff3017e98e7d9$export$44831334ca780533)(this.transformState.transform, 'y');
                    this.propagateTransformationChange();
                    this.easelSelect.setTransform(this.transformState.transform);
                },
                onFlipX: ()=>{
                    if (!this.transformState) return;
                    this.transformState.transform = (0, $b14ff3017e98e7d9$export$44831334ca780533)(this.transformState.transform, 'x');
                    this.propagateTransformationChange();
                    this.easelSelect.setTransform(this.transformState.transform);
                },
                onRotateDeg: (deg)=>{
                    if (!this.transformState) return;
                    this.transformState.transform = (0, $b14ff3017e98e7d9$export$71dd993772432b93)(this.transformState.transform, deg);
                    this.propagateTransformationChange();
                    this.easelSelect.setTransform(this.transformState.transform);
                },
                onClone: ()=>{
                    if (!this.transformState) return;
                    // commit
                    const layerIndex = this.getCurrentLayerIndex();
                    const transform = this.transformState.transform;
                    // apply
                    // should always apply. user might want to make something more opaque.
                    if (transform.type === 'free') {
                        if (this.transformState.doClone) (0, $6c09ad18bebe19fe$export$2f6704cc6a7abecb)({
                            klCanvas: this.klCanvas,
                            selectionSample: this.transformState.selectionSample,
                            targetLayerIndex: this.transformState.targetLayerIndex,
                            freeTransform: transform.freeTransform,
                            algorithm: this.transformState.algorithm,
                            selection: this.transformState.selection
                        });
                        else if (this.isTransformationChanged()) (0, $6c09ad18bebe19fe$export$2f6704cc6a7abecb)({
                            klCanvas: this.klCanvas,
                            selectionSample: this.transformState.selectionSample,
                            eraseLayerIndex: layerIndex,
                            targetLayerIndex: this.transformState.targetLayerIndex,
                            freeTransform: transform.freeTransform,
                            backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                            algorithm: this.transformState.algorithm,
                            selection: this.transformState.selection
                        });
                    } else {
                        const ffd = transform.type === 'ffd+free' ? (0, $b14ff3017e98e7d9$export$a56ca41a0dbe2002)(transform.ffd, (0, $b14ff3017e98e7d9$export$e464a809f7257768)(transform.freeTransform, (0, $4c2c6808296c0d73$export$d89ccdf57354a99c)(transform.ffdBounds, 'index'))) : transform.ffd;
                        if (this.transformState.doClone) (0, $b23a3da840927596$export$d43d373c54e74296)({
                            klCanvas: this.klCanvas,
                            selectionSample: this.transformState.selectionSample,
                            targetLayerIndex: this.transformState.targetLayerIndex,
                            ffd: ffd,
                            algorithm: this.transformState.algorithm,
                            selection: this.transformState.selection,
                            ffdRenderer: this.ffdRenderer
                        });
                        else if (this.isTransformationChanged()) (0, $b23a3da840927596$export$d43d373c54e74296)({
                            klCanvas: this.klCanvas,
                            selectionSample: this.transformState.selectionSample,
                            eraseLayerIndex: layerIndex,
                            targetLayerIndex: this.transformState.targetLayerIndex,
                            ffd: ffd,
                            backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                            algorithm: this.transformState.algorithm,
                            selection: this.transformState.selection,
                            ffdRenderer: this.ffdRenderer
                        });
                    }
                    this.tempHistory.clear();
                    // push initial state
                    this.tempHistoryPush();
                    this.transformState.doClone = true;
                    this.updateComposites();
                    this.onUpdateProject();
                    this.statusOverlay.out((0, $fc42a07754814920$export$ce37e184d908d785)('select-transform-clone-applied'), true);
                },
                onScale: (factor)=>{
                    if (!this.transformState) return;
                    this.transformState.transform = (0, $b14ff3017e98e7d9$export$7eaa413076082bd7)(this.transformState.transform, factor);
                    this.propagateTransformationChange();
                    this.easelSelect.setTransform(this.transformState.transform);
                },
                onCenter: ()=>{
                    if (!this.transformState) return;
                    this.transformState.transform = (0, $b14ff3017e98e7d9$export$552b36716f27e91b)(this.transformState.transform, {
                        x: this.klCanvas.getWidth() / 2,
                        y: this.klCanvas.getHeight() / 2
                    });
                    this.propagateTransformationChange();
                    this.easelSelect.setTransform(this.transformState.transform);
                },
                onMoveToLayer: (index)=>{
                    if (!this.transformState) return;
                    this.resetKlCanvasLayerComposites();
                    this.transformState.targetLayerIndex = index;
                    this.updateComposites();
                    this.onUpdateProject();
                    this.tempHistoryPush();
                },
                onChangeTransparentBackground: (isTransparent)=>{
                    if (!this.transformState) return;
                    this.transformState.backgroundIsTransparent = isTransparent;
                    this.updateComposites();
                    this.onUpdateProject();
                    this.tempHistoryPush();
                },
                onChangeAlgorithm: (algorithm)=>{
                    if (!this.transformState) return;
                    this.transformState.algorithm = algorithm;
                    this.updateComposites();
                    this.onUpdateProject();
                    this.tempHistoryPush();
                },
                onChangeConstrain: (isConstrained)=>{
                    this.easelSelect.setIsConstrained(isConstrained);
                },
                onChangeSnapping: (isSnapping)=>{
                    this.easelSelect.setIsSnapping(isSnapping);
                },
                onChangeWarp: (isWarping)=>{
                    if (!this.transformState) return;
                    const transform = this.transformState.transform;
                    if (isWarping) {
                        if (transform.type === 'free') {
                            const selectionBounds = (0, $08c423c0549b6f9e$export$13786f381c8abcf1)(this.transformState.selectionSample);
                            const matrix = (0, $b14ff3017e98e7d9$export$e464a809f7257768)(transform.freeTransform, selectionBounds);
                            this.transformState.transform = {
                                type: 'ffd',
                                ffd: (0, $b14ff3017e98e7d9$export$a56ca41a0dbe2002)((0, $cb638405dd43878a$export$1dc7cad4a5f0f0a6)(5, 5, (0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)(selectionBounds)), matrix)
                            };
                        } else if (transform.type === 'ffd+free') {
                            const matrix = (0, $b14ff3017e98e7d9$export$e464a809f7257768)(transform.freeTransform, (0, $4c2c6808296c0d73$export$d89ccdf57354a99c)(transform.ffdBounds, 'index'));
                            this.transformState.transform = {
                                type: 'ffd',
                                ffd: (0, $b14ff3017e98e7d9$export$a56ca41a0dbe2002)(transform.ffd, matrix)
                            };
                        }
                    } else if (transform.type === 'ffd') {
                        const ffdBounds = (0, $4c2c6808296c0d73$export$4218cb0e42c2e7e)((0, $2a95441a1b997bbf$export$da260002c67d0dd)(transform.ffd));
                        const freeTransform = (0, $b14ff3017e98e7d9$export$928f0648354c9a2f)(ffdBounds);
                        this.transformState.transform = {
                            type: 'ffd+free',
                            ffd: (0, $be957da3610487e9$export$921068d8846a1559).copyObj(transform.ffd),
                            ffdBounds: ffdBounds,
                            freeTransform: freeTransform
                        };
                    }
                    this.transformState.isWarping = isWarping;
                    this.easelSelect.setTransform(this.transformState.transform);
                    this.updateComposites();
                    this.onUpdateProject();
                    this.tempHistoryPush();
                }
            },
            onErase: ()=>{
                this.onErase();
            },
            onFill: ()=>{
                this.onFill();
            }
        });
        this.klHistory.addListener(()=>{
            const selection = this.klCanvas.getSelection();
            if (this.selectMode === 'select') this.selectTool.setSelection(selection);
        });
    }
}


class $2ce7d1dfd46df5b7$export$ab82e91194f5da86 {
    emit(type) {
        this.listeners.forEach((item)=>item(type));
    }
    push(entry) {
        while(this.currentIndex < this.entries.length - 1)this.entries.pop();
        this.entries.push(entry);
        this.currentIndex = this.entries.length - 1;
        setTimeout(()=>this.emit('push'));
    }
    replaceTop(newEntry) {
        this.entries.splice(this.currentIndex);
        this.entries.push(newEntry);
        this.currentIndex = this.entries.length - 1;
        setTimeout(()=>this.emit('push'));
    }
    canDecreaseIndex() {
        return this.currentIndex > 0;
    }
    canIncreaseIndex() {
        return this.currentIndex < this.entries.length - 1;
    }
    // aka undo
    decreaseIndex() {
        if (!this.canDecreaseIndex()) return;
        this.currentIndex--;
        setTimeout(()=>this.emit('decrease'));
    }
    // aka redo
    increaseIndex() {
        if (!this.canIncreaseIndex()) return;
        this.currentIndex++;
        setTimeout(()=>this.emit('increase'));
    }
    // all entries up to currentIndex
    getEntries() {
        return this.entries.slice(0, this.currentIndex + 1);
    }
    clear() {
        this.entries = [];
        this.currentIndex = -1;
        setTimeout(()=>this.emit('clear'));
    }
    // emits on push, decrease, increase, clear, or toggle active
    addListener(listener) {
        if (this.listeners.includes(listener)) return;
        this.listeners.push(listener);
    }
    removeListener(listener) {
        this.listeners.map((item, index)=>{
            if (item === listener) this.listeners.splice(index, 1);
        });
    }
    setIsActive(isActive) {
        if (this.isActive === isActive) return;
        this.isActive = isActive;
        this.emit('active');
    }
    getIsActive() {
        return this.isActive;
    }
    // ----------------------------------- public -----------------------------------
    constructor(){
        this.entries = [];
        this.currentIndex = -1;
        this.listeners = [];
        this.isActive = false;
    }
}





class $3c8d80bb9e6c6c3e$export$3e66e8feec69f8d {
    // -------------------- public ----------------------
    constructor(){
        if (!('visualViewport' in window) || visualViewport === null) return;
        const viewport = visualViewport;
        let isDismissed = false;
        const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('browser-zoom-help'),
            className: 'kl-pinch-overlay',
            css: {
                position: 'fixed',
                pointerEvents: 'none',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: '100',
                flexDirection: 'column',
                gap: 10,
                padding: 10,
                backdropFilter: 'blur(3px)'
            }
        });
        (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: rootEl,
            tagName: 'button',
            className: 'kl-button',
            content: (0, $fc42a07754814920$export$ce37e184d908d785)('dismiss'),
            onClick: ()=>{
                isDismissed = true;
                iframe.remove();
                rootEl.remove();
            },
            css: {
                pointerEvents: 'initial'
            }
        });
        // iframe allows pinch-zooming the page even if viewport meta tag set to user-scalable=no
        const iframe = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'iframe',
            css: {
                position: 'fixed',
                width: '100vw',
                height: '100vh',
                zIndex: 99,
                opacity: 0
            }
        });
        let isInDom = false;
        function check() {
            if (!document.body) // somehow this is possible although all scripts run from within <body>
            // observed with user agent: Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/146.0.0.0 Safari/537.36
            return;
            if (isDismissed) return;
            const testEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: document.body,
                css: {
                    position: 'fixed',
                    inset: 0,
                    zIndex: -1
                }
            });
            const rect = testEl.getBoundingClientRect();
            testEl.remove();
            const isZoomed = (viewport.width !== Math.round(rect.width) || viewport.height !== Math.round(rect.height)) && viewport.scale > 1;
            if (isZoomed) {
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(rootEl, {
                    left: viewport.offsetLeft,
                    top: viewport.offsetTop,
                    width: viewport.width,
                    height: viewport.height
                });
                if (!isInDom) {
                    document.body.append(iframe);
                    document.body.append(rootEl);
                }
            } else if (isInDom) {
                iframe.remove();
                rootEl.remove();
            }
            isInDom = isZoomed;
        }
        viewport.addEventListener('resize', check);
        viewport.addEventListener('scroll', check);
        setTimeout(check);
    }
}



class $4693929864e33be7$export$cb9945923eaef1dd {
    /**
     * If UI is frozen while pressing undo/redo, the user might click multiple times
     * because they think the click wasn't registered.
     * This test prevents multiple undo/redo at once.
     * true = skip
     */ testShouldSkip() {
        if (this.doIgnore) return true;
        this.doIgnore = true;
        setTimeout(()=>{
            this.doIgnore = false;
        }, 0);
        return false;
    }
    canUndo() {
        return this.tempHistory.getIsActive() && this.tempHistory.canDecreaseIndex() || this.klHistory.canUndo();
    }
    canRedo() {
        if (this.tempHistory.getIsActive()) return this.tempHistory.canIncreaseIndex();
        return this.klHistory.canRedo();
    }
    // returns undefined if it can't undo
    undo() {
        if (this.testShouldSkip()) return undefined;
        if (this.tempHistory.getIsActive() && this.tempHistory.canDecreaseIndex()) {
            this.tempHistory.decreaseIndex();
            return {
                type: 'tempUndo'
            };
        }
        if (!this.klHistory.canUndo()) return undefined;
        this.klHistory.decreaseIndex();
        return {
            type: 'undo'
        };
    }
    // returns undefined if it can't redo
    redo() {
        if (this.testShouldSkip()) return undefined;
        if (this.tempHistory.getIsActive() && this.tempHistory.canIncreaseIndex()) {
            this.tempHistory.increaseIndex();
            return {
                type: 'tempRedo'
            };
        }
        if (!this.klHistory.canRedo()) return undefined;
        this.klHistory.increaseIndex();
        return {
            type: 'redo'
        };
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.doIgnore = false;
        this.lastCanUndo = false;
        this.lastCanRedo = false;
        this.klHistory = p.klHistory;
        this.tempHistory = p.tempHistory;
        this.onCanUndoRedoChange = p.onCanUndoRedoChange;
        const emitCanUndoRedo = ()=>{
            const canUndo = this.canUndo();
            const canRedo = this.canRedo();
            if (this.lastCanUndo === canUndo && this.lastCanRedo === canRedo) return;
            this.lastCanUndo = canUndo;
            this.lastCanRedo = canRedo;
            this.onCanUndoRedoChange(canUndo, canRedo);
        };
        this.klHistory.addListener(emitCanUndoRedo);
        this.tempHistory.addListener(emitCanUndoRedo);
    }
}



function $b31e47e994a6284f$export$beb462111ff337c5(entry) {
    const keys = Object.keys(entry);
    return keys.length === 1 && keys[0] === 'activeLayerId';
}






class $4f0d150541aeb1cb$export$38b681d46b785af1 {
    update() {
        if (this.isVisible) {
            if (this.toolspaceIsOpen) {
                this.mobileWrapperEl.style.display = 'none';
                if (this.orientation === 'left') (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
                    left: 271,
                    right: ''
                });
                else (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
                    left: '',
                    right: 271
                });
            } else {
                this.mobileWrapperEl.style.display = 'flex';
                if (this.orientation === 'left') (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
                    left: 0,
                    right: ''
                });
                else (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
                    left: '',
                    right: 0
                });
            }
            this.rootEl.style.display = 'block';
        } else this.rootEl.style.display = 'none';
    }
    setOrientation(orientation) {
        this.orientation = orientation;
        this.toolspaceCollapser.setOrientation(orientation);
    }
    setIsVisible(b) {
        this.isVisible = b;
    }
    getToolspaceIsOpen() {
        return this.toolspaceIsOpen;
    }
    setToolspaceIsOpen(b) {
        this.toolspaceIsOpen = b;
        this.toolspaceCollapser.setIsOpen(b);
        this.onShowToolspace(b);
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.toolspaceIsOpen = true;
        this.orientation = 'right';
        this.isVisible = false;
        this.onShowToolspace = p.onShowToolspace;
        this.toolspaceCollapser = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).ToolspaceCollapser({
            onChange: ()=>{
                this.toolspaceIsOpen = this.toolspaceCollapser.isOpen();
                this.onShowToolspace(this.toolspaceIsOpen);
                if (this.toolspaceIsOpen) (0, $7a8f101d3676d17a$export$19fffca37ef3e106).removeItem('uiShowMobile');
                else (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem('uiShowMobile', 'true');
            }
        });
        this.mobileWrapperEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                marginTop: 4,
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        });
        this.mobileWrapperEl.append(...p.toolUis);
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                position: 'absolute',
                top: 0,
                userSelect: 'none'
            }
        });
        this.rootEl.append(this.toolspaceCollapser.getElement(), this.mobileWrapperEl);
        this.update();
    }
}







const $0c12e2fdb2b1466a$var$brushIconImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-paint');
const $0c12e2fdb2b1466a$var$eraserIconImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('brush-eraser');
class $0c12e2fdb2b1466a$export$87fd7552ee5cd26e {
    setIsVisible(b) {
        this.rootEl.style.display = b ? 'block' : 'none';
    }
    setType(type) {
        this.brushOptions.setValue(type, true);
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        const brushIcon = new (0, $9a4caa1ec0cbd978$export$f04a61298a47a40f)({
            imageUrl: $0c12e2fdb2b1466a$var$brushIconImg,
            width: 28,
            height: 28,
            darkInvert: true,
            css: {
                margin: 4
            }
        });
        const eraserIcon = new (0, $9a4caa1ec0cbd978$export$f04a61298a47a40f)({
            imageUrl: $0c12e2fdb2b1466a$var$eraserIconImg,
            width: 28,
            height: 28,
            darkInvert: true,
            css: {
                margin: 4
            }
        });
        this.brushOptions = new (0, $bf43abcd46abf209$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'brush',
                    label: brushIcon.getElement(),
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('tool-brush')
                },
                {
                    id: 'eraser',
                    label: eraserIcon.getElement(),
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('eraser')
                }
            ],
            initId: 'brush',
            onChange: (id)=>{
                if (id === 'brush') p.onBrush();
                else p.onEraser();
            },
            isColumn: true
        });
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {}
        });
        this.rootEl.append(this.brushOptions.getElement());
    }
}







function $b755383612084e8a$export$f8f3f96593f6a47(project) {
    let lastId = '';
    const layerMap = Object.fromEntries(project.layers.map((layer, index)=>{
        lastId = (0, $f13a819f841fbdb5$export$b2ce7a8a096070e2)();
        let tiles = [];
        if (layer.image instanceof Array) tiles = [
            ...layer.image
        ];
        else {
            const canvas = (()=>{
                if (layer.image instanceof HTMLCanvasElement) return layer.image;
                const canvas = (0, $be957da3610487e9$export$921068d8846a1559).canvas(project.width, project.height);
                const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(canvas);
                if ((0, $2bd547100370cd3c$export$dba0834b723f37f4)(layer.image)) {
                    ctx.fillStyle = layer.image.fill;
                    ctx.fillRect(0, 0, project.width, project.height);
                } else ctx.drawImage(layer.image, 0, 0);
                return canvas;
            })();
            tiles = (0, $3aa9c52208735678$export$7b1ba44282f9a519)(canvas);
        }
        return [
            lastId,
            {
                name: layer.name,
                opacity: layer.opacity,
                isVisible: layer.isVisible,
                mixModeStr: layer.mixModeStr,
                hasClipping: layer.hasClipping,
                index: index,
                tiles: tiles
            }
        ];
    }));
    return {
        projectId: {
            value: project.projectId
        },
        size: {
            width: project.width,
            height: project.height
        },
        selection: {},
        activeLayerId: lastId,
        layerMap: layerMap
    };
}



class $09c50d395e24995f$export$747c5e57cda7ca57 {
    update() {
        const historyIndex = this.klHistory.getTotalIndex();
        if (this.getLastSavedHistoryIndex() !== historyIndex) window.addEventListener('beforeunload', this.onBeforeUnload);
        else window.removeEventListener('beforeunload', this.onBeforeUnload);
    }
    destroy() {
    //...
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.onBeforeUnload = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        this.klHistory = p.klHistory;
        this.getLastSavedHistoryIndex = p.getLastSavedHistoryIndex;
        p.klHistory.addListener(()=>this.update());
    }
}






var $f8757f75a915ee7b$export$bb5ee47d9ea2348e;
var $f8757f75a915ee7b$export$534219b709288da9;
var $f8757f75a915ee7b$export$8001e369bcc9b474;
var $f8757f75a915ee7b$export$efe229eab43a9869;
var $f8757f75a915ee7b$export$ad430d422a89f9f0;
var $f8757f75a915ee7b$export$48c2d0f2f545ac27;
var $f8757f75a915ee7b$export$4a3e8128f471434a;
var $f8757f75a915ee7b$export$e8e78c978b129247;
var $f8757f75a915ee7b$export$bbeb943159d69f5b;
$f8757f75a915ee7b$export$bb5ee47d9ea2348e = `RP219q_banner`;
$f8757f75a915ee7b$export$534219b709288da9 = `RP219q_btn`;
$f8757f75a915ee7b$export$8001e369bcc9b474 = `RP219q_closeArea`;
$f8757f75a915ee7b$export$efe229eab43a9869 = `RP219q_closeButton`;
$f8757f75a915ee7b$export$ad430d422a89f9f0 = `RP219q_mainContent`;
$f8757f75a915ee7b$export$48c2d0f2f545ac27 = `RP219q_preview`;
$f8757f75a915ee7b$export$4a3e8128f471434a = `RP219q_rightCol`;
$f8757f75a915ee7b$export$e8e78c978b129247 = `RP219q_root`;
$f8757f75a915ee7b$export$bbeb943159d69f5b = `RP219q_rootAnim`;
$f8757f75a915ee7b$export$bbeb943159d69f5b;





const $b7defe50cfcdbb1a$var$cancelImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('cancel');
async function $b7defe50cfcdbb1a$export$4a2ed1038e76f37f(p) {
    /*
    only show banner if all:
    - nothing was recovered
    - project store is not empty
    - no other tab has this project already open (prevent confusion)
     */ if (!p.projectStore) // no store -> noop
    return;
    const openedProjectIds = [];
    {
        const crossTabChannel = new (0, $c7ee49b4041304a6$export$84f7c9d87f70395e)('kl-tab-communication');
        // This subscription stays up during run of application.
        // It's to ensure other tabs know if the browser storage project is already opened.
        crossTabChannel.subscribe((message)=>{
            if (message.type === 'request-project-ids') crossTabChannel.postMessage({
                type: 'response-project-id',
                id: p.klHistory.getComposed().projectId.value
            });
        });
        const otherIdListener = (message)=>{
            if (message.type === 'response-project-id') openedProjectIds.push(message.id);
        };
        crossTabChannel.subscribe(otherIdListener);
        crossTabChannel.postMessage({
            type: 'request-project-ids'
        });
        await (0, $94f0b2b810d4d191$export$e772c8ff12451969)(100);
        crossTabChannel.unsubscribe(otherIdListener);
    }
    if (p.klRecoveryManager?.getTabId() !== undefined) // something already recovered -> noop
    return;
    const meta = await p.projectStore.readMeta();
    if (!meta) // nothing stored -> noop
    return;
    if (openedProjectIds.includes(meta.projectId)) // already open in other tab -> noop
    return;
    const fit = (0, $94f0b2b810d4d191$export$fa55905620c22535)(meta.thumbnail.width, meta.thumbnail.height, 100, 100);
    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(meta.thumbnail, {
        width: fit.width,
        height: fit.height
    });
    const closeButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'button',
        className: $f8757f75a915ee7b$export$efe229eab43a9869 + ' popup-x',
        content: `<img alt="${(0, $fc42a07754814920$export$ce37e184d908d785)('modal-close')}" height="20" src="${$b7defe50cfcdbb1a$var$cancelImg}">`,
        title: (0, $fc42a07754814920$export$ce37e184d908d785)('modal-close'),
        props: {
            tabIndex: 0
        }
    });
    closeButton.onclick = close;
    const preview = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: $f8757f75a915ee7b$export$48c2d0f2f545ac27,
        content: meta.thumbnail,
        title: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-open')
    });
    preview.onclick = ()=>{
        close();
        p.onOpenBrowserStorage();
    };
    const title = (0, $be957da3610487e9$export$921068d8846a1559).el({
        content: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage')
    });
    const buttonClass = $f8757f75a915ee7b$export$534219b709288da9;
    const openBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
        tagName: 'button',
        className: [
            'kl-button',
            'kl-button-primary',
            buttonClass
        ],
        content: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-open'),
        props: {
            tabIndex: -1
        }
    });
    openBtn.onclick = ()=>{
        close();
        p.onOpenBrowserStorage();
    };
    const rightCol = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: $f8757f75a915ee7b$export$4a3e8128f471434a,
        content: [
            title,
            openBtn
        ]
    });
    const mainContent = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: $f8757f75a915ee7b$export$ad430d422a89f9f0,
        content: [
            preview,
            rightCol
        ]
    });
    const closeArea = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: $f8757f75a915ee7b$export$8001e369bcc9b474
    });
    closeArea.onclick = close;
    const banner = (0, $be957da3610487e9$export$921068d8846a1559).el({
        className: $f8757f75a915ee7b$export$bb5ee47d9ea2348e,
        content: [
            mainContent,
            closeButton
        ]
    });
    banner.onclick = (0, $be957da3610487e9$export$921068d8846a1559).handleClick;
    const rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
        content: [
            closeArea,
            banner
        ],
        className: $f8757f75a915ee7b$export$e8e78c978b129247
    });
    document.body.append(rootEl);
    function close() {
        clearTimeout(timeout);
        document.removeEventListener('pointerdown', onPointerDown);
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(rootEl, {
            opacity: 0
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(banner, {
            pointerEvents: 'none'
        });
        setTimeout(()=>{
            rootEl.remove();
        }, 200);
    }
    function checkCanClose() {
        if (banner.matches(':hover')) {
            timeout = setTimeout(checkCanClose, 500);
            return;
        }
        close();
    }
    let timeout = setTimeout(checkCanClose, 4500);
    const onPointerDown = (e)=>{
        const target = e.target;
        if (banner.contains(target)) return;
        close();
    };
    document.addEventListener('pointerdown', onPointerDown, {
        passive: false
    });
}










const $baecd4659396dff5$var$eyedropperImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-picker');
class $baecd4659396dff5$export$f27d6e4616dd9b30 {
    getIsEyedropping() {
        return this.eyedropperToggle.getValue();
    }
    setIsEyedropping(b) {
        this.eyedropperToggle.setValue(b);
    }
    setColor(color) {
        this.color = {
            ...color
        };
        this.colorCircle.style.backgroundColor = (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr(color);
        this.colorPickerWindow?.setColor(color);
    }
    closeColorPicker() {
        if (this.colorPickerWindow) {
            this.colorPickerWindow.destroy();
            this.colorPickerWindow = undefined;
        }
    }
    setIsVisible(b) {
        this.rootEl.style.display = b ? 'flex' : 'none';
        if (!b) this.closeColorPicker();
    }
    getElement() {
        return this.rootEl;
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.colorPickerPosition = {
            x: 100,
            y: 100
        };
        this.color = {
            r: 0,
            g: 0,
            b: 0
        };
        this.color = {
            ...p.color
        };
        this.colorCircle = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: 30,
                height: 30,
                background: (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr(p.color),
                borderRadius: '100%',
                boxShadow: '0 0 0 1px rgba(0,0,0,0.5), inset 0 0 0 1px rgba(255,255,255,0.5)',
                alignSelf: 'center',
                cursor: 'pointer'
            },
            onClick: ()=>{
                if (this.colorPickerWindow) {
                    this.closeColorPicker();
                    return;
                }
                this.colorPickerWindow = new (0, $364f444c1ac877b6$export$214507535a0fe5b2)({
                    color: this.color,
                    onChange: p.onColorChange,
                    onClose: ()=>this.closeColorPicker(),
                    onMove: (position)=>{
                        this.colorPickerPosition = position;
                    },
                    position: this.colorPickerPosition
                });
            }
        });
        const icon = new (0, $9a4caa1ec0cbd978$export$f04a61298a47a40f)({
            imageUrl: $baecd4659396dff5$var$eyedropperImg,
            width: 1,
            height: 1,
            css: {
                width: '100%',
                height: '100%'
            },
            darkInvert: true
        });
        this.eyedropperToggle = new (0, $0b383e4686740404$export$2358c75ad3c15b2d)({
            init: false,
            title: (0, $fc42a07754814920$export$ce37e184d908d785)('eyedropper'),
            onChange: (b)=>{
                p.onEyedropper(b);
            },
            label: (0, $be957da3610487e9$export$921068d8846a1559).el({
                content: icon.getElement(),
                css: {
                    padding: 6,
                    height: 36
                }
            })
        });
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4
            }
        });
        this.rootEl.append(this.colorCircle, this.eyedropperToggle.getElement());
    }
}





// unfocus buttons that are intended to be unfocused (tabIndex=-1)
function $3fec33d627ef1f3a$export$38c09d1055eef009() {
    document.addEventListener('click', (event)=>{
        const target = event.target;
        const button = target instanceof Element ? target.closest('button') : null;
        if (button instanceof HTMLButtonElement && button.tabIndex === -1 && document.activeElement === button) button.blur();
    });
}




var $c5a6cb51fc88122c$export$e8e78c978b129247;
$c5a6cb51fc88122c$export$e8e78c978b129247 = `Lmy4tW_root`;


const $77e901a73d057ac0$var$animationDurationMs = 300;
class $77e901a73d057ac0$export$ebe217a0232decd2 {
    show(image, yCenter) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
        if (this.rootEl.parentElement) {
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
                top: Math.max(10, Math.round(yCenter - image?.height / 2)),
                opacity: 1
            });
            this.rootEl.replaceChildren(image);
            return;
        }
        this.timeout = setTimeout(()=>{
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
                top: Math.max(10, Math.round(yCenter - image?.height / 2)),
                opacity: 0
            });
            this.rootEl.replaceChildren(image);
            document.body.append(this.rootEl);
            this.timeout = setTimeout(()=>{
                (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
                    opacity: 1
                });
            }, 20);
        }, 250);
    }
    hide() {
        clearTimeout(this.timeout);
        this.timeout = undefined;
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
            opacity: 0
        });
        this.timeout = setTimeout(()=>{
            this.rootEl.remove();
            this.rootEl.replaceChildren();
        }, $77e901a73d057ac0$var$animationDurationMs + 20);
    }
    setUiState(stateStr) {
        this.uiState = stateStr;
        if (this.uiState === 'left') (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
            left: 280,
            right: undefined
        });
        else (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.rootEl, {
            left: undefined,
            right: 280
        });
    }
    // ----------------------- public -----------------------
    constructor(){
        this.uiState = 'right';
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: $c5a6cb51fc88122c$export$e8e78c978b129247,
            css: {
                transition: 'opacity ' + $77e901a73d057ac0$var$animationDurationMs + 'ms ease-in-out'
            }
        });
    }
}


const $8d08c083c4b95b50$var$toolPaintImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-paint');
const $8d08c083c4b95b50$var$toolHandImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-hand');
const $8d08c083c4b95b50$var$toolFillImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-fill');
const $8d08c083c4b95b50$var$toolGradientImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-gradient');
const $8d08c083c4b95b50$var$toolTextImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-text');
const $8d08c083c4b95b50$var$toolShapeImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-shape');
const $8d08c083c4b95b50$var$toolSelectImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tool-select');
const $8d08c083c4b95b50$var$tabSettingsImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tab-settings');
const $8d08c083c4b95b50$var$tabLayersImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tab-layers');
const $8d08c083c4b95b50$var$tabEditImg = (0, $1b4b6b9aff0ae5e5$export$89d1c740383224f4)('tab-edit');
(0, $5e9f44c5ddf923e3$export$4283b00eae4a6956)();
/**
 * Toolspace shrinks as the window gets shorter: first the color slider, then the tool row becomes small,
 * then the layer preview hides. Only after that does it overflow.
 * Values are tuned so the tallest brush tab (pixel) fits, with 10px spacing above the bottom bar.
 */ function $8d08c083c4b95b50$var$getToolspaceLayout(uiHeight) {
    const otherContentHeight = 478; // everything but color slider, with layer preview and large tool row
    const toolRowSaving = 18; // when small
    const layerPreviewSmallSaving = 4; // 36px instead of 40px
    const colorSliderMin = 158;
    const colorSliderMax = 400;
    let available = uiHeight - otherContentHeight;
    const isToolRowSmall = available < colorSliderMin;
    if (isToolRowSmall) available += toolRowSaving + layerPreviewSmallSaving;
    const isLayerPreviewSmall = isToolRowSmall;
    const isLayerPreviewVisible = available >= colorSliderMin;
    if (!isLayerPreviewVisible) available += isLayerPreviewSmall ? 26 : 30; // hidden preview keeps a 10px bottom margin
    return {
        isLayerPreviewVisible: isLayerPreviewVisible,
        isLayerPreviewSmall: isLayerPreviewSmall,
        isToolRowSmall: isToolRowSmall,
        colorSliderHeight: Math.max(colorSliderMin, Math.min(colorSliderMax, available))
    };
}
class $8d08c083c4b95b50$export$96f6458b62e4c2c {
    updateLastSaved() {
        this.lastSavedHistoryIndex = this.klHistory.getTotalIndex();
        this.saveReminder?.reset();
        this.unloadWarningTrigger?.update();
    }
    updateCollapse(isInitial) {
        if (isInitial) {
            const isMobile = Boolean((0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem('uiShowMobile') ?? false);
            if (isMobile) this.mobileUi.setToolspaceIsOpen(false);
        }
        this.mobileUi.setOrientation(this.uiLayout);
        if (this.uiWidth < this.collapseThreshold) {
            this.mobileUi.setIsVisible(true);
            if (this.mobileUi.getToolspaceIsOpen()) {
                if (this.uiLayout === 'left') (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.easel.getElement(), {
                    left: 271
                });
                else (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.easel.getElement(), {
                    left: 0
                });
                this.toolspace.style.display = 'block';
                this.easel.setSize(Math.max(0, this.uiWidth - this.toolWidth), this.uiHeight);
                this.statusOverlay.setWide(false);
            } else {
                if (this.uiLayout === 'left') (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.easel.getElement(), {
                    left: 0
                });
                else (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.easel.getElement(), {
                    left: 0
                });
                this.toolspace.style.display = 'none';
                this.easel.setSize(Math.max(0, this.uiWidth), this.uiHeight);
                this.statusOverlay.setWide(true);
            }
        } else {
            this.mobileColorUi.closeColorPicker();
            this.mobileUi.setIsVisible(false);
            if (this.uiLayout === 'left') (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.easel.getElement(), {
                left: 271
            });
            this.toolspace.style.display = 'block';
            this.easel.setSize(Math.max(0, this.uiWidth - this.toolWidth), this.uiHeight);
            this.statusOverlay.setWide(false);
        }
        this.mobileUi.update();
    }
    updateUi() {
        this.toolspace.classList.toggle('kl-toolspace--left', this.uiLayout === 'left');
        this.toolspace.classList.toggle('kl-toolspace--right', this.uiLayout === 'right');
        if (this.uiLayout === 'left') {
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.toolspace, {
                left: 0,
                right: ''
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.easel.getElement(), {
                left: 271
            });
        } else {
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.toolspace, {
                left: '',
                right: 0
            });
            (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.easel.getElement(), {
                left: 0
            });
        }
        this.statusOverlay.setUiState(this.uiLayout);
        this.floatingLayerPreview.setUiState(this.uiLayout);
        this.updateCollapse();
        this.toolspaceScroller.updateUiState(this.uiLayout);
    }
    // -------- interface --------
    getElement() {
        return this.rootEl;
    }
    resize(w, h) {
        // iPad scrolls down when increasing text zoom
        if (window.scrollY > 0) window.scrollTo(0, 0);
        if (this.uiWidth === Math.max(0, w) && this.uiHeight === Math.max(0, h)) return;
        this.uiWidth = Math.max(0, w);
        this.uiHeight = Math.max(0, h);
        this.updateCollapse();
        const toolspaceLayout = $8d08c083c4b95b50$var$getToolspaceLayout(this.uiHeight);
        this.layerPreview.setIsVisible(toolspaceLayout.isLayerPreviewVisible);
        this.layerPreview.setIsSmall(toolspaceLayout.isLayerPreviewSmall);
        this.klColorSlider.setHeight(toolspaceLayout.colorSliderHeight);
        this.toolspaceToolRow.setIsSmall(toolspaceLayout.isToolRowSmall);
    }
    out(msg) {
        this.statusOverlay.out(msg);
    }
    async getPNG() {
        return await (0, $2f436639594531f3$export$403d539f215df596)(this.klCanvas.getCanvas(), 'image/png');
    }
    getProject() {
        return this.klCanvas.getProject();
    }
    swapUiLeftRight() {
        this.uiLayout = this.uiLayout === 'left' ? 'right' : 'left';
        if (!this.embed) (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem('uiState', this.uiLayout);
        this.updateUi();
    }
    setLogo(logoImg, isPixelated, keepOriginalColors) {
        if (this.toolspaceTopRow instanceof (0, $e3cc87398ab80fdb$export$665d2c76b1eb8459)) this.toolspaceTopRow.setLogo(logoImg, isPixelated, keepOriginalColors);
    }
    saveAsPsd() {
        this.saveToComputer.save('psd');
    }
    isDrawing() {
        return this.lineSanitizer.getIsDrawing() || this.easel.getIsLocked();
    }
    // ----------------------------------- public -----------------------------------
    constructor(p){
        this.collapseThreshold = 820;
        this.toolWidth = 271;
        this.lastSavedHistoryIndex = 0;
        this.getPSD = async ()=>{
            return await (0, $2f59a00fe0e77e1d$export$92433b641be3f7a)(this.klCanvas, false);
        };
        (0, $3fec33d627ef1f3a$export$38c09d1055eef009)();
        this.embed = p.embed;
        this.helpPath = p.helpPath ?? 'help.html';
        // default 2048, unless your screen is bigger than that (that computer then probably has the horsepower for that)
        // but not larger than 4096 - a fairly arbitrary decision
        const maxCanvasSize = Math.min(4096, Math.max(2048, Math.max(window.screen.width, window.screen.height)));
        this.uiLayout = this.embed ? 'left' : (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem('uiState') ? (0, $7a8f101d3676d17a$export$19fffca37ef3e106).getItem('uiState') : 'right';
        const projectStore = (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).getIsAvailable() ? new (0, $37813638caeb4048$export$93d91060b9af7e2a)() : undefined;
        this.rootEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'g-root',
            css: {
                position: 'absolute',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            }
        });
        this.uiWidth = Math.max(0, window.innerWidth);
        this.uiHeight = Math.max(0, window.innerHeight);
        let exportType = 'png';
        const initialWidth = Math.max(10, Math.min(maxCanvasSize, window.innerWidth < this.collapseThreshold ? this.uiWidth : this.uiWidth - this.toolWidth));
        const initialHeight = Math.max(10, Math.min(maxCanvasSize, this.uiHeight));
        this.klHistory = new (0, $211b564339712990$export$1a1044741a812c67)({
            oldest: (0, $b755383612084e8a$export$f8f3f96593f6a47)(p.project ?? {
                projectId: (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)(),
                width: initialWidth,
                height: initialHeight,
                layers: [
                    {
                        name: (0, $fc42a07754814920$export$ce37e184d908d785)('layers-layer') + ' 1',
                        opacity: 1,
                        isVisible: true,
                        mixModeStr: 'source-over',
                        hasClipping: false,
                        image: {
                            fill: (0, $be957da3610487e9$export$921068d8846a1559).ColorConverter.toRgbStr({
                                r: (0, $bc268e0fc7103648$export$e4203cb02d5e5b28),
                                g: (0, $bc268e0fc7103648$export$e4203cb02d5e5b28),
                                b: (0, $bc268e0fc7103648$export$e4203cb02d5e5b28)
                            })
                        }
                    }
                ]
            })
        });
        const klRecoveryManager = p.klRecoveryManager;
        if (klRecoveryManager) {
            klRecoveryManager.setKlHistory(this.klHistory);
            klRecoveryManager.setGetThumbnail((factor)=>this.klCanvas.getCanvas(factor));
        }
        if (p.project) // attempt at freeing memory
        p.project.layers.forEach((layer)=>{
            if (layer.image instanceof HTMLCanvasElement) (0, $be957da3610487e9$export$921068d8846a1559).freeCanvas(layer.image);
            layer.image = null;
        });
        this.klCanvas = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).KlCanvas(this.klHistory, this.embed ? -1 : 1);
        const tempHistory = new (0, $2ce7d1dfd46df5b7$export$ab82e91194f5da86)();
        let mainTabRow = undefined;
        const clearLayer = (showStatus, ignoreSelection)=>{
            applyUncommitted();
            const layerIndex = currentLayerIndex;
            this.klCanvas.eraseLayer({
                layerIndex: layerIndex,
                useAlphaLock: layerIndex === 0 && !brushUiMap.eraserBrush.getIsTransparentBg(),
                useSelection: !ignoreSelection
            });
            showStatus && this.statusOverlay.out(this.klCanvas.getSelection() ? (0, $fc42a07754814920$export$ce37e184d908d785)('cleared-selected-area') : (0, $fc42a07754814920$export$ce37e184d908d785)('cleared-layer'), true);
        };
        let currentColor = new (0, $be957da3610487e9$export$921068d8846a1559).RGB(0, 0, 0);
        let currentBrushUi;
        let currentBrushId;
        let lastNonEraserBrushId;
        let currentLayerIndex = this.klCanvas.getLayerCount() - 1;
        // when cycling through brushes you need to know the next non-eraser brush
        const getNextBrushId = ()=>{
            if (currentBrushId === 'eraserBrush') return lastNonEraserBrushId;
            const keyArr = Object.keys(brushUiMap).filter((item)=>item !== 'eraserBrush');
            const i = keyArr.findIndex((item)=>item === currentBrushId);
            return keyArr[(i + 1) % keyArr.length];
        };
        const sizeWatcher = (val)=>{
            brushSettingService.emitSize(val);
            if (this.easelBrush) this.easelBrush.setBrush({
                radius: val
            });
        };
        const brushSettingService = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BrushSettingService({
            onSetColor: (color)=>{
                this.klColorSlider.setColor(color);
                currentBrushUi.setColor(color);
                this.mobileColorUi.setColor(color);
                currentColor = (0, $be957da3610487e9$export$921068d8846a1559).copyObj(color);
            },
            onSetSize: (size)=>{
                currentBrushUi.setSize(size);
                this.easelBrush.setBrush({
                    radius: size
                });
            },
            onSetOpacity: (opacity)=>{
                currentBrushUi.setOpacity(opacity);
            },
            onGetColor: ()=>this.klColorSlider.getColor(),
            onGetSize: ()=>brushUiMap[currentBrushId].getSize(),
            onGetOpacity: ()=>brushUiMap[currentBrushId].getOpacity(),
            onGetSliderConfig: ()=>{
                return {
                    sizeSlider: (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].sizeSlider,
                    opacitySlider: (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].opacitySlider
                };
            }
        });
        const lineSmoothing = new (0, $ba111226d39f0ec4$export$c57e2ed65bcf4d6a)({
            smoothing: (0, $603f5a48e1f92529$export$bcd109042a2e4bb5)(1)
        });
        this.lineSanitizer = new (0, $675f74f720367ea9$export$91dcf4209534d21f)();
        const drawEventChain = new (0, $be957da3610487e9$export$921068d8846a1559).EventChain({
            chainArr: [
                this.lineSanitizer,
                lineSmoothing
            ]
        });
        drawEventChain.setChainOut((event)=>{
            if (event.type === 'down') {
                this.toolspace.style.pointerEvents = 'none';
                currentBrushUi.startLine(event.x, event.y, event.pressure);
                this.easelBrush.setLastDrawEvent({
                    x: event.x,
                    y: event.y
                });
                this.easel.requestRender();
            }
            if (event.type === 'move') {
                currentBrushUi.goLine(event.x, event.y, event.pressure, event.isCoalesced);
                this.easelBrush.setLastDrawEvent({
                    x: event.x,
                    y: event.y
                });
                this.easel.requestRender();
            }
            if (event.type === 'up') {
                this.toolspace.style.pointerEvents = '';
                currentBrushUi.endLine();
                this.easel.requestRender();
            }
            if (event.type === 'line') {
                currentBrushUi.getBrush().drawLineSegment(event.x0, event.y0, event.x1, event.y1);
                this.easelBrush.setLastDrawEvent({
                    x: event.x1,
                    y: event.y1
                });
                this.easel.requestRender();
            }
        });
        let textToolSettings = {
            size: 20,
            align: 'left',
            isBold: false,
            isItalic: false,
            font: 'sans-serif',
            letterSpacing: 0,
            lineHeight: 1,
            fill: {
                color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                }
            }
        };
        /**
         * Uncommited action is something like select tool > transform which puts the canvas and UI into
         * a temporary state. Changes need to be committed or discarded *before* doing something else.
         *
         * returns true if something was applied
         */ const applyUncommitted = ()=>{
            let didApply = false;
            if (this.easel.getTool() === 'select') didApply = klAppSelect.commitTransform();
            return didApply;
        };
        /** see applyUncommitted **/ const discardUncommitted = ()=>{
            if (this.easel.getTool() === 'select') return klAppSelect.discardTransform();
            return false;
        };
        const propagateUndoRedoChanges = (type, composedBefore)=>{
            if ([
                'undo',
                'redo'
            ].includes(type)) {
                const composedAfter = this.klHistory.getComposed();
                this.klCanvas.updateViaComposed(composedBefore, composedAfter);
                setCurrentLayer(composedAfter.layerMap[composedAfter.activeLayerId].index);
                this.easelProjectUpdater.update(); // triggers render
                const dimensionChanged = composedBefore.size.width !== composedAfter.size.width || composedBefore.size.height !== composedAfter.size.height;
                if (dimensionChanged) this.easel.resetOrFitTransform(true);
                this.easelBrush.setLastDrawEvent();
                this.layersUi.update(currentLayerIndex);
            }
            klAppSelect.onHistory(type);
        };
        const undo = (showMessage)=>{
            if (!tempHistory.canDecreaseIndex()) discardUncommitted();
            const composedBefore = this.klHistory.getComposed();
            const result = klHistoryExecutor.undo();
            if (!result) // didn't do anything
            return;
            propagateUndoRedoChanges(result.type, composedBefore);
            if (showMessage) this.statusOverlay.out((0, $fc42a07754814920$export$ce37e184d908d785)('undo'), true);
        };
        const redo = (showMessage)=>{
            const composedBefore = this.klHistory.getComposed();
            const result = klHistoryExecutor.redo();
            if (!result) // didn't do anything
            return;
            propagateUndoRedoChanges(result.type, composedBefore);
            if (showMessage) this.statusOverlay.out((0, $fc42a07754814920$export$ce37e184d908d785)('redo'), true);
        };
        this.statusOverlay = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).StatusOverlay();
        const klAppSelect = new (0, $959ada5c6d90f030$export$e471993a29671b7)({
            klCanvas: this.klCanvas,
            getCurrentLayerIndex: ()=>currentLayerIndex,
            onUpdateProject: ()=>this.easelProjectUpdater.update(),
            klHistory: this.klHistory,
            tempHistory: tempHistory,
            statusOverlay: this.statusOverlay,
            onFill: ()=>{
                this.klCanvas.layerFill(currentLayerIndex, this.klColorSlider.getColor(), undefined, true);
                this.statusOverlay.out(this.klCanvas.getSelection() ? (0, $fc42a07754814920$export$ce37e184d908d785)('filled-selected-area') : (0, $fc42a07754814920$export$ce37e184d908d785)('filled'), true);
            },
            onErase: ()=>{
                const layerIndex = currentLayerIndex;
                this.klCanvas.eraseLayer({
                    layerIndex: layerIndex,
                    useAlphaLock: layerIndex === 0 && !brushUiMap.eraserBrush.getIsTransparentBg(),
                    useSelection: true
                });
                this.statusOverlay.out(this.klCanvas.getSelection() ? (0, $fc42a07754814920$export$ce37e184d908d785)('cleared-selected-area') : (0, $fc42a07754814920$export$ce37e184d908d785)('cleared-layer'), true);
            }
        });
        this.easelBrush = new (0, $eefd099c1f1ae66b$export$dfeedd8879a1038a)({
            radius: 5,
            onLineStart: (e)=>{
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'down',
                    scale: this.easel.getTransform().scale,
                    shiftIsPressed: keyListener.isPressed('shift'),
                    pressure: e.pressure,
                    isCoalesced: e.isCoalesced,
                    x: e.x,
                    y: e.y
                });
            },
            onLineGo: (e)=>{
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'move',
                    scale: this.easel.getTransform().scale,
                    shiftIsPressed: keyListener.isPressed('shift'),
                    pressure: e.pressure,
                    isCoalesced: e.isCoalesced,
                    x: e.x,
                    y: e.y
                });
            },
            onLineEnd: ()=>{
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'up',
                    scale: this.easel.getTransform().scale,
                    shiftIsPressed: keyListener.isPressed('shift'),
                    isCoalesced: false
                });
            },
            onLine: (p1, p2)=>{
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'line',
                    x0: p1.x,
                    y0: p1.y,
                    x1: p2.x,
                    y1: p2.y,
                    pressure0: 1,
                    pressure1: 1
                });
            }
        });
        const easelHand = new (0, $5ca5d42f583e32e1$export$8202a4a90789f655)({});
        const easelShape = new (0, $aa7e232d5dcb3944$export$f4821fa73b1145e5)({
            onDown: (p, angleRad)=>{
                shapeTool.onDown(p.x, p.y, angleRad);
            },
            onMove: (p)=>{
                shapeTool.onMove(p.x, p.y);
            },
            onUp: (p)=>{
                shapeTool.onUp(p.x, p.y);
            }
        });
        let isFirstTransform = true;
        this.easel = new (0, $ed70604d5995cba6$export$2732362bcaeb02c2)({
            onBeforeRender: ()=>{
                currentBrushUi?.getBrush().transferToCanvas?.();
            },
            width: Math.max(0, this.uiWidth - this.toolWidth),
            height: this.uiHeight,
            project: {
                width: this.klCanvas.getWidth(),
                height: this.klCanvas.getHeight(),
                layers: []
            },
            tools: {
                brush: this.easelBrush,
                hand: easelHand,
                select: klAppSelect.getEaselSelect(),
                eyedropper: new (0, $eccddf41322a390c$export$1fda302750a9ba48)({
                    onPick: (p)=>{
                        const color = this.klCanvas.getColorAt(p.x, p.y);
                        if (color) {
                            brushSettingService.setColor(color);
                            return color;
                        }
                        return brushSettingService.getColor();
                    },
                    onPickEnd: ()=>{
                        if (this.klColorSlider.getIsEyedropping() || this.mobileColorUi.getIsEyedropping()) {
                            this.klColorSlider.setIsEyedropping(false);
                            this.mobileColorUi.setIsEyedropping(false);
                            this.easel.setTool(this.toolspaceToolRow.getActive());
                        }
                    }
                }),
                paintBucket: new (0, $15c0e2366e5fdeef$export$9b29623161064b87)({
                    onFill: (p)=>{
                        this.klCanvas.floodFill(currentLayerIndex, p.x, p.y, fillUi.getIsEraser() ? null : this.klColorSlider.getColor(), fillUi.getOpacity(), fillUi.getTolerance(), fillUi.getSample(), fillUi.getGrow(), fillUi.getContiguous());
                        this.easel.requestRender();
                    }
                }),
                gradient: new (0, $dec404f7e2a863cb$export$11badb1ec62816a1)({
                    onDown: (p, angleRad)=>{
                        gradientTool.onDown(p.x, p.y, angleRad);
                    },
                    onMove: (p)=>{
                        gradientTool.onMove(p.x, p.y);
                    },
                    onUp: (p)=>{
                        gradientTool.onUp(p.x, p.y);
                    }
                }),
                text: new (0, $ec661ae45b234a5a$export$b10c22a3fee9197f)({
                    onDown: (p, angleRad)=>{
                        if ((0, $25422d204ef184a3$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0) return;
                        (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).textToolDialog({
                            klCanvas: this.klCanvas,
                            layerIndex: currentLayerIndex,
                            primaryColor: this.klColorSlider.getColor(),
                            secondaryColor: this.klColorSlider.getSecondaryRGB(),
                            text: {
                                ...textToolSettings,
                                text: '',
                                x: p.x,
                                y: p.y,
                                angleRad: angleRad,
                                fill: textToolSettings.fill ? {
                                    color: {
                                        ...this.klColorSlider.getColor(),
                                        a: textToolSettings.fill.color.a
                                    }
                                } : undefined,
                                stroke: textToolSettings.stroke ? {
                                    ...textToolSettings.stroke,
                                    color: {
                                        ...this.klColorSlider.getSecondaryRGB(),
                                        a: textToolSettings.stroke.color.a
                                    }
                                } : undefined
                            },
                            onConfirm: (val)=>{
                                textToolSettings = {
                                    ...val,
                                    text: ''
                                };
                                if (val.fill) brushSettingService.setColor(new (0, $be957da3610487e9$export$921068d8846a1559).RGB(val.fill.color.r, val.fill.color.g, val.fill.color.b));
                                this.klCanvas.text(currentLayerIndex, val);
                            }
                        });
                    }
                }),
                shape: easelShape,
                rotate: new (0, $48668e17d9112bf7$export$f3b0846760df78b)({}),
                zoom: new (0, $b2bad4693d9c09c9$export$6c389c8425707374)({})
            },
            tool: 'brush',
            onChangeTool: (toolId)=>{
                if (toolId !== 'brush' && toolId !== 'eyedropper') currentBrushUi.freeResources?.();
                this.mobileBrushUi.setIsVisible(toolId === 'brush');
                this.mobileColorUi.setIsVisible(toolId !== 'select');
            },
            onTransformChange: (transform, isScaleOrAngleChanged)=>{
                handUi.update(transform.scale, transform.angleDeg, transform.isMirrored);
                this.toolspaceToolRow.setEnableZoomIn(transform.scale !== (0, $00631e3d51f88f11$export$ac82c07320907c00));
                this.toolspaceToolRow.setEnableZoomOut(transform.scale !== (0, $00631e3d51f88f11$export$5e2c057e240c0b8c));
                if (isScaleOrAngleChanged && !isFirstTransform) this.statusOverlay.out({
                    type: 'transform',
                    scale: transform.scale,
                    angleDeg: transform.angleDeg
                });
                if (isFirstTransform) isFirstTransform = false;
            },
            onUndo: ()=>{
                undo(true);
            },
            onRedo: ()=>{
                redo(true);
            },
            onResetSelection: ()=>klAppSelect.resetSelection()
        });
        (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(this.easel.getElement(), {
            position: 'absolute',
            left: 0,
            top: 0
        });
        this.easelProjectUpdater = new (0, $47fa1687308adf8f$export$abfede0290e9bfba)({
            klCanvas: this.klCanvas,
            easel: this.easel
        });
        this.klHistory.addListener(()=>{
            this.easelProjectUpdater.update();
        });
        (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).DIALOG_COUNTER.subscribe((count)=>{
            this.easel.setIsFrozen(count > 0);
        });
        const updateMainTabVisibility = ()=>{
            if (!mainTabRow) return;
            const toolObj = {
                brush: {},
                hand: {},
                paintBucket: {},
                gradient: {},
                text: {},
                shape: {},
                select: {}
            };
            const activeStr = this.toolspaceToolRow.getActive();
            const oldTabId = mainTabRow.getOpenedTabId();
            const keysArr = Object.keys(toolObj);
            for(let i = 0; i < keysArr.length; i++)if (activeStr === keysArr[i]) mainTabRow.setIsVisible(keysArr[i], true);
            else {
                mainTabRow.setIsVisible(keysArr[i], false);
                if (oldTabId === keysArr[i]) mainTabRow.open(activeStr);
            }
        };
        const keyListener = new (0, $be957da3610487e9$export$921068d8846a1559).KeyListener({
            onDown: (keyStr, event, comboStr, isRepeat)=>{
                if ((0, $25422d204ef184a3$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0 || (0, $be957da3610487e9$export$921068d8846a1559).isInputFocused(true)) return;
                const isDrawing = this.lineSanitizer.getIsDrawing() || this.easel.getIsLocked();
                if (isDrawing) return;
                if (comboStr === 'home' && !isRepeat) this.easel.fitTransform();
                if (comboStr === 'end' && !isRepeat) this.easel.resetTransform();
                // more reliably this way
                const isCtrlOrCmd = (event.ctrlKey || event.metaKey) && !event.altKey;
                const isShift = event.shiftKey;
                // ctrl+z
                const isUndo = isCtrlOrCmd && !isShift && keyStr === 'z';
                // ctrl+shift+z or ctrl+y
                const isRedo = isCtrlOrCmd && isShift && keyStr === 'z' || isCtrlOrCmd && keyStr === 'y';
                if (isUndo) {
                    event.preventDefault();
                    undo();
                }
                if (isRedo) {
                    event.preventDefault();
                    redo();
                }
                if (!this.embed) {
                    if ([
                        'ctrl+s',
                        'cmd+s'
                    ].includes(comboStr) && !isRepeat) {
                        event.preventDefault();
                        applyUncommitted();
                        this.saveToComputer.save();
                    }
                    if ([
                        'ctrl+shift+s',
                        'cmd+shift+s'
                    ].includes(comboStr) && !isRepeat) {
                        event.preventDefault();
                        applyUncommitted();
                        if (projectStore) (async ()=>{
                            await (0, $e2768fb1f61c700a$export$f565b71ad023b7df)();
                            const meta = projectStore.getCurrentMeta();
                            const project = this.getProject();
                            if (meta && meta.projectId !== project.projectId) {
                                const doOverwrite = await new Promise((resolve, reject)=>{
                                    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                                        type: 'warning',
                                        message: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-overwrite-confirm'),
                                        buttons: [
                                            {
                                                id: 'overwrite',
                                                label: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-overwrite')
                                            },
                                            'Cancel'
                                        ],
                                        callback: async (result)=>{
                                            if (result === 'Cancel') {
                                                resolve(false);
                                                return;
                                            }
                                            resolve(true);
                                        }
                                    });
                                });
                                if (!doOverwrite) return;
                            }
                            let success = true;
                            try {
                                await projectStore.store(this.klCanvas.getProject());
                            } catch (e) {
                                success = false;
                                (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(new Error('keyboard-shortcut: failed to store browser storage, ' + e));
                                this.statusOverlay.out("\u274C " + (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-failed'), true);
                            }
                            if (success) {
                                this.updateLastSaved();
                                this.statusOverlay.out((0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-stored'), true);
                            }
                        })();
                        else this.statusOverlay.out("\u274C " + (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-failed'), true);
                    }
                    if ([
                        'ctrl+c',
                        'cmd+c'
                    ].includes(comboStr) && !isRepeat) {
                        event.preventDefault();
                        applyUncommitted();
                        copyToClipboard(true);
                    }
                }
                if ([
                    'ctrl+a',
                    'cmd+a'
                ].includes(comboStr)) event.preventDefault();
                if (comboStr === 'sqbr_open') currentBrushUi.decreaseSize(Math.max(0.005, 0.03 / this.easel.getTransform().scale));
                if (comboStr === 'sqbr_close') currentBrushUi.increaseSize(Math.max(0.005, 0.03 / this.easel.getTransform().scale));
                if (comboStr === 'enter' && !isRepeat) {
                    if (!applyUncommitted()) {
                        this.klCanvas.layerFill(currentLayerIndex, this.klColorSlider.getColor(), undefined, true);
                        this.statusOverlay.out(this.klCanvas.getSelection() ? (0, $fc42a07754814920$export$ce37e184d908d785)('filled-selected-area') : (0, $fc42a07754814920$export$ce37e184d908d785)('filled'), true);
                    }
                }
                if (comboStr === 'esc' && !isRepeat) {
                    if (discardUncommitted()) event.preventDefault();
                }
                if ([
                    'delete',
                    'backspace'
                ].includes(comboStr) && !isRepeat) clearLayer(true);
                if ((comboStr === 'ctrl+shift+e' || comboStr === 'shift+ctrl+e') && !isRepeat) {
                    event.preventDefault();
                    this.layersUi.advancedMergeDialog();
                }
                if (comboStr === 'shift+e' && !isRepeat) {
                    event.preventDefault();
                    currentBrushUi.toggleEraser?.();
                } else if (comboStr === 'e' && !isRepeat) {
                    event.preventDefault();
                    applyUncommitted();
                    this.easel.setTool('brush');
                    this.toolspaceToolRow.setActive('brush');
                    mainTabRow?.open('brush');
                    updateMainTabVisibility();
                    brushTabRow.open('eraserBrush');
                }
                if (comboStr === 'b' && !isRepeat) {
                    event.preventDefault();
                    const prevMode = this.easel.getTool();
                    const prevMainTabId = mainTabRow?.getOpenedTabId();
                    applyUncommitted();
                    this.easel.setTool('brush');
                    this.toolspaceToolRow.setActive('brush');
                    mainTabRow?.open('brush');
                    updateMainTabVisibility();
                    brushTabRow.open(prevMode === 'brush' && prevMainTabId === 'brush' ? getNextBrushId() : currentBrushId === 'eraserBrush' ? lastNonEraserBrushId : currentBrushId);
                }
                if (comboStr === 'h' && !isRepeat) {
                    event.preventDefault();
                    this.toolspaceToolRow.setActive('hand', true);
                }
                if (comboStr === 'g' && !isRepeat) {
                    event.preventDefault();
                    applyUncommitted();
                    const newMode = this.easel.getTool() === 'paintBucket' ? 'gradient' : 'paintBucket';
                    this.easel.setTool(newMode);
                    this.toolspaceToolRow.setActive(newMode);
                    mainTabRow?.open(newMode);
                    updateMainTabVisibility();
                }
                if (comboStr === 't' && !isRepeat) {
                    event.preventDefault();
                    applyUncommitted();
                    this.easel.setTool('text');
                    this.toolspaceToolRow.setActive('text');
                    mainTabRow?.open('text');
                    updateMainTabVisibility();
                }
                if (comboStr === 'u' && !isRepeat) {
                    event.preventDefault();
                    applyUncommitted();
                    this.easel.setTool('shape');
                    this.toolspaceToolRow.setActive('shape');
                    mainTabRow?.open('shape');
                    updateMainTabVisibility();
                }
                if (comboStr === 'l' && !isRepeat) {
                    event.preventDefault();
                    const prevTool = this.easel.getTool();
                    const prevSelectMode = klAppSelect.getSelectMode();
                    const prevMainTabId = mainTabRow?.getOpenedTabId();
                    applyUncommitted();
                    this.easel.setTool('select');
                    this.toolspaceToolRow.setActive('select');
                    mainTabRow?.open('select');
                    updateMainTabVisibility();
                    if (prevTool === 'select' && prevSelectMode === 'select' && prevMainTabId === 'select') klAppSelect.getSelectUi().setMode('transform');
                }
                if (comboStr === 'x' && !isRepeat) {
                    event.preventDefault();
                    this.klColorSlider.swapColors();
                }
                if (comboStr === 'm' && !isRepeat) {
                    event.preventDefault();
                    this.easel.setIsMirrored(!this.easel.getIsMirrored());
                }
            },
            onUp: (keyStr, event)=>{}
        });
        const brushUiMap = {};
        // create brush UIs
        Object.entries((0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BRUSHES_UI).forEach(([b, brushUi])=>{
            const ui = new brushUi.Ui({
                klHistory: this.klHistory,
                onSizeChange: sizeWatcher,
                onOpacityChange: (opacity)=>{
                    brushSettingService.emitOpacity(opacity);
                },
                onConfigChange: ()=>{
                    brushSettingService.emitSliderConfig({
                        sizeSlider: (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].sizeSlider,
                        opacitySlider: (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].opacitySlider
                    });
                    updateBrushCursor();
                }
            });
            brushUiMap[b] = ui;
            // no bottom padding. spacer above bottom bar provides it
            ui.getElement().style.padding = '10px 10px 0';
        });
        this.toolspace = (0, $be957da3610487e9$export$921068d8846a1559).el({
            className: 'kl-toolspace',
            css: {
                position: 'absolute',
                right: 0,
                top: 0,
                bottom: 0,
                width: this.toolWidth,
                overflow: 'hidden',
                userSelect: 'none',
                touchAction: 'none'
            }
        });
        this.toolspaceInner = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: this.toolspace,
            css: {
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100%'
            }
        });
        this.toolspace.oncontextmenu = ()=>{
            return false;
        };
        this.toolspace.onclick = (0, $be957da3610487e9$export$921068d8846a1559).handleClick;
        this.mobileBrushUi = new (0, $0c12e2fdb2b1466a$export$87fd7552ee5cd26e)({
            onBrush: ()=>{
                brushTabRow.open(lastNonEraserBrushId);
            },
            onEraser: ()=>{
                brushTabRow.open('eraserBrush');
            }
        });
        this.mobileColorUi = new (0, $baecd4659396dff5$export$f27d6e4616dd9b30)({
            onEyedropper: (isActive)=>{
                if (isActive) {
                    this.klColorSlider.setIsEyedropping(true);
                    this.easel.setTool('eyedropper');
                } else {
                    this.klColorSlider.setIsEyedropping(false);
                    this.easel.setTool(this.toolspaceToolRow.getActive());
                }
            },
            color: currentColor,
            onColorChange: (c)=>{
                brushSettingService.setColor(c);
            }
        });
        this.mobileUi = new (0, $4f0d150541aeb1cb$export$38b681d46b785af1)({
            onShowToolspace: (b)=>{
                this.mobileColorUi.closeColorPicker();
                this.updateCollapse();
            },
            toolUis: [
                this.mobileBrushUi.getElement(),
                this.mobileColorUi.getElement()
            ]
        });
        this.updateCollapse(true);
        let overlayToolspace;
        setTimeout(()=>{
            overlayToolspace = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).OverlayToolspace({
                enabledTest: ()=>{
                    return (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() === 0 && !this.easel.getIsLocked();
                },
                brushSettingService: brushSettingService
            });
            this.rootEl.append(overlayToolspace.getElement());
        }, 0);
        (0, $be957da3610487e9$export$921068d8846a1559).append(this.rootEl, [
            this.easel.getElement(),
            // this.klCanvasWorkspace.getElement(),
            this.toolspace,
            this.mobileUi.getElement()
        ]);
        if (this.embed) this.toolspaceTopRow = new (0, $6bf9aa70e7adafe5$export$ce26cd3db18613a3)({
            onHelp: ()=>{
                (0, $331e59f8d60fc7d5$export$35fa34e5af64bd4a)(this.embed.url + this.helpPath, !!this.embed);
            },
            onSubmit: ()=>{
                applyUncommitted();
                const onFailure = ()=>{
                    let closeFunc;
                    const saveBtn = (0, $be957da3610487e9$export$921068d8846a1559).el({
                        tagName: 'button',
                        className: 'kl-button',
                        textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('save-reminder-save-psd'),
                        css: {
                            display: 'block'
                        }
                    });
                    saveBtn.onclick = ()=>{
                        this.saveAsPsd();
                        closeFunc();
                    };
                    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                        message: '<b>' + (0, $fc42a07754814920$export$ce37e184d908d785)('upload-failed') + '</b>',
                        div: (0, $be957da3610487e9$export$921068d8846a1559).el({
                            content: [
                                (0, $be957da3610487e9$export$921068d8846a1559).el({
                                    content: (0, $fc42a07754814920$export$ce37e184d908d785)('backup-drawing'),
                                    css: {
                                        marginBottom: 10
                                    }
                                }),
                                saveBtn
                            ]
                        }),
                        ignoreBackground: true,
                        closeFunc: (f)=>{
                            closeFunc = f;
                        }
                    });
                };
                (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                    message: (0, $fc42a07754814920$export$ce37e184d908d785)('submit-prompt'),
                    buttons: [
                        {
                            id: 'submit',
                            label: (0, $fc42a07754814920$export$ce37e184d908d785)('submit')
                        },
                        'Cancel'
                    ],
                    callback: async (result)=>{
                        if (result !== 'submit') return;
                        const overlay = (0, $be957da3610487e9$export$921068d8846a1559).el({
                            parent: this.rootEl,
                            className: 'upload-overlay',
                            content: '<div class="spinner"></div> ' + (0, $fc42a07754814920$export$ce37e184d908d785)('submit-submitting')
                        });
                        this.embed.onSubmit(()=>{
                            this.updateLastSaved();
                            overlay.remove();
                        }, ()=>{
                            overlay.remove();
                            onFailure();
                        });
                    }
                });
            },
            onLeftRight: ()=>{
                this.uiLayout = this.uiLayout === 'left' ? 'right' : 'left';
                this.updateUi();
            }
        });
        else this.toolspaceTopRow = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).ToolspaceTopRow({
            logoImg: p.logoImg,
            onLogo: ()=>{
                (0, $331e59f8d60fc7d5$export$35fa34e5af64bd4a)('./home/', !!this.embed);
            },
            onNew: ()=>{
                showNewImageDialog();
            },
            onImport: ()=>{
                fileUi.triggerImport();
            },
            onSave: ()=>{
                this.saveToComputer.save();
            },
            onShare: ()=>{
                shareImage();
            },
            onHelp: ()=>{
                (0, $331e59f8d60fc7d5$export$35fa34e5af64bd4a)(this.helpPath, !!this.embed);
            }
        });
        this.toolspaceTopRow.getElement().style.marginBottom = '10px';
        this.toolspaceInner.append(this.toolspaceTopRow.getElement());
        this.toolspaceToolRow = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).ToolspaceToolRow({
            onActivate: (activeStr)=>{
                if (activeStr !== 'hand') // hand only one that doesn't cause changes
                applyUncommitted();
                if (activeStr === 'brush') this.easel.setTool('brush');
                else if (activeStr === 'hand') this.easel.setTool('hand');
                else if (activeStr === 'paintBucket') this.easel.setTool('paintBucket');
                else if (activeStr === 'gradient') this.easel.setTool('gradient');
                else if (activeStr === 'text') this.easel.setTool('text');
                else if (activeStr === 'shape') this.easel.setTool('shape');
                else if (activeStr === 'select') // this.klCanvasWorkspace.setMode('shape');
                this.easel.setTool('select');
                else throw new Error('unknown activeStr');
                mainTabRow?.open(activeStr);
                updateMainTabVisibility();
                this.klColorSlider.setIsEyedropping(false);
                this.mobileColorUi.setIsEyedropping(false);
            },
            onZoomIn: ()=>{
                const oldScale = this.easel.getTransform().scale;
                const newScale = (0, $b9d080b8d62d48af$export$8c03162b1a39d183)(oldScale, keyListener.isPressed('shift') ? 1 / 8 : 0.5);
                this.easel.scale(newScale / oldScale);
            },
            onZoomOut: ()=>{
                const oldScale = this.easel.getTransform().scale;
                const newScale = (0, $b9d080b8d62d48af$export$8c03162b1a39d183)(oldScale, keyListener.isPressed('shift') ? -1 / 8 : -0.5);
                this.easel.scale(newScale / oldScale);
            },
            onUndo: ()=>{
                undo();
            },
            onRedo: ()=>{
                redo();
            }
        });
        this.toolspaceToolRow.setIsSmall($8d08c083c4b95b50$var$getToolspaceLayout(this.uiHeight).isToolRowSmall);
        this.toolspaceInner.append(this.toolspaceToolRow.getElement());
        const setBrushColor = (p_color)=>{
            currentColor = p_color;
            currentBrushUi.setColor(p_color);
            brushSettingService.emitColor(p_color);
            this.mobileColorUi.setColor(p_color);
            this.klColorSlider.setIsEyedropping(false);
            this.mobileColorUi.setIsEyedropping(false);
        };
        this.klColorSlider = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).KlColorSlider({
            width: 250,
            height: 30,
            svHeight: 100,
            startValue: new (0, $be957da3610487e9$export$921068d8846a1559).RGB(0, 0, 0),
            onPick: setBrushColor,
            onEyedropper: (isActive)=>{
                if (isActive) {
                    this.mobileColorUi.setIsEyedropping(true);
                    this.easel.setTool('eyedropper');
                } else {
                    this.mobileColorUi.setIsEyedropping(false);
                    this.easel.setTool(this.toolspaceToolRow.getActive());
                }
            }
        });
        this.klColorSlider.setHeight($8d08c083c4b95b50$var$getToolspaceLayout(this.uiHeight).colorSliderHeight);
        const updateBrushCursor = ()=>{
            const brush = currentBrushUi.getBrush();
            this.easelBrush.setBrush(brush instanceof (0, $84ca9200b907548e$export$4de5ef8eecde6f12) ? {
                type: 'pixel',
                pixelTip: brush.getTip()
            } : {
                type: 'round'
            });
        };
        const setCurrentBrush = (brushId)=>{
            if (currentBrushUi && brushId !== currentBrushId) currentBrushUi.freeResources?.();
            if (brushId !== 'eraserBrush') lastNonEraserBrushId = brushId;
            if (this.klColorSlider) {
                if (brushId === 'eraserBrush') this.klColorSlider.enable(false);
                else this.klColorSlider.enable(true);
            }
            currentBrushId = brushId;
            currentBrushUi = brushUiMap[brushId];
            currentBrushUi.setColor(currentColor);
            currentBrushUi.setLayer(this.klCanvas.getLayer(currentLayerIndex));
            updateBrushCursor();
            this.toolspaceToolRow.setActive('brush');
            updateMainTabVisibility();
        };
        const setCurrentLayer = (index)=>{
            currentLayerIndex = index;
            currentBrushUi.setLayer(this.klCanvas.getLayer(currentLayerIndex));
        };
        const brushDiv = (0, $be957da3610487e9$export$921068d8846a1559).el();
        const colorDiv = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                margin: 10,
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignItems: 'flex-end'
            }
        });
        const toolspaceStabilizerRow = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).ToolspaceStabilizerRow({
            smoothing: 1,
            onSelect: (v)=>{
                lineSmoothing.setSmoothing((0, $603f5a48e1f92529$export$bcd109042a2e4bb5)(v));
            }
        });
        brushDiv.append(colorDiv);
        (0, $be957da3610487e9$export$921068d8846a1559).append(colorDiv, [
            this.klColorSlider.getElement(),
            this.klColorSlider.getOutputElement(),
            toolspaceStabilizerRow.getElement()
        ]);
        const brushTabRow = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).TabRow({
            initialId: 'penBrush',
            useAccent: true,
            tabArr: (()=>{
                const commonStyle = {
                    height: 28,
                    width: 28,
                    color: 'var(--ui-on-bg-full-contrast)'
                };
                const createTab = (keyStr)=>{
                    const im = (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].image;
                    (0, $94f0b2b810d4d191$export$dbf350e5966cf602)(im, commonStyle);
                    return {
                        id: keyStr,
                        label: (0, $be957da3610487e9$export$921068d8846a1559).el({
                            content: im,
                            css: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%'
                            }
                        }),
                        title: (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].tooltip,
                        onOpen: ()=>{
                            brushUiMap[keyStr].getElement().style.display = 'block';
                            setCurrentBrush(keyStr);
                            this.klColorSlider.setIsEyedropping(false);
                            this.mobileColorUi.setIsEyedropping(false);
                            brushSettingService.emitSliderConfig({
                                sizeSlider: (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].sizeSlider,
                                opacitySlider: (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].opacitySlider
                            });
                            sizeWatcher(brushUiMap[keyStr].getSize());
                            brushSettingService.emitOpacity(brushUiMap[keyStr].getOpacity());
                            this.mobileBrushUi.setType(keyStr === 'eraserBrush' ? 'eraser' : 'brush');
                        },
                        onClose: ()=>{
                            brushUiMap[keyStr].getElement().style.display = 'none';
                        }
                    };
                };
                const keyArr = Object.keys(brushUiMap);
                return keyArr.map(createTab);
            })()
        });
        (0, $be957da3610487e9$export$921068d8846a1559).append(brushDiv, [
            brushTabRow.getElement(),
            ...Object.entries((0, $25422d204ef184a3$export$6e4a713ddcda1e5e).BRUSHES_UI).map(([b])=>brushUiMap[b].getElement())
        ]);
        const handUi = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).HandUi({
            scale: this.easel.getTransform().scale,
            angleDeg: 0,
            onReset: ()=>{
                this.easel.resetTransform();
            },
            onFit: ()=>{
                this.easel.fitTransform();
            },
            onAngleChange: (angleDeg, isRelative)=>{
                this.easel.setAngleDeg(angleDeg, isRelative);
            },
            onChangeIsMirrored: (b)=>{
                this.easel.setIsMirrored(b);
            },
            onChangeUseInertiaScrolling: (b)=>{
                easelHand.setUseInertiaScrolling(b);
            }
        });
        const fillUi = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).FillUi({
            colorSlider: this.klColorSlider
        });
        const gradientUi = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).GradientUi({
            colorSlider: this.klColorSlider
        });
        const textUi = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).TextUi({
            colorSlider: this.klColorSlider
        });
        const shapeUi = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).ShapeUi({
            colorSlider: this.klColorSlider,
            onChangePanning: (doPan)=>easelShape.setPanning(doPan)
        });
        const gradientTool = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).GradientTool({
            onGradient: (isDone, x1, y1, x2, y2, angleRad)=>{
                const layerIndex = currentLayerIndex;
                const settings = gradientUi.getSettings();
                const gradientObj = {
                    type: settings.type,
                    color1: this.klColorSlider.getColor(),
                    isReversed: settings.isReversed,
                    opacity: settings.opacity,
                    doLockAlpha: settings.doLockAlpha,
                    isEraser: settings.isEraser,
                    doSnap: keyListener.isPressed('shift') || settings.doSnap,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    angleRad: angleRad
                };
                if (isDone) {
                    this.klCanvas.setComposite(layerIndex, undefined);
                    this.klCanvas.drawGradient(layerIndex, gradientObj);
                } else {
                    const selection = this.klCanvas.getSelection();
                    const selectionPath = selection ? new Path2D((0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(selection)) : undefined;
                    this.klCanvas.setComposite(layerIndex, {
                        draw: (ctx)=>{
                            (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).drawGradient(ctx, gradientObj, selectionPath);
                        }
                    });
                }
                this.easelProjectUpdater.update();
            }
        });
        const shapeTool = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).ShapeTool({
            onShape: (isDone, x1, y1, x2, y2, angleRad)=>{
                const layerIndex = currentLayerIndex;
                const shapeObj = {
                    type: shapeUi.getShape(),
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    angleRad: angleRad,
                    isOutwards: shapeUi.getIsOutwards(),
                    opacity: shapeUi.getOpacity(),
                    isEraser: shapeUi.getIsEraser(),
                    doLockAlpha: shapeUi.getDoLockAlpha()
                };
                if (shapeUi.getShape() === 'line') {
                    shapeObj.strokeRgb = this.klColorSlider.getColor();
                    shapeObj.lineWidth = shapeUi.getLineWidth();
                    shapeObj.isAngleSnap = shapeUi.getIsSnap() || keyListener.isPressed('shift');
                } else {
                    shapeObj.isFixedRatio = shapeUi.getIsFixed() || keyListener.isPressed('shift');
                    if (shapeUi.getMode() === 'stroke') {
                        shapeObj.strokeRgb = this.klColorSlider.getColor();
                        shapeObj.lineWidth = shapeUi.getLineWidth();
                    } else shapeObj.fillRgb = this.klColorSlider.getColor();
                }
                if (isDone) {
                    this.klCanvas.setComposite(layerIndex, undefined);
                    this.klCanvas.drawShape(layerIndex, shapeObj);
                } else {
                    const selection = this.klCanvas.getSelection();
                    const selectionPath = selection ? new Path2D((0, $b5f980f0748d5a71$export$ba7ed3181f35c1cc)(selection)) : undefined;
                    this.klCanvas.setComposite(layerIndex, {
                        draw: (ctx)=>{
                            (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).drawShape(ctx, shapeObj, selectionPath);
                        }
                    });
                }
                this.easelProjectUpdater.update();
            }
        });
        this.floatingLayerPreview = new (0, $77e901a73d057ac0$export$ebe217a0232decd2)();
        this.layersUi = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).LayersUi({
            klCanvas: this.klCanvas,
            onSelect: (layerIndex, pushHistory)=>{
                setCurrentLayer(layerIndex);
                if (pushHistory) {
                    const topEntry = this.klHistory.getEntries().at(-1).data;
                    const replaceTop = (0, $b31e47e994a6284f$export$beb462111ff337c5)(topEntry);
                    this.klHistory.push({
                        activeLayerId: this.klCanvas.getLayer(layerIndex).id
                    }, replaceTop);
                }
            },
            parentEl: this.rootEl,
            floatingLayerPreview: this.floatingLayerPreview,
            applyUncommitted: ()=>applyUncommitted(),
            klHistory: this.klHistory,
            onUpdateProject: ()=>this.easelProjectUpdater.update(),
            onClearLayer: ()=>clearLayer(false, true)
        });
        this.layerPreview = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).LayerPreview({
            klRootEl: this.rootEl,
            onClick: ()=>{
                mainTabRow?.open('layers');
            },
            floatingLayerPreview: this.floatingLayerPreview,
            klHistory: this.klHistory,
            klCanvas: this.klCanvas
        });
        const toolspaceLayout = $8d08c083c4b95b50$var$getToolspaceLayout(this.uiHeight);
        this.layerPreview.setIsVisible(toolspaceLayout.isLayerPreviewVisible);
        this.layerPreview.setIsSmall(toolspaceLayout.isLayerPreviewSmall);
        const editUi = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).EditUi({
            klRootEl: this.rootEl,
            klColorSlider: this.klColorSlider,
            layersUi: this.layersUi,
            getCurrentColor: ()=>currentColor,
            maxCanvasSize: maxCanvasSize,
            klCanvas: this.klCanvas,
            getCurrentLayerIndex: ()=>currentLayerIndex,
            isEmbed: !!this.embed,
            statusOverlay: this.statusOverlay,
            onCanvasChanged: ()=>{
                this.easelProjectUpdater.update();
                this.easel.resetOrFitTransform(true);
            },
            applyUncommitted: ()=>applyUncommitted(),
            klHistory: this.klHistory,
            onCopyToClipboard: ()=>{
                applyUncommitted();
                copyToClipboard(false, false);
            },
            onPaste: ()=>importHandler.readClipboard()
        });
        const klHistoryExecutor = new (0, $4693929864e33be7$export$cb9945923eaef1dd)({
            klHistory: this.klHistory,
            tempHistory: tempHistory,
            onCanUndoRedoChange: (canUndo, canRedo)=>{
                this.toolspaceToolRow.setEnableUndo(canUndo);
                this.toolspaceToolRow.setEnableRedo(canRedo);
            }
        });
        const showNewImageDialog = ()=>{
            applyUncommitted();
            (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).newImageDialog({
                currentColor: currentColor,
                secondaryColor: this.klColorSlider.getSecondaryRGB(),
                maxCanvasSize: maxCanvasSize,
                canvasWidth: this.klCanvas.getWidth(),
                canvasHeight: this.klCanvas.getHeight(),
                workspaceWidth: window.innerWidth < this.collapseThreshold ? this.uiWidth : this.uiWidth - this.toolWidth,
                workspaceHeight: this.uiHeight,
                onConfirm: (width, height, color)=>{
                    this.klCanvas.reset({
                        width: width,
                        height: height,
                        color: color.a === 1 ? color : undefined
                    });
                    this.layersUi.update(0);
                    setCurrentLayer(0);
                    this.easelProjectUpdater.update();
                    this.easel.resetOrFitTransform(true);
                },
                onCancel: ()=>{}
            });
        };
        const shareImage = (callback)=>{
            applyUncommitted();
            (0, $be957da3610487e9$export$921068d8846a1559).shareCanvas({
                canvas: this.klCanvas.getCanvas(),
                fileName: (0, $94f0b2b810d4d191$export$27be2b2470a97a3)() + (0, $00d7ded47eb0b8eb$export$67ac20532b9ededa).filenameBase + '.png',
                title: (0, $94f0b2b810d4d191$export$27be2b2470a97a3)() + (0, $00d7ded47eb0b8eb$export$67ac20532b9ededa).filenameBase + '.png',
                callback: callback ? callback : ()=>{}
            });
        };
        this.saveToComputer = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).SaveToComputer(()=>exportType, this.klCanvas, ()=>{
            this.updateLastSaved();
        });
        const copyToClipboard = (showCrop = false, closeOnBlur = true)=>{
            (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).clipboardDialog(this.rootEl, (maskSelection)=>{
                return this.klCanvas.getCanvas(1, maskSelection);
            }, (inputObj)=>{
                if (inputObj.left === 0 && inputObj.right === 0 && inputObj.top === 0 && inputObj.bottom === 0) return;
                //do a crop
                (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).FILTER_LIB.cropExtend.apply({
                    layer: this.klCanvas.getLayer(currentLayerIndex),
                    klCanvas: this.klCanvas,
                    input: inputObj,
                    klHistory: this.klHistory
                });
                this.layersUi.update();
                this.easelProjectUpdater.update();
                this.easel.resetOrFitTransform(true);
            }, this.statusOverlay, showCrop || false, closeOnBlur, this.klCanvas.getSelection());
        };
        const onOpenBrowserStorage = async ()=>{
            const showFailureMessage = ()=>{
                (0, $5f9f54d39d868ac2$export$3879b24e8245693d)((0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-open-failed'));
            };
            if (!projectStore) {
                showFailureMessage();
                return;
            }
            const meta = projectStore.getCurrentMeta();
            // Check is project already opened in other tab.
            // (if it's already open in the current tab, user showed intentionality. Don't ask again.)
            if (meta && this.klHistory.getComposed().projectId.value !== meta.projectId) {
                let doOpen = true;
                const crossTabChannel = new (0, $c7ee49b4041304a6$export$84f7c9d87f70395e)('kl-tab-communication');
                const openedProjectIds = [];
                const otherIdListener = (message)=>{
                    if (message.type === 'response-project-id') openedProjectIds.push(message.id);
                };
                crossTabChannel.subscribe(otherIdListener);
                crossTabChannel.postMessage({
                    type: 'request-project-ids'
                });
                await (0, $94f0b2b810d4d191$export$e772c8ff12451969)(100);
                crossTabChannel.unsubscribe(otherIdListener);
                if (meta && openedProjectIds.includes(meta.projectId)) doOpen = await new Promise((resolve, reject)=>{
                    (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                        message: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-open-confirmation'),
                        buttons: [
                            {
                                id: 'open',
                                label: (0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-open')
                            },
                            'Cancel'
                        ],
                        callback: async (result)=>{
                            if (result === 'Cancel') {
                                resolve(false);
                                return;
                            }
                            resolve(true);
                        }
                    });
                });
                crossTabChannel.close();
                if (!doOpen) return;
            }
            let closeLoader;
            (0, $5f9f54d39d868ac2$export$d7e8d4d4450c819c)({
                message: (0, $fc42a07754814920$export$ce37e184d908d785)('loading'),
                callback: (result)=>{
                    closeLoader = undefined;
                },
                closeFunc: (f)=>{
                    closeLoader = f;
                }
            });
            let project;
            try {
                project = await projectStore?.read();
            } catch (e) {
                (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
            }
            if (!project) {
                closeLoader?.();
                showFailureMessage();
                return;
            }
            applyUncommitted();
            const layerIndex = this.klCanvas.reset({
                projectId: project.project.projectId,
                width: project.project.width,
                height: project.project.height,
                layers: project.project.layers.map((item)=>{
                    let image = item.image;
                    if (!(image instanceof HTMLCanvasElement)) {
                        image = (0, $be957da3610487e9$export$921068d8846a1559).canvas(project.project.width, project.project.height);
                        if (item.image instanceof HTMLImageElement) {
                            const ctx = (0, $be957da3610487e9$export$921068d8846a1559).ctx(image);
                            ctx.drawImage(item.image, 0, 0);
                        }
                    }
                    return {
                        ...item,
                        id: (0, $94f0b2b810d4d191$export$4773ec3a7b05a3f2)(),
                        image: image
                    };
                })
            });
            this.layersUi.update(layerIndex);
            setCurrentLayer(layerIndex);
            this.easelProjectUpdater.update();
            this.easel.resetOrFitTransform(true);
            setTimeout(()=>{
                // timeout to overwrite zoom overlay msg
                this.statusOverlay.out((0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-restored'));
            });
            closeLoader?.();
        };
        const fileUi = this.embed ? null : new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).FileUi({
            klRootEl: this.rootEl,
            helpPath: this.helpPath,
            projectStore: projectStore,
            getProject: ()=>this.klCanvas.getProject(),
            exportType: exportType,
            onExportTypeChange: (type)=>{
                exportType = type;
            },
            onFileSelect: (files, optionsStr)=>importHandler.handleFileSelect(files, optionsStr),
            onSaveImageToComputer: ()=>{
                applyUncommitted();
                this.saveToComputer.save();
            },
            onNewImage: showNewImageDialog,
            onShareImage: (callback)=>{
                applyUncommitted();
                shareImage(callback);
            },
            onUpload: ()=>{
                // on upload
                applyUncommitted();
                (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).imgurUpload(this.klCanvas, p.app && p.app.imgurKey ? p.app.imgurKey : '', ()=>this.updateLastSaved());
            },
            applyUncommitted: ()=>applyUncommitted(),
            onChangeShowSaveDialog: (b)=>{
                this.saveToComputer.setShowsSaveDialog(b);
            },
            klRecoveryManager: klRecoveryManager,
            onOpenBrowserStorage: onOpenBrowserStorage,
            onStoredToBrowserStorage: ()=>{
                this.updateLastSaved();
            }
        });
        if (!this.embed && projectStore) this.saveReminder = new (0, $0e4cfd755d2d08c9$export$befc6437ad34b28a)({
            onSaveAsPsd: ()=>{
                if (!this.embed) this.saveAsPsd();
            },
            isDrawing: ()=>{
                return this.isDrawing();
            },
            projectStore: projectStore,
            getProject: ()=>this.getProject(),
            onStored: ()=>{
                this.updateLastSaved();
            },
            applyUncommitted: applyUncommitted,
            klHistory: this.klHistory,
            helpPath: this.helpPath
        });
        const settingsUi = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).SettingsUi({
            onLeftRight: ()=>{
                this.uiLayout = this.uiLayout === 'left' ? 'right' : 'left';
                this.updateUi();
                if (!this.embed) (0, $7a8f101d3676d17a$export$19fffca37ef3e106).setItem('uiState', this.uiLayout);
            },
            saveReminder: this.saveReminder,
            customAbout: p.aboutEl
        });
        mainTabRow = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).TabRow({
            initialId: 'brush',
            tabArr: [
                {
                    id: 'brush',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('tool-brush'),
                    image: $8d08c083c4b95b50$var$toolPaintImg,
                    onOpen: ()=>{
                        if (currentBrushId === 'eraserBrush') this.klColorSlider.enable(false);
                        (0, $be957da3610487e9$export$921068d8846a1559).append(colorDiv, [
                            this.klColorSlider.getElement(),
                            this.klColorSlider.getOutputElement(),
                            toolspaceStabilizerRow.getElement()
                        ]);
                        brushDiv.style.display = 'block';
                    },
                    onClose: ()=>{
                        brushDiv.style.display = 'none';
                    },
                    css: {
                        minWidth: 45
                    }
                },
                {
                    id: 'hand',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('tool-hand'),
                    image: $8d08c083c4b95b50$var$toolHandImg,
                    isVisible: false,
                    onOpen: ()=>{
                        handUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        handUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: 45
                    }
                },
                {
                    id: 'paintBucket',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('tool-paint-bucket'),
                    image: $8d08c083c4b95b50$var$toolFillImg,
                    isVisible: false,
                    onOpen: ()=>{
                        this.klColorSlider.enable(true);
                        fillUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        fillUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: 45
                    }
                },
                {
                    id: 'gradient',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('tool-gradient'),
                    image: $8d08c083c4b95b50$var$toolGradientImg,
                    isVisible: false,
                    onOpen: ()=>{
                        this.klColorSlider.enable(true);
                        gradientUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        gradientUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: 45
                    }
                },
                {
                    id: 'text',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('tool-text'),
                    image: $8d08c083c4b95b50$var$toolTextImg,
                    isVisible: false,
                    onOpen: ()=>{
                        this.klColorSlider.enable(true);
                        textUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        textUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: 45
                    }
                },
                {
                    id: 'shape',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('tool-shape'),
                    image: $8d08c083c4b95b50$var$toolShapeImg,
                    isVisible: false,
                    onOpen: ()=>{
                        this.klColorSlider.enable(true);
                        shapeUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        shapeUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: 45
                    }
                },
                {
                    id: 'select',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('tool-select'),
                    image: $8d08c083c4b95b50$var$toolSelectImg,
                    isVisible: false,
                    onOpen: ()=>{
                        klAppSelect.getSelectUi().setIsVisible(true);
                    },
                    onClose: ()=>{
                        klAppSelect.getSelectUi().setIsVisible(false);
                    },
                    css: {
                        minWidth: 45
                    }
                },
                {
                    id: 'layers',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('layers'),
                    image: $8d08c083c4b95b50$var$tabLayersImg,
                    onOpen: ()=>{
                        this.layersUi.setIsVisible(true);
                        this.layersUi.update();
                    },
                    onClose: ()=>{
                        this.layersUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: 45
                    }
                },
                {
                    id: 'edit',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('tab-edit'),
                    image: $8d08c083c4b95b50$var$tabEditImg,
                    onOpen: ()=>{
                        editUi.show();
                    },
                    onClose: ()=>{
                        editUi.hide();
                    },
                    css: {
                        minWidth: 45
                    }
                },
                {
                    id: 'file',
                    label: (0, $fc42a07754814920$export$ce37e184d908d785)('tab-file'),
                    isVisible: !!fileUi,
                    onOpen: ()=>{
                        if (!fileUi) return;
                        fileUi.getElement().style.display = 'block';
                        fileUi.setIsVisible(true);
                    },
                    onClose: ()=>{
                        if (!fileUi) return;
                        fileUi.getElement().style.display = 'none';
                        fileUi.setIsVisible(false);
                    },
                    css: {
                        padding: '0 7px'
                    }
                },
                {
                    id: 'settings',
                    title: (0, $fc42a07754814920$export$ce37e184d908d785)('tab-settings'),
                    image: $8d08c083c4b95b50$var$tabSettingsImg,
                    onOpen: ()=>{
                        settingsUi.getElement().style.display = 'block';
                    // settingsTab.setIsVisible(true);
                    },
                    onClose: ()=>{
                        settingsUi.getElement().style.display = 'none';
                    // settingsTab.setIsVisible(false);
                    },
                    css: {
                        minWidth: 45
                    }
                }
            ]
        });
        this.bottomBarWrapper = (0, $be957da3610487e9$export$921068d8846a1559).el({
            css: {
                width: 270
            }
        });
        if (p.bottomBar) {
            this.bottomBar = p.bottomBar;
            this.bottomBarWrapper.append(this.bottomBar);
        }
        (0, $be957da3610487e9$export$921068d8846a1559).append(this.toolspaceInner, [
            this.layerPreview.getElement(),
            mainTabRow.getElement(),
            brushDiv,
            handUi.getElement(),
            fillUi.getElement(),
            gradientUi.getElement(),
            textUi.getElement(),
            shapeUi.getElement(),
            klAppSelect.getSelectUi().getElement(),
            this.layersUi.getElement(),
            editUi.getElement(),
            fileUi ? fileUi.getElement() : undefined,
            settingsUi.getElement(),
            (0, $be957da3610487e9$export$921068d8846a1559).el({
                css: {
                    height: 10,
                    flexGrow: 1
                }
            }),
            this.bottomBarWrapper ? this.bottomBarWrapper : undefined
        ]);
        this.toolspaceScroller = new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).ToolspaceScroller({
            toolspace: this.toolspace,
            uiState: this.uiLayout
        });
        if (!this.embed) Object.defineProperty(window, 'KL', {
            value: (0, $29243e5a58a0dfdb$export$982e7602957287fa)({
                onDraw: (path)=>{
                    if (!path || path.length === 0) return;
                    path.forEach((p, index)=>{
                        if (index === 0) currentBrushUi.startLine(p.x, p.y, 1);
                        else currentBrushUi.goLine(p.x, p.y, 1);
                    });
                    currentBrushUi.endLine();
                }
            }),
            writable: false
        });
        this.resize(this.uiWidth, this.uiHeight);
        this.updateUi();
        const importHandler = new (0, $2f6676beceb707bc$export$1ec1306c0c05d48d)({
            klRootEl: this.rootEl,
            maxCanvasSize: maxCanvasSize,
            layersUi: this.layersUi,
            setCurrentLayer: setCurrentLayer,
            klCanvas: this.klCanvas,
            onImportConfirm: ()=>{
                this.easelProjectUpdater.update();
                this.easel.resetOrFitTransform(true);
            },
            applyUncommitted: ()=>applyUncommitted()
        }, {
            onColor: (rgb)=>brushSettingService.setColor(rgb)
        });
        if (!this.embed || this.embed.enableImageDropperImport) {
            new (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).KlImageDropper({
                target: document.body,
                onDrop: (files, optionStr)=>{
                    if ((0, $25422d204ef184a3$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0) return;
                    applyUncommitted();
                    importHandler.handleFileSelect(files, optionStr);
                },
                enabledTest: ()=>{
                    return (0, $25422d204ef184a3$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() === 0;
                }
            });
            window.document.addEventListener('paste', (e)=>importHandler.onPaste(e), false);
        }
        this.unloadWarningTrigger = new (0, $09c50d395e24995f$export$747c5e57cda7ca57)({
            klHistory: this.klHistory,
            getLastSavedHistoryIndex: ()=>this.lastSavedHistoryIndex
        });
        {
            window.addEventListener('resize', ()=>{
                this.resize(window.innerWidth, window.innerHeight);
            });
            window.addEventListener('orientationchange', ()=>{
                this.resize(window.innerWidth, window.innerHeight);
            });
            // 2024-08: window.resize doesn't fire on iPad Safari when:
            // pinch zoomed page, then reload, and un-pinch-zoom page
            // therefor also listen to visualViewport.
            if ('visualViewport' in window && visualViewport !== null) visualViewport.addEventListener('resize', ()=>{
                this.resize(window.innerWidth, window.innerHeight);
            });
            // iPad doesn't trigger 'resize' event when using text zoom, although it's resizing the window.
            // Workaround: place a div in the body that fills the window, and use a ResizeObserver
            const windowResizeWatcher = (0, $be957da3610487e9$export$921068d8846a1559).el({
                parent: document.body,
                css: {
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    pointerEvents: 'none',
                    zIndex: '-1',
                    userSelect: 'none'
                }
            });
            try {
                // Not all browsers support ResizeObserver. Not critical though.
                const observer = new ResizeObserver(()=>this.resize(window.innerWidth, window.innerHeight));
                observer.observe(windowResizeWatcher);
            } catch (e) {
                windowResizeWatcher.remove();
            }
            // prevent ctrl scroll -> zooming page
            this.rootEl.addEventListener('wheel', (event)=>{
                if (keyListener.isPressed('ctrl')) event.preventDefault();
            }, {
                passive: false
            });
            // prevents pinch zoom of page on macOS Safari
            const prevent = (e)=>{
                e.preventDefault();
            };
            window.addEventListener('gesturestart', prevent, {
                passive: false
            });
            window.addEventListener('gesturechange', prevent, {
                passive: false
            });
            window.addEventListener('gestureend', prevent, {
                passive: false
            });
            const pinchZoomWatcher = new (0, $3c8d80bb9e6c6c3e$export$3e66e8feec69f8d)();
        }
        if (!this.embed) setTimeout(()=>{
            (0, $b7defe50cfcdbb1a$export$4a2ed1038e76f37f)({
                projectStore: projectStore,
                klRecoveryManager: klRecoveryManager,
                onOpenBrowserStorage: onOpenBrowserStorage,
                klHistory: this.klHistory
            });
        });
        this.saveReminder?.init();
    }
}









var $c961027ccc398c2c$export$337c2b438c93a763;
$c961027ccc398c2c$export$337c2b438c93a763 = `dtnPga_loadingScreen`;



const $958cfe0c95f0379e$var$showCancelAfterMs = 3000;
async function $958cfe0c95f0379e$export$5740af0b1f61fbac(recoveryManager, loadingScreenEl) {
    if (!recoveryManager) return undefined;
    const abortController = typeof AbortController === 'undefined' ? undefined : new AbortController();
    const destroyer = new (0, $94f0b2b810d4d191$export$40612b7e1b7c8ee4)();
    let recoveryLoadingEl;
    const showCancelRecoveryTimeout = abortController && loadingScreenEl ? setTimeout(()=>{
        loadingScreenEl.classList.add($c961027ccc398c2c$export$337c2b438c93a763);
        const cancelButton = (0, $be957da3610487e9$export$921068d8846a1559).el({
            tagName: 'button',
            className: 'kl-button',
            textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('modal-cancel'),
            destroyer: destroyer,
            onClick: ()=>{
                cancelButton.disabled = true;
                abortController.abort();
            }
        });
        recoveryLoadingEl = (0, $be957da3610487e9$export$921068d8846a1559).el({
            parent: loadingScreenEl,
            css: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 10
            },
            content: [
                (0, $be957da3610487e9$export$921068d8846a1559).el({
                    css: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        fontSize: 16
                    },
                    content: [
                        (0, $be957da3610487e9$export$921068d8846a1559).el({
                            tagName: 'img',
                            props: {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7c2e67a7cc9b2390$exports))),
                                alt: ''
                            }
                        }),
                        (0, $be957da3610487e9$export$921068d8846a1559).el({
                            tagName: 'span',
                            textContent: (0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-restoring-session')
                        })
                    ]
                }),
                cancelButton
            ]
        });
    }, $958cfe0c95f0379e$var$showCancelAfterMs) : undefined;
    try {
        return await recoveryManager.getRecovery(abortController?.signal);
    } catch (error) {
        if (error instanceof Error && error.name === 'AbortError') return undefined;
        throw error;
    } finally{
        clearTimeout(showCancelRecoveryTimeout);
        destroyer.destroy();
        recoveryLoadingEl?.remove();
        loadingScreenEl?.classList.remove($c961027ccc398c2c$export$337c2b438c93a763);
    }
}




function $0399723d8733a2f8$var$showInitError(e) {
    const el = document.createElement('div');
    el.style.textAlign = 'center';
    el.style.background = '#fff';
    el.style.padding = '20px';
    el.innerHTML = '<h1>App failed to initialize</h1>';
    const errorMsg = document.createElement('div');
    errorMsg.textContent = 'Error: ' + (e.message ? e.message : '' + e);
    el.append(errorMsg);
    document.body.append(el);
    console.error(e);
}
(async ()=>{
    try {
        (0, $1b4b6b9aff0ae5e5$export$cabc69a67231dae8)();
        const outQueue = [];
        await (0, $fc42a07754814920$export$7a2ea9f2e4d199d3)();
        (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).init((0, $f603d6ecd683b596$export$620c18ffd80459f1)());
        if (!await (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).testConnection()) outQueue.push((0, $fc42a07754814920$export$ce37e184d908d785)('file-storage-cant-access'));
        const klRecoveryManager = (0, $f603d6ecd683b596$export$8d693ea241b9d9a6).getIsAvailable() ? new (0, $cc19f288fbbad83c$export$36c5c4b26ead79bd)({}) : undefined;
        const loadingScreenEl = document.getElementById('loading-screen');
        let project = undefined;
        try {
            const readResult = await (0, $958cfe0c95f0379e$export$5740af0b1f61fbac)(klRecoveryManager, loadingScreenEl);
            if (readResult) {
                project = readResult.project;
                outQueue.push((0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-recovered'));
            }
        } catch (e) {
            (0, $94f0b2b810d4d191$export$18ba0e477ccb0900)(e);
            outQueue.push((0, $fc42a07754814920$export$ce37e184d908d785)('tab-recovery-failed-to-recover'));
        }
        // in case an extension manipulated the page
        loadingScreenEl?.remove();
        const klApp = new (0, $8d08c083c4b95b50$export$96f6458b62e4c2c)({
            project: project,
            klRecoveryManager: klRecoveryManager
        });
        document.body.append(klApp.getElement());
        setTimeout(()=>{
            outQueue.forEach((msg)=>{
                klApp.out(msg);
            });
        }, 100);
    } catch (e) {
        $0399723d8733a2f8$var$showInitError(e);
    }
})();


//# sourceMappingURL=bundle.8cc6db39.js.map
